export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  BigInt: any
  Byte: any
  Date: string
  DateTime: string
  JSON: any
  JSONObject: any
  Time: any
}

export interface AbrCompany {
  __typename?: 'AbrCompany'
  abn: Scalars['String']
  name: Scalars['String']
}

export interface AccessControl {
  __typename?: 'AccessControl'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  identifier: Scalars['String']
  projects: Array<Project>
  status: AccessControlStatus
  type: AccessControlType
  updatedAt?: Maybe<Scalars['DateTime']>
  worker: Worker
}

export enum AccessControlAccess {
  Granted = 'GRANTED',
  Suspended = 'SUSPENDED',
}

export enum AccessControlAccessTypes {
  FaceId = 'FACE_ID',
  KeyFob = 'KEY_FOB',
}

export interface AccessControlHardware {
  __typename?: 'AccessControlHardware'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  createdAt: Scalars['DateTime']
  hardwareIdentifier: Scalars['String']
  id: Scalars['String']
  project: Project
  type: AccessControlHardwareType
  updatedAt?: Maybe<Scalars['DateTime']>
}

export enum AccessControlHardwareType {
  FaceScanner = 'FACE_SCANNER',
  RfidScanner = 'RFID_SCANNER',
}

export interface AccessControlProjectAccess {
  __typename?: 'AccessControlProjectAccess'
  access: AccessControlAccess
  createdAt: Scalars['DateTime']
  project: Project
  projectId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export enum AccessControlStatus {
  Granted = 'GRANTED',
  Suspended = 'SUSPENDED',
}

export enum AccessControlType {
  Face = 'FACE',
  Fingerprint = 'FINGERPRINT',
  Rfid = 'RFID',
}

export interface AccessControlIntegrationConnection {
  __typename?: 'AccessControl_IntegrationConnection'
  accessTypes?: Maybe<Array<Maybe<AccessControlAccessTypes>>>
  createdAt: Scalars['DateTime']
  faceIdAccessId?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  integration: Integration
  integrationId: Scalars['String']
  /** @deprecated Use faceIdAccessId and keyFobAccessId */
  integrationIdentifier: Scalars['String']
  keyFobAccessId?: Maybe<Scalars['String']>
  projectAccess?: Maybe<Array<Maybe<AccessControlProjectAccess>>>
  updatedAt: Scalars['DateTime']
  worker?: Maybe<Worker>
  workerId?: Maybe<Scalars['String']>
}

export interface AccessControlIntegrationConnectionError {
  __typename?: 'AccessControl_IntegrationConnection_Error'
  message: Scalars['String']
}

export type AccessControlIntegrationConnectionResult =
  | AccessControlIntegrationConnection
  | AccessControlIntegrationConnectionError

export interface AccessProfile {
  __typename?: 'AccessProfile'
  accessProfileTemplate?: Maybe<AccessProfileTemplate>
  actors: Array<AccessProfileActor>
  createdAt: Scalars['DateTime']
  defaultRole?: Maybe<AccessProfileRole>
  id: Scalars['String']
  name: Scalars['String']
  owner?: Maybe<AdminUser>
  templateResponses: Array<TemplateResponse>
  updatedAt: Scalars['DateTime']
}

export interface AccessProfileActor {
  __typename?: 'AccessProfileActor'
  accessProfile: AccessProfile
  adminUser: AdminUser
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  role: AccessProfileRole
  updatedAt: Scalars['DateTime']
}

export interface AccessProfileActorInput {
  adminUserId: Scalars['String']
  role: AccessProfileRole
}

export interface AccessProfileInput {
  accessProfileTemplateId?: InputMaybe<Scalars['String']>
  actors?: InputMaybe<Array<AccessProfileActorInput>>
  defaultRole?: InputMaybe<AccessProfileRole>
  name?: InputMaybe<Scalars['String']>
}

export enum AccessProfileRole {
  ReadWrite = 'READ_WRITE',
  ViewOnly = 'VIEW_ONLY',
}

export interface AccessProfileTemplate {
  __typename?: 'AccessProfileTemplate'
  accessProfiles: Array<AccessProfile>
  actors: Array<AccessProfileTemplateActor>
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  createdAt: Scalars['DateTime']
  defaultRole?: Maybe<AccessProfileRole>
  id: Scalars['String']
  name: Scalars['String']
  templates: Array<Maybe<Template>>
  updatedAt: Scalars['DateTime']
}

export interface AccessProfileTemplateActor {
  __typename?: 'AccessProfileTemplateActor'
  accessProfileTemplate: AccessProfileTemplate
  adminUser: AdminUser
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  role: AccessProfileRole
  updatedAt: Scalars['DateTime']
}

export interface AccessProfileTemplateActorInput {
  adminUserId: Scalars['String']
  role: AccessProfileRole
}

export interface AccessProfileTemplateInput {
  actors?: InputMaybe<Array<AccessProfileTemplateActorInput>>
  defaultRole?: InputMaybe<AccessProfileRole>
  name: Scalars['String']
}

export interface AccessProfileTemplatesFilters {
  archivedFilter?: InputMaybe<ArchivedFilter>
}

export interface Acknowledgement {
  __typename?: 'Acknowledgement'
  actionBy: AuditActionedBy
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  preStartId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  worker: Worker
}

export interface AcknowledgementResourceLink {
  __typename?: 'Acknowledgement_ResourceLink'
  actionBy: AuditActionedBy
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  preStartId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  worker?: Maybe<WorkerResourceLink>
}

export interface Address {
  __typename?: 'Address'
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  formattedAddress?: Maybe<Scalars['String']>
  id: Scalars['String']
  postcode?: Maybe<Scalars['String']>
  rawAddress?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  suburb?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export interface AdminUser {
  __typename?: 'AdminUser'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder?: Maybe<Builder>
  builderId?: Maybe<Scalars['String']>
  builders: Array<Maybe<AdminUserToBuilder>>
  createdAt: Scalars['DateTime']
  dashboards?: Maybe<Array<Dashboard>>
  id: Scalars['String']
  latestActivity?: Maybe<Scalars['DateTime']>
  limitedPermissions: Scalars['Boolean']
  mobile?: Maybe<Scalars['String']>
  modules?: Maybe<Array<BuildPassModule>>
  projects: Array<Maybe<Project>>
  roles?: Maybe<Array<Maybe<Role>>>
  updatedAt: Scalars['DateTime']
  user: User
  userId: Scalars['String']
}

export interface AdminUserEntity {
  __typename?: 'AdminUserEntity'
  id: Scalars['String']
  user?: Maybe<UserEntity>
}

export interface AdminUserFilterInput {
  archivedFilter?: InputMaybe<ArchivedFilter>
  excludeRoles?: InputMaybe<Array<Scalars['String']>>
  projectId?: InputMaybe<Scalars['String']>
  roles?: InputMaybe<Array<Scalars['String']>>
}

export interface AdminUserSortInput {
  email?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

export interface AdminUserStats {
  __typename?: 'AdminUserStats'
  stats?: Maybe<Scalars['JSON']>
}

export interface AdminUserToBuilder {
  __typename?: 'AdminUserToBuilder'
  adminUser: AdminUser
  adminUserId: Scalars['String']
  archivedAt: Scalars['DateTime']
  builder?: Maybe<Builder>
  builderId: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  limitedPermissions: Scalars['Boolean']
  roles?: Maybe<Array<Maybe<Role>>>
  updatedAt: Scalars['DateTime']
}

export interface AdminUserResourceLink {
  __typename?: 'AdminUser_ResourceLink'
  id: Scalars['String']
  user: UserResourceLink
}

export interface AgaveAccountStatus {
  __typename?: 'AgaveAccountStatus'
  connected: Scalars['Boolean']
  setup: Scalars['Boolean']
}

export interface AgaveFile {
  __typename?: 'AgaveFile'
  filename: Scalars['String']
  id: Scalars['String']
  sourceId: Scalars['String']
}

export enum AgaveFileTransferType {
  Checklist = 'CHECKLIST',
  Induction = 'INDUCTION',
  SiteDiary = 'SITE_DIARY',
  Swms = 'SWMS',
  Toolbox = 'TOOLBOX',
}

export interface AgaveFolder {
  __typename?: 'AgaveFolder'
  files?: Maybe<Array<Maybe<AgaveFile>>>
  folders?: Maybe<Array<Maybe<AgaveFolder>>>
  hasChildren: Scalars['Boolean']
  id: Scalars['String']
  name: Scalars['String']
}

export interface AgaveLinkTokenResponse {
  __typename?: 'AgaveLinkTokenResponse'
  linkToken?: Maybe<Scalars['String']>
}

export interface AgavePagedMeta {
  __typename?: 'AgavePagedMeta'
  currentPage: Scalars['Int']
  hasMoreResults: Scalars['Boolean']
  pageSize: Scalars['Int']
}

export interface AgavePaginationInput {
  page: Scalars['Int']
  pageSize: Scalars['Int']
}

export interface AgaveProject {
  __typename?: 'AgaveProject'
  address?: Maybe<Scalars['String']>
  completionDate?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  integrationConnection?: Maybe<IntegrationConnection>
  integrationId: Scalars['String']
  logoUrl?: Maybe<Scalars['String']>
  name: Scalars['String']
  sourceId: Scalars['String']
  sourceUrl?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
  status: AgaveProjectStatus
}

export interface AgaveProjectFilterInput {
  searchString?: InputMaybe<Scalars['String']>
}

export enum AgaveProjectStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export interface AgaveProjectsPagedResponse {
  __typename?: 'AgaveProjectsPagedResponse'
  meta: AgavePagedMeta
  projects: Array<AgaveProject>
}

export interface AgaveVendor {
  __typename?: 'AgaveVendor'
  abn?: Maybe<Scalars['String']>
  address?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  id: Scalars['String']
  integrationConnection?: Maybe<IntegrationConnection>
  integrationId: Scalars['String']
  name: Scalars['String']
  phone?: Maybe<Scalars['String']>
  sourceId: Scalars['String']
  sourceUrl?: Maybe<Scalars['String']>
}

export interface AgaveVendorFilterInput {
  searchString?: InputMaybe<Scalars['String']>
}

export interface AgaveVendorsPagedResponse {
  __typename?: 'AgaveVendorsPagedResponse'
  meta: AgavePagedMeta
  vendors: Array<AgaveVendor>
}

export interface AiToolsSettings {
  __typename?: 'AiToolsSettings'
  /** Whether the action enhancement is enabled */
  actionEnhancementEnabled?: Maybe<Scalars['Boolean']>
  /** Whether the AI tools are enabled, has the additional terms and conditions been accepted */
  aiToolsEnabled?: Maybe<Scalars['Boolean']>
  /** Whether the checklist assistant is enabled */
  checklistAssistantEnabled?: Maybe<Scalars['Boolean']>
  /** Whether the content tagging is enabled (resouce tags) */
  contentTaggingEnabled?: Maybe<Scalars['Boolean']>
  /** Whether the contextual action generator is enabled */
  contextualActionGeneratorEnabled?: Maybe<Scalars['Boolean']>
  /** Whether the defect enhancement is enabled */
  defectEnhancementEnabled?: Maybe<Scalars['Boolean']>
  /** Whether the document summary is enabled */
  documentSummaryEnabled?: Maybe<Scalars['Boolean']>
  /** The date the AI tools were enabled */
  enabledByDate?: Maybe<Scalars['DateTime']>
  /** The name of the user who enabled the AI tools */
  enabledByName?: Maybe<Scalars['String']>
  /** Whether the image tagging is enabled */
  imageTaggingEnabled?: Maybe<Scalars['Boolean']>
  /** Whether the location import is enabled */
  locationImportEnabled?: Maybe<Scalars['Boolean']>
  /** List of AI tools requested by the user */
  requestedAiTools?: Maybe<Array<Scalars['String']>>
  /** Whether the site diary summary is enabled */
  siteDiarySummaryEnabled?: Maybe<Scalars['Boolean']>
  /** Whether the toolbox summary is enabled */
  toolboxSummaryEnabled?: Maybe<Scalars['Boolean']>
}

export interface AllProjectHoursBudgetReport {
  __typename?: 'AllProjectHoursBudgetReport'
  projects: Array<AllProjectHoursBudgetReportProject>
}

export interface AllProjectHoursBudgetReportFilterInput {
  projectIds?: InputMaybe<Array<Scalars['String']>>
}

export interface AllProjectHoursBudgetReportProject {
  __typename?: 'AllProjectHoursBudgetReportProject'
  budget?: Maybe<Scalars['Int']>
  percentageHoursUsed?: Maybe<Scalars['Int']>
  project: Project
  projectHours?: Maybe<Scalars['Float']>
  projectId: Scalars['String']
  status: BudgetStatus
}

export enum AnalyzedBlockType {
  KeyValueSet = 'KEY_VALUE_SET',
  Line = 'LINE',
  Page = 'PAGE',
  SelectionElement = 'SELECTION_ELEMENT',
  Word = 'WORD',
}

export interface ApprovePermitInputAdmin {
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  message?: InputMaybe<Scalars['String']>
}

export interface ArchiveSwmsTemplateInput {
  subcontractorId: Scalars['String']
  templateId: Scalars['String']
}

export interface ArchiveSwmsTemplateResponseInput {
  subcontractorId: Scalars['String']
  templateResponseId: Scalars['String']
}

export enum ArchivedFilter {
  ActiveOnly = 'ACTIVE_ONLY',
  ArchivedOnly = 'ARCHIVED_ONLY',
  Both = 'BOTH',
}

export interface AssignProjectToTemplateInput {
  disconnectExisting: Scalars['Boolean']
}

export interface Assignee {
  __typename?: 'Assignee'
  adminUser?: Maybe<AdminUser>
  adminUserId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  registerItem?: Maybe<RegisterItem>
  registerItemId?: Maybe<Scalars['String']>
  subcontractor?: Maybe<Subcontractor>
  subcontractorId?: Maybe<Scalars['String']>
  type?: Maybe<AssigneeType>
  updatedAt: Scalars['DateTime']
  worker?: Maybe<Worker>
  workerId?: Maybe<Scalars['String']>
}

export interface AssigneeEntity {
  __typename?: 'AssigneeEntity'
  adminUser?: Maybe<AdminUserEntity>
  adminUserId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  subcontractor?: Maybe<SubcontractorEntity>
  subcontractorId?: Maybe<Scalars['String']>
  type?: Maybe<AssigneeType>
  updatedAt: Scalars['DateTime']
  worker?: Maybe<WorkerEntity>
  workerId?: Maybe<Scalars['String']>
}

export interface AssigneeInput {
  id: Scalars['String']
  type: AssigneeType
}

export enum AssigneeType {
  AdminUser = 'ADMIN_USER',
  Subcontractor = 'SUBCONTRACTOR',
  Worker = 'WORKER',
}

export interface AssigneeResourceLink {
  __typename?: 'Assignee_ResourceLink'
  adminUser?: Maybe<AdminUserResourceLink>
  adminUserId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  subcontractor?: Maybe<SubcontractorResourceLink>
  subcontractorId?: Maybe<Scalars['String']>
  type?: Maybe<AssigneeType>
  updatedAt: Scalars['DateTime']
  worker?: Maybe<WorkerResourceLink>
  workerId?: Maybe<Scalars['String']>
}

export interface Attachment {
  __typename?: 'Attachment'
  archivedAt?: Maybe<Scalars['DateTime']>
  author?: Maybe<AuditActionByLink>
  builderId?: Maybe<Scalars['String']>
  contentType: Scalars['String']
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  /** @deprecated use photoTakenDate */
  displayDate?: Maybe<Scalars['DateTime']>
  fileName: Scalars['String']
  fileSize: Scalars['String']
  id: Scalars['String']
  key: Scalars['String']
  metadata?: Maybe<Scalars['JSON']>
  photoTakenDate?: Maybe<Scalars['DateTime']>
  platformAction?: Maybe<PlatformAction>
  rawUrl?: Maybe<Scalars['String']>
  resource?: Maybe<Resource>
  sortDate?: Maybe<Scalars['DateTime']>
  tags?: Maybe<Array<Maybe<ResourceTag>>>
  templateResponse?: Maybe<TemplateResponse>
  thumbnail?: Maybe<Thumbnail>
  type: AttachmentType
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
}

export interface AttachmentEntity {
  __typename?: 'AttachmentEntity'
  id: Scalars['String']
  key: Scalars['String']
  thumbnail?: Maybe<Thumbnail>
  url: Scalars['String']
}

export enum AttachmentType {
  Document = 'DOCUMENT',
  Media = 'MEDIA',
  Signature = 'SIGNATURE',
  TemplateResponseMedia = 'TEMPLATE_RESPONSE_MEDIA',
}

export interface AttachmentUploadUrl {
  __typename?: 'AttachmentUploadUrl'
  contentType: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['String']
  key: Scalars['String']
  type: AttachmentType
  uploadUrl: Scalars['String']
  url: Scalars['String']
}

export interface AttachmentUrl {
  __typename?: 'AttachmentUrl'
  key?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export interface AttachmentResourceLink {
  __typename?: 'Attachment_ResourceLink'
  fileName: Scalars['String']
  id: Scalars['String']
  thumbnail?: Maybe<Thumbnail>
  url: Scalars['String']
}

export enum AuditAction {
  Archive = 'ARCHIVE',
  Connect = 'CONNECT',
  Create = 'CREATE',
  Delete = 'DELETE',
  Disconnect = 'DISCONNECT',
  GenerateSummary = 'GENERATE_SUMMARY',
  Invite = 'INVITE',
  Message = 'MESSAGE',
  Process = 'PROCESS',
  Request = 'REQUEST',
  Restore = 'RESTORE',
  Share = 'SHARE',
  Update = 'UPDATE',
}

export type AuditActionByLink =
  | AdminUserEntity
  | SubcontractorEntity
  | WorkerAuditEntity

export type AuditActionByLinkResourceLink =
  | AdminUserResourceLink
  | SubcontractorResourceLink
  | WorkerAuditResourceLink

export enum AuditActionedBy {
  Admin = 'ADMIN',
  Guest = 'GUEST',
  Integration = 'INTEGRATION',
  Procore = 'PROCORE',
  Subcontractor = 'SUBCONTRACTOR',
  SuperAdmin = 'SUPER_ADMIN',
  System = 'SYSTEM',
  User = 'USER',
  Visitor = 'VISITOR',
  Worker = 'WORKER',
}

export interface AuditLog {
  __typename?: 'AuditLog'
  action: AuditAction
  actionBy?: Maybe<AuditActionedBy>
  actionByIdentity?: Maybe<Scalars['String']>
  actionByLink?: Maybe<AuditActionByLink>
  builder?: Maybe<Builder>
  builderId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  linkedResource?: Maybe<AuditResource>
  linkedResourceIdentity?: Maybe<Scalars['String']>
  newSnapshot?: Maybe<Scalars['JSON']>
  oldSnapshot?: Maybe<Scalars['JSON']>
  project?: Maybe<Project>
  projectId?: Maybe<Scalars['String']>
  resource: AuditResource
  resourceIdentity?: Maybe<Scalars['String']>
}

export interface AuditLogSummary {
  __typename?: 'AuditLogSummary'
  last30Days: Scalars['Int']
  last60Days: Scalars['Int']
  last90Days: Scalars['Int']
}

export interface AuditLogResourceLink {
  __typename?: 'AuditLog_ResourceLink'
  action: AuditAction
  actionBy?: Maybe<AuditActionedBy>
  actionByIdentity?: Maybe<Scalars['String']>
  actionByLink?: Maybe<AuditActionByLinkResourceLink>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  linkedResource?: Maybe<AuditResource>
  linkedResourceIdentity?: Maybe<Scalars['String']>
  newSnapshot?: Maybe<Scalars['JSON']>
  oldSnapshot?: Maybe<Scalars['JSON']>
  resource: AuditResource
  resourceIdentity?: Maybe<Scalars['String']>
}

export interface AuditLogsFilterInput {
  action?: InputMaybe<AuditAction>
  actionBy?: InputMaybe<AuditActionedBy>
  actionByIdentity?: InputMaybe<Scalars['String']>
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  builderId?: InputMaybe<Scalars['String']>
  linkedResource?: InputMaybe<AuditResource>
  linkedResourceIdentity?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  resource?: InputMaybe<AuditResource>
  resourceIdentity?: InputMaybe<Scalars['String']>
}

export interface AuditLogsSortInput {
  date?: InputMaybe<SortOrder>
}

export enum AuditResource {
  AccessControl = 'ACCESS_CONTROL',
  AccessControlHardware = 'ACCESS_CONTROL_HARDWARE',
  AccessProfile = 'ACCESS_PROFILE',
  AccessProfileTemplate = 'ACCESS_PROFILE_TEMPLATE',
  AdminUser = 'ADMIN_USER',
  AdminUserToBuilder = 'ADMIN_USER_TO_BUILDER',
  Attachment = 'ATTACHMENT',
  Builder = 'BUILDER',
  BuilderWorkerConnection = 'BUILDER_WORKER_CONNECTION',
  Checklist = 'CHECKLIST',
  CompanyRegisterItem = 'COMPANY_REGISTER_ITEM',
  Contact = 'CONTACT',
  ConversationMessage = 'CONVERSATION_MESSAGE',
  ConversationThread = 'CONVERSATION_THREAD',
  Dashboard = 'DASHBOARD',
  Defect = 'DEFECT',
  Document = 'DOCUMENT',
  DocumentFolder = 'DOCUMENT_FOLDER',
  DocumentSignature = 'DOCUMENT_SIGNATURE',
  Drawing = 'DRAWING',
  Emergency = 'EMERGENCY',
  EmergencyMessage = 'EMERGENCY_MESSAGE',
  File = 'FILE',
  FileUploadInvite = 'FILE_UPLOAD_INVITE',
  HoursBudgetReport = 'HOURS_BUDGET_REPORT',
  Induction = 'INDUCTION',
  InductionInvite = 'INDUCTION_INVITE',
  InductionTemplate = 'INDUCTION_TEMPLATE',
  InsuranceDoc = 'INSURANCE_DOC',
  Integration = 'INTEGRATION',
  IntegrationConnection = 'INTEGRATION_CONNECTION',
  LibrarySwmsDoc = 'LIBRARY_SWMS_DOC',
  LibraryTemplate = 'LIBRARY_TEMPLATE',
  MsdsDoc = 'MSDS_DOC',
  Permission = 'PERMISSION',
  Permit = 'PERMIT',
  PermitType = 'PERMIT_TYPE',
  PermitWorker = 'PERMIT_WORKER',
  PlatformAction = 'PLATFORM_ACTION',
  Prequalification = 'PREQUALIFICATION',
  PreStart = 'PRE_START',
  ProcoreConfig = 'PROCORE_CONFIG',
  Project = 'PROJECT',
  ProjectLocation = 'PROJECT_LOCATION',
  ProjectSchedule = 'PROJECT_SCHEDULE',
  ProjectScheduleItem = 'PROJECT_SCHEDULE_ITEM',
  ProjectWorkerConnection = 'PROJECT_WORKER_CONNECTION',
  Register = 'REGISTER',
  RegisterItem = 'REGISTER_ITEM',
  RegisterItemBooking = 'REGISTER_ITEM_BOOKING',
  RegisterItemType = 'REGISTER_ITEM_TYPE',
  ResourceLink = 'RESOURCE_LINK',
  Role = 'ROLE',
  Schedule = 'SCHEDULE',
  ScheduledJob = 'SCHEDULED_JOB',
  Setting = 'SETTING',
  SignOn = 'SIGN_ON',
  SiteDiary = 'SITE_DIARY',
  SiteTimings = 'SITE_TIMINGS',
  SmsLog = 'SMS_LOG',
  Staff = 'STAFF',
  Subcontractor = 'SUBCONTRACTOR',
  SwmsDoc = 'SWMS_DOC',
  SwmsDocLog = 'SWMS_DOC_LOG',
  Task = 'TASK',
  Template = 'TEMPLATE',
  TemplateResponse = 'TEMPLATE_RESPONSE',
  Ticket = 'TICKET',
  TicketReview = 'TICKET_REVIEW',
  Timesheet = 'TIMESHEET',
  TimesheetGroup = 'TIMESHEET_GROUP',
  Toolbox = 'TOOLBOX',
  ToolboxInvite = 'TOOLBOX_INVITE',
  User = 'USER',
  VersionHistory = 'VERSION_HISTORY',
  Visitor = 'VISITOR',
  WebhookSubscription = 'WEBHOOK_SUBSCRIPTION',
  Worker = 'WORKER',
  WorkerBuilderMetadata = 'WORKER_BUILDER_METADATA',
  WorkerConnection = 'WORKER_CONNECTION',
  WorkerDocument = 'WORKER_DOCUMENT',
  Workflow = 'WORKFLOW',
  WorkflowStep = 'WORKFLOW_STEP',
}

export interface BatchedSmsLog {
  __typename?: 'BatchedSmsLog'
  adminUser?: Maybe<AdminUser>
  adminUserId?: Maybe<Scalars['String']>
  batchId: Scalars['String']
  count: Scalars['Int']
  createdAt: Scalars['DateTime']
  message: Scalars['String']
}

export interface Billing {
  __typename?: 'Billing'
  billingAmount?: Maybe<Scalars['Int']>
  billingInterval?: Maybe<BillingInterval>
  billingIntervalCount?: Maybe<Scalars['Int']>
  createdAt?: Maybe<Scalars['DateTime']>
  currentPeriodStart?: Maybe<Scalars['DateTime']>
  discount?: Maybe<BillingDiscount>
  features?: Maybe<Array<BuildPassModule>>
  product?: Maybe<BuilderTier>
  renewalDate?: Maybe<Scalars['DateTime']>
  status?: Maybe<BillingStatus>
  trialEnd?: Maybe<Scalars['DateTime']>
  trialStart?: Maybe<Scalars['DateTime']>
}

export interface BillingDiscount {
  __typename?: 'BillingDiscount'
  amountOff?: Maybe<Scalars['Int']>
  discountType?: Maybe<BillingDiscountType>
  durationInMonths?: Maybe<Scalars['Int']>
  durationType?: Maybe<BillingDiscountDurationType>
  percentOff?: Maybe<Scalars['Int']>
}

export enum BillingDiscountDurationType {
  Forever = 'FOREVER',
  Once = 'ONCE',
  Repeating = 'REPEATING',
}

export enum BillingDiscountType {
  AmountOff = 'AMOUNT_OFF',
  PercentOff = 'PERCENT_OFF',
}

export enum BillingInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export enum BillingStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID',
}

export enum BlockEntityType {
  Key = 'KEY',
  Value = 'VALUE',
}

export interface BlockRelationship {
  __typename?: 'BlockRelationship'
  Ids: Array<Scalars['String']>
  Type: BlockRelationshipType
}

export enum BlockRelationshipType {
  Child = 'CHILD',
  Value = 'VALUE',
}

export enum BudgetStatus {
  AtBudget = 'AT_BUDGET',
  InvalidTimeframe = 'INVALID_TIMEFRAME',
  NoBudget = 'NO_BUDGET',
  NoHoursLogged = 'NO_HOURS_LOGGED',
  NoTimeframe = 'NO_TIMEFRAME',
  OnTrack = 'ON_TRACK',
  OverBudget = 'OVER_BUDGET',
  ProjectedOverBudget = 'PROJECTED_OVER_BUDGET',
  UnderBudget = 'UNDER_BUDGET',
}

export interface BuildPassData {
  __typename?: 'BuildPassData'
  environment?: Maybe<Scalars['String']>
  healthCheck?: Maybe<Scalars['String']>
  version?: Maybe<Scalars['String']>
}

export enum BuildPassModule {
  AccessControl = 'ACCESS_CONTROL',
  AccessProfiles = 'ACCESS_PROFILES',
  Actions = 'ACTIONS',
  AiTools = 'AI_TOOLS',
  Checklists = 'CHECKLISTS',
  Communication = 'COMMUNICATION',
  CustomSiteInductions = 'CUSTOM_SITE_INDUCTIONS',
  Defects = 'DEFECTS',
  DefectReport = 'DEFECT_REPORT',
  Documents = 'DOCUMENTS',
  Drawings = 'DRAWINGS',
  Emergency = 'EMERGENCY',
  HoursBudgetReport = 'HOURS_BUDGET_REPORT',
  ImageGallery = 'IMAGE_GALLERY',
  Itps = 'ITPS',
  Locations = 'LOCATIONS',
  MyDashboards = 'MY_DASHBOARDS',
  MyDashboardsMetabaseWidget = 'MY_DASHBOARDS_METABASE_WIDGET',
  MyDashboardsWordGames = 'MY_DASHBOARDS_WORD_GAMES',
  PerformanceReport = 'PERFORMANCE_REPORT',
  Permits = 'PERMITS',
  PremierIntegration = 'PREMIER_INTEGRATION',
  Prequalifications = 'PREQUALIFICATIONS',
  PreStarts = 'PRE_STARTS',
  ProjectMap = 'PROJECT_MAP',
  ProjectOverview = 'PROJECT_OVERVIEW',
  Registers = 'REGISTERS',
  Reports = 'REPORTS',
  RotatingQrCode = 'ROTATING_QR_CODE',
  Safety = 'SAFETY',
  Scheduling = 'SCHEDULING',
  Sds = 'SDS',
  SiteDiaries = 'SITE_DIARIES',
  Staff = 'STAFF',
  Subcontractors = 'SUBCONTRACTORS',
  SubcontractorReport = 'SUBCONTRACTOR_REPORT',
  SwmsBuilder = 'SWMS_BUILDER',
  SwmsLibrary = 'SWMS_LIBRARY',
  Tickets = 'TICKETS',
  Timesheets = 'TIMESHEETS',
  Toolboxes = 'TOOLBOXES',
  WhiteLabelling = 'WHITE_LABELLING',
  Workers = 'WORKERS',
  WorkerQrCodes = 'WORKER_QR_CODES',
  Workflows = 'WORKFLOWS',
}

export interface Builder {
  __typename?: 'Builder'
  accessControlHardware: Array<AccessControlHardware>
  adminUsers: Array<Maybe<AdminUser>>
  adminUsersCount: Scalars['Int']
  archivedAt?: Maybe<Scalars['DateTime']>
  auditLogSummary: AuditLogSummary
  builderMetadata?: Maybe<Scalars['JSON']>
  builderSettings: BuilderSettings
  builderSubcontractor?: Maybe<Subcontractor>
  clerkOrganizationId?: Maybe<Scalars['String']>
  company: Company
  createdAt: Scalars['DateTime']
  defaultLanguage?: Maybe<Scalars['String']>
  defaultLocale?: Maybe<SupportedLocaleCountryCode>
  defaultTimezone?: Maybe<Scalars['String']>
  hideBuildPassLogos?: Maybe<Scalars['Boolean']>
  hubspotDealIdentifier?: Maybe<Scalars['String']>
  id: Scalars['String']
  inductionTemplate?: Maybe<InductionTemplate>
  inductions: Array<Maybe<Induction>>
  integrations?: Maybe<Array<Integration>>
  isDemo?: Maybe<Scalars['Boolean']>
  isSeeded?: Maybe<Scalars['Boolean']>
  isTrial?: Maybe<Scalars['Boolean']>
  kindeOrganizationId?: Maybe<Scalars['String']>
  logoKey?: Maybe<Scalars['String']>
  logoUrl?: Maybe<Scalars['String']>
  mapPinLogoUrl?: Maybe<Scalars['String']>
  modules: Array<BuildPassModule>
  procoreConfig?: Maybe<ProcoreConfig>
  projects: Array<Maybe<Project>>
  projectsCount: Scalars['Int']
  publicBuilderSettings: PublicBuilderSettings
  registers: Array<Register>
  requiredTickets: Array<Maybe<TicketTemplateEntity>>
  stripeIdentifier?: Maybe<Scalars['String']>
  subcontractors: Array<Maybe<Subcontractor>>
  subscriptId?: Maybe<Scalars['String']>
  subscription: BuilderTier
  templates: Array<Maybe<Template>>
  trialExpiresAt?: Maybe<Scalars['DateTime']>
  updatedAt: Scalars['DateTime']
}

export interface BuilderTemplatesArgs {
  templateType?: InputMaybe<TemplateType>
}

export interface BuilderAccountInput {
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  role: BuilderAccountRole
  sendInvite?: InputMaybe<Scalars['Boolean']>
}

export enum BuilderAccountRole {
  Manager = 'MANAGER',
  Owner = 'OWNER',
  ProjectManager = 'PROJECT_MANAGER',
}

export interface BuilderEngagement {
  __typename?: 'BuilderEngagement'
  latestAdminUserAudit?: Maybe<AuditLog>
  latestAudit?: Maybe<AuditLog>
  latestProject?: Maybe<Project>
  latestSignOn?: Maybe<SignOn>
}

export interface BuilderEntity {
  __typename?: 'BuilderEntity'
  builderMetadata?: Maybe<Scalars['JSON']>
  company?: Maybe<Company>
  defaultLanguage?: Maybe<Scalars['String']>
  defaultLocale?: Maybe<SupportedLocaleCountryCode>
  defaultTimezone?: Maybe<Scalars['String']>
  hideBuildPassLogos?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  logoUrl?: Maybe<Scalars['String']>
  requiredTickets?: Maybe<Array<Maybe<TicketTemplateEntity>>>
  templates: Array<Maybe<TemplateEntity>>
}

export interface BuilderEntityTemplatesArgs {
  templateType?: InputMaybe<TemplateType>
}

export interface BuilderEntityPublic {
  __typename?: 'BuilderEntityPublic'
  company?: Maybe<Company>
  defaultLanguage?: Maybe<Scalars['String']>
  defaultLocale?: Maybe<SupportedLocaleCountryCode>
  defaultTimezone?: Maybe<Scalars['String']>
  id: Scalars['String']
  logoUrl?: Maybe<Scalars['String']>
}

export interface BuilderEntityWhitelabel {
  __typename?: 'BuilderEntityWhitelabel'
  defaultLanguage?: Maybe<Scalars['String']>
  defaultLocale?: Maybe<SupportedLocaleCountryCode>
  defaultTimezone?: Maybe<Scalars['String']>
  hideBuildPassLogos?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  logoUrl?: Maybe<Scalars['String']>
}

export interface BuilderEvent {
  __typename?: 'BuilderEvent'
  actionBy?: Maybe<BuilderEventActionBy>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  projectId: Scalars['String']
  type: BuilderEventType
}

export type BuilderEventActionBy = AdminUserEntity | WorkerAuditEntity

export enum BuilderEventOrderByInput {
  Asc = 'asc',
  Desc = 'desc',
}

export interface BuilderEventResult {
  __typename?: 'BuilderEventResult'
  events?: Maybe<Array<Maybe<BuilderEvent>>>
  projectStats?: Maybe<Array<Maybe<ProjectStats>>>
}

export enum BuilderEventType {
  Induction = 'INDUCTION',
  SignOn = 'SIGN_ON',
}

export interface BuilderExternalLink {
  __typename?: 'BuilderExternalLink'
  externalLinkCuid: Scalars['String']
  homeUrl: Scalars['String']
  id: Scalars['String']
  linkUrl: Scalars['String']
  type: Scalars['String']
}

export interface BuilderExternalLinkInput {
  externalLinkCuid: Scalars['String']
  id: Scalars['String']
  type: Scalars['String']
}

export interface BuilderFilterInput {
  isArchived?: InputMaybe<Scalars['Boolean']>
  isDemo?: InputMaybe<Scalars['Boolean']>
  isSeeded?: InputMaybe<Scalars['Boolean']>
  isTrial?: InputMaybe<BuilderFilterTrialStatus>
  searchString?: InputMaybe<Scalars['String']>
  subscription?: InputMaybe<Array<InputMaybe<BuilderTier>>>
}

export enum BuilderFilterTrialStatus {
  Expired = 'EXPIRED',
  False = 'FALSE',
  True = 'TRUE',
}

export interface BuilderInduction extends Induction {
  __typename?: 'BuilderInduction'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  builderId: Scalars['String']
  contextMetadata?: Maybe<ContextMetadata>
  createdAt: Scalars['DateTime']
  currentVersion?: Maybe<VersionHistory>
  documentSignatures: Array<Maybe<DocumentSignature>>
  evidenceSighted?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  /** @deprecated Use templateResponse instead */
  inductionSections?: Maybe<Scalars['JSON']>
  /** @deprecated Use template instead */
  inductionTemplate?: Maybe<InductionTemplate>
  signatureUrl?: Maybe<Scalars['String']>
  status?: Maybe<InductionStatus>
  subcontractor?: Maybe<Subcontractor>
  subcontractorId?: Maybe<Scalars['String']>
  templateName?: Maybe<Scalars['String']>
  templateResponse?: Maybe<TemplateResponse>
  type: InductionType
  updatedAt: Scalars['DateTime']
  versionHistory?: Maybe<Array<VersionHistory>>
  worker: Worker
  workerId: Scalars['String']
  /** @deprecated Use workerSnapshotFull instead */
  workerSnapshot?: Maybe<Scalars['JSON']>
  workerSnapshotFull?: Maybe<WorkerSnapshot>
}

export interface BuilderInductionFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InductionStatus>>
  subcontractorIds?: InputMaybe<Array<Scalars['String']>>
  workerIds?: InputMaybe<Array<Scalars['String']>>
}

export interface BuilderQuestionnaireResponse {
  __typename?: 'BuilderQuestionnaireResponse'
  questionnaire?: Maybe<Scalars['JSON']>
}

/** Register module settings for the entire Builder */
export interface BuilderRegisterSettings {
  __typename?: 'BuilderRegisterSettings'
  /** Only allow register items linked checklists to be completed when the status is REVIEWED */
  onlyAllowReviewedRegisterItemChecklists: Scalars['Boolean']
}

export interface BuilderSettings {
  __typename?: 'BuilderSettings'
  externalLinks?: Maybe<Array<BuilderExternalLink>>
  hideMedical?: Maybe<Scalars['Boolean']>
}

export interface BuilderSortInput {
  builderName?: InputMaybe<SortOrder>
  date?: InputMaybe<SortOrder>
}

export enum BuilderTier {
  Enterprise = 'ENTERPRISE',
  EnterpriseSeat = 'ENTERPRISE_SEAT',
  Free = 'FREE',
  Lite = 'LITE',
  LiteSeat = 'LITE_SEAT',
  Pro = 'PRO',
  ProSeat = 'PRO_SEAT',
  Solo = 'SOLO',
  Standard = 'STANDARD',
  StandardSeat = 'STANDARD_SEAT',
  Starter = 'STARTER',
}

export interface BuilderWorkerDocument {
  __typename?: 'BuilderWorkerDocument'
  attachment: Attachment
  attachmentId: Scalars['String']
  builder: Builder
  builderId: Scalars['String']
  createdAt: Scalars['DateTime']
  deletedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  name?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  worker: Worker
  workerId: Scalars['String']
}

export interface BuilderWorkersFilterInput {
  projectId?: InputMaybe<Scalars['String']>
}

export interface BuilderResourceLink {
  __typename?: 'Builder_ResourceLink'
  company: CompanyResourceLink
  defaultLanguage?: Maybe<Scalars['String']>
  defaultLocale?: Maybe<SupportedLocaleCountryCode>
  defaultTimezone?: Maybe<Scalars['String']>
  hideBuildPassLogos?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  logoUrl?: Maybe<Scalars['String']>
}

export interface BuildxactAccountStatus {
  __typename?: 'BuildxactAccountStatus'
  connected: Scalars['Boolean']
  setup: Scalars['Boolean']
}

export interface BuildxactContact {
  __typename?: 'BuildxactContact'
  abn?: Maybe<Scalars['String']>
  address?: Maybe<Scalars['String']>
  businessName: Scalars['String']
  contactName?: Maybe<Scalars['String']>
  contactUrl?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  id: Scalars['String']
  integrationConnection?: Maybe<IntegrationConnection>
  integrationId: Scalars['String']
}

export interface BuildxactContactsPaginatedResponse {
  __typename?: 'BuildxactContactsPaginatedResponse'
  contacts: Array<BuildxactContact>
  pagination: PaginationAggregation
}

export enum BuildxactFileType {
  Document = 'DOCUMENT',
  SiteDiary = 'SITE_DIARY',
}

export interface BuildxactProject {
  __typename?: 'BuildxactProject'
  address?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  integrationConnection?: Maybe<IntegrationConnection>
  integrationId: Scalars['String']
  jobUrl?: Maybe<Scalars['String']>
  name: Scalars['String']
  status: Scalars['String']
}

export interface BuildxactProjectsPaginatedResponse {
  __typename?: 'BuildxactProjectsPaginatedResponse'
  pagination: PaginationAggregation
  projects: Array<BuildxactProject>
}

export interface BulkSyncDataPipelineResponse {
  __typename?: 'BulkSyncDataPipelineResponse'
  failedSyncedIds: Array<Maybe<Scalars['String']>>
  successfullySyncedIds: Array<Maybe<Scalars['String']>>
}

export interface BulkSyncResult {
  __typename?: 'BulkSyncResult'
  ids: Array<Scalars['String']>
}

export interface CallbackInfo {
  attachPdf?: InputMaybe<Scalars['Boolean']>
  builderId?: InputMaybe<Scalars['String']>
  emailPdfCallbackInfo?: InputMaybe<EmailPdfCallbackInfo>
  projectId?: InputMaybe<Scalars['String']>
  resourceId?: InputMaybe<Scalars['String']>
  resourceType?: InputMaybe<Scalars['String']>
  type?: InputMaybe<PdfWorkflowType>
}

export interface CaptureExtra {
  attachments?: Maybe<Array<Maybe<Attachment>>>
  notes?: Maybe<Scalars['String']>
}

export interface CheckboxCaptureBlock extends CaptureExtra, TemplateBlockBase {
  __typename?: 'CheckboxCaptureBlock'
  attachments?: Maybe<Array<Maybe<Attachment>>>
  checkboxes?: Maybe<Array<Maybe<CheckboxRadioField>>>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
}

export interface CheckboxRadioField {
  __typename?: 'CheckboxRadioField'
  checked?: Maybe<Scalars['Boolean']>
  desiredState?: Maybe<Scalars['Boolean']>
  label?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
}

export interface ChecklistCategorySetting {
  __typename?: 'ChecklistCategorySetting'
  colour?: Maybe<Scalars['String']>
  icon?: Maybe<Scalars['String']>
  id: Scalars['String']
  label: Scalars['String']
}

export interface ChecklistCategorySettingInput {
  colour?: InputMaybe<Scalars['String']>
  icon?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  label: Scalars['String']
}

export interface ChecklistColumn {
  __typename?: 'ChecklistColumn'
  blockId: Scalars['String']
  templateId: Scalars['String']
  title?: Maybe<Scalars['String']>
}

export interface ChecklistColumnInput {
  blockId: Scalars['String']
  templateId: Scalars['String']
  title?: InputMaybe<Scalars['String']>
}

export interface ChecklistDisplayBlock extends TemplateBlockBase {
  __typename?: 'ChecklistDisplayBlock'
  checklist?: Maybe<Array<Maybe<CheckboxRadioField>>>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
}

/** Checklist module settings for the entire Builder */
export interface ChecklistSettings {
  __typename?: 'ChecklistSettings'
  /** Customisable list of categories that can be used on checklists */
  checklistCategories?: Maybe<Array<ChecklistCategorySetting>>
  /** Set which categories should display in the side navigation bar */
  checklistCategoriesInNavigation?: Maybe<Array<Scalars['String']>>
  /** Allow any checklist to be completed by staff of the builder */
  checklistsAvailableForStaff?: Maybe<Scalars['Boolean']>
  /** Only send actions to assignees once a checklist is completed */
  onlySendActionsAfterChecklistCompleted?: Maybe<Scalars['Boolean']>
  /** Checklists available publicly for workers to fill in */
  publicChecklistIds?: Maybe<Array<Scalars['String']>>
  /** Require workers to complete a project induction before they can fill checklists */
  requireProjectInduction?: Maybe<Scalars['Boolean']>
  /** Whether to show the subcontractor column in the checklist table */
  showSubcontractorColumnInChecklistTable?: Maybe<Scalars['Boolean']>
  /**
   * TEMPORARY - For testing as we roll out this new feature
   * @deprecated No longer used, quickUploader is default in UI
   */
  useQuickUploader?: Maybe<Scalars['Boolean']>
}

export interface ChecklistUsage {
  __typename?: 'ChecklistUsage'
  completed: Scalars['Int']
  started: Scalars['Int']
  topCategories: Array<TopChecklistCategories>
}

export interface CloneProjectLocationsInput {
  fromProjectId: Scalars['String']
  toProjectId: Scalars['String']
}

export interface CloseoutPermitInputAdmin {
  closeoutTemplateResponseData?: InputMaybe<Scalars['JSON']>
}

export interface CloseoutPermitInputWorker {
  closeoutTemplateResponseData?: InputMaybe<Scalars['JSON']>
}

export type CodeForProjectCheckPayload =
  | CodeForProjectCheckFailure
  | CodeForProjectCheckSuccess

export interface CodeForProjectCheckFailure {
  __typename?: 'CodeForProjectCheck_Failure'
  customMessage?: Maybe<Scalars['String']>
  message: Scalars['String']
}

export interface CodeForProjectCheckSuccess {
  __typename?: 'CodeForProjectCheck_Success'
  expiresAt: Scalars['DateTime']
  token: Scalars['String']
}

export type CodeForProjectPayload =
  | CodeForProjectDisabled
  | CodeForProjectSuccess

export interface CodeForProjectDisabled {
  __typename?: 'CodeForProject_Disabled'
  message: Scalars['String']
  project: Project
}

export interface CodeForProjectSuccess {
  __typename?: 'CodeForProject_Success'
  code: Scalars['String']
  interval?: Maybe<Scalars['Int']>
  nextRefresh?: Maybe<Scalars['DateTime']>
  project: Project
}

export interface CommunicationSettings {
  __typename?: 'CommunicationSettings'
  /** Whether or not to allow sending an SMS across all projects */
  allowCompanyWideCommunication?: Maybe<Scalars['Boolean']>
}

export interface Company {
  __typename?: 'Company'
  abn?: Maybe<Scalars['String']>
  attachments?: Maybe<Array<CompanyAttachment>>
  createdAt?: Maybe<Scalars['DateTime']>
  id?: Maybe<Scalars['String']>
  name: Scalars['String']
  subcontractors?: Maybe<Array<Maybe<CompanySubcontractor>>>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export interface CompanyAttachment {
  __typename?: 'CompanyAttachment'
  fileName: Scalars['String']
  id: Scalars['String']
  metadata?: Maybe<Scalars['JSON']>
  type: CompanyAttachmentType
}

export enum CompanyAttachmentType {
  InsuranceDoc = 'INSURANCE_DOC',
  MsdsDoc = 'MSDS_DOC',
  Other = 'OTHER',
  SwmsDoc = 'SWMS_DOC',
}

export interface CompanyEntity {
  __typename?: 'CompanyEntity'
  abn?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  name: Scalars['String']
}

export interface CompanyInductionResourceLink {
  __typename?: 'CompanyInduction_ResourceLink'
  createdAt: Scalars['DateTime']
  documentSignatures: Array<Maybe<DocumentSignatureResourceLink>>
  id: Scalars['String']
  status?: Maybe<InductionStatus>
  subcontractor?: Maybe<SubcontractorResourceLink>
  templateResponse?: Maybe<TemplateResponseResourceLink>
  type: InductionType
  updatedAt: Scalars['DateTime']
  worker: WorkerResourceLink
}

export interface CompanyNameInput {
  abn?: InputMaybe<Scalars['String']>
  contactName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  number?: InputMaybe<Scalars['String']>
}

export interface CompanyRegisterItem {
  __typename?: 'CompanyRegisterItem'
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  name: Scalars['String']
  typeTemplateResponse?: Maybe<Scalars['JSON']>
  updatedAt: Scalars['DateTime']
}

export interface CompanyRegisterItemFilterInput {
  archivedFilter?: InputMaybe<ArchivedFilter>
  searchString?: InputMaybe<Scalars['String']>
}

export interface CompanyResourceLink {
  __typename?: 'Company_ResourceLink'
  name: Scalars['String']
}

export interface CompanySubcontractor {
  __typename?: 'Company_Subcontractor'
  builder?: Maybe<BuilderEntity>
  company?: Maybe<CompanyEntity>
  id: Scalars['String']
}

export interface CompleteSwmsTemplateResponseInput {
  subcontractorId: Scalars['String']
  templateResponseId: Scalars['String']
}

export interface ConnectAgaveAccountInput {
  integrationType: IntegrationType
  publicToken: Scalars['String']
}

export interface ConnectBuildxactAccountInput {
  bxcontext: Scalars['String']
}

export interface ConnectBuildxactContactsInput {
  ids?: InputMaybe<Array<Scalars['String']>>
}

export interface ConnectBuildxactContactsResponse {
  __typename?: 'ConnectBuildxactContactsResponse'
  ids: Array<Scalars['String']>
}

export interface ConnectBuildxactProjectsInput {
  ids?: InputMaybe<Array<Scalars['String']>>
}

export interface ConnectBuildxactProjectsResponse {
  __typename?: 'ConnectBuildxactProjectsResponse'
  ids: Array<Scalars['String']>
}

export interface ConnectPremierAccountInput {
  clientId: Scalars['String']
  password: Scalars['String']
  username: Scalars['String']
}

export interface ConnectPremierJobsInput {
  companyId: Scalars['String']
  ids?: InputMaybe<Array<Scalars['String']>>
}

export interface ConnectPremierJobsResponse {
  __typename?: 'ConnectPremierJobsResponse'
  ids: Array<Scalars['String']>
}

export interface ConnectPremierVendorsInput {
  companyId: Scalars['String']
  ids?: InputMaybe<Array<Scalars['String']>>
}

export interface ConnectPremierVendorsResponse {
  __typename?: 'ConnectPremierVendorsResponse'
  ids: Array<Scalars['String']>
}

export interface Contact {
  __typename?: 'Contact'
  createdAt: Scalars['DateTime']
  /** When type is OTHER, this field is used to store the custom type */
  customType?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  id: Scalars['String']
  isPrimaryContact: Scalars['Boolean']
  name?: Maybe<Scalars['String']>
  number?: Maybe<Scalars['String']>
  projects?: Maybe<Array<Maybe<Project>>>
  subcontractor?: Maybe<Subcontractor>
  subcontractorId?: Maybe<Scalars['String']>
  type: ContactType
  updatedAt: Scalars['DateTime']
}

export interface ContactEntity {
  __typename?: 'ContactEntity'
  customType?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  id: Scalars['String']
  isPrimaryContact: Scalars['Boolean']
  name?: Maybe<Scalars['String']>
  number?: Maybe<Scalars['String']>
  type: ContactType
}

export interface ContactInput {
  customType?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  isPrimaryContact?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  number?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  type?: InputMaybe<ContactType>
}

export enum ContactType {
  Client = 'CLIENT',
  Hsr = 'HSR',
  Other = 'OTHER',
  SiteManager = 'SITE_MANAGER',
  Subcontractor = 'SUBCONTRACTOR',
}

export interface ContactResourceLink {
  __typename?: 'Contact_ResourceLink'
  id: Scalars['String']
  name?: Maybe<Scalars['String']>
  subcontractor?: Maybe<SubcontractorResourceLink>
}

export interface ContextMetadata {
  __typename?: 'ContextMetadata'
  appVersion?: Maybe<Scalars['String']>
  createdFrom?: Maybe<CreatedFromContext>
  formName?: Maybe<Scalars['String']>
  geolocationContext?: Maybe<GeolocationContext>
  integrationContext?: Maybe<IntegrationContext>
  ipAddress?: Maybe<Scalars['String']>
  isPWA?: Maybe<Scalars['Boolean']>
  userAgent?: Maybe<Scalars['String']>
}

export interface ContextMetadataInput {
  appVersion?: InputMaybe<Scalars['String']>
  createdFrom?: InputMaybe<CreatedFromContext>
  geolocationContext?: InputMaybe<GeolocationContextInput>
  integrationContext?: InputMaybe<IntegrationContextInput>
  ipAddress?: InputMaybe<Scalars['String']>
  isPWA?: InputMaybe<Scalars['Boolean']>
  userAgent?: InputMaybe<Scalars['String']>
}

export interface ConversationMessage {
  __typename?: 'ConversationMessage'
  attachments: Array<Maybe<Attachment>>
  content?: Maybe<Scalars['String']>
  conversation: ConversationThread
  conversationId: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  sender: Assignee
  senderId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export interface ConversationMessageEntity {
  __typename?: 'ConversationMessageEntity'
  attachments?: Maybe<Array<AttachmentEntity>>
  content?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  sender: AssigneeEntity
  updatedAt: Scalars['DateTime']
}

export interface ConversationMessageResourceLink {
  __typename?: 'ConversationMessage_ResourceLink'
  attachments?: Maybe<Array<AttachmentResourceLink>>
  content?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  sender: AssigneeResourceLink
  updatedAt: Scalars['DateTime']
}

export interface ConversationThread {
  __typename?: 'ConversationThread'
  builder: Builder
  builderId: Scalars['String']
  createdAt: Scalars['DateTime']
  defect: Defect
  defectId: Scalars['String']
  id: Scalars['String']
  messages: Array<Maybe<ConversationMessage>>
  project?: Maybe<Project>
  projectId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface ConversationThreadEntity {
  __typename?: 'ConversationThreadEntity'
  builder: BuilderEntity
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  messages?: Maybe<Array<ConversationMessageResourceLink>>
  project: ProjectEntity
  updatedAt: Scalars['DateTime']
}

export interface ConversationThreadResourceLink {
  __typename?: 'ConversationThread_ResourceLink'
  builder: BuilderResourceLink
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  messages?: Maybe<Array<ConversationMessageResourceLink>>
  project?: Maybe<ProjectResourceLink>
  updatedAt: Scalars['DateTime']
}

export interface CostCode {
  __typename?: 'CostCode'
  code: Scalars['String']
  description: Scalars['String']
  id: Scalars['String']
}

export interface CostCodeInput {
  code: Scalars['String']
  description: Scalars['String']
  id: Scalars['String']
}

export interface Count {
  __typename?: 'Count'
  count: Scalars['String']
}

export interface CreateAccessControlForWorkerInput {
  identifier: Scalars['String']
  projectIds: Array<Scalars['String']>
  type: AccessControlType
  workerId: Scalars['String']
}

export interface CreateAccessControlIntegrationConnectionInput {
  integrationId: Scalars['String']
  keyFobAccessId?: InputMaybe<Scalars['String']>
  projectIdsAccess?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  workerId?: InputMaybe<Scalars['String']>
}

export interface CreateAgaveLinkSessionTokenInput {
  integrationType: IntegrationType
}

export interface CreateAgaveLinkSessionTokenResponse {
  __typename?: 'CreateAgaveLinkSessionTokenResponse'
  sessionToken: Scalars['String']
}

export interface CreateAttachmentInput {
  builderId?: InputMaybe<Scalars['String']>
  contentType: Scalars['String']
  exifMetadata?: InputMaybe<Scalars['JSON']>
  fileName: Scalars['String']
  fileSize: Scalars['String']
  id?: InputMaybe<Scalars['String']>
  immediatelyPublish?: InputMaybe<Scalars['Boolean']>
  key: Scalars['String']
  metadata?: InputMaybe<Scalars['JSON']>
  photoTakenDate?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  projectLocationId?: InputMaybe<Scalars['String']>
  resource: Resource
  sortDate?: InputMaybe<Scalars['DateTime']>
  type: AttachmentType
}

export interface CreateAttachmentUploadUrlInput {
  contentType: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['String']
  key?: InputMaybe<Scalars['String']>
  type: AttachmentType
}

export interface CreateAuditLogInput {
  action: AuditAction
  actionBy: AuditActionedBy
  actionByIdentity: Scalars['String']
  builderId?: InputMaybe<Scalars['String']>
  linkedResource?: InputMaybe<AuditResource>
  linkedResourceIdentity?: InputMaybe<Scalars['String']>
  newSnapshot?: InputMaybe<Scalars['JSON']>
  oldSnapshot?: InputMaybe<Scalars['JSON']>
  projectId?: InputMaybe<Scalars['String']>
  resource: AuditResource
  resourceIdentity?: InputMaybe<Scalars['String']>
}

export interface CreateBuilderInput {
  accounts?: InputMaybe<Array<BuilderAccountInput>>
  defaultLanguage?: InputMaybe<Scalars['String']>
  defaultLocale?: InputMaybe<SupportedLocaleCountryCode>
  defaultTimezone?: InputMaybe<Scalars['String']>
  hubspotDealIdentifier?: InputMaybe<Scalars['String']>
  isDemo?: InputMaybe<Scalars['Boolean']>
  isSeeded?: InputMaybe<Scalars['Boolean']>
  isTrial?: InputMaybe<Scalars['Boolean']>
  modules?: InputMaybe<Array<BuildPassModule>>
  name: Scalars['String']
  seedWithDummyData?: InputMaybe<Scalars['Boolean']>
  stripeIdentifier?: InputMaybe<Scalars['String']>
  subscription?: InputMaybe<BuilderTier>
  trialExpiresAt?: InputMaybe<Scalars['DateTime']>
}

export interface CreateBuilderWorkerDocumentInput {
  createAttachment: CreateAttachmentInput
  name?: InputMaybe<Scalars['String']>
  workerId: Scalars['String']
}

export interface CreateCompanyRegisterItemPublicInput {
  name?: InputMaybe<Scalars['String']>
  typeTemplateResponseData: Scalars['JSON']
}

export interface CreateConversationMessageInput {
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  content?: InputMaybe<Scalars['String']>
  conversationId: Scalars['String']
}

export interface CreateDefectInput {
  assignees?: InputMaybe<Array<AssigneeInput>>
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  description?: InputMaybe<Scalars['String']>
  dueDate?: InputMaybe<Scalars['DateTime']>
  locationId?: InputMaybe<Scalars['String']>
  priority?: InputMaybe<DefectPriority>
  projectId: Scalars['String']
  status: DefectStatus
  tags?: InputMaybe<Array<Scalars['String']>>
  templateResponseBlockIdentifier?: InputMaybe<Scalars['String']>
  templateResponseId?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export interface CreateDocumentFolderInput {
  category: DocumentCategory
  name: Scalars['String']
  parentId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  visibleToWorkers?: InputMaybe<Scalars['Boolean']>
}

export interface CreateDocumentInput {
  category: DocumentCategory
  documentFolderId?: InputMaybe<Scalars['String']>
  key: Scalars['String']
  name: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
  public?: InputMaybe<Scalars['Boolean']>
  status: DocumentStatus
  subcontractorId?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export interface CreateDocumentSignatureForWorkerInput {
  signatureKey: Scalars['String']
  swmsDocId: Scalars['String']
  workerId: Scalars['String']
}

export interface CreateDocumentSignatureInput {
  inductionId?: InputMaybe<Scalars['String']>
  signatureKey: Scalars['String']
  swmsDocId: Scalars['String']
}

export interface CreateDocumentSignaturesInput {
  inductionId?: InputMaybe<Scalars['String']>
  signatureKey: Scalars['String']
  swmsDocIds: Array<InputMaybe<Scalars['String']>>
}

export interface CreateDrawingInputAdmin {
  documentFolderId?: InputMaybe<Scalars['String']>
  drawingNumber?: InputMaybe<Scalars['String']>
  drawingRevision?: InputMaybe<Scalars['String']>
  fileName: Scalars['String']
  key: Scalars['String']
  projectId: Scalars['String']
  title?: InputMaybe<Scalars['String']>
}

export interface CreateEmergencyInput {
  description: Scalars['String']
  projectId: Scalars['String']
  title: Scalars['String']
  visitorIds?: InputMaybe<Array<Scalars['String']>>
  workerIds?: InputMaybe<Array<Scalars['String']>>
}

export interface CreateFileUploadInviteInput {
  metadata?: InputMaybe<Scalars['JSON']>
  projectId?: InputMaybe<Scalars['String']>
  subcontractorId: Scalars['String']
}

export interface CreateFileUploadInvitesInput {
  metadata?: InputMaybe<Scalars['JSON']>
  projectId?: InputMaybe<Scalars['String']>
  subcontractorIds: Array<Scalars['String']>
}

export interface CreateInductionInput {
  builderId?: InputMaybe<Scalars['String']>
  contextMetadata?: InputMaybe<ContextMetadataInput>
  inductionSections?: InputMaybe<Scalars['JSON']>
  inductionTemplateId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  signatureKey?: InputMaybe<Scalars['String']>
  status?: InputMaybe<InductionStatus>
  subcontractorId?: InputMaybe<Scalars['String']>
  templateResponse?: InputMaybe<CreateTemplateResponseInput>
  type: InductionType
  workerId?: InputMaybe<Scalars['String']>
}

export interface CreateInductionInviteAcceptInput {
  inductionInviteId: Scalars['String']
}

export interface CreateInductionInviteInput {
  metadata?: InputMaybe<Scalars['JSON']>
}

export interface CreateInsuranceDocInput {
  expiry?: InputMaybe<Scalars['DateTime']>
  key: Scalars['String']
  name: Scalars['String']
  status: InsuranceStatus
  subcontractorId: Scalars['String']
  type: InsuranceType
  typeOther?: InputMaybe<Scalars['String']>
}

export interface CreateIntegrationConnectionInput {
  integrationId: Scalars['String']
  integrationIdentifier: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
  subcontractorId?: InputMaybe<Scalars['String']>
}

export interface CreateIntegrationConnectionsInBulkInput {
  integrationId: Scalars['String']
  integrations: Array<InputMaybe<RelationPair>>
}

export interface CreateIntegrationInput {
  integrationData?: InputMaybe<Scalars['JSON']>
  integrationIdentifier: Scalars['String']
  integrationSecrets?: InputMaybe<Scalars['JSON']>
  integrationType: IntegrationType
}

export interface CreateLibrarySwmsDocInputAdmin {
  key?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  status?: InputMaybe<SwmsStatus>
  subcontractorId: Scalars['String']
}

export interface CreateLibraryTemplateInput {
  templateData?: InputMaybe<Scalars['JSON']>
  templateDescription?: InputMaybe<Scalars['String']>
  templateName: Scalars['String']
  templateType: TemplateType
}

export interface CreateMsdsDocInput {
  key: Scalars['String']
  name: Scalars['String']
  projectIds?: InputMaybe<Array<Scalars['String']>>
  reviewDate?: InputMaybe<Scalars['DateTime']>
  status: MsdsStatus
  subcontractorId: Scalars['String']
}

export interface CreateMyTimesheetsInput {
  projectId: Scalars['String']
  subcontractorId: Scalars['String']
  templateResponse?: InputMaybe<CreateTemplateResponseInput>
  timesheetEntries: Array<TimesheetEntryInput>
}

export interface CreateOrUpdateHubspotContactInput {
  adminUserId: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  phoneNumber?: InputMaybe<Scalars['String']>
  role?: InputMaybe<Scalars['String']>
}

export interface CreatePermitInputAdmin {
  applicationTemplateResponseData?: InputMaybe<Scalars['JSON']>
  description?: InputMaybe<Scalars['String']>
  endDate: Scalars['DateTime']
  permitTypeId: Scalars['String']
  projectId: Scalars['String']
  projectLocationId?: InputMaybe<Scalars['String']>
  startDate: Scalars['DateTime']
  status?: InputMaybe<PermitStatus>
  workerIds: Array<Scalars['String']>
}

export interface CreatePermitInputWorker {
  applicationTemplateResponseData?: InputMaybe<Scalars['JSON']>
  description?: InputMaybe<Scalars['String']>
  endDate: Scalars['DateTime']
  name?: InputMaybe<Scalars['String']>
  permitTypeId: Scalars['String']
  projectId: Scalars['String']
  startDate: Scalars['DateTime']
  workerIds?: InputMaybe<Array<Scalars['String']>>
}

export interface CreatePermitTypeInputAdmin {
  identifierPrefix: Scalars['String']
  maxDays?: InputMaybe<Scalars['Int']>
  name: Scalars['String']
}

export interface CreatePlatformActionInput {
  assignees?: InputMaybe<Array<AssigneeInput>>
  attachmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  config?: InputMaybe<PlatformActionConfigInput>
  description?: InputMaybe<Scalars['String']>
  dueDate?: InputMaybe<Scalars['DateTime']>
  id?: InputMaybe<Scalars['String']>
  locationId?: InputMaybe<Scalars['String']>
  priority?: InputMaybe<PlatformActionPriority>
  priorityType?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  status: PlatformActionStatus
  templateResponseBlockIdentifier?: InputMaybe<Scalars['String']>
  templateResponseId?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export interface CreatePreStartInput {
  date: Scalars['DateTime']
  endDate?: InputMaybe<Scalars['DateTime']>
  projectId: Scalars['String']
  template: CreateTemplateResponseInput
}

export interface CreatePrequalificationForSubcontractor {
  responseData: Scalars['JSON']
  status: PrequalificationStatus
}

export interface CreateProjectInput {
  address?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['DateTime']>
  language?: InputMaybe<Scalars['String']>
  locale?: InputMaybe<SupportedLocaleCountryCode>
  name: Scalars['String']
  projectAdminsIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  projectContacts?: InputMaybe<Array<InputMaybe<ContactInput>>>
  requiredTicketsIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  signOnRedirectUrl?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['DateTime']>
  status: ProjectStatus
  timezone?: InputMaybe<Scalars['String']>
}

export interface CreateProjectLocationInput {
  name: Scalars['String']
  parentId?: InputMaybe<Scalars['String']>
  projectId: Scalars['String']
}

export interface CreateProjectScheduleInputAdmin {
  title: Scalars['String']
}

export interface CreatePublicConversationMessageAsSubcontractorInput {
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  content?: InputMaybe<Scalars['String']>
  conversationId: Scalars['String']
  defectId?: InputMaybe<Scalars['String']>
  platformActionId?: InputMaybe<Scalars['String']>
  subcontractorId: Scalars['String']
}

export interface CreatePublicPlatformActionViaChecklistResourceLinkInput {
  attachmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  description?: InputMaybe<Scalars['String']>
  dueDate?: InputMaybe<Scalars['DateTime']>
  priority?: InputMaybe<PlatformActionPriority>
  priorityType?: InputMaybe<Scalars['String']>
  resourceLinkId: Scalars['String']
  status: PlatformActionStatus
  templateResponseBlockIdentifier?: InputMaybe<Scalars['String']>
  templateResponseId: Scalars['String']
  title?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export interface CreatePublicTemplateResponseInput {
  completedAt?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  relatedRegisterItemId?: InputMaybe<Scalars['String']>
  resourceLinkId?: InputMaybe<Scalars['String']>
  responseData?: InputMaybe<Scalars['JSON']>
  templateId?: InputMaybe<Scalars['String']>
}

export interface CreateRegisterInput {
  identifierPrefix: Scalars['String']
  name: Scalars['String']
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  settings?: InputMaybe<RegisterSettingsInput>
  templateData: Scalars['JSON']
  typeLibraryTemplateId?: InputMaybe<Scalars['String']>
}

export interface CreateRegisterItemBookingInput {
  endDate: Scalars['DateTime']
  registerItemId: Scalars['String']
  startDate: Scalars['DateTime']
  title?: InputMaybe<Scalars['String']>
}

export interface CreateRegisterItemInput {
  assignees?: InputMaybe<Array<AssigneeInput>>
  checklistTemplateIds?: InputMaybe<Array<Scalars['String']>>
  followUpAt?: InputMaybe<Scalars['DateTime']>
  name: Scalars['String']
  projectIds?: InputMaybe<Array<Scalars['String']>>
  registerId: Scalars['String']
  registerItemTypeId?: InputMaybe<Scalars['String']>
  reviewTemplateResponseData?: InputMaybe<Scalars['JSON']>
  status?: InputMaybe<RegisterItemStatus>
  templateResponseData: Scalars['JSON']
  typeLibraryTemplateData?: InputMaybe<Scalars['JSON']>
  uploadTemplateResponseData?: InputMaybe<Scalars['JSON']>
}

export interface CreateRegisterItemPublicInput {
  checklistTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  companyRegisterItemId?: InputMaybe<Scalars['String']>
  followUpAt?: InputMaybe<Scalars['DateTime']>
  name: Scalars['String']
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  registerId: Scalars['String']
  registerItemTypeId?: InputMaybe<Scalars['String']>
  templateResponseData?: InputMaybe<Scalars['JSON']>
  typeTemplateResponseData?: InputMaybe<Scalars['JSON']>
  uploadTemplateResponseData?: InputMaybe<Scalars['JSON']>
}

export interface CreateRegisterItemTypeInput {
  linkedChecklistIds?: InputMaybe<Array<Scalars['String']>>
  name: Scalars['String']
}

export interface CreateResourceLinkInput {
  companyInductionId?: InputMaybe<Scalars['String']>
  contactId?: InputMaybe<Scalars['String']>
  documentFolderId?: InputMaybe<Scalars['String']>
  prequalificationId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  registerItemId?: InputMaybe<Scalars['String']>
  relatedResources?: InputMaybe<ResourceLinkRelatedResourceInput>
  resourceType: Scalars['String']
  siteInductionId?: InputMaybe<Scalars['String']>
  templateId?: InputMaybe<Scalars['String']>
}

export interface CreateResourceTagsInput {
  tags: Array<InputMaybe<Scalars['String']>>
}

export interface CreateRoleInput {
  description?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  permissions?: InputMaybe<Array<InputMaybe<PermissionInput>>>
}

export interface CreateScheduleInput {
  assignedAdminUserIds: Array<Scalars['String']>
  interval?: InputMaybe<Scalars['String']>
  libraryTemplateId?: InputMaybe<Scalars['String']>
  projectId: Scalars['String']
  startDate: Scalars['DateTime']
  templateId?: InputMaybe<Scalars['String']>
  title: Scalars['String']
}

export interface CreateSignOnInput {
  contextMetadata?: InputMaybe<ContextMetadataInput>
  idempotencyKey?: InputMaybe<Scalars['String']>
  metadata?: InputMaybe<Scalars['JSON']>
  preStartIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  projectId: Scalars['String']
  signOnDate?: InputMaybe<Scalars['DateTime']>
  workerId?: InputMaybe<Scalars['String']>
}

export interface CreateSiteDiaryInput {
  archivedAt?: InputMaybe<Scalars['DateTime']>
  date: Scalars['DateTime']
  projectId: Scalars['String']
  templateResponse: CreateTemplateResponseInput
}

export interface CreateSubcontractorInput {
  address?: InputMaybe<Scalars['String']>
  builderId?: InputMaybe<Scalars['String']>
  company: CompanyNameInput
  procoreId?: InputMaybe<Scalars['String']>
  procoreProjectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface CreateSwmsDocInput {
  checklist?: InputMaybe<Scalars['JSON']>
  expireInDays?: InputMaybe<Scalars['Int']>
  key?: InputMaybe<Scalars['String']>
  librarySwmsDocId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  projectId: Scalars['String']
  required?: InputMaybe<Scalars['Boolean']>
  requiredAll?: InputMaybe<Scalars['Boolean']>
  review?: InputMaybe<Scalars['String']>
  showAll?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<SwmsStatus>
  subcontractorId: Scalars['String']
  workerIds?: InputMaybe<Array<Scalars['String']>>
}

export interface CreateSwmsTemplateInput {
  subcontractorId: Scalars['String']
  templateData: Scalars['JSON']
  templateName: Scalars['String']
}

export interface CreateSwmsTemplateResponseInput {
  libraryTemplateId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  responseData: Scalars['JSON']
  subcontractorId: Scalars['String']
  templateId?: InputMaybe<Scalars['String']>
}

export interface CreateTemplateInput {
  builderId?: InputMaybe<Scalars['String']>
  identifierPrefix?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  templateCategoryName?: InputMaybe<Scalars['String']>
  templateData?: InputMaybe<Scalars['JSON']>
  templateName: Scalars['String']
  templateType: TemplateType
}

export interface CreateTemplateResponseAsWorkerInput {
  completedAt?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  relatedRegisterItemId?: InputMaybe<Scalars['String']>
  responseData?: InputMaybe<Scalars['JSON']>
  templateId?: InputMaybe<Scalars['String']>
  templateResponseId?: InputMaybe<Scalars['String']>
}

export interface CreateTemplateResponseInput {
  completedAt?: InputMaybe<Scalars['DateTime']>
  libraryTemplateId?: InputMaybe<Scalars['String']>
  locationId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  relatedRegisterItemId?: InputMaybe<Scalars['String']>
  responseData?: InputMaybe<Scalars['JSON']>
  scheduledJobId?: InputMaybe<Scalars['String']>
  templateId?: InputMaybe<Scalars['String']>
  workerId?: InputMaybe<Scalars['String']>
}

export interface CreateTicketInput {
  countryIssued?: InputMaybe<Scalars['String']>
  expiry?: InputMaybe<Scalars['DateTime']>
  files?: InputMaybe<Array<InputMaybe<TicketFileInput>>>
  number?: InputMaybe<Scalars['String']>
  obtained?: InputMaybe<Scalars['DateTime']>
  stateIssued?: InputMaybe<State>
  ticketTemplateId: Scalars['String']
  workerId?: InputMaybe<Scalars['String']>
}

export interface CreateTicketInputV2 {
  countryIssued?: InputMaybe<Scalars['String']>
  expiry?: InputMaybe<Scalars['DateTime']>
  files?: InputMaybe<Array<InputMaybe<TicketFileInput>>>
  number?: InputMaybe<Scalars['String']>
  obtained?: InputMaybe<Scalars['DateTime']>
  stateIssued?: InputMaybe<Scalars['String']>
  ticketTemplateId: Scalars['String']
  workerId?: InputMaybe<Scalars['String']>
}

export interface CreateTicketReviewInput {
  reviewComments?: InputMaybe<Scalars['String']>
  reviewStatus: TicketReviewStatus
  ticketId: Scalars['String']
}

export interface CreateTicketTemplateInput {
  code?: InputMaybe<Scalars['String']>
  expiry: Scalars['Boolean']
  medical: Scalars['Boolean']
  name: Scalars['String']
  number: Scalars['Boolean']
  obtained: Scalars['Boolean']
  shortName: Scalars['String']
  ticketCategoryId: Scalars['String']
  ticketFileConfigs?: InputMaybe<Array<TicketFileConfigInput>>
  ticketTypeId: Scalars['String']
}

export interface CreateTimesheetsInput {
  projectId: Scalars['String']
  subcontractorId: Scalars['String']
  templateResponse?: InputMaybe<CreateTemplateResponseInput>
  timesheetEntries: Array<TimesheetEntryInput>
  workerId: Scalars['String']
}

export interface CreateToolboxInput {
  agenda?: InputMaybe<Scalars['String']>
  date: Scalars['DateTime']
  invitedUsers?: InputMaybe<InvitedUsersToolboxInput>
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  notes?: InputMaybe<Scalars['String']>
  projectId: Scalars['String']
  status: ToolboxStatus
  templateResponse?: InputMaybe<CreateTemplateResponseInput>
  type: ToolboxType
}

export interface CreateToolboxInviteInput {
  adminUserId?: InputMaybe<Scalars['String']>
  attended?: InputMaybe<Scalars['Boolean']>
  toolboxId: Scalars['String']
  workerId?: InputMaybe<Scalars['String']>
}

export interface CreateToolboxInvitesInput {
  adminUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  attended?: InputMaybe<Scalars['Boolean']>
  toolboxId: Scalars['String']
  workerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface CreateToolboxPreStartInput {
  numberOfDays: Scalars['Int']
}

export interface CreateUserInput {
  email?: InputMaybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  userIdentity?: InputMaybe<Scalars['String']>
}

export interface CreateVisitorInput {
  mobile: Scalars['String']
  userId: Scalars['String']
}

export interface CreateVisitorSignOnInput {
  idempotencyKey?: InputMaybe<Scalars['String']>
  metadata?: InputMaybe<Scalars['JSON']>
  projectId: Scalars['String']
}

export interface CreateVisitorUserUserInput {
  identity: Scalars['String']
  mobile: Scalars['String']
}

export interface CreateVisitorWorkerInput {
  email?: InputMaybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  mobile?: InputMaybe<Scalars['String']>
}

export interface CreateWorkerInput {
  address?: InputMaybe<Scalars['String']>
  allergies?: InputMaybe<Scalars['String']>
  dob?: InputMaybe<Scalars['String']>
  emergencyContact?: InputMaybe<Scalars['String']>
  emergencyContactNumber?: InputMaybe<Scalars['String']>
  emergencyContactRelationship?: InputMaybe<Scalars['String']>
  employmentStatus?: InputMaybe<Scalars['String']>
  medicalInformation?: InputMaybe<Scalars['String']>
  mobile?: InputMaybe<Scalars['String']>
  subcontractorId?: InputMaybe<Scalars['String']>
  trade?: InputMaybe<Scalars['String']>
  userId: Scalars['String']
}

export interface CreateWorkerSignOnFromFormInput {
  formName?: InputMaybe<Scalars['String']>
  idempotencyKey: Scalars['String']
  projectId: Scalars['String']
  workerId: Scalars['String']
}

export interface CreateWorkerSignOnFromFormWorkerInput {
  formName?: InputMaybe<Scalars['String']>
  idempotencyKey: Scalars['String']
  projectId: Scalars['String']
  workerId: Scalars['String']
}

export interface CreateWorkerUserInput {
  address?: InputMaybe<Scalars['String']>
  allergies?: InputMaybe<Scalars['String']>
  builderGenerated?: InputMaybe<Scalars['Boolean']>
  dob?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  emergencyContact?: InputMaybe<Scalars['String']>
  emergencyContactNumber?: InputMaybe<Scalars['String']>
  emergencyContactRelationship?: InputMaybe<Scalars['String']>
  employmentStatus?: InputMaybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  medicalInformation?: InputMaybe<Scalars['String']>
  mobile?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  subcontractorId?: InputMaybe<Scalars['String']>
  trade?: InputMaybe<Scalars['String']>
  userIdentity?: InputMaybe<Scalars['String']>
}

export interface CreateWorkerUserUserInput {
  identity: Scalars['String']
  mobile: Scalars['String']
}

export interface CreateZipAttachmentsUrlInput {
  attachmentIds: Array<Scalars['String']>
  zipFileName?: InputMaybe<Scalars['String']>
}

export enum CreatedFromContext {
  AdminUi = 'ADMIN_UI',
  App = 'APP',
  Form = 'FORM',
  Integration = 'INTEGRATION',
  WebInductions = 'WEB_INDUCTIONS',
}

export interface Dashboard {
  __typename?: 'Dashboard'
  access: DashboardAccess
  canMutate: Scalars['Boolean']
  description?: Maybe<Scalars['String']>
  favourited: Scalars['Boolean']
  id: Scalars['String']
  owner: AdminUser
  projects?: Maybe<Array<Project>>
  title: Scalars['String']
  widgets: Array<DashboardWidget>
}

export interface DashboardAccess {
  __typename?: 'DashboardAccess'
  adminUsers?: Maybe<Array<DashboardAccessAdminUser>>
  companyRole?: Maybe<DashboardAccessRole>
}

export interface DashboardAccessAdminUser {
  __typename?: 'DashboardAccessAdminUser'
  adminUser: AdminUser
  role: DashboardAccessRole
}

export interface DashboardAccessAdminUserInput {
  adminUserId: Scalars['String']
  role: DashboardAccessRole
}

export interface DashboardAccessInput {
  adminUsers?: InputMaybe<Array<DashboardAccessAdminUserInput>>
  companyRole?: InputMaybe<DashboardAccessRole>
}

export enum DashboardAccessRole {
  ReadWrite = 'READ_WRITE',
  ViewOnly = 'VIEW_ONLY',
}

export interface DashboardData {
  __typename?: 'DashboardData'
  /** @deprecated is separate query now */
  changesRequestedInductions?: Maybe<Array<Maybe<Induction>>>
  /** @deprecated is separate query now */
  companyInductions?: Maybe<Array<Maybe<Induction>>>
  /** @deprecated is separate query now */
  inductions?: Maybe<Array<Maybe<Induction>>>
  insuranceDocs?: Maybe<Array<Maybe<InsuranceDoc>>>
  meta?: Maybe<DashboardMeta>
  signOnsByDate?: Maybe<Array<Maybe<GroupedSignOn>>>
  /** @deprecated is separate query now */
  siteInductions?: Maybe<Array<Maybe<Induction>>>
  /** @deprecated use projectStats query */
  subcontractorCount?: Maybe<Scalars['Int']>
  swms?: Maybe<Array<Maybe<SwmsDoc>>>
  ticketExpiries?: Maybe<Array<Maybe<Ticket>>>
  ticketReviews?: Maybe<Array<Maybe<Ticket>>>
  totalTicketsAwaitingReview?: Maybe<Scalars['Int']>
  /** @deprecated use projectStats query */
  workerCount?: Maybe<Scalars['Int']>
  workers?: Maybe<Array<Maybe<Worker>>>
  workersWithoutWhiteCard?: Maybe<Array<Maybe<Worker>>>
}

export interface DashboardInput {
  access?: InputMaybe<DashboardAccessInput>
  description?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  title?: InputMaybe<Scalars['String']>
  widgets?: InputMaybe<Array<DashboardWidgetInput>>
}

export interface DashboardListFilterInput {
  projectIds?: InputMaybe<Array<Scalars['String']>>
  searchString?: InputMaybe<Scalars['String']>
}

export interface DashboardMeta {
  __typename?: 'DashboardMeta'
  afterDateTime?: Maybe<Scalars['DateTime']>
  beforeDateTime?: Maybe<Scalars['DateTime']>
}

export interface DashboardSignOns {
  __typename?: 'DashboardSignOns'
  signOnsByDate: Array<Maybe<SignOnsByDate>>
  signOnsBySubcontractorOnDate: Array<Maybe<SignOnsBySubcontractorOnDate>>
  todaysSignOns: Array<SignOn>
  todaysSignOnsAggregation: PaginationAggregation
}

export interface DashboardWidget {
  __typename?: 'DashboardWidget'
  id: Scalars['String']
  layout: Scalars['JSON']
  settings?: Maybe<DashboardWidgetSettings>
  title: Scalars['String']
  widgetType: WidgetType
}

export interface DashboardWidgetInput {
  gameSettings?: InputMaybe<WidgetGamesSettingsInput>
  id: Scalars['String']
  layout?: InputMaybe<Scalars['JSON']>
  metabaseSettings?: InputMaybe<WidgetMetabaseSettingsInput>
  settings?: InputMaybe<WidgetReportingSettingsInput>
  title: Scalars['String']
  widgetType: WidgetType
}

export type DashboardWidgetSettings =
  | WidgetGamesSettings
  | WidgetMetabaseSettings
  | WidgetReportingSettings

export interface DateFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
}

export enum DateTimeBlockType {
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Time = 'TIME',
  Week = 'WEEK',
  Year = 'YEAR',
}

export interface DateTimeCaptureBlock extends CaptureExtra, TemplateBlockBase {
  __typename?: 'DateTimeCaptureBlock'
  attachments?: Maybe<Array<Maybe<Attachment>>>
  captureRange?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  pickerType?: Maybe<DateTimeBlockType>
  type: TemplateBlockTypes
  value?: Maybe<Array<Maybe<Scalars['DateTime']>>>
}

export interface DateTimeDisplayBlock extends TemplateBlockBase {
  __typename?: 'DateTimeDisplayBlock'
  content?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  showTime?: Maybe<Scalars['Boolean']>
  type: TemplateBlockTypes
}

export interface DeactivatedResourceLinkEntity {
  __typename?: 'DeactivatedResourceLinkEntity'
  active: Scalars['Boolean']
  id: Scalars['String']
  slug: Scalars['String']
}

export interface Defect {
  __typename?: 'Defect'
  archivedAt?: Maybe<Scalars['DateTime']>
  assignees: Array<Maybe<Assignee>>
  assigner: AdminUser
  assignerId: Scalars['String']
  attachments?: Maybe<Array<Maybe<Attachment>>>
  builder: Builder
  builderId: Scalars['String']
  completedAt?: Maybe<Scalars['DateTime']>
  conversation?: Maybe<ConversationThread>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  distributedAt?: Maybe<Scalars['DateTime']>
  dueDate?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  location?: Maybe<ProjectLocation>
  locationId?: Maybe<Scalars['String']>
  nextDefectId?: Maybe<Scalars['String']>
  order?: Maybe<Scalars['Int']>
  overdue?: Maybe<Scalars['Boolean']>
  previousDefectId?: Maybe<Scalars['String']>
  priority?: Maybe<DefectPriority>
  project: Project
  projectId: Scalars['String']
  status: DefectStatus
  tags?: Maybe<Array<Scalars['String']>>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface DefectFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  assignees?: InputMaybe<Array<InputMaybe<AssigneeInput>>>
  assignerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  includeSublocations?: InputMaybe<Scalars['Boolean']>
  locationId?: InputMaybe<Scalars['String']>
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  overdue?: InputMaybe<Scalars['Boolean']>
  pending?: InputMaybe<Scalars['Boolean']>
  priority?: InputMaybe<Array<InputMaybe<DefectPriority>>>
  projectId: Scalars['String']
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InputMaybe<DefectStatus>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export enum DefectPriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export interface DefectReport {
  __typename?: 'DefectReport'
  overdue: Array<Defect>
  statistics: DefectsUsage
  waitingReview: Array<Defect>
}

export interface DefectReportFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  regions?: InputMaybe<Array<Scalars['String']>>
}

export interface DefectSettings {
  __typename?: 'DefectSettings'
  /** Whether defects can be assigned to workers, defaults to false */
  allowWorkerAssignees: Scalars['Boolean']
  /** Enable this option to skip the defect pending state and send notifications to assignees immediately on defect creation, defaults to false */
  notifyAssigneesOnDefectCreated: Scalars['Boolean']
}

export interface DefectSortInput {
  createdAt?: InputMaybe<SortOrder>
  dueDate?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export enum DefectStatus {
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  InProgress = 'IN_PROGRESS',
  Resolved = 'RESOLVED',
  ToDo = 'TO_DO',
  WaitingReview = 'WAITING_REVIEW',
}

export interface DefectResourceLink {
  __typename?: 'Defect_ResourceLink'
  archivedAt?: Maybe<Scalars['DateTime']>
  assignees: Array<Maybe<AssigneeResourceLink>>
  assigner: AdminUserResourceLink
  attachments?: Maybe<Array<Maybe<AttachmentResourceLink>>>
  completedAt?: Maybe<Scalars['DateTime']>
  conversation?: Maybe<ConversationThreadResourceLink>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  location?: Maybe<ProjectLocationResourceLink>
  locationId?: Maybe<Scalars['String']>
  order?: Maybe<Scalars['Int']>
  overdue?: Maybe<Scalars['Boolean']>
  priority?: Maybe<DefectPriority>
  project: ProjectResourceLink
  status: DefectStatus
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface DefectsUsage {
  __typename?: 'DefectsUsage'
  builderDefects: Scalars['Int']
  clientDefects: Scalars['Int']
  inProgress: Scalars['Int']
  incompleteWorks: Scalars['Int']
  overdue: Scalars['Int']
  resolved: Scalars['Int']
  total: Scalars['Int']
  waitingReview: Scalars['Int']
}

export interface DeleteIntegrationConnectionsInBulkInput {
  ids: Array<Scalars['String']>
}

export interface DeleteStaffSubcontractorInput {
  workerId: Scalars['String']
}

export interface DeleteWorkerSubcontractorInput {
  subcontractorId: Scalars['String']
}

export interface DividerDisplayBlock extends TemplateBlockBase {
  __typename?: 'DividerDisplayBlock'
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
}

export interface Document {
  __typename?: 'Document'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  builderId: Scalars['String']
  category?: Maybe<DocumentCategory>
  createdAt: Scalars['DateTime']
  currentVersion?: Maybe<VersionHistory>
  id: Scalars['String']
  name: Scalars['String']
  project?: Maybe<Project>
  projectId?: Maybe<Scalars['String']>
  public?: Maybe<Scalars['Boolean']>
  status: DocumentStatus
  subcontractor?: Maybe<Subcontractor>
  subcontractorId?: Maybe<Scalars['String']>
  summary?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
  versionHistory?: Maybe<Array<VersionHistory>>
}

export enum DocumentCategory {
  Builder = 'BUILDER',
  Drawing = 'DRAWING',
  Project = 'PROJECT',
  Subcontractor = 'SUBCONTRACTOR',
}

export interface DocumentEntity {
  __typename?: 'DocumentEntity'
  category?: Maybe<DocumentCategory>
  id: Scalars['String']
  name: Scalars['String']
  type?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
}

export interface DocumentFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  category?: InputMaybe<DocumentCategory>
  folderId?: InputMaybe<Scalars['String']>
  includeFolders?: InputMaybe<Scalars['Boolean']>
  projectId?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<DocumentStatus>>
  type?: InputMaybe<Array<Scalars['String']>>
}

export interface DocumentFolder {
  __typename?: 'DocumentFolder'
  category: DocumentCategory
  createdAt: Scalars['DateTime']
  fileCount?: Maybe<Scalars['Int']>
  folderCount?: Maybe<Scalars['Int']>
  id: Scalars['String']
  name: Scalars['String']
  parentId?: Maybe<Scalars['String']>
  resourceLink?: Maybe<ResourceLink>
  updatedAt: Scalars['DateTime']
  visibleToWorkers?: Maybe<Scalars['Boolean']>
}

export interface DocumentFolderFilterInput {
  category?: InputMaybe<DocumentCategory>
  folderId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
}

export interface DocumentFolderFilterInputPublic {
  category?: InputMaybe<DocumentCategory>
  folderId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
}

export interface DocumentFolderFilterInputWorker {
  category?: InputMaybe<DocumentCategory>
  folderId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
}

export interface DocumentFolderSortInput {
  createdAt?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

export interface DocumentFolderPublic {
  __typename?: 'DocumentFolder_Public'
  category: DocumentCategory
  createdAt: Scalars['DateTime']
  drawings?: Maybe<Array<DrawingPublic>>
  id: Scalars['String']
  name: Scalars['String']
  parentId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface DocumentFolderResourceLink {
  __typename?: 'DocumentFolder_ResourceLink'
  childrenFolders?: Maybe<Array<DocumentFolderResourceLink>>
  drawings?: Maybe<Array<DrawingResourceLink>>
  id: Scalars['String']
  name: Scalars['String']
}

export interface DocumentFolderWorker {
  __typename?: 'DocumentFolder_Worker'
  category: DocumentCategory
  createdAt: Scalars['DateTime']
  drawings?: Maybe<Array<DrawingWorker>>
  fileCount?: Maybe<Scalars['Int']>
  id: Scalars['String']
  name: Scalars['String']
  parentId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface DocumentSignature {
  __typename?: 'DocumentSignature'
  adminUser?: Maybe<AdminUserEntity>
  builderGenerated: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  expired: Scalars['Boolean']
  id: Scalars['String']
  induction?: Maybe<Induction>
  signatureKey: Scalars['String']
  signatureUrl: Scalars['String']
  swmsDoc: SwmsDoc
  worker: Worker
}

export interface DocumentSignatureEntity {
  __typename?: 'DocumentSignatureEntity'
  adminUser?: Maybe<AdminUserResourceLink>
  builderGenerated: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  induction?: Maybe<InductionEntity>
  signatureUrl: Scalars['String']
  worker: WorkerResourceLink
}

export interface DocumentSignatureResourceLink {
  __typename?: 'DocumentSignature_ResourceLink'
  adminUser?: Maybe<AdminUserResourceLink>
  builderGenerated: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  induction?: Maybe<InductionResourceLink>
  signatureUrl: Scalars['String']
  swmsDoc?: Maybe<SwmsDocEntity>
  worker?: Maybe<WorkerResourceLink>
}

export interface DocumentSortInput {
  createdAt?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  type?: InputMaybe<SortOrder>
}

export enum DocumentStatus {
  ChangesRequested = 'CHANGES_REQUESTED',
  Reviewed = 'REVIEWED',
  WaitingReview = 'WAITING_REVIEW',
}

export enum DocumentType {
  Builder = 'BUILDER',
  Document = 'DOCUMENT',
  Drawing = 'DRAWING',
  Insurance = 'INSURANCE',
  LibrarySwms = 'LIBRARY_SWMS',
  Msds = 'MSDS',
  Pdf = 'PDF',
  Signature = 'SIGNATURE',
  Swms = 'SWMS',
  Ticket = 'TICKET',
  Toolbox = 'TOOLBOX',
  WorkerPhoto = 'WORKER_PHOTO',
  Zip = 'ZIP',
}

export interface DocumentUpload {
  __typename?: 'DocumentUpload'
  container?: Maybe<Scalars['String']>
  fileName?: Maybe<Scalars['String']>
  fileSizeInBytes?: Maybe<Scalars['Int']>
  fileSizeInKb?: Maybe<Scalars['Int']>
  fileUrl?: Maybe<Scalars['String']>
}

export interface Drawing {
  createdAt: Scalars['DateTime']
  drawingNumber?: Maybe<Scalars['String']>
  drawingRevision?: Maybe<Scalars['String']>
  id: Scalars['String']
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
}

export interface DrawingActivityDay {
  __typename?: 'DrawingActivityDay'
  date: Scalars['DateTime']
  folders: Array<DrawingActivityFolder>
}

export interface DrawingActivityFolder {
  __typename?: 'DrawingActivityFolder'
  drawings: Array<DrawingActivityItem>
  id: Scalars['String']
  name: Scalars['String']
  resourceLink?: Maybe<ResourceLink>
}

export interface DrawingActivityItem {
  __typename?: 'DrawingActivityItem'
  builderId: Scalars['String']
  createdAt: Scalars['DateTime']
  documentFolder?: Maybe<DocumentFolder>
  documentFolderId?: Maybe<Scalars['String']>
  drawingNumber?: Maybe<Scalars['String']>
  drawingRevision?: Maybe<Scalars['String']>
  fileName: Scalars['String']
  id: Scalars['String']
  key: Scalars['String']
  projectId: Scalars['String']
  status: DrawingStatus
  title?: Maybe<Scalars['String']>
  type: DrawingWaitingReviewStatus
  updatedAt: Scalars['DateTime']
}

export interface DrawingFilterInput {
  archivedFilter?: InputMaybe<ArchivedFilter>
  folderId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InputMaybe<DrawingStatus>>>
}

export interface DrawingFilterInputPublic {
  folderId?: InputMaybe<Scalars['String']>
}

export interface DrawingFilterInputWorker {
  folderId?: InputMaybe<Scalars['String']>
  searchString?: InputMaybe<Scalars['String']>
}

export interface DrawingSortInput {
  drawingNumber?: InputMaybe<SortOrder>
  publishedAt?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export interface DrawingSortInputPublic {
  createdAt?: InputMaybe<SortOrder>
  drawingNumber?: InputMaybe<SortOrder>
}

export interface DrawingSortInputWorker {
  drawingNumber?: InputMaybe<SortOrder>
  publishedAt?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export enum DrawingStatus {
  Approved = 'APPROVED',
  Outdated = 'OUTDATED',
  Processing = 'PROCESSING',
  WaitingReview = 'WAITING_REVIEW',
}

export enum DrawingWaitingReviewStatus {
  Duplicate = 'DUPLICATE',
  NewDrawing = 'NEW_DRAWING',
  VersionUpdate = 'VERSION_UPDATE',
}

export interface DrawingAdmin extends Drawing {
  __typename?: 'Drawing_Admin'
  builder: Builder
  builderId: Scalars['String']
  createdAt: Scalars['DateTime']
  currentVersion: VersionHistory
  documentFolder?: Maybe<DocumentFolder>
  documentFolderId?: Maybe<Scalars['String']>
  drawingNumber?: Maybe<Scalars['String']>
  drawingRevision?: Maybe<Scalars['String']>
  fileName: Scalars['String']
  id: Scalars['String']
  key: Scalars['String']
  previousRevision?: Maybe<DrawingAdmin>
  project: Project
  projectId: Scalars['String']
  status: DrawingStatus
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
  versionHistory?: Maybe<Array<VersionHistory>>
  waitingReviewStatus?: Maybe<DrawingWaitingReviewStatus>
}

export interface DrawingPublic extends Drawing {
  __typename?: 'Drawing_Public'
  createdAt: Scalars['DateTime']
  drawingNumber?: Maybe<Scalars['String']>
  drawingRevision?: Maybe<Scalars['String']>
  id: Scalars['String']
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
}

export interface DrawingResourceLink {
  __typename?: 'Drawing_ResourceLink'
  drawingNumber?: Maybe<Scalars['String']>
  drawingRevision?: Maybe<Scalars['String']>
  id: Scalars['String']
  url: Scalars['String']
}

export interface DrawingWorker extends Drawing {
  __typename?: 'Drawing_Worker'
  builder: Builder
  builderId: Scalars['String']
  createdAt: Scalars['DateTime']
  drawingNumber?: Maybe<Scalars['String']>
  drawingRevision?: Maybe<Scalars['String']>
  fileName: Scalars['String']
  id: Scalars['String']
  project: Project
  projectId: Scalars['String']
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
}

export interface EmailLog {
  __typename?: 'EmailLog'
  adminUser?: Maybe<AdminUserEntity>
  adminUserId?: Maybe<Scalars['String']>
  builder?: Maybe<Builder>
  builderId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  project?: Maybe<Project>
  projectId?: Maybe<Scalars['String']>
  serviceResponse?: Maybe<Scalars['JSON']>
  status: EmailStatus
  subcontractor?: Maybe<Subcontractor>
  subcontractorId?: Maybe<Scalars['String']>
  to: Scalars['String']
  type: EmailType
}

export interface EmailLogFilterInput {
  recipientType?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export interface EmailPdfCallbackInfo {
  builder: Scalars['String']
  customMessage?: InputMaybe<Scalars['String']>
  emails: Array<Scalars['String']>
  fileName: Scalars['String']
  userId: Scalars['String']
}

export enum EmailRecipientType {
  Builder = 'BUILDER',
  Subcontractor = 'SUBCONTRACTOR',
  Worker = 'WORKER',
}

export interface EmailSent {
  __typename?: 'EmailSent'
  serviceResponse?: Maybe<Scalars['JSON']>
}

export enum EmailStatus {
  Bounced = 'BOUNCED',
  Delivered = 'DELIVERED',
  Opened = 'OPENED',
  Sent = 'SENT',
}

export enum EmailType {
  FileRequest = 'FILE_REQUEST',
  FileUpdateRequest = 'FILE_UPDATE_REQUEST',
  InductionInvite = 'INDUCTION_INVITE',
  ProjectUpdate = 'PROJECT_UPDATE',
  ScheduleReminder = 'SCHEDULE_REMINDER',
  StaffInvite = 'STAFF_INVITE',
  SubcontractorExpiredInsurances = 'SUBCONTRACTOR_EXPIRED_INSURANCES',
  SubcontractorWelcome = 'SUBCONTRACTOR_WELCOME',
}

export interface Emergency {
  __typename?: 'Emergency'
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<AdminUser>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  messages?: Maybe<Array<EmergencyMessage>>
  project?: Maybe<Project>
  projectId?: Maybe<Scalars['String']>
  resolvedAt?: Maybe<Scalars['DateTime']>
  status: EmergencyStatus
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export interface EmergencyFilterInput {
  projectId?: InputMaybe<Scalars['String']>
}

export interface EmergencyMessage {
  __typename?: 'EmergencyMessage'
  acknowledgedBy?: Maybe<EmergencyMessageAcknowledgedBy>
  adminId?: Maybe<Scalars['String']>
  adminUser?: Maybe<AdminUser>
  createdAt: Scalars['DateTime']
  emergency?: Maybe<Emergency>
  emergencyId?: Maybe<Scalars['String']>
  id: Scalars['String']
  slug: Scalars['String']
  status: EmergencyMessageStatus
  to: Scalars['String']
  updatedAt: Scalars['DateTime']
  visitor?: Maybe<Visitor>
  visitorId?: Maybe<Scalars['String']>
  worker?: Maybe<Worker>
  workerId?: Maybe<Scalars['String']>
}

export enum EmergencyMessageAcknowledgedBy {
  Admin = 'ADMIN',
  Visitor = 'VISITOR',
  Worker = 'WORKER',
}

export enum EmergencyMessageStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Opened = 'OPENED',
  Pending = 'PENDING',
  Sent = 'SENT',
}

export enum EmergencyMessageStatusForWorker {
  Acknowledged = 'ACKNOWLEDGED',
  Opened = 'OPENED',
}

export enum EmergencyStatus {
  Ongoing = 'ONGOING',
  Resolved = 'RESOLVED',
}

export interface EngagmentAggregation {
  __typename?: 'EngagmentAggregation'
  actions?: Maybe<Scalars['String']>
  date?: Maybe<Scalars['DateTime']>
  resourceId?: Maybe<Scalars['String']>
  resourceName?: Maybe<Scalars['String']>
}

export interface EngagmentMetadata {
  __typename?: 'EngagmentMetadata'
  adminUsers?: Maybe<Array<Maybe<AdminUser>>>
  builders?: Maybe<Array<Maybe<Builder>>>
  projects?: Maybe<Array<Maybe<Project>>>
}

export interface ExpiredResourceLinkEntity {
  __typename?: 'ExpiredResourceLinkEntity'
  expiresAt: Scalars['DateTime']
  id: Scalars['String']
}

export interface ExternalLinkConfig {
  __typename?: 'ExternalLinkConfig'
  cuid: Scalars['String']
  homeUrl?: Maybe<Scalars['String']>
  type: Scalars['String']
  url: Scalars['String']
}

export interface ExternalLinkConfigInput {
  cuid: Scalars['String']
  homeUrl?: InputMaybe<Scalars['String']>
  type: Scalars['String']
  url: Scalars['String']
}

export interface ExtractTextInput {
  key: Scalars['String']
  type: DocumentType
}

export interface ExtractedBlock {
  __typename?: 'ExtractedBlock'
  BlockType: AnalyzedBlockType
  Confidence?: Maybe<Scalars['Float']>
  EntityTypes?: Maybe<Array<BlockEntityType>>
  Id: Scalars['String']
  Relationships?: Maybe<Array<BlockRelationship>>
  Text?: Maybe<Scalars['String']>
}

export interface ExtractedText {
  __typename?: 'ExtractedText'
  blocks: Array<Maybe<ExtractedBlock>>
  data?: Maybe<ExtractionData>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export interface ExtractionData {
  __typename?: 'ExtractionData'
  dateOfBirth?: Maybe<Scalars['String']>
  expiryDate?: Maybe<Scalars['String']>
  fullName?: Maybe<Scalars['String']>
  issueDate?: Maybe<Scalars['String']>
  issueState?: Maybe<Scalars['String']>
  licenseNumber?: Maybe<Scalars['String']>
}

export interface File {
  __typename?: 'File'
  contentType: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  key: Scalars['String']
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  ticketFile?: Maybe<TicketFile>
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
}

export enum FileBlockType {
  Document = 'DOCUMENT',
  Image = 'IMAGE',
}

export interface FileCaptureAttachment {
  __typename?: 'FileCaptureAttachment'
  altText?: Maybe<Scalars['String']>
  caption?: Maybe<Scalars['String']>
  fileType?: Maybe<FileBlockType>
  key?: Maybe<Scalars['String']>
}

export interface FileCaptureBlock extends CaptureExtra, TemplateBlockBase {
  __typename?: 'FileCaptureBlock'
  attachments?: Maybe<Array<Maybe<Attachment>>>
  description?: Maybe<Scalars['String']>
  draggerEnabled?: Maybe<Scalars['Boolean']>
  fileAttachments?: Maybe<Array<Maybe<FileCaptureAttachment>>>
  id: Scalars['String']
  kind: TemplateBlockKind
  multiUpload?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
}

export interface FileEntity {
  __typename?: 'FileEntity'
  contentType: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  key: Scalars['String']
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
}

export interface FileInput {
  customType?: InputMaybe<Scalars['String']>
  expiry?: InputMaybe<Scalars['DateTime']>
  insuranceType?: InputMaybe<InsuranceType>
  insuranceTypeOther?: InputMaybe<Scalars['String']>
  key: Scalars['String']
  name: Scalars['String']
  oldVersion?: InputMaybe<Scalars['String']>
  type: FileType
}

export enum FileType {
  Document = 'DOCUMENT',
  Insurance = 'INSURANCE',
  LibrarySwms = 'LIBRARY_SWMS',
  Msds = 'MSDS',
  Swms = 'SWMS',
  Toolbox = 'TOOLBOX',
}

export interface FileUploadInvite {
  __typename?: 'FileUploadInvite'
  batchId?: Maybe<Scalars['String']>
  builder?: Maybe<FileUploadBuilder>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  isSwmsBuilderEnabled?: Maybe<Scalars['Boolean']>
  metadata?: Maybe<Scalars['JSON']>
  project?: Maybe<FileUploadProject>
  registers?: Maybe<Array<RegisterPublic>>
  sdsChecklistTemplateResponse?: Maybe<FileUploadInviteTemplateResponse>
  subcontractor: FileUploadSubcontractor
  subcontractorId: Scalars['String']
  swmsChecklistTemplateResponse?: Maybe<FileUploadInviteTemplateResponse>
}

export interface FileUploadInviteEmail {
  __typename?: 'FileUploadInviteEmail'
  builderId: Scalars['String']
  projectId?: Maybe<Scalars['String']>
  subcontractorId: Scalars['String']
}

export interface FileUploadInviteEmailSent {
  __typename?: 'FileUploadInviteEmailSent'
  serviceResponse?: Maybe<Scalars['JSON']>
}

export interface FileUploadInviteTemplateResponse {
  __typename?: 'FileUploadInviteTemplateResponse'
  id: Scalars['String']
  responseData: Scalars['JSON']
}

export interface FileUploadBuilder {
  __typename?: 'FileUpload_Builder'
  builderMetadata?: Maybe<Scalars['JSON']>
  defaultLocale?: Maybe<SupportedLocaleCountryCode>
  defaultTimezone?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  logoUrl?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
}

export interface FileUploadCompany {
  __typename?: 'FileUpload_Company'
  abn?: Maybe<Scalars['String']>
  attachments?: Maybe<Array<CompanyAttachment>>
}

export interface FileUploadInsurance {
  __typename?: 'FileUpload_Insurance'
  expiry: Scalars['DateTime']
  id: Scalars['String']
  name: Scalars['String']
  type?: Maybe<InsuranceType>
  typeOther?: Maybe<Scalars['String']>
}

export interface FileUploadLibrarySwms {
  __typename?: 'FileUpload_LibrarySwms'
  id: Scalars['String']
  name: Scalars['String']
  templateResponseId?: Maybe<Scalars['String']>
}

export interface FileUploadMsds {
  __typename?: 'FileUpload_Msds'
  id: Scalars['String']
  name: Scalars['String']
}

export interface FileUploadOtherDoc {
  __typename?: 'FileUpload_OtherDoc'
  id: Scalars['String']
  name: Scalars['String']
  type: Scalars['String']
}

export interface FileUploadProject {
  __typename?: 'FileUpload_Project'
  address?: Maybe<Scalars['String']>
  builder?: Maybe<FileUploadBuilder>
  /** @deprecated Use projectContacts instead */
  contacts?: Maybe<FileUploadProjectContacts>
  country?: Maybe<Scalars['String']>
  id: Scalars['String']
  latitude?: Maybe<Scalars['Float']>
  locale?: Maybe<SupportedLocaleCountryCode>
  longitude?: Maybe<Scalars['Float']>
  name: Scalars['String']
  projectContacts?: Maybe<Array<Maybe<ContactEntity>>>
  timezone?: Maybe<Scalars['String']>
}

export interface FileUploadProjectContacts {
  __typename?: 'FileUpload_ProjectContacts'
  siteManagerName?: Maybe<Scalars['String']>
  siteManagerNumber?: Maybe<Scalars['String']>
}

export interface FileUploadSubcontractor {
  __typename?: 'FileUpload_Subcontractor'
  company?: Maybe<FileUploadCompany>
  contacts?: Maybe<Array<Contact>>
  email: Scalars['String']
  id: Scalars['String']
  insuranceDocs?: Maybe<Array<Maybe<FileUploadInsurance>>>
  librarySwmsDocs?: Maybe<Array<Maybe<FileUploadLibrarySwms>>>
  msdsDocs?: Maybe<Array<Maybe<FileUploadMsds>>>
  name: Scalars['String']
  otherDocs?: Maybe<Array<Maybe<FileUploadOtherDoc>>>
  swmsDocs?: Maybe<Array<Maybe<FileUploadSwms>>>
}

export interface FileUploadSwms {
  __typename?: 'FileUpload_Swms'
  id: Scalars['String']
  name: Scalars['String']
  templateResponseId?: Maybe<Scalars['String']>
}

export interface FilesUploaded {
  __typename?: 'FilesUploaded'
  filesUploaded?: Maybe<Scalars['Int']>
}

export interface FilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  includeBuilderSubcontractor?: InputMaybe<Scalars['Boolean']>
  todaysDate?: InputMaybe<Scalars['DateTime']>
}

export interface Flags {
  actions?: InputMaybe<Scalars['Boolean']>
  allowSwmsBeforeSiteInduction?: InputMaybe<Scalars['Boolean']>
  companyInductionNew?: InputMaybe<Scalars['Boolean']>
  defects?: InputMaybe<Scalars['Boolean']>
  language?: InputMaybe<Scalars['String']>
  permits?: InputMaybe<Scalars['Boolean']>
  siteInductions?: InputMaybe<Scalars['Boolean']>
  supportsQrCodeRotation?: InputMaybe<Scalars['Boolean']>
  swmsSignOn?: InputMaybe<Scalars['Boolean']>
  ticketAdd?: InputMaybe<Scalars['Boolean']>
}

export interface GalleryFilterInput {
  imageSources?: InputMaybe<Array<InputMaybe<ImageSource>>>
  projectId: Scalars['String']
  searchString?: InputMaybe<Scalars['String']>
}

export interface GallerySettings {
  __typename?: 'GallerySettings'
  defaultCompression?: Maybe<ImageCompressionPreset>
}

export interface GallerySortInput {
  photoTakenDate?: InputMaybe<SortOrder>
  sortDate?: InputMaybe<SortOrder>
  uploadedDate?: InputMaybe<SortOrder>
}

export enum GameType {
  Riddle = 'RIDDLE',
  Wordle = 'WORDLE',
  WordWheel = 'WORD_WHEEL',
}

export interface GeolocationContext {
  __typename?: 'GeolocationContext'
  autoSignOff?: Maybe<Scalars['Boolean']>
  autoSignOn?: Maybe<Scalars['Boolean']>
  signOffGeolocationData?: Maybe<GeolocationData>
  signOnGeolocationData?: Maybe<GeolocationData>
}

export interface GeolocationContextInput {
  autoSignOff?: InputMaybe<Scalars['Boolean']>
  autoSignOn?: InputMaybe<Scalars['Boolean']>
  signOffGeolocationData?: InputMaybe<GeolocationDataInput>
  signOnGeolocationData?: InputMaybe<GeolocationDataInput>
}

export interface GeolocationData {
  __typename?: 'GeolocationData'
  accuracy?: Maybe<Scalars['Float']>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
}

export interface GeolocationDataInput {
  accuracy?: InputMaybe<Scalars['Float']>
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
}

export interface GetCompaniesInput {
  onlyShowNoAbn?: InputMaybe<Scalars['Boolean']>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<GetCompaniesSortInput>
}

export interface GetCompaniesSortInput {
  abn?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  numberOfSubcontractors?: InputMaybe<SortOrder>
}

export interface GetWelcomeLinkInput {
  metadata?: InputMaybe<Scalars['JSON']>
  projectId: Scalars['String']
  subcontractorId: Scalars['String']
}

export interface GlobalSettings {
  __typename?: 'GlobalSettings'
  /** The external links that can be associated with builders */
  externalLinks?: Maybe<Array<ExternalLinkConfig>>
}

export interface GroupedSignOn {
  __typename?: 'GroupedSignOn'
  date?: Maybe<Scalars['DateTime']>
  signOns?: Maybe<Array<Maybe<SignOn>>>
}

export enum HeadingBlockSizes {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
}

export interface HeadingDisplayBlock extends TemplateBlockBase {
  __typename?: 'HeadingDisplayBlock'
  content?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  size: HeadingBlockSizes
  type: TemplateBlockTypes
}

export interface HelpScoutVisitorToken {
  __typename?: 'HelpScoutVisitorToken'
  token?: Maybe<Scalars['String']>
}

export interface HistoricPlatformUsage {
  __typename?: 'HistoricPlatformUsage'
  adminUsersToDate: Scalars['Int']
  month: Scalars['String']
  newAudits: Scalars['Int']
}

/** Hours budget module settings for a project */
export interface HoursBudgetSettings {
  __typename?: 'HoursBudgetSettings'
  /** Returns the amount of project hours budgeted for a project (or null if none) */
  hoursBudget?: Maybe<Scalars['Int']>
}

export enum ImageCompressionPreset {
  High = 'high',
  Original = 'original',
  Standard = 'standard',
}

export interface ImageDisplayBlock extends TemplateBlockBase {
  __typename?: 'ImageDisplayBlock'
  altText?: Maybe<Scalars['String']>
  caption?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
  url: Scalars['String']
}

export enum ImageSource {
  Checklist = 'CHECKLIST',
  Gallery = 'GALLERY',
  PlatformAction = 'PLATFORM_ACTION',
  PreStart = 'PRE_START',
  SiteDiary = 'SITE_DIARY',
}

export interface Induction {
  archivedAt?: Maybe<Scalars['DateTime']>
  contextMetadata?: Maybe<ContextMetadata>
  createdAt: Scalars['DateTime']
  documentSignatures: Array<Maybe<DocumentSignature>>
  evidenceSighted?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  /** @deprecated Use templateResponse instead */
  inductionSections?: Maybe<Scalars['JSON']>
  /** @deprecated Use template instead */
  inductionTemplate?: Maybe<InductionTemplate>
  signatureUrl?: Maybe<Scalars['String']>
  status?: Maybe<InductionStatus>
  subcontractor?: Maybe<Subcontractor>
  subcontractorId?: Maybe<Scalars['String']>
  templateName?: Maybe<Scalars['String']>
  templateResponse?: Maybe<TemplateResponse>
  type: InductionType
  updatedAt: Scalars['DateTime']
  worker: Worker
  workerId: Scalars['String']
  /** @deprecated Use workerSnapshotFull instead */
  workerSnapshot?: Maybe<Scalars['JSON']>
  workerSnapshotFull?: Maybe<WorkerSnapshot>
}

export interface InductionEntity {
  __typename?: 'InductionEntity'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  templateName?: Maybe<Scalars['String']>
  type: InductionType
}

export interface InductionFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InductionStatus>>
  subcontractorIds?: InputMaybe<Array<Scalars['String']>>
  workerIds?: InputMaybe<Array<Scalars['String']>>
}

export interface InductionInvite {
  __typename?: 'InductionInvite'
  batchId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  inductionTemplate?: Maybe<InductionTemplateEntity>
  metadata?: Maybe<Scalars['JSON']>
  requiredTickets: Array<Maybe<TicketTemplateEntity>>
}

export interface InductionInviteAccept {
  __typename?: 'InductionInviteAccept'
  complete: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  inductionInvite: InductionInvite
  inductionInviteId: Scalars['String']
  user: User
  userId: Scalars['String']
}

export interface InductionInviteEmail {
  __typename?: 'InductionInviteEmail'
  projectId: Scalars['String']
  subcontractorId: Scalars['String']
}

export interface InductionInviteEmailSent {
  __typename?: 'InductionInviteEmailSent'
  serviceResponse?: Maybe<Scalars['JSON']>
}

export interface InductionReviewerResourceLink {
  __typename?: 'InductionReviewer_ResourceLink'
  reviewedAt: Scalars['DateTime']
  reviewedBy: AdminUserResourceLink
}

/** Induction module settings for the entire Builder */
export interface InductionSettings {
  __typename?: 'InductionSettings'
  /** Returns true if Induction QR Code scan requirement is disabled for all projects */
  inductionScanRequirementDisabledForAllProjects?: Maybe<Scalars['Boolean']>
  /** Returns true if inductions are disabled for all projects */
  inductionsDisabledForAllProjects?: Maybe<Scalars['Boolean']>
  /** Prevent induction without approved SMWS */
  preventInductionWithoutApprovedSwms?: Maybe<Scalars['Boolean']>
  /** Returns true if workers cant access documents until they have been approved */
  preventWorkersAccessingDocumentsUntilApproved?: Maybe<Scalars['Boolean']>
  /** Projects that have the induction disabled */
  projectIdsWithInductionDisabled?: Maybe<Array<Scalars['String']>>
  /** Projects that have the Induction QR Code scan requirement disabled */
  projectIdsWithInductionScanRequirementDisabled?: Maybe<
    Array<Scalars['String']>
  >
  /** If a visitor has signed on, they can access public documents for these projects */
  projectIdsWithVisitorAccessToPublicDocumentsAfterInduction?: Maybe<
    Array<Scalars['String']>
  >
  /** Returns true if project managers can edit induction templates */
  projectManagersCanEditInductionTemplates?: Maybe<Scalars['Boolean']>
}

export interface InductionSortInput {
  createdAt?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  subcontractorName?: InputMaybe<SortOrder>
  workerName?: InputMaybe<SortOrder>
}

export enum InductionStatus {
  ChangesRequested = 'CHANGES_REQUESTED',
  Reviewed = 'REVIEWED',
  WaitingReview = 'WAITING_REVIEW',
}

export interface InductionTemplate {
  __typename?: 'InductionTemplate'
  builder?: Maybe<Builder>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  inductionSections?: Maybe<Scalars['JSON']>
  inductions: Array<Maybe<Induction>>
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  type?: Maybe<InductionType>
  updatedAt: Scalars['DateTime']
}

export interface InductionTemplateEntity {
  __typename?: 'InductionTemplateEntity'
  builder?: Maybe<BuilderEntity>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  inductionSections?: Maybe<Scalars['JSON']>
  metadata?: Maybe<Scalars['JSON']>
  name: Scalars['String']
  type?: Maybe<InductionType>
  updatedAt: Scalars['DateTime']
}

export interface InductionTemplateId {
  __typename?: 'InductionTemplateId'
  inductionTemplateId: Scalars['String']
}

export type InductionToReview = BuilderInduction | ProjectInduction

export enum InductionType {
  BuilderInduction = 'BUILDER_INDUCTION',
  ProjectInduction = 'PROJECT_INDUCTION',
}

export interface InductionResourceLink {
  __typename?: 'Induction_ResourceLink'
  id: Scalars['String']
  templateName?: Maybe<Scalars['String']>
  type: InductionType
}

export interface InsuranceDoc {
  __typename?: 'InsuranceDoc'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  builderId: Scalars['String']
  createdAt: Scalars['DateTime']
  currentVersion: VersionHistory
  expiry?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  name: Scalars['String']
  status: InsuranceStatus
  subcontractor: Subcontractor
  subcontractorId: Scalars['String']
  type?: Maybe<InsuranceType>
  typeOther?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
  versionHistory?: Maybe<Array<VersionHistory>>
}

export interface InsuranceFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  expiryStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  insuranceReviewStatus?: InputMaybe<Array<InsuranceStatus>>
  projectId?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  searchString?: InputMaybe<Scalars['String']>
  subcontractorIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface InsuranceSortInput {
  createdAt?: InputMaybe<SortOrder>
  expiry?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

export enum InsuranceStatus {
  ChangesRequested = 'CHANGES_REQUESTED',
  Reviewed = 'REVIEWED',
  WaitingReview = 'WAITING_REVIEW',
}

export enum InsuranceType {
  Other = 'OTHER',
  PublicLiability = 'PUBLIC_LIABILITY',
  WorkCover = 'WORK_COVER',
}

export interface Integration {
  __typename?: 'Integration'
  builder?: Maybe<Builder>
  builderId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  integrationConnections: Array<Maybe<IntegrationConnection>>
  integrationData?: Maybe<Scalars['JSON']>
  integrationIdentifier: Scalars['String']
  integrationType: IntegrationType
  updatedAt: Scalars['DateTime']
}

export enum IntegrationActions {
  GetProjects = 'GET_PROJECTS',
}

export interface IntegrationConnection {
  __typename?: 'IntegrationConnection'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  integration: Integration
  integrationId: Scalars['String']
  integrationIdentifier: Scalars['String']
  project?: Maybe<Project>
  projectId?: Maybe<Scalars['String']>
  sourceId: Scalars['String']
  subcontractor?: Maybe<Subcontractor>
  subcontractorId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface IntegrationConnectionFilterInput {
  projectId?: InputMaybe<Scalars['String']>
  subcontractorId?: InputMaybe<Scalars['String']>
}

export type IntegrationConnectionSource = AgaveProject | AgaveVendor

export interface IntegrationContext {
  __typename?: 'IntegrationContext'
  integrationConnectionId?: Maybe<Scalars['String']>
  integrationId?: Maybe<Scalars['String']>
  integrationType?: Maybe<IntegrationType>
}

export interface IntegrationContextInput {
  integrationConnectionId?: InputMaybe<Scalars['String']>
  integrationId?: InputMaybe<Scalars['String']>
  integrationType?: InputMaybe<IntegrationType>
}

export interface IntegrationLog {
  __typename?: 'IntegrationLog'
  action: IntegrationLogAction
  adminUser?: Maybe<AdminUser>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  integration: Integration
  integrationConnection?: Maybe<IntegrationConnection>
  internal: Scalars['Boolean']
  resource?: Maybe<IntegrationLogResource>
  resourceIdentity?: Maybe<Scalars['String']>
  status: IntegrationLogStatus
}

export enum IntegrationLogAction {
  Connect = 'CONNECT',
  Create = 'CREATE',
  Delete = 'DELETE',
  Disconnect = 'DISCONNECT',
  Sync = 'SYNC',
  Update = 'UPDATE',
}

export interface IntegrationLogFilterInput {
  action?: InputMaybe<Array<InputMaybe<IntegrationLogAction>>>
  actionBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  resource?: InputMaybe<Array<InputMaybe<IntegrationLogResource>>>
  status?: InputMaybe<Array<InputMaybe<IntegrationLogStatus>>>
}

export enum IntegrationLogResource {
  Document = 'DOCUMENT',
  Induction = 'INDUCTION',
  Integration = 'INTEGRATION',
  Project = 'PROJECT',
  SiteDiary = 'SITE_DIARY',
  Subcontractor = 'SUBCONTRACTOR',
  Swms = 'SWMS',
  Toolbox = 'TOOLBOX',
  WebhookSubscription = 'WEBHOOK_SUBSCRIPTION',
}

export interface IntegrationLogSortInput {
  createdAt?: InputMaybe<SortOrder>
}

export enum IntegrationLogStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS',
  Unactioned = 'UNACTIONED',
}

export enum IntegrationType {
  Buildxact = 'BUILDXACT',
  IronLogic = 'IRON_LOGIC',
  Premier = 'PREMIER',
  Procore = 'PROCORE',
}

export interface InviteAdminUserInput {
  builderId?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  limitedPermissions?: InputMaybe<Scalars['Boolean']>
  mobile?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  roleId?: InputMaybe<Scalars['String']>
  sendInvite?: InputMaybe<Scalars['Boolean']>
}

export interface InvitedUsersToolboxInput {
  workerIds?: InputMaybe<Array<Scalars['String']>>
}

export interface IsPrimaryApprover {
  __typename?: 'IsPrimaryApprover'
  isPrimaryApprover: Scalars['Boolean']
  projectId: Scalars['String']
}

export interface KnockMessageContentAdmin {
  __typename?: 'KnockMessageContent_admin'
  html_body?: Maybe<Scalars['String']>
  subject?: Maybe<Scalars['String']>
  text_body?: Maybe<Scalars['String']>
  to?: Maybe<Scalars['String']>
}

export interface KnockMessageLogUserAdmin {
  __typename?: 'KnockMessageLogUser_admin'
  id: Scalars['String']
  name: Scalars['String']
}

export interface KnockMessageLogAdmin {
  __typename?: 'KnockMessageLog_Admin'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  logDate: Scalars['DateTime']
  messageId: Scalars['String']
  sentBy: KnockMessageLogUserAdmin
  sentTo: KnockMessageLogUserAdmin
  status: KnockMessageStatus
  updatedAt: Scalars['DateTime']
}

export interface KnockMessageLogsFilterInputAdmin {
  defectId?: InputMaybe<Scalars['String']>
  permitId?: InputMaybe<Scalars['String']>
  platformActionId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  projectScheduleItemId?: InputMaybe<Scalars['String']>
  templateResponseId?: InputMaybe<Scalars['String']>
}

export enum KnockMessageStatus {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Read = 'READ',
  Seen = 'SEEN',
  Sent = 'SENT',
}

export interface LibrarySwmsDocFilterInputAdmin {
  archivedFilter?: InputMaybe<ArchivedFilter>
  expired?: InputMaybe<Scalars['Boolean']>
  projectId?: InputMaybe<Scalars['String']>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InputMaybe<SwmsStatus>>>
  subcontractorIds?: InputMaybe<Array<Scalars['String']>>
}

export interface LibrarySwmsDocSortInputAdmin {
  createdAt?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

export interface LibrarySwmsDocAdmin {
  __typename?: 'LibrarySwmsDoc_Admin'
  archivedAt?: Maybe<Scalars['DateTime']>
  checklistTemplateResponse?: Maybe<TemplateResponse>
  connectedToProject: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  currentVersion?: Maybe<VersionHistory>
  expiresAt?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  key: Scalars['String']
  name: Scalars['String']
  status: SwmsStatus
  subcontractor?: Maybe<Subcontractor>
  subcontractorId: Scalars['String']
  subcontractorOnProject: Scalars['Boolean']
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
  versionHistory?: Maybe<Array<VersionHistory>>
}

export interface LibraryTemplate {
  __typename?: 'LibraryTemplate'
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  lastRun?: Maybe<Scalars['DateTime']>
  schedules?: Maybe<Array<Maybe<Schedule>>>
  templateData?: Maybe<Scalars['JSON']>
  templateDescription?: Maybe<Scalars['String']>
  templateName: Scalars['String']
  templateResponsesCount: Scalars['Int']
  templateType: TemplateType
  updatedAt: Scalars['DateTime']
}

export interface LibraryTemplateFilterInput {
  archivedFilter?: InputMaybe<ArchivedFilter>
  searchString?: InputMaybe<Scalars['String']>
  templateResponseLocationId?: InputMaybe<Scalars['String']>
  templateResponseProjectId?: InputMaybe<Scalars['String']>
  templateType?: InputMaybe<TemplateType>
}

export interface LibraryTemplateSortInput {
  name?: InputMaybe<SortOrder>
}

export interface Link {
  __typename?: 'Link'
  uploadUrl: Scalars['String']
}

export interface LinkedResourceMeta {
  __typename?: 'LinkedResourceMeta'
  adminUser?: Maybe<AdminUser>
  builder?: Maybe<Builder>
  project?: Maybe<Project>
  subcontractor?: Maybe<Subcontractor>
  user?: Maybe<User>
  worker?: Maybe<Worker>
}

export interface ListDisplayBlock extends TemplateBlockBase {
  __typename?: 'ListDisplayBlock'
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  items?: Maybe<Array<Maybe<TemplateListItems>>>
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
}

export interface ListPdfDateRange {
  afterDateTime: Scalars['Date']
  beforeDateTime: Scalars['Date']
}

export interface ListPdfGenerationInput {
  callbackInfo?: InputMaybe<CallbackInfo>
  extraData?: InputMaybe<Scalars['JSON']>
  includeAppendix?: InputMaybe<Scalars['Boolean']>
  margin?: InputMaybe<Scalars['String']>
  orientation?: InputMaybe<Orientation>
  projectId?: InputMaybe<Scalars['String']>
  resourceAppendUrl?: InputMaybe<Scalars['String']>
  resourceAppendUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  timezone?: InputMaybe<Scalars['String']>
  type: PdfType
}

export interface ManuallySignOffBulkInput {
  signOffDate?: InputMaybe<Scalars['DateTime']>
  signOffHoursOverride?: InputMaybe<Scalars['Float']>
  signOnDate?: InputMaybe<Scalars['DateTime']>
  signOnIds: Array<Scalars['String']>
}

export interface ManuallySignOffInput {
  signOffDate: Scalars['DateTime']
  signOnDate?: InputMaybe<Scalars['DateTime']>
  signOnId: Scalars['String']
}

export interface MarkOwnToolboxAttendanceInput {
  builderGeneratedAttendance?: InputMaybe<Scalars['Boolean']>
  toolboxId: Scalars['String']
}

export interface MarkToolboxAttendanceBatchInput {
  adminUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  attended?: InputMaybe<Scalars['Boolean']>
  builderGeneratedAttendance?: InputMaybe<Scalars['Boolean']>
  toolboxId: Scalars['String']
  workerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface MarkToolboxAttendanceInput {
  adminUserId?: InputMaybe<Scalars['String']>
  attended?: InputMaybe<Scalars['Boolean']>
  builderGeneratedAttendance?: InputMaybe<Scalars['Boolean']>
  toolboxId: Scalars['String']
  workerId?: InputMaybe<Scalars['String']>
}

export interface MergeCompaniesInput {
  companyIds: Array<Scalars['String']>
}

export interface MsdsDoc {
  __typename?: 'MsdsDoc'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  builderId: Scalars['String']
  checklistTemplateResponse?: Maybe<TemplateResponse>
  createdAt: Scalars['DateTime']
  currentVersion?: Maybe<VersionHistory>
  id: Scalars['String']
  name: Scalars['String']
  projects: Array<Maybe<Project>>
  reviewDate?: Maybe<Scalars['DateTime']>
  status: MsdsStatus
  subcontractor: Subcontractor
  subcontractorId: Scalars['String']
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
  versionHistory?: Maybe<Array<VersionHistory>>
}

export interface MsdsDocEntity {
  __typename?: 'MsdsDocEntity'
  id: Scalars['String']
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
}

export interface MsdsFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  reviewDate?: InputMaybe<Array<MsdsReviewDate>>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<MsdsStatus>>
}

export enum MsdsReviewDate {
  Current = 'CURRENT',
  DueSoon = 'DUE_SOON',
  None = 'NONE',
  Overdue = 'OVERDUE',
}

export interface MsdsSortInput {
  createdAt?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  reviewDate?: InputMaybe<SortOrder>
}

export enum MsdsStatus {
  ChangesRequested = 'CHANGES_REQUESTED',
  Reviewed = 'REVIEWED',
  WaitingReview = 'WAITING_REVIEW',
}

export interface MultiPdfGenerationInput {
  callbackInfo?: InputMaybe<CallbackInfo>
  includeAppendix?: InputMaybe<Scalars['Boolean']>
  margin?: InputMaybe<Scalars['String']>
  orientation?: InputMaybe<Orientation>
  resourceAppendUrl?: InputMaybe<Scalars['String']>
  resourceAppendUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  resourceIds: Array<Scalars['String']>
  timezone?: InputMaybe<Scalars['String']>
  type: PdfType
}

export interface Mutation {
  __typename?: 'Mutation'
  acknowledgePreStarts: SignOn
  activateSchedule: Schedule
  addProjectAccessToAccessControlIntegrationConnection: AccessControlIntegrationConnection
  /** Add one checklist id to the list of publicly available checklists */
  addPublicChecklist: ChecklistSettings
  approvePermit_admin: Array<PermitWorkerAdmin>
  approvePrequalification: Prequalification
  archiveAccessControlForWorker: SyncWorkerAccessControlManualResult
  archiveAccessProfileTemplate: AccessProfileTemplate
  archiveAdminUser: AdminUser
  archiveAttachment: Attachment
  archiveCompanyRegisterItem_public: CompanyRegisterItem
  archiveDefect: Defect
  archiveDocument: Document
  archiveDrawing_admin: DrawingAdmin
  archiveInduction: Induction
  archiveInsuranceDoc: InsuranceDoc
  archiveLibrarySwmsDoc_admin: LibrarySwmsDocAdmin
  archiveLibraryTemplate: LibraryTemplate
  archiveMsdsDoc: MsdsDoc
  archivePermitType_admin: PermitTypeAdmin
  archivePermitWorker_admin: PermitWorkerAdmin
  archivePermit_admin: PermitAdmin
  archivePlatformAction: PlatformAction
  archivePreStart: PreStart
  archiveProjectSchedule_admin: ProjectScheduleAdmin
  archiveRegister: Register
  archiveRegisterItem: RegisterItem
  archiveRegisterItemBooking: RegisterItemBooking
  archiveRegisterItemType: RegisterItemType
  archiveRegisterItemTypeTemplate: RegisterItemType
  archiveRegisterItem_public: RegisterItemPublic
  archiveSchedule: Schedule
  archiveSignOn: SignOn
  archiveSiteDiary: SiteDiary
  archiveSubcontractor: Subcontractor
  archiveSwmsDoc: SwmsDoc
  archiveSwmsTemplate: SwmsTemplate
  archiveSwmsTemplateResponse: SwmsTemplateResponse
  archiveTemplate: Template
  archiveTemplateResponse: TemplateResponse
  archiveWorker: Worker
  archiveWorkflow: Workflow
  assignContactToProject: Contact
  assignSubcontractorsToProject: Project
  attachMsdsDocsToProject: Array<Scalars['String']>
  autoSaveProjectScheduleDraft_admin?: Maybe<Scalars['Boolean']>
  bulkAddTags_admin: Array<ResourceTag>
  bulkArchiveDocuments: Array<Scalars['String']>
  bulkArchiveDrawings_admin: Array<Scalars['String']>
  bulkArchiveInsuranceDocs: Array<Scalars['String']>
  bulkArchiveMsdsDocs: Array<Scalars['String']>
  bulkArchiveSubcontractors: Scalars['Int']
  bulkArchiveTemplateResponses: Array<Scalars['String']>
  bulkArchiveTemplates?: Maybe<Array<Scalars['String']>>
  bulkDeleteDocumentFolders: Array<Scalars['String']>
  bulkDeleteDrawings_admin: Array<Scalars['String']>
  bulkRestoreDocuments: Array<Scalars['String']>
  bulkRestoreInsuranceDocs: Array<Scalars['String']>
  bulkRestoreMsdsDocs: Array<Scalars['String']>
  bulkRestoreTemplateResponses: Array<Scalars['String']>
  bulkRestoreTemplates?: Maybe<Array<Scalars['String']>>
  bulkSyncBuilderWithDataPipeline: BulkSyncDataPipelineResponse
  bulkUpdateTemplates: Array<Maybe<Template>>
  checkProjectCode_public: CodeForProjectCheckPayload
  checkProjectInductionCode: Scalars['Boolean']
  checkoutProjectSchedule_admin: ProjectScheduleAdmin
  cloneProjectLocation: ProjectLocation
  cloneProjectLocations: Array<ProjectLocation>
  closeoutPermit_admin: Array<PermitWorkerAdmin>
  closeoutPermit_worker: PermitWorker
  completeSwmsTemplateResponse: PdfResponse
  completeTemplateResponse: TemplateResponse
  configureProcoreWebhooks: ProcoreConfig
  confirmProjectScheduleItem_admin: ProjectScheduleItemAdmin
  confirmProjectScheduleItem_public: ProjectScheduleItemPublic
  connectAgaveAccount: AgaveAccountStatus
  connectBuildxactAccount: BuildxactAccountStatus
  connectBuildxactContacts: ConnectBuildxactContactsResponse
  connectBuildxactProjects: ConnectBuildxactProjectsResponse
  connectPremierAccount: PremierAccountStatus
  connectPremierJobs: ConnectPremierJobsResponse
  connectPremierVendors: ConnectPremierVendorsResponse
  connectProcoreProject: Project
  connectProcoreSubcontractor: Subcontractor
  connectProcoreSubcontractors: Array<Subcontractor>
  connectProjectToTemplate: Template
  createAccessControlForWorker: AccessControl
  createAccessControlIntegrationConnection: AccessControlIntegrationConnectionResult
  createAccessProfileTemplate: AccessProfileTemplate
  createAgaveLinkSessionToken: CreateAgaveLinkSessionTokenResponse
  createAttachment: Attachment
  createAttachmentUploadUrl: AttachmentUploadUrl
  createBuilder: Builder
  createBuilderWorkerDocument: BuilderWorkerDocument
  createCompanyRegisterItem_public: CompanyRegisterItem
  createContact: Contact
  createConversationMessage: ConversationMessage
  createDashboard: Dashboard
  createDefect: Defect
  createDefectMessageViaResourceLink: ConversationMessageResourceLink
  createDocument: Document
  createDocumentFolder: DocumentFolder
  createDocumentSignature: DocumentSignature
  createDocumentSignatureForWorker: DocumentSignature
  createDocumentSignatures: Array<Maybe<DocumentSignature>>
  createDocuments: Array<Document>
  createDrawing_admin: DrawingAdmin
  createEmergency: Emergency
  createFileUploadInvite: FileUploadInvite
  createFileUploadInvites: Array<FileUploadInvite>
  createInduction: Induction
  createInductionInvite: InductionInvite
  createInductionInviteAccept: InductionInviteAccept
  createInductionInvites: Array<InductionInvite>
  createInsuranceDoc: InsuranceDoc
  createIntegration: Integration
  createIntegrationConnection: IntegrationConnection
  createIntegrationConnectionsInBulk: Array<Maybe<IntegrationConnection>>
  createLibrarySwmsDoc_admin: LibrarySwmsDocAdmin
  createLibraryTemplate: LibraryTemplate
  createMsdsDoc: MsdsDoc
  createMultipleAttachments?: Maybe<Array<Attachment>>
  createMyDefectMessage: ConversationMessageResourceLink
  createMyTimesheetEntries?: Maybe<Array<WorkerTimesheetEntry>>
  createOrFindResourceTags: Array<Maybe<ResourceTag>>
  createOrUpdateHubspotContact?: Maybe<Scalars['String']>
  createPermitMessage_worker: ConversationMessageResourceLink
  createPermitTypeTemplate_admin: Template
  createPermitType_admin: PermitTypeAdmin
  createPermit_admin: PermitAdmin
  createPermit_worker: PermitWorker
  createPlatformAction: PlatformAction
  createPlatformActionConversationMessage_worker: ConversationMessageResourceLink
  createPreStart: PreStart
  /** @deprecated Use sendRequestForPrequalification instead */
  createPrequalification: Prequalification
  createPrequalificationForSubcontractor: Prequalification
  createProject: Project
  createProjectLocation: ProjectLocation
  createProjectSchedule_admin: ProjectScheduleAdmin
  createPublicAttachment: AttachmentEntity
  createPublicConversationMessageAsSubcontractor: ConversationMessage
  createPublicPlatformActionViaChecklistResourceLink: PlatformActionResourceLink
  createPublicTemplateResponse: TemplateResponseEntity
  createRegister: Register
  createRegisterItem: RegisterItem
  createRegisterItemBooking: RegisterItemBooking
  createRegisterItemType: RegisterItemType
  createRegisterItemTypeTemplate: Template
  createRegisterItem_public: RegisterItemPublic
  createResourceLink: ResourceLink
  createRole: Role
  createSchedule: Schedule
  createSignOn: SignOn
  createSiteDiary: SiteDiary
  createSubcontractor: Subcontractor
  createSubcontractors: Count
  createSwmsDoc: SwmsDoc
  createSwmsTemplate: SwmsTemplate
  createSwmsTemplateResponse: SwmsTemplateResponse
  createTemplate: Template
  createTemplateResponse: TemplateResponse
  createTemplateResponseAsWorker: TemplateResponseEntity
  /** @deprecated Use createTicketv2 instead */
  createTicket: Ticket
  createTicketReview: TicketReview
  createTicketReviews: Array<Maybe<TicketReview>>
  createTicketTemplate: TicketTemplate
  createTicketWalletShare: TicketWalletShare
  createTicketv2: Ticket
  createTimesheetEntries?: Maybe<Array<TimesheetEntry>>
  createToolbox: Toolbox
  createToolboxInvite: ToolboxInvite
  createToolboxInvites: Array<ToolboxInvite>
  createToolboxPreStart: Toolbox
  createUser: User
  createVisitor: Visitor
  createVisitorSignOn: SignOn
  createVisitorToken?: Maybe<VisitorToken>
  createVisitorUser: User
  createWorker: WorkerEntity
  createWorkerPlatformAction: PlatformAction
  createWorkerSignOnFromForm: SignOn
  createWorkerSignOnFromForm_worker: SignOnWorker
  createWorkerUser: User
  createWorkerWithUser: Worker
  createWorkflow: Workflow
  createZipAttachmentsUrl: ZipAttachmentsResponse
  deactivateSchedule: Schedule
  deleteAccessControlIntegrationConnection: AccessControlIntegrationConnection
  deleteBuilderWorkerDocument: BuilderWorkerDocument
  deleteContact: Contact
  deleteDashboard: Dashboard
  deleteDocument: Document
  deleteDocumentFolder: DocumentFolder
  deleteDrawing_admin: DrawingAdmin
  deleteIntegration: Integration
  deleteIntegrationConnection: IntegrationConnection
  deleteIntegrationConnectionsInBulk: Array<Scalars['String']>
  deleteMsdsDoc: MsdsDoc
  deleteMyTimesheetEntry: WorkerTimesheetEntry
  deletePermitTypeTemplate_admin: PermitTypeAdmin
  deleteProcoreConfig: ProcoreConfig
  deleteProject: Project
  deleteProjectLocation: ProjectLocation
  deleteStaffSubcontractor: Worker
  /** @deprecated Use archiveSwmsDoc instead */
  deleteSwmsDoc: SwmsDoc
  deleteTicket: Ticket
  deleteTimesheetEntry: TimesheetEntry
  deleteToolbox?: Maybe<Toolbox>
  deleteWorkerSubcontractor: Worker
  disableModules: ToggleModuleResponse
  discardProjectScheduleChanges_admin: ProjectScheduleAdmin
  disconnectProcoreProject: Project
  disconnectProcoreSubcontractor: Subcontractor
  disconnectProjectFromTemplateType: Project
  disconnectWorkerFromBuilder: Worker
  dismissSwmsDocLog: SwmsDocLog
  duplicatePermit_admin: PermitAdmin
  enableModules: ToggleModuleResponse
  findOrCreateResourceLink: ResourceLink
  findOrCreateResourceLinks: Array<ResourceLink>
  generateListPDF: PdfResponse
  generateMultiEntityPDF: PdfResponse
  generatePDF: PdfResponse
  generatePublicDefectsPDF: PdfResponse
  generateSummary_admin?: Maybe<Scalars['Boolean']>
  /** Generate AI suggestions for the current user */
  generateUserAISuggestions: Scalars['Boolean']
  getWelcomeLink: Link
  handleDrawingReviewConfirm_admin: DrawingAdmin
  importIntegrationProjects: Array<Project>
  importLibrarySwmsToProject_admin: Scalars['Boolean']
  inviteAdminUser: AdminUser
  manuallySignOff: SignOn
  manuallySignOffBulk: Array<SignOn>
  markOwnToolboxAttendance: ToolboxInvite
  markToolboxAttendance: ToolboxInvite
  markToolboxAttendanceBatch: Array<ToolboxInvite>
  mergeCompanies: Company
  moveDocumentFolders: Array<DocumentFolder>
  moveDocuments: Array<Document>
  moveDrawings_admin: Array<DrawingAdmin>
  pausePermit_admin: Array<PermitWorkerAdmin>
  pausePermit_worker: PermitWorker
  persistProjectScheduleDraft_admin: ProjectScheduleChangeLogAdmin
  publishIntegrationConnectionDocument: DocumentUpload
  reassignWorkerSubcontractors: Worker
  registerAIToolsUsage: Scalars['Boolean']
  reinviteAdminUser: Scalars['String']
  rejectPermit_admin: Array<PermitWorkerAdmin>
  rejectPrequalification: Prequalification
  removeContactFromProject: Contact
  removeProjectAccessFromAccessControlIntegrationConnection: AccessControlIntegrationConnection
  /** Remove one checklist id from the list of publicly available checklists */
  removePublicChecklist: ChecklistSettings
  renameWidget: DashboardWidget
  replaceProjectScheduleEditor_admin?: Maybe<Scalars['String']>
  /** Request access to an AI tool */
  requestAiToolSettings: AiToolsSettings
  resendMultiplePlatformActionEmails?: Maybe<Array<PlatformAction>>
  resendPlatformActionEmail: PlatformAction
  restoreAccessProfileTemplate: AccessProfileTemplate
  restoreDocument: Document
  restoreInduction: Induction
  restoreLibrarySwmsDoc_admin: LibrarySwmsDocAdmin
  restorePermitType_admin: PermitTypeAdmin
  restorePermitWorker_admin: PermitWorkerAdmin
  restorePermit_admin: PermitAdmin
  restorePlatformAction: PlatformAction
  restorePreStart: PreStart
  restoreProjectSchedule_admin: ProjectScheduleAdmin
  restoreRegister: Register
  restoreRegisterItem: RegisterItem
  restoreRegisterItemBooking: RegisterItemBooking
  restoreSchedule: Schedule
  restoreSignOn: SignOn
  restoreSwmsDoc: SwmsDoc
  restoreTemplate: Template
  restoreTemplateResponse: TemplateResponse
  resumePermit_admin: Array<PermitWorkerAdmin>
  saArchiveBuilder: Scalars['Boolean']
  saMergeSubcontractors: Subcontractor
  saUpdateBuilder: Builder
  saUpdateBuilderModules: Array<Maybe<BuildPassModule>>
  saveDashboard: Dashboard
  sendBulkInductionUpdateEmails_admin: Array<Scalars['String']>
  sendDefects?: Maybe<Array<Defect>>
  sendFileToBuildxact: SendFileToBuildxactResponse
  sendFileUploadInviteEmail: FileUploadInviteEmailSent
  sendInductionInviteEmail: InductionInviteEmailSent
  sendInductionUpdateEmail: EmailSent
  /** @deprecated Use sendDefects query */
  sendPendingDefects?: Maybe<Array<Defect>>
  sendProjectSms: SendProjectSmsResponse
  sendRequestForPrequalification: Prequalification
  sendRequestUpdateEmail: EmailSent
  sendScheduleNotifications_admin: Array<Scalars['String']>
  sendStaffInviteEmails: EmailSent
  sendTestWelcomeEmails: EmailSent
  sendWelcomeEmails: EmailSent
  setPremierCompanyAsPrimary: Scalars['Boolean']
  setProjectSiteTimings?: Maybe<Array<Maybe<ProjectSiteTiming>>>
  setupBuildxactAccessToken: BuildxactAccountStatus
  signInToken?: Maybe<SignInTokenResponse>
  signOff: SignOn
  startPermit_admin: Array<PermitWorkerAdmin>
  startPermit_worker: PermitWorker
  submitRegisterItemReview: RegisterItem
  submitSwmsTemplateResponse: SwmsDocEntity
  suspendPermit_admin: Array<PermitWorkerAdmin>
  switchBuilder: AdminUser
  switchSuperAdminBuilder: Builder
  syncAgaveProjects: SyncAgaveProjectsResponse
  syncAgaveVendors: SyncAgaveVendorsResponse
  syncBuilderWithDataPipeline: Billing
  syncIntegrationConnection: IntegrationConnection
  syncIntegrationConnections: BulkSyncResult
  syncIntegrationToProjects: Array<Project>
  syncSiteAttendanceToProcore: SyncSiteAttendanceResults
  syncWorkerAccessControlManual: SyncWorkerAccessControlManualResult
  /** Enable/Disable the AI tools for the current Builder */
  toggleAiToolsEnabledSettings: AiToolsSettings
  toggleFavouriteDashboard: Dashboard
  togglePrimaryContact: Contact
  transferFileToAgave: TransferFileToAgaveResponse
  transferPermitType_admin: Scalars['String']
  transferTemplate: Scalars['String']
  transferTemplates: Array<Scalars['String']>
  unarchiveAdminUser: AdminUser
  unassignSubcontractorsFromProject: Project
  updateAccessControlForWorker: SyncWorkerAccessControlManualResult
  updateAccessControlIntegrationConnection: AccessControlIntegrationConnectionResult
  updateAccessProfile: AccessProfile
  updateAccessProfileTemplate: AccessProfileTemplate
  updateAdminUser: AdminUser
  updateAdminUserRoles: AdminUser
  /** Update the AI tools settings for the current Builder */
  updateAiToolsSettings: AiToolsSettings
  updateAttachmentInfo: Attachment
  updateBuilder: Builder
  updateBuilderMetadata: Builder
  updateBuilderQuestionnaire: BuilderQuestionnaireResponse
  /** Update the Register module settings for the current Builder */
  updateBuilderRegisterSettings: BuilderRegisterSettings
  /** Update the Builder settings */
  updateBuilderSettings: BuilderSettings
  updateBuilderSubcontractor: Worker
  updateBuilderSubcontractorData: Subcontractor
  updateBuilderWorkerDocument: BuilderWorkerDocument
  /** Update the Checklist module settings for the current Builder */
  updateChecklistSettings: ChecklistSettings
  /** Update the communication settings for the current Builder */
  updateCommunicationSettings: CommunicationSettings
  updateContact: Contact
  updateDefect: Defect
  /** Update the Defect module settings for the current Builder */
  updateDefectSettings: DefectSettings
  updateDefectStatus: Defect
  updateDefectViaResourceLink: DefectResourceLink
  updateDefectsAssignees?: Maybe<Array<Defect>>
  updateDefectsDueDate?: Maybe<Array<Defect>>
  updateDefectsStatus?: Maybe<Array<Defect>>
  updateDocument: Document
  updateDocumentFolder: DocumentFolder
  updateDocumentSignatures: Array<Scalars['String']>
  updateDrawing_admin: DrawingAdmin
  updateEmergency: Emergency
  updateEmergencyMessage: EmergencyMessage
  updateEmergencyMessageAsWorker: PublicEmergencyMessage
  /** Update the Image settings for the current Builder */
  updateGallerySettings: GallerySettings
  /** Update the global settings */
  updateGlobalSettings: GlobalSettings
  /** Update the Hours budget module settings for the specified project */
  updateHoursBudgetSettings: HoursBudgetSettings
  updateInduction: Induction
  /** Update the Induction module settings for the current Builder */
  updateInductionSettings: InductionSettings
  updateInsuranceDoc: InsuranceDoc
  updateLibrarySwmsDocReview_admin: LibrarySwmsDocAdmin
  updateLibrarySwmsDoc_admin: LibrarySwmsDocAdmin
  updateLibraryTemplate: LibraryTemplate
  updateMsdsDoc: MsdsDoc
  updateMyDefect: WorkerDefectEntry
  updatePermitTemplateResponse_admin: TemplateResponse
  updatePermitType_admin: PermitTypeAdmin
  updatePermitWorkerTemplateResponse_admin: TemplateResponse
  updatePermitWorkerTemplateResponse_worker: TemplateResponse
  updatePermit_admin: PermitAdmin
  updatePermit_worker: PermitWorker
  updatePlatformAction: PlatformAction
  /** Update the Platform Action module settings for the current Builder */
  updatePlatformActionSettings: PlatformActionSettings
  updatePlatformAction_worker: PlatformActionEntity
  updatePlatformActionsStatus?: Maybe<Array<PlatformAction>>
  updatePreStart: PreStart
  /** Update the Premier integration settings for the current Builder */
  updatePremierSettings: PremierSettings
  /** Update the Prequalification module settings for the current Builder */
  updatePrequalificationSettings: PrequalificationSettings
  updatePrequalificationViaResourceLink: PrequalificationResourceLink
  /** Update the Procore integration settings for the current Builder */
  updateProcoreSettings: ProcoreSettings
  updateProject: Project
  updateProjectAccessForAccessControlIntegrationConnection: AccessControlIntegrationConnection
  updateProjectLocation: ProjectLocation
  updateProjectScheduleItemStatus_admin: ProjectScheduleItemAdmin
  updateProjectSchedule_admin: ProjectScheduleAdmin
  updateProjectSpecificInductionSettings: ProjectSpecificInductionSettings
  /** Update the project specific Permit module settings for the current Builder */
  updateProjectSpecificPermitSettings: ProjectSpecificPermitSettings
  /** Update the Procore integration settings for the current project */
  updateProjectSpecificProcoreSettings: ProjectSpecificProcoreSettings
  updateProjectSpecificSettings: ProjectSpecificSettings
  /** Update the Site Diary module settings for the current project */
  updateProjectSpecificSiteDiarySettings: ProjectSpecificSiteDiarySettings
  updateProjectSubcontractors: Project
  updatePublicPlatformActionViaChecklistResourceLink: PlatformActionResourceLink
  updatePublicSubcontractorPlatformAction: PlatformActionEntity
  updatePublicTemplateResponse: TemplateResponseEntity
  updateRegister: Register
  updateRegisterItem: RegisterItem
  updateRegisterItemBooking: RegisterItemBooking
  updateRegisterItemType: RegisterItemType
  updateResourceLink: ResourceLink
  updateResourceTags_admin: Array<ResourceTag>
  updateRolePermissions: Role
  /** Update the SWMS module settings for the current Builder */
  updateSWMSSettings: SwmsSettings
  updateSchedule: Schedule
  updateSignOnContextMetadata: SignOn
  /** Update the Sign On module settings for the current Builder */
  updateSignOnSettings: SignOnSettings
  updateSiteDiary: SiteDiary
  /** Update the styling settings for the current Builder */
  updateStylingSettings: StylingSettings
  updateSubcontractor: Subcontractor
  updateSubcontractorDetails: Subcontractor
  /** Update the Subcontractor module settings for the current Builder */
  updateSubcontractorSettings: SubcontractorSettings
  updateSwmsDoc: SwmsDoc
  updateSwmsTemplate: SwmsTemplate
  updateSwmsTemplateResponse: SwmsTemplateResponse
  updateTemplate: Template
  updateTemplateResponse: TemplateResponse
  updateTemplateResponseAsWorker: TemplateResponseEntity
  updateTemplateResponseRelatedRegisterItem: TemplateResponse
  /** @deprecated Use updateTicketv2 instead */
  updateTicket: Ticket
  updateTicketv2: Ticket
  updateTimesheetEntries: Array<TimesheetEntry>
  updateTimesheetEntry: TimesheetEntry
  /** Update the Timesheet module settings for the current Builder */
  updateTimesheetSettings: TimesheetSettings
  updateTimesheetsStatus?: Maybe<Array<TimesheetEntry>>
  updateToolbox: Toolbox
  updateUser: User
  /** Update the settings for a user */
  updateUserSettings: UserSettings
  updateWidgetSettings: DashboardWidget
  updateWorker: Worker
  updateWorkerMetadata: Worker
  updateWorkerUser_admin: User
  updateWorkerWithUser: Worker
  updateWorkflow: Workflow
  uploadFiles: FilesUploaded
  upsertProcoreConfig: ProcoreConfig
  upsertProcoreDailyLogs?: Maybe<ProcoreDailyLogsConfirmation>
}

export interface MutationAcknowledgePreStartsArgs {
  preStartIds: Array<Scalars['String']>
  signOnId: Scalars['String']
}

export interface MutationActivateScheduleArgs {
  id: Scalars['String']
}

export interface MutationAddProjectAccessToAccessControlIntegrationConnectionArgs {
  id: Scalars['String']
  projectId: Scalars['String']
}

export interface MutationAddPublicChecklistArgs {
  checklistId: Scalars['String']
}

export interface MutationApprovePermitAdminArgs {
  ids: Array<Scalars['String']>
  input?: InputMaybe<ApprovePermitInputAdmin>
  permitId: Scalars['String']
}

export interface MutationApprovePrequalificationArgs {
  id: Scalars['String']
  input?: InputMaybe<UpdatePrequalificationInput>
}

export interface MutationArchiveAccessControlForWorkerArgs {
  id: Scalars['String']
}

export interface MutationArchiveAccessProfileTemplateArgs {
  id: Scalars['String']
}

export interface MutationArchiveAdminUserArgs {
  id: Scalars['String']
}

export interface MutationArchiveAttachmentArgs {
  id: Scalars['String']
}

export interface MutationArchiveCompanyRegisterItemPublicArgs {
  id: Scalars['String']
  subcontractorId: Scalars['String']
}

export interface MutationArchiveDefectArgs {
  id: Scalars['String']
}

export interface MutationArchiveDocumentArgs {
  id: Scalars['String']
}

export interface MutationArchiveDrawingAdminArgs {
  id: Scalars['String']
}

export interface MutationArchiveInductionArgs {
  id: Scalars['String']
}

export interface MutationArchiveInsuranceDocArgs {
  id: Scalars['String']
}

export interface MutationArchiveLibrarySwmsDocAdminArgs {
  id: Scalars['String']
}

export interface MutationArchiveLibraryTemplateArgs {
  id: Scalars['String']
}

export interface MutationArchiveMsdsDocArgs {
  id: Scalars['String']
}

export interface MutationArchivePermitTypeAdminArgs {
  id: Scalars['String']
}

export interface MutationArchivePermitWorkerAdminArgs {
  id: Scalars['String']
}

export interface MutationArchivePermitAdminArgs {
  id: Scalars['String']
}

export interface MutationArchivePlatformActionArgs {
  id: Scalars['String']
}

export interface MutationArchivePreStartArgs {
  id: Scalars['String']
}

export interface MutationArchiveProjectScheduleAdminArgs {
  projectScheduleId: Scalars['String']
}

export interface MutationArchiveRegisterArgs {
  id: Scalars['String']
}

export interface MutationArchiveRegisterItemArgs {
  id: Scalars['String']
}

export interface MutationArchiveRegisterItemBookingArgs {
  id: Scalars['String']
}

export interface MutationArchiveRegisterItemTypeArgs {
  id: Scalars['String']
}

export interface MutationArchiveRegisterItemTypeTemplateArgs {
  id: Scalars['String']
  type: RegisterItemTypeTemplate
}

export interface MutationArchiveRegisterItemPublicArgs {
  id: Scalars['String']
  subcontractorId: Scalars['String']
}

export interface MutationArchiveScheduleArgs {
  id: Scalars['String']
}

export interface MutationArchiveSignOnArgs {
  id: Scalars['String']
}

export interface MutationArchiveSiteDiaryArgs {
  id: Scalars['String']
}

export interface MutationArchiveSubcontractorArgs {
  id: Scalars['String']
}

export interface MutationArchiveSwmsDocArgs {
  id: Scalars['String']
}

export interface MutationArchiveSwmsTemplateArgs {
  input?: InputMaybe<ArchiveSwmsTemplateInput>
}

export interface MutationArchiveSwmsTemplateResponseArgs {
  input: ArchiveSwmsTemplateResponseInput
}

export interface MutationArchiveTemplateArgs {
  id: Scalars['String']
}

export interface MutationArchiveTemplateResponseArgs {
  id: Scalars['String']
}

export interface MutationArchiveWorkerArgs {
  id: Scalars['String']
}

export interface MutationArchiveWorkflowArgs {
  id: Scalars['String']
}

export interface MutationAssignContactToProjectArgs {
  contactId: Scalars['String']
  projectId: Scalars['String']
}

export interface MutationAssignSubcontractorsToProjectArgs {
  id: Scalars['String']
  subcontractorIds: Array<Scalars['String']>
}

export interface MutationAttachMsdsDocsToProjectArgs {
  ids: Array<Scalars['String']>
  projectId: Scalars['String']
}

export interface MutationAutoSaveProjectScheduleDraftAdminArgs {
  data: Scalars['JSON']
  projectScheduleId: Scalars['String']
}

export interface MutationBulkAddTagsAdminArgs {
  resourceIds: Array<Scalars['String']>
  resourceType: ResourceTagResourceTypeAdmin
  tags: Array<Scalars['String']>
}

export interface MutationBulkArchiveDocumentsArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkArchiveDrawingsAdminArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkArchiveInsuranceDocsArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkArchiveMsdsDocsArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkArchiveSubcontractorsArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkArchiveTemplateResponsesArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkArchiveTemplatesArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkDeleteDocumentFoldersArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkDeleteDrawingsAdminArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkRestoreDocumentsArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkRestoreInsuranceDocsArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkRestoreMsdsDocsArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkRestoreTemplateResponsesArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkRestoreTemplatesArgs {
  ids: Array<Scalars['String']>
}

export interface MutationBulkSyncBuilderWithDataPipelineArgs {
  builderIds: Array<Scalars['String']>
}

export interface MutationBulkUpdateTemplatesArgs {
  ids: Array<InputMaybe<Scalars['String']>>
  input: UpdateTemplateInput
}

export interface MutationCheckProjectCodePublicArgs {
  code: Scalars['String']
  projectId: Scalars['String']
}

export interface MutationCheckProjectInductionCodeArgs {
  code: Scalars['String']
  projectId: Scalars['String']
}

export interface MutationCheckoutProjectScheduleAdminArgs {
  projectScheduleId: Scalars['String']
}

export interface MutationCloneProjectLocationArgs {
  id: Scalars['String']
}

export interface MutationCloneProjectLocationsArgs {
  input: CloneProjectLocationsInput
}

export interface MutationCloseoutPermitAdminArgs {
  ids: Array<Scalars['String']>
  input?: InputMaybe<CloseoutPermitInputAdmin>
  permitId: Scalars['String']
}

export interface MutationCloseoutPermitWorkerArgs {
  id: Scalars['String']
  input?: InputMaybe<CloseoutPermitInputWorker>
}

export interface MutationCompleteSwmsTemplateResponseArgs {
  input: CompleteSwmsTemplateResponseInput
}

export interface MutationCompleteTemplateResponseArgs {
  completedAt?: InputMaybe<Scalars['DateTime']>
  id: Scalars['String']
}

export interface MutationConfirmProjectScheduleItemAdminArgs {
  confirmedAt?: InputMaybe<Scalars['DateTime']>
  projectScheduleItemId: Scalars['String']
}

export interface MutationConfirmProjectScheduleItemPublicArgs {
  projectScheduleItemId: Scalars['String']
  subcontractorId: Scalars['String']
}

export interface MutationConnectAgaveAccountArgs {
  input: ConnectAgaveAccountInput
}

export interface MutationConnectBuildxactAccountArgs {
  input: ConnectBuildxactAccountInput
}

export interface MutationConnectBuildxactContactsArgs {
  input: ConnectBuildxactContactsInput
}

export interface MutationConnectBuildxactProjectsArgs {
  input: ConnectBuildxactProjectsInput
}

export interface MutationConnectPremierAccountArgs {
  input: ConnectPremierAccountInput
}

export interface MutationConnectPremierJobsArgs {
  input: ConnectPremierJobsInput
}

export interface MutationConnectPremierVendorsArgs {
  input: ConnectPremierVendorsInput
}

export interface MutationConnectProcoreProjectArgs {
  id: Scalars['String']
  input?: InputMaybe<ProcoreProjectInput>
}

export interface MutationConnectProcoreSubcontractorArgs {
  id: Scalars['String']
  input?: InputMaybe<ProcoreSubcontractorInput>
}

export interface MutationConnectProcoreSubcontractorsArgs {
  input: Array<ProcoreSubcontractorConnectInput>
}

export interface MutationConnectProjectToTemplateArgs {
  input: AssignProjectToTemplateInput
  projectId: Scalars['String']
  templateId: Scalars['String']
}

export interface MutationCreateAccessControlForWorkerArgs {
  input: CreateAccessControlForWorkerInput
}

export interface MutationCreateAccessControlIntegrationConnectionArgs {
  input: CreateAccessControlIntegrationConnectionInput
}

export interface MutationCreateAccessProfileTemplateArgs {
  input: AccessProfileTemplateInput
}

export interface MutationCreateAgaveLinkSessionTokenArgs {
  input: CreateAgaveLinkSessionTokenInput
}

export interface MutationCreateAttachmentArgs {
  input: CreateAttachmentInput
}

export interface MutationCreateAttachmentUploadUrlArgs {
  input: CreateAttachmentUploadUrlInput
}

export interface MutationCreateBuilderArgs {
  input: CreateBuilderInput
}

export interface MutationCreateBuilderWorkerDocumentArgs {
  input: CreateBuilderWorkerDocumentInput
}

export interface MutationCreateCompanyRegisterItemPublicArgs {
  input: CreateCompanyRegisterItemPublicInput
  subcontractorId: Scalars['String']
}

export interface MutationCreateContactArgs {
  input: ContactInput
  subcontractorId: Scalars['String']
}

export interface MutationCreateConversationMessageArgs {
  input: CreateConversationMessageInput
}

export interface MutationCreateDashboardArgs {
  input: DashboardInput
}

export interface MutationCreateDefectArgs {
  input: CreateDefectInput
}

export interface MutationCreateDefectMessageViaResourceLinkArgs {
  defectId: Scalars['String']
  input: CreateConversationMessageInput
  resourceLinkSlug: Scalars['String']
}

export interface MutationCreateDocumentArgs {
  input: CreateDocumentInput
}

export interface MutationCreateDocumentFolderArgs {
  input: CreateDocumentFolderInput
}

export interface MutationCreateDocumentSignatureArgs {
  input: CreateDocumentSignatureInput
}

export interface MutationCreateDocumentSignatureForWorkerArgs {
  input: CreateDocumentSignatureForWorkerInput
}

export interface MutationCreateDocumentSignaturesArgs {
  input: CreateDocumentSignaturesInput
}

export interface MutationCreateDocumentsArgs {
  input: Array<CreateDocumentInput>
}

export interface MutationCreateDrawingAdminArgs {
  input: CreateDrawingInputAdmin
}

export interface MutationCreateEmergencyArgs {
  input: CreateEmergencyInput
}

export interface MutationCreateFileUploadInviteArgs {
  input: CreateFileUploadInviteInput
}

export interface MutationCreateFileUploadInvitesArgs {
  input: CreateFileUploadInvitesInput
}

export interface MutationCreateInductionArgs {
  input: CreateInductionInput
}

export interface MutationCreateInductionInviteArgs {
  input: CreateInductionInviteInput
}

export interface MutationCreateInductionInviteAcceptArgs {
  input: CreateInductionInviteAcceptInput
}

export interface MutationCreateInductionInvitesArgs {
  input: CreateInductionInviteInput
}

export interface MutationCreateInsuranceDocArgs {
  input: CreateInsuranceDocInput
}

export interface MutationCreateIntegrationArgs {
  input: CreateIntegrationInput
}

export interface MutationCreateIntegrationConnectionArgs {
  input: CreateIntegrationConnectionInput
}

export interface MutationCreateIntegrationConnectionsInBulkArgs {
  input: CreateIntegrationConnectionsInBulkInput
}

export interface MutationCreateLibrarySwmsDocAdminArgs {
  input?: InputMaybe<CreateLibrarySwmsDocInputAdmin>
}

export interface MutationCreateLibraryTemplateArgs {
  input: CreateLibraryTemplateInput
}

export interface MutationCreateMsdsDocArgs {
  input: CreateMsdsDocInput
}

export interface MutationCreateMultipleAttachmentsArgs {
  input?: InputMaybe<Array<CreateAttachmentInput>>
}

export interface MutationCreateMyDefectMessageArgs {
  id?: InputMaybe<Scalars['String']>
  input: CreateConversationMessageInput
}

export interface MutationCreateMyTimesheetEntriesArgs {
  input: CreateMyTimesheetsInput
}

export interface MutationCreateOrFindResourceTagsArgs {
  input?: InputMaybe<CreateResourceTagsInput>
}

export interface MutationCreateOrUpdateHubspotContactArgs {
  input: CreateOrUpdateHubspotContactInput
}

export interface MutationCreatePermitMessageWorkerArgs {
  id?: InputMaybe<Scalars['String']>
  input: CreateConversationMessageInput
}

export interface MutationCreatePermitTypeTemplateAdminArgs {
  id: Scalars['String']
  type: PermitTypeTemplate
}

export interface MutationCreatePermitTypeAdminArgs {
  input: CreatePermitTypeInputAdmin
}

export interface MutationCreatePermitAdminArgs {
  input: CreatePermitInputAdmin
}

export interface MutationCreatePermitWorkerArgs {
  input: CreatePermitInputWorker
}

export interface MutationCreatePlatformActionArgs {
  input: CreatePlatformActionInput
}

export interface MutationCreatePlatformActionConversationMessageWorkerArgs {
  id?: InputMaybe<Scalars['String']>
  input: CreateConversationMessageInput
}

export interface MutationCreatePreStartArgs {
  input: CreatePreStartInput
}

export interface MutationCreatePrequalificationArgs {
  subcontractorId: Scalars['String']
}

export interface MutationCreatePrequalificationForSubcontractorArgs {
  input: CreatePrequalificationForSubcontractor
  subcontractorId: Scalars['String']
}

export interface MutationCreateProjectArgs {
  input: CreateProjectInput
}

export interface MutationCreateProjectLocationArgs {
  input: CreateProjectLocationInput
}

export interface MutationCreateProjectScheduleAdminArgs {
  input: CreateProjectScheduleInputAdmin
  projectId: Scalars['String']
}

export interface MutationCreatePublicAttachmentArgs {
  input: CreateAttachmentInput
}

export interface MutationCreatePublicConversationMessageAsSubcontractorArgs {
  input: CreatePublicConversationMessageAsSubcontractorInput
}

export interface MutationCreatePublicPlatformActionViaChecklistResourceLinkArgs {
  input: CreatePublicPlatformActionViaChecklistResourceLinkInput
}

export interface MutationCreatePublicTemplateResponseArgs {
  input: CreatePublicTemplateResponseInput
}

export interface MutationCreateRegisterArgs {
  input: CreateRegisterInput
}

export interface MutationCreateRegisterItemArgs {
  input: CreateRegisterItemInput
}

export interface MutationCreateRegisterItemBookingArgs {
  input: CreateRegisterItemBookingInput
}

export interface MutationCreateRegisterItemTypeArgs {
  input: CreateRegisterItemTypeInput
}

export interface MutationCreateRegisterItemTypeTemplateArgs {
  id: Scalars['String']
  type: RegisterItemTypeTemplate
}

export interface MutationCreateRegisterItemPublicArgs {
  input: CreateRegisterItemPublicInput
  subcontractorId: Scalars['String']
}

export interface MutationCreateResourceLinkArgs {
  input: CreateResourceLinkInput
}

export interface MutationCreateRoleArgs {
  input: CreateRoleInput
}

export interface MutationCreateScheduleArgs {
  input: CreateScheduleInput
}

export interface MutationCreateSignOnArgs {
  input: CreateSignOnInput
}

export interface MutationCreateSiteDiaryArgs {
  input: CreateSiteDiaryInput
}

export interface MutationCreateSubcontractorArgs {
  input: CreateSubcontractorInput
}

export interface MutationCreateSubcontractorsArgs {
  input?: InputMaybe<Array<CreateSubcontractorInput>>
}

export interface MutationCreateSwmsDocArgs {
  input?: InputMaybe<CreateSwmsDocInput>
}

export interface MutationCreateSwmsTemplateArgs {
  input?: InputMaybe<CreateSwmsTemplateInput>
}

export interface MutationCreateSwmsTemplateResponseArgs {
  input: CreateSwmsTemplateResponseInput
}

export interface MutationCreateTemplateArgs {
  input: CreateTemplateInput
}

export interface MutationCreateTemplateResponseArgs {
  input: CreateTemplateResponseInput
}

export interface MutationCreateTemplateResponseAsWorkerArgs {
  input: CreateTemplateResponseAsWorkerInput
}

export interface MutationCreateTicketArgs {
  input: CreateTicketInput
}

export interface MutationCreateTicketReviewArgs {
  input: CreateTicketReviewInput
}

export interface MutationCreateTicketReviewsArgs {
  input: Array<InputMaybe<CreateTicketReviewInput>>
}

export interface MutationCreateTicketTemplateArgs {
  input: CreateTicketTemplateInput
}

export interface MutationCreateTicketv2Args {
  input: CreateTicketInputV2
}

export interface MutationCreateTimesheetEntriesArgs {
  input: CreateTimesheetsInput
}

export interface MutationCreateToolboxArgs {
  input: CreateToolboxInput
}

export interface MutationCreateToolboxInviteArgs {
  input: CreateToolboxInviteInput
}

export interface MutationCreateToolboxInvitesArgs {
  input: CreateToolboxInvitesInput
}

export interface MutationCreateToolboxPreStartArgs {
  input?: InputMaybe<CreateToolboxPreStartInput>
  toolboxId: Scalars['String']
}

export interface MutationCreateUserArgs {
  input: CreateUserInput
}

export interface MutationCreateVisitorArgs {
  input: CreateVisitorInput
}

export interface MutationCreateVisitorSignOnArgs {
  input: CreateVisitorSignOnInput
}

export interface MutationCreateVisitorUserArgs {
  input: CreateVisitorUserUserInput
}

export interface MutationCreateWorkerArgs {
  input: CreateWorkerInput
}

export interface MutationCreateWorkerPlatformActionArgs {
  input: CreatePlatformActionInput
}

export interface MutationCreateWorkerSignOnFromFormArgs {
  input: CreateWorkerSignOnFromFormInput
}

export interface MutationCreateWorkerSignOnFromFormWorkerArgs {
  input: CreateWorkerSignOnFromFormWorkerInput
}

export interface MutationCreateWorkerUserArgs {
  input: CreateWorkerUserUserInput
}

export interface MutationCreateWorkerWithUserArgs {
  input: CreateWorkerUserInput
}

export interface MutationCreateWorkflowArgs {
  workflow: WorkflowInput
}

export interface MutationCreateZipAttachmentsUrlArgs {
  input: CreateZipAttachmentsUrlInput
}

export interface MutationDeactivateScheduleArgs {
  id: Scalars['String']
}

export interface MutationDeleteAccessControlIntegrationConnectionArgs {
  id: Scalars['String']
}

export interface MutationDeleteBuilderWorkerDocumentArgs {
  id: Scalars['String']
}

export interface MutationDeleteContactArgs {
  contactId: Scalars['String']
}

export interface MutationDeleteDashboardArgs {
  id: Scalars['String']
}

export interface MutationDeleteDocumentArgs {
  id: Scalars['String']
}

export interface MutationDeleteDocumentFolderArgs {
  id: Scalars['String']
}

export interface MutationDeleteDrawingAdminArgs {
  id: Scalars['String']
}

export interface MutationDeleteIntegrationArgs {
  id: Scalars['String']
}

export interface MutationDeleteIntegrationConnectionArgs {
  id: Scalars['String']
}

export interface MutationDeleteIntegrationConnectionsInBulkArgs {
  input: DeleteIntegrationConnectionsInBulkInput
}

export interface MutationDeleteMsdsDocArgs {
  id: Scalars['String']
}

export interface MutationDeleteMyTimesheetEntryArgs {
  id: Scalars['String']
}

export interface MutationDeletePermitTypeTemplateAdminArgs {
  id: Scalars['String']
  type: PermitTypeTemplate
}

export interface MutationDeleteProjectArgs {
  id: Scalars['String']
}

export interface MutationDeleteProjectLocationArgs {
  id: Scalars['String']
}

export interface MutationDeleteStaffSubcontractorArgs {
  input: DeleteStaffSubcontractorInput
}

export interface MutationDeleteSwmsDocArgs {
  id: Scalars['String']
}

export interface MutationDeleteTicketArgs {
  id: Scalars['String']
}

export interface MutationDeleteTimesheetEntryArgs {
  id: Scalars['String']
}

export interface MutationDeleteToolboxArgs {
  id: Scalars['String']
}

export interface MutationDeleteWorkerSubcontractorArgs {
  input: DeleteWorkerSubcontractorInput
}

export interface MutationDisableModulesArgs {
  input: ToggleModuleInput
}

export interface MutationDiscardProjectScheduleChangesAdminArgs {
  projectScheduleId: Scalars['String']
}

export interface MutationDisconnectProcoreProjectArgs {
  id: Scalars['String']
}

export interface MutationDisconnectProcoreSubcontractorArgs {
  id: Scalars['String']
}

export interface MutationDisconnectProjectFromTemplateTypeArgs {
  projectId: Scalars['String']
  templateType: TemplateType
}

export interface MutationDisconnectWorkerFromBuilderArgs {
  id: Scalars['String']
}

export interface MutationDismissSwmsDocLogArgs {
  id: Scalars['String']
}

export interface MutationDuplicatePermitAdminArgs {
  id: Scalars['String']
}

export interface MutationEnableModulesArgs {
  input: ToggleModuleInput
}

export interface MutationFindOrCreateResourceLinkArgs {
  input: CreateResourceLinkInput
}

export interface MutationFindOrCreateResourceLinksArgs {
  input: Array<CreateResourceLinkInput>
}

export interface MutationGenerateListPdfArgs {
  input: ListPdfGenerationInput
}

export interface MutationGenerateMultiEntityPdfArgs {
  input: MultiPdfGenerationInput
}

export interface MutationGeneratePdfArgs {
  input: PdfGenerationInput
}

export interface MutationGeneratePublicDefectsPdfArgs {
  input: PublicDefectsPdfGenerationInput
}

export interface MutationGenerateSummaryAdminArgs {
  resource: AuditResource
  resourceId: Scalars['String']
}

export interface MutationGenerateUserAiSuggestionsArgs {
  projectId: Scalars['String']
}

export interface MutationGetWelcomeLinkArgs {
  input: GetWelcomeLinkInput
}

export interface MutationHandleDrawingReviewConfirmAdminArgs {
  id: Scalars['String']
  waitingReviewStatus: DrawingWaitingReviewStatus
}

export interface MutationImportIntegrationProjectsArgs {
  integrationIdentifiers: Array<Scalars['String']>
  integrationType: IntegrationType
}

export interface MutationImportLibrarySwmsToProjectAdminArgs {
  librarySwmsDocIds: Array<Scalars['String']>
  projectId: Scalars['String']
}

export interface MutationInviteAdminUserArgs {
  input: InviteAdminUserInput
}

export interface MutationManuallySignOffArgs {
  input?: InputMaybe<ManuallySignOffInput>
}

export interface MutationManuallySignOffBulkArgs {
  input?: InputMaybe<ManuallySignOffBulkInput>
}

export interface MutationMarkOwnToolboxAttendanceArgs {
  input: MarkOwnToolboxAttendanceInput
}

export interface MutationMarkToolboxAttendanceArgs {
  input: MarkToolboxAttendanceInput
}

export interface MutationMarkToolboxAttendanceBatchArgs {
  input: MarkToolboxAttendanceBatchInput
}

export interface MutationMergeCompaniesArgs {
  input: MergeCompaniesInput
}

export interface MutationMoveDocumentFoldersArgs {
  documentFolderId?: InputMaybe<Scalars['String']>
  ids: Array<Scalars['String']>
}

export interface MutationMoveDocumentsArgs {
  documentFolderId?: InputMaybe<Scalars['String']>
  ids: Array<Scalars['String']>
}

export interface MutationMoveDrawingsAdminArgs {
  documentFolderId?: InputMaybe<Scalars['String']>
  ids: Array<Scalars['String']>
}

export interface MutationPausePermitAdminArgs {
  ids: Array<Scalars['String']>
  permitId: Scalars['String']
}

export interface MutationPausePermitWorkerArgs {
  id: Scalars['String']
}

export interface MutationPersistProjectScheduleDraftAdminArgs {
  items?: InputMaybe<Array<ScheduleItemDtoInputAdmin>>
  projectScheduleId: Scalars['String']
}

export interface MutationPublishIntegrationConnectionDocumentArgs {
  documentId: Scalars['String']
  integrationIdentifier: Scalars['String']
  type: IntegrationType
}

export interface MutationReassignWorkerSubcontractorsArgs {
  subcontractorIds: Array<Scalars['String']>
  workerId: Scalars['String']
}

export interface MutationRegisterAiToolsUsageArgs {
  action: Scalars['String']
  tool: Scalars['String']
}

export interface MutationReinviteAdminUserArgs {
  id: Scalars['String']
}

export interface MutationRejectPermitAdminArgs {
  ids: Array<Scalars['String']>
  input?: InputMaybe<RejectPermitInputAdmin>
  permitId: Scalars['String']
}

export interface MutationRejectPrequalificationArgs {
  id: Scalars['String']
  input?: InputMaybe<UpdatePrequalificationInput>
}

export interface MutationRemoveContactFromProjectArgs {
  contactId: Scalars['String']
  projectId: Scalars['String']
}

export interface MutationRemoveProjectAccessFromAccessControlIntegrationConnectionArgs {
  id: Scalars['String']
  projectId: Scalars['String']
}

export interface MutationRemovePublicChecklistArgs {
  checklistId: Scalars['String']
}

export interface MutationRenameWidgetArgs {
  title: Scalars['String']
  widgetId: Scalars['String']
}

export interface MutationReplaceProjectScheduleEditorAdminArgs {
  adminUserId?: InputMaybe<Scalars['String']>
  projectScheduleId: Scalars['String']
}

export interface MutationRequestAiToolSettingsArgs {
  tool: Scalars['String']
}

export interface MutationResendMultiplePlatformActionEmailsArgs {
  ids: Array<Scalars['String']>
}

export interface MutationResendPlatformActionEmailArgs {
  id: Scalars['String']
}

export interface MutationRestoreAccessProfileTemplateArgs {
  id: Scalars['String']
}

export interface MutationRestoreDocumentArgs {
  id: Scalars['String']
}

export interface MutationRestoreInductionArgs {
  id: Scalars['String']
}

export interface MutationRestoreLibrarySwmsDocAdminArgs {
  id: Scalars['String']
}

export interface MutationRestorePermitTypeAdminArgs {
  id: Scalars['String']
}

export interface MutationRestorePermitWorkerAdminArgs {
  id: Scalars['String']
}

export interface MutationRestorePermitAdminArgs {
  id: Scalars['String']
}

export interface MutationRestorePlatformActionArgs {
  id: Scalars['String']
}

export interface MutationRestorePreStartArgs {
  id: Scalars['String']
}

export interface MutationRestoreProjectScheduleAdminArgs {
  projectScheduleId: Scalars['String']
}

export interface MutationRestoreRegisterArgs {
  id: Scalars['String']
}

export interface MutationRestoreRegisterItemArgs {
  id: Scalars['String']
}

export interface MutationRestoreRegisterItemBookingArgs {
  id: Scalars['String']
}

export interface MutationRestoreScheduleArgs {
  id: Scalars['String']
}

export interface MutationRestoreSignOnArgs {
  id: Scalars['String']
}

export interface MutationRestoreSwmsDocArgs {
  id: Scalars['String']
}

export interface MutationRestoreTemplateArgs {
  id: Scalars['String']
}

export interface MutationRestoreTemplateResponseArgs {
  id: Scalars['String']
}

export interface MutationResumePermitAdminArgs {
  ids: Array<Scalars['String']>
  permitId: Scalars['String']
}

export interface MutationSaArchiveBuilderArgs {
  id: Scalars['String']
}

export interface MutationSaMergeSubcontractorsArgs {
  archiveId: Scalars['String']
  keepId: Scalars['String']
}

export interface MutationSaUpdateBuilderArgs {
  id: Scalars['String']
  input: SaUpdateBuilderInput
}

export interface MutationSaUpdateBuilderModulesArgs {
  id: Scalars['String']
  input: ToggleModuleInput
}

export interface MutationSaveDashboardArgs {
  id: Scalars['String']
  input: DashboardInput
}

export interface MutationSendBulkInductionUpdateEmailsAdminArgs {
  input: SendBulkInductionUpdateEmailsInputAdmin
}

export interface MutationSendDefectsArgs {
  ids: Array<Scalars['String']>
  projectId: Scalars['String']
}

export interface MutationSendFileToBuildxactArgs {
  input: SendFileToBuildxactInput
}

export interface MutationSendFileUploadInviteEmailArgs {
  input: SendFileUploadInviteEmailInput
}

export interface MutationSendInductionInviteEmailArgs {
  input: SendInductionInviteEmailInput
}

export interface MutationSendInductionUpdateEmailArgs {
  input: SendInductionUpdateEmailInput
}

export interface MutationSendPendingDefectsArgs {
  ids: Array<Scalars['String']>
  projectId: Scalars['String']
}

export interface MutationSendProjectSmsArgs {
  input?: InputMaybe<SendProjectSmsInput>
}

export interface MutationSendRequestForPrequalificationArgs {
  subcontractorId: Scalars['String']
}

export interface MutationSendRequestUpdateEmailArgs {
  input: SendRequestUpdateEmailInput
}

export interface MutationSendScheduleNotificationsAdminArgs {
  input: Array<ScheduleNotificationInputAdmin>
  preferSms?: InputMaybe<Scalars['Boolean']>
  projectScheduleId: Scalars['String']
}

export interface MutationSendStaffInviteEmailsArgs {
  input: SendStaffInviteEmailInput
}

export interface MutationSendTestWelcomeEmailsArgs {
  input: SendTestWelcomeEmailInput
}

export interface MutationSendWelcomeEmailsArgs {
  input: SendWelcomeEmailInput
}

export interface MutationSetPremierCompanyAsPrimaryArgs {
  input: SetPremierCompanyAsPrimaryInput
}

export interface MutationSetProjectSiteTimingsArgs {
  id: Scalars['String']
  input: SetProjectTimingsInput
}

export interface MutationSetupBuildxactAccessTokenArgs {
  input: SetupBuildxactAccessTokenInput
}

export interface MutationSignOffArgs {
  input?: InputMaybe<SignOffInput>
}

export interface MutationStartPermitAdminArgs {
  ids: Array<Scalars['String']>
  input?: InputMaybe<StartPermitInputAdmin>
  permitId: Scalars['String']
}

export interface MutationStartPermitWorkerArgs {
  id: Scalars['String']
  input?: InputMaybe<StartPermitInputWorker>
}

export interface MutationSubmitRegisterItemReviewArgs {
  id: Scalars['String']
  input: SubmitRegisterItemReviewInput
}

export interface MutationSubmitSwmsTemplateResponseArgs {
  input: SubmitSwmsTemplateResponseInput
}

export interface MutationSuspendPermitAdminArgs {
  ids: Array<Scalars['String']>
  input?: InputMaybe<SuspendPermitInputAdmin>
  permitId: Scalars['String']
}

export interface MutationSwitchBuilderArgs {
  orgId: Scalars['String']
}

export interface MutationSwitchSuperAdminBuilderArgs {
  builderId: Scalars['String']
}

export interface MutationSyncAgaveProjectsArgs {
  input: SyncAgaveProjectsInput
}

export interface MutationSyncAgaveVendorsArgs {
  input: SyncAgaveVendorsInput
}

export interface MutationSyncBuilderWithDataPipelineArgs {
  builderId: Scalars['String']
}

export interface MutationSyncIntegrationConnectionArgs {
  id: Scalars['String']
}

export interface MutationSyncIntegrationConnectionsArgs {
  ids: Array<Scalars['String']>
}

export interface MutationSyncIntegrationToProjectsArgs {
  integrationType: IntegrationType
}

export interface MutationSyncSiteAttendanceToProcoreArgs {
  id: Scalars['String']
}

export interface MutationSyncWorkerAccessControlManualArgs {
  projectId?: InputMaybe<Scalars['String']>
  workerId: Scalars['String']
}

export interface MutationToggleFavouriteDashboardArgs {
  id: Scalars['String']
  isFavourited: Scalars['Boolean']
}

export interface MutationTogglePrimaryContactArgs {
  contactId: Scalars['String']
}

export interface MutationTransferFileToAgaveArgs {
  input: TransferFileToAgaveInput
}

export interface MutationTransferPermitTypeAdminArgs {
  builderId: Scalars['String']
  permitType: TransferPermitTypeInputAdmin
}

export interface MutationTransferTemplateArgs {
  builderId: Scalars['String']
  id: Scalars['String']
  name: Scalars['String']
}

export interface MutationTransferTemplatesArgs {
  builderId: Scalars['String']
  templates: Array<TransferTemplateInput>
}

export interface MutationUnarchiveAdminUserArgs {
  id: Scalars['String']
}

export interface MutationUnassignSubcontractorsFromProjectArgs {
  id: Scalars['String']
  subcontractorIds: Array<Scalars['String']>
}

export interface MutationUpdateAccessControlForWorkerArgs {
  id: Scalars['String']
  input: UpdateAccessControlForWorkerInput
}

export interface MutationUpdateAccessControlIntegrationConnectionArgs {
  id: Scalars['String']
  input: UpdateAccessControlIntegrationConnectionInput
}

export interface MutationUpdateAccessProfileArgs {
  id: Scalars['String']
  input: AccessProfileInput
}

export interface MutationUpdateAccessProfileTemplateArgs {
  id: Scalars['String']
  input: AccessProfileTemplateInput
  overrideOlderAccessProfiles?: InputMaybe<Scalars['Boolean']>
}

export interface MutationUpdateAdminUserArgs {
  id: Scalars['String']
  input: UpdateAdminUserInput
}

export interface MutationUpdateAdminUserRolesArgs {
  id: Scalars['String']
  roleIds: Array<InputMaybe<Scalars['String']>>
}

export interface MutationUpdateAiToolsSettingsArgs {
  input: UpdateAiToolsSettingsInput
}

export interface MutationUpdateAttachmentInfoArgs {
  id: Scalars['String']
  input: UpdateAttachmentInfoInput
}

export interface MutationUpdateBuilderArgs {
  id: Scalars['String']
  input: UpdateBuilderInput
}

export interface MutationUpdateBuilderMetadataArgs {
  input: UpdateBuilderMetadataInput
}

export interface MutationUpdateBuilderQuestionnaireArgs {
  input: UpdateBuilderQuestionnaireInput
}

export interface MutationUpdateBuilderRegisterSettingsArgs {
  input: UpdateBuilderRegisterSettingsInput
}

export interface MutationUpdateBuilderSettingsArgs {
  builderId?: InputMaybe<Scalars['String']>
  input: UpdateBuilderSettingsInput
}

export interface MutationUpdateBuilderSubcontractorArgs {
  input?: InputMaybe<UpdateBuilderSubcontractorInput>
}

export interface MutationUpdateBuilderSubcontractorDataArgs {
  input: UpdateBuilderSubcontractorDataInput
}

export interface MutationUpdateBuilderWorkerDocumentArgs {
  id: Scalars['String']
  input: UpdateBuilderWorkerDocumentInput
}

export interface MutationUpdateChecklistSettingsArgs {
  input: UpdateChecklistSettingInput
}

export interface MutationUpdateCommunicationSettingsArgs {
  input: UpdateCommunicationSettingsInput
}

export interface MutationUpdateContactArgs {
  contactId: Scalars['String']
  input: ContactInput
}

export interface MutationUpdateDefectArgs {
  id: Scalars['String']
  input: UpdateDefectInput
}

export interface MutationUpdateDefectSettingsArgs {
  input: UpdateDefectSettingsInput
}

export interface MutationUpdateDefectStatusArgs {
  id: Scalars['String']
  status: DefectStatus
}

export interface MutationUpdateDefectViaResourceLinkArgs {
  defectId: Scalars['String']
  input: UpdateResourceLinkDefectInput
  resourceLinkSlug: Scalars['String']
}

export interface MutationUpdateDefectsAssigneesArgs {
  assignees?: InputMaybe<Array<AssigneeInput>>
  ids: Array<Scalars['String']>
}

export interface MutationUpdateDefectsDueDateArgs {
  dueDate: Scalars['DateTime']
  ids: Array<Scalars['String']>
}

export interface MutationUpdateDefectsStatusArgs {
  ids: Array<Scalars['String']>
  status: DefectStatus
}

export interface MutationUpdateDocumentArgs {
  id: Scalars['String']
  input: UpdateDocumentInput
}

export interface MutationUpdateDocumentFolderArgs {
  id: Scalars['String']
  input: UpdateDocumentFolderInput
}

export interface MutationUpdateDocumentSignaturesArgs {
  input: UpdateDocumentSignaturesInput
}

export interface MutationUpdateDrawingAdminArgs {
  id: Scalars['String']
  input: UpdateDrawingInputAdmin
}

export interface MutationUpdateEmergencyArgs {
  id: Scalars['String']
  input: UpdateEmergencyInput
}

export interface MutationUpdateEmergencyMessageArgs {
  id: Scalars['String']
  input: UpdateEmergencyMessageInput
}

export interface MutationUpdateEmergencyMessageAsWorkerArgs {
  id: Scalars['String']
  input: UpdateEmergencyMessageAsWorkerInput
}

export interface MutationUpdateGallerySettingsArgs {
  input: UpdateGallerySettingsInput
}

export interface MutationUpdateGlobalSettingsArgs {
  input: UpdateGlobalSettingsInput
}

export interface MutationUpdateHoursBudgetSettingsArgs {
  input: UpdateHoursBudgetSettingsInput
  projectId: Scalars['String']
}

export interface MutationUpdateInductionArgs {
  input: UpdateInductionInput
}

export interface MutationUpdateInductionSettingsArgs {
  input: UpdateInductionSettingInput
}

export interface MutationUpdateInsuranceDocArgs {
  id: Scalars['String']
  input: UpdateInsuranceDocInput
}

export interface MutationUpdateLibrarySwmsDocReviewAdminArgs {
  id: Scalars['String']
  input?: InputMaybe<UpdateLibrarySwmsDocReviewInputAdmin>
}

export interface MutationUpdateLibrarySwmsDocAdminArgs {
  id: Scalars['String']
  input?: InputMaybe<UpdateLibrarySwmsDocInputAdmin>
}

export interface MutationUpdateLibraryTemplateArgs {
  id: Scalars['String']
  input: UpdateLibraryTemplateInput
}

export interface MutationUpdateMsdsDocArgs {
  id: Scalars['String']
  input: UpdateMsdsDocInput
}

export interface MutationUpdateMyDefectArgs {
  id: Scalars['String']
  input: UpdateMyDefectInput
}

export interface MutationUpdatePermitTemplateResponseAdminArgs {
  permitId: Scalars['String']
  responseData: Scalars['JSON']
  templateResponseId: Scalars['String']
  type: PermitTypeTemplate
}

export interface MutationUpdatePermitTypeAdminArgs {
  id: Scalars['String']
  input: UpdatePermitTypeInputAdmin
}

export interface MutationUpdatePermitWorkerTemplateResponseAdminArgs {
  permitWorkerId: Scalars['String']
  responseData: Scalars['JSON']
  templateResponseId: Scalars['String']
  type: PermitTypeTemplate
}

export interface MutationUpdatePermitWorkerTemplateResponseWorkerArgs {
  id: Scalars['String']
  responseData: Scalars['JSON']
}

export interface MutationUpdatePermitAdminArgs {
  id: Scalars['String']
  input: UpdatePermitInputAdmin
}

export interface MutationUpdatePermitWorkerArgs {
  id: Scalars['String']
  input: UpdatePermitInputWorker
  projectId: Scalars['String']
}

export interface MutationUpdatePlatformActionArgs {
  id: Scalars['String']
  input: UpdatePlatformActionInput
}

export interface MutationUpdatePlatformActionSettingsArgs {
  input: UpdatePlatformActionSettingInput
}

export interface MutationUpdatePlatformActionWorkerArgs {
  id: Scalars['String']
  input: UpdatePlatformActionInputWorker
}

export interface MutationUpdatePlatformActionsStatusArgs {
  ids: Array<Scalars['String']>
  status: PlatformActionStatus
}

export interface MutationUpdatePreStartArgs {
  id: Scalars['String']
  input: UpdatePreStartInput
}

export interface MutationUpdatePremierSettingsArgs {
  input: UpdatePremierSettingInput
}

export interface MutationUpdatePrequalificationSettingsArgs {
  input: UpdatePrequalificationSettingsInput
}

export interface MutationUpdatePrequalificationViaResourceLinkArgs {
  input: UpdateResourceLinkPrequalificationInput
  prequalificationId: Scalars['String']
  resourceLinkSlug: Scalars['String']
  subcontractorId: Scalars['String']
}

export interface MutationUpdateProcoreSettingsArgs {
  input: UpdateProcoreSettingInput
}

export interface MutationUpdateProjectArgs {
  id: Scalars['String']
  input: UpdateProjectInput
}

export interface MutationUpdateProjectAccessForAccessControlIntegrationConnectionArgs {
  access: AccessControlAccess
  id: Scalars['String']
  projectId: Scalars['String']
}

export interface MutationUpdateProjectLocationArgs {
  id: Scalars['String']
  input: UpdateProjectLocationInput
}

export interface MutationUpdateProjectScheduleItemStatusAdminArgs {
  projectScheduleItemId: Scalars['String']
  status: ProjectScheduleItemStatus
}

export interface MutationUpdateProjectScheduleAdminArgs {
  input: UpdateProjectScheduleInputAdmin
  projectScheduleId: Scalars['String']
}

export interface MutationUpdateProjectSpecificInductionSettingsArgs {
  input: UpdateProjectSpecificInductionSettingInput
  projectId: Scalars['String']
}

export interface MutationUpdateProjectSpecificPermitSettingsArgs {
  input: UpdateProjectSpecificPermitSettingsInput
  projectId: Scalars['String']
}

export interface MutationUpdateProjectSpecificProcoreSettingsArgs {
  input: UpdateProjectSpecificProcoreSettingInput
  projectId: Scalars['String']
}

export interface MutationUpdateProjectSpecificSettingsArgs {
  id: Scalars['String']
  input: UpdateProjectSpecificSettingsInput
}

export interface MutationUpdateProjectSpecificSiteDiarySettingsArgs {
  input: UpdateProjectSpecificSiteDiarySettingsInput
  projectId: Scalars['String']
}

export interface MutationUpdateProjectSubcontractorsArgs {
  id: Scalars['String']
  input: UpdateProjectSubcontractorsInput
}

export interface MutationUpdatePublicPlatformActionViaChecklistResourceLinkArgs {
  id: Scalars['String']
  input: UpdatePublicPlatformActionViaChecklistResourceLinkInput
}

export interface MutationUpdatePublicSubcontractorPlatformActionArgs {
  input: UpdatePublicSubcontractorPlatformActionInput
  platformActionId: Scalars['String']
  subcontractorId: Scalars['String']
}

export interface MutationUpdatePublicTemplateResponseArgs {
  id: Scalars['String']
  input: UpdatePublicTemplateResponseInput
}

export interface MutationUpdateRegisterArgs {
  id: Scalars['String']
  input: UpdateRegisterInput
}

export interface MutationUpdateRegisterItemArgs {
  id: Scalars['String']
  input: UpdateRegisterItemInput
}

export interface MutationUpdateRegisterItemBookingArgs {
  id: Scalars['String']
  input: UpdateRegisterItemBookingInput
}

export interface MutationUpdateRegisterItemTypeArgs {
  id: Scalars['String']
  input: UpdateRegisterItemTypeInput
}

export interface MutationUpdateResourceLinkArgs {
  id: Scalars['String']
  input: UpdateResourceLinkInput
}

export interface MutationUpdateResourceTagsAdminArgs {
  resourceId: Scalars['String']
  resourceType: ResourceTagResourceTypeAdmin
  tags: Array<InputMaybe<Scalars['String']>>
}

export interface MutationUpdateRolePermissionsArgs {
  id: Scalars['String']
  input: UpdateRolePermissionsInput
}

export interface MutationUpdateSwmsSettingsArgs {
  input: UpdateSwmsSettingInput
}

export interface MutationUpdateScheduleArgs {
  id: Scalars['String']
  input: UpdateScheduleInput
}

export interface MutationUpdateSignOnContextMetadataArgs {
  input: UpdateSignOnContextMetadataInput
}

export interface MutationUpdateSignOnSettingsArgs {
  input: UpdateSignOnSettingInput
}

export interface MutationUpdateSiteDiaryArgs {
  id: Scalars['String']
  input: UpdateSiteDiaryInput
}

export interface MutationUpdateStylingSettingsArgs {
  input: UpdateStylingSettingsInput
}

export interface MutationUpdateSubcontractorArgs {
  id: Scalars['String']
  input: UpdateSubcontractorInput
}

export interface MutationUpdateSubcontractorDetailsArgs {
  id: Scalars['String']
  input: UpdateSubcontractorDetailsInput
}

export interface MutationUpdateSubcontractorSettingsArgs {
  input: UpdateSubcontractorSettingInput
}

export interface MutationUpdateSwmsDocArgs {
  id: Scalars['String']
  input?: InputMaybe<UpdateSwmsDocInput>
}

export interface MutationUpdateSwmsTemplateArgs {
  input?: InputMaybe<UpdateSwmsTemplateInput>
}

export interface MutationUpdateSwmsTemplateResponseArgs {
  input: UpdateSwmsTemplateResponseInput
}

export interface MutationUpdateTemplateArgs {
  id: Scalars['String']
  input: UpdateTemplateInput
}

export interface MutationUpdateTemplateResponseArgs {
  id: Scalars['String']
  input: UpdateTemplateResponseInput
}

export interface MutationUpdateTemplateResponseAsWorkerArgs {
  input: UpdateTemplateResponseAsWorkerInput
}

export interface MutationUpdateTemplateResponseRelatedRegisterItemArgs {
  id: Scalars['String']
  registerItemId?: InputMaybe<Scalars['String']>
}

export interface MutationUpdateTicketArgs {
  id: Scalars['String']
  input?: InputMaybe<UpdateTicketInput>
}

export interface MutationUpdateTicketv2Args {
  id: Scalars['String']
  input?: InputMaybe<UpdateTicketInputV2>
}

export interface MutationUpdateTimesheetEntriesArgs {
  input: UpdateTimesheetsInputs
}

export interface MutationUpdateTimesheetEntryArgs {
  id: Scalars['String']
  input: UpdateTimesheetInput
}

export interface MutationUpdateTimesheetSettingsArgs {
  input: UpdateTimesheetSettingInput
}

export interface MutationUpdateTimesheetsStatusArgs {
  ids: Array<Scalars['String']>
  status: TimesheetEntryStatus
}

export interface MutationUpdateToolboxArgs {
  id: Scalars['String']
  input: UpdateToolboxInput
}

export interface MutationUpdateUserArgs {
  input: UpdateUserInput
}

export interface MutationUpdateUserSettingsArgs {
  input: UpdateUserSettings
}

export interface MutationUpdateWidgetSettingsArgs {
  settings: WidgetReportingSettingsInput
  widgetId: Scalars['String']
}

export interface MutationUpdateWorkerArgs {
  input: UpdateWorkerInput
}

export interface MutationUpdateWorkerMetadataArgs {
  id: Scalars['String']
  input: UpdateWorkerMetadataInput
}

export interface MutationUpdateWorkerUserAdminArgs {
  input: UpdateUserInput
  workerId: Scalars['String']
}

export interface MutationUpdateWorkerWithUserArgs {
  input: UpdateWorkerUserInput
}

export interface MutationUpdateWorkflowArgs {
  id: Scalars['String']
  workflow: WorkflowInput
}

export interface MutationUploadFilesArgs {
  companyAttachmentIds?: InputMaybe<Array<Scalars['String']>>
  fileUploadInviteId: Scalars['String']
  files: Array<FileInput>
  replyTo?: InputMaybe<Scalars['String']>
}

export interface MutationUpsertProcoreConfigArgs {
  input?: InputMaybe<UpsertProcoreConfigInput>
}

export interface MutationUpsertProcoreDailyLogsArgs {
  input?: InputMaybe<UpsertProcoreDailyLogsInput>
}

export interface MyTimesheetEntryFilterInput {
  afterDateTime: Scalars['DateTime']
  beforeDateTime: Scalars['DateTime']
  projectId: Scalars['String']
}

export enum Orientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
}

export enum OverallPermitStatus {
  Active = 'ACTIVE',
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  Paused = 'PAUSED',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED',
  WaitingCloseoutReview = 'WAITING_CLOSEOUT_REVIEW',
  WaitingReview = 'WAITING_REVIEW',
}

export interface PdfGenerationInput {
  callbackInfo?: InputMaybe<CallbackInfo>
  includeAppendix?: InputMaybe<Scalars['Boolean']>
  margin?: InputMaybe<Scalars['String']>
  orientation?: InputMaybe<Orientation>
  resourceAppendUrl?: InputMaybe<Scalars['String']>
  resourceAppendUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  resourceId: Scalars['String']
  timezone?: InputMaybe<Scalars['String']>
  type: PdfType
}

export interface PdfResponse {
  __typename?: 'PDFResponse'
  key?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
  viewUrl?: Maybe<Scalars['String']>
}

export enum PdfType {
  CompanyInduction = 'COMPANY_INDUCTION',
  Defects = 'DEFECTS',
  Permit = 'PERMIT',
  PreStart = 'PRE_START',
  ProjectSignOnPoster = 'PROJECT_SIGN_ON_POSTER',
  RegisterItem = 'REGISTER_ITEM',
  SignOns = 'SIGN_ONS',
  SiteDiary = 'SITE_DIARY',
  SiteInduction = 'SITE_INDUCTION',
  Swms = 'SWMS',
  TemplateCapture = 'TEMPLATE_CAPTURE',
  TemplateResponseDisplay = 'TEMPLATE_RESPONSE_DISPLAY',
  Toolbox = 'TOOLBOX',
}

export interface PaginationAggregation extends PaginationStructure {
  __typename?: 'PaginationAggregation'
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  totalCount?: Maybe<Scalars['Int']>
  totalPages?: Maybe<Scalars['Int']>
}

export interface PaginationInput {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export interface PaginationStructure {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  totalCount?: Maybe<Scalars['Int']>
  totalPages?: Maybe<Scalars['Int']>
}

export enum PdfWorkflowType {
  SendPdf = 'SEND_PDF',
  SendUpdate = 'SEND_UPDATE',
}

export interface PerformanceIndicator {
  __typename?: 'PerformanceIndicator'
  name: Scalars['String']
  percentage: Scalars['Float']
  progress: Scalars['Int']
  status: PerformanceIndicatorStatus
  target: Scalars['Int']
}

export enum PerformanceIndicatorStatus {
  Behind = 'BEHIND',
  Complete = 'COMPLETE',
  NotStarted = 'NOT_STARTED',
  OnTrack = 'ON_TRACK',
}

export interface Permission {
  __typename?: 'Permission'
  action: PermissionAction
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  resource: Scalars['String']
  roles: Array<Role>
  updatedAt: Scalars['DateTime']
}

export enum PermissionAction {
  Archive = 'ARCHIVE',
  Create = 'CREATE',
  Update = 'UPDATE',
  View = 'VIEW',
}

export interface PermissionInput {
  action: PermissionAction
  allowed: Scalars['Boolean']
  resource: Scalars['String']
}

export interface Permit {
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  endDate: Scalars['DateTime']
  id: Scalars['String']
  identifier: Scalars['Int']
  name?: Maybe<Scalars['String']>
  startDate: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export enum PermitActiveStatus {
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Paused = 'PAUSED',
}

export interface PermitFilterInput {
  activeStatus?: InputMaybe<Array<InputMaybe<PermitActiveStatus>>>
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  permitTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  projectId?: InputMaybe<Scalars['String']>
  projectLocationId?: InputMaybe<Scalars['String']>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InputMaybe<PermitStatus>>>
  workers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface PermitSortInput {
  created?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  startDate?: InputMaybe<SortOrder>
}

export enum PermitStatus {
  Approved = 'APPROVED',
  Closed = 'CLOSED',
  Rejected = 'REJECTED',
  WaitingCloseoutReview = 'WAITING_CLOSEOUT_REVIEW',
  WaitingReview = 'WAITING_REVIEW',
}

export interface PermitType {
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  identifierPrefix: Scalars['String']
  maxDays?: Maybe<Scalars['Int']>
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export interface PermitTypeFilterInputAdmin {
  archivedFilter?: InputMaybe<ArchivedFilter>
  searchString?: InputMaybe<Scalars['String']>
}

export interface PermitTypeSortInputAdmin {
  createdAt?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

export enum PermitTypeTemplate {
  Application = 'APPLICATION',
  Closeout = 'CLOSEOUT',
  Enacting = 'ENACTING',
}

export interface PermitTypeAdmin extends PermitType {
  __typename?: 'PermitType_Admin'
  applicationTemplate?: Maybe<Template>
  applicationTemplateId?: Maybe<Scalars['String']>
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  builderId: Scalars['String']
  closeoutTemplate?: Maybe<Template>
  closeoutTemplateId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  enactingTemplate?: Maybe<Template>
  enactingTemplateId?: Maybe<Scalars['String']>
  id: Scalars['String']
  identifierPrefix: Scalars['String']
  maxDays?: Maybe<Scalars['Int']>
  name: Scalars['String']
  permits: Array<Permit>
  updatedAt: Scalars['DateTime']
}

export interface PermitTypeResourceLink {
  __typename?: 'PermitType_ResourceLink'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  identifierPrefix: Scalars['String']
  maxDays?: Maybe<Scalars['Int']>
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export interface PermitTypeWorker extends PermitType {
  __typename?: 'PermitType_Worker'
  applicationTemplate?: Maybe<TemplateEntity>
  archivedAt?: Maybe<Scalars['DateTime']>
  closeoutTemplate?: Maybe<TemplateEntity>
  createdAt: Scalars['DateTime']
  enactingTemplate?: Maybe<TemplateEntity>
  id: Scalars['String']
  identifierPrefix: Scalars['String']
  maxDays?: Maybe<Scalars['Int']>
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export interface PermitWorkerPaginationLinks {
  __typename?: 'PermitWorkerPaginationLinks'
  next?: Maybe<PermitWorkerAdmin>
  previous?: Maybe<PermitWorkerAdmin>
}

export interface PermitWorkerAdmin {
  __typename?: 'PermitWorker_Admin'
  activeStatus: PermitActiveStatus
  applicationTemplateResponse?: Maybe<TemplateResponse>
  applicationTemplateResponseId?: Maybe<Scalars['String']>
  approvedAt?: Maybe<Scalars['DateTime']>
  archivedAt?: Maybe<Scalars['DateTime']>
  closedOutAt?: Maybe<Scalars['DateTime']>
  closeoutTemplateResponse?: Maybe<TemplateResponse>
  closeoutTemplateResponseId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  enactingTemplateResponses?: Maybe<Array<TemplateResponse>>
  id: Scalars['String']
  overallStatus: OverallPermitStatus
  paginationLinks?: Maybe<PermitWorkerPaginationLinks>
  status: PermitStatus
  suspendedAt?: Maybe<Scalars['DateTime']>
  updatedAt: Scalars['DateTime']
  worker?: Maybe<Worker>
  workerId: Scalars['String']
}

export interface PermitWorkerResourceLink {
  __typename?: 'PermitWorker_ResourceLink'
  applicationTemplateResponse?: Maybe<TemplateResponseResourceLink>
  applicationTemplateResponseId?: Maybe<Scalars['String']>
  closeoutTemplateResponse?: Maybe<TemplateResponseResourceLink>
  closeoutTemplateResponseId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  enactingTemplateResponses?: Maybe<Array<TemplateResponseResourceLink>>
  id: Scalars['String']
  overallStatus: OverallPermitStatus
  updatedAt: Scalars['DateTime']
  worker: WorkerResourceLink
}

export interface PermitWorkerWorker {
  __typename?: 'PermitWorker_Worker'
  activeStatus: PermitActiveStatus
  applicationTemplateResponse?: Maybe<TemplateResponse>
  applicationTemplateResponseId?: Maybe<Scalars['String']>
  approvedAt?: Maybe<Scalars['DateTime']>
  archivedAt?: Maybe<Scalars['DateTime']>
  closedOutAt?: Maybe<Scalars['DateTime']>
  closeoutTemplateResponse?: Maybe<TemplateResponse>
  closeoutTemplateResponseId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  enactingTemplateResponses?: Maybe<Array<TemplateResponse>>
  id: Scalars['String']
  overallStatus: OverallPermitStatus
  status: PermitStatus
  suspendedAt?: Maybe<Scalars['DateTime']>
  updatedAt: Scalars['DateTime']
  worker: Worker
  workerId: Scalars['String']
}

export interface PermitAdmin extends Permit {
  __typename?: 'Permit_Admin'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  builderId: Scalars['String']
  conversation?: Maybe<ConversationThread>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Assignee>
  description?: Maybe<Scalars['String']>
  endDate: Scalars['DateTime']
  id: Scalars['String']
  identifier: Scalars['Int']
  name?: Maybe<Scalars['String']>
  overallStatus: OverallPermitStatus
  permitType: PermitTypeAdmin
  permitTypeId: Scalars['String']
  project: Project
  projectId: Scalars['String']
  projectLocation?: Maybe<ProjectLocation>
  projectLocationId?: Maybe<Scalars['String']>
  startDate: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  workers?: Maybe<Array<PermitWorkerAdmin>>
}

export interface PermitResourceLink {
  __typename?: 'Permit_ResourceLink'
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  endDate: Scalars['DateTime']
  id: Scalars['String']
  name: Scalars['String']
  overallStatus: OverallPermitStatus
  permitType: PermitTypeResourceLink
  project: ProjectResourceLink
  startDate: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  workers?: Maybe<Array<PermitWorkerResourceLink>>
}

export interface PermitWorker extends Permit {
  __typename?: 'Permit_Worker'
  conversation?: Maybe<ConversationThreadResourceLink>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  endDate: Scalars['DateTime']
  id: Scalars['String']
  identifier: Scalars['Int']
  name?: Maybe<Scalars['String']>
  overallStatus: OverallPermitStatus
  permitType: PermitTypeWorker
  permitTypeId: Scalars['String']
  permitWorker: PermitWorkerWorker
  permitWorkers: Array<PermitWorkerWorker>
  project: ProjectResourceLink
  projectId: Scalars['String']
  projectLocation?: Maybe<ProjectLocationResourceLink>
  startDate: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export interface PlatformAction {
  __typename?: 'PlatformAction'
  archivedAt?: Maybe<Scalars['DateTime']>
  assignees: Array<Maybe<Assignee>>
  attachments?: Maybe<Array<Maybe<Attachment>>>
  builder: Builder
  builderId: Scalars['String']
  completedAt?: Maybe<Scalars['DateTime']>
  config?: Maybe<PlatformActionConfig>
  conversation?: Maybe<ConversationThread>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  isOwner?: Maybe<Scalars['Boolean']>
  locationId?: Maybe<Scalars['String']>
  /** @deprecated Use priorityType */
  priority: PlatformActionPriority
  priorityType?: Maybe<Scalars['String']>
  project?: Maybe<Project>
  projectId?: Maybe<Scalars['String']>
  remindedAt?: Maybe<Scalars['DateTime']>
  status: PlatformActionStatus
  templateBlockResponseIdentifier?: Maybe<Scalars['String']>
  templateResponse?: Maybe<TemplateResponse>
  templateResponseBlockData?: Maybe<Scalars['JSON']>
  templateResponseId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface PlatformActionAggregateStats {
  __typename?: 'PlatformActionAggregateStats'
  count: Scalars['Int']
  status: PlatformActionStatus
}

export interface PlatformActionConfig {
  __typename?: 'PlatformActionConfig'
  requireAttachmentToClose?: Maybe<Scalars['Boolean']>
}

export interface PlatformActionConfigInput {
  requireAttachmentToClose?: InputMaybe<Scalars['Boolean']>
}

export interface PlatformActionEntity {
  __typename?: 'PlatformActionEntity'
  attachments?: Maybe<Array<Maybe<AttachmentEntity>>>
  builder?: Maybe<BuilderEntityPublic>
  canCloseActions: Scalars['Boolean']
  config?: Maybe<PlatformActionConfig>
  conversation?: Maybe<ConversationThreadEntity>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  location?: Maybe<ProjectLocationResourceLink>
  /** @deprecated Use priorityType */
  priority: PlatformActionPriority
  priorityType?: Maybe<Scalars['String']>
  project?: Maybe<ProjectEntity>
  status: PlatformActionStatus
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface PlatformActionFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  assignees?: InputMaybe<Array<InputMaybe<AssigneeInput>>>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  ids?: InputMaybe<Array<Scalars['String']>>
  includeSublocations?: InputMaybe<Scalars['Boolean']>
  overdue?: InputMaybe<Scalars['Boolean']>
  priority?: InputMaybe<Array<InputMaybe<PlatformActionPriority>>>
  priorityType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  projectId?: InputMaybe<Scalars['String']>
  projectLocationId?: InputMaybe<Scalars['String']>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InputMaybe<PlatformActionStatus>>>
  type?: InputMaybe<Array<Scalars['String']>>
}

export enum PlatformActionPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export interface PlatformActionPriorityType {
  __typename?: 'PlatformActionPriorityType'
  colour?: Maybe<Scalars['String']>
  icon?: Maybe<Scalars['String']>
  id: Scalars['String']
  label: Scalars['String']
}

export interface PlatformActionPriorityTypeInput {
  colour?: InputMaybe<Scalars['String']>
  icon?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  label: Scalars['String']
}

export interface PlatformActionSettings {
  __typename?: 'PlatformActionSettings'
  /** Whether or not automatic reminders are enabled for actions due soon */
  actionsDueSoonReminder: Scalars['Boolean']
  /** Which admin users to send notifications to if any actions are due soon */
  actionsDueSoonReminderAdminUsers?: Maybe<Array<Scalars['String']>>
  /** How many days before the due date of an action should reminders be sent */
  actionsDueSoonReminderDays: Scalars['Int']
  /** Frequency in days of how often automatic reminders are sent for actions due soon */
  actionsDueSoonReminderFrequency: Scalars['Int']
  /** Whether or not subcontractors can close actions themselves */
  allowSubcontractorsToCloseActions: Scalars['Boolean']
  /** Whether or not automatic reminders are enabled for overdue actions */
  overdueActionsReminder: Scalars['Boolean']
  /** Which admin users to send notifications to if any actions are overdue */
  overdueActionsReminderAdminUsers?: Maybe<Array<Scalars['String']>>
  /** Frequency in days of how often automatic reminders are sent for overdue actions */
  overdueActionsReminderFrequency: Scalars['Int']
  /** Customisable list of priorities that can be used on platform actions */
  priorities: Array<PlatformActionPriorityType>
  /** Returns how many days before an action is due that reminders can be sent */
  sendReminderDays: Scalars['Int']
  /** Whether or not reminders can be manually triggered via the actions list */
  sendReminderEnabled: Scalars['Boolean']
  /** Customisable list of types that can be used on platform actions */
  types: Array<PlatformActionType>
}

export interface PlatformActionSortInput {
  dueDate?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export enum PlatformActionStatus {
  CantDo = 'CANT_DO',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  ToDo = 'TO_DO',
  WaitingReview = 'WAITING_REVIEW',
}

export interface PlatformActionType {
  __typename?: 'PlatformActionType'
  colour?: Maybe<Scalars['String']>
  icon?: Maybe<Scalars['String']>
  id: Scalars['String']
  label: Scalars['String']
}

export interface PlatformActionTypeInput {
  colour?: InputMaybe<Scalars['String']>
  icon?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  label: Scalars['String']
}

export interface PlatformActionResourceLink {
  __typename?: 'PlatformAction_ResourceLink'
  archivedAt?: Maybe<Scalars['DateTime']>
  attachments?: Maybe<Array<Maybe<AttachmentResourceLink>>>
  config?: Maybe<PlatformActionConfig>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  /** @deprecated Use priorityType */
  priority: PlatformActionPriority
  priorityType?: Maybe<Scalars['String']>
  project?: Maybe<ProjectResourceLink>
  status: PlatformActionStatus
  templateBlockResponseIdentifier?: Maybe<Scalars['String']>
  templateResponse?: Maybe<TemplateResponseResourceLink>
  templateResponseBlockData?: Maybe<Scalars['JSON']>
  templateResponseId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface PlatformActionWorker {
  __typename?: 'PlatformAction_Worker'
  attachments?: Maybe<Array<Maybe<AttachmentEntity>>>
  canCloseActions: Scalars['Boolean']
  config?: Maybe<PlatformActionConfig>
  conversation?: Maybe<ConversationThreadEntity>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  location?: Maybe<ProjectLocationResourceLink>
  priorityType?: Maybe<Scalars['String']>
  project?: Maybe<ProjectEntity>
  status: PlatformActionStatus
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface PlatformAggregationReport {
  __typename?: 'PlatformAggregationReport'
  historicalPlatformUsage?: Maybe<Array<Maybe<HistoricPlatformUsage>>>
  newAdminUsers: Scalars['Int']
  newAudits: Scalars['Int']
  newBuilders?: Maybe<Scalars['Int']>
  newDefects: Scalars['Int']
  newProjects: Scalars['Int']
  newSubcontractors: Scalars['Int']
  newUsers: Scalars['Int']
  newWorkers: Scalars['Int']
  totalAdminUserActions: Scalars['Int']
  totalAdminUsers: Scalars['Int']
  totalAudits: Scalars['Int']
  totalBuilders?: Maybe<Scalars['Int']>
  totalDefects: Scalars['Int']
  totalProjects: Scalars['Int']
  totalSubcontractorActions: Scalars['Int']
  totalSubcontractors: Scalars['Int']
  totalUsers: Scalars['Int']
  totalWorkerActions: Scalars['Int']
  totalWorkers: Scalars['Int']
}

export interface PlatformData {
  __typename?: 'PlatformData'
  data?: Maybe<Scalars['JSON']>
}

export interface PlatformEngagementFilterInput {
  adminUserId?: InputMaybe<Scalars['String']>
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  builderId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
}

export interface PlatformEngagementReport {
  __typename?: 'PlatformEngagementReport'
  adminUsers?: Maybe<Array<Maybe<EngagmentAggregation>>>
  builderEngagement?: Maybe<BuilderEngagement>
  builders?: Maybe<Array<Maybe<EngagmentAggregation>>>
  features?: Maybe<Array<Maybe<EngagmentAggregation>>>
  metadata?: Maybe<EngagmentMetadata>
  projects?: Maybe<Array<Maybe<EngagmentAggregation>>>
  totalAuditsPerBuilder?: Maybe<Array<Maybe<EngagmentAggregation>>>
  totalAuditsPerFeature?: Maybe<Array<Maybe<EngagmentAggregation>>>
}

export interface PlatformUsagAggregationFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  builderId?: InputMaybe<Scalars['String']>
}

export interface PlatformUsageReport {
  __typename?: 'PlatformUsageReport'
  SWMS?: Maybe<SwmsUsage>
  actions: Scalars['Int']
  checklistReport?: Maybe<ChecklistUsage>
  checklists: Scalars['Int']
  communications: Scalars['Int']
  defects?: Maybe<DefectsUsage>
  inductions: Scalars['Int']
  insurances: Scalars['Int']
  meta?: Maybe<PlatformUsageReportMeta>
  numberOfVisitors: Scalars['Int']
  preStarts: Scalars['Int']
  signOns?: Maybe<SignOnsUsage>
  siteDiaries?: Maybe<SiteDiaryUsage>
  siteDiariesCount: Scalars['Int']
  subcontractors: Scalars['Int']
  toolboxes: Scalars['Int']
  workers?: Maybe<WorkerUsage>
}

export interface PlatformUsageReportFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
}

export interface PlatformUsageReportMeta {
  __typename?: 'PlatformUsageReportMeta'
  afterDateTime?: Maybe<Scalars['DateTime']>
  beforeDateTime?: Maybe<Scalars['DateTime']>
  projectId?: Maybe<Scalars['String']>
}

export interface PreStart {
  __typename?: 'PreStart'
  acknowledgements?: Maybe<Array<Maybe<Acknowledgement>>>
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  date: Scalars['DateTime']
  endDate?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  project: Project
  projectId: Scalars['String']
  signOns: Array<Maybe<SignOn>>
  template: TemplateResponse
  templateResponseId: Scalars['String']
  toolbox?: Maybe<Toolbox>
  updatedAt: Scalars['DateTime']
}

export interface PreStartResourceLink {
  __typename?: 'PreStart_ResourceLink'
  acknowledgements?: Maybe<Array<Maybe<AcknowledgementResourceLink>>>
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  date: Scalars['DateTime']
  endDate?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  project?: Maybe<ProjectResourceLink>
  projectId: Scalars['String']
  signOns: Array<Maybe<SignOnResourceLink>>
  template?: Maybe<TemplateResponseResourceLink>
  templateResponseId: Scalars['String']
  toolbox?: Maybe<ToolboxResourceLink>
  updatedAt: Scalars['DateTime']
}

export interface PreStartsFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
}

export interface PreStartsSortInput {
  date?: InputMaybe<SortOrder>
}

export interface PremierAccountStatus {
  __typename?: 'PremierAccountStatus'
  connected: Scalars['Boolean']
  setup: Scalars['Boolean']
}

export interface PremierCompany {
  __typename?: 'PremierCompany'
  active: Scalars['Boolean']
  code: Scalars['String']
  id: Scalars['String']
  name: Scalars['String']
}

export interface PremierCompanyInput {
  active: Scalars['Boolean']
  code: Scalars['String']
  id: Scalars['String']
  name: Scalars['String']
}

export interface PremierJob {
  __typename?: 'PremierJob'
  address?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  integrationConnection?: Maybe<IntegrationConnection>
  integrationId: Scalars['String']
  jobUrl?: Maybe<Scalars['String']>
  name: Scalars['String']
  status: Scalars['String']
  subledgerCode?: Maybe<Scalars['String']>
}

export enum PremierProjectField {
  Address = 'ADDRESS',
  Name = 'NAME',
  Status = 'STATUS',
}

/** Premier integration settings for the entire Builder */
export interface PremierSettings {
  __typename?: 'PremierSettings'
  /** Returns true if a notification will be sent to admin users when a new project is synced from Premier */
  notifyForProjects: Scalars['Boolean']
  /** Returns true if a notification will be sent to admin users when a new subcontractor is synced from Premier */
  notifyForSubcontractors: Scalars['Boolean']
  /** Returns which fields will sync from Premier to BuildPass when a project is updated */
  projectFields: Array<PremierProjectField>
  /** Returns which fields will sync from Premier to BuildPass when a subcontractor is updated */
  subcontractorFields: Array<PremierSubcontractorField>
  /** Returns true if new Premier jobs will sync from Premier to BuildPass */
  syncProjects: Scalars['Boolean']
  /** Returns true if Premier subcontractors will sync from Premier to BuildPass as subcontractors */
  syncSubcontractors: Scalars['Boolean']
}

export enum PremierSubcontractorField {
  Abn = 'ABN',
  Address = 'ADDRESS',
  ContactName = 'CONTACT_NAME',
  Email = 'EMAIL',
  Name = 'NAME',
  Phone = 'PHONE',
}

export interface PremierVendor {
  __typename?: 'PremierVendor'
  abn?: Maybe<Scalars['String']>
  address?: Maybe<Scalars['String']>
  businessName: Scalars['String']
  contactName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  id: Scalars['String']
  integrationConnection?: Maybe<IntegrationConnection>
  integrationId: Scalars['String']
  subledgerCode?: Maybe<Scalars['String']>
  vendorUrl?: Maybe<Scalars['String']>
}

export interface Prequalification {
  __typename?: 'Prequalification'
  archivedAt?: Maybe<Scalars['DateTime']>
  builderGenerated?: Maybe<Scalars['Boolean']>
  createdAt: Scalars['DateTime']
  currentVersion: VersionHistory
  id: Scalars['String']
  reviewComments?: Maybe<Scalars['String']>
  status: PrequalificationStatus
  subcontractor: Subcontractor
  templateResponse: TemplateResponse
  updatedAt: Scalars['DateTime']
  versionHistory?: Maybe<Array<VersionHistory>>
}

export interface PrequalificationEnabled {
  __typename?: 'PrequalificationEnabled'
  enabled: Scalars['Boolean']
}

export interface PrequalificationFilterInput {
  archivedFilter?: InputMaybe<ArchivedFilter>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InputMaybe<PrequalificationStatus>>>
  subcontractorIds?: InputMaybe<Array<Scalars['String']>>
}

export interface PrequalificationSettings {
  __typename?: 'PrequalificationSettings'
  /** When a prequalification is submitted, send an email to these admin users */
  notifyAdminUsers?: Maybe<Array<Scalars['String']>>
  /** When a prequalification is approved, send an email to these admin users */
  notifyAdminUsersOnApproval?: Maybe<Array<Scalars['String']>>
}

export interface PrequalificationSortInput {
  date?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export enum PrequalificationStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Sent = 'SENT',
  WaitingReview = 'WAITING_REVIEW',
}

export interface PrequalificationResourceLink {
  __typename?: 'Prequalification_ResourceLink'
  builder: BuilderResourceLink
  id: Scalars['String']
  status: PrequalificationStatus
  subcontractor: SubcontractorResourceLink
  templateResponse: TemplateResponseResourceLink
}

export interface PresignedUrl {
  __typename?: 'PresignedUrl'
  key: Scalars['String']
  url: Scalars['String']
  viewUrl: Scalars['String']
}

export interface PresignedUrlInput {
  filename: Scalars['String']
  filesize: Scalars['String']
  filetype: Scalars['String']
  id: Scalars['String']
  type: DocumentType
}

export interface ProcessedSignOn {
  __typename?: 'ProcessedSignOn'
  id: Scalars['String']
  projectId: Scalars['String']
  signOffTime?: Maybe<Scalars['DateTime']>
  signOnTime: Scalars['DateTime']
  workerId: Scalars['String']
}

export interface ProcessedSignOnFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  workerId?: InputMaybe<Scalars['String']>
}

export interface ProcoreConfig {
  __typename?: 'ProcoreConfig'
  builder: Builder
  builderId: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  isDev: Scalars['Boolean']
  procoreCompanyId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export interface ProcoreDailyLogsConfirmation {
  __typename?: 'ProcoreDailyLogsConfirmation'
  success: Scalars['Boolean']
}

export enum ProcoreProjectField {
  Address = 'ADDRESS',
  Name = 'NAME',
  StartAndEndDate = 'START_AND_END_DATE',
  Status = 'STATUS',
}

export interface ProcoreProjectInput {
  procoreId: Scalars['String']
}

/** Procore integration settings for the entire Builder */
export interface ProcoreSettings {
  __typename?: 'ProcoreSettings'
  /** Returns true if a notification will be sent to admin users when a new project is synced from Procore */
  notifyForProjects: Scalars['Boolean']
  /** Returns true if a notification will be sent to admin users when a new subcontractor is synced from Procore */
  notifyForSubcontractors: Scalars['Boolean']
  /** Returns which fields will sync from Procore to BuildPass when a project is updated */
  projectFields: Array<ProcoreProjectField>
  /** Returns which fields will sync from Procore to BuildPass when a subcontractor is updated */
  subcontractorFields: Array<ProcoreVendorField>
  /** Returns true if BuildPass checklists will be automatically synced to Procore documents in PDF format */
  syncChecklists: Array<Scalars['String']>
  /** Returns true if BuildPass inductions will be automatically synced to Procore documents in PDF format */
  syncInductions: Scalars['Boolean']
  /** Returns true if new Procore projects will sync from Procore to BuildPass */
  syncProjects: Scalars['Boolean']
  /** Returns true if subcontractors attendance will be synced to the Procore daily log for Manpower */
  syncSiteAttendanceToDailyLog_Manpower?: Maybe<Scalars['Boolean']>
  /** Returns true if worker attendance will be synced to the Procore daily log for Timecards */
  syncSiteAttendanceToDailyLog_Timecards?: Maybe<Scalars['Boolean']>
  /** Returns true if BuildPass site diaries will be automatically synced to Procore documents in PDF format */
  syncSiteDiaries: Scalars['Boolean']
  /** Returns true if Procore vendors will sync from Procore to BuildPass as subcontractors */
  syncSubcontractors: Scalars['Boolean']
  /** Returns true if BuildPass SWMS will be automatically synced to Procore documents (via SWMS Builder or otherwise) */
  syncSwms: Scalars['Boolean']
  /** Returns true if BuildPass toolboxes will be automatically synced to Procore documents in PDF format */
  syncToolboxes: Scalars['Boolean']
}

export interface ProcoreSubcontractorConnectInput {
  procoreId: Scalars['String']
  procoreProjectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  subcontractorId: Scalars['String']
}

export interface ProcoreSubcontractorInput {
  procoreId: Scalars['String']
  procoreProjectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export enum ProcoreVendorField {
  Abn = 'ABN',
  Address = 'ADDRESS',
  ContactDetails = 'CONTACT_DETAILS',
  Name = 'NAME',
  ProjectAssignments = 'PROJECT_ASSIGNMENTS',
}

export interface Project {
  __typename?: 'Project'
  accessControlHardware: Array<AccessControlHardware>
  accessControls?: Maybe<Array<AccessControl>>
  address?: Maybe<Scalars['String']>
  builder?: Maybe<Builder>
  builderId?: Maybe<Scalars['String']>
  config?: Maybe<Scalars['JSON']>
  contacts?: Maybe<ProjectContacts>
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  documents?: Maybe<Array<Maybe<Document>>>
  endDate?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  /** @deprecated Use templates instead */
  inductionTemplate?: Maybe<InductionTemplate>
  inductions: Array<Maybe<Induction>>
  inductionsInPastMonth?: Maybe<Scalars['Int']>
  info?: Maybe<Scalars['JSON']>
  integrationConnections: Array<Maybe<IntegrationConnection>>
  language?: Maybe<Scalars['String']>
  latitude?: Maybe<Scalars['Float']>
  locale?: Maybe<SupportedLocaleCountryCode>
  locations?: Maybe<Array<Maybe<ProjectLocation>>>
  longitude?: Maybe<Scalars['Float']>
  name: Scalars['String']
  procoreId?: Maybe<Scalars['String']>
  projectAddress?: Maybe<Address>
  projectAdmins: Array<Maybe<AdminUser>>
  projectContacts?: Maybe<Array<Maybe<Contact>>>
  projectSettings?: Maybe<ProjectSettings>
  publicProjectContacts?: Maybe<Array<Maybe<ContactEntity>>>
  radius?: Maybe<Scalars['Int']>
  requiredTickets: Array<Maybe<TicketTemplateEntity>>
  sdsChecklistTemplate?: Maybe<Template>
  signOns: Array<Maybe<SignOn>>
  signOnsInPastMonth?: Maybe<Scalars['Int']>
  siteTimings?: Maybe<Array<Maybe<ProjectSiteTiming>>>
  startDate?: Maybe<Scalars['DateTime']>
  status: ProjectStatus
  subcontractors: Array<Maybe<Subcontractor>>
  swmsChecklistTemplate?: Maybe<Template>
  tags?: Maybe<Array<Maybe<ResourceTag>>>
  timezone?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface ProjectCompletionByDate {
  __typename?: 'ProjectCompletionByDate'
  completionPercentage: Scalars['Float']
  date: Scalars['Date']
}

export interface ProjectContacts {
  __typename?: 'ProjectContacts'
  hsrName?: Maybe<Scalars['String']>
  hsrNumber?: Maybe<Scalars['String']>
  siteManagerName?: Maybe<Scalars['String']>
  siteManagerNumber?: Maybe<Scalars['String']>
}

export interface ProjectEntity {
  __typename?: 'ProjectEntity'
  builder?: Maybe<BuilderEntityPublic>
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  language?: Maybe<Scalars['String']>
  locale?: Maybe<SupportedLocaleCountryCode>
  name: Scalars['String']
  status: ProjectStatus
  timezone?: Maybe<Scalars['String']>
}

export interface ProjectExists {
  __typename?: 'ProjectExists'
  exists: Scalars['Boolean']
  qrCodeRotationEnabled?: Maybe<Scalars['Boolean']>
  redirectUrl?: Maybe<Scalars['String']>
}

export interface ProjectFilterInput {
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InputMaybe<ProjectStatus>>>
}

export interface ProjectHoursBudgetReport {
  __typename?: 'ProjectHoursBudgetReport'
  completionLastLoggedAt?: Maybe<Scalars['DateTime']>
  lastLoggedCompletionPercentage?: Maybe<Scalars['Int']>
  project: Project
  projectCompletionByDate: Array<ProjectCompletionByDate>
  projectHoursByDate: Array<ProjectHoursByDate>
  status: BudgetStatus
  subcontractors?: Maybe<Array<SubcontractorReport>>
  totalHours: Scalars['Float']
  totalWorkers?: Maybe<Scalars['Int']>
}

export interface ProjectHoursBudgetReportFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId: Scalars['String']
}

export interface ProjectHoursByDate {
  __typename?: 'ProjectHoursByDate'
  date: Scalars['Date']
  projectHours: Scalars['Float']
  signOns: Array<Maybe<SignOnReport>>
}

export interface ProjectInduction extends Induction {
  __typename?: 'ProjectInduction'
  archivedAt?: Maybe<Scalars['DateTime']>
  contextMetadata?: Maybe<ContextMetadata>
  createdAt: Scalars['DateTime']
  currentVersion?: Maybe<VersionHistory>
  documentSignatures: Array<Maybe<DocumentSignature>>
  evidenceSighted?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  identifier?: Maybe<Scalars['Int']>
  /** @deprecated Use templateResponse instead */
  inductionSections?: Maybe<Scalars['JSON']>
  /** @deprecated Use template instead */
  inductionTemplate?: Maybe<InductionTemplate>
  project: Project
  projectId: Scalars['String']
  signatureUrl?: Maybe<Scalars['String']>
  status?: Maybe<InductionStatus>
  subcontractor?: Maybe<Subcontractor>
  subcontractorId?: Maybe<Scalars['String']>
  templateName?: Maybe<Scalars['String']>
  templateResponse?: Maybe<TemplateResponse>
  type: InductionType
  updatedAt: Scalars['DateTime']
  versionHistory?: Maybe<Array<VersionHistory>>
  worker: Worker
  workerId: Scalars['String']
  /** @deprecated Use workerSnapshotFull instead */
  workerSnapshot?: Maybe<Scalars['JSON']>
  workerSnapshotFull?: Maybe<WorkerSnapshot>
}

export interface ProjectInductionPublic {
  __typename?: 'ProjectInduction_Public'
  firstName: Scalars['String']
  lastName: Scalars['String']
  signedOnAt?: Maybe<Scalars['DateTime']>
  status: InductionStatus
  subcontractorId: Scalars['String']
  workerId: Scalars['String']
}

export interface ProjectLocation {
  __typename?: 'ProjectLocation'
  attachments?: Maybe<Array<Attachment>>
  checklistsCount: Scalars['Int']
  children?: Maybe<Array<ProjectLocation>>
  createdAt: Scalars['DateTime']
  defects?: Maybe<Array<Defect>>
  defectsCount: Scalars['Int']
  id: Scalars['String']
  itpsCount: Scalars['Int']
  name: Scalars['String']
  order: Scalars['Int']
  parent?: Maybe<ProjectLocation>
  parentId?: Maybe<Scalars['String']>
  permitsCount: Scalars['Int']
  platformActions?: Maybe<Array<PlatformAction>>
  platformActionsCount: Scalars['Int']
  project: Project
  projectId: Scalars['String']
  templateResponses?: Maybe<Array<TemplateResponse>>
  updatedAt: Scalars['DateTime']
}

export interface ProjectLocationPublic {
  __typename?: 'ProjectLocation_Public'
  children?: Maybe<Array<ProjectLocationPublic>>
  id: Scalars['String']
  name: Scalars['String']
  order: Scalars['Int']
  parent?: Maybe<ProjectLocationPublic>
  parentId?: Maybe<Scalars['String']>
}

export interface ProjectLocationResourceLink {
  __typename?: 'ProjectLocation_ResourceLink'
  createdAt?: Maybe<Scalars['DateTime']>
  fullLocationName: Scalars['String']
  id: Scalars['String']
  name: Scalars['String']
  order?: Maybe<Scalars['Int']>
  parent?: Maybe<ProjectLocationResourceLink>
  parentId?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export interface ProjectPerformance {
  __typename?: 'ProjectPerformance'
  overallStatus: PerformanceIndicatorStatus
  performanceIndicators: Array<PerformanceIndicator>
  projectDetails: Project
}

export interface ProjectScheduleChangeLogAdmin {
  __typename?: 'ProjectScheduleChangeLog_Admin'
  added?: Maybe<Array<ScheduleItemDtoAdmin>>
  deleted?: Maybe<Array<ScheduleItemDtoAdmin>>
  updated?: Maybe<Array<ScheduleItemDtoAdmin>>
}

export interface ProjectScheduleDependency {
  __typename?: 'ProjectScheduleDependency'
  dependencyId: Scalars['String']
  relationship: Scalars['String']
}

export interface ProjectScheduleInstruction {
  __typename?: 'ProjectScheduleInstruction'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  instructions: Scalars['String']
  projectScheduleId: Scalars['String']
  subcontractorId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export interface ProjectScheduleItemChangedField {
  __typename?: 'ProjectScheduleItemChangedField'
  field: Scalars['String']
  newValue?: Maybe<Scalars['String']>
  oldValue?: Maybe<Scalars['String']>
}

export enum ProjectScheduleItemStatus {
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NeedsReview = 'NEEDS_REVIEW',
  NotStarted = 'NOT_STARTED',
}

export enum ProjectScheduleItemType {
  Milestone = 'MILESTONE',
  Phase = 'PHASE',
  Task = 'TASK',
}

export interface ProjectScheduleItemAdmin {
  __typename?: 'ProjectScheduleItem_Admin'
  children?: Maybe<Array<Maybe<ProjectScheduleItemAdmin>>>
  confirmedAt?: Maybe<Scalars['DateTime']>
  confirmedByAdminUser?: Maybe<AdminUser>
  createdAt: Scalars['DateTime']
  dependencies?: Maybe<Array<ProjectScheduleDependency>>
  description?: Maybe<Scalars['String']>
  duration: Scalars['Int']
  id: Scalars['String']
  latestMessage?: Maybe<KnockMessageLogAdmin>
  parent?: Maybe<ProjectScheduleItemAdmin>
  parentId?: Maybe<Scalars['String']>
  startDate: Scalars['DateTime']
  status: ProjectScheduleItemStatus
  subcontractor?: Maybe<Subcontractor>
  title?: Maybe<Scalars['String']>
  type: ProjectScheduleItemType
  updatedAt: Scalars['DateTime']
}

export interface ProjectScheduleItemPublic {
  __typename?: 'ProjectScheduleItem_Public'
  confirmedAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  duration: Scalars['Int']
  id: Scalars['String']
  startDate: Scalars['DateTime']
  title?: Maybe<Scalars['String']>
}

export enum ProjectScheduleStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
}

export interface ProjectScheduleAdmin {
  __typename?: 'ProjectSchedule_Admin'
  archivedAt?: Maybe<Scalars['DateTime']>
  autosaveDraft?: Maybe<Scalars['JSON']>
  checkedOutBy?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  earliestDate?: Maybe<Scalars['DateTime']>
  editingAdminUser?: Maybe<AdminUser>
  id: Scalars['String']
  isCheckedOut?: Maybe<Scalars['Boolean']>
  isCheckedOutByMe?: Maybe<Scalars['Boolean']>
  itemCount?: Maybe<Scalars['Int']>
  items?: Maybe<Array<Maybe<ProjectScheduleItemAdmin>>>
  latestDate?: Maybe<Scalars['DateTime']>
  project?: Maybe<Project>
  /** @deprecated TODO: clean up once UI is no longer using */
  status?: Maybe<ProjectScheduleStatus>
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface ProjectSchedulePublic {
  __typename?: 'ProjectSchedule_Public'
  builder?: Maybe<BuilderEntityPublic>
  id: Scalars['String']
  instructions?: Maybe<Array<Maybe<ProjectScheduleInstruction>>>
  items?: Maybe<Array<Maybe<ProjectScheduleItemPublic>>>
  project?: Maybe<PublicProject>
  title?: Maybe<Scalars['String']>
}

export interface ProjectSettings {
  __typename?: 'ProjectSettings'
  actionsEnabled?: Maybe<Scalars['Boolean']>
  defectsEnabled?: Maybe<Scalars['Boolean']>
  drawingsEnabled?: Maybe<Scalars['Boolean']>
  geolocationAutoSignOnOffEnabled?: Maybe<Scalars['Boolean']>
  geolocationRemindersEnabled?: Maybe<Scalars['Boolean']>
  hideDocumentsUntilInductionApproved?: Maybe<Scalars['Boolean']>
  permitsEnabled?: Maybe<Scalars['Boolean']>
  qrCodeRotationEnabled?: Maybe<Scalars['Boolean']>
  swmsBuilderEnabled?: Maybe<Scalars['Boolean']>
  timesheetsEnabled?: Maybe<Scalars['Boolean']>
}

export interface ProjectSiteTiming {
  __typename?: 'ProjectSiteTiming'
  dayOfWeek: Scalars['String']
  endTime?: Maybe<Scalars['String']>
  startTime?: Maybe<Scalars['String']>
}

export interface ProjectSortInput {
  createdAt?: InputMaybe<SortOrder>
}

export interface ProjectSpecificInductionSettings {
  __typename?: 'ProjectSpecificInductionSettings'
  /** Returns true if project managers can edit induction templates */
  projectManagersCanEditInductionTemplates?: Maybe<Scalars['Boolean']>
  /** A code that is required to be entered by workers to complete their site induction */
  siteInductionCode?: Maybe<Scalars['String']>
  /** Some help text to display to workers when they are entering the site induction code */
  siteInductionCodeDescription?: Maybe<Scalars['String']>
}

export interface ProjectSpecificPermitSettings {
  __typename?: 'ProjectSpecificPermitSettings'
  /** A list of which workers are authorised to request permits. All workers if empty. */
  authorisedWorkersForPermitRequests?: Maybe<Array<Scalars['String']>>
  /** A list of which project admins will receive permit notifications. All admins if empty. */
  permitAdminNotificationsIds?: Maybe<Array<Scalars['String']>>
}

export interface ProjectSpecificProcoreSettings {
  __typename?: 'ProjectSpecificProcoreSettings'
  checklistFolderId?: Maybe<Scalars['String']>
  inductionFolderId?: Maybe<Scalars['String']>
  siteDiaryFolderId?: Maybe<Scalars['String']>
  swmsFolderId?: Maybe<Scalars['String']>
  toolboxFolderId?: Maybe<Scalars['String']>
}

export interface ProjectSpecificSettings {
  __typename?: 'ProjectSpecificSettings'
  /** Alternative to the auto qr code rotation, this will allow you to manually set the project code */
  manualQrCodeRotationProjectCode?: Maybe<Scalars['String']>
  /** The custom message to be displayed when the wrong QR code is scanned */
  qrCodeRotationCustomMessage?: Maybe<Scalars['String']>
  /** Whether the sign on and induction QR code rotation is enabled */
  qrCodeRotationEnabled: Scalars['Boolean']
  /** The interval in secoonds between each rotation of the QR code */
  qrCodeRotationInterval: Scalars['Int']
}

/** Project-specific Site Diary module settings */
export interface ProjectSpecificSiteDiarySettings {
  __typename?: 'ProjectSpecificSiteDiarySettings'
  /** Whether automatic creation of daily site diaries is enabled for this project */
  automaticCreationEnabled: Scalars['Boolean']
}

export interface ProjectSpecificUserSettings {
  __typename?: 'ProjectSpecificUserSettings'
  /** The AI suggestions for the current user */
  aiSuggestions?: Maybe<Array<UserAiSuggestion>>
  aiSuggestionsLastGenerated?: Maybe<Scalars['DateTime']>
  birthdayWorkerNames?: Maybe<Scalars['String']>
}

export interface ProjectSpecificWorkerPermitSettings {
  __typename?: 'ProjectSpecificWorkerPermitSettings'
  /** Whether the current worker is authorised to request permits */
  isAuthorisedToRequestPermits?: Maybe<Scalars['Boolean']>
}

export interface ProjectStats {
  __typename?: 'ProjectStats'
  inductionCount?: Maybe<Scalars['Int']>
  inductions: Scalars['Int']
  projectId: Scalars['String']
  signOnCount?: Maybe<Scalars['Int']>
  signOns: Scalars['Int']
  subcontractorCount?: Maybe<Scalars['Int']>
  workerCount?: Maybe<Scalars['Int']>
}

export enum ProjectStatus {
  Archived = 'ARCHIVED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Upcoming = 'UPCOMING',
}

export interface ProjectResourceLink {
  __typename?: 'Project_ResourceLink'
  address?: Maybe<Scalars['String']>
  builder?: Maybe<BuilderResourceLink>
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  language?: Maybe<Scalars['String']>
  locale?: Maybe<SupportedLocaleCountryCode>
  name: Scalars['String']
  projectCode?: Maybe<Scalars['String']>
  status: ProjectStatus
  timezone?: Maybe<Scalars['String']>
}

export interface ProjectsForBuilderFilterAggregation {
  __typename?: 'ProjectsForBuilderFilterAggregation'
  archived?: Maybe<Scalars['Int']>
  complete?: Maybe<Scalars['Int']>
  inProgress?: Maybe<Scalars['Int']>
  upcoming?: Maybe<Scalars['Int']>
}

export interface ProjectsForBuilderFilterInput {
  resourceTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  searchString?: InputMaybe<Scalars['String']>
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  status?: InputMaybe<Array<InputMaybe<ProjectStatus>>>
}

export interface ProjectsForBuilderSortInput {
  createdAt?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

export interface PublicBuilderSettings {
  __typename?: 'PublicBuilderSettings'
  hideMedical?: Maybe<Scalars['Boolean']>
}

export interface PublicDefectsPdfGenerationInput {
  callbackInfo?: InputMaybe<CallbackInfo>
  includeAppendix?: InputMaybe<Scalars['Boolean']>
  margin?: InputMaybe<Scalars['String']>
  orientation?: InputMaybe<Orientation>
  resourceAppendUrl?: InputMaybe<Scalars['String']>
  resourceAppendUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  resourceIds: Array<Scalars['String']>
  subcontractorId: Scalars['String']
  timezone?: InputMaybe<Scalars['String']>
  type: PdfType
}

export interface PublicEmergency {
  __typename?: 'PublicEmergency'
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  project?: Maybe<ProjectEntity>
  projectId?: Maybe<Scalars['String']>
  resolvedAt?: Maybe<Scalars['DateTime']>
  status: EmergencyStatus
  title: Scalars['String']
}

export interface PublicEmergencyMessage {
  __typename?: 'PublicEmergencyMessage'
  id: Scalars['String']
  status: EmergencyMessageStatus
}

export interface PublicEmergencyWithMessage {
  __typename?: 'PublicEmergencyWithMessage'
  emergency?: Maybe<PublicEmergency>
  message?: Maybe<PublicEmergencyMessage>
}

export interface PublicPlatformActionSettings {
  __typename?: 'PublicPlatformActionSettings'
  allowSubcontractorsToCloseActions: Scalars['Boolean']
  priorities: Array<PlatformActionPriorityType>
  /** Customisable list of types that can be used on platform actions */
  types: Array<PlatformActionType>
}

export interface PublicProject {
  __typename?: 'PublicProject'
  actionsEnabled?: Maybe<Scalars['Boolean']>
  address?: Maybe<Scalars['String']>
  builder?: Maybe<BuilderEntity>
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  defectsEnabled?: Maybe<Scalars['Boolean']>
  drawingsEnabled?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  language?: Maybe<Scalars['String']>
  latitude?: Maybe<Scalars['Float']>
  locale?: Maybe<SupportedLocaleCountryCode>
  longitude?: Maybe<Scalars['Float']>
  name: Scalars['String']
  permitsEnabled?: Maybe<Scalars['Boolean']>
  projectContacts?: Maybe<Array<Maybe<ContactEntity>>>
  qrCodeRotationCustomMessage?: Maybe<Scalars['String']>
  qrCodeRotationEnabled?: Maybe<Scalars['Boolean']>
  signOnRedirectUrl?: Maybe<Scalars['String']>
  siteTimings?: Maybe<Array<Maybe<ProjectSiteTiming>>>
  status: ProjectStatus
  swmsBuilderEnabled?: Maybe<Scalars['Boolean']>
  timesheetsEnabled?: Maybe<Scalars['Boolean']>
  timezone?: Maybe<Scalars['String']>
  visitorDocumentAccessEnabled?: Maybe<Scalars['Boolean']>
  workerChecklistsEnabled?: Maybe<Scalars['Boolean']>
}

export interface PublicSubcontractorSettings {
  __typename?: 'PublicSubcontractorSettings'
  customInsurancesTypes?: Maybe<Array<Scalars['String']>>
}

export interface PublicTemplateResponseFilterInput {
  projectId?: InputMaybe<Scalars['String']>
  relatedRegisterItemId?: InputMaybe<Scalars['String']>
  templateId?: InputMaybe<Scalars['String']>
  templateType?: InputMaybe<TemplateType>
}

/** About the Redwood queries. */
export interface Query {
  __typename?: 'Query'
  accessControlIntegrationConnectionByWorkerId?: Maybe<AccessControlIntegrationConnection>
  accessControlIntegrationConnectionsByIntegrationId: Array<AccessControlIntegrationConnection>
  accessControlIntegrationConnectionsByProjectId: Array<AccessControlIntegrationConnection>
  accessProfileTemplate?: Maybe<AccessProfileTemplate>
  accessProfileTemplates: Array<AccessProfileTemplate>
  adminUser?: Maybe<AdminUser>
  adminUserStats?: Maybe<AdminUserStats>
  adminUsers: Array<AdminUser>
  adminUsersAggregation: PaginationAggregation
  agaveAccountStatus: AgaveAccountStatus
  agaveFolder?: Maybe<AgaveFolder>
  agaveFoldersByProject?: Maybe<Array<Maybe<AgaveFolder>>>
  agaveProjectsPaged: AgaveProjectsPagedResponse
  agaveVendorsPaged: AgaveVendorsPagedResponse
  /** For the current Builder, get the AI tools settings */
  aiToolsSettings: AiToolsSettings
  /** For the current Worker, get the Checklist module settings that apply for all projects. */
  allWorkerChecklistSettings: Array<WorkerChecklistSettings>
  auditLog?: Maybe<AuditLog>
  auditLogs: Array<AuditLog>
  auditLogsByResourceId: Array<AuditLog>
  auditLogsByResourceIdAggregation: PaginationAggregation
  buildPassSwmsTemplates: Array<SwmsLibraryTemplate>
  builder?: Maybe<Builder>
  builderEvents?: Maybe<BuilderEventResult>
  builderInduction?: Maybe<BuilderInduction>
  builderInductions: Array<BuilderInduction>
  builderInductionsAggregation: PaginationAggregation
  /** For the current Builder, get the Register module settings. If no settings exist, will default. */
  builderRegisterSettings: BuilderRegisterSettings
  /** For the current Builder, get the Builder settings */
  builderSettings: BuilderSettings
  builderWhitelabel?: Maybe<BuilderEntityWhitelabel>
  builderWorkerDocument?: Maybe<BuilderWorkerDocument>
  builderWorkers: Array<Worker>
  builderWorkersAggregation: PaginationAggregation
  builders: Array<Builder>
  buildpass: BuildPassData
  /** For the current Builder, get the Checklist module settings. If no settings exist, will default. */
  checklistSettings: ChecklistSettings
  /** For the current Builder, get the communication settings */
  communicationSettings: CommunicationSettings
  companies: Array<Company>
  companiesAggregation: PaginationAggregation
  companyRegisterItem_public: CompanyRegisterItem
  companyRegisterItems_public: Array<CompanyRegisterItem>
  completedTasks: Array<Task>
  contact: Contact
  conversationMessagesForThread: Array<ConversationMessage>
  conversationThread?: Maybe<ConversationThread>
  createAgaveLinkToken: AgaveLinkTokenResponse
  dashboard: Dashboard
  dashboardSignOnsByDate: DashboardSignOns
  dashboards: Array<Dashboard>
  dashboardsAggregation: PaginationAggregation
  defect?: Maybe<Defect>
  /** For the current Builder, get the Defect module settings. If no settings exist, will default. */
  defectSettings: DefectSettings
  defects?: Maybe<Array<Defect>>
  defectsAggregation: PaginationAggregation
  document?: Maybe<Document>
  documentFolder?: Maybe<DocumentFolder>
  documentFolderHierarchy: Array<DocumentFolder>
  documentFolderTree: Array<DocumentFolder>
  documentFolder_public?: Maybe<DocumentFolderPublic>
  documentFolder_worker?: Maybe<DocumentFolderWorker>
  documentFolders: Array<DocumentFolder>
  documentFolders_public: Array<DocumentFolderPublic>
  documentFolders_worker: Array<DocumentFolderWorker>
  documentForWorker?: Maybe<DocumentEntity>
  documentSignature?: Maybe<DocumentSignature>
  document_visitor: DocumentEntity
  documents: Array<Document>
  documentsAggregation: PaginationAggregation
  documentsForVisitor: VisitorDocuments
  documents_visitor: VisitorDocuments
  drawingActivityFeed_admin?: Maybe<Array<DrawingActivityDay>>
  drawing_admin?: Maybe<DrawingAdmin>
  drawing_public?: Maybe<DrawingPublic>
  drawing_worker?: Maybe<DrawingWorker>
  drawingsAggregation_admin: PaginationAggregation
  drawings_admin?: Maybe<Array<DrawingAdmin>>
  drawings_public?: Maybe<Array<DrawingPublic>>
  drawings_worker?: Maybe<Array<DrawingWorker>>
  emailLog?: Maybe<EmailLog>
  emailLogsByBuilder: Array<EmailLog>
  emailLogsByProject: Array<EmailLog>
  emailLogsBySubcontractor: Array<EmailLog>
  emergencies: Array<Emergency>
  emergency?: Maybe<Emergency>
  existingResourceTags_admin: Array<ResourceTag>
  exportAccessControlWorkersStatus: Array<ExportAccessControlWorkersStatus>
  /** @deprecated use extractTicketData instead */
  extractText: ExtractedText
  extractTicketData: ExtractedText
  fileUploadInvite?: Maybe<FileUploadInvite>
  findResourceById?: Maybe<ResourceMeta>
  gallery?: Maybe<Array<Attachment>>
  galleryAggregation: PaginationAggregation
  /** For the current Builder, get the Image settings */
  gallerySettings: GallerySettings
  generateCodeForProject_admin: CodeForProjectPayload
  getAllProjectHoursBudgetReports: AllProjectHoursBudgetReport
  getAttachmentForBuilder: Attachment
  getAttachmentUrl?: Maybe<AttachmentUrl>
  getAvailableProjectsForPremier: Array<Project>
  getAvailableVendorsForPremier: Array<Subcontractor>
  getBuildxactContacts: Array<BuildxactContact>
  getBuildxactContactsPaginated: BuildxactContactsPaginatedResponse
  getBuildxactProjects: Array<BuildxactProject>
  getBuildxactProjectsPaginated: BuildxactProjectsPaginatedResponse
  getDashboardData: DashboardData
  getDefectReport: DefectReport
  getIntegrationData?: Maybe<Scalars['JSON']>
  getPlatformAggregation: PlatformAggregationReport
  getPlatformEngagement: PlatformEngagementReport
  getPlatformUsage: PlatformUsageReport
  getPremierCompanies: Array<PremierCompany>
  getPremierJobs: Array<PremierJob>
  getPremierVendors: Array<PremierVendor>
  getPresignedUrl: PresignedUrl
  getProjectHoursBudgetReport?: Maybe<ProjectHoursBudgetReport>
  getProjectHoursBudgetReportForSiteDiary?: Maybe<ProjectHoursBudgetReport>
  /** @deprecated Use siteDiaries under getPlatformUsage */
  getSiteDiaryUsage: SiteDiaryUsage
  getSubcontractorArchiveInfo?: Maybe<SubcontractorArchiveInfo>
  getSubcontractorReport: SubcontractorsReport
  /** For all Builders, get the global settings */
  globalSettings: GlobalSettings
  hasProcoreAppInstalled?: Maybe<Scalars['Boolean']>
  helpScoutVisitorToken?: Maybe<HelpScoutVisitorToken>
  /** For the specified project, get the Hours budget module settings */
  hoursBudgetSettings: HoursBudgetSettings
  inductionInvite?: Maybe<InductionInvite>
  /** For the current Builder, get the Induction module settings. If no settings exist, will default. */
  inductionSettings: InductionSettings
  /** @deprecated Use templates instead */
  inductionTemplate?: Maybe<InductionTemplateEntity>
  insuranceDoc?: Maybe<InsuranceDoc>
  insuranceDocs: Array<InsuranceDoc>
  insuranceDocsAggregation: PaginationAggregation
  integration?: Maybe<Integration>
  integrationByType?: Maybe<Integration>
  integrationConnection?: Maybe<IntegrationConnection>
  integrationConnectionForProject?: Maybe<IntegrationConnection>
  integrationConnections: Array<IntegrationConnection>
  integrationLogs: Array<IntegrationLog>
  integrationLogsAggregation: PaginationAggregation
  integrations: Array<Integration>
  isDocumentFolderEmpty: Scalars['Boolean']
  knockMessageContent_admin: KnockMessageContentAdmin
  knockMessageLog_admin?: Maybe<KnockMessageLogAdmin>
  knockMessageLogs_admin: Array<KnockMessageLogAdmin>
  latestTicketReview?: Maybe<TicketReview>
  librarySwmsDoc_admin?: Maybe<LibrarySwmsDocAdmin>
  librarySwmsDocsAggregation_admin: PaginationAggregation
  librarySwmsDocs_admin: Array<LibrarySwmsDocAdmin>
  libraryTemplate?: Maybe<LibraryTemplate>
  libraryTemplates: Array<LibraryTemplate>
  mostRecentSiteDiary?: Maybe<SiteDiary>
  msdsDoc?: Maybe<MsdsDoc>
  msdsDocForWorker?: Maybe<MsdsDocEntity>
  msdsDoc_visitor: MsdsDocEntity
  msdsDocs: Array<MsdsDoc>
  msdsDocsAggregation: PaginationAggregation
  myDefect: WorkerDefectEntry
  myDefects: Array<WorkerDefectEntry>
  myTimesheets: Array<WorkerTimesheetEntry>
  permission?: Maybe<Permission>
  permissionsByRole: Array<Permission>
  permitAggregation_admin: PaginationAggregation
  permitType_admin?: Maybe<PermitTypeAdmin>
  permitType_worker?: Maybe<PermitTypeWorker>
  permitTypesAggregation_admin: PaginationAggregation
  permitTypes_admin: Array<PermitTypeAdmin>
  permitTypes_worker: Array<PermitTypeWorker>
  permitWorker_admin?: Maybe<PermitWorkerAdmin>
  permitWorker_worker?: Maybe<PermitWorkerWorker>
  permitWorkers_admin: Array<PermitWorkerAdmin>
  permit_admin?: Maybe<PermitAdmin>
  permit_worker?: Maybe<PermitWorker>
  permitsForDashboard_admin: Array<PermitAdmin>
  permits_admin?: Maybe<Array<PermitAdmin>>
  permits_worker?: Maybe<Array<PermitWorker>>
  platformAction?: Maybe<PlatformAction>
  /** For the current Builder, get the Platform Action module settings. If no settings exist, will default. */
  platformActionSettings: PlatformActionSettings
  platformAction_worker?: Maybe<PlatformActionWorker>
  platformActions: Array<PlatformAction>
  platformActionsAggregateStats?: Maybe<
    Array<Maybe<PlatformActionAggregateStats>>
  >
  platformActionsAggregation: PaginationAggregation
  platformActions_worker: Array<PlatformActionWorker>
  preStart?: Maybe<PreStart>
  preStarts: Array<PreStart>
  preStartsAggregation: PaginationAggregation
  /** For the current Builder, get the Premier integration settings. If no settings exist, will default. */
  premierSettings: PremierSettings
  prequalification: Prequalification
  prequalificationEnabled: PrequalificationEnabled
  /** For the current Builder, get the Prequalification module settings. If no settings exist, will default. */
  prequalificationSettings: PrequalificationSettings
  prequalifications: Array<Prequalification>
  prequalificationsAggregation: PaginationAggregation
  processedSignOns_admin: Array<ProcessedSignOn>
  processedSignOns_worker: Array<ProcessedSignOn>
  procoreCompanyProjects?: Maybe<Scalars['JSON']>
  procoreCompanySubcontractors?: Maybe<Scalars['JSON']>
  procoreCompanyWebhooks: Scalars['Boolean']
  procoreConfig?: Maybe<ProcoreConfig>
  /** For the current Builder, get the Procore integration settings. If no settings exist, will default. */
  procoreSettings: ProcoreSettings
  project?: Maybe<Project>
  projectExists?: Maybe<ProjectExists>
  projectInduction?: Maybe<ProjectInduction>
  projectInductionByIdentifier?: Maybe<ProjectInduction>
  projectInductionByIdentifier_public?: Maybe<ProjectInductionPublic>
  projectInductionByWorker?: Maybe<ProjectInduction>
  projectInductionByWorker_public?: Maybe<ProjectInductionPublic>
  projectInductionForWorker?: Maybe<WorkerProjectInduction>
  projectInductionRequiresCode: SiteInductionCodeInfo
  projectInductions: Array<ProjectInduction>
  projectInductionsAggregation: PaginationAggregation
  projectInductionsForWorker?: Maybe<Array<WorkerProjectInduction>>
  projectLocation?: Maybe<ProjectLocation>
  projectLocation_public?: Maybe<ProjectLocationPublic>
  projectLocations: Array<ProjectLocation>
  projectLocations_public: Array<ProjectLocationPublic>
  projectPerformances: Array<ProjectPerformance>
  projectScheduleItemNotificationDiff_admin: ProjectScheduleChangeLogAdmin
  projectScheduleItem_admin?: Maybe<ProjectScheduleItemAdmin>
  projectSchedule_admin?: Maybe<ProjectScheduleAdmin>
  projectSchedules_admin: Array<ProjectScheduleAdmin>
  projectSmsLogs: Array<SmsLog>
  projectSmsLogsBatched: Array<BatchedSmsLog>
  /** For the current Builder, get the Induction module settings for the current project. If no settings exist, will default. */
  projectSpecificInductionSettings: ProjectSpecificInductionSettings
  /** For the current Builder, get the Permit module settings for the current project. If no settings exist, will default. */
  projectSpecificPermitSettings: ProjectSpecificPermitSettings
  /** For the current project, get the Procore integration settings. If no settings exist, will return null. */
  projectSpecificProcoreSettings?: Maybe<ProjectSpecificProcoreSettings>
  /** For the current Project, get the Project specific settings */
  projectSpecificSettings: ProjectSpecificSettings
  /** For the current project, get the Site Diary module settings. If no settings exist, will default. */
  projectSpecificSiteDiarySettings: ProjectSpecificSiteDiarySettings
  /** For the current user, get their project specific settings */
  projectSpecificUserSettings: ProjectSpecificUserSettings
  /** For the current Worker, get the Permit module settings for the current project. If no settings exist, will default. */
  projectSpecificWorkerPermitSettings: ProjectSpecificWorkerPermitSettings
  projectStats: ProjectStats
  /** @deprecated Use projectsForBuilder for builders, or workerProjects for workers */
  projects: Array<Project>
  projectsForBuilder: Array<Project>
  projectsForBuilderAggregation: PaginationAggregation
  projectsForBuilderFilterAggregation?: Maybe<ProjectsForBuilderFilterAggregation>
  publicCompanySubcontractors: Array<SubcontractorEntity>
  publicEmergencyFromMessage?: Maybe<PublicEmergencyWithMessage>
  /** For the provided Builder, get the Platform Action module settings. If no settings exist, will default. */
  publicPlatformActionSettings: PublicPlatformActionSettings
  /** For the provided Project, get the Platform Action module settings. If no settings exist, will default. */
  publicPlatformActionSettingsByProject: PublicPlatformActionSettings
  publicPlatformActionViaChecklistResourceLink?: Maybe<PlatformActionResourceLink>
  publicProject?: Maybe<PublicProject>
  publicProjectsForSubcontractor?: Maybe<Array<PublicProject>>
  publicSubcontractor?: Maybe<SubcontractorEntity>
  publicSubcontractorPlatformAction?: Maybe<PlatformActionEntity>
  publicSubcontractorPlatformActions: Array<PlatformActionEntity>
  /** For the provided Builder, get the subcontractor module settings. If no settings exist, will default. */
  publicSubcontractorSettings: PublicSubcontractorSettings
  publicTemplateResponse?: Maybe<TemplateResponseEntity>
  publicTemplateResponses: Array<TemplateResponseEntity>
  /** Fetches the Redwood root schema. */
  redwood?: Maybe<Redwood>
  register?: Maybe<Register>
  registerIdentifiers: Array<Scalars['String']>
  registerItem?: Maybe<RegisterItem>
  registerItemBooking?: Maybe<RegisterItemBooking>
  registerItemBookings: Array<RegisterItemBooking>
  registerItemType?: Maybe<RegisterItemType>
  registerItemType_public: RegisterItemTypePublic
  registerItemTypes: Array<RegisterItemType>
  registerItemTypesAggregation: PaginationAggregation
  registerItemTypes_public: Array<RegisterItemTypePublic>
  registerItem_public: RegisterItemPublic
  registerItem_worker?: Maybe<RegisterItemWorker>
  registerItems: Array<RegisterItem>
  registerItemsAggregation: PaginationAggregation
  registerItems_public: Array<RegisterItemPublic>
  register_public: RegisterPublic
  register_worker?: Maybe<RegisterWorker>
  registers: Array<Register>
  registers_nav: Array<Register>
  registers_public: Array<RegisterPublic>
  registers_worker: Array<RegisterWorker>
  resourceLink?: Maybe<ResourceLink>
  resourceLinkByResource?: Maybe<ResourceLink>
  resourceLinkBySlug?: Maybe<ResourceLinkEntityResult>
  resourceTags: Array<ResourceTag>
  role?: Maybe<Role>
  roles: Array<Role>
  saAdminUser?: Maybe<AdminUser>
  saBuilder?: Maybe<Builder>
  saBuilders: Array<Builder>
  saBuildersAggregation: PaginationAggregation
  saGetDashboardData: DashboardData
  saPlatformData?: Maybe<PlatformData>
  saProjectsByBuilder: Array<Project>
  saProjectsForMap: Array<Project>
  schedule?: Maybe<Schedule>
  scheduledJob?: Maybe<ScheduledJob>
  scheduledJobs: Array<ScheduledJob>
  scheduledJobsForProject: Array<ScheduledJob>
  schedules: Array<Schedule>
  schedulesByTemplate: Array<Schedule>
  searchCompanies: Array<AbrCompany>
  signOn?: Maybe<SignOn>
  /** For the current Builder, get the Sign On module settings. If no settings exist, will default. */
  signOnSettings: SignOnSettings
  signOns: Array<SignOn>
  signOnsAggregation: PaginationAggregation
  /** @deprecated Use signOns instead */
  signOnsByProject: Array<SignOn>
  signOnsByProjectAndDate: Array<Maybe<GroupedSignOn>>
  siteDiaries: Array<SiteDiary>
  siteDiariesAggregation: PaginationAggregation
  siteDiary?: Maybe<SiteDiary>
  siteDiaryByDay?: Maybe<SiteDiary>
  smsBatch: Array<SmsLog>
  smsLogsReport: SmsLogsReport
  /** For the current Builder, get the styling settings */
  stylingSettings: StylingSettings
  subcontractor?: Maybe<Subcontractor>
  subcontractorFilterAggregation?: Maybe<SubcontractorFilterAggregation>
  subcontractorProjectSchedule_public?: Maybe<ProjectSchedulePublic>
  subcontractorProjectSchedules_public: Array<ProjectSchedulePublic>
  /** For the current Builder, get the Subcontractor module settings. If no settings exist, will default. */
  subcontractorSettings: SubcontractorSettings
  subcontractorSuggest: Array<SubcontractorEntity>
  /** For the current Subcontractor, get the SWMS module settings. If no settings exist, will default. */
  subcontractorSwmsSettings: SubcontractorSwmsSettings
  subcontractorsByBuilder: Array<Subcontractor>
  subcontractorsByBuilderAggregation: PaginationAggregation
  subcontractorsByProject: Array<Subcontractor>
  subcontractorsByProjectAggregation: PaginationAggregation
  subcontractors_public?: Maybe<Array<SubcontractorPublic>>
  swmsDoc?: Maybe<SwmsDoc>
  swmsDocForWorker?: Maybe<SwmsDocEntity>
  swmsDocLogs: Array<SwmsDocLog>
  swmsDoc_visitor: SwmsDocEntity
  swmsDocs: Array<SwmsDoc>
  swmsDocsAggregation: PaginationAggregation
  swmsInProgress: Array<SwmsTemplateResponse>
  /** For the current Builder, get the SWMS module settings. If no settings exist, will default. */
  swmsSettings: SwmsSettings
  swmsTemplateResponse: SwmsTemplateResponse
  swmsTemplates: Array<SwmsTemplate>
  tasks: Array<Task>
  template?: Maybe<Template>
  templateAsWorker?: Maybe<TemplateEntity>
  templateFromMarketplace?: Maybe<TemplateEntity>
  templateIdentifiers: Array<Scalars['String']>
  templateOrLibraryTemplate?: Maybe<TemplateOrLibraryTemplate>
  templateResponse?: Maybe<TemplateResponse>
  templateResponses: Array<TemplateResponse>
  templateResponsesAggregateStats?: Maybe<
    Array<Maybe<TemplateResponseAggregateStats>>
  >
  templateResponsesAggregation: PaginationAggregation
  templates: Array<Template>
  templatesAggregation: PaginationAggregation
  templates_public: Array<TemplateEntity>
  ticket?: Maybe<Ticket>
  ticketCategories: Array<TicketCategory>
  ticketTemplates: Array<TicketTemplate>
  ticketTypes: Array<TicketType>
  ticketWalletShare?: Maybe<TicketWalletShare>
  ticketWalletSharePublic?: Maybe<TicketShareUnion>
  ticketWalletShares: Array<TicketWalletShare>
  tickets: Array<Ticket>
  ticketsByWorker: Array<Maybe<Ticket>>
  ticketsByWorkers: Array<Maybe<Ticket>>
  ticketsByWorkersAggregation: PaginationAggregation
  timesheet: TimesheetEntry
  timesheetGroup: TimesheetGroup
  /** For the current Builder, get the Timesheet module settings. If no settings exist, will default. */
  timesheetSettings: TimesheetSettings
  timesheets?: Maybe<Array<TimesheetEntry>>
  timesheetsAggregation: PaginationAggregation
  todaysPreStarts: Array<PreStart>
  toolbox?: Maybe<Toolbox>
  toolboxInvite?: Maybe<ToolboxInvite>
  toolboxInviteByWorker?: Maybe<ToolboxInvite>
  toolboxInvitesByToolbox: Array<ToolboxInvite>
  toolboxInvitesByWorker: Array<ToolboxInvite>
  toolboxesByProject: Array<Toolbox>
  toolboxesByProjectAggregation: PaginationAggregation
  user?: Maybe<User>
  /** For the current user, get their settings */
  userSettings: UserSettings
  visitor?: Maybe<Visitor>
  visitorsOnSite?: Maybe<Array<Maybe<Visitor>>>
  widgetActivity: WidgetActivityData
  widgetFollowUp: WidgetFollowUpData
  widgetMetabase: WidgetMetabaseData
  widgetReporting: WidgetReportingData
  widgetToReview: WidgetToReviewData
  worker?: Maybe<Worker>
  /** @deprecated Use worker query */
  workerByProject?: Maybe<Worker>
  /** For the current Worker, get the Checklist module settings that apply. */
  workerChecklistSettings: WorkerChecklistSettings
  workerDocuments: WorkerDocuments
  workerProject?: Maybe<WorkerProject>
  workerProjects: Array<WorkerProject>
  workerSignOnStatus?: Maybe<SignOnStatus>
  workerSignOns: Array<SignOn>
  workerSignOnsAggregation: PaginationAggregation
  workerSignOnsByProject: Array<SignOn>
  workerSignOnsToday: Array<Maybe<SignOn>>
  workerSignatures: WorkerSignatures
  workerTemplateResponse?: Maybe<TemplateResponseEntity>
  workerTemplateResponses: Array<TemplateResponseEntity>
  workerTemplateResponsesAggregation: PaginationAggregation
  workerTicketReviewStatuses: WorkerTicketReviewStatuses
  /** For the current Worker, get the Timesheet module settings that apply to workers. */
  workerTimesheetSettings: WorkerTimesheetSettings
  workerToolbox?: Maybe<ToolboxEntity>
  workerToolboxesByProject: Array<Toolbox>
  workers: Array<Worker>
  workersAggregation: PaginationAggregation
  /** @deprecated Use workers query */
  workersByProject?: Maybe<Array<Maybe<Worker>>>
  workersBySubcontractor?: Maybe<Array<Maybe<Worker>>>
  workersOnSite?: Maybe<Array<Maybe<WorkerForEmergency>>>
  workersWithInduction?: Maybe<Array<Maybe<Worker>>>
  /** @deprecated Use workersWithInduction instead - Misleading query as this checks for inductions on signons */
  workersWithProjectSignons?: Maybe<Array<Maybe<Worker>>>
  workersWithSignon?: Maybe<Array<Maybe<Worker>>>
  workers_worker: Array<WorkerEntity>
  workflow: Workflow
  workflowExecutions: Array<WorkflowExecution>
  workflowExecutionsAggregation: PaginationAggregation
  workflows: Array<Workflow>
  workflowsAggregation: PaginationAggregation
  yearInReview: Array<YearInReview>
  yearInReviewForBuilder: YearInReview
  yearInReviewPublic: YearInReviewPublic
}

/** About the Redwood queries. */
export interface QueryAccessControlIntegrationConnectionByWorkerIdArgs {
  workerId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryAccessControlIntegrationConnectionsByIntegrationIdArgs {
  integrationId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryAccessControlIntegrationConnectionsByProjectIdArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryAccessProfileTemplateArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryAccessProfileTemplatesArgs {
  filters?: InputMaybe<AccessProfileTemplatesFilters>
}

/** About the Redwood queries. */
export interface QueryAdminUserArgs {
  id?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryAdminUserStatsArgs {
  adminUserId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryAdminUsersArgs {
  filter?: InputMaybe<AdminUserFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<AdminUserSortInput>
}

/** About the Redwood queries. */
export interface QueryAdminUsersAggregationArgs {
  filter?: InputMaybe<AdminUserFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<AdminUserSortInput>
}

/** About the Redwood queries. */
export interface QueryAgaveAccountStatusArgs {
  integrationType: IntegrationType
}

/** About the Redwood queries. */
export interface QueryAgaveFolderArgs {
  folderId: Scalars['String']
  integrationType: IntegrationType
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryAgaveFoldersByProjectArgs {
  integrationType: IntegrationType
  parentFolderId?: InputMaybe<Scalars['String']>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryAgaveProjectsPagedArgs {
  filter?: InputMaybe<AgaveProjectFilterInput>
  input: QueryAgaveProjectsInput
  pagination?: InputMaybe<AgavePaginationInput>
}

/** About the Redwood queries. */
export interface QueryAgaveVendorsPagedArgs {
  filter?: InputMaybe<AgaveVendorFilterInput>
  input: QueryAgaveVendorsInput
  pagination?: InputMaybe<AgavePaginationInput>
}

/** About the Redwood queries. */
export interface QueryAllWorkerChecklistSettingsArgs {
  sanitise?: InputMaybe<Scalars['Boolean']>
}

/** About the Redwood queries. */
export interface QueryAuditLogArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryAuditLogsArgs {
  filter?: InputMaybe<AuditLogsFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<AuditLogsSortInput>
}

/** About the Redwood queries. */
export interface QueryAuditLogsByResourceIdArgs {
  id: Scalars['String']
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryAuditLogsByResourceIdAggregationArgs {
  id: Scalars['String']
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryBuildPassSwmsTemplatesArgs {
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryBuilderArgs {
  id?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryBuilderEventsArgs {
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<BuilderEventOrderByInput>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

/** About the Redwood queries. */
export interface QueryBuilderInductionArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryBuilderInductionsArgs {
  builderId: Scalars['String']
  filter?: InputMaybe<BuilderInductionFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<InductionSortInput>
}

/** About the Redwood queries. */
export interface QueryBuilderInductionsAggregationArgs {
  builderId: Scalars['String']
  filter?: InputMaybe<BuilderInductionFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryBuilderSettingsArgs {
  builderId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryBuilderWhitelabelArgs {
  name: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryBuilderWorkerDocumentArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryBuilderWorkersArgs {
  filter?: InputMaybe<BuilderWorkersFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryBuilderWorkersAggregationArgs {
  filter?: InputMaybe<BuilderWorkersFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryCompaniesArgs {
  input?: InputMaybe<GetCompaniesInput>
}

/** About the Redwood queries. */
export interface QueryCompaniesAggregationArgs {
  input?: InputMaybe<GetCompaniesInput>
}

/** About the Redwood queries. */
export interface QueryCompanyRegisterItemPublicArgs {
  id: Scalars['String']
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryCompanyRegisterItemsPublicArgs {
  filter?: InputMaybe<CompanyRegisterItemFilterInput>
  pagination?: InputMaybe<PaginationInput>
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryCompletedTasksArgs {
  projectId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryContactArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryConversationMessagesForThreadArgs {
  threadId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryConversationThreadArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDashboardArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDashboardSignOnsByDateArgs {
  filter?: InputMaybe<FilterInput>
  pagination?: InputMaybe<PaginationInput>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDashboardsArgs {
  filter: DashboardListFilterInput
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryDashboardsAggregationArgs {
  filter: DashboardListFilterInput
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryDefectArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDefectsArgs {
  filter: DefectFilterInput
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<DefectSortInput>
}

/** About the Redwood queries. */
export interface QueryDefectsAggregationArgs {
  filter: DefectFilterInput
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryDocumentArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDocumentFolderArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDocumentFolderHierarchyArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDocumentFolderTreeArgs {
  category: DocumentCategory
  projectId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryDocumentFolderPublicArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDocumentFolderWorkerArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDocumentFoldersArgs {
  filter: DocumentFolderFilterInput
  sort?: InputMaybe<DocumentFolderSortInput>
}

/** About the Redwood queries. */
export interface QueryDocumentFoldersPublicArgs {
  filter?: InputMaybe<DocumentFolderFilterInputPublic>
}

/** About the Redwood queries. */
export interface QueryDocumentFoldersWorkerArgs {
  filter?: InputMaybe<DocumentFolderFilterInputWorker>
}

/** About the Redwood queries. */
export interface QueryDocumentForWorkerArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDocumentSignatureArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDocumentVisitorArgs {
  documentId: Scalars['String']
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDocumentsArgs {
  filter?: InputMaybe<DocumentFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<DocumentSortInput>
}

/** About the Redwood queries. */
export interface QueryDocumentsAggregationArgs {
  filter?: InputMaybe<DocumentFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryDocumentsForVisitorArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDocumentsVisitorArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDrawingActivityFeedAdminArgs {
  documentFolderId?: InputMaybe<Scalars['String']>
  pagination?: InputMaybe<PaginationInput>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDrawingAdminArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDrawingPublicArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDrawingWorkerArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryDrawingsAggregationAdminArgs {
  filter?: InputMaybe<DrawingFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryDrawingsAdminArgs {
  filter?: InputMaybe<DrawingFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<DrawingSortInput>
}

/** About the Redwood queries. */
export interface QueryDrawingsPublicArgs {
  filter?: InputMaybe<DrawingFilterInputPublic>
  sort?: InputMaybe<DrawingSortInputPublic>
}

/** About the Redwood queries. */
export interface QueryDrawingsWorkerArgs {
  filter?: InputMaybe<DrawingFilterInputWorker>
  sort?: InputMaybe<DrawingSortInputWorker>
}

/** About the Redwood queries. */
export interface QueryEmailLogArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryEmailLogsByBuilderArgs {
  builderId: Scalars['String']
  filter?: InputMaybe<EmailLogFilterInput>
}

/** About the Redwood queries. */
export interface QueryEmailLogsByProjectArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryEmailLogsBySubcontractorArgs {
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryEmergenciesArgs {
  filter?: InputMaybe<EmergencyFilterInput>
}

/** About the Redwood queries. */
export interface QueryEmergencyArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryExistingResourceTagsAdminArgs {
  filter?: InputMaybe<ResourceTagsFilterInputAdmin>
}

/** About the Redwood queries. */
export interface QueryExportAccessControlWorkersStatusArgs {
  projectIds: Array<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryExtractTextArgs {
  input: ExtractTextInput
}

/** About the Redwood queries. */
export interface QueryExtractTicketDataArgs {
  input: ExtractTextInput
}

/** About the Redwood queries. */
export interface QueryFileUploadInviteArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryFindResourceByIdArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryGalleryArgs {
  filter?: InputMaybe<GalleryFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<GallerySortInput>
}

/** About the Redwood queries. */
export interface QueryGalleryAggregationArgs {
  filter?: InputMaybe<GalleryFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryGenerateCodeForProjectAdminArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryGetAllProjectHoursBudgetReportsArgs {
  filter?: InputMaybe<AllProjectHoursBudgetReportFilterInput>
}

/** About the Redwood queries. */
export interface QueryGetAttachmentForBuilderArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryGetAttachmentUrlArgs {
  key: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryGetBuildxactContactsPaginatedArgs {
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryGetBuildxactProjectsPaginatedArgs {
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryGetDashboardDataArgs {
  filter?: InputMaybe<FilterInput>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryGetDefectReportArgs {
  filter?: InputMaybe<DefectReportFilterInput>
}

/** About the Redwood queries. */
export interface QueryGetIntegrationDataArgs {
  action: IntegrationActions
  type: IntegrationType
}

/** About the Redwood queries. */
export interface QueryGetPlatformAggregationArgs {
  filter?: InputMaybe<PlatformUsagAggregationFilterInput>
}

/** About the Redwood queries. */
export interface QueryGetPlatformEngagementArgs {
  filter?: InputMaybe<PlatformEngagementFilterInput>
}

/** About the Redwood queries. */
export interface QueryGetPlatformUsageArgs {
  filter?: InputMaybe<PlatformUsageReportFilterInput>
}

/** About the Redwood queries. */
export interface QueryGetPremierJobsArgs {
  companyId: Scalars['String']
  search?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryGetPremierVendorsArgs {
  companyId: Scalars['String']
  search?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryGetPresignedUrlArgs {
  input: PresignedUrlInput
}

/** About the Redwood queries. */
export interface QueryGetProjectHoursBudgetReportArgs {
  filter: ProjectHoursBudgetReportFilterInput
}

/** About the Redwood queries. */
export interface QueryGetProjectHoursBudgetReportForSiteDiaryArgs {
  siteDiaryId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryGetSiteDiaryUsageArgs {
  filter?: InputMaybe<PlatformUsageReportFilterInput>
}

/** About the Redwood queries. */
export interface QueryGetSubcontractorArchiveInfoArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryGetSubcontractorReportArgs {
  filter?: InputMaybe<SubcontractorReportFilterInput>
}

/** About the Redwood queries. */
export interface QueryHasProcoreAppInstalledArgs {
  isDev: Scalars['Boolean']
}

/** About the Redwood queries. */
export interface QueryHoursBudgetSettingsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryInductionInviteArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryInductionTemplateArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryInsuranceDocArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryInsuranceDocsArgs {
  filter?: InputMaybe<InsuranceFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<InsuranceSortInput>
}

/** About the Redwood queries. */
export interface QueryInsuranceDocsAggregationArgs {
  filter?: InputMaybe<InsuranceFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryIntegrationArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryIntegrationByTypeArgs {
  integrationType: IntegrationType
}

/** About the Redwood queries. */
export interface QueryIntegrationConnectionArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryIntegrationConnectionForProjectArgs {
  integrationType: IntegrationType
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryIntegrationConnectionsArgs {
  filter?: InputMaybe<IntegrationConnectionFilterInput>
}

/** About the Redwood queries. */
export interface QueryIntegrationLogsArgs {
  filter?: InputMaybe<IntegrationLogFilterInput>
  id: Scalars['String']
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<IntegrationLogSortInput>
}

/** About the Redwood queries. */
export interface QueryIntegrationLogsAggregationArgs {
  filter?: InputMaybe<IntegrationLogFilterInput>
  id: Scalars['String']
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<IntegrationLogSortInput>
}

/** About the Redwood queries. */
export interface QueryIsDocumentFolderEmptyArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryKnockMessageContentAdminArgs {
  logId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryKnockMessageLogAdminArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryKnockMessageLogsAdminArgs {
  filter?: InputMaybe<KnockMessageLogsFilterInputAdmin>
}

/** About the Redwood queries. */
export interface QueryLatestTicketReviewArgs {
  ticketId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryLibrarySwmsDocAdminArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryLibrarySwmsDocsAggregationAdminArgs {
  filter?: InputMaybe<LibrarySwmsDocFilterInputAdmin>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryLibrarySwmsDocsAdminArgs {
  filter?: InputMaybe<LibrarySwmsDocFilterInputAdmin>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<LibrarySwmsDocSortInputAdmin>
}

/** About the Redwood queries. */
export interface QueryLibraryTemplateArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryLibraryTemplatesArgs {
  filter?: InputMaybe<LibraryTemplateFilterInput>
  sort?: InputMaybe<LibraryTemplateSortInput>
}

/** About the Redwood queries. */
export interface QueryMostRecentSiteDiaryArgs {
  filter?: InputMaybe<SiteDiaryFilterInput>
}

/** About the Redwood queries. */
export interface QueryMsdsDocArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryMsdsDocForWorkerArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryMsdsDocVisitorArgs {
  documentId: Scalars['String']
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryMsdsDocsArgs {
  filter?: InputMaybe<MsdsFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<MsdsSortInput>
}

/** About the Redwood queries. */
export interface QueryMsdsDocsAggregationArgs {
  filter?: InputMaybe<MsdsFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryMyDefectArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryMyDefectsArgs {
  projectId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryMyTimesheetsArgs {
  filter: MyTimesheetEntryFilterInput
}

/** About the Redwood queries. */
export interface QueryPermissionArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermissionsByRoleArgs {
  roleId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermitAggregationAdminArgs {
  filter?: InputMaybe<PermitFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryPermitTypeAdminArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermitTypeWorkerArgs {
  permitTypeId: Scalars['String']
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermitTypesAggregationAdminArgs {
  filter?: InputMaybe<PermitTypeFilterInputAdmin>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryPermitTypesAdminArgs {
  filter?: InputMaybe<PermitTypeFilterInputAdmin>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<PermitTypeSortInputAdmin>
}

/** About the Redwood queries. */
export interface QueryPermitTypesWorkerArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermitWorkerAdminArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermitWorkerWorkerArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermitWorkersAdminArgs {
  pagination?: InputMaybe<PaginationInput>
  permitId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermitAdminArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermitWorkerArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermitsForDashboardAdminArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPermitsAdminArgs {
  filter?: InputMaybe<PermitFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<PermitSortInput>
}

/** About the Redwood queries. */
export interface QueryPermitsWorkerArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPlatformActionArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPlatformActionWorkerArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPlatformActionsArgs {
  filter?: InputMaybe<PlatformActionFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<PlatformActionSortInput>
}

/** About the Redwood queries. */
export interface QueryPlatformActionsAggregateStatsArgs {
  filter?: InputMaybe<PlatformActionFilterInput>
}

/** About the Redwood queries. */
export interface QueryPlatformActionsAggregationArgs {
  filter?: InputMaybe<PlatformActionFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryPlatformActionsWorkerArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPreStartArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPreStartsArgs {
  filter?: InputMaybe<PreStartsFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<PreStartsSortInput>
}

/** About the Redwood queries. */
export interface QueryPreStartsAggregationArgs {
  filter?: InputMaybe<PreStartsFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryPrequalificationArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPrequalificationsArgs {
  filter?: InputMaybe<PrequalificationFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<PrequalificationSortInput>
}

/** About the Redwood queries. */
export interface QueryPrequalificationsAggregationArgs {
  filter?: InputMaybe<PrequalificationFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryProcessedSignOnsAdminArgs {
  filter?: InputMaybe<SignOnFilterInput>
}

/** About the Redwood queries. */
export interface QueryProcessedSignOnsWorkerArgs {
  filter?: InputMaybe<ProcessedSignOnFilterInput>
}

/** About the Redwood queries. */
export interface QueryProjectArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectExistsArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectInductionArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectInductionByIdentifierArgs {
  inductionIdentifier: Scalars['Int']
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectInductionByIdentifierPublicArgs {
  inductionIdentifier: Scalars['Int']
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectInductionByWorkerArgs {
  projectId: Scalars['String']
  workerId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectInductionByWorkerPublicArgs {
  projectId: Scalars['String']
  workerId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectInductionForWorkerArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectInductionRequiresCodeArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectInductionsArgs {
  filter?: InputMaybe<InductionFilterInput>
  pagination?: InputMaybe<PaginationInput>
  projectId: Scalars['String']
  sort?: InputMaybe<InductionSortInput>
}

/** About the Redwood queries. */
export interface QueryProjectInductionsAggregationArgs {
  filter?: InputMaybe<InductionFilterInput>
  pagination?: InputMaybe<PaginationInput>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectLocationArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectLocationPublicArgs {
  id: Scalars['String']
  slug?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryProjectLocationsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectLocationsPublicArgs {
  projectId: Scalars['String']
  slug?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryProjectScheduleItemNotificationDiffAdminArgs {
  items?: InputMaybe<Array<ScheduleItemDtoInputAdmin>>
  projectScheduleId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectScheduleItemAdminArgs {
  projectScheduleItemId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectScheduleAdminArgs {
  projectScheduleId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectSchedulesAdminArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectSmsLogsArgs {
  projectId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryProjectSmsLogsBatchedArgs {
  filter?: InputMaybe<SmsLogFilterInput>
  projectId?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<SmsLogSortInput>
}

/** About the Redwood queries. */
export interface QueryProjectSpecificInductionSettingsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectSpecificPermitSettingsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectSpecificProcoreSettingsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectSpecificSettingsArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectSpecificSiteDiarySettingsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectSpecificUserSettingsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectSpecificWorkerPermitSettingsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectStatsArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryProjectsArgs {
  filter?: InputMaybe<ProjectFilterInput>
  sort?: InputMaybe<ProjectSortInput>
}

/** About the Redwood queries. */
export interface QueryProjectsForBuilderArgs {
  filter?: InputMaybe<ProjectsForBuilderFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<ProjectsForBuilderSortInput>
}

/** About the Redwood queries. */
export interface QueryProjectsForBuilderAggregationArgs {
  filter?: InputMaybe<ProjectsForBuilderFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryPublicCompanySubcontractorsArgs {
  hasSubcontractorEnabledRegisters?: InputMaybe<Scalars['Boolean']>
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicEmergencyFromMessageArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicPlatformActionSettingsArgs {
  builderId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicPlatformActionSettingsByProjectArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicPlatformActionViaChecklistResourceLinkArgs {
  id: Scalars['String']
  resourceLinkId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicProjectArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicProjectsForSubcontractorArgs {
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicSubcontractorArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicSubcontractorPlatformActionArgs {
  platformActionId: Scalars['String']
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicSubcontractorPlatformActionsArgs {
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicSubcontractorSettingsArgs {
  builderId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicTemplateResponseArgs {
  id: Scalars['String']
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryPublicTemplateResponsesArgs {
  filter?: InputMaybe<PublicTemplateResponseFilterInput>
  pagination?: InputMaybe<PaginationInput>
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterArgs {
  filter?: InputMaybe<RegisterFilterInput>
  identifierPrefix: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterItemArgs {
  identifier: Scalars['Int']
  identifierPrefix: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterItemBookingArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterItemBookingsArgs {
  filter?: InputMaybe<RegisterItemBookingFilterInput>
}

/** About the Redwood queries. */
export interface QueryRegisterItemTypeArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterItemTypePublicArgs {
  id: Scalars['String']
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterItemTypesArgs {
  filter?: InputMaybe<RegisterItemTypeFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<RegisterItemTypeSortInput>
}

/** About the Redwood queries. */
export interface QueryRegisterItemTypesAggregationArgs {
  filter?: InputMaybe<RegisterItemTypeFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryRegisterItemTypesPublicArgs {
  filter?: InputMaybe<RegisterItemTypePublicFilterInput>
  pagination?: InputMaybe<PaginationInput>
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterItemPublicArgs {
  id: Scalars['String']
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterItemWorkerArgs {
  id: Scalars['String']
  registerId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterItemsArgs {
  filter?: InputMaybe<RegisterItemFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<RegisterItemSortInput>
}

/** About the Redwood queries. */
export interface QueryRegisterItemsAggregationArgs {
  filter?: InputMaybe<RegisterItemFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryRegisterItemsPublicArgs {
  projectId: Scalars['String']
  registerId?: InputMaybe<Scalars['String']>
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterPublicArgs {
  id: Scalars['String']
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegisterWorkerArgs {
  id: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryRegistersArgs {
  filter?: InputMaybe<RegisterFilterInput>
}

/** About the Redwood queries. */
export interface QueryRegistersNavArgs {
  filter?: InputMaybe<RegisterFilterInput>
}

/** About the Redwood queries. */
export interface QueryRegistersPublicArgs {
  builderId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRegistersWorkerArgs {
  filter?: InputMaybe<RegistersWorkerFilterInput>
}

/** About the Redwood queries. */
export interface QueryResourceLinkArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryResourceLinkByResourceArgs {
  filter: ResourceLinkByResourceFilterInput
}

/** About the Redwood queries. */
export interface QueryResourceLinkBySlugArgs {
  slug: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryRoleArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySaAdminUserArgs {
  input?: InputMaybe<SaAdminUserInput>
}

/** About the Redwood queries. */
export interface QuerySaBuilderArgs {
  id?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QuerySaBuildersArgs {
  filter?: InputMaybe<BuilderFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<BuilderSortInput>
}

/** About the Redwood queries. */
export interface QuerySaBuildersAggregationArgs {
  filter?: InputMaybe<BuilderFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QuerySaGetDashboardDataArgs {
  filter?: InputMaybe<FilterInput>
  input: SaDashboardDataInput
}

/** About the Redwood queries. */
export interface QuerySaProjectsByBuilderArgs {
  builderId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryScheduleArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryScheduledJobArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryScheduledJobsArgs {
  scheduleId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryScheduledJobsForProjectArgs {
  filter?: InputMaybe<ScheduledJobFilterInput>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySchedulesArgs {
  filter?: InputMaybe<SchedulesFilterInput>
}

/** About the Redwood queries. */
export interface QuerySchedulesByTemplateArgs {
  projectId?: InputMaybe<Scalars['String']>
  templateId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySearchCompaniesArgs {
  input: SearchCompaniesInput
}

/** About the Redwood queries. */
export interface QuerySignOnArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySignOnsArgs {
  filter?: InputMaybe<SignOnFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SignOnSortInput>
}

/** About the Redwood queries. */
export interface QuerySignOnsAggregationArgs {
  filter?: InputMaybe<SignOnFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QuerySignOnsByProjectArgs {
  filter?: InputMaybe<SignOnFilterInput>
  pagination?: InputMaybe<PaginationInput>
  projectId: Scalars['String']
  sort?: InputMaybe<SignOnSortInput>
}

/** About the Redwood queries. */
export interface QuerySignOnsByProjectAndDateArgs {
  filter?: InputMaybe<SignOnFilterInput>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySiteDiariesArgs {
  filter?: InputMaybe<SiteDiaryFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SiteDiarySortInput>
}

/** About the Redwood queries. */
export interface QuerySiteDiariesAggregationArgs {
  filter?: InputMaybe<SiteDiaryFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SiteDiarySortInput>
}

/** About the Redwood queries. */
export interface QuerySiteDiaryArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySiteDiaryByDayArgs {
  date: Scalars['String']
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySmsBatchArgs {
  batchId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySmsLogsReportArgs {
  projectId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QuerySubcontractorArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySubcontractorFilterAggregationArgs {
  filter?: InputMaybe<SubcontractorFilterInput>
  projectId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QuerySubcontractorProjectSchedulePublicArgs {
  projectScheduleId: Scalars['String']
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySubcontractorProjectSchedulesPublicArgs {
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySubcontractorSuggestArgs {
  projectId: Scalars['String']
  text: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySubcontractorSwmsSettingsArgs {
  projectId?: InputMaybe<Scalars['String']>
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySubcontractorsByBuilderArgs {
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<SubcontractorSortInput>
}

/** About the Redwood queries. */
export interface QuerySubcontractorsByBuilderAggregationArgs {
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<SubcontractorSortInput>
}

/** About the Redwood queries. */
export interface QuerySubcontractorsByProjectArgs {
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  projectId: Scalars['String']
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<SubcontractorSortInput>
}

/** About the Redwood queries. */
export interface QuerySubcontractorsByProjectAggregationArgs {
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  projectId: Scalars['String']
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<SubcontractorSortInput>
}

/** About the Redwood queries. */
export interface QuerySubcontractorsPublicArgs {
  builderId: Scalars['String']
  filter?: InputMaybe<SubcontractorFilterInputPublic>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QuerySwmsDocArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySwmsDocForWorkerArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySwmsDocLogsArgs {
  filter?: InputMaybe<SwmsDocLogsFilterInput>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySwmsDocVisitorArgs {
  documentId: Scalars['String']
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySwmsDocsArgs {
  filter?: InputMaybe<SwmsFilterInput>
  pagination?: InputMaybe<PaginationInput>
  projectId?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<SwmsSortInput>
}

/** About the Redwood queries. */
export interface QuerySwmsDocsAggregationArgs {
  filter?: InputMaybe<SwmsFilterInput>
  pagination?: InputMaybe<PaginationInput>
  projectId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QuerySwmsInProgressArgs {
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySwmsTemplateResponseArgs {
  id: Scalars['String']
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QuerySwmsTemplatesArgs {
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTasksArgs {
  date?: InputMaybe<Scalars['Date']>
  filter?: InputMaybe<DateFilterInput>
  flags?: InputMaybe<Flags>
  projectId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryTemplateArgs {
  archivedFilter?: InputMaybe<ArchivedFilter>
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTemplateAsWorkerArgs {
  id: Scalars['String']
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTemplateFromMarketplaceArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTemplateOrLibraryTemplateArgs {
  projectId?: InputMaybe<Scalars['String']>
  templateType: TemplateType
}

/** About the Redwood queries. */
export interface QueryTemplateResponseArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTemplateResponsesArgs {
  filter?: InputMaybe<TemplateResponseFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<TemplateResponseSortInput>
}

/** About the Redwood queries. */
export interface QueryTemplateResponsesAggregateStatsArgs {
  filter?: InputMaybe<TemplateResponseFilterInput>
}

/** About the Redwood queries. */
export interface QueryTemplateResponsesAggregationArgs {
  filter?: InputMaybe<TemplateResponseFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<TemplateResponseSortInput>
}

/** About the Redwood queries. */
export interface QueryTemplatesArgs {
  filter?: InputMaybe<TemplateFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<TemplateSortInput>
}

/** About the Redwood queries. */
export interface QueryTemplatesAggregationArgs {
  filter?: InputMaybe<TemplateFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryTemplatesPublicArgs {
  filter?: InputMaybe<TemplateFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<TemplateSortInput>
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTicketArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTicketWalletShareArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTicketWalletSharePublicArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTicketsByWorkerArgs {
  workerId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTicketsByWorkersArgs {
  filter?: InputMaybe<TicketFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<TicketSortInput>
}

/** About the Redwood queries. */
export interface QueryTicketsByWorkersAggregationArgs {
  filter?: InputMaybe<TicketFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<TicketSortInput>
}

/** About the Redwood queries. */
export interface QueryTimesheetArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTimesheetGroupArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryTimesheetsArgs {
  filter: TimesheetEntryFilterInput
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<TimesheetEntrySortInput>
}

/** About the Redwood queries. */
export interface QueryTimesheetsAggregationArgs {
  filter: TimesheetEntryFilterInput
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryTodaysPreStartsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryToolboxArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryToolboxInviteArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryToolboxInviteByWorkerArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryToolboxInvitesByToolboxArgs {
  toolboxId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryToolboxesByProjectArgs {
  filter?: InputMaybe<ToolboxFilterInput>
  pagination?: InputMaybe<PaginationInput>
  projectId: Scalars['String']
  sort?: InputMaybe<ToolboxSortInput>
}

/** About the Redwood queries. */
export interface QueryToolboxesByProjectAggregationArgs {
  filter?: InputMaybe<ToolboxFilterInput>
  pagination?: InputMaybe<PaginationInput>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryVisitorArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryVisitorsOnSiteArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWidgetActivityArgs {
  filter: WidgetFilter
}

/** About the Redwood queries. */
export interface QueryWidgetFollowUpArgs {
  filter: WidgetFilter
}

/** About the Redwood queries. */
export interface QueryWidgetMetabaseArgs {
  buildPassWidgetId: Scalars['String']
  filter: WidgetFilter
}

/** About the Redwood queries. */
export interface QueryWidgetReportingArgs {
  filter: WidgetFilter
  settings: WidgetReportingSettingsInput
}

/** About the Redwood queries. */
export interface QueryWidgetToReviewArgs {
  filter: WidgetFilter
}

/** About the Redwood queries. */
export interface QueryWorkerArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkerByProjectArgs {
  id: Scalars['String']
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkerChecklistSettingsArgs {
  projectId: Scalars['String']
  sanitise?: InputMaybe<Scalars['Boolean']>
}

/** About the Redwood queries. */
export interface QueryWorkerDocumentsArgs {
  projectId: Scalars['String']
  subcontractorId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryWorkerProjectArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkerSignOnStatusArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkerSignOnsArgs {
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<WorkerSignOnSortInput>
  workerId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryWorkerSignOnsAggregationArgs {
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<WorkerSignOnSortInput>
  workerId?: InputMaybe<Scalars['String']>
}

/** About the Redwood queries. */
export interface QueryWorkerSignOnsByProjectArgs {
  filter?: InputMaybe<SignOnFilterInput>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkerSignOnsTodayArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkerSignaturesArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkerTemplateResponseArgs {
  id: Scalars['String']
  sanitise?: InputMaybe<Scalars['Boolean']>
}

/** About the Redwood queries. */
export interface QueryWorkerTemplateResponsesArgs {
  filter?: InputMaybe<WorkerTemplateResponseFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sanitise?: InputMaybe<Scalars['Boolean']>
}

/** About the Redwood queries. */
export interface QueryWorkerTemplateResponsesAggregationArgs {
  filter?: InputMaybe<WorkerTemplateResponseFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryWorkerTicketReviewStatusesArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkerTimesheetSettingsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkerToolboxArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkerToolboxesByProjectArgs {
  filter?: InputMaybe<DateFilterInput>
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkersArgs {
  filter?: InputMaybe<WorkersFilterInput>
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<WorkerSortInput>
}

/** About the Redwood queries. */
export interface QueryWorkersAggregationArgs {
  filter?: InputMaybe<WorkersFilterInput>
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<WorkerSortInput>
}

/** About the Redwood queries. */
export interface QueryWorkersByProjectArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkersBySubcontractorArgs {
  subcontractorId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkersOnSiteArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkersWithInductionArgs {
  filter?: InputMaybe<WorkersWithResourceFilterInput>
  inductionStatus?: InputMaybe<InductionStatus>
  inductionType: InductionType
}

/** About the Redwood queries. */
export interface QueryWorkersWithProjectSignonsArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkersWithSignonArgs {
  filter?: InputMaybe<WorkersWithResourceFilterInput>
}

/** About the Redwood queries. */
export interface QueryWorkersWorkerArgs {
  projectId: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkflowArgs {
  id: Scalars['String']
}

/** About the Redwood queries. */
export interface QueryWorkflowExecutionsArgs {
  filter?: InputMaybe<WorkflowExecutionFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<WorkflowExecutionSortInput>
}

/** About the Redwood queries. */
export interface QueryWorkflowExecutionsAggregationArgs {
  filter?: InputMaybe<WorkflowExecutionFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryWorkflowsArgs {
  filter?: InputMaybe<WorkflowFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<WorkflowSortInput>
}

/** About the Redwood queries. */
export interface QueryWorkflowsAggregationArgs {
  filter?: InputMaybe<WorkflowFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** About the Redwood queries. */
export interface QueryYearInReviewArgs {
  filter: YearInReviewFilterInput
}

/** About the Redwood queries. */
export interface QueryYearInReviewForBuilderArgs {
  builderId: Scalars['String']
  filter: YearInReviewFilterInput
}

/** About the Redwood queries. */
export interface QueryYearInReviewPublicArgs {
  builderId: Scalars['String']
}

export interface QueryAgaveProjectsInput {
  integrationType: IntegrationType
}

export interface QueryAgaveRootFolderInput {
  integrationType: IntegrationType
  projectId: Scalars['String']
}

export interface QueryAgaveVendorsInput {
  integrationType: IntegrationType
}

export enum RadioBlockOptionType {
  Button = 'BUTTON',
  Default = 'DEFAULT',
}

export interface RadioCaptureBlock extends CaptureExtra, TemplateBlockBase {
  __typename?: 'RadioCaptureBlock'
  attachments?: Maybe<Array<Maybe<Attachment>>>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  optionType?: Maybe<RadioBlockOptionType>
  radioButtons?: Maybe<Array<Maybe<CheckboxRadioField>>>
  type: TemplateBlockTypes
}

/**
 * The RedwoodJS Root Schema
 *
 * Defines details about RedwoodJS such as the current user and version information.
 */
export interface Redwood {
  __typename?: 'Redwood'
  /** The current user. */
  currentUser?: Maybe<Scalars['JSON']>
  /** The version of Prisma. */
  prismaVersion?: Maybe<Scalars['String']>
  /** The version of Redwood. */
  version?: Maybe<Scalars['String']>
}

export interface Register {
  __typename?: 'Register'
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  identifierPrefix: Scalars['String']
  itemCount: Scalars['Int']
  items: Array<Maybe<RegisterItem>>
  name: Scalars['String']
  projects?: Maybe<Array<Maybe<Project>>>
  settings?: Maybe<RegisterSettings>
  template: Template
  templateId: Scalars['String']
  typeLibraryTemplate?: Maybe<LibraryTemplate>
  typeLibraryTemplateId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface RegisterFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  searchString?: InputMaybe<Scalars['String']>
}

export interface RegisterItem {
  __typename?: 'RegisterItem'
  archivedAt?: Maybe<Scalars['DateTime']>
  assignees?: Maybe<Array<Maybe<Assignee>>>
  bookings?: Maybe<Array<Maybe<RegisterItemBooking>>>
  checklistTableBlocks?: Maybe<Scalars['JSON']>
  checklistTemplateResponses?: Maybe<Array<Maybe<TemplateResponse>>>
  checklistTemplates?: Maybe<Array<Maybe<Template>>>
  createdAt: Scalars['DateTime']
  followUpAt?: Maybe<Scalars['DateTime']>
  fullIdentifier: Scalars['String']
  id: Scalars['String']
  identifier: Scalars['Int']
  name: Scalars['String']
  projects?: Maybe<Array<Maybe<Project>>>
  register: Register
  registerId: Scalars['String']
  registerItemType?: Maybe<RegisterItemType>
  reviewTemplateResponse?: Maybe<TemplateResponse>
  reviewTemplateResponseId?: Maybe<Scalars['String']>
  status?: Maybe<RegisterItemStatus>
  templateResponse: TemplateResponse
  templateResponseId: Scalars['String']
  typeTemplateResponse?: Maybe<TemplateResponse>
  typeTemplateResponseId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  uploadTemplateResponse?: Maybe<TemplateResponse>
  uploadTemplateResponseId?: Maybe<Scalars['String']>
}

export interface RegisterItemBooking {
  __typename?: 'RegisterItemBooking'
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  endDate: Scalars['DateTime']
  id: Scalars['String']
  registerItem: RegisterItem
  registerItemId: Scalars['String']
  startDate: Scalars['DateTime']
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface RegisterItemBookingFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  registerId?: InputMaybe<Scalars['String']>
}

export interface RegisterItemEntity {
  __typename?: 'RegisterItemEntity'
  archivedAt?: Maybe<Scalars['DateTime']>
  checklistResourceLinks?: Maybe<Array<Maybe<ResourceLinkEntity>>>
  checklistTemplates?: Maybe<Array<Maybe<TemplateEntity>>>
  createdAt: Scalars['DateTime']
  followUpAt?: Maybe<Scalars['DateTime']>
  fullIdentifier: Scalars['String']
  id: Scalars['String']
  identifier: Scalars['Int']
  name: Scalars['String']
  templateResponse: TemplateResponseResourceLink
  updatedAt: Scalars['DateTime']
}

export interface RegisterItemFilterInput {
  archivedFilter?: InputMaybe<ArchivedFilter>
  assignees?: InputMaybe<Array<InputMaybe<AssigneeInput>>>
  excludeArchivedRegisters?: InputMaybe<Scalars['Boolean']>
  identifierPrefix?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  searchString?: InputMaybe<Scalars['String']>
}

export interface RegisterItemSortInput {
  createdAt?: InputMaybe<SortOrder>
  followUpAt?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export enum RegisterItemStatus {
  ChangesRequested = 'CHANGES_REQUESTED',
  Reviewed = 'REVIEWED',
  WaitingReview = 'WAITING_REVIEW',
}

export interface RegisterItemType {
  __typename?: 'RegisterItemType'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  builderId: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  linkedChecklists: Array<Template>
  name: Scalars['String']
  registerItems: Array<RegisterItem>
  reviewTemplate?: Maybe<Template>
  reviewTemplateId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  uploadTemplate?: Maybe<Template>
  uploadTemplateId?: Maybe<Scalars['String']>
}

export interface RegisterItemTypeFilterInput {
  archivedFilter?: InputMaybe<ArchivedFilter>
  searchString?: InputMaybe<Scalars['String']>
}

export interface RegisterItemTypePublicFilterInput {
  archivedFilter?: InputMaybe<ArchivedFilter>
  searchString?: InputMaybe<Scalars['String']>
}

export interface RegisterItemTypeSortInput {
  createdAt?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export enum RegisterItemTypeTemplate {
  Review = 'REVIEW',
  Upload = 'UPLOAD',
}

export interface RegisterItemTypePublic {
  __typename?: 'RegisterItemType_Public'
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  linkedChecklists: Array<TemplateEntity>
  name: Scalars['String']
  reviewTemplate?: Maybe<Template>
  reviewTemplateId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  uploadTemplate?: Maybe<Template>
  uploadTemplateId?: Maybe<Scalars['String']>
}

export interface RegisterItemPublic {
  __typename?: 'RegisterItem_Public'
  archivedAt?: Maybe<Scalars['DateTime']>
  checklistTemplates: Array<TemplateEntity>
  companyRegisterItem?: Maybe<CompanyRegisterItem>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  name: Scalars['String']
  projects?: Maybe<Array<PublicProject>>
  register?: Maybe<Register>
  registerItemType?: Maybe<RegisterItemType>
  status: Scalars['String']
  templateResponse?: Maybe<Scalars['JSON']>
  typeTemplateResponse?: Maybe<Scalars['JSON']>
  updatedAt: Scalars['DateTime']
  uploadTemplateResponse?: Maybe<Scalars['JSON']>
}

export interface RegisterItemResourceLink {
  __typename?: 'RegisterItem_ResourceLink'
  archivedAt?: Maybe<Scalars['DateTime']>
  checklistResourceLinks?: Maybe<Array<Maybe<ResourceLinkEntity>>>
  checklistTemplates?: Maybe<Array<Maybe<TemplateEntity>>>
  createdAt: Scalars['DateTime']
  followUpAt?: Maybe<Scalars['DateTime']>
  fullIdentifier: Scalars['String']
  id: Scalars['String']
  identifier: Scalars['Int']
  name: Scalars['String']
  templateResponse: TemplateResponseResourceLink
  updatedAt: Scalars['DateTime']
}

export interface RegisterItemWorker {
  __typename?: 'RegisterItem_Worker'
  archivedAt?: Maybe<Scalars['DateTime']>
  checklistTemplates?: Maybe<Array<Maybe<TemplateEntity>>>
  createdAt: Scalars['DateTime']
  followUpAt?: Maybe<Scalars['DateTime']>
  fullIdentifier: Scalars['String']
  id: Scalars['String']
  identifier: Scalars['Int']
  name: Scalars['String']
  register: RegisterWorker
  status: RegisterItemStatus
  templateResponse?: Maybe<TemplateResponseEntity>
  typeTemplateResponse?: Maybe<TemplateResponseEntity>
  updatedAt: Scalars['DateTime']
}

export interface RegisterSettings {
  __typename?: 'RegisterSettings'
  canAssignChecklists?: Maybe<Scalars['Boolean']>
  canAssignItemsToProject?: Maybe<Scalars['Boolean']>
  canAssignMultipleProjects?: Maybe<Scalars['Boolean']>
  canSubcontractorsManageItems?: Maybe<Scalars['Boolean']>
  checklistColumns?: Maybe<Array<ChecklistColumn>>
  hideAssignees?: Maybe<Scalars['Boolean']>
  hideFollowUpDate?: Maybe<Scalars['Boolean']>
  hideIdentifier?: Maybe<Scalars['Boolean']>
  hideName?: Maybe<Scalars['Boolean']>
}

export interface RegisterSettingsInput {
  canAssignChecklists?: InputMaybe<Scalars['Boolean']>
  canAssignItemsToProject?: InputMaybe<Scalars['Boolean']>
  canAssignMultipleProjects?: InputMaybe<Scalars['Boolean']>
  canSubcontractorsManageItems?: InputMaybe<Scalars['Boolean']>
  checklistColumns?: InputMaybe<Array<ChecklistColumnInput>>
  hideAssignees?: InputMaybe<Scalars['Boolean']>
  hideFollowUpDate?: InputMaybe<Scalars['Boolean']>
  hideIdentifier?: InputMaybe<Scalars['Boolean']>
  hideName?: InputMaybe<Scalars['Boolean']>
}

export interface RegisterPublic {
  __typename?: 'Register_Public'
  id: Scalars['String']
  name: Scalars['String']
  settings?: Maybe<RegisterSettings>
  template: TemplateEntity
  typeLibraryTemplate?: Maybe<LibraryTemplate>
}

export interface RegisterWorker {
  __typename?: 'Register_Worker'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: BuilderEntity
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  identifierPrefix: Scalars['String']
  items: Array<RegisterItemWorker>
  name: Scalars['String']
  typeLibraryTemplateId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface RegistersWorkerFilterInput {
  projectId?: InputMaybe<Scalars['String']>
}

export interface RejectPermitInputAdmin {
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  message: Scalars['String']
}

export interface RelationPair {
  integrationIdentifier: Scalars['String']
  projectId: Scalars['String']
}

export interface ReportDimensionData {
  __typename?: 'ReportDimensionData'
  dimension?: Maybe<WidgetReportDimension>
  metric: WidgetReportMetric
  number: Scalars['Float']
  seriesType?: Maybe<Scalars['String']>
  suffix?: Maybe<Scalars['String']>
  tableData?: Maybe<Array<ReportTableData>>
}

export interface ReportTableData {
  __typename?: 'ReportTableData'
  id: Scalars['String']
  parentId?: Maybe<Scalars['String']>
  resourceType: WidgetReportResource
  row: Scalars['JSON']
}

export enum Resource {
  AccessControl = 'ACCESS_CONTROL',
  AccessControlHardware = 'ACCESS_CONTROL_HARDWARE',
  AccessProfile = 'ACCESS_PROFILE',
  AccessProfileTemplate = 'ACCESS_PROFILE_TEMPLATE',
  AdminUser = 'ADMIN_USER',
  Attachment = 'ATTACHMENT',
  Builder = 'BUILDER',
  BuilderWorkerConnection = 'BUILDER_WORKER_CONNECTION',
  Checklist = 'CHECKLIST',
  CompanyRegisterItem = 'COMPANY_REGISTER_ITEM',
  ConversationMessage = 'CONVERSATION_MESSAGE',
  ConversationThread = 'CONVERSATION_THREAD',
  Defect = 'DEFECT',
  Document = 'DOCUMENT',
  DocumentSignature = 'DOCUMENT_SIGNATURE',
  File = 'FILE',
  FileUploadInvite = 'FILE_UPLOAD_INVITE',
  Gallery = 'GALLERY',
  Induction = 'INDUCTION',
  InductionInvite = 'INDUCTION_INVITE',
  InductionTemplate = 'INDUCTION_TEMPLATE',
  InsuranceDoc = 'INSURANCE_DOC',
  Itp = 'ITP',
  LibraryTemplate = 'LIBRARY_TEMPLATE',
  MsdsDoc = 'MSDS_DOC',
  Permit = 'PERMIT',
  PermitType = 'PERMIT_TYPE',
  PermitWorker = 'PERMIT_WORKER',
  PlatformAction = 'PLATFORM_ACTION',
  Prequalification = 'PREQUALIFICATION',
  PreStart = 'PRE_START',
  ProfilePicture = 'PROFILE_PICTURE',
  Project = 'PROJECT',
  ProjectLocation = 'PROJECT_LOCATION',
  ProjectSchedule = 'PROJECT_SCHEDULE',
  ProjectScheduleItem = 'PROJECT_SCHEDULE_ITEM',
  ProjectWorkerConnection = 'PROJECT_WORKER_CONNECTION',
  Register = 'REGISTER',
  RegisterItem = 'REGISTER_ITEM',
  RegisterItemType = 'REGISTER_ITEM_TYPE',
  Schedule = 'SCHEDULE',
  ScheduledJob = 'SCHEDULED_JOB',
  SdsChecklist = 'SDS_CHECKLIST',
  SignOn = 'SIGN_ON',
  SiteDiary = 'SITE_DIARY',
  SmsLog = 'SMS_LOG',
  Staff = 'STAFF',
  Subcontractor = 'SUBCONTRACTOR',
  SwmsChecklist = 'SWMS_CHECKLIST',
  SwmsDoc = 'SWMS_DOC',
  SwmsDocLog = 'SWMS_DOC_LOG',
  Task = 'TASK',
  Template = 'TEMPLATE',
  TemplateResponse = 'TEMPLATE_RESPONSE',
  Ticket = 'TICKET',
  TicketReview = 'TICKET_REVIEW',
  Timesheet = 'TIMESHEET',
  TimesheetGroup = 'TIMESHEET_GROUP',
  Toolbox = 'TOOLBOX',
  User = 'USER',
  WhiteLabelling = 'WHITE_LABELLING',
  Worker = 'WORKER',
  WorkerBuilderMetadata = 'WORKER_BUILDER_METADATA',
  WorkerConnection = 'WORKER_CONNECTION',
  WorkerDocument = 'WORKER_DOCUMENT',
  Workflow = 'WORKFLOW',
  WorkflowStep = 'WORKFLOW_STEP',
}

export interface ResourceLink {
  __typename?: 'ResourceLink'
  active: Scalars['Boolean']
  builder?: Maybe<Builder>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  project?: Maybe<Project>
  registerItem?: Maybe<RegisterItem>
  registerItemId?: Maybe<Scalars['String']>
  slug: Scalars['String']
  template?: Maybe<Template>
  templateId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface ResourceLinkByResourceFilterInput {
  projectId?: InputMaybe<Scalars['String']>
  relatedResources?: InputMaybe<ResourceLinkRelatedResourceInput>
  resourceId: Scalars['String']
  resourceType: ResourceLinkFilterType
}

export interface ResourceLinkEntity {
  __typename?: 'ResourceLinkEntity'
  active: Scalars['Boolean']
  builder?: Maybe<BuilderResourceLink>
  companyInduction?: Maybe<CompanyInductionResourceLink>
  companyInductionId?: Maybe<Scalars['String']>
  contact?: Maybe<ContactResourceLink>
  createdAt: Scalars['DateTime']
  defects?: Maybe<Array<Maybe<DefectResourceLink>>>
  documentFolder?: Maybe<DocumentFolderResourceLink>
  documentFolderId?: Maybe<Scalars['String']>
  extraData?: Maybe<Scalars['JSON']>
  id: Scalars['String']
  permit?: Maybe<PermitResourceLink>
  permitId?: Maybe<Scalars['String']>
  preStart?: Maybe<PreStartResourceLink>
  preStartId?: Maybe<Scalars['String']>
  prequalification?: Maybe<PrequalificationResourceLink>
  project?: Maybe<ProjectResourceLink>
  registerItem?: Maybe<RegisterItemEntity>
  registerItemId?: Maybe<Scalars['String']>
  registerItemResourceLink?: Maybe<RegisterItemResourceLink>
  signOns?: Maybe<Array<Maybe<SignOnResourceLink>>>
  siteDiary?: Maybe<SiteDiaryResourceLink>
  siteDiaryId?: Maybe<Scalars['String']>
  siteInduction?: Maybe<SiteInductionResourceLink>
  siteInductionId?: Maybe<Scalars['String']>
  slug: Scalars['String']
  swmsDoc?: Maybe<SwmsDocEntity>
  swmsDocId?: Maybe<Scalars['String']>
  template?: Maybe<TemplateEntity>
  templateId?: Maybe<Scalars['String']>
  templateResponse?: Maybe<TemplateResponseResourceLink>
  templateResponseId?: Maybe<Scalars['String']>
  toolbox?: Maybe<ToolboxResourceLink>
  toolboxId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type ResourceLinkEntityResult =
  | DeactivatedResourceLinkEntity
  | ExpiredResourceLinkEntity
  | ResourceLinkEntity

export enum ResourceLinkFilterType {
  DocumentFolder = 'DOCUMENT_FOLDER',
  Template = 'TEMPLATE',
}

export type ResourceLinkRelatedResource = RegisterItem

export interface ResourceLinkRelatedResourceInput {
  registerItemId?: InputMaybe<Scalars['String']>
}

export enum ResourceLinkType {
  Checklist = 'checklist',
  CompanyInduction = 'companyInduction',
  Defects = 'defects',
  DocumentFolder = 'documentFolder',
  Permit = 'permit',
  PreStart = 'preStart',
  Prequalification = 'prequalification',
  ProjectSignOnPoster = 'projectSignOnPoster',
  RegisterItem = 'registerItem',
  RegisterItemChecklist = 'registerItemChecklist',
  SignOns = 'signOns',
  SiteDiary = 'siteDiary',
  SiteInduction = 'siteInduction',
  SubbieDefects = 'subbieDefects',
  SwmsBuilder = 'swmsBuilder',
  SwmsDoc = 'swmsDoc',
  SwmsTemplateResponse = 'swmsTemplateResponse',
  TemplateCapture = 'templateCapture',
  TemplateResponseDisplay = 'templateResponseDisplay',
  Toolbox = 'toolbox',
}

export interface ResourceMeta {
  __typename?: 'ResourceMeta'
  adminUser?: Maybe<AdminUser>
  archivedAt?: Maybe<Scalars['DateTime']>
  builder?: Maybe<Builder>
  createdAt: Scalars['DateTime']
  linkedResources?: Maybe<LinkedResourceMeta>
  project?: Maybe<Project>
  resource: AuditResource
  subcontractor?: Maybe<Subcontractor>
  updatedAt: Scalars['DateTime']
  user?: Maybe<User>
  worker?: Maybe<Worker>
}

export interface ResourceTag {
  __typename?: 'ResourceTag'
  attachmentCount: Scalars['Int']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  name: Scalars['String']
  projectUsageCount: Scalars['Int']
  slug: Scalars['String']
  subcontractorUsageCount: Scalars['Int']
  updatedAt: Scalars['DateTime']
}

export enum ResourceTagResourceTypeAdmin {
  Attachment = 'ATTACHMENT',
  Project = 'PROJECT',
  Subcontractor = 'SUBCONTRACTOR',
}

export interface ResourceTagsFilterInputAdmin {
  resourceType?: InputMaybe<ResourceTagResourceTypeAdmin>
}

export interface RichTextCaptureBlock extends CaptureExtra, TemplateBlockBase {
  __typename?: 'RichTextCaptureBlock'
  attachments?: Maybe<Array<Maybe<Attachment>>>
  characterLimit?: Maybe<Scalars['Int']>
  defaultValue?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
  value?: Maybe<Scalars['String']>
}

export interface RichTextDisplayBlock extends TemplateBlockBase {
  __typename?: 'RichTextDisplayBlock'
  content?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
}

export interface Role {
  __typename?: 'Role'
  auth0Identifier?: Maybe<Scalars['String']>
  builderId?: Maybe<Scalars['String']>
  countOfUsers: Scalars['Int']
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  name: Scalars['String']
  permissions: Array<Permission>
  updatedAt?: Maybe<Scalars['DateTime']>
}

/** SWMS module settings for the entire Builder */
export interface SwmsSettings {
  __typename?: 'SWMSSettings'
  /** Allow setting an expiration on a SWMS signature */
  allowExpiringSWMS: Scalars['Boolean']
  /** Whether the option to override an existing template is allowed */
  allowOverridingExistingSWMSTemplates: Scalars['Boolean']
  /** Whether the option to save a new template is allowed */
  allowSavingNewSWMSTemplates: Scalars['Boolean']
  /** Whether to auto approve SWMS for the builder */
  autoApproveSWMSForBuilder: Scalars['Boolean']
  /** Whether to auto approve SWMS for subcontractors from a shared template */
  autoApproveSWMSForSubcontractorFromTemplate: Scalars['Boolean']
  /** The default list of selectable responsible values for the SWMS builder */
  defaultSWMSHazardResponsible?: Maybe<Array<Scalars['String']>>
  /** Include the audit log activity in the PDF export */
  includeSWMSActivityInPDFExport: Scalars['Boolean']
  /** Include the AdminUser filled in SWMS checklist in the PDF export */
  includeSWMSChecklistInPDFExport: Scalars['Boolean']
  /** The default number of days to expire a library SWMS */
  librarySwmsExpiryDays?: Maybe<Scalars['Int']>
  /** Shared SWMS templates with subcontractors */
  sharedSWMSTemplateIds?: Maybe<Array<Scalars['String']>>
  /** Show BuildPass Template as an option when creating a SWMS */
  showBuildPassSWMSTemplatesOption: Scalars['Boolean']
  /** Show 'Start from Scratch' as an option when creating a SWMS */
  showStartFromScratchSWMSOption: Scalars['Boolean']
}

export interface SwmsUsage {
  __typename?: 'SWMSUsage'
  pendingReview: Scalars['Int']
  requestedChanges: Scalars['Int']
  reviewed: Scalars['Int']
  total: Scalars['Int']
}

export interface SaAdminUserInput {
  email?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['String']>
}

export interface SaDashboardDataInput {
  builderId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
}

export interface SaUpdateBuilderInput {
  defaultLanguage?: InputMaybe<Scalars['String']>
  defaultLocale?: InputMaybe<SupportedLocaleCountryCode>
  defaultTimezone?: InputMaybe<Scalars['String']>
  hubspotDealIdentifier?: InputMaybe<Scalars['String']>
  isDemo?: InputMaybe<Scalars['Boolean']>
  isSeeded?: InputMaybe<Scalars['Boolean']>
  isTrial?: InputMaybe<Scalars['Boolean']>
  modules?: InputMaybe<Array<BuildPassModule>>
  name: Scalars['String']
  stripeIdentifier?: InputMaybe<Scalars['String']>
  subscription?: InputMaybe<BuilderTier>
  trialExpiresAt?: InputMaybe<Scalars['DateTime']>
}

export interface Schedule {
  __typename?: 'Schedule'
  archivedAt?: Maybe<Scalars['DateTime']>
  assignees: Array<Maybe<AdminUser>>
  assigner: AdminUser
  assignerAdminUserId: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  interval?: Maybe<Scalars['String']>
  libraryTemplate?: Maybe<LibraryTemplate>
  libraryTemplateId?: Maybe<Scalars['String']>
  project: Project
  projectId: Scalars['String']
  scheduledJobs: Array<Maybe<ScheduledJob>>
  startDate: Scalars['DateTime']
  status: ScheduleStatus
  template?: Maybe<Template>
  templateId?: Maybe<Scalars['String']>
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export interface ScheduleScheduledJobsArgs {
  processed?: InputMaybe<Scalars['Boolean']>
}

export interface ScheduleItemDtoInputAdmin {
  dependencies?: InputMaybe<Array<ScheduleItemDependencyDtoInputAdmin>>
  description?: InputMaybe<Scalars['String']>
  duration: Scalars['Int']
  id: Scalars['String']
  order: Scalars['Int']
  parentId?: InputMaybe<Scalars['String']>
  startDate: Scalars['DateTime']
  status: ProjectScheduleItemStatus
  subcontractorId?: InputMaybe<Scalars['String']>
  title: Scalars['String']
  type: ProjectScheduleItemType
}

export interface ScheduleItemDtoAdmin {
  __typename?: 'ScheduleItemDTO_Admin'
  changedFields?: Maybe<Array<ProjectScheduleItemChangedField>>
  dependencies?: Maybe<Array<ProjectScheduleDependency>>
  description?: Maybe<Scalars['String']>
  duration: Scalars['Int']
  id: Scalars['String']
  order: Scalars['Int']
  parentId?: Maybe<Scalars['String']>
  startDate: Scalars['DateTime']
  status: ProjectScheduleItemStatus
  subcontractor?: Maybe<Subcontractor>
  subcontractorId?: Maybe<Scalars['String']>
  title: Scalars['String']
  type: ProjectScheduleItemType
}

export interface ScheduleItemDependencyDtoInputAdmin {
  dependencyId: Scalars['String']
  relationship: Scalars['String']
}

export interface ScheduleNotificationInputAdmin {
  action: Scalars['String']
  customMessage?: InputMaybe<Scalars['String']>
  projectScheduleItemId: Scalars['String']
}

export enum ScheduleStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Paused = 'PAUSED',
}

export interface ScheduledJob {
  __typename?: 'ScheduledJob'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  processed: Scalars['Boolean']
  schedule: Schedule
  scheduleId: Scalars['String']
  scheduledFor: Scalars['DateTime']
  templateResponse?: Maybe<TemplateResponse>
  templateResponseId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface ScheduledJobFilterInput {
  futureOnly?: InputMaybe<Scalars['Boolean']>
  processed?: InputMaybe<Scalars['Boolean']>
}

export interface SchedulesFilterInput {
  assigner?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
}

export interface SearchCompaniesInput {
  searchString: Scalars['String']
}

export interface SelectCaptureBlock extends CaptureExtra, TemplateBlockBase {
  __typename?: 'SelectCaptureBlock'
  attachments?: Maybe<Array<Maybe<Attachment>>>
  defaultOption?: Maybe<SelectOptionsField>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  multiSelect?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  options?: Maybe<Array<Maybe<SelectOptionsField>>>
  searchable?: Maybe<Scalars['Boolean']>
  type: TemplateBlockTypes
}

export interface SelectOptionsField {
  __typename?: 'SelectOptionsField'
  label?: Maybe<Scalars['String']>
  selected?: Maybe<Scalars['Boolean']>
  value?: Maybe<Scalars['String']>
}

export interface SendBulkInductionUpdateEmailsInputAdmin {
  customMessage?: InputMaybe<Scalars['String']>
  inductionIds: Array<Scalars['String']>
}

export interface SendFileToBuildxactInput {
  fileName: Scalars['String']
  fileType?: InputMaybe<BuildxactFileType>
  fileUrl: Scalars['String']
  projectId: Scalars['String']
}

export interface SendFileToBuildxactResponse {
  __typename?: 'SendFileToBuildxactResponse'
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export interface SendFileUploadInviteEmailInput {
  contactIds?: InputMaybe<Array<Scalars['String']>>
  customMessage?: InputMaybe<Scalars['String']>
  metadata?: InputMaybe<Scalars['JSON']>
  projectId?: InputMaybe<Scalars['String']>
  subcontractorId: Scalars['String']
}

export interface SendInductionInviteEmailInput {
  contactIds?: InputMaybe<Array<Scalars['String']>>
  customMessage?: InputMaybe<Scalars['String']>
  inviteId: Scalars['String']
  projectId: Scalars['String']
  subcontractorId: Scalars['String']
}

export interface SendInductionUpdateEmailInput {
  customMessage?: InputMaybe<Scalars['String']>
  inductionId: Scalars['String']
}

export interface SendProjectSmsInput {
  message: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
  workerIds: Array<Scalars['String']>
}

export interface SendProjectSmsResponse {
  __typename?: 'SendProjectSmsResponse'
  id: Scalars['String']
}

export interface SendRequestUpdateEmailInput {
  contactIds?: InputMaybe<Array<Scalars['String']>>
  customMessage?: InputMaybe<Scalars['String']>
  documentId: Scalars['String']
  documentType?: InputMaybe<DocumentType>
  subcontractorId: Scalars['String']
}

export interface SendStaffInviteEmailInput {
  customMessage?: InputMaybe<Scalars['String']>
  emails: Array<Scalars['String']>
}

export interface SendTestWelcomeEmailInput {
  customMessage?: InputMaybe<Scalars['String']>
  emails: Array<Scalars['String']>
  metadata?: InputMaybe<Scalars['JSON']>
  projectId: Scalars['String']
}

export interface SendWelcomeEmailInput {
  contactIds: Array<Scalars['String']>
  customMessage?: InputMaybe<Scalars['String']>
  metadata?: InputMaybe<Scalars['JSON']>
  projectId: Scalars['String']
  subcontractorIds: Array<Scalars['String']>
}

export interface SetPremierCompanyAsPrimaryInput {
  company: PremierCompanyInput
}

export interface SetProjectTimingsInput {
  siteTimings?: InputMaybe<Array<InputMaybe<SiteTimingsInput>>>
}

export enum SettingType {
  Builder = 'BUILDER',
  Integration = 'INTEGRATION',
  Module = 'MODULE',
  Project = 'PROJECT',
  User = 'USER',
}

export interface SetupBuildxactAccessTokenInput {
  code: Scalars['String']
}

export interface SignInTokenResponse {
  __typename?: 'SignInTokenResponse'
  expiresAt: Scalars['DateTime']
  token: Scalars['String']
}

export interface SignOffInput {
  contextMetadata?: InputMaybe<ContextMetadataInput>
  signOffDate: Scalars['DateTime']
  signOnId: Scalars['String']
}

export interface SignOn {
  __typename?: 'SignOn'
  archivedAt?: Maybe<Scalars['DateTime']>
  builderGenerated: Scalars['Boolean']
  contextMetadata?: Maybe<ContextMetadata>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  integrationGenerated?: Maybe<Scalars['Boolean']>
  integrationType?: Maybe<Scalars['String']>
  manualSignedOffAt?: Maybe<Scalars['DateTime']>
  manualSignedOnAt?: Maybe<Scalars['DateTime']>
  metadata?: Maybe<Scalars['JSON']>
  preStarts?: Maybe<Array<Maybe<PreStart>>>
  project?: Maybe<Project>
  projectId?: Maybe<Scalars['String']>
  signOnHours?: Maybe<SignOnHours>
  signedOffAt?: Maybe<Scalars['DateTime']>
  updatedAt?: Maybe<Scalars['DateTime']>
  visitor?: Maybe<Visitor>
  visitorId?: Maybe<Scalars['String']>
  worker?: Maybe<Worker>
  workerId?: Maybe<Scalars['String']>
}

export interface SignOnFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  integrationGeneratedOnly?: InputMaybe<Scalars['Boolean']>
  projectId?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  searchString?: InputMaybe<Scalars['String']>
  signedOffFilter?: InputMaybe<SignedOffFilter>
  subcontractorIds?: InputMaybe<Array<Scalars['String']>>
  visitorsOnly?: InputMaybe<Scalars['Boolean']>
  workerIds?: InputMaybe<Array<Scalars['String']>>
  workersOnly?: InputMaybe<Scalars['Boolean']>
}

export interface SignOnHours {
  __typename?: 'SignOnHours'
  hours?: Maybe<Scalars['Float']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export interface SignOnReport {
  __typename?: 'SignOnReport'
  hours?: Maybe<Scalars['Float']>
  id: Scalars['String']
  timeIn: Scalars['DateTime']
  timeOut?: Maybe<Scalars['DateTime']>
}

/** Sign on module settings for the entire Builder */
export interface SignOnSettings {
  __typename?: 'SignOnSettings'
  /** Returns true if workers can be automatically signed on/off based on geolocation */
  geolocationAutoSignOnOffEnabledForAllProjects?: Maybe<Scalars['Boolean']>
  /** Projects that have the Sign On/Off geolocation reminders enabled */
  geolocationSignOnOffRemindersEnabledForAllProjects?: Maybe<Scalars['Boolean']>
  /** Returns true if workers cant sign on until they have their induction approved */
  preventSignOnUntilInductionApproved?: Maybe<Scalars['Boolean']>
  /** If a worker's ticket is expired or has had changes requested it will disable the sign on task */
  preventSignOnWithoutValidTickets?: Maybe<Scalars['Boolean']>
  /** Projects that have the Sign On/Off geolocation reminders enabled */
  projectIdsWithGeolocationSignOnOffRemindersEnabled?: Maybe<
    Array<Scalars['String']>
  >
  /** Projects that have the Sign On QR Code scan requirement disabled */
  projectIdsWithSignOnScanRequirementDisabled?: Maybe<Array<Scalars['String']>>
  /** Returns true if Sign On QR Code scan requirement is disabled for all projects */
  signOnScanRequirementDisabledForAllProjects?: Maybe<Scalars['Boolean']>
}

export interface SignOnSortInput {
  date?: InputMaybe<SortOrder>
  trade?: InputMaybe<SortOrder>
  workerName?: InputMaybe<SortOrder>
}

export interface SignOnStatus {
  __typename?: 'SignOnStatus'
  active?: Maybe<SignOn>
  open?: Maybe<SignOn>
}

export interface SignOnResourceLink {
  __typename?: 'SignOn_ResourceLink'
  builderGenerated: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  integrationGenerated?: Maybe<Scalars['Boolean']>
  manualSignedOffAt?: Maybe<Scalars['DateTime']>
  manualSignedOnAt?: Maybe<Scalars['DateTime']>
  project?: Maybe<ProjectResourceLink>
  signOnHours?: Maybe<SignOnHours>
  signedOffAt?: Maybe<Scalars['DateTime']>
  visitor?: Maybe<VisitorResourceLink>
  worker?: Maybe<WorkerResourceLink>
}

export interface SignOnWorker {
  __typename?: 'SignOn_Worker'
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export interface SignOnsByDate {
  __typename?: 'SignOnsByDate'
  dateIndex: Scalars['String']
  totalSignOns: Scalars['Int']
}

export interface SignOnsBySubcontractorOnDate {
  __typename?: 'SignOnsBySubcontractorOnDate'
  subcontractorId: Scalars['String']
  subcontractorName: Scalars['String']
  totalSignOffs: Scalars['Int']
  totalSignOns: Scalars['Int']
}

export interface SignOnsUsage {
  __typename?: 'SignOnsUsage'
  manual: Scalars['Int']
  total: Scalars['Int']
  visitor: Scalars['Int']
}

export enum SignedOffFilter {
  Both = 'BOTH',
  SignedOffOnly = 'SIGNED_OFF_ONLY',
  SignedOnOnly = 'SIGNED_ON_ONLY',
}

export interface SiteDiary {
  __typename?: 'SiteDiary'
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<User>
  date: Scalars['DateTime']
  id: Scalars['String']
  paginationLinks?: Maybe<SiteDiaryPaginationLinks>
  project: Project
  projectId: Scalars['String']
  signOns?: Maybe<Array<SignOn>>
  statistics?: Maybe<SiteDiaryStatistics>
  templateResponse: TemplateResponse
  templateResponseId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export interface SiteDiaryFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  searchString?: InputMaybe<Scalars['String']>
}

export interface SiteDiaryPaginationLinks {
  __typename?: 'SiteDiaryPaginationLinks'
  next?: Maybe<SiteDiary>
  previous?: Maybe<SiteDiary>
}

export interface SiteDiarySortInput {
  createdAt?: InputMaybe<SortOrder>
  date?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export interface SiteDiaryStatistics {
  __typename?: 'SiteDiaryStatistics'
  hasUploads?: Maybe<Scalars['Boolean']>
  numberOfSubcontractors?: Maybe<Scalars['Float']>
  numberOfWorkers?: Maybe<Scalars['Float']>
  projectCompletionPercentage?: Maybe<Scalars['Int']>
  projectHours?: Maybe<Scalars['Float']>
  temperature?: Maybe<Scalars['Float']>
  totalSignOns?: Maybe<Scalars['Int']>
  updatedAt?: Maybe<Scalars['DateTime']>
  weather?: Maybe<Scalars['String']>
}

export interface SiteDiaryUsage {
  __typename?: 'SiteDiaryUsage'
  inclementWeatherHours?: Maybe<Scalars['Float']>
  numberOfSubcontractors: Scalars['Int']
  numberOfWorkers: Scalars['Int']
  projectHours: Scalars['Float']
  total: Scalars['Int']
}

export interface SiteDiaryResourceLink {
  __typename?: 'SiteDiary_ResourceLink'
  date: Scalars['DateTime']
  id: Scalars['String']
  project: ProjectResourceLink
  signOns?: Maybe<Array<SignOnResourceLink>>
  subcontractors?: Maybe<Array<SubcontractorResourceLink>>
  templateResponse: TemplateResponseResourceLink
}

export interface SiteInductionCodeInfo {
  __typename?: 'SiteInductionCodeInfo'
  description?: Maybe<Scalars['String']>
  requiresCode: Scalars['Boolean']
}

export interface SiteInductionResourceLink {
  __typename?: 'SiteInduction_ResourceLink'
  createdAt: Scalars['DateTime']
  documentSignatures: Array<Maybe<DocumentSignatureResourceLink>>
  id: Scalars['String']
  project: ProjectResourceLink
  reviewer?: Maybe<InductionReviewerResourceLink>
  signatureUrl?: Maybe<Scalars['String']>
  status?: Maybe<InductionStatus>
  subcontractor?: Maybe<SubcontractorResourceLink>
  templateResponse?: Maybe<TemplateResponseResourceLink>
  type: InductionType
  updatedAt: Scalars['DateTime']
  worker: WorkerResourceLink
}

export interface SiteTimingsInput {
  dayOfWeek: Scalars['String']
  endTime?: InputMaybe<Scalars['String']>
  startTime?: InputMaybe<Scalars['String']>
}

export interface SmsLog {
  __typename?: 'SmsLog'
  adminUser?: Maybe<AdminUser>
  adminUserId?: Maybe<Scalars['String']>
  batchId?: Maybe<Scalars['String']>
  builder?: Maybe<Builder>
  builderId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  message?: Maybe<Scalars['String']>
  messageId?: Maybe<Scalars['String']>
  numberOfSegments?: Maybe<Scalars['Int']>
  project?: Maybe<Project>
  projectId?: Maybe<Scalars['String']>
  recipientType: SmsRecipientType
  status: SmsStatus
  subcontractor?: Maybe<Subcontractor>
  subcontractorId?: Maybe<Scalars['String']>
  to: Scalars['String']
  type: SmsType
  updatedAt: Scalars['DateTime']
  worker?: Maybe<Worker>
  workerId?: Maybe<Scalars['String']>
}

export interface SmsLogFilterInput {
  searchString?: InputMaybe<Scalars['String']>
}

export interface SmsLogSortInput {
  createdAt?: InputMaybe<SortOrder>
}

export interface SmsLogsReport {
  __typename?: 'SmsLogsReport'
  monthToDateProject?: Maybe<Scalars['Int']>
  monthToDateTotal: Scalars['Int']
  yearToDateTotal: Scalars['Int']
}

export enum SmsRecipientType {
  Builder = 'BUILDER',
  Subcontractor = 'SUBCONTRACTOR',
  Worker = 'WORKER',
}

export enum SmsStatus {
  Bounced = 'BOUNCED',
  Delivered = 'DELIVERED',
  Sent = 'SENT',
}

export enum SmsType {
  ProjectUpdate = 'PROJECT_UPDATE',
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export interface StartPermitInputAdmin {
  enactingTemplateResponseData?: InputMaybe<Scalars['JSON']>
}

export interface StartPermitInputWorker {
  enactingTemplateResponseData?: InputMaybe<Scalars['JSON']>
}

export enum State {
  Act = 'ACT',
  Nsw = 'NSW',
  Nt = 'NT',
  Qld = 'QLD',
  Sa = 'SA',
  Tas = 'TAS',
  Vic = 'VIC',
  Wa = 'WA',
}

export interface StylingSettings {
  __typename?: 'StylingSettings'
  /** Text colour for buttons and such */
  buttonTextColour?: Maybe<Scalars['String']>
  /** Main colour for buttons and such */
  primaryColour?: Maybe<Scalars['String']>
  /** Text colour for primary text */
  primaryTextColour?: Maybe<Scalars['String']>
}

export interface Subcontractor {
  __typename?: 'Subcontractor'
  address?: Maybe<Scalars['String']>
  addressParts?: Maybe<Address>
  archivedAt?: Maybe<Scalars['DateTime']>
  builder: Builder
  company: Company
  contacts?: Maybe<Array<Maybe<Contact>>>
  createdAt: Scalars['DateTime']
  documents?: Maybe<Array<Maybe<Document>>>
  id: Scalars['String']
  insuranceDocs?: Maybe<Array<Maybe<InsuranceDoc>>>
  integrationConnections: Array<Maybe<IntegrationConnection>>
  isBuilder?: Maybe<Scalars['Boolean']>
  lastFileUploadEmail?: Maybe<EmailLog>
  lastFileUploadInvite?: Maybe<FileUploadInvite>
  lastInductionEmail?: Maybe<EmailLog>
  lastWelcomeEmail?: Maybe<EmailLog>
  msdsDocs?: Maybe<Array<Maybe<MsdsDoc>>>
  preferredContacts?: Maybe<Array<Contact>>
  prequalifications?: Maybe<Array<Maybe<Prequalification>>>
  procoreId?: Maybe<Scalars['String']>
  projects?: Maybe<Array<Maybe<Project>>>
  stats?: Maybe<SubcontractorStats>
  statuses?: Maybe<Array<Maybe<SubcontractorStatus>>>
  swmsDocs?: Maybe<Array<Maybe<SwmsDoc>>>
  tags?: Maybe<Array<Maybe<ResourceTag>>>
  updatedAt: Scalars['DateTime']
  workers: Array<Maybe<Worker>>
}

export interface SubcontractorLastFileUploadEmailArgs {
  projectId?: InputMaybe<Scalars['String']>
}

export interface SubcontractorLastFileUploadInviteArgs {
  projectId?: InputMaybe<Scalars['String']>
}

export interface SubcontractorLastInductionEmailArgs {
  projectId?: InputMaybe<Scalars['String']>
}

export interface SubcontractorLastWelcomeEmailArgs {
  projectId?: InputMaybe<Scalars['String']>
}

export interface SubcontractorPreferredContactsArgs {
  projectId?: InputMaybe<Scalars['String']>
}

export interface SubcontractorArchiveInfo {
  __typename?: 'SubcontractorArchiveInfo'
  documentsCount?: Maybe<Scalars['Int']>
  insuranceDocsCount?: Maybe<Scalars['Int']>
  integrationConnectionsCount?: Maybe<Scalars['Int']>
  prequalificationsCount?: Maybe<Scalars['Int']>
  sdsDocsCount?: Maybe<Scalars['Int']>
  swmsDocsCount?: Maybe<Scalars['Int']>
  timesheetsCount?: Maybe<Scalars['Int']>
  workersCount?: Maybe<Scalars['Int']>
}

export interface SubcontractorCompanyPublic {
  __typename?: 'SubcontractorCompany_Public'
  abn?: Maybe<Scalars['String']>
  name: Scalars['String']
}

export interface SubcontractorEntity {
  __typename?: 'SubcontractorEntity'
  builder?: Maybe<BuilderEntityPublic>
  company: CompanyEntity
  createdAt: Scalars['DateTime']
  hasShowAllSwms?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  isBuilder?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  registers?: Maybe<Array<RegisterPublic>>
  updatedAt: Scalars['DateTime']
  validationStatus: SubcontractorValidationStatus
}

export interface SubcontractorFilterAggregation {
  __typename?: 'SubcontractorFilterAggregation'
  allBuilder?: Maybe<Scalars['Int']>
  allProject?: Maybe<Scalars['Int']>
  invited?: Maybe<Scalars['Int']>
  notInvited?: Maybe<Scalars['Int']>
}

export interface SubcontractorFilterInput {
  hasSwms?: InputMaybe<Scalars['Boolean']>
  includeBuilderSubcontractor?: InputMaybe<Scalars['Boolean']>
  resourceTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  subcontractorIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface SubcontractorFilterInputPublic {
  includeBuilderSubcontractor?: InputMaybe<Scalars['Boolean']>
  projectId?: InputMaybe<Scalars['String']>
  searchString?: InputMaybe<Scalars['String']>
}

export interface SubcontractorReport {
  __typename?: 'SubcontractorReport'
  id: Scalars['String']
  name: Scalars['String']
  numberOfWorkers: Scalars['Int']
  projectHours: Scalars['Float']
  projectHoursByDate: Array<ProjectHoursByDate>
  workers?: Maybe<Array<WorkerReport>>
}

export interface SubcontractorReportFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
}

export interface SubcontractorSwmsSettings {
  __typename?: 'SubcontractorSWMSSettings'
  /** Whether the option to override an existing template is allowed */
  allowOverridingExistingSWMSTemplates: Scalars['Boolean']
  /** Whether the option to save a new template is allowed */
  allowSavingNewSWMSTemplates: Scalars['Boolean']
  /** The default list of selectable responsible values for the SWMS builder */
  defaultSWMSHazardResponsible?: Maybe<Array<Scalars['String']>>
  /** Shared SWMS templates with subcontractors */
  sharedSWMSTemplates?: Maybe<Array<SwmsTemplate>>
  /** Show BuildPass Template as an option when creating a SWMS */
  showBuildPassSWMSTemplatesOption: Scalars['Boolean']
  /** Show 'Start from Scratch' as an option when creating a SWMS */
  showStartFromScratchSWMSOption: Scalars['Boolean']
}

/** Subcontractor module settings for the entire Builder */
export interface SubcontractorSettings {
  __typename?: 'SubcontractorSettings'
  /** Specify additional types of insurances that a subcontractor can upload in addition to the default types */
  customInsurancesTypes?: Maybe<Array<Scalars['String']>>
  /** Enable expired insurance reminder emails for the builder subcontractors */
  expiredInsurancesEmails: Scalars['Boolean']
  /** Which admin user(s) to receive notifications when subcontractors have expired insurances */
  notifyAdminUsers?: Maybe<Array<Scalars['String']>>
}

export interface SubcontractorSortInput {
  name?: InputMaybe<SortOrder>
  workers?: InputMaybe<SortOrder>
}

export interface SubcontractorStats {
  __typename?: 'SubcontractorStats'
  documentsCount?: Maybe<Scalars['Int']>
  insuranceDocsCount?: Maybe<Scalars['Int']>
  integrationConnectionsCount?: Maybe<Scalars['Int']>
  msdsDocsCount?: Maybe<Scalars['Int']>
  prequalificationsCount?: Maybe<Scalars['Int']>
  swmsDocsCount?: Maybe<Scalars['Int']>
  timesheetsCount?: Maybe<Scalars['Int']>
  workersCount?: Maybe<Scalars['Int']>
}

export enum SubcontractorStatus {
  InsurancesReviewed = 'INSURANCES_REVIEWED',
  InsurancesUploaded = 'INSURANCES_UPLOADED',
  Invited = 'INVITED',
  NotInvited = 'NOT_INVITED',
  SwmsReviewed = 'SWMS_REVIEWED',
  SwmsUploaded = 'SWMS_UPLOADED',
}

export enum SubcontractorValidationStatus {
  AutoApprovedSwms = 'AUTO_APPROVED_SWMS',
  NoApprovedSwms = 'NO_APPROVED_SWMS',
  Valid = 'VALID',
}

export interface SubcontractorPublic {
  __typename?: 'Subcontractor_Public'
  company: SubcontractorCompanyPublic
  id: Scalars['String']
  isBuilder?: Maybe<Scalars['Boolean']>
}

export interface SubcontractorResourceLink {
  __typename?: 'Subcontractor_ResourceLink'
  company: CompanyResourceLink
  defects?: Maybe<Array<Maybe<DefectResourceLink>>>
  id: Scalars['String']
  projects?: Maybe<Array<Maybe<ProjectResourceLink>>>
  workers?: Maybe<Array<Maybe<WorkerResourceLink>>>
}

export interface SubcontractorsReport {
  __typename?: 'SubcontractorsReport'
  subcontractors: Array<SubcontractorReport>
}

export interface SubmitRegisterItemReviewInput {
  reviewTemplateResponseData?: InputMaybe<Scalars['JSON']>
}

export interface SubmitSwmsTemplateResponseInput {
  fileUploadInviteId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  oldSwmsDocId?: InputMaybe<Scalars['String']>
  subcontractorId: Scalars['String']
  templateResponseId: Scalars['String']
}

export enum SupportedLocaleCountryCode {
  Au = 'AU',
  Ca = 'CA',
  Gb = 'GB',
  Us = 'US',
}

export interface SuspendPermitInputAdmin {
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  message?: InputMaybe<Scalars['String']>
}

export interface SwmsDoc {
  __typename?: 'SwmsDoc'
  archivedAt?: Maybe<Scalars['DateTime']>
  checklist?: Maybe<Scalars['JSON']>
  checklistTemplateResponse?: Maybe<TemplateResponse>
  createdAt: Scalars['DateTime']
  currentVersion: VersionHistory
  documentSignatures: Array<Maybe<DocumentSignature>>
  expireInDays?: Maybe<Scalars['Int']>
  id: Scalars['String']
  isBuilder?: Maybe<Scalars['Boolean']>
  key?: Maybe<Scalars['String']>
  librarySwmsDoc?: Maybe<LibrarySwmsDocAdmin>
  name: Scalars['String']
  project: Project
  projectId: Scalars['String']
  required?: Maybe<Scalars['Boolean']>
  requiredAll?: Maybe<Scalars['Boolean']>
  review?: Maybe<Scalars['String']>
  showAll?: Maybe<Scalars['Boolean']>
  signCount: Scalars['Int']
  status: SwmsStatus
  subcontractor: Subcontractor
  subcontractorId: Scalars['String']
  templateResponse?: Maybe<TemplateResponse>
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
  versionHistory?: Maybe<Array<VersionHistory>>
  workers: Array<Worker>
}

export interface SwmsDocEntity {
  __typename?: 'SwmsDocEntity'
  activityLogs?: Maybe<Array<Maybe<AuditLogResourceLink>>>
  checklist?: Maybe<Scalars['JSON']>
  checklistTemplateResponse?: Maybe<TemplateResponseEntity>
  createdAt: Scalars['DateTime']
  documentSignatures: Array<Maybe<DocumentSignatureEntity>>
  id: Scalars['String']
  isBuilder?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  project: ProjectEntity
  required?: Maybe<Scalars['Boolean']>
  requiredAll?: Maybe<Scalars['Boolean']>
  review?: Maybe<Scalars['String']>
  showAll?: Maybe<Scalars['Boolean']>
  status: SwmsStatus
  subcontractor?: Maybe<SubcontractorResourceLink>
  templateResponse?: Maybe<TemplateResponseEntity>
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
}

export interface SwmsDocLog {
  __typename?: 'SwmsDocLog'
  createdAt: Scalars['DateTime']
  hasNotified: Scalars['Boolean']
  hasSigned: Scalars['Boolean']
  id: Scalars['String']
  project: Project
  swmsDoc: SwmsDoc
  swmsDocId: Scalars['String']
  updatedAt: Scalars['DateTime']
  worker: Worker
  workerId: Scalars['String']
}

export interface SwmsDocLogsFilterInput {
  dismissed?: InputMaybe<Scalars['Boolean']>
  hasNotified?: InputMaybe<Scalars['Boolean']>
  hasSigned?: InputMaybe<Scalars['Boolean']>
}

export interface SwmsFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  librarySwmsDocId?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<SwmsStatus>>
  subcontractorIds?: InputMaybe<Array<Scalars['String']>>
}

export interface SwmsLibraryTemplate {
  __typename?: 'SwmsLibraryTemplate'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  templateData?: Maybe<Scalars['JSON']>
  templateName: Scalars['String']
  templateType: TemplateType
  updatedAt: Scalars['DateTime']
}

export interface SwmsSortInput {
  createdAt?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

export enum SwmsStatus {
  ChangesRequested = 'CHANGES_REQUESTED',
  Reviewed = 'REVIEWED',
  WaitingReview = 'WAITING_REVIEW',
}

export interface SwmsTemplate {
  __typename?: 'SwmsTemplate'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  templateData?: Maybe<Scalars['JSON']>
  templateName: Scalars['String']
  templateType: TemplateType
  updatedAt: Scalars['DateTime']
}

export type SwmsTemplateOrLibraryTemplate = SwmsLibraryTemplate | SwmsTemplate

export interface SwmsTemplateResponse {
  __typename?: 'SwmsTemplateResponse'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  isOwnTemplate: Scalars['Boolean']
  project?: Maybe<PublicProject>
  responseData?: Maybe<Scalars['JSON']>
  template?: Maybe<SwmsTemplateOrLibraryTemplate>
  updatedAt: Scalars['DateTime']
}

export interface SyncAgaveProjectsInput {
  ids?: InputMaybe<Array<Scalars['String']>>
  integrationType: IntegrationType
}

export interface SyncAgaveProjectsResponse {
  __typename?: 'SyncAgaveProjectsResponse'
  ids: Array<Scalars['String']>
}

export interface SyncAgaveVendorsInput {
  ids?: InputMaybe<Array<Scalars['String']>>
  integrationType: IntegrationType
}

export interface SyncAgaveVendorsResponse {
  __typename?: 'SyncAgaveVendorsResponse'
  ids: Array<Scalars['String']>
}

export interface SyncSiteAttendanceResult {
  __typename?: 'SyncSiteAttendanceResult'
  numberOfWorkers?: Maybe<Scalars['Float']>
  projectHours?: Maybe<Scalars['Float']>
  subcontractorId: Scalars['String']
}

export interface SyncSiteAttendanceResults {
  __typename?: 'SyncSiteAttendanceResults'
  results: Array<SyncSiteAttendanceResult>
}

export interface SyncWorkerAccessControlManualResult {
  __typename?: 'SyncWorkerAccessControlManualResult'
  message: Scalars['String']
  success: Scalars['Boolean']
}

export interface Task {
  __typename?: 'Task'
  actionText?: Maybe<Scalars['String']>
  date?: Maybe<Scalars['DateTime']>
  dismissable?: Maybe<Scalars['Boolean']>
  longDesc?: Maybe<Scalars['String']>
  metadata?: Maybe<TaskMetaData>
  shortDesc?: Maybe<Scalars['String']>
  title: Scalars['String']
  type?: Maybe<TaskType>
}

export interface TaskMetaData {
  __typename?: 'TaskMetaData'
  disabled?: Maybe<Scalars['Boolean']>
  inductionInviteId?: Maybe<Scalars['String']>
  inductionTemplateId?: Maybe<Scalars['String']>
  permit?: Maybe<Scalars['String']>
  /** @deprecated Please use preStarts field */
  preStart?: Maybe<PreStart>
  preStarts?: Maybe<Array<Maybe<PreStart>>>
  projectId?: Maybe<Scalars['String']>
  qrScanRequired?: Maybe<Scalars['Boolean']>
  recentInduction?: Maybe<Scalars['Boolean']>
  swmsDocs?: Maybe<Array<Maybe<SwmsDoc>>>
  taskIconName?: Maybe<Scalars['String']>
  ticket?: Maybe<Ticket>
  ticketTemplate?: Maybe<TicketTemplate>
  webviewUrl?: Maybe<Scalars['String']>
}

export enum TaskType {
  AddTicket = 'ADD_TICKET',
  AppUpdateOta = 'APP_UPDATE_OTA',
  AppUpdateStore = 'APP_UPDATE_STORE',
  BuilderInduction = 'BUILDER_INDUCTION',
  Defect = 'DEFECT',
  DisabledProjectInduction = 'DISABLED_PROJECT_INDUCTION',
  PendingInductionReview = 'PENDING_INDUCTION_REVIEW',
  Permit = 'PERMIT',
  PlatformAction = 'PLATFORM_ACTION',
  ProjectInduction = 'PROJECT_INDUCTION',
  SignOn = 'SIGN_ON',
  SiteUpdate = 'SITE_UPDATE',
  SwmsReview = 'SWMS_REVIEW',
  UpdateTicket = 'UPDATE_TICKET',
  WebviewTask = 'WEBVIEW_TASK',
}

export interface Template {
  __typename?: 'Template'
  accessProfileTemplate?: Maybe<AccessProfileTemplate>
  archivedAt?: Maybe<Scalars['DateTime']>
  builder?: Maybe<Builder>
  builderId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  default?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  identifierPrefix?: Maybe<Scalars['String']>
  isPublicChecklist: Scalars['Boolean']
  lastRun?: Maybe<Scalars['DateTime']>
  linkedRegisterItems?: Maybe<Array<RegisterItem>>
  projects: Array<Maybe<Project>>
  schedules?: Maybe<Array<Maybe<Schedule>>>
  templateCategoryName?: Maybe<Scalars['String']>
  templateData?: Maybe<Scalars['JSON']>
  templateName: Scalars['String']
  /** @deprecated Do not use. Causes memory issues due to giant tempate JSON data */
  templateResponses: Array<Maybe<TemplateResponse>>
  templateResponsesCount: Scalars['Int']
  templateType: TemplateType
  updatedAt: Scalars['DateTime']
}

export type TemplateBlock =
  | CheckboxCaptureBlock
  | ChecklistDisplayBlock
  | DateTimeCaptureBlock
  | DateTimeDisplayBlock
  | DividerDisplayBlock
  | FileCaptureBlock
  | HeadingDisplayBlock
  | ImageDisplayBlock
  | ListDisplayBlock
  | RadioCaptureBlock
  | RichTextCaptureBlock
  | RichTextDisplayBlock
  | SelectCaptureBlock
  | TextCaptureBlock
  | TextDisplayBlock
  | ToggleCaptureBlock
  | VideoDisplayBlock

export interface TemplateBlockBase {
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
}

export interface TemplateBlockGroup {
  __typename?: 'TemplateBlockGroup'
  blocks?: Maybe<Array<Maybe<TemplateBlock>>>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  name?: Maybe<Scalars['String']>
}

export enum TemplateBlockKind {
  Capture = 'CAPTURE',
  Display = 'DISPLAY',
}

export enum TemplateBlockTypes {
  Checkbox = 'CHECKBOX',
  Checklist = 'CHECKLIST',
  Datetime = 'DATETIME',
  Divider = 'DIVIDER',
  File = 'FILE',
  Heading = 'HEADING',
  Image = 'IMAGE',
  List = 'LIST',
  Radio = 'RADIO',
  RichText = 'RICH_TEXT',
  Select = 'SELECT',
  Text = 'TEXT',
  Toggle = 'TOGGLE',
  Video = 'VIDEO',
}

export interface TemplateData {
  __typename?: 'TemplateData'
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  sections?: Maybe<Array<Maybe<TemplateSection>>>
}

export interface TemplateEntity {
  __typename?: 'TemplateEntity'
  archivedAt?: Maybe<Scalars['DateTime']>
  builder?: Maybe<BuilderEntityPublic>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  templateCategoryName?: Maybe<Scalars['String']>
  templateData?: Maybe<Scalars['JSON']>
  templateName: Scalars['String']
  templateType: TemplateType
  updatedAt: Scalars['DateTime']
}

export interface TemplateFilterInput {
  archivedFilter?: InputMaybe<ArchivedFilter>
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  excludeTemplateTypes?: InputMaybe<Array<InputMaybe<TemplateType>>>
  projectId?: InputMaybe<Scalars['String']>
  registerItemId?: InputMaybe<Scalars['String']>
  searchString?: InputMaybe<Scalars['String']>
  showIfActiveTemplateResponses?: InputMaybe<Scalars['Boolean']>
  templateResponseLocationId?: InputMaybe<Scalars['String']>
  templateResponseProjectId?: InputMaybe<Scalars['String']>
  templateType?: InputMaybe<TemplateType>
}

export interface TemplateListItems {
  __typename?: 'TemplateListItems'
  label?: Maybe<Scalars['String']>
}

export type TemplateOrLibraryTemplate = LibraryTemplate | Template

export interface TemplateResponse {
  __typename?: 'TemplateResponse'
  accessProfile?: Maybe<AccessProfile>
  archivedAt?: Maybe<Scalars['DateTime']>
  attachments?: Maybe<Array<Attachment>>
  author?: Maybe<TemplateResponseAuthor>
  completedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  defects?: Maybe<Array<Maybe<Defect>>>
  fullIdentifier?: Maybe<Scalars['String']>
  id: Scalars['String']
  identifier?: Maybe<Scalars['Int']>
  location?: Maybe<ProjectLocation>
  locationId?: Maybe<Scalars['String']>
  platformActions?: Maybe<Array<Maybe<PlatformAction>>>
  preStarts?: Maybe<Array<PreStart>>
  project?: Maybe<Project>
  relatedRegisterItem?: Maybe<RegisterItem>
  /** @deprecated use foreign key on Attachment record */
  resourceIdentifier?: Maybe<Scalars['String']>
  responseData?: Maybe<Scalars['JSON']>
  responseSummary?: Maybe<TemplateResponseSummary>
  scheduledJobId?: Maybe<Scalars['String']>
  siteDiaries?: Maybe<Array<SiteDiary>>
  subcontractor?: Maybe<Subcontractor>
  tableBlocks?: Maybe<Scalars['JSON']>
  template?: Maybe<TemplateResponseTemplate>
  updatedAt: Scalars['DateTime']
}

export interface TemplateResponseAggregateStats {
  __typename?: 'TemplateResponseAggregateStats'
  count: Scalars['Int']
  status: TemplateResponseAggregateTypes
}

export enum TemplateResponseAggregateTypes {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
}

export type TemplateResponseAuthor = AdminUser | Worker

export interface TemplateResponseAuthorInput {
  id: Scalars['String']
  type: TemplateResponseAuthorTypes
}

export enum TemplateResponseAuthorTypes {
  AdminUser = 'ADMIN_USER',
  Worker = 'WORKER',
}

export interface TemplateResponseBlocksSummary {
  __typename?: 'TemplateResponseBlocksSummary'
  completed?: Maybe<Scalars['Int']>
  inDesiredState?: Maybe<Scalars['Int']>
  inNeutralState?: Maybe<Scalars['Int']>
  inUndesiredState?: Maybe<Scalars['Int']>
  incomplete?: Maybe<Scalars['Int']>
  total?: Maybe<Scalars['Int']>
  totalWithDesiredState?: Maybe<Scalars['Int']>
}

export interface TemplateResponseEntity {
  __typename?: 'TemplateResponseEntity'
  archivedAt?: Maybe<Scalars['DateTime']>
  attachments?: Maybe<Array<AttachmentEntity>>
  completedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  project?: Maybe<ProjectEntity>
  responseData?: Maybe<Scalars['JSON']>
  template?: Maybe<TemplateEntity>
  updatedAt: Scalars['DateTime']
}

export interface TemplateResponseFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  authors?: InputMaybe<Array<TemplateResponseAuthorInput>>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  createdAfterDateTime?: InputMaybe<Scalars['DateTime']>
  createdBeforeDateTime?: InputMaybe<Scalars['DateTime']>
  includeAllProjects?: InputMaybe<Scalars['Boolean']>
  locationId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  publicResponse?: InputMaybe<Scalars['Boolean']>
  registerItemId?: InputMaybe<Scalars['String']>
  select?: InputMaybe<TemplateResponseFilterSelect>
  templateId?: InputMaybe<Scalars['String']>
  templateType?: InputMaybe<TemplateType>
}

export interface TemplateResponseFilterSelect {
  archived?: InputMaybe<Scalars['Boolean']>
  completed?: InputMaybe<Scalars['Boolean']>
  inProgress?: InputMaybe<Scalars['Boolean']>
  inProgressAndCompleted?: InputMaybe<Scalars['Boolean']>
}

export interface TemplateResponseSortInput {
  createdAt?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export interface TemplateResponseSummary {
  __typename?: 'TemplateResponseSummary'
  actions?: Maybe<Array<Maybe<PlatformAction>>>
  blocks?: Maybe<TemplateResponseBlocksSummary>
}

export type TemplateResponseTemplate = LibraryTemplate | Template

export interface TemplateResponseResourceLink {
  __typename?: 'TemplateResponse_ResourceLink'
  author?: Maybe<Scalars['String']>
  completedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  location?: Maybe<ProjectLocationResourceLink>
  project?: Maybe<ProjectResourceLink>
  responseData?: Maybe<Scalars['JSON']>
  template?: Maybe<TemplateResourceLink>
  templateName?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export interface TemplateSection {
  __typename?: 'TemplateSection'
  blockGroups?: Maybe<Array<Maybe<TemplateBlockGroup>>>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  name?: Maybe<Scalars['String']>
}

export interface TemplateSortInput {
  category?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  type?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export enum TemplateType {
  CompanyInduction = 'COMPANY_INDUCTION',
  Inspection = 'INSPECTION',
  Itp = 'ITP',
  Other = 'OTHER',
  PermitType = 'PERMIT_TYPE',
  Prequalification = 'PREQUALIFICATION',
  PreStart = 'PRE_START',
  Register = 'REGISTER',
  RegisterItemType = 'REGISTER_ITEM_TYPE',
  RegisterType = 'REGISTER_TYPE',
  SdsChecklist = 'SDS_CHECKLIST',
  SignOn = 'SIGN_ON',
  SiteDiary = 'SITE_DIARY',
  SiteInduction = 'SITE_INDUCTION',
  Swms = 'SWMS',
  SwmsChecklist = 'SWMS_CHECKLIST',
  TimesheetGroup = 'TIMESHEET_GROUP',
  Toolbox = 'TOOLBOX',
  VisitorSignOn = 'VISITOR_SIGN_ON',
}

export interface TemplateResourceLink {
  __typename?: 'Template_ResourceLink'
  id: Scalars['String']
  templateData?: Maybe<Scalars['JSON']>
}

export enum TextBlockTypes {
  Email = 'EMAIL',
  Number = 'NUMBER',
  Phone = 'PHONE',
  Plain = 'PLAIN',
}

export interface TextCaptureBlock extends CaptureExtra, TemplateBlockBase {
  __typename?: 'TextCaptureBlock'
  attachments?: Maybe<Array<Maybe<Attachment>>>
  characterLimit?: Maybe<Scalars['Int']>
  defaultValue?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
  value?: Maybe<Scalars['String']>
}

export interface TextDisplayBlock extends TemplateBlockBase {
  __typename?: 'TextDisplayBlock'
  content?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  textType: TextBlockTypes
  type: TemplateBlockTypes
}

export interface Thumbnail {
  __typename?: 'Thumbnail'
  small?: Maybe<Scalars['String']>
}

export interface Ticket {
  __typename?: 'Ticket'
  builderGenerated?: Maybe<Scalars['Boolean']>
  countryIssued?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  expiry?: Maybe<Scalars['DateTime']>
  files: Array<Maybe<TicketFile>>
  hidden?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  latestReview?: Maybe<TicketReview>
  latestReviewStatus?: Maybe<TicketReviewStatus>
  number?: Maybe<Scalars['String']>
  obtained?: Maybe<Scalars['DateTime']>
  reviews?: Maybe<Array<Maybe<TicketReview>>>
  stateIssued?: Maybe<Scalars['String']>
  ticketTemplate: TicketTemplate
  ticketTemplateId: Scalars['String']
  updatedAt: Scalars['DateTime']
  worker: Worker
  workerId: Scalars['String']
}

export interface TicketCategory {
  __typename?: 'TicketCategory'
  id: Scalars['String']
  name: Scalars['String']
  ticketTemplates: Array<Maybe<TicketTemplate>>
  ticketTemplatesCount: Scalars['Int']
}

export interface TicketEntity {
  __typename?: 'TicketEntity'
  builderGenerated?: Maybe<Scalars['Boolean']>
  countryIssued?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  expiry?: Maybe<Scalars['DateTime']>
  files: Array<Maybe<TicketFileEntity>>
  hidden?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  number?: Maybe<Scalars['String']>
  obtained?: Maybe<Scalars['DateTime']>
  stateIssued?: Maybe<Scalars['String']>
  ticketTemplate: TicketTemplateEntity
  ticketTemplateId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export interface TicketFile {
  __typename?: 'TicketFile'
  file: File
  fileId: Scalars['String']
  id: Scalars['String']
  name: Scalars['String']
  ticket: Ticket
  ticketId: Scalars['String']
}

export interface TicketFileConfig {
  __typename?: 'TicketFileConfig'
  id: Scalars['String']
  name: Scalars['String']
  required: Scalars['Boolean']
  ticketTemplate?: Maybe<TicketTemplate>
  ticketTemplateId?: Maybe<Scalars['String']>
}

export interface TicketFileConfigInput {
  name: Scalars['String']
  required: Scalars['Boolean']
}

export interface TicketFileEntity {
  __typename?: 'TicketFileEntity'
  file: FileEntity
  fileId: Scalars['String']
  id: Scalars['String']
  name: Scalars['String']
}

export interface TicketFileInput {
  fileType?: InputMaybe<Scalars['String']>
  key: Scalars['String']
  name: Scalars['String']
}

export interface TicketFilterInput {
  archivedFilter?: InputMaybe<ArchivedFilter>
  expiringSoon?: InputMaybe<Scalars['Boolean']>
  projectId?: InputMaybe<Scalars['String']>
  shouldIncludeBuilderSubcontractors?: InputMaybe<Scalars['Boolean']>
  shouldIncludeManuallyGeneratedWorkers?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  subcontractorIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  ticketIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  ticketReviewStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  workerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface TicketReview {
  __typename?: 'TicketReview'
  adminUser?: Maybe<AdminUser>
  adminUserId?: Maybe<Scalars['String']>
  builder?: Maybe<Builder>
  builderId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  reviewComments?: Maybe<Scalars['String']>
  reviewStatus: TicketReviewStatus
  ticket: Ticket
  ticketId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export enum TicketReviewStatus {
  ChangesRequested = 'CHANGES_REQUESTED',
  Reviewed = 'REVIEWED',
  WaitingReview = 'WAITING_REVIEW',
}

export interface TicketReviewResourceLink {
  __typename?: 'TicketReview_ResourceLink'
  reviewStatus: TicketReviewStatus
}

export type TicketShareUnion = TicketWalletShare | TicketWalletShareExpired

export interface TicketSortInput {
  name?: InputMaybe<SortOrder>
  number?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  worker?: InputMaybe<SortOrder>
}

export interface TicketTemplate {
  __typename?: 'TicketTemplate'
  code?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  expiry: Scalars['Boolean']
  id: Scalars['String']
  medical: Scalars['Boolean']
  name: Scalars['String']
  number: Scalars['Boolean']
  obtained: Scalars['Boolean']
  shortName: Scalars['String']
  ticketCategory: TicketCategory
  ticketCategoryId: Scalars['String']
  ticketCount: Scalars['Int']
  ticketFileConfigs: Array<Maybe<TicketFileConfig>>
  ticketType: TicketType
  ticketTypeId: Scalars['String']
  tickets: Array<Maybe<Ticket>>
  updatedAt: Scalars['DateTime']
}

export interface TicketTemplateEntity {
  __typename?: 'TicketTemplateEntity'
  code?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  expiry: Scalars['Boolean']
  id: Scalars['String']
  name: Scalars['String']
  number: Scalars['Boolean']
  obtained: Scalars['Boolean']
  shortName: Scalars['String']
  ticketFileConfigs: Array<Maybe<TicketFileConfig>>
  updatedAt: Scalars['DateTime']
}

export interface TicketTemplateResourceLink {
  __typename?: 'TicketTemplate_ResourceLink'
  name: Scalars['String']
  shortName: Scalars['String']
}

export interface TicketType {
  __typename?: 'TicketType'
  id: Scalars['String']
  name: Scalars['String']
  ticketTemplates: Array<Maybe<TicketTemplate>>
  ticketTemplatesCount: Scalars['Int']
}

export interface TicketWalletShare {
  __typename?: 'TicketWalletShare'
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  expiry: Scalars['DateTime']
  id: Scalars['String']
  shareUrl: Scalars['String']
  updatedAt: Scalars['DateTime']
  worker: WorkerTicketShareEntity
  workerId: Scalars['String']
}

export interface TicketWalletShareExpired {
  __typename?: 'TicketWalletShareExpired'
  expired: Scalars['Boolean']
  expiry: Scalars['DateTime']
  id: Scalars['String']
}

export interface TicketResourceLink {
  __typename?: 'Ticket_ResourceLink'
  countryIssued?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  expiry?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  number?: Maybe<Scalars['String']>
  reviews?: Maybe<Array<Maybe<TicketReviewResourceLink>>>
  stateIssued?: Maybe<Scalars['String']>
  ticketTemplate: TicketTemplateResourceLink
  updatedAt: Scalars['DateTime']
}

export interface TimeType {
  __typename?: 'TimeType'
  colour?: Maybe<Scalars['String']>
  icon?: Maybe<Scalars['String']>
  id: Scalars['String']
  label: Scalars['String']
}

export interface TimeTypeInput {
  colour?: InputMaybe<Scalars['String']>
  icon?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  label?: InputMaybe<Scalars['String']>
}

export interface TimesheetEntry {
  __typename?: 'TimesheetEntry'
  approvedAt1?: Maybe<Scalars['DateTime']>
  approvedAt2?: Maybe<Scalars['DateTime']>
  approver1?: Maybe<AdminUser>
  approver2?: Maybe<AdminUser>
  associatedSignOn?: Maybe<ProcessedSignOn>
  builder: Builder
  builderId: Scalars['String']
  costCode?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  date: Scalars['DateTime']
  endTime?: Maybe<Scalars['DateTime']>
  hours: Scalars['Float']
  hoursOverride?: Maybe<Scalars['Float']>
  id: Scalars['String']
  notes?: Maybe<Scalars['String']>
  project: Project
  projectId: Scalars['String']
  startTime?: Maybe<Scalars['DateTime']>
  status: TimesheetEntryStatus
  subcontractor: Subcontractor
  subcontractorId: Scalars['String']
  timeType: Scalars['String']
  timesheetGroup: TimesheetGroup
  timesheetGroupCount: Scalars['Int']
  timesheetGroupId: Scalars['String']
  updatedAt: Scalars['DateTime']
  worker: Worker
  workerId: Scalars['String']
}

export interface TimesheetEntryFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  costCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  ids?: InputMaybe<Array<Scalars['String']>>
  projectId?: InputMaybe<Scalars['String']>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InputMaybe<TimesheetEntryStatus>>>
  subcontractorIds?: InputMaybe<Array<Scalars['String']>>
  timeType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  workerIds?: InputMaybe<Array<Scalars['String']>>
}

export interface TimesheetEntryInput {
  costCode?: InputMaybe<Scalars['String']>
  date: Scalars['DateTime']
  endTime?: InputMaybe<Scalars['DateTime']>
  hours: Scalars['Float']
  id?: InputMaybe<Scalars['String']>
  notes?: InputMaybe<Scalars['String']>
  startTime?: InputMaybe<Scalars['DateTime']>
  status: TimesheetEntryStatus
  timeType: Scalars['String']
}

export interface TimesheetEntrySortInput {
  createdAt?: InputMaybe<SortOrder>
  date?: InputMaybe<SortOrder>
  workerName?: InputMaybe<SortOrder>
}

export enum TimesheetEntryStatus {
  Approved_1 = 'APPROVED_1',
  Approved_2 = 'APPROVED_2',
  Pending = 'PENDING',
}

export interface TimesheetGroup {
  __typename?: 'TimesheetGroup'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  templateResponse?: Maybe<TemplateResponse>
  timesheetEntries: Array<TimesheetEntry>
  updatedAt: Scalars['DateTime']
}

export interface TimesheetPrimaryApprover {
  __typename?: 'TimesheetPrimaryApprover'
  adminUserIds?: Maybe<Array<Scalars['String']>>
  projectId: Scalars['String']
}

export interface TimesheetPrimaryApproverInput {
  adminUserIds?: InputMaybe<Array<Scalars['String']>>
  projectId: Scalars['String']
}

/** Timesheet module settings for the entire Builder */
export interface TimesheetSettings {
  __typename?: 'TimesheetSettings'
  /** Customisable list of time types that can be used on timesheets */
  costCodes: Array<Maybe<CostCode>>
  /** Returns which projects the current user is a primary approver for, if project is missing, assumed true */
  isPrimaryApproverOfProjects?: Maybe<Array<IsPrimaryApprover>>
  /** Returns true if the current user is a secondary approver and has access to approve timesheets */
  isSecondaryApprover: Scalars['Boolean']
  /** Whether to show the jobpac csv export on the timesheet list page */
  jobPacCsvExport: Scalars['Boolean']
  /** Returns which admin users are primary approvers for which projects */
  primaryApprovers?: Maybe<Array<TimesheetPrimaryApprover>>
  /** Returns true if timesheets are required to be approved by a secondary approver */
  requiresSecondaryApproval: Scalars['Boolean']
  /** An array of user ids who are secondary approvers */
  secondaryApproverIds?: Maybe<Array<Scalars['String']>>
  /** An array of users who are secondary approvers */
  secondaryApprovers?: Maybe<Array<AdminUserEntity>>
  /** An array of whitelisted subcontractor ids that timesheets are enabled for */
  subcontractorIdsWhitelist?: Maybe<Array<Scalars['String']>>
  /** An array of whitelisted subcontractor ids that timesheets are enabled for */
  subcontractorsWhitelist?: Maybe<Array<SubcontractorEntity>>
  /** Customisable list of time types that can be used on timesheets */
  timeTypes: Array<Maybe<TimeType>>
  /** Whether the notes field on each timesheet entry is enabled or not */
  timesheetEntryNotes: Scalars['Boolean']
  /** Whether the start and end time fields on each timesheet entry is enabled or not */
  timesheetStartEndTimes: Scalars['Boolean']
}

export enum ToggleBlockOptions {
  Off = 'OFF',
  On = 'ON',
}

export interface ToggleCaptureBlock extends CaptureExtra, TemplateBlockBase {
  __typename?: 'ToggleCaptureBlock'
  attachments?: Maybe<Array<Maybe<Attachment>>>
  defaultState?: Maybe<ToggleBlockOptions>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  offLabel?: Maybe<Scalars['String']>
  onLabel?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
  value?: Maybe<ToggleBlockOptions>
}

export interface ToggleModuleInput {
  modules: Array<BuildPassModule>
}

export interface ToggleModuleResponse {
  __typename?: 'ToggleModuleResponse'
  modules: Array<BuildPassModule>
}

export interface Toolbox {
  __typename?: 'Toolbox'
  agenda?: Maybe<Scalars['String']>
  attended: Array<Maybe<ToolboxInvitee>>
  createdAt: Scalars['DateTime']
  date: Scalars['DateTime']
  deletedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  invited: Array<Maybe<ToolboxInvitee>>
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
  notes?: Maybe<Scalars['String']>
  preStart?: Maybe<PreStart>
  presenters: Array<Maybe<ToolboxPresenter>>
  project: Project
  projectId: Scalars['String']
  status: ToolboxStatus
  templateResponse?: Maybe<TemplateResponse>
  templateResponseId?: Maybe<Scalars['String']>
  type: ToolboxType
  updatedAt: Scalars['DateTime']
  urls?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface ToolboxEntity {
  __typename?: 'ToolboxEntity'
  agenda?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  date: Scalars['DateTime']
  id: Scalars['String']
  notes?: Maybe<Scalars['String']>
  project: ProjectEntity
  status: ToolboxStatus
  templateResponse?: Maybe<TemplateResponseEntity>
  type: ToolboxType
  urls?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface ToolboxFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  searchString?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Array<InputMaybe<ToolboxStatus>>>
  type?: InputMaybe<Array<InputMaybe<ToolboxType>>>
}

export interface ToolboxInvite {
  __typename?: 'ToolboxInvite'
  attended?: Maybe<Scalars['Boolean']>
  batchIdentifer?: Maybe<Scalars['String']>
  builderGeneratedAttendance?: Maybe<Scalars['Boolean']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  invitee?: Maybe<ToolboxInvitee>
  toolbox: Toolbox
  toolboxId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type ToolboxInvitee = AdminUser | Worker

export type ToolboxInviteeResourceLink =
  | AdminUserResourceLink
  | WorkerResourceLink

export type ToolboxPresenter = AdminUser | Worker

export type ToolboxPresenterResourceLink =
  | AdminUserResourceLink
  | WorkerResourceLink

export interface ToolboxSortInput {
  createdAt?: InputMaybe<SortOrder>
}

export enum ToolboxStatus {
  Completed = 'COMPLETED',
  Distributed = 'DISTRIBUTED',
  Draft = 'DRAFT',
}

export enum ToolboxType {
  Incident = 'INCIDENT',
  Other = 'OTHER',
  Regular = 'REGULAR',
}

export interface ToolboxResourceLink {
  __typename?: 'Toolbox_ResourceLink'
  agenda?: Maybe<Scalars['String']>
  attended: Array<Maybe<ToolboxInviteeResourceLink>>
  createdAt: Scalars['DateTime']
  date: Scalars['DateTime']
  deletedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  invited: Array<Maybe<ToolboxInviteeResourceLink>>
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
  notes?: Maybe<Scalars['String']>
  preStart?: Maybe<PreStartResourceLink>
  presenters: Array<Maybe<ToolboxPresenterResourceLink>>
  project: ProjectResourceLink
  projectId: Scalars['String']
  status: ToolboxStatus
  templateResponse?: Maybe<TemplateResponseResourceLink>
  templateResponseId?: Maybe<Scalars['String']>
  type: ToolboxType
  updatedAt: Scalars['DateTime']
  urls?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface TopChecklistCategories {
  __typename?: 'TopChecklistCategories'
  completed: Scalars['Int']
  name: Scalars['String']
}

export interface TopProject {
  __typename?: 'TopProject'
  count: Scalars['Int']
  project: Project
}

export interface TopUser {
  __typename?: 'TopUser'
  adminUser: AdminUser
  count: Scalars['Int']
}

export interface TransferFileToAgaveInput {
  fileName: Scalars['String']
  fileType?: InputMaybe<AgaveFileTransferType>
  integrationType: IntegrationType
  projectId?: InputMaybe<Scalars['String']>
  remoteFileUrl: Scalars['String']
}

export interface TransferFileToAgaveResponse {
  __typename?: 'TransferFileToAgaveResponse'
  success: Scalars['Boolean']
}

export interface TransferPermitTypeInputAdmin {
  id: Scalars['String']
  identifierPrefix: Scalars['String']
  maxDays?: InputMaybe<Scalars['Int']>
  name: Scalars['String']
}

export interface TransferTemplateInput {
  id: Scalars['String']
  name: Scalars['String']
}

export interface UpdateAccessControlForWorkerInput {
  projectIds?: InputMaybe<Array<Scalars['String']>>
  status?: InputMaybe<AccessControlStatus>
}

export interface UpdateAccessControlIntegrationConnectionInput {
  keyFobAccessId?: InputMaybe<Scalars['String']>
  projectIdsAccess?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface UpdateAdminUserInput {
  builderId?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  limitedPermissions?: InputMaybe<Scalars['Boolean']>
  mobile?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
}

export interface UpdateAiToolsSettingsInput {
  actionEnhancementEnabled?: InputMaybe<Scalars['Boolean']>
  checklistAssistantEnabled?: InputMaybe<Scalars['Boolean']>
  contentTaggingEnabled?: InputMaybe<Scalars['Boolean']>
  contextualActionGeneratorEnabled?: InputMaybe<Scalars['Boolean']>
  defectEnhancementEnabled?: InputMaybe<Scalars['Boolean']>
  documentSummaryEnabled?: InputMaybe<Scalars['Boolean']>
  imageTaggingEnabled?: InputMaybe<Scalars['Boolean']>
  locationImportEnabled?: InputMaybe<Scalars['Boolean']>
  siteDiarySummaryEnabled?: InputMaybe<Scalars['Boolean']>
  toolboxSummaryEnabled?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateAttachmentInfoInput {
  description?: InputMaybe<Scalars['String']>
  tags?: InputMaybe<Array<Scalars['String']>>
}

export interface UpdateBuilderInput {
  company?: InputMaybe<CompanyNameInput>
  defaultLanguage?: InputMaybe<Scalars['String']>
  defaultLocale?: InputMaybe<SupportedLocaleCountryCode>
  defaultTimezone?: InputMaybe<Scalars['String']>
  inductionTemplateId?: InputMaybe<Scalars['String']>
  logoKey?: InputMaybe<Scalars['String']>
  requiredTicketsIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface UpdateBuilderMetadataInput {
  builderMetadata?: InputMaybe<Scalars['JSON']>
}

export interface UpdateBuilderQuestionnaireInput {
  questionnaire?: InputMaybe<Scalars['JSON']>
}

export interface UpdateBuilderRegisterSettingsInput {
  onlyAllowReviewedRegisterItemChecklists?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateBuilderSettingsInput {
  externalLinks?: InputMaybe<Array<BuilderExternalLinkInput>>
  hideMedical?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateBuilderSubcontractorDataInput {
  abn?: InputMaybe<Scalars['String']>
}

export interface UpdateBuilderSubcontractorInput {
  projectId: Scalars['String']
}

export interface UpdateBuilderWorkerDocumentInput {
  name?: InputMaybe<Scalars['String']>
}

export interface UpdateChecklistSettingInput {
  checklistCategories?: InputMaybe<Array<ChecklistCategorySettingInput>>
  checklistCategoriesInNavigation?: InputMaybe<
    Array<InputMaybe<Scalars['String']>>
  >
  checklistsAvailableForStaff?: InputMaybe<Scalars['Boolean']>
  onlySendActionsAfterChecklistCompleted?: InputMaybe<Scalars['Boolean']>
  publicChecklistIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  requireProjectInduction?: InputMaybe<Scalars['Boolean']>
  showSubcontractorColumnInChecklistTable?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateCommunicationSettingsInput {
  allowCompanyWideCommunication?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateContactInput {
  customType?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['String']>
  isPrimaryContact?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  number?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  type?: InputMaybe<ContactType>
}

export interface UpdateDefectInput {
  assignees?: InputMaybe<Array<AssigneeInput>>
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  description?: InputMaybe<Scalars['String']>
  dueDate?: InputMaybe<Scalars['DateTime']>
  locationId?: InputMaybe<Scalars['String']>
  priority?: InputMaybe<DefectPriority>
  status: DefectStatus
  tags?: InputMaybe<Array<Scalars['String']>>
  title?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export interface UpdateDefectSettingsInput {
  allowWorkerAssignees?: InputMaybe<Scalars['Boolean']>
  notifyAssigneesOnDefectCreated?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateDocumentFolderInput {
  name: Scalars['String']
  visibleToWorkers?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateDocumentInput {
  category?: InputMaybe<DocumentCategory>
  key?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  public?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<DocumentStatus>
  subcontractorId?: InputMaybe<Scalars['String']>
  summary?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export interface UpdateDocumentSignaturesInput {
  documentSignatureIds?: InputMaybe<Array<Scalars['String']>>
  inductionId: Scalars['String']
}

export interface UpdateDrawingInputAdmin {
  title?: InputMaybe<Scalars['String']>
}

export interface UpdateEmergencyInput {
  description?: InputMaybe<Scalars['String']>
  status?: InputMaybe<EmergencyStatus>
  title?: InputMaybe<Scalars['String']>
}

export interface UpdateEmergencyMessageAsWorkerInput {
  status?: InputMaybe<EmergencyMessageStatusForWorker>
}

export interface UpdateEmergencyMessageInput {
  status?: InputMaybe<EmergencyMessageStatus>
}

export interface UpdateGallerySettingsInput {
  defaultCompression?: InputMaybe<ImageCompressionPreset>
}

export interface UpdateGlobalSettingsInput {
  externalLinks?: InputMaybe<Array<ExternalLinkConfigInput>>
}

export interface UpdateHoursBudgetSettingsInput {
  hoursBudget?: InputMaybe<Scalars['Int']>
}

export interface UpdateInductionInput {
  evidenceSighted?: InputMaybe<Scalars['Boolean']>
  inductionId: Scalars['String']
  signatureKey?: InputMaybe<Scalars['String']>
  status?: InputMaybe<InductionStatus>
  updateTicketStatus?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateInductionSettingInput {
  inductionScanRequirementDisabledForAllProjects?: InputMaybe<
    Scalars['Boolean']
  >
  inductionsDisabledForAllProjects?: InputMaybe<Scalars['Boolean']>
  preventInductionWithoutApprovedSwms?: InputMaybe<Scalars['Boolean']>
  preventWorkersAccessingDocumentsUntilApproved?: InputMaybe<Scalars['Boolean']>
  projectIdsWithInductionDisabled?: InputMaybe<Array<Scalars['String']>>
  projectIdsWithInductionScanRequirementDisabled?: InputMaybe<
    Array<Scalars['String']>
  >
  projectIdsWithVisitorAccessToPublicDocumentsAfterInduction?: InputMaybe<
    Array<Scalars['String']>
  >
  projectManagersCanEditInductionTemplates?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateInsuranceDocInput {
  expiry?: InputMaybe<Scalars['DateTime']>
  key?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  status: InsuranceStatus
  subcontractorId?: InputMaybe<Scalars['String']>
  type?: InputMaybe<InsuranceType>
  typeOther?: InputMaybe<Scalars['String']>
}

export interface UpdateLibrarySwmsDocInputAdmin {
  key?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  status?: InputMaybe<SwmsStatus>
}

export interface UpdateLibrarySwmsDocReviewInputAdmin {
  checklistTemplateResponse?: InputMaybe<CreateTemplateResponseInput>
  status?: InputMaybe<SwmsStatus>
}

export interface UpdateLibraryTemplateInput {
  archivedAt?: InputMaybe<Scalars['DateTime']>
  templateData?: InputMaybe<Scalars['JSON']>
  templateDescription?: InputMaybe<Scalars['String']>
  templateName?: InputMaybe<Scalars['String']>
  templateType?: InputMaybe<TemplateType>
}

export interface UpdateMsdsDocInput {
  checklistTemplateResponse?: InputMaybe<CreateTemplateResponseInput>
  key?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  reviewDate?: InputMaybe<Scalars['DateTime']>
  status?: InputMaybe<MsdsStatus>
  subcontractorId?: InputMaybe<Scalars['String']>
}

export interface UpdateMyDefectInput {
  status?: InputMaybe<DefectStatus>
}

export interface UpdatePermitInputAdmin {
  description?: InputMaybe<Scalars['String']>
  endDate: Scalars['DateTime']
  name?: InputMaybe<Scalars['String']>
  projectLocationId?: InputMaybe<Scalars['String']>
  startDate: Scalars['DateTime']
  workerIds: Array<Scalars['String']>
}

export interface UpdatePermitInputWorker {
  description?: InputMaybe<Scalars['String']>
  endDate: Scalars['DateTime']
  startDate: Scalars['DateTime']
  workerIds?: InputMaybe<Array<Scalars['String']>>
}

export interface UpdatePermitTypeInputAdmin {
  identifierPrefix: Scalars['String']
  maxDays?: InputMaybe<Scalars['Int']>
  name: Scalars['String']
}

export interface UpdatePlatformActionInput {
  assignees?: InputMaybe<Array<AssigneeInput>>
  attachmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  config?: InputMaybe<PlatformActionConfigInput>
  description?: InputMaybe<Scalars['String']>
  dueDate?: InputMaybe<Scalars['DateTime']>
  locationId?: InputMaybe<Scalars['String']>
  priority?: InputMaybe<PlatformActionPriority>
  priorityType?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  status?: InputMaybe<PlatformActionStatus>
  title?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export interface UpdatePlatformActionInputWorker {
  status?: InputMaybe<PlatformActionStatus>
}

export interface UpdatePlatformActionSettingInput {
  actionsDueSoonReminder: Scalars['Boolean']
  actionsDueSoonReminderAdminUsers?: InputMaybe<Array<Scalars['String']>>
  actionsDueSoonReminderDays?: InputMaybe<Scalars['Int']>
  actionsDueSoonReminderFrequency?: InputMaybe<Scalars['Int']>
  allowSubcontractorsToCloseActions: Scalars['Boolean']
  overdueActionsReminder: Scalars['Boolean']
  overdueActionsReminderAdminUsers?: InputMaybe<Array<Scalars['String']>>
  overdueActionsReminderFrequency?: InputMaybe<Scalars['Int']>
  priorities?: InputMaybe<Array<InputMaybe<PlatformActionPriorityTypeInput>>>
  sendReminderDays?: InputMaybe<Scalars['Int']>
  sendReminderEnabled: Scalars['Boolean']
  types: Array<PlatformActionTypeInput>
}

export interface UpdatePreStartInput {
  date?: InputMaybe<Scalars['DateTime']>
  endDate?: InputMaybe<Scalars['DateTime']>
  template?: InputMaybe<CreateTemplateResponseInput>
}

export interface UpdatePremierSettingInput {
  notifyForProjects: Scalars['Boolean']
  notifyForSubcontractors: Scalars['Boolean']
  projectFields?: InputMaybe<Array<PremierProjectField>>
  subcontractorFields?: InputMaybe<Array<PremierSubcontractorField>>
  syncProjects: Scalars['Boolean']
  syncSubcontractors: Scalars['Boolean']
}

export interface UpdatePrequalificationInput {
  comments?: InputMaybe<Scalars['String']>
}

export interface UpdatePrequalificationSettingsInput {
  notifyAdminUsers?: InputMaybe<Array<Scalars['String']>>
  notifyAdminUsersOnApproval?: InputMaybe<Array<Scalars['String']>>
}

export interface UpdateProcoreSettingInput {
  notifyForProjects: Scalars['Boolean']
  notifyForSubcontractors: Scalars['Boolean']
  projectFields?: InputMaybe<Array<ProcoreProjectField>>
  subcontractorFields?: InputMaybe<Array<ProcoreVendorField>>
  syncChecklists: Array<Scalars['String']>
  syncInductions: Scalars['Boolean']
  syncProjects: Scalars['Boolean']
  syncSiteAttendanceToDailyLog_Manpower?: InputMaybe<Scalars['Boolean']>
  syncSiteAttendanceToDailyLog_Timecards?: InputMaybe<Scalars['Boolean']>
  syncSiteDiaries: Scalars['Boolean']
  syncSubcontractors: Scalars['Boolean']
  syncSwms: Scalars['Boolean']
  syncToolboxes: Scalars['Boolean']
}

export interface UpdateProjectInput {
  address?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['DateTime']>
  info?: InputMaybe<Scalars['JSON']>
  language?: InputMaybe<Scalars['String']>
  latitude?: InputMaybe<Scalars['Float']>
  locale?: InputMaybe<SupportedLocaleCountryCode>
  longitude?: InputMaybe<Scalars['Float']>
  name?: InputMaybe<Scalars['String']>
  projectAdminsIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  projectContacts?: InputMaybe<Array<InputMaybe<UpdateContactInput>>>
  radius?: InputMaybe<Scalars['Float']>
  requiredTicketsIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  signOnRedirectUrl?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['DateTime']>
  status?: InputMaybe<ProjectStatus>
  timezone?: InputMaybe<Scalars['String']>
}

export interface UpdateProjectLocationInput {
  name?: InputMaybe<Scalars['String']>
  parentId?: InputMaybe<Scalars['String']>
}

export interface UpdateProjectScheduleInputAdmin {
  title?: InputMaybe<Scalars['String']>
}

export interface UpdateProjectSpecificInductionSettingInput {
  siteInductionCode?: InputMaybe<Scalars['String']>
  siteInductionCodeDescription?: InputMaybe<Scalars['String']>
}

export interface UpdateProjectSpecificPermitSettingsInput {
  authorisedWorkersForPermitRequests?: InputMaybe<Array<Scalars['String']>>
  permitAdminNotificationsIds?: InputMaybe<Array<Scalars['String']>>
}

export interface UpdateProjectSpecificProcoreSettingInput {
  checklistFolderId?: InputMaybe<Scalars['String']>
  inductionFolderId?: InputMaybe<Scalars['String']>
  siteDiaryFolderId?: InputMaybe<Scalars['String']>
  swmsFolderId?: InputMaybe<Scalars['String']>
  toolboxFolderId?: InputMaybe<Scalars['String']>
}

export interface UpdateProjectSpecificSettingsInput {
  manualQrCodeRotationProjectCode?: InputMaybe<Scalars['String']>
  qrCodeRotationCustomMessage?: InputMaybe<Scalars['String']>
  qrCodeRotationEnabled: Scalars['Boolean']
  qrCodeRotationInterval?: InputMaybe<Scalars['Int']>
}

export interface UpdateProjectSpecificSiteDiarySettingsInput {
  automaticCreationEnabled?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateProjectSubcontractorsInput {
  subcontractorIds: Array<InputMaybe<Scalars['String']>>
}

export interface UpdatePublicPlatformActionViaChecklistResourceLinkInput {
  attachmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  description?: InputMaybe<Scalars['String']>
  dueDate?: InputMaybe<Scalars['DateTime']>
  priority?: InputMaybe<PlatformActionPriority>
  priorityType?: InputMaybe<Scalars['String']>
  resourceLinkId: Scalars['String']
  status: PlatformActionStatus
  templateResponseId: Scalars['String']
  title?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export interface UpdatePublicSubcontractorPlatformActionInput {
  status?: InputMaybe<PlatformActionStatus>
}

export interface UpdatePublicTemplateResponseInput {
  completedAt?: InputMaybe<Scalars['DateTime']>
  locationId?: InputMaybe<Scalars['String']>
  resourceLinkId: Scalars['String']
  responseData?: InputMaybe<Scalars['JSON']>
}

export interface UpdateRegisterInput {
  identifierPrefix: Scalars['String']
  name: Scalars['String']
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  settings?: InputMaybe<RegisterSettingsInput>
  typeLibraryTemplateId?: InputMaybe<Scalars['String']>
}

export interface UpdateRegisterItemBookingInput {
  endDate?: InputMaybe<Scalars['DateTime']>
  startDate?: InputMaybe<Scalars['DateTime']>
  title?: InputMaybe<Scalars['String']>
}

export interface UpdateRegisterItemInput {
  assignees: Array<AssigneeInput>
  checklistTemplateIds?: InputMaybe<Array<Scalars['String']>>
  followUpAt?: InputMaybe<Scalars['DateTime']>
  name?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  registerItemTypeId?: InputMaybe<Scalars['String']>
  status?: InputMaybe<RegisterItemStatus>
  templateResponseData: Scalars['JSON']
}

export interface UpdateRegisterItemTypeInput {
  linkedChecklistIds?: InputMaybe<Array<Scalars['String']>>
  name?: InputMaybe<Scalars['String']>
}

export interface UpdateResourceLinkDefectInput {
  status?: InputMaybe<DefectStatus>
}

export interface UpdateResourceLinkInput {
  active?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateResourceLinkPrequalificationInput {
  responseData: Scalars['JSON']
}

export interface UpdateRolePermissionsInput {
  description?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  permissions?: InputMaybe<Array<InputMaybe<PermissionInput>>>
}

export interface UpdateSwmsSettingInput {
  allowExpiringSWMS?: InputMaybe<Scalars['Boolean']>
  allowOverridingExistingSWMSTemplates?: InputMaybe<Scalars['Boolean']>
  allowSavingNewSWMSTemplates?: InputMaybe<Scalars['Boolean']>
  autoApproveSWMSForBuilder?: InputMaybe<Scalars['Boolean']>
  autoApproveSWMSForSubcontractorFromTemplate?: InputMaybe<Scalars['Boolean']>
  defaultSWMSHazardResponsible?: InputMaybe<Array<Scalars['String']>>
  includeSWMSActivityInPDFExport: Scalars['Boolean']
  includeSWMSChecklistInPDFExport: Scalars['Boolean']
  librarySwmsExpiryDays?: InputMaybe<Scalars['Int']>
  sharedSWMSTemplateIds?: InputMaybe<Array<Scalars['String']>>
  showBuildPassSWMSTemplatesOption?: InputMaybe<Scalars['Boolean']>
  showStartFromScratchSWMSOption?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateScheduleInput {
  archivedAt?: InputMaybe<Scalars['DateTime']>
  assignedAdminUserIds: Array<Scalars['String']>
  interval?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['DateTime']>
  status?: InputMaybe<ScheduleStatus>
  title?: InputMaybe<Scalars['String']>
}

export interface UpdateSignOnContextMetadataInput {
  contextMetadata: ContextMetadataInput
  signOnId: Scalars['String']
}

export interface UpdateSignOnSettingInput {
  geolocationAutoSignOnOffEnabledForAllProjects?: InputMaybe<Scalars['Boolean']>
  geolocationSignOnOffRemindersEnabledForAllProjects?: InputMaybe<
    Scalars['Boolean']
  >
  preventSignOnUntilInductionApproved?: InputMaybe<Scalars['Boolean']>
  preventSignOnWithoutValidTickets?: InputMaybe<Scalars['Boolean']>
  projectIdsWithGeolocationSignOnOffRemindersEnabled?: InputMaybe<
    Array<Scalars['String']>
  >
  projectIdsWithSignOnScanRequirementDisabled?: InputMaybe<
    Array<Scalars['String']>
  >
  signOnScanRequirementDisabledForAllProjects?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateSiteDiaryInput {
  date?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  templateResponse?: InputMaybe<CreateTemplateResponseInput>
}

export interface UpdateStylingSettingsInput {
  buttonTextColour?: InputMaybe<Scalars['String']>
  primaryColour?: InputMaybe<Scalars['String']>
  primaryTextColour?: InputMaybe<Scalars['String']>
}

export interface UpdateSubcontractorDetailsInput {
  address?: InputMaybe<Scalars['String']>
  company?: InputMaybe<CompanyNameInput>
}

export interface UpdateSubcontractorInput {
  address?: InputMaybe<Scalars['String']>
  builderId?: InputMaybe<Scalars['String']>
  company?: InputMaybe<CompanyNameInput>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface UpdateSubcontractorSettingInput {
  customInsurancesTypes?: InputMaybe<Array<Scalars['String']>>
  expiredInsurancesEmails?: InputMaybe<Scalars['Boolean']>
  notifyAdminUsers?: InputMaybe<Array<Scalars['String']>>
}

export interface UpdateSwmsDocInput {
  checklist?: InputMaybe<Scalars['JSON']>
  checklistTemplateResponse?: InputMaybe<CreateTemplateResponseInput>
  expireInDays?: InputMaybe<Scalars['Int']>
  key?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  required?: InputMaybe<Scalars['Boolean']>
  requiredAll?: InputMaybe<Scalars['Boolean']>
  review?: InputMaybe<Scalars['String']>
  showAll?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<SwmsStatus>
  workerIds?: InputMaybe<Array<Scalars['String']>>
}

export interface UpdateSwmsTemplateInput {
  subcontractorId: Scalars['String']
  templateData?: InputMaybe<Scalars['JSON']>
  templateId: Scalars['String']
  templateName?: InputMaybe<Scalars['String']>
}

export interface UpdateSwmsTemplateResponseInput {
  libraryTemplateId?: InputMaybe<Scalars['String']>
  responseData?: InputMaybe<Scalars['JSON']>
  subcontractorId: Scalars['String']
  templateId?: InputMaybe<Scalars['String']>
  templateResponseId: Scalars['String']
}

export interface UpdateTemplateInput {
  accessProfileTemplateId?: InputMaybe<Scalars['String']>
  identifierPrefix?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  templateCategoryName?: InputMaybe<Scalars['String']>
  templateData?: InputMaybe<Scalars['JSON']>
  templateName?: InputMaybe<Scalars['String']>
  templateType?: InputMaybe<TemplateType>
}

export interface UpdateTemplateResponseAsWorkerInput {
  archivedAt?: InputMaybe<Scalars['DateTime']>
  completedAt?: InputMaybe<Scalars['DateTime']>
  responseData?: InputMaybe<Scalars['JSON']>
  templateResponseId: Scalars['String']
}

export interface UpdateTemplateResponseInput {
  accessProfile?: InputMaybe<AccessProfileInput>
  completedAt?: InputMaybe<Scalars['DateTime']>
  locationId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
  responseData?: InputMaybe<Scalars['JSON']>
  scheduledJobId?: InputMaybe<Scalars['String']>
}

export interface UpdateTicketInput {
  countryIssued?: InputMaybe<Scalars['String']>
  expiry?: InputMaybe<Scalars['DateTime']>
  files?: InputMaybe<Array<InputMaybe<TicketFileInput>>>
  number?: InputMaybe<Scalars['String']>
  obtained?: InputMaybe<Scalars['DateTime']>
  stateIssued?: InputMaybe<State>
  ticketTemplateId?: InputMaybe<Scalars['String']>
}

export interface UpdateTicketInputV2 {
  countryIssued?: InputMaybe<Scalars['String']>
  expiry?: InputMaybe<Scalars['DateTime']>
  files?: InputMaybe<Array<InputMaybe<TicketFileInput>>>
  number?: InputMaybe<Scalars['String']>
  obtained?: InputMaybe<Scalars['DateTime']>
  stateIssued?: InputMaybe<Scalars['String']>
  ticketTemplateId?: InputMaybe<Scalars['String']>
}

export interface UpdateTicketReviewInput {
  reviewComments?: InputMaybe<Scalars['String']>
  reviewStatus?: InputMaybe<TicketReviewStatus>
}

export interface UpdateTimesheetInput {
  responseData?: InputMaybe<Scalars['JSON']>
  timesheetEntry: TimesheetEntryInput
}

export interface UpdateTimesheetSettingInput {
  costCodes?: InputMaybe<Array<CostCodeInput>>
  jobPacCsvExport?: InputMaybe<Scalars['Boolean']>
  primaryApprovers?: InputMaybe<Array<TimesheetPrimaryApproverInput>>
  requiresSecondaryApproval?: InputMaybe<Scalars['Boolean']>
  secondaryApproverIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  subcontractorIdsWhitelist?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  timeTypes?: InputMaybe<Array<TimeTypeInput>>
  timesheetEntryNotes?: InputMaybe<Scalars['Boolean']>
  timesheetStartEndTimes?: InputMaybe<Scalars['Boolean']>
}

export interface UpdateTimesheetsInputs {
  responseData?: InputMaybe<Scalars['JSON']>
  timesheetEntries: Array<TimesheetEntryInput>
}

export interface UpdateToolboxInput {
  agenda?: InputMaybe<Scalars['String']>
  date?: InputMaybe<Scalars['DateTime']>
  invitedUsers?: InputMaybe<InvitedUsersToolboxInput>
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  notes?: InputMaybe<Scalars['String']>
  status?: InputMaybe<ToolboxStatus>
  templateResponse?: InputMaybe<UpdateTemplateResponseInput>
  type?: InputMaybe<ToolboxType>
}

export interface UpdateUserInput {
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  profilePicture?: InputMaybe<Scalars['String']>
}

export interface UpdateUserSettings {
  favourites?: InputMaybe<Array<Scalars['String']>>
}

export interface UpdateWorkerInput {
  address?: InputMaybe<Scalars['String']>
  allergies?: InputMaybe<Scalars['String']>
  dob?: InputMaybe<Scalars['String']>
  emergencyContact?: InputMaybe<Scalars['String']>
  emergencyContactNumber?: InputMaybe<Scalars['String']>
  emergencyContactRelationship?: InputMaybe<Scalars['String']>
  employmentStatus?: InputMaybe<Scalars['String']>
  medicalInformation?: InputMaybe<Scalars['String']>
  mobile?: InputMaybe<Scalars['String']>
  subcontractorId?: InputMaybe<Scalars['String']>
  trade?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export interface UpdateWorkerMetadataInput {
  metadata?: InputMaybe<Scalars['JSON']>
}

export interface UpdateWorkerUserInput {
  address?: InputMaybe<Scalars['String']>
  allergies?: InputMaybe<Scalars['String']>
  builderGenerated?: InputMaybe<Scalars['Boolean']>
  dob?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  emergencyContact?: InputMaybe<Scalars['String']>
  emergencyContactNumber?: InputMaybe<Scalars['String']>
  emergencyContactRelationship?: InputMaybe<Scalars['String']>
  employmentStatus?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  medicalInformation?: InputMaybe<Scalars['String']>
  mobile?: InputMaybe<Scalars['String']>
  subcontractorIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  trade?: InputMaybe<Scalars['String']>
  userIdentity?: InputMaybe<Scalars['String']>
  workerId?: InputMaybe<Scalars['String']>
}

export interface UpsertProcoreConfigInput {
  isDev?: InputMaybe<Scalars['Boolean']>
  procoreAccessToken: Scalars['String']
  procoreCompanyId: Scalars['String']
}

export interface UpsertProcoreDailyLogsInput {
  date: Scalars['DateTime']
  projectId: Scalars['String']
  templateResponse: CreateTemplateResponseInput
}

export interface User {
  __typename?: 'User'
  adminUser?: Maybe<AdminUser>
  createdAt: Scalars['DateTime']
  email?: Maybe<Scalars['String']>
  firstName: Scalars['String']
  hasVisitor?: Maybe<Scalars['Boolean']>
  hasWorker?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  /** @deprecated Performance issues */
  kindeMobile?: Maybe<Scalars['String']>
  lastName: Scalars['String']
  profilePicture?: Maybe<Attachment>
  updatedAt: Scalars['DateTime']
  userHash: Scalars['String']
  userIdentity?: Maybe<Scalars['String']>
  visitor?: Maybe<Visitor>
  worker?: Maybe<Worker>
}

export interface UserAiSuggestion {
  __typename?: 'UserAISuggestion'
  hasCreatedToday: Scalars['Boolean']
  nextPromptDate?: Maybe<Scalars['DateTime']>
  resource: Resource
  resourceId?: Maybe<Scalars['String']>
  resourceName?: Maybe<Scalars['String']>
}

export interface UserEntity {
  __typename?: 'UserEntity'
  firstName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
}

export interface UserSettings {
  __typename?: 'UserSettings'
  favourites?: Maybe<Array<Scalars['String']>>
}

export interface UserResourceLink {
  __typename?: 'User_ResourceLink'
  firstName: Scalars['String']
  id: Scalars['String']
  lastName: Scalars['String']
}

export interface VersionHistory {
  __typename?: 'VersionHistory'
  collectionIdentifier: Scalars['String']
  createdAt: Scalars['DateTime']
  document?: Maybe<Document>
  drawing?: Maybe<DrawingAdmin>
  id: Scalars['String']
  induction?: Maybe<Induction>
  insuranceDoc?: Maybe<InsuranceDoc>
  librarySwmsDoc?: Maybe<LibrarySwmsDocAdmin>
  msdsDoc?: Maybe<MsdsDoc>
  prequalification?: Maybe<Prequalification>
  swmsDoc?: Maybe<SwmsDoc>
  version: Scalars['Int']
}

export interface VideoDisplayBlock extends TemplateBlockBase {
  __typename?: 'VideoDisplayBlock'
  caption?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  kind: TemplateBlockKind
  name?: Maybe<Scalars['String']>
  type: TemplateBlockTypes
  url: Scalars['String']
}

export interface Visitor {
  __typename?: 'Visitor'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  mobile?: Maybe<Scalars['String']>
  signOns?: Maybe<Array<SignOn>>
  updatedAt: Scalars['DateTime']
  user: User
  userId: Scalars['String']
}

export interface VisitorDocuments {
  __typename?: 'VisitorDocuments'
  documents: Array<Maybe<DocumentEntity>>
  msdsDocs: Array<Maybe<MsdsDocEntity>>
  swmsDocs: Array<Maybe<SwmsDocEntity>>
}

export interface VisitorToken {
  __typename?: 'VisitorToken'
  email?: Maybe<Scalars['String']>
  token?: Maybe<Scalars['String']>
}

export interface VisitorResourceLink {
  __typename?: 'Visitor_ResourceLink'
  user: UserResourceLink
}

export interface WidgetActivityData {
  __typename?: 'WidgetActivityData'
  signOns?: Maybe<Array<SignOn>>
}

export interface WidgetFilter {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectId?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<Scalars['String']>>
  projectResourceTagIds?: InputMaybe<Array<Scalars['String']>>
}

export interface WidgetFollowUpData {
  __typename?: 'WidgetFollowUpData'
  defects?: Maybe<Array<Defect>>
  platformActions?: Maybe<Array<PlatformAction>>
  registerItems?: Maybe<Array<RegisterItem>>
  swms?: Maybe<Array<SwmsDoc>>
}

export interface WidgetGamesSettings {
  __typename?: 'WidgetGamesSettings'
  gameType?: Maybe<GameType>
}

export interface WidgetGamesSettingsInput {
  gameType?: InputMaybe<GameType>
}

export interface WidgetMetabaseData {
  __typename?: 'WidgetMetabaseData'
  iframeUrl?: Maybe<Scalars['String']>
}

export interface WidgetMetabaseSettings {
  __typename?: 'WidgetMetabaseSettings'
  dashboardId?: Maybe<Scalars['String']>
}

export interface WidgetMetabaseSettingsInput {
  dashboardId?: InputMaybe<Scalars['String']>
}

export enum WidgetReportDimension {
  Status = 'STATUS',
}

export enum WidgetReportGraphType {
  Bar = 'BAR',
  Column = 'COLUMN',
}

export enum WidgetReportMetric {
  ActionCount = 'ACTION_COUNT',
  AverageScore = 'AVERAGE_SCORE',
  ItemsToFollowUp = 'ITEMS_TO_FOLLOW_UP',
  TotalCount = 'TOTAL_COUNT',
}

export enum WidgetReportResource {
  Checklists = 'CHECKLISTS',
  Registers = 'REGISTERS',
  RegisterItem = 'REGISTER_ITEM',
}

export interface WidgetReportingData {
  __typename?: 'WidgetReportingData'
  items?: Maybe<Array<WidgetReportingItem>>
}

export interface WidgetReportingItem {
  __typename?: 'WidgetReportingItem'
  data?: Maybe<Array<ReportDimensionData>>
  metricType: WidgetReportMetric
  resource: WidgetReportingItemResource
}

export interface WidgetReportingItemResource {
  __typename?: 'WidgetReportingItemResource'
  id: Scalars['String']
  name: Scalars['String']
  resourceType: WidgetReportResource
}

export interface WidgetReportingSettings {
  __typename?: 'WidgetReportingSettings'
  dimension?: Maybe<WidgetReportDimension>
  graphType?: Maybe<WidgetReportGraphType>
  metric: WidgetReportMetric
  resourceIds?: Maybe<Array<Scalars['String']>>
  resourceType: WidgetReportResource
  showTable?: Maybe<Scalars['Boolean']>
}

export interface WidgetReportingSettingsInput {
  dimension?: InputMaybe<WidgetReportDimension>
  graphType?: InputMaybe<WidgetReportGraphType>
  metric: WidgetReportMetric
  resourceIds?: InputMaybe<Array<Scalars['String']>>
  resourceType: WidgetReportResource
  showTable?: InputMaybe<Scalars['Boolean']>
}

export interface WidgetToReviewData {
  __typename?: 'WidgetToReviewData'
  documents?: Maybe<Array<Document>>
  inductions?: Maybe<Array<InductionToReview>>
  insurances?: Maybe<Array<InsuranceDoc>>
  sds: Array<Maybe<MsdsDoc>>
  swms?: Maybe<Array<SwmsDoc>>
}

export enum WidgetType {
  Activity = 'ACTIVITY',
  FollowUp = 'FOLLOW_UP',
  Games = 'GAMES',
  Metabase = 'METABASE',
  Reporting = 'REPORTING',
  ToReview = 'TO_REVIEW',
}

export interface Worker {
  __typename?: 'Worker'
  accessControlIntegrationConnection?: Maybe<AccessControlIntegrationConnection>
  accessControls?: Maybe<Array<AccessControl>>
  address?: Maybe<Scalars['String']>
  allergies?: Maybe<Scalars['String']>
  archivedAt?: Maybe<Scalars['DateTime']>
  builderDocuments?: Maybe<Array<Maybe<BuilderWorkerDocument>>>
  builderGenerated: Scalars['Boolean']
  builderMetadata?: Maybe<WorkerBuilderMetadata>
  createdAt: Scalars['DateTime']
  defects?: Maybe<Array<Maybe<Defect>>>
  dob?: Maybe<Scalars['String']>
  documentSignatures: Array<Maybe<DocumentSignature>>
  emergencyContact?: Maybe<Scalars['String']>
  emergencyContactNumber?: Maybe<Scalars['String']>
  emergencyContactRelationship?: Maybe<Scalars['String']>
  employmentStatus?: Maybe<Scalars['String']>
  id: Scalars['String']
  inductions: Array<Maybe<Induction>>
  medicalInformation?: Maybe<Scalars['String']>
  mobile?: Maybe<Scalars['String']>
  mostRecentSignOnDate?: Maybe<Scalars['DateTime']>
  permits?: Maybe<Array<Maybe<PermitAdmin>>>
  projects: Array<Maybe<Project>>
  signOns: Array<Maybe<SignOn>>
  subcontractors: Array<Maybe<Subcontractor>>
  tickets?: Maybe<Array<Maybe<Ticket>>>
  trade?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  user: User
  userId: Scalars['String']
}

export interface WorkerSubcontractorsArgs {
  projectId?: InputMaybe<Scalars['String']>
}

export interface WorkerAuditEntity {
  __typename?: 'WorkerAuditEntity'
  id: Scalars['String']
  user?: Maybe<UserEntity>
}

export interface WorkerAuditResourceLink {
  __typename?: 'WorkerAudit_ResourceLink'
  id: Scalars['String']
  user: UserResourceLink
}

export interface WorkerBuilderMetadata {
  __typename?: 'WorkerBuilderMetadata'
  builder: Builder
  builderId: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  metadata?: Maybe<Scalars['JSON']>
  updatedAt: Scalars['DateTime']
  worker: Worker
  workerId: Scalars['String']
}

export interface WorkerChecklistSettings {
  __typename?: 'WorkerChecklistSettings'
  /** Customisable list of categories that can be used on checklists */
  checklistCategories?: Maybe<Array<ChecklistCategorySetting>>
  /** Set which categories should display in the side navigation bar */
  checklistCategoriesInNavigation?: Maybe<Array<Scalars['String']>>
  /** Checklists available for the current worker to fill in */
  checklistsAvailableForMe?: Maybe<Array<Maybe<TemplateEntity>>>
  /** The associated project */
  project: ProjectEntity
}

export interface WorkerDefectEntry {
  __typename?: 'WorkerDefectEntry'
  archivedAt?: Maybe<Scalars['DateTime']>
  attachments?: Maybe<Array<Maybe<AttachmentResourceLink>>>
  completedAt?: Maybe<Scalars['DateTime']>
  conversation?: Maybe<ConversationThreadResourceLink>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  location?: Maybe<ProjectLocationResourceLink>
  locationId?: Maybe<Scalars['String']>
  order?: Maybe<Scalars['Int']>
  overdue?: Maybe<Scalars['Boolean']>
  priority?: Maybe<DefectPriority>
  project: ProjectResourceLink
  status: DefectStatus
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface WorkerDocuments {
  __typename?: 'WorkerDocuments'
  documents: Array<Maybe<DocumentEntity>>
  msdsDocs: Array<Maybe<MsdsDocEntity>>
  swmsDocs: Array<Maybe<SwmsDocEntity>>
}

export interface WorkerEntity {
  __typename?: 'WorkerEntity'
  address?: Maybe<Scalars['String']>
  allergies?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  dob?: Maybe<Scalars['String']>
  emergencyContact?: Maybe<Scalars['String']>
  emergencyContactNumber?: Maybe<Scalars['String']>
  emergencyContactRelationship?: Maybe<Scalars['String']>
  employmentStatus?: Maybe<Scalars['String']>
  id: Scalars['String']
  medicalInformation?: Maybe<Scalars['String']>
  mobile?: Maybe<Scalars['String']>
  subcontractors: Array<Maybe<SubcontractorEntity>>
  trade?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  user: UserEntity
  userId: Scalars['String']
}

export interface WorkerFileSnapshot {
  __typename?: 'WorkerFileSnapshot'
  contentType?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['DateTime']>
  id?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
  url?: Maybe<Scalars['String']>
}

export interface WorkerForEmergency {
  __typename?: 'WorkerForEmergency'
  id: Scalars['String']
  mobile?: Maybe<Scalars['String']>
  trade?: Maybe<Scalars['String']>
  user: UserEntity
  userId: Scalars['String']
}

export interface WorkerProject {
  __typename?: 'WorkerProject'
  address?: Maybe<Scalars['String']>
  builder?: Maybe<BuilderEntity>
  config?: Maybe<Scalars['JSON']>
  /** @deprecated Use projectContacts instead */
  contacts?: Maybe<ProjectContacts>
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  info?: Maybe<Scalars['JSON']>
  language?: Maybe<Scalars['String']>
  latitude?: Maybe<Scalars['Float']>
  locale?: Maybe<SupportedLocaleCountryCode>
  longitude?: Maybe<Scalars['Float']>
  name: Scalars['String']
  projectContacts?: Maybe<Array<Maybe<ContactEntity>>>
  projectSettings?: Maybe<ProjectSettings>
  publicProjectContacts?: Maybe<Array<Maybe<ContactEntity>>>
  radius?: Maybe<Scalars['Int']>
  requiredTickets?: Maybe<Array<Maybe<TicketTemplate>>>
  status: ProjectStatus
  subcontractors?: Maybe<Array<Maybe<SubcontractorEntity>>>
  timezone?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export interface WorkerProjectSubcontractorsArgs {
  filter?: InputMaybe<WorkerProjectSubcontractorFilterInput>
}

export interface WorkerProjectInduction {
  __typename?: 'WorkerProjectInduction'
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  identifier?: Maybe<Scalars['Int']>
  project: WorkerProjectInductionProject
  projectId: Scalars['String']
  signatureUrl?: Maybe<Scalars['String']>
  status?: Maybe<InductionStatus>
  templateName?: Maybe<Scalars['String']>
  templateResponse?: Maybe<WorkerProjectInductionTemplateResponse>
  type: InductionType
  updatedAt: Scalars['DateTime']
  /** @deprecated Use workerSnapshotFull instead */
  workerSnapshot?: Maybe<Scalars['JSON']>
  workerSnapshotFull?: Maybe<WorkerSnapshot>
}

export interface WorkerProjectInductionProject {
  __typename?: 'WorkerProjectInduction_Project'
  id: Scalars['String']
  name: Scalars['String']
}

export interface WorkerProjectInductionTemplateResponse {
  __typename?: 'WorkerProjectInduction_TemplateResponse'
  id: Scalars['String']
  responseData?: Maybe<Scalars['JSON']>
}

export interface WorkerProjectSubcontractorFilterInput {
  includeBuildSubcontractors?: InputMaybe<Scalars['Boolean']>
}

export interface WorkerReport {
  __typename?: 'WorkerReport'
  id?: Maybe<Scalars['String']>
  name: Scalars['String']
  projectHours: Scalars['Float']
  projectHoursByDate: Array<ProjectHoursByDate>
}

export interface WorkerSignOnFilterInput {
  workerId: Scalars['String']
}

export interface WorkerSignOnSortInput {
  date?: InputMaybe<SortOrder>
}

export interface WorkerSignatures {
  __typename?: 'WorkerSignatures'
  inductions: Array<Maybe<Induction>>
  signatures: Array<Maybe<DocumentSignature>>
}

export interface WorkerSnapshot {
  __typename?: 'WorkerSnapshot'
  address?: Maybe<Scalars['String']>
  allergies?: Maybe<Scalars['String']>
  archivedAt?: Maybe<Scalars['DateTime']>
  createdAt?: Maybe<Scalars['DateTime']>
  dob?: Maybe<Scalars['String']>
  emergencyContact?: Maybe<Scalars['String']>
  emergencyContactNumber?: Maybe<Scalars['String']>
  emergencyContactRelationship?: Maybe<Scalars['String']>
  employmentStatus?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  medicalInformation?: Maybe<Scalars['String']>
  mobile?: Maybe<Scalars['String']>
  subcontractors?: Maybe<Array<Maybe<WorkerSubcontractorSnapshot>>>
  tickets?: Maybe<Array<Maybe<WorkerTicketSnapshot>>>
  trade?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
  user?: Maybe<WorkerUserSnapshot>
  userId?: Maybe<Scalars['String']>
}

export interface WorkerSortInput {
  name?: InputMaybe<SortOrder>
  trade?: InputMaybe<SortOrder>
}

export interface WorkerSubcontractorSnapshot {
  __typename?: 'WorkerSubcontractorSnapshot'
  builderId?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['DateTime']>
  email?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export interface WorkerTemplateResponseFilterInput {
  projectId?: InputMaybe<Scalars['String']>
  relatedRegisterItemId?: InputMaybe<Scalars['String']>
  select?: InputMaybe<TemplateResponseFilterSelect>
  templateCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  templateId?: InputMaybe<Scalars['String']>
  templateType?: InputMaybe<TemplateType>
}

export interface WorkerTicketFileSnapshot {
  __typename?: 'WorkerTicketFileSnapshot'
  createdAt?: Maybe<Scalars['DateTime']>
  file?: Maybe<WorkerFileSnapshot>
  id?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export interface WorkerTicketReviewStatus {
  __typename?: 'WorkerTicketReviewStatus'
  reviewComments?: Maybe<Scalars['String']>
  reviewStatus: TicketReviewStatus
  ticketId: Scalars['String']
}

export interface WorkerTicketReviewStatuses {
  __typename?: 'WorkerTicketReviewStatuses'
  enforceValidation: Scalars['Boolean']
  reviews?: Maybe<Array<WorkerTicketReviewStatus>>
}

export interface WorkerTicketShareEntity {
  __typename?: 'WorkerTicketShareEntity'
  dob?: Maybe<Scalars['String']>
  id: Scalars['String']
  subcontractors: Array<Maybe<SubcontractorEntity>>
  tickets?: Maybe<Array<Maybe<TicketEntity>>>
  trade?: Maybe<Scalars['String']>
  user: UserEntity
}

export interface WorkerTicketSnapshot {
  __typename?: 'WorkerTicketSnapshot'
  builderGenerated?: Maybe<Scalars['Boolean']>
  builderId?: Maybe<Scalars['String']>
  countryIssued?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['DateTime']>
  expiry?: Maybe<Scalars['DateTime']>
  files?: Maybe<Array<Maybe<WorkerTicketFileSnapshot>>>
  id?: Maybe<Scalars['String']>
  number?: Maybe<Scalars['String']>
  obtained?: Maybe<Scalars['DateTime']>
  stateIssued?: Maybe<Scalars['String']>
  ticketTemplate?: Maybe<WorkerTicketTemplateSnapshot>
  ticketTemplateId?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
  workerId?: Maybe<Scalars['String']>
}

export interface WorkerTicketTemplateSnapshot {
  __typename?: 'WorkerTicketTemplateSnapshot'
  code?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['DateTime']>
  expiry?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  obtained?: Maybe<Scalars['Boolean']>
  shortName?: Maybe<Scalars['String']>
  ticketCategoryId?: Maybe<Scalars['String']>
  ticketTypeId?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export interface WorkerTimesheetEntry {
  __typename?: 'WorkerTimesheetEntry'
  costCode?: Maybe<Scalars['String']>
  date: Scalars['DateTime']
  hours: Scalars['Float']
  hoursOverride?: Maybe<Scalars['Float']>
  id: Scalars['String']
  notes?: Maybe<Scalars['String']>
  project: ProjectEntity
  status: TimesheetEntryStatus
  subcontractor: SubcontractorEntity
  timeType: Scalars['String']
  timesheetGroup: WorkerTimesheetGroup
}

export interface WorkerTimesheetGroup {
  __typename?: 'WorkerTimesheetGroup'
  id: Scalars['String']
  templateResponse?: Maybe<TemplateResponseEntity>
}

export interface WorkerTimesheetSettings {
  __typename?: 'WorkerTimesheetSettings'
  /** List of cost codes that can be used on timesheets */
  costCodes: Array<Maybe<CostCode>>
  /** Whether timesheets are enabled for this worker */
  isTimesheetsEnabledForMe: Scalars['Boolean']
  /** List of time types that can be used on timesheets */
  timeTypes: Array<Maybe<TimeType>>
  /** Whether the notes field on each timesheet entry is enabled or not */
  timesheetEntryNotes: Scalars['Boolean']
  /** Whether the start and end time fields on each timesheet entry is enabled or not */
  timesheetStartEndTimes: Scalars['Boolean']
}

export interface WorkerUsage {
  __typename?: 'WorkerUsage'
  numberOfManuallyCreatedWorkers: Scalars['Int']
  numberOfUsers: Scalars['Int']
  numberOfVisitors: Scalars['Int']
  numberOfWorkers: Scalars['Int']
  vaccineStatus?: Maybe<WorkerVaccineStatus>
}

export interface WorkerUserSnapshot {
  __typename?: 'WorkerUserSnapshot'
  createdAt?: Maybe<Scalars['DateTime']>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
  userIdentity?: Maybe<Scalars['String']>
}

export interface WorkerVaccineStatus {
  __typename?: 'WorkerVaccineStatus'
  exemption: Scalars['Int']
  firstVaccine: Scalars['Int']
  noVaccine: Scalars['Int']
  secondVaccine: Scalars['Int']
  thirdVaccine: Scalars['Int']
}

export interface WorkerResourceLink {
  __typename?: 'Worker_ResourceLink'
  address?: Maybe<Scalars['String']>
  allergies?: Maybe<Scalars['String']>
  builderGenerated: Scalars['Boolean']
  dob?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  emergencyContact?: Maybe<Scalars['String']>
  emergencyContactNumber?: Maybe<Scalars['String']>
  emergencyContactRelationship?: Maybe<Scalars['String']>
  id: Scalars['String']
  medicalInformation?: Maybe<Scalars['String']>
  mobile?: Maybe<Scalars['String']>
  subcontractors: Array<Maybe<SubcontractorResourceLink>>
  tickets?: Maybe<Array<Maybe<TicketResourceLink>>>
  trade?: Maybe<Scalars['String']>
  user: UserResourceLink
}

export interface WorkersFilterInput {
  employmentStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  hasWhiteCard?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>
  highestJabStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  projectId?: InputMaybe<Scalars['String']>
  shouldIncludeArchivedWorkers?: InputMaybe<Scalars['Boolean']>
  shouldIncludeBuilderSubcontractors?: InputMaybe<Scalars['Boolean']>
  shouldIncludeManuallyGeneratedWorkers?: InputMaybe<Scalars['Boolean']>
  subcontractorIds?: InputMaybe<Array<Scalars['String']>>
  ticketReviewStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  trade?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface WorkersWithResourceFilterInput {
  afterDateTime?: InputMaybe<Scalars['DateTime']>
  beforeDateTime?: InputMaybe<Scalars['DateTime']>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface Workflow {
  __typename?: 'Workflow'
  active?: Maybe<Scalars['Boolean']>
  archivedAt?: Maybe<Scalars['DateTime']>
  conditions?: Maybe<Array<WorkflowCondition>>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  name?: Maybe<Scalars['String']>
  projects?: Maybe<Array<Maybe<Project>>>
  resource?: Maybe<Template>
  resourceId?: Maybe<Scalars['String']>
  resourceTitle?: Maybe<Scalars['String']>
  resourceType?: Maybe<Resource>
  steps?: Maybe<Array<Maybe<WorkflowStep>>>
  updatedAt: Scalars['DateTime']
  version: Scalars['Int']
}

export interface WorkflowCondition {
  __typename?: 'WorkflowCondition'
  conditionType: WorkflowConditionType
  fieldComparison?: Maybe<WorkflowConditionFieldComparisonData>
  label: Scalars['String']
}

export interface WorkflowConditionFieldComparisonData {
  __typename?: 'WorkflowConditionFieldComparisonData'
  field: Array<Scalars['String']>
  operator: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export interface WorkflowConditionFieldComparisonDataInput {
  field: Array<Scalars['String']>
  operator: Scalars['String']
  value?: InputMaybe<Scalars['String']>
}

export interface WorkflowConditionInput {
  conditionType: WorkflowConditionType
  fieldComparison?: InputMaybe<WorkflowConditionFieldComparisonDataInput>
  label: Scalars['String']
}

export enum WorkflowConditionType {
  FieldComparison = 'FIELD_COMPARISON',
  IsCreated = 'IS_CREATED',
  IsUpdated = 'IS_UPDATED',
}

export interface WorkflowExecution {
  __typename?: 'WorkflowExecution'
  completedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  executionSteps?: Maybe<Array<WorkflowExecutionStep>>
  id: Scalars['String']
  status: WorkflowExecutionStatus
  statusMessage?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  workflow: Workflow
}

export interface WorkflowExecutionFilterInput {
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  resourceTypes?: InputMaybe<Array<InputMaybe<Resource>>>
  status?: InputMaybe<Array<InputMaybe<WorkflowExecutionStatus>>>
  workflowIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export interface WorkflowExecutionSortInput {
  completedAt?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  workflowName?: InputMaybe<SortOrder>
}

export enum WorkflowExecutionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
}

export interface WorkflowExecutionStep {
  __typename?: 'WorkflowExecutionStep'
  completedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  status: WorkflowExecutionStatus
  statusMessage?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  workflowExecution: WorkflowExecution
}

export interface WorkflowFilterInput {
  active?: InputMaybe<Scalars['Boolean']>
  archivedFilter?: InputMaybe<ArchivedFilter>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  resourceTypes?: InputMaybe<Array<InputMaybe<Resource>>>
  searchString?: InputMaybe<Scalars['String']>
}

export interface WorkflowInput {
  active?: InputMaybe<Scalars['Boolean']>
  conditions?: InputMaybe<Array<WorkflowConditionInput>>
  name?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  resourceId?: InputMaybe<Scalars['String']>
  resourceType?: InputMaybe<Resource>
  steps?: InputMaybe<Array<InputMaybe<WorkflowStepInput>>>
}

export interface WorkflowSortInput {
  name?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export interface WorkflowStep {
  __typename?: 'WorkflowStep'
  conditions?: Maybe<Array<WorkflowCondition>>
  data?: Maybe<Scalars['JSON']>
  id: Scalars['String']
  parent?: Maybe<WorkflowStep>
  parentId?: Maybe<Scalars['String']>
  type?: Maybe<WorkflowStepType>
}

export interface WorkflowStepInput {
  conditions?: InputMaybe<Array<WorkflowConditionInput>>
  data?: InputMaybe<Scalars['JSON']>
  id?: InputMaybe<Scalars['String']>
  parentId?: InputMaybe<Scalars['String']>
  type?: InputMaybe<WorkflowStepType>
}

export enum WorkflowStepType {
  SendEmail = 'SEND_EMAIL',
  SendNotification = 'SEND_NOTIFICATION',
}

export interface YearInReview {
  __typename?: 'YearInReview'
  builder: Builder
  topActionsUser?: Maybe<TopUser>
  topInductionsReviewer?: Maybe<TopUser>
  topSMSSender?: Maybe<TopUser>
  topSWMSReviewer?: Maybe<TopUser>
  topSignOnsProject?: Maybe<TopProject>
  totalChecklists: Scalars['Int']
  totalPreStarts: Scalars['Int']
  totalSMSs: Scalars['Int']
  totalSignOns: Scalars['Int']
  totalSiteDiaries: Scalars['Int']
  totalSiteInductions: Scalars['Int']
  totalSiteSwms: Scalars['Int']
  totalSiteToolboxes: Scalars['Int']
}

export interface YearInReviewFilterInput {
  year: Scalars['Int']
}

export interface YearInReviewPublic {
  __typename?: 'YearInReviewPublic'
  builder: BuilderEntityPublic
}

export interface ZipAttachmentsResponse {
  __typename?: 'ZipAttachmentsResponse'
  url: Scalars['String']
}

export interface ExportAccessControlWorkersStatus {
  __typename?: 'exportAccessControlWorkersStatus'
  approvedProjectInductionIds?: Maybe<Array<Maybe<Scalars['String']>>>
  firstName: Scalars['String']
  id: Scalars['String']
  lastName: Scalars['String']
  photoUrl?: Maybe<Scalars['String']>
  subcontractorName?: Maybe<Scalars['String']>
}

export type CreateAccessControlForWorkerUiMutationVariables = Exact<{
  input: CreateAccessControlForWorkerInput
}>

export type CreateAccessControlForWorkerUiMutation = {
  __typename?: 'Mutation'
  createAccessControlForWorker: { __typename?: 'AccessControl'; id: string }
}

export type UpdateAccessControlForWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateAccessControlForWorkerInput
}>

export type UpdateAccessControlForWorkerUiMutation = {
  __typename?: 'Mutation'
  updateAccessControlForWorker: {
    __typename?: 'SyncWorkerAccessControlManualResult'
    success: boolean
    message: string
  }
}

export type ArchiveAccessControlForWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveAccessControlForWorkerUiMutation = {
  __typename?: 'Mutation'
  archiveAccessControlForWorker: {
    __typename?: 'SyncWorkerAccessControlManualResult'
    success: boolean
    message: string
  }
}

export type SyncWorkerAccessControlManualUiMutationVariables = Exact<{
  workerId: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
}>

export type SyncWorkerAccessControlManualUiMutation = {
  __typename?: 'Mutation'
  syncWorkerAccessControlManual: {
    __typename?: 'SyncWorkerAccessControlManualResult'
    message: string
    success: boolean
  }
}

export type ExportAccessControlWorkersStatusUiQueryVariables = Exact<{
  projectIds: Array<Scalars['String']> | Scalars['String']
}>

export type ExportAccessControlWorkersStatusUiQuery = {
  __typename?: 'Query'
  exportAccessControlWorkersStatus: Array<{
    __typename?: 'exportAccessControlWorkersStatus'
    id: string
    firstName: string
    lastName: string
    photoUrl?: string | null
    approvedProjectInductionIds?: Array<string | null> | null
    subcontractorName?: string | null
  }>
}

export type AccessProfileTemplateUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type AccessProfileTemplateUiQuery = {
  __typename?: 'Query'
  accessProfileTemplate?: {
    __typename?: 'AccessProfileTemplate'
    id: string
    name: string
    defaultRole?: AccessProfileRole | null
    archivedAt?: string | null
    accessProfiles: Array<{
      __typename?: 'AccessProfile'
      id: string
      name: string
      templateResponses: Array<{ __typename?: 'TemplateResponse'; id: string }>
    }>
    actors: Array<{
      __typename?: 'AccessProfileTemplateActor'
      id: string
      role: AccessProfileRole
      adminUser: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    }>
  } | null
}

export type AccessProfileTemplatesUiQueryVariables = Exact<{
  filters?: InputMaybe<AccessProfileTemplatesFilters>
}>

export type AccessProfileTemplatesUiQuery = {
  __typename?: 'Query'
  accessProfileTemplates: Array<{
    __typename?: 'AccessProfileTemplate'
    id: string
    name: string
    defaultRole?: AccessProfileRole | null
    archivedAt?: string | null
    actors: Array<{
      __typename?: 'AccessProfileTemplateActor'
      id: string
      role: AccessProfileRole
      adminUser: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    }>
    templates: Array<{
      __typename?: 'Template'
      id: string
      templateName: string
    } | null>
  }>
}

export type CreateAccessProfileTemplateUiMutationVariables = Exact<{
  input: AccessProfileTemplateInput
}>

export type CreateAccessProfileTemplateUiMutation = {
  __typename?: 'Mutation'
  createAccessProfileTemplate: {
    __typename?: 'AccessProfileTemplate'
    id: string
    name: string
  }
}

export type UpdateAccessProfileTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
  input: AccessProfileTemplateInput
  overrideOlderAccessProfiles?: InputMaybe<Scalars['Boolean']>
}>

export type UpdateAccessProfileTemplateUiMutation = {
  __typename?: 'Mutation'
  updateAccessProfileTemplate: {
    __typename?: 'AccessProfileTemplate'
    id: string
    name: string
  }
}

export type ArchiveAccessProfileTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveAccessProfileTemplateUiMutation = {
  __typename?: 'Mutation'
  archiveAccessProfileTemplate: {
    __typename?: 'AccessProfileTemplate'
    id: string
    name: string
  }
}

export type RestoreAccessProfileTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreAccessProfileTemplateUiMutation = {
  __typename?: 'Mutation'
  restoreAccessProfileTemplate: {
    __typename?: 'AccessProfileTemplate'
    id: string
    name: string
  }
}

export type UpdateAccessProfileUiMutationVariables = Exact<{
  id: Scalars['String']
  input: AccessProfileInput
}>

export type UpdateAccessProfileUiMutation = {
  __typename?: 'Mutation'
  updateAccessProfile: {
    __typename?: 'AccessProfile'
    id: string
    name: string
    defaultRole?: AccessProfileRole | null
    actors: Array<{
      __typename?: 'AccessProfileActor'
      role: AccessProfileRole
      adminUser: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    }>
    owner?: { __typename?: 'AdminUser'; id: string } | null
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
  }
}

export type UserAttributesFragment = {
  __typename?: 'User'
  id: string
  createdAt: string
  updatedAt: string
  firstName: string
  lastName: string
  email?: string | null
  userIdentity?: string | null
  profilePicture?: { __typename?: 'Attachment'; id: string; url: string } | null
}

export type UserUiQueryVariables = Exact<{ [key: string]: never }>

export type UserUiQuery = {
  __typename?: 'Query'
  user?: {
    __typename?: 'User'
    id: string
    createdAt: string
    updatedAt: string
    firstName: string
    lastName: string
    email?: string | null
    userIdentity?: string | null
    profilePicture?: {
      __typename?: 'Attachment'
      id: string
      url: string
    } | null
  } | null
}

export type UpdateUserUiMutationVariables = Exact<{
  input: UpdateUserInput
}>

export type UpdateUserUiMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'User'
    id: string
    createdAt: string
    updatedAt: string
    firstName: string
    lastName: string
    email?: string | null
    userIdentity?: string | null
    profilePicture?: {
      __typename?: 'Attachment'
      id: string
      url: string
    } | null
  }
}

export type GetWorkerOrAdminUserUiQueryVariables = Exact<{
  [key: string]: never
}>

export type GetWorkerOrAdminUserUiQuery = {
  __typename?: 'Query'
  user?: {
    __typename?: 'User'
    id: string
    createdAt: string
    updatedAt: string
    firstName: string
    lastName: string
    email?: string | null
    userIdentity?: string | null
    worker?: { __typename?: 'Worker'; id: string } | null
    adminUser?: { __typename?: 'AdminUser'; id: string } | null
    profilePicture?: {
      __typename?: 'Attachment'
      id: string
      url: string
    } | null
  } | null
}

export type ActionsAttributesFragment = {
  __typename?: 'PlatformAction'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  remindedAt?: string | null
  projectId?: string | null
  type?: string | null
  title?: string | null
  description?: string | null
  status: PlatformActionStatus
  priorityType?: string | null
  dueDate?: string | null
  locationId?: string | null
  templateResponseBlockData?: any | null
  project?: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
  } | null
  attachments?: Array<{
    __typename?: 'Attachment'
    id: string
    key: string
    url: string
    fileName: string
  } | null> | null
  templateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    fullIdentifier?: string | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateName: string
          templateType: TemplateType
          templateData?: any | null
        }
      | {
          __typename?: 'Template'
          id: string
          templateName: string
          templateType: TemplateType
          templateData?: any | null
        }
      | null
  } | null
  assignees: Array<{
    __typename?: 'Assignee'
    id: string
    worker?: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
  } | null>
  config?: {
    __typename?: 'PlatformActionConfig'
    requireAttachmentToClose?: boolean | null
  } | null
  conversation?: {
    __typename?: 'ConversationThread'
    id: string
    messages: Array<{
      __typename?: 'ConversationMessage'
      id: string
      createdAt: string
      content?: string | null
      sender: {
        __typename?: 'Assignee'
        id: string
        worker?: {
          __typename?: 'Worker'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        adminUser?: {
          __typename?: 'AdminUser'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        subcontractor?: {
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null
      }
      attachments: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      } | null>
    } | null>
  } | null
}

export type PlatformActionsUiQueryVariables = Exact<{
  filter?: InputMaybe<PlatformActionFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<PlatformActionSortInput>
}>

export type PlatformActionsUiQuery = {
  __typename?: 'Query'
  platformActions: Array<{
    __typename?: 'PlatformAction'
    id: string
    createdAt: string
    archivedAt?: string | null
    remindedAt?: string | null
    completedAt?: string | null
    type?: string | null
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    priorityType?: string | null
    dueDate?: string | null
    locationId?: string | null
    projectId?: string | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
      fileName: string
    } | null> | null
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      fullIdentifier?: string | null
      template?:
        | { __typename?: 'LibraryTemplate'; id: string; templateName: string }
        | { __typename?: 'Template'; id: string; templateName: string }
        | null
    } | null
  }>
  platformActionsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type PlatformActionsAggregateStatsUiQueryVariables = Exact<{
  filter?: InputMaybe<PlatformActionFilterInput>
}>

export type PlatformActionsAggregateStatsUiQuery = {
  __typename?: 'Query'
  platformActionsAggregateStats?: Array<{
    __typename?: 'PlatformActionAggregateStats'
    status: PlatformActionStatus
    count: number
  } | null> | null
}

export type PlatformActionUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PlatformActionUiQuery = {
  __typename?: 'Query'
  platformAction?: {
    __typename?: 'PlatformAction'
    isOwner?: boolean | null
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    remindedAt?: string | null
    projectId?: string | null
    type?: string | null
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    priorityType?: string | null
    dueDate?: string | null
    locationId?: string | null
    templateResponseBlockData?: any | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
      fileName: string
    } | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      fullIdentifier?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateName: string
            templateType: TemplateType
            templateData?: any | null
          }
        | {
            __typename?: 'Template'
            id: string
            templateName: string
            templateType: TemplateType
            templateData?: any | null
          }
        | null
    } | null
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    config?: {
      __typename?: 'PlatformActionConfig'
      requireAttachmentToClose?: boolean | null
    } | null
    conversation?: {
      __typename?: 'ConversationThread'
      id: string
      messages: Array<{
        __typename?: 'ConversationMessage'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee'
          id: string
          worker?: {
            __typename?: 'Worker'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor'
            id: string
            company: { __typename?: 'Company'; name: string }
          } | null
        }
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  } | null
}

export type PlatformActionWithAuditLogsUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PlatformActionWithAuditLogsUiQuery = {
  __typename?: 'Query'
  platformAction?: {
    __typename?: 'PlatformAction'
    isOwner?: boolean | null
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    remindedAt?: string | null
    projectId?: string | null
    type?: string | null
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    priorityType?: string | null
    dueDate?: string | null
    locationId?: string | null
    templateResponseBlockData?: any | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
      fileName: string
    } | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      fullIdentifier?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateName: string
            templateType: TemplateType
            templateData?: any | null
          }
        | {
            __typename?: 'Template'
            id: string
            templateName: string
            templateType: TemplateType
            templateData?: any | null
          }
        | null
    } | null
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    config?: {
      __typename?: 'PlatformActionConfig'
      requireAttachmentToClose?: boolean | null
    } | null
    conversation?: {
      __typename?: 'ConversationThread'
      id: string
      messages: Array<{
        __typename?: 'ConversationMessage'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee'
          id: string
          worker?: {
            __typename?: 'Worker'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor'
            id: string
            company: { __typename?: 'Company'; name: string }
          } | null
        }
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  } | null
  auditLogsByResourceId: Array<{
    __typename?: 'AuditLog'
    id: string
    createdAt: string
    builderId?: string | null
    projectId?: string | null
    action: AuditAction
    actionBy?: AuditActionedBy | null
    actionByIdentity?: string | null
    resource: AuditResource
    resourceIdentity?: string | null
    newSnapshot?: any | null
    oldSnapshot?: any | null
    project?: { __typename?: 'Project'; name: string } | null
    actionByLink?:
      | {
          __typename?: 'AdminUserEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | { __typename?: 'SubcontractorEntity'; id: string; name: string }
      | {
          __typename?: 'WorkerAuditEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | null
  }>
  knockMessageLogs_admin: Array<{
    __typename?: 'KnockMessageLog_Admin'
    id: string
    logDate: string
    status: KnockMessageStatus
    messageId: string
    sentTo: {
      __typename?: 'KnockMessageLogUser_admin'
      id: string
      name: string
    }
  }>
}

export type CreatePlatformActionUiMutationVariables = Exact<{
  input: CreatePlatformActionInput
}>

export type CreatePlatformActionUiMutation = {
  __typename?: 'Mutation'
  createPlatformAction: {
    __typename?: 'PlatformAction'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    remindedAt?: string | null
    projectId?: string | null
    type?: string | null
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    priorityType?: string | null
    dueDate?: string | null
    locationId?: string | null
    templateResponseBlockData?: any | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
      fileName: string
    } | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      fullIdentifier?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateName: string
            templateType: TemplateType
            templateData?: any | null
          }
        | {
            __typename?: 'Template'
            id: string
            templateName: string
            templateType: TemplateType
            templateData?: any | null
          }
        | null
    } | null
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    config?: {
      __typename?: 'PlatformActionConfig'
      requireAttachmentToClose?: boolean | null
    } | null
    conversation?: {
      __typename?: 'ConversationThread'
      id: string
      messages: Array<{
        __typename?: 'ConversationMessage'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee'
          id: string
          worker?: {
            __typename?: 'Worker'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor'
            id: string
            company: { __typename?: 'Company'; name: string }
          } | null
        }
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  }
}

export type UpdatePlatformActionUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdatePlatformActionInput
}>

export type UpdatePlatformActionUiMutation = {
  __typename?: 'Mutation'
  updatePlatformAction: {
    __typename?: 'PlatformAction'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    remindedAt?: string | null
    projectId?: string | null
    type?: string | null
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    priorityType?: string | null
    dueDate?: string | null
    locationId?: string | null
    templateResponseBlockData?: any | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
      fileName: string
    } | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      fullIdentifier?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateName: string
            templateType: TemplateType
            templateData?: any | null
          }
        | {
            __typename?: 'Template'
            id: string
            templateName: string
            templateType: TemplateType
            templateData?: any | null
          }
        | null
    } | null
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    config?: {
      __typename?: 'PlatformActionConfig'
      requireAttachmentToClose?: boolean | null
    } | null
    conversation?: {
      __typename?: 'ConversationThread'
      id: string
      messages: Array<{
        __typename?: 'ConversationMessage'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee'
          id: string
          worker?: {
            __typename?: 'Worker'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor'
            id: string
            company: { __typename?: 'Company'; name: string }
          } | null
        }
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  }
}

export type ArchivePlatformActionUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchivePlatformActionUiMutation = {
  __typename?: 'Mutation'
  archivePlatformAction: { __typename?: 'PlatformAction'; id: string }
}

export type RestorePlatformActionUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestorePlatformActionUiMutation = {
  __typename?: 'Mutation'
  restorePlatformAction: { __typename?: 'PlatformAction'; id: string }
}

export type ResendPlatformActionEmailUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ResendPlatformActionEmailUiMutation = {
  __typename?: 'Mutation'
  resendPlatformActionEmail: { __typename?: 'PlatformAction'; id: string }
}

export type ResendMultiplePlatformActionEmailUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type ResendMultiplePlatformActionEmailUiMutation = {
  __typename?: 'Mutation'
  resendMultiplePlatformActionEmails?: Array<{
    __typename?: 'PlatformAction'
    id: string
  }> | null
}

export type PublicSubcontractorPlatformActionsUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type PublicSubcontractorPlatformActionsUiQuery = {
  __typename?: 'Query'
  publicSubcontractorPlatformActions: Array<{
    __typename?: 'PlatformActionEntity'
    id: string
    type?: string | null
    status: PlatformActionStatus
    title?: string | null
    description?: string | null
    dueDate?: string | null
    priorityType?: string | null
    project?: {
      __typename?: 'ProjectEntity'
      id: string
      status: ProjectStatus
      name: string
      timezone?: string | null
      locale?: SupportedLocaleCountryCode | null
      builder?: {
        __typename?: 'BuilderEntityPublic'
        id: string
        logoUrl?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultTimezone?: string | null
        company?: { __typename?: 'Company'; name: string } | null
      } | null
    } | null
    attachments?: Array<{
      __typename?: 'AttachmentEntity'
      id: string
      key: string
      url: string
    } | null> | null
    location?: {
      __typename?: 'ProjectLocation_ResourceLink'
      id: string
      name: string
      order?: number | null
      fullLocationName: string
      parent?: {
        __typename?: 'ProjectLocation_ResourceLink'
        id: string
        name: string
        order?: number | null
        fullLocationName: string
        parent?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
          order?: number | null
          fullLocationName: string
          parent?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
            order?: number | null
            fullLocationName: string
            parent?: {
              __typename?: 'ProjectLocation_ResourceLink'
              id: string
              name: string
              order?: number | null
              fullLocationName: string
              parent?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                order?: number | null
                fullLocationName: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                  order?: number | null
                  fullLocationName: string
                  parent?: {
                    __typename?: 'ProjectLocation_ResourceLink'
                    id: string
                    name: string
                    order?: number | null
                    fullLocationName: string
                    parent?: {
                      __typename?: 'ProjectLocation_ResourceLink'
                      id: string
                      name: string
                      order?: number | null
                      fullLocationName: string
                      parent?: {
                        __typename?: 'ProjectLocation_ResourceLink'
                        id: string
                        name: string
                        order?: number | null
                        fullLocationName: string
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  }>
  publicSubcontractor?: {
    __typename?: 'SubcontractorEntity'
    id: string
    company: { __typename?: 'CompanyEntity'; name: string; abn?: string | null }
    builder?: {
      __typename?: 'BuilderEntityPublic'
      id: string
      logoUrl?: string | null
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
      company?: { __typename?: 'Company'; name: string } | null
    } | null
  } | null
}

export type PublicSubcontractorPlatformActionUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
  platformActionId: Scalars['String']
}>

export type PublicSubcontractorPlatformActionUiQuery = {
  __typename?: 'Query'
  publicSubcontractorPlatformAction?: {
    __typename?: 'PlatformActionEntity'
    id: string
    type?: string | null
    status: PlatformActionStatus
    title?: string | null
    description?: string | null
    dueDate?: string | null
    priorityType?: string | null
    canCloseActions: boolean
    config?: {
      __typename?: 'PlatformActionConfig'
      requireAttachmentToClose?: boolean | null
    } | null
    project?: {
      __typename?: 'ProjectEntity'
      id: string
      status: ProjectStatus
      name: string
      timezone?: string | null
      locale?: SupportedLocaleCountryCode | null
      builder?: {
        __typename?: 'BuilderEntityPublic'
        id: string
        logoUrl?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultTimezone?: string | null
        company?: { __typename?: 'Company'; name: string } | null
      } | null
    } | null
    location?: {
      __typename?: 'ProjectLocation_ResourceLink'
      id: string
      name: string
      order?: number | null
      fullLocationName: string
      parent?: {
        __typename?: 'ProjectLocation_ResourceLink'
        id: string
        name: string
        order?: number | null
        fullLocationName: string
        parent?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
          order?: number | null
          fullLocationName: string
          parent?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
            order?: number | null
            fullLocationName: string
            parent?: {
              __typename?: 'ProjectLocation_ResourceLink'
              id: string
              name: string
              order?: number | null
              fullLocationName: string
              parent?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                order?: number | null
                fullLocationName: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                  order?: number | null
                  fullLocationName: string
                  parent?: {
                    __typename?: 'ProjectLocation_ResourceLink'
                    id: string
                    name: string
                    order?: number | null
                    fullLocationName: string
                    parent?: {
                      __typename?: 'ProjectLocation_ResourceLink'
                      id: string
                      name: string
                      order?: number | null
                      fullLocationName: string
                      parent?: {
                        __typename?: 'ProjectLocation_ResourceLink'
                        id: string
                        name: string
                        order?: number | null
                        fullLocationName: string
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
    attachments?: Array<{
      __typename?: 'AttachmentEntity'
      id: string
      url: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null> | null
    conversation?: {
      __typename?: 'ConversationThreadEntity'
      id: string
      messages?: Array<{
        __typename?: 'ConversationMessage_ResourceLink'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee_ResourceLink'
          id: string
          worker?: {
            __typename?: 'Worker_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
          } | null
        }
        attachments?: Array<{
          __typename?: 'Attachment_ResourceLink'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        }> | null
      }> | null
    } | null
  } | null
  publicSubcontractor?: {
    __typename?: 'SubcontractorEntity'
    id: string
    company: { __typename?: 'CompanyEntity'; name: string; abn?: string | null }
    builder?: {
      __typename?: 'BuilderEntityPublic'
      id: string
      logoUrl?: string | null
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
      company?: { __typename?: 'Company'; name: string } | null
    } | null
  } | null
}

export type UpdatePublicSubcontractorPlatformActionUiMutationVariables = Exact<{
  subcontractorId: Scalars['String']
  platformActionId: Scalars['String']
  input: UpdatePublicSubcontractorPlatformActionInput
}>

export type UpdatePublicSubcontractorPlatformActionUiMutation = {
  __typename?: 'Mutation'
  updatePublicSubcontractorPlatformAction: {
    __typename?: 'PlatformActionEntity'
    id: string
  }
}

export type UpdatePlatformActionsStatusUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  status: PlatformActionStatus
}>

export type UpdatePlatformActionsStatusUiMutation = {
  __typename?: 'Mutation'
  updatePlatformActionsStatus?: Array<{
    __typename?: 'PlatformAction'
    id: string
  }> | null
}

export type PlatformActionsWorkerUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type PlatformActionsWorkerUiQuery = {
  __typename?: 'Query'
  platformActions_worker: Array<{
    __typename?: 'PlatformAction_Worker'
    id: string
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    priorityType?: string | null
    type?: string | null
    dueDate?: string | null
    attachments?: Array<{
      __typename?: 'AttachmentEntity'
      id: string
      key: string
      url: string
    } | null> | null
  }>
}

export type PlatformActionWorkerUiQueryVariables = Exact<{
  actionId: Scalars['String']
}>

export type PlatformActionWorkerUiQuery = {
  __typename?: 'Query'
  platformAction_worker?: {
    __typename?: 'PlatformAction_Worker'
    id: string
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    priorityType?: string | null
    type?: string | null
    dueDate?: string | null
    canCloseActions: boolean
    project?: {
      __typename?: 'ProjectEntity'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      country?: string | null
    } | null
    attachments?: Array<{
      __typename?: 'AttachmentEntity'
      id: string
      key: string
      url: string
    } | null> | null
    config?: {
      __typename?: 'PlatformActionConfig'
      requireAttachmentToClose?: boolean | null
    } | null
    location?: {
      __typename?: 'ProjectLocation_ResourceLink'
      id: string
      name: string
      order?: number | null
      fullLocationName: string
      parent?: {
        __typename?: 'ProjectLocation_ResourceLink'
        id: string
        name: string
        order?: number | null
        fullLocationName: string
        parent?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
          order?: number | null
          fullLocationName: string
          parent?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
            order?: number | null
            fullLocationName: string
            parent?: {
              __typename?: 'ProjectLocation_ResourceLink'
              id: string
              name: string
              order?: number | null
              fullLocationName: string
              parent?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                order?: number | null
                fullLocationName: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                  order?: number | null
                  fullLocationName: string
                  parent?: {
                    __typename?: 'ProjectLocation_ResourceLink'
                    id: string
                    name: string
                    order?: number | null
                    fullLocationName: string
                    parent?: {
                      __typename?: 'ProjectLocation_ResourceLink'
                      id: string
                      name: string
                      order?: number | null
                      fullLocationName: string
                      parent?: {
                        __typename?: 'ProjectLocation_ResourceLink'
                        id: string
                        name: string
                        order?: number | null
                        fullLocationName: string
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
    conversation?: {
      __typename?: 'ConversationThreadEntity'
      id: string
      messages?: Array<{
        __typename?: 'ConversationMessage_ResourceLink'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee_ResourceLink'
          id: string
          worker?: {
            __typename?: 'Worker_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
          } | null
        }
        attachments?: Array<{
          __typename?: 'Attachment_ResourceLink'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        }> | null
      }> | null
    } | null
  } | null
}

export type CreatePlatformActionConversationMessageWorkerUiMutationVariables =
  Exact<{
    actionId: Scalars['String']
    input: CreateConversationMessageInput
  }>

export type CreatePlatformActionConversationMessageWorkerUiMutation = {
  __typename?: 'Mutation'
  createPlatformActionConversationMessage_worker: {
    __typename?: 'ConversationMessage_ResourceLink'
    id: string
  }
}

export type UpdatePlatformActionWorkerUiMutationVariables = Exact<{
  actionId: Scalars['String']
  input: UpdatePlatformActionInputWorker
}>

export type UpdatePlatformActionWorkerUiMutation = {
  __typename?: 'Mutation'
  updatePlatformAction_worker: {
    __typename?: 'PlatformActionEntity'
    id: string
  }
}

export type AdminUserAttributesFragment = {
  __typename?: 'AdminUser'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  latestActivity?: string | null
  mobile?: string | null
  limitedPermissions: boolean
  roles?: Array<{ __typename?: 'Role'; id: string; name: string } | null> | null
  user: {
    __typename?: 'User'
    id: string
    firstName: string
    lastName: string
    email?: string | null
    userIdentity?: string | null
  }
  projects: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  } | null>
}

export type AdminUsersUiQueryVariables = Exact<{
  filter?: InputMaybe<AdminUserFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<AdminUserSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type AdminUsersUiQuery = {
  __typename?: 'Query'
  adminUsers: Array<{
    __typename?: 'AdminUser'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    latestActivity?: string | null
    mobile?: string | null
    limitedPermissions: boolean
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
      userIdentity?: string | null
      profilePicture?: { __typename?: 'Attachment'; url: string } | null
    }
    roles?: Array<{
      __typename?: 'Role'
      id: string
      name: string
    } | null> | null
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
  }>
  adminUsersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type AdminUsersBasicInfoUiQueryVariables = Exact<{
  filter?: InputMaybe<AdminUserFilterInput>
}>

export type AdminUsersBasicInfoUiQuery = {
  __typename?: 'Query'
  adminUsers: Array<{
    __typename?: 'AdminUser'
    id: string
    mobile?: string | null
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
  }>
}

export type AdminUserLicenseCountUiQueryVariables = Exact<{
  filter?: InputMaybe<AdminUserFilterInput>
}>

export type AdminUserLicenseCountUiQuery = {
  __typename?: 'Query'
  adminUsersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
  }
}

export type AdminUsersListUiQueryVariables = Exact<{
  filter?: InputMaybe<AdminUserFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<AdminUserSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type AdminUsersListUiQuery = {
  __typename?: 'Query'
  adminUsers: Array<{
    __typename?: 'AdminUser'
    id: string
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
    }
  }>
  adminUsersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type AdminUsersCsvUiQueryVariables = Exact<{
  filter?: InputMaybe<AdminUserFilterInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type AdminUsersCsvUiQuery = {
  __typename?: 'Query'
  adminUsers: Array<{
    __typename?: 'AdminUser'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    latestActivity?: string | null
    mobile?: string | null
    limitedPermissions: boolean
    roles?: Array<{
      __typename?: 'Role'
      id: string
      name: string
    } | null> | null
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
      userIdentity?: string | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
  }>
}

export type AdminUsersForSearchUiQueryVariables = Exact<{
  filter?: InputMaybe<AdminUserFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<AdminUserSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type AdminUsersForSearchUiQuery = {
  __typename?: 'Query'
  adminUsers: Array<{
    __typename?: 'AdminUser'
    id: string
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
  }>
  adminUsersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type RolesUiQueryVariables = Exact<{ [key: string]: never }>

export type RolesUiQuery = {
  __typename?: 'Query'
  roles: Array<{
    __typename?: 'Role'
    id: string
    name: string
    createdAt: string
    updatedAt?: string | null
    builderId?: string | null
    auth0Identifier?: string | null
    description?: string | null
    countOfUsers: number
    permissions: Array<{
      __typename?: 'Permission'
      id: string
      action: PermissionAction
      resource: string
    }>
  }>
}

export type InviteAdminUserUiMutationVariables = Exact<{
  input: InviteAdminUserInput
}>

export type InviteAdminUserUiMutation = {
  __typename?: 'Mutation'
  inviteAdminUser: {
    __typename?: 'AdminUser'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    latestActivity?: string | null
    mobile?: string | null
    limitedPermissions: boolean
    roles?: Array<{
      __typename?: 'Role'
      id: string
      name: string
    } | null> | null
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
      userIdentity?: string | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
  }
}

export type UpdateAdminUserUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateAdminUserInput
}>

export type UpdateAdminUserUiMutation = {
  __typename?: 'Mutation'
  updateAdminUser: {
    __typename?: 'AdminUser'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    latestActivity?: string | null
    mobile?: string | null
    limitedPermissions: boolean
    roles?: Array<{
      __typename?: 'Role'
      id: string
      name: string
    } | null> | null
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
      userIdentity?: string | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
  }
}

export type UpdateAdminUserRolesUiMutationVariables = Exact<{
  id: Scalars['String']
  roleIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
}>

export type UpdateAdminUserRolesUiMutation = {
  __typename?: 'Mutation'
  updateAdminUserRoles: {
    __typename?: 'AdminUser'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    latestActivity?: string | null
    mobile?: string | null
    limitedPermissions: boolean
    roles?: Array<{
      __typename?: 'Role'
      id: string
      name: string
    } | null> | null
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
      userIdentity?: string | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
  }
}

export type ArchiveAdminUserUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveAdminUserUiMutation = {
  __typename?: 'Mutation'
  archiveAdminUser: {
    __typename?: 'AdminUser'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    latestActivity?: string | null
    mobile?: string | null
    limitedPermissions: boolean
    roles?: Array<{
      __typename?: 'Role'
      id: string
      name: string
    } | null> | null
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
      userIdentity?: string | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
  }
}

export type UnarchiveAdminUserUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type UnarchiveAdminUserUiMutation = {
  __typename?: 'Mutation'
  unarchiveAdminUser: {
    __typename?: 'AdminUser'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    latestActivity?: string | null
    mobile?: string | null
    limitedPermissions: boolean
    roles?: Array<{
      __typename?: 'Role'
      id: string
      name: string
    } | null> | null
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
      userIdentity?: string | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
  }
}

export type ReinviteAdminUserUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ReinviteAdminUserUiMutation = {
  __typename?: 'Mutation'
  reinviteAdminUser: string
}

export type AdminUserStatsUiQueryVariables = Exact<{
  adminUserId: Scalars['String']
}>

export type AdminUserStatsUiQuery = {
  __typename?: 'Query'
  adminUserStats?: { __typename?: 'AdminUserStats'; stats?: any | null } | null
}

export type SaAdminUserUiQueryVariables = Exact<{
  input: SaAdminUserInput
}>

export type SaAdminUserUiQuery = {
  __typename?: 'Query'
  saAdminUser?: {
    __typename?: 'AdminUser'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    latestActivity?: string | null
    mobile?: string | null
    limitedPermissions: boolean
    builder?: {
      __typename?: 'Builder'
      company: { __typename?: 'Company'; name: string }
    } | null
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      id: string
      email?: string | null
      userIdentity?: string | null
    }
    roles?: Array<{
      __typename?: 'Role'
      id: string
      name: string
    } | null> | null
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
  } | null
}

export type AdminUserInfoUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type AdminUserInfoUiQuery = {
  __typename?: 'Query'
  adminUser?: {
    __typename?: 'AdminUser'
    id: string
    mobile?: string | null
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
  } | null
}

export type SwitchBuilderUiMutationVariables = Exact<{
  orgId: Scalars['String']
}>

export type SwitchBuilderUiMutation = {
  __typename?: 'Mutation'
  switchBuilder: { __typename?: 'AdminUser'; id: string }
}

export type GenerateSummaryAdminUiMutationVariables = Exact<{
  resourceId: Scalars['String']
  resource: AuditResource
}>

export type GenerateSummaryAdminUiMutation = {
  __typename?: 'Mutation'
  generateSummary_admin?: boolean | null
}

export type GetProjectsForMapUiQueryVariables = Exact<{ [key: string]: never }>

export type GetProjectsForMapUiQuery = {
  __typename?: 'Query'
  saProjectsForMap: Array<{
    __typename?: 'Project'
    id: string
    name: string
    address?: string | null
    latitude?: number | null
    longitude?: number | null
    inductionsInPastMonth?: number | null
    signOnsInPastMonth?: number | null
    projectContacts?: Array<{
      __typename?: 'Contact'
      name?: string | null
      number?: string | null
      type: ContactType
    } | null> | null
    builder?: {
      __typename?: 'Builder'
      id: string
      logoUrl?: string | null
      mapPinLogoUrl?: string | null
      company: { __typename?: 'Company'; name: string }
    } | null
  }>
}

export type AttachmentAttributesFragment = {
  __typename?: 'Attachment'
  id: string
  createdAt: string
  updatedAt: string
  fileName: string
  fileSize: string
  contentType: string
  description?: string | null
  metadata?: any | null
  type: AttachmentType
  key: string
  url: string
}

export type AttachmentEntityAttributesFragment = {
  __typename?: 'AttachmentEntity'
  id: string
  key: string
  url: string
}

export type AttachmentUploadUrlAttributesFragment = {
  __typename?: 'AttachmentUploadUrl'
  uploadUrl: string
  key: string
  url: string
  fileName: string
  fileSize: string
  contentType: string
  type: AttachmentType
}

export type CreateAttachmentUploadUrlUiMutationVariables = Exact<{
  input: CreateAttachmentUploadUrlInput
}>

export type CreateAttachmentUploadUrlUiMutation = {
  __typename?: 'Mutation'
  createAttachmentUploadUrl: {
    __typename?: 'AttachmentUploadUrl'
    uploadUrl: string
    key: string
    url: string
    fileName: string
    fileSize: string
    contentType: string
    type: AttachmentType
  }
}

export type CreateAttachmentUiMutationVariables = Exact<{
  input: CreateAttachmentInput
}>

export type CreateAttachmentUiMutation = {
  __typename?: 'Mutation'
  createAttachment: {
    __typename?: 'Attachment'
    id: string
    createdAt: string
    updatedAt: string
    fileName: string
    fileSize: string
    contentType: string
    description?: string | null
    metadata?: any | null
    type: AttachmentType
    key: string
    url: string
  }
}

export type CreateMultipleAttachmentsUiMutationVariables = Exact<{
  input?: InputMaybe<Array<CreateAttachmentInput> | CreateAttachmentInput>
}>

export type CreateMultipleAttachmentsUiMutation = {
  __typename?: 'Mutation'
  createMultipleAttachments?: Array<{
    __typename?: 'Attachment'
    id: string
    createdAt: string
    updatedAt: string
    fileName: string
    fileSize: string
    contentType: string
    description?: string | null
    metadata?: any | null
    type: AttachmentType
    key: string
    url: string
  }> | null
}

export type ArchiveAttachmentUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveAttachmentUiMutation = {
  __typename?: 'Mutation'
  archiveAttachment: {
    __typename?: 'Attachment'
    id: string
    createdAt: string
    updatedAt: string
    fileName: string
    fileSize: string
    contentType: string
    description?: string | null
    metadata?: any | null
    type: AttachmentType
    key: string
    url: string
  }
}

export type CreatePublicAttachmentUiMutationVariables = Exact<{
  input: CreateAttachmentInput
}>

export type CreatePublicAttachmentUiMutation = {
  __typename?: 'Mutation'
  createPublicAttachment: {
    __typename?: 'AttachmentEntity'
    id: string
    key: string
    url: string
  }
}

export type GetAttachmentUrlUiQueryVariables = Exact<{
  key: Scalars['String']
}>

export type GetAttachmentUrlUiQuery = {
  __typename?: 'Query'
  getAttachmentUrl?: {
    __typename?: 'AttachmentUrl'
    key?: string | null
    url?: string | null
  } | null
}

export type CreateZipAttachmentsUrlUiMutationVariables = Exact<{
  input: CreateZipAttachmentsUrlInput
}>

export type CreateZipAttachmentsUrlUiMutation = {
  __typename?: 'Mutation'
  createZipAttachmentsUrl: {
    __typename?: 'ZipAttachmentsResponse'
    url: string
  }
}

export type UpdateAttachmentInfoUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateAttachmentInfoInput
}>

export type UpdateAttachmentInfoUiMutation = {
  __typename?: 'Mutation'
  updateAttachmentInfo: {
    __typename?: 'Attachment'
    id: string
    createdAt: string
    updatedAt: string
    fileName: string
    fileSize: string
    contentType: string
    description?: string | null
    metadata?: any | null
    type: AttachmentType
    key: string
    url: string
  }
}

export type AuditAttributesFragment = {
  __typename?: 'AuditLog'
  id: string
  createdAt: string
  builderId?: string | null
  projectId?: string | null
  action: AuditAction
  actionBy?: AuditActionedBy | null
  actionByIdentity?: string | null
  resource: AuditResource
  resourceIdentity?: string | null
  newSnapshot?: any | null
  oldSnapshot?: any | null
  project?: { __typename?: 'Project'; name: string } | null
  actionByLink?:
    | {
        __typename?: 'AdminUserEntity'
        user?: {
          __typename?: 'UserEntity'
          id?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      }
    | { __typename?: 'SubcontractorEntity'; id: string; name: string }
    | {
        __typename?: 'WorkerAuditEntity'
        user?: {
          __typename?: 'UserEntity'
          id?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      }
    | null
}

export type AuditAttributesSubsetFragment = {
  __typename?: 'AuditLog'
  id: string
  createdAt: string
  projectId?: string | null
  action: AuditAction
  actionBy?: AuditActionedBy | null
  resource: AuditResource
  resourceIdentity?: string | null
  project?: {
    __typename?: 'Project'
    name: string
    timezone?: string | null
  } | null
}

export type AuditLogUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type AuditLogUiQuery = {
  __typename?: 'Query'
  auditLog?: {
    __typename?: 'AuditLog'
    id: string
    createdAt: string
    builderId?: string | null
    projectId?: string | null
    action: AuditAction
    actionBy?: AuditActionedBy | null
    actionByIdentity?: string | null
    resource: AuditResource
    resourceIdentity?: string | null
    newSnapshot?: any | null
    oldSnapshot?: any | null
    project?: { __typename?: 'Project'; name: string } | null
    actionByLink?:
      | {
          __typename?: 'AdminUserEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | { __typename?: 'SubcontractorEntity'; id: string; name: string }
      | {
          __typename?: 'WorkerAuditEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | null
  } | null
}

export type AuditLogsUiQueryVariables = Exact<{ [key: string]: never }>

export type AuditLogsUiQuery = {
  __typename?: 'Query'
  auditLogs: Array<{
    __typename?: 'AuditLog'
    id: string
    createdAt: string
    builderId?: string | null
    projectId?: string | null
    action: AuditAction
    actionBy?: AuditActionedBy | null
    actionByIdentity?: string | null
    resource: AuditResource
    resourceIdentity?: string | null
    newSnapshot?: any | null
    oldSnapshot?: any | null
    project?: { __typename?: 'Project'; name: string } | null
    actionByLink?:
      | {
          __typename?: 'AdminUserEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | { __typename?: 'SubcontractorEntity'; id: string; name: string }
      | {
          __typename?: 'WorkerAuditEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | null
  }>
}

export type AuditLogsListUiQueryVariables = Exact<{ [key: string]: never }>

export type AuditLogsListUiQuery = {
  __typename?: 'Query'
  auditLogs: Array<{
    __typename?: 'AuditLog'
    id: string
    createdAt: string
    projectId?: string | null
    action: AuditAction
    actionBy?: AuditActionedBy | null
    resource: AuditResource
    resourceIdentity?: string | null
    project?: {
      __typename?: 'Project'
      name: string
      timezone?: string | null
    } | null
  }>
}

export type AuditLogsByResourceIdUiQueryVariables = Exact<{
  id: Scalars['String']
  pagination?: InputMaybe<PaginationInput>
}>

export type AuditLogsByResourceIdUiQuery = {
  __typename?: 'Query'
  auditLogsByResourceId: Array<{
    __typename?: 'AuditLog'
    id: string
    createdAt: string
    builderId?: string | null
    projectId?: string | null
    action: AuditAction
    actionBy?: AuditActionedBy | null
    actionByIdentity?: string | null
    resource: AuditResource
    resourceIdentity?: string | null
    newSnapshot?: any | null
    oldSnapshot?: any | null
    project?: { __typename?: 'Project'; name: string } | null
    actionByLink?:
      | {
          __typename?: 'AdminUserEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | { __typename?: 'SubcontractorEntity'; id: string; name: string }
      | {
          __typename?: 'WorkerAuditEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | null
  }>
  auditLogsByResourceIdAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type FindResourceByIdUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type FindResourceByIdUiQuery = {
  __typename?: 'Query'
  findResourceById?: {
    __typename?: 'ResourceMeta'
    resource: AuditResource
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    project?: { __typename?: 'Project'; id: string; name: string } | null
    builder?: {
      __typename?: 'Builder'
      createdAt: string
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    user?: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
    } | null
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
    linkedResources?: {
      __typename?: 'LinkedResourceMeta'
      project?: { __typename?: 'Project'; id: string; name: string } | null
      builder?: {
        __typename?: 'Builder'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      user?: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null
  } | null
}

export type BuilderAttributesFragment = {
  __typename?: 'Builder'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  builderMetadata?: any | null
  logoKey?: string | null
  logoUrl?: string | null
  subscription: BuilderTier
  isTrial?: boolean | null
  trialExpiresAt?: string | null
  clerkOrganizationId?: string | null
  defaultTimezone?: string | null
  defaultLocale?: SupportedLocaleCountryCode | null
  defaultLanguage?: string | null
  company: { __typename?: 'Company'; name: string }
  requiredTickets: Array<{
    __typename?: 'TicketTemplateEntity'
    id: string
    name: string
    shortName: string
  } | null>
}

export type BuilderListAttributesFragment = {
  __typename?: 'Builder'
  id: string
  createdAt: string
  projectsCount: number
  adminUsersCount: number
  stripeIdentifier?: string | null
  hubspotDealIdentifier?: string | null
  isDemo?: boolean | null
  isSeeded?: boolean | null
  isTrial?: boolean | null
  trialExpiresAt?: string | null
  subscription: BuilderTier
  company: { __typename?: 'Company'; name: string }
}

export type BuilderUiQueryVariables = Exact<{ [key: string]: never }>

export type BuilderUiQuery = {
  __typename?: 'Query'
  builder?: {
    __typename?: 'Builder'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    builderMetadata?: any | null
    logoKey?: string | null
    logoUrl?: string | null
    subscription: BuilderTier
    isTrial?: boolean | null
    trialExpiresAt?: string | null
    clerkOrganizationId?: string | null
    defaultTimezone?: string | null
    defaultLocale?: SupportedLocaleCountryCode | null
    defaultLanguage?: string | null
    company: { __typename?: 'Company'; name: string }
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      name: string
      shortName: string
    } | null>
  } | null
}

export type BuilderWhitelabelUiQueryVariables = Exact<{
  name: Scalars['String']
}>

export type BuilderWhitelabelUiQuery = {
  __typename?: 'Query'
  builderWhitelabel?: {
    __typename?: 'BuilderEntityWhitelabel'
    logoUrl?: string | null
    hideBuildPassLogos?: boolean | null
  } | null
}

export type BuilderWithProcoreUiQueryVariables = Exact<{ [key: string]: never }>

export type BuilderWithProcoreUiQuery = {
  __typename?: 'Query'
  builder?: {
    __typename?: 'Builder'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    builderMetadata?: any | null
    logoKey?: string | null
    logoUrl?: string | null
    subscription: BuilderTier
    isTrial?: boolean | null
    trialExpiresAt?: string | null
    clerkOrganizationId?: string | null
    defaultTimezone?: string | null
    defaultLocale?: SupportedLocaleCountryCode | null
    defaultLanguage?: string | null
    procoreConfig?: {
      __typename?: 'ProcoreConfig'
      id: string
      isDev: boolean
      procoreCompanyId: string
    } | null
    company: { __typename?: 'Company'; name: string }
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      name: string
      shortName: string
    } | null>
  } | null
}

export type BuilderWithProcoreAndProjectsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type BuilderWithProcoreAndProjectsUiQuery = {
  __typename?: 'Query'
  builder?: {
    __typename?: 'Builder'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    builderMetadata?: any | null
    logoKey?: string | null
    logoUrl?: string | null
    subscription: BuilderTier
    isTrial?: boolean | null
    trialExpiresAt?: string | null
    clerkOrganizationId?: string | null
    defaultTimezone?: string | null
    defaultLocale?: SupportedLocaleCountryCode | null
    defaultLanguage?: string | null
    procoreConfig?: {
      __typename?: 'ProcoreConfig'
      id: string
      procoreCompanyId: string
      isDev: boolean
    } | null
    projects: Array<{
      __typename?: 'Project'
      id: string
      procoreId?: string | null
    } | null>
    company: { __typename?: 'Company'; name: string }
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      name: string
      shortName: string
    } | null>
  } | null
}

export type BuilderMetadataUiQueryVariables = Exact<{ [key: string]: never }>

export type BuilderMetadataUiQuery = {
  __typename?: 'Query'
  builder?: { __typename?: 'Builder'; builderMetadata?: any | null } | null
}

export type UserBuilderUiQueryVariables = Exact<{ [key: string]: never }>

export type UserBuilderUiQuery = {
  __typename?: 'Query'
  user?: {
    __typename?: 'User'
    adminUser?: {
      __typename?: 'AdminUser'
      builder?: {
        __typename?: 'Builder'
        id: string
        createdAt: string
        updatedAt: string
        archivedAt?: string | null
        builderMetadata?: any | null
        logoKey?: string | null
        logoUrl?: string | null
        subscription: BuilderTier
        isTrial?: boolean | null
        trialExpiresAt?: string | null
        clerkOrganizationId?: string | null
        defaultTimezone?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultLanguage?: string | null
        builderSubcontractor?: {
          __typename?: 'Subcontractor'
          company: { __typename?: 'Company'; abn?: string | null }
        } | null
        company: { __typename?: 'Company'; name: string }
        requiredTickets: Array<{
          __typename?: 'TicketTemplateEntity'
          id: string
          name: string
          shortName: string
        } | null>
      } | null
    } | null
  } | null
}

export type UpdateBuilderUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateBuilderInput
}>

export type UpdateBuilderUiMutation = {
  __typename?: 'Mutation'
  updateBuilder: {
    __typename?: 'Builder'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    builderMetadata?: any | null
    logoKey?: string | null
    logoUrl?: string | null
    subscription: BuilderTier
    isTrial?: boolean | null
    trialExpiresAt?: string | null
    clerkOrganizationId?: string | null
    defaultTimezone?: string | null
    defaultLocale?: SupportedLocaleCountryCode | null
    defaultLanguage?: string | null
    company: { __typename?: 'Company'; name: string }
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      name: string
      shortName: string
    } | null>
  }
}

export type UpdateBuilderMetadataUiMutationVariables = Exact<{
  input: UpdateBuilderMetadataInput
}>

export type UpdateBuilderMetadataUiMutation = {
  __typename?: 'Mutation'
  updateBuilderMetadata: {
    __typename?: 'Builder'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    builderMetadata?: any | null
    logoKey?: string | null
    logoUrl?: string | null
    subscription: BuilderTier
    isTrial?: boolean | null
    trialExpiresAt?: string | null
    clerkOrganizationId?: string | null
    defaultTimezone?: string | null
    defaultLocale?: SupportedLocaleCountryCode | null
    defaultLanguage?: string | null
    company: { __typename?: 'Company'; name: string }
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      name: string
      shortName: string
    } | null>
  }
}

export type UpdateBuilderSubcontractorDataUiMutationVariables = Exact<{
  input: UpdateBuilderSubcontractorDataInput
}>

export type UpdateBuilderSubcontractorDataUiMutation = {
  __typename?: 'Mutation'
  updateBuilderSubcontractorData: { __typename?: 'Subcontractor'; id: string }
}

export type GetPresignedUrlForBuilderLogoUiQueryVariables = Exact<{
  id: Scalars['String']
  filename: Scalars['String']
  filesize: Scalars['String']
}>

export type GetPresignedUrlForBuilderLogoUiQuery = {
  __typename?: 'Query'
  getPresignedUrl: { __typename?: 'PresignedUrl'; url: string; key: string }
}

export type SaBuildersWithAggUiQueryVariables = Exact<{
  filter?: InputMaybe<BuilderFilterInput>
  sort?: InputMaybe<BuilderSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type SaBuildersWithAggUiQuery = {
  __typename?: 'Query'
  saBuilders: Array<{
    __typename?: 'Builder'
    id: string
    createdAt: string
    projectsCount: number
    adminUsersCount: number
    stripeIdentifier?: string | null
    hubspotDealIdentifier?: string | null
    isDemo?: boolean | null
    isSeeded?: boolean | null
    isTrial?: boolean | null
    trialExpiresAt?: string | null
    subscription: BuilderTier
    builderSettings: {
      __typename?: 'BuilderSettings'
      externalLinks?: Array<{
        __typename?: 'BuilderExternalLink'
        externalLinkCuid: string
        type: string
        homeUrl: string
        linkUrl: string
        id: string
      }> | null
    }
    company: { __typename?: 'Company'; name: string }
  }>
  saBuildersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SaBuildersUiQueryVariables = Exact<{ [key: string]: never }>

export type SaBuildersUiQuery = {
  __typename?: 'Query'
  saBuilders: Array<{
    __typename?: 'Builder'
    id: string
    logoUrl?: string | null
    isDemo?: boolean | null
    company: { __typename?: 'Company'; name: string }
  }>
}

export type SaBuilderWithModulesUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type SaBuilderWithModulesUiQuery = {
  __typename?: 'Query'
  saBuilder?: {
    __typename?: 'Builder'
    modules: Array<BuildPassModule>
    projectsCount: number
    adminUsersCount: number
    stripeIdentifier?: string | null
    hubspotDealIdentifier?: string | null
    isDemo?: boolean | null
    isSeeded?: boolean | null
    isTrial?: boolean | null
    trialExpiresAt?: string | null
    subscription: BuilderTier
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    builderMetadata?: any | null
    logoKey?: string | null
    logoUrl?: string | null
    clerkOrganizationId?: string | null
    defaultTimezone?: string | null
    defaultLocale?: SupportedLocaleCountryCode | null
    defaultLanguage?: string | null
    builderSettings: {
      __typename?: 'BuilderSettings'
      hideMedical?: boolean | null
      externalLinks?: Array<{
        __typename?: 'BuilderExternalLink'
        externalLinkCuid: string
        type: string
        homeUrl: string
        linkUrl: string
        id: string
      }> | null
    }
    company: { __typename?: 'Company'; name: string }
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      name: string
      shortName: string
    } | null>
  } | null
}

export type SaBuilderAuditSummaryUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type SaBuilderAuditSummaryUiQuery = {
  __typename?: 'Query'
  saBuilder?: {
    __typename?: 'Builder'
    auditLogSummary: {
      __typename?: 'AuditLogSummary'
      last30Days: number
      last60Days: number
      last90Days: number
    }
  } | null
}

export type SaArchiveBuilderUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type SaArchiveBuilderUiMutation = {
  __typename?: 'Mutation'
  saArchiveBuilder: boolean
}

export type SaBuilderModulesListUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type SaBuilderModulesListUiQuery = {
  __typename?: 'Query'
  saBuilder?: {
    __typename?: 'Builder'
    id: string
    modules: Array<BuildPassModule>
    company: { __typename?: 'Company'; name: string }
  } | null
}

export type SaUpdateBuilderModulesUiMutationVariables = Exact<{
  id: Scalars['String']
  input: ToggleModuleInput
}>

export type SaUpdateBuilderModulesUiMutation = {
  __typename?: 'Mutation'
  saUpdateBuilderModules: Array<BuildPassModule | null>
}

export type CreateBuilderUiMutationVariables = Exact<{
  input: CreateBuilderInput
}>

export type CreateBuilderUiMutation = {
  __typename?: 'Mutation'
  createBuilder: { __typename?: 'Builder'; id: string }
}

export type SaUpdateBuilderUiMutationVariables = Exact<{
  id: Scalars['String']
  input: SaUpdateBuilderInput
}>

export type SaUpdateBuilderUiMutation = {
  __typename?: 'Mutation'
  saUpdateBuilder: { __typename?: 'Builder'; id: string }
}

export type UpdateBuilderQuestionnaireUiMutationVariables = Exact<{
  input: UpdateBuilderQuestionnaireInput
}>

export type UpdateBuilderQuestionnaireUiMutation = {
  __typename?: 'Mutation'
  updateBuilderQuestionnaire: {
    __typename?: 'BuilderQuestionnaireResponse'
    questionnaire?: any | null
  }
}

export type SwitchSuperAdminBuilderUiMutationVariables = Exact<{
  builderId: Scalars['String']
}>

export type SwitchSuperAdminBuilderUiMutation = {
  __typename?: 'Mutation'
  switchSuperAdminBuilder: { __typename?: 'Builder'; id: string }
}

export type SyncBuilderWithDataPipelineUiMutationVariables = Exact<{
  builderId: Scalars['String']
}>

export type SyncBuilderWithDataPipelineUiMutation = {
  __typename?: 'Mutation'
  syncBuilderWithDataPipeline: {
    __typename?: 'Billing'
    renewalDate?: string | null
    createdAt?: string | null
    currentPeriodStart?: string | null
    status?: BillingStatus | null
    product?: BuilderTier | null
    features?: Array<BuildPassModule> | null
    billingInterval?: BillingInterval | null
    billingIntervalCount?: number | null
    billingAmount?: number | null
    trialStart?: string | null
    trialEnd?: string | null
    discount?: {
      __typename?: 'BillingDiscount'
      durationType?: BillingDiscountDurationType | null
      durationInMonths?: number | null
      discountType?: BillingDiscountType | null
      amountOff?: number | null
      percentOff?: number | null
    } | null
  }
}

export type BulkSyncBuilderWithDataPipelineUiMutationVariables = Exact<{
  builderIds: Array<Scalars['String']> | Scalars['String']
}>

export type BulkSyncBuilderWithDataPipelineUiMutation = {
  __typename?: 'Mutation'
  bulkSyncBuilderWithDataPipeline: {
    __typename?: 'BulkSyncDataPipelineResponse'
    successfullySyncedIds: Array<string | null>
    failedSyncedIds: Array<string | null>
  }
}

export type WorkerChecklistSettingsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type WorkerChecklistSettingsUiQuery = {
  __typename?: 'Query'
  workerChecklistSettings: {
    __typename?: 'WorkerChecklistSettings'
    checklistsAvailableForMe?: Array<{
      __typename?: 'TemplateEntity'
      id: string
      templateName: string
    } | null> | null
  }
}

export type LinkedChecklistTemplateRegisterItemsUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type LinkedChecklistTemplateRegisterItemsUiQuery = {
  __typename?: 'Query'
  template?: {
    __typename?: 'Template'
    id: string
    templateName: string
    linkedRegisterItems?: Array<{
      __typename?: 'RegisterItem'
      id: string
      name: string
      identifier: number
      fullIdentifier: string
      projects?: Array<{
        __typename?: 'Project'
        id: string
        status: ProjectStatus
        name: string
      } | null> | null
      register: { __typename?: 'Register'; identifierPrefix: string }
    }> | null
  } | null
}

export type HasLinkedChecklistTemplateRegisterItemsUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type HasLinkedChecklistTemplateRegisterItemsUiQuery = {
  __typename?: 'Query'
  template?: {
    __typename?: 'Template'
    id: string
    linkedRegisterItems?: Array<{
      __typename?: 'RegisterItem'
      id: string
    }> | null
  } | null
}

export type ChecklistTemplateResponseUiQueryVariables = Exact<{
  id: Scalars['String']
  includeLogs: Scalars['Boolean']
}>

export type ChecklistTemplateResponseUiQuery = {
  __typename?: 'Query'
  templateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    archivedAt?: string | null
    fullIdentifier?: string | null
    responseData?: any | null
    relatedRegisterItem?: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      identifier: number
      fullIdentifier: string
      followUpAt?: string | null
      templateResponse: {
        __typename?: 'TemplateResponse'
        responseData?: any | null
      }
      projects?: Array<{
        __typename?: 'Project'
        id: string
        name: string
        status: ProjectStatus
      } | null> | null
      assignees?: Array<{
        __typename?: 'Assignee'
        id: string
        type?: AssigneeType | null
        worker?: {
          __typename?: 'Worker'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        adminUser?: {
          __typename?: 'AdminUser'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        subcontractor?: {
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null
      } | null> | null
      register: {
        __typename?: 'Register'
        identifierPrefix: string
        name: string
        settings?: {
          __typename?: 'RegisterSettings'
          canAssignItemsToProject?: boolean | null
          canAssignMultipleProjects?: boolean | null
          hideAssignees?: boolean | null
        } | null
      }
    } | null
    accessProfile?: {
      __typename?: 'AccessProfile'
      id: string
      name: string
      defaultRole?: AccessProfileRole | null
      owner?: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      actors: Array<{
        __typename?: 'AccessProfileActor'
        role: AccessProfileRole
        adminUser: {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      }>
      accessProfileTemplate?: {
        __typename?: 'AccessProfileTemplate'
        id: string
        name: string
      } | null
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateName: string
          templateData?: any | null
        }
      | {
          __typename?: 'Template'
          id: string
          templateName: string
          templateData?: any | null
          accessProfileTemplate?: {
            __typename?: 'AccessProfileTemplate'
            id: string
          } | null
        }
      | null
    author?:
      | {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
    }> | null
    responseSummary?: {
      __typename?: 'TemplateResponseSummary'
      blocks?: {
        __typename?: 'TemplateResponseBlocksSummary'
        total?: number | null
        completed?: number | null
        incomplete?: number | null
        totalWithDesiredState?: number | null
        inDesiredState?: number | null
        inNeutralState?: number | null
        inUndesiredState?: number | null
      } | null
    } | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  } | null
  knockMessageLogs_admin?: Array<{
    __typename?: 'KnockMessageLog_Admin'
    id: string
    logDate: string
    status: KnockMessageStatus
    messageId: string
    sentTo: {
      __typename?: 'KnockMessageLogUser_admin'
      id: string
      name: string
    }
  }>
}

export type WorkerChecklistsUiQueryVariables = Exact<{
  filter: WorkerTemplateResponseFilterInput
  pagination?: InputMaybe<PaginationInput>
}>

export type WorkerChecklistsUiQuery = {
  __typename?: 'Query'
  workerTemplateResponses: Array<{
    __typename?: 'TemplateResponseEntity'
    id: string
    completedAt?: string | null
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    responseData?: any | null
    template?: {
      __typename?: 'TemplateEntity'
      id: string
      templateName: string
    } | null
    project?: { __typename?: 'ProjectEntity'; id: string; name: string } | null
  }>
  workerTemplateResponsesAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type WorkerTemplateResponseUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type WorkerTemplateResponseUiQuery = {
  __typename?: 'Query'
  workerTemplateResponse?: {
    __typename?: 'TemplateResponseEntity'
    id: string
    completedAt?: string | null
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    responseData?: any | null
    template?: {
      __typename?: 'TemplateEntity'
      id: string
      templateName: string
      templateData?: any | null
      builder?: { __typename?: 'BuilderEntityPublic'; id: string } | null
    } | null
    project?: { __typename?: 'ProjectEntity'; id: string; name: string } | null
  } | null
}

export type WorkerMyChecklistsUiQueryVariables = Exact<{
  filter?: InputMaybe<WorkerTemplateResponseFilterInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type WorkerMyChecklistsUiQuery = {
  __typename?: 'Query'
  workerTemplateResponses: Array<{
    __typename?: 'TemplateResponseEntity'
    id: string
    completedAt?: string | null
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    responseData?: any | null
    template?: {
      __typename?: 'TemplateEntity'
      id: string
      templateName: string
    } | null
    project?: { __typename?: 'ProjectEntity'; id: string; name: string } | null
  }>
  workerTemplateResponsesAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type BulkArchiveTemplateResponsesUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkArchiveTemplateResponsesUiMutation = {
  __typename?: 'Mutation'
  bulkArchiveTemplateResponses: Array<string>
}

export type BulkRestoreTemplateResponsesUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkRestoreTemplateResponsesUiMutation = {
  __typename?: 'Mutation'
  bulkRestoreTemplateResponses: Array<string>
}

export type SendProjectSmsUiMutationVariables = Exact<{
  input?: InputMaybe<SendProjectSmsInput>
}>

export type SendProjectSmsUiMutation = {
  __typename?: 'Mutation'
  sendProjectSms: { __typename?: 'SendProjectSmsResponse'; id: string }
}

export type ProjectSmsLogsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectSmsLogsUiQuery = {
  __typename?: 'Query'
  projectSmsLogs: Array<{
    __typename?: 'SmsLog'
    id: string
    createdAt: string
    to: string
    status: SmsStatus
    workerId?: string | null
    message?: string | null
    batchId?: string | null
    worker?: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }>
}

export type SmsLogsReportUiQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>
}>

export type SmsLogsReportUiQuery = {
  __typename?: 'Query'
  smsLogsReport: {
    __typename?: 'SmsLogsReport'
    yearToDateTotal: number
    monthToDateTotal: number
    monthToDateProject?: number | null
  }
}

export type ProjectSmsLogsBatchedUiQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SmsLogFilterInput>
  sort?: InputMaybe<SmsLogSortInput>
}>

export type ProjectSmsLogsBatchedUiQuery = {
  __typename?: 'Query'
  projectSmsLogsBatched: Array<{
    __typename?: 'BatchedSmsLog'
    createdAt: string
    batchId: string
    message: string
    count: number
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }>
}

export type SmsBatchUiQueryVariables = Exact<{
  batchId: Scalars['String']
}>

export type SmsBatchUiQuery = {
  __typename?: 'Query'
  smsBatch: Array<{
    __typename?: 'SmsLog'
    createdAt: string
    to: string
    status: SmsStatus
    message?: string | null
    worker?: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }>
}

export type GetSignedOnWorkersForAllProjectsUiQueryVariables = Exact<{
  filter: SignOnFilterInput
  sort?: InputMaybe<SignOnSortInput>
}>

export type GetSignedOnWorkersForAllProjectsUiQuery = {
  __typename?: 'Query'
  signOns: Array<{
    __typename?: 'SignOn'
    id: string
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      mobile?: string | null
      user: { __typename?: 'User'; firstName: string; lastName: string }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        company: { __typename?: 'Company'; name: string }
      } | null>
    } | null
  }>
}

export type GetCompaniesUiQueryVariables = Exact<{
  input?: InputMaybe<GetCompaniesInput>
}>

export type GetCompaniesUiQuery = {
  __typename?: 'Query'
  companies: Array<{
    __typename?: 'Company'
    id?: string | null
    createdAt?: string | null
    updatedAt?: string | null
    name: string
    abn?: string | null
    subcontractors?: Array<{
      __typename?: 'Company_Subcontractor'
      id: string
      company?: {
        __typename?: 'CompanyEntity'
        name: string
        abn?: string | null
      } | null
      builder?: {
        __typename?: 'BuilderEntity'
        id: string
        company?: { __typename?: 'Company'; name: string } | null
      } | null
    } | null> | null
  }>
  companiesAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SearchCompaniesUiQueryVariables = Exact<{
  input: SearchCompaniesInput
}>

export type SearchCompaniesUiQuery = {
  __typename?: 'Query'
  searchCompanies: Array<{
    __typename?: 'AbrCompany'
    name: string
    abn: string
  }>
}

export type MergeCompaniesUiMutationVariables = Exact<{
  input: MergeCompaniesInput
}>

export type MergeCompaniesUiMutation = {
  __typename?: 'Mutation'
  mergeCompanies: {
    __typename?: 'Company'
    id?: string | null
    createdAt?: string | null
    updatedAt?: string | null
    name: string
    abn?: string | null
    subcontractors?: Array<{
      __typename?: 'Company_Subcontractor'
      id: string
      company?: {
        __typename?: 'CompanyEntity'
        name: string
        abn?: string | null
      } | null
      builder?: {
        __typename?: 'BuilderEntity'
        id: string
        company?: { __typename?: 'Company'; name: string } | null
      } | null
    } | null> | null
  }
}

export type CompanyRegisterItemAttributesFragment = {
  __typename?: 'CompanyRegisterItem'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  name: string
  typeTemplateResponse?: any | null
}

export type CompanyRegisterItemsUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
  filter?: InputMaybe<CompanyRegisterItemFilterInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type CompanyRegisterItemsUiQuery = {
  __typename?: 'Query'
  companyRegisterItems_public: Array<{
    __typename?: 'CompanyRegisterItem'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    typeTemplateResponse?: any | null
  }>
}

export type CompanyRegisterItemUiQueryVariables = Exact<{
  id: Scalars['String']
  subcontractorId: Scalars['String']
}>

export type CompanyRegisterItemUiQuery = {
  __typename?: 'Query'
  companyRegisterItem_public: {
    __typename?: 'CompanyRegisterItem'
    id: string
    name: string
    typeTemplateResponse?: any | null
  }
}

export type CreateCompanyRegisterItemUiMutationVariables = Exact<{
  input: CreateCompanyRegisterItemPublicInput
  subcontractorId: Scalars['String']
}>

export type CreateCompanyRegisterItemUiMutation = {
  __typename?: 'Mutation'
  createCompanyRegisterItem_public: {
    __typename?: 'CompanyRegisterItem'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    typeTemplateResponse?: any | null
  }
}

export type ConversationMessageAttributesFragment = {
  __typename?: 'ConversationMessage'
  id: string
  createdAt: string
  content?: string | null
  sender: {
    __typename?: 'Assignee'
    id: string
    worker?: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
  }
  attachments: Array<{
    __typename?: 'Attachment'
    id: string
    url: string
    thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
  } | null>
}

export type ConversationThreadAttributesFragment = {
  __typename?: 'ConversationThread'
  id: string
  messages: Array<{
    __typename?: 'ConversationMessage'
    id: string
    createdAt: string
    content?: string | null
    sender: {
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    }
    attachments: Array<{
      __typename?: 'Attachment'
      id: string
      url: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null>
  } | null>
}

export type ConversationThreadResourceLinkAttributesFragment = {
  __typename?: 'ConversationThread_ResourceLink'
  id: string
  messages?: Array<{
    __typename?: 'ConversationMessage_ResourceLink'
    id: string
    createdAt: string
    content?: string | null
    sender: {
      __typename?: 'Assignee_ResourceLink'
      id: string
      worker?: {
        __typename?: 'Worker_ResourceLink'
        id: string
        user: {
          __typename?: 'User_ResourceLink'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser_ResourceLink'
        id: string
        user: {
          __typename?: 'User_ResourceLink'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor_ResourceLink'
        id: string
        company: { __typename?: 'Company_ResourceLink'; name: string }
      } | null
    }
    attachments?: Array<{
      __typename?: 'Attachment_ResourceLink'
      id: string
      url: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    }> | null
  }> | null
}

export type ConversationThreadEntityAttributesFragment = {
  __typename?: 'ConversationThreadEntity'
  id: string
  messages?: Array<{
    __typename?: 'ConversationMessage_ResourceLink'
    id: string
    createdAt: string
    content?: string | null
    sender: {
      __typename?: 'Assignee_ResourceLink'
      id: string
      worker?: {
        __typename?: 'Worker_ResourceLink'
        id: string
        user: {
          __typename?: 'User_ResourceLink'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser_ResourceLink'
        id: string
        user: {
          __typename?: 'User_ResourceLink'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor_ResourceLink'
        id: string
        company: { __typename?: 'Company_ResourceLink'; name: string }
      } | null
    }
    attachments?: Array<{
      __typename?: 'Attachment_ResourceLink'
      id: string
      url: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    }> | null
  }> | null
}

export type CreateConversationMessageUiMutationVariables = Exact<{
  input: CreateConversationMessageInput
}>

export type CreateConversationMessageUiMutation = {
  __typename?: 'Mutation'
  createConversationMessage: { __typename?: 'ConversationMessage'; id: string }
}

export type CreatePublicConversationMessageAsSubcontractorUiMutationVariables =
  Exact<{
    input: CreatePublicConversationMessageAsSubcontractorInput
  }>

export type CreatePublicConversationMessageAsSubcontractorUiMutation = {
  __typename?: 'Mutation'
  createPublicConversationMessageAsSubcontractor: {
    __typename?: 'ConversationMessage'
    id: string
  }
}

export type KnockMessageContentUiQueryVariables = Exact<{
  logId: Scalars['String']
}>

export type KnockMessageContentUiQuery = {
  __typename?: 'Query'
  knockMessageContent_admin: {
    __typename?: 'KnockMessageContent_admin'
    html_body?: string | null
    text_body?: string | null
    subject?: string | null
    to?: string | null
  }
}

export type KnockMessageLogAttributesFragment = {
  __typename?: 'KnockMessageLog_Admin'
  id: string
  logDate: string
  status: KnockMessageStatus
  messageId: string
  sentTo: { __typename?: 'KnockMessageLogUser_admin'; id: string; name: string }
}

export type GetGalleryUiQueryVariables = Exact<{
  filter: GalleryFilterInput
  sort?: InputMaybe<GallerySortInput>
  pagination: PaginationInput
}>

export type GetGalleryUiQuery = {
  __typename?: 'Query'
  gallery?: Array<{
    __typename?: 'Attachment'
    id: string
    createdAt: string
    updatedAt: string
    sortDate?: string | null
    photoTakenDate?: string | null
    fileName: string
    url: string
    rawUrl?: string | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      slug: string
      name: string
    } | null> | null
    thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
  }> | null
  galleryAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type GetAttachmentForBuilderUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type GetAttachmentForBuilderUiQuery = {
  __typename?: 'Query'
  getAttachmentForBuilder: {
    __typename?: 'Attachment'
    id: string
    author?:
      | {
          __typename?: 'AdminUserEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | { __typename?: 'SubcontractorEntity'; id: string; name: string }
      | {
          __typename?: 'WorkerAuditEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | null
  }
}

export type GetAttachmentForBuilderDetailedUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type GetAttachmentForBuilderDetailedUiQuery = {
  __typename?: 'Query'
  getAttachmentForBuilder: {
    __typename?: 'Attachment'
    id: string
    createdAt: string
    updatedAt: string
    sortDate?: string | null
    photoTakenDate?: string | null
    description?: string | null
    fileName: string
    fileSize: string
    contentType: string
    type: AttachmentType
    resource?: Resource | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      slug: string
      name: string
    } | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      template?:
        | { __typename?: 'LibraryTemplate'; id: string }
        | { __typename?: 'Template'; id: string }
        | null
      siteDiaries?: Array<{
        __typename?: 'SiteDiary'
        id: string
        date: string
      }> | null
      preStarts?: Array<{
        __typename?: 'PreStart'
        id: string
        date: string
      }> | null
    } | null
    platformAction?: { __typename?: 'PlatformAction'; id: string } | null
    author?:
      | {
          __typename?: 'AdminUserEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | { __typename?: 'SubcontractorEntity'; id: string; name: string }
      | {
          __typename?: 'WorkerAuditEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | null
  }
}

export type GetWidgetActivityUiQueryVariables = Exact<{
  filter: WidgetFilter
}>

export type GetWidgetActivityUiQuery = {
  __typename?: 'Query'
  widgetActivity: {
    __typename?: 'WidgetActivityData'
    signOns?: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      updatedAt?: string | null
      manualSignedOnAt?: string | null
      signedOffAt?: string | null
      manualSignedOffAt?: string | null
      projectId?: string | null
      project?: { __typename?: 'Project'; name: string } | null
      worker?: {
        __typename?: 'Worker'
        id: string
        trade?: string | null
        user: { __typename?: 'User'; firstName: string; lastName: string }
        inductions: Array<
          | { __typename?: 'BuilderInduction' }
          | {
              __typename?: 'ProjectInduction'
              projectId: string
              subcontractor?: {
                __typename?: 'Subcontractor'
                company: { __typename?: 'Company'; name: string }
              } | null
            }
          | null
        >
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
          projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
        } | null>
      } | null
      visitor?: {
        __typename?: 'Visitor'
        mobile?: string | null
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    }> | null
  }
}

export type GetWidgetFollowUpUiQueryVariables = Exact<{
  filter: WidgetFilter
}>

export type GetWidgetFollowUpUiQuery = {
  __typename?: 'Query'
  widgetFollowUp: {
    __typename?: 'WidgetFollowUpData'
    platformActions?: Array<{
      __typename?: 'PlatformAction'
      id: string
      remindedAt?: string | null
      createdAt: string
      dueDate?: string | null
      title?: string | null
      status: PlatformActionStatus
      project?: {
        __typename?: 'Project'
        id: string
        name: string
        status: ProjectStatus
      } | null
      assignees: Array<{
        __typename?: 'Assignee'
        id: string
        worker?: {
          __typename?: 'Worker'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        adminUser?: {
          __typename?: 'AdminUser'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        subcontractor?: {
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null
      } | null>
    }> | null
    defects?: Array<{
      __typename?: 'Defect'
      id: string
      title?: string | null
      createdAt: string
      distributedAt?: string | null
      type?: string | null
      order?: number | null
      dueDate?: string | null
      status: DefectStatus
      project: {
        __typename?: 'Project'
        id: string
        name: string
        status: ProjectStatus
      }
      assignees: Array<{
        __typename?: 'Assignee'
        id: string
        worker?: {
          __typename?: 'Worker'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        adminUser?: {
          __typename?: 'AdminUser'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        subcontractor?: {
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null
      } | null>
    }> | null
    registerItems?: Array<{
      __typename?: 'RegisterItem'
      id: string
      name: string
      followUpAt?: string | null
      identifier: number
      register: {
        __typename?: 'Register'
        id: string
        identifierPrefix: string
      }
      projects?: Array<{
        __typename?: 'Project'
        id: string
        name: string
        status: ProjectStatus
      } | null> | null
    }> | null
    swms?: Array<{
      __typename?: 'SwmsDoc'
      id: string
      updatedAt: string
      name: string
      status: SwmsStatus
      project: {
        __typename?: 'Project'
        id: string
        name: string
        status: ProjectStatus
      }
      subcontractor: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
        contacts?: Array<{
          __typename?: 'Contact'
          id: string
          name?: string | null
          email?: string | null
          number?: string | null
          isPrimaryContact: boolean
        } | null> | null
      }
    }> | null
  }
}

export type GetWidgetMetabaseUiQueryVariables = Exact<{
  filter: WidgetFilter
  buildPassWidgetId: Scalars['String']
}>

export type GetWidgetMetabaseUiQuery = {
  __typename?: 'Query'
  widgetMetabase: {
    __typename?: 'WidgetMetabaseData'
    iframeUrl?: string | null
  }
}

export type GetWidgetReportUiQueryVariables = Exact<{
  filter: WidgetFilter
  settings: WidgetReportingSettingsInput
}>

export type GetWidgetReportUiQuery = {
  __typename?: 'Query'
  widgetReporting: {
    __typename?: 'WidgetReportingData'
    items?: Array<{
      __typename?: 'WidgetReportingItem'
      metricType: WidgetReportMetric
      resource: {
        __typename?: 'WidgetReportingItemResource'
        id: string
        name: string
        resourceType: WidgetReportResource
      }
      data?: Array<{
        __typename?: 'ReportDimensionData'
        metric: WidgetReportMetric
        dimension?: WidgetReportDimension | null
        number: number
        suffix?: string | null
        seriesType?: string | null
        tableData?: Array<{
          __typename?: 'ReportTableData'
          id: string
          parentId?: string | null
          resourceType: WidgetReportResource
          row: any
        }> | null
      }> | null
    }> | null
  }
}

export type GetWidgetToReviewUiQueryVariables = Exact<{
  filter: WidgetFilter
}>

export type GetWidgetToReviewUiQuery = {
  __typename?: 'Query'
  widgetToReview: {
    __typename?: 'WidgetToReviewData'
    inductions?: Array<
      | {
          __typename?: 'BuilderInduction'
          id: string
          type: InductionType
          status?: InductionStatus | null
          worker: {
            __typename?: 'Worker'
            user: { __typename?: 'User'; firstName: string; lastName: string }
          }
          subcontractor?: {
            __typename?: 'Subcontractor'
            company: { __typename?: 'Company'; name: string }
          } | null
        }
      | {
          __typename?: 'ProjectInduction'
          id: string
          type: InductionType
          status?: InductionStatus | null
          worker: {
            __typename?: 'Worker'
            user: { __typename?: 'User'; firstName: string; lastName: string }
          }
          project: { __typename?: 'Project'; name: string }
        }
    > | null
    insurances?: Array<{
      __typename?: 'InsuranceDoc'
      id: string
      name: string
      expiry?: string | null
      status: InsuranceStatus
      subcontractor: {
        __typename?: 'Subcontractor'
        company: { __typename?: 'Company'; name: string }
      }
    }> | null
    swms?: Array<{
      __typename?: 'SwmsDoc'
      id: string
      createdAt: string
      name: string
      status: SwmsStatus
      expireInDays?: number | null
      subcontractor: {
        __typename?: 'Subcontractor'
        company: { __typename?: 'Company'; name: string }
      }
      project: { __typename?: 'Project'; name: string }
    }> | null
    documents?: Array<{
      __typename?: 'Document'
      id: string
      name: string
      status: DocumentStatus
      subcontractor?: {
        __typename?: 'Subcontractor'
        company: { __typename?: 'Company'; name: string }
      } | null
      project?: { __typename?: 'Project'; name: string } | null
    }> | null
    sds: Array<{
      __typename?: 'MsdsDoc'
      id: string
      name: string
      status: MsdsStatus
      subcontractor: {
        __typename?: 'Subcontractor'
        company: { __typename?: 'Company'; name: string }
      }
      projects: Array<{ __typename?: 'Project'; name: string } | null>
    } | null>
  }
}

export type RenameWidgetUiMutationVariables = Exact<{
  widgetId: Scalars['String']
  title: Scalars['String']
}>

export type RenameWidgetUiMutation = {
  __typename?: 'Mutation'
  renameWidget: { __typename?: 'DashboardWidget'; id: string }
}

export type OverviewSignOnsUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<FilterInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type OverviewSignOnsUiQuery = {
  __typename?: 'Query'
  dashboardSignOnsByDate: {
    __typename?: 'DashboardSignOns'
    signOnsByDate: Array<{
      __typename?: 'SignOnsByDate'
      dateIndex: string
      totalSignOns: number
    } | null>
    signOnsBySubcontractorOnDate: Array<{
      __typename?: 'SignOnsBySubcontractorOnDate'
      subcontractorId: string
      subcontractorName: string
      totalSignOns: number
      totalSignOffs: number
    } | null>
    todaysSignOns: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      signedOffAt?: string | null
      manualSignedOnAt?: string | null
      manualSignedOffAt?: string | null
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null>
      } | null
      visitor?: {
        __typename?: 'Visitor'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    }>
    todaysSignOnsAggregation: {
      __typename?: 'PaginationAggregation'
      totalCount?: number | null
      totalPages?: number | null
      offset?: number | null
      limit?: number | null
    }
  }
}

export type OverviewStatisticsUiQueryVariables = Exact<{
  defectFilters: DefectFilterInput
  actionFilters: PlatformActionFilterInput
  permitFilters: PermitFilterInput
  projectId: Scalars['String']
  subcontractorFilters: SubcontractorFilterInput
  workerFilters: WorkersFilterInput
}>

export type OverviewStatisticsUiQuery = {
  __typename?: 'Query'
  defectsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
  }
  platformActionsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
  }
  permitAggregation_admin: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
  }
  subcontractorsByProject: Array<{
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
  }>
  workersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
  }
}

export type WorkersToReviewUiQueryVariables = Exact<{
  projectId: Scalars['String']
  builderId: Scalars['String']
  projectInductionsFilter?: InputMaybe<InductionFilterInput>
  builderInductionsFilter?: InputMaybe<BuilderInductionFilterInput>
  inductionSort?: InputMaybe<InductionSortInput>
  ticketFilter?: InputMaybe<TicketFilterInput>
  ticketSort?: InputMaybe<TicketSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type WorkersToReviewUiQuery = {
  __typename?: 'Query'
  projectInductions: Array<{
    __typename?: 'ProjectInduction'
    id: string
    createdAt: string
    type: InductionType
    status?: InductionStatus | null
    worker: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    }
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
  }>
  projectInductionsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  builderInductions: Array<{
    __typename?: 'BuilderInduction'
    id: string
    createdAt: string
    type: InductionType
    status?: InductionStatus | null
    worker: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    }
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
  }>
  builderInductionsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  ticketsByWorkers: Array<{
    __typename?: 'Ticket'
    id: string
    createdAt: string
    hidden?: boolean | null
    latestReviewStatus?: TicketReviewStatus | null
    ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
    files: Array<{
      __typename?: 'TicketFile'
      file: { __typename?: 'File'; url?: string | null; name: string }
    } | null>
    worker: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
  } | null>
  ticketsByWorkersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type PermitsToReviewUiQueryVariables = Exact<{
  filter?: InputMaybe<PermitFilterInput>
  sort?: InputMaybe<PermitSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type PermitsToReviewUiQuery = {
  __typename?: 'Query'
  permits_admin?: Array<{
    __typename?: 'Permit_Admin'
    id: string
    startDate: string
    endDate: string
    overallStatus: OverallPermitStatus
    permitType: { __typename?: 'PermitType_Admin'; identifierPrefix: string }
    workers?: Array<{
      __typename?: 'PermitWorker_Admin'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null>
      } | null
    }> | null
  }> | null
  permitAggregation_admin: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SwmsToReviewUiQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>
  swmsFilter?: InputMaybe<SwmsFilterInput>
  swmsSort?: InputMaybe<SwmsSortInput>
  librarySwmsFilter?: InputMaybe<LibrarySwmsDocFilterInputAdmin>
  librarySwmsSort?: InputMaybe<LibrarySwmsDocSortInputAdmin>
  pagination?: InputMaybe<PaginationInput>
}>

export type SwmsToReviewUiQuery = {
  __typename?: 'Query'
  swmsDocs: Array<{
    __typename?: 'SwmsDoc'
    id: string
    name: string
    createdAt: string
    status: SwmsStatus
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
  }>
  swmsDocsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  librarySwmsDocs_admin: Array<{
    __typename?: 'LibrarySwmsDoc_Admin'
    id: string
    name: string
    createdAt: string
    status: SwmsStatus
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
  }>
  librarySwmsDocsAggregation_admin: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type InsurancesToReviewUiQueryVariables = Exact<{
  filter?: InputMaybe<InsuranceFilterInput>
  sort?: InputMaybe<InsuranceSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type InsurancesToReviewUiQuery = {
  __typename?: 'Query'
  insuranceDocs: Array<{
    __typename?: 'InsuranceDoc'
    id: string
    name: string
    type?: InsuranceType | null
    createdAt: string
    status: InsuranceStatus
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
  }>
  insuranceDocsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type ActionsAndDefectsToReviewUiQueryVariables = Exact<{
  actionsFilter?: InputMaybe<PlatformActionFilterInput>
  actionsSort?: InputMaybe<PlatformActionSortInput>
  defectsFilter: DefectFilterInput
  defectsSort?: InputMaybe<DefectSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type ActionsAndDefectsToReviewUiQuery = {
  __typename?: 'Query'
  platformActions: Array<{
    __typename?: 'PlatformAction'
    id: string
    createdAt: string
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    dueDate?: string | null
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    templateResponse?: {
      __typename?: 'TemplateResponse'
      attachments?: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        fileName: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      }> | null
    } | null
    conversation?: {
      __typename?: 'ConversationThread'
      messages: Array<{
        __typename?: 'ConversationMessage'
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          fileName: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  }>
  platformActionsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  defects?: Array<{
    __typename?: 'Defect'
    id: string
    createdAt: string
    title?: string | null
    description?: string | null
    dueDate?: string | null
    status: DefectStatus
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null> | null
    conversation?: {
      __typename?: 'ConversationThread'
      messages: Array<{
        __typename?: 'ConversationMessage'
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          fileName: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  }> | null
  defectsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type PrequalsToReviewUiQueryVariables = Exact<{
  filter?: InputMaybe<PrequalificationFilterInput>
  sort?: InputMaybe<PrequalificationSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type PrequalsToReviewUiQuery = {
  __typename?: 'Query'
  prequalifications: Array<{
    __typename?: 'Prequalification'
    id: string
    createdAt: string
    status: PrequalificationStatus
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
  }>
  prequalificationsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type DocumentsToReviewUiQueryVariables = Exact<{
  subbieFilter?: InputMaybe<DocumentFilterInput>
  projectFilter?: InputMaybe<DocumentFilterInput>
  builderFilter?: InputMaybe<DocumentFilterInput>
  sort?: InputMaybe<DocumentSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type DocumentsToReviewUiQuery = {
  __typename?: 'Query'
  subbieDocuments: Array<{
    __typename?: 'Document'
    id: string
    createdAt: string
    name: string
    type?: string | null
    category?: DocumentCategory | null
    status: DocumentStatus
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
  }>
  subbieDocumentsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  projectDocuments: Array<{
    __typename?: 'Document'
    id: string
    createdAt: string
    name: string
    type?: string | null
    category?: DocumentCategory | null
    status: DocumentStatus
  }>
  projectDocumentsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  builderDocuments: Array<{
    __typename?: 'Document'
    id: string
    createdAt: string
    name: string
    type?: string | null
    category?: DocumentCategory | null
    status: DocumentStatus
  }>
  builderDocumentsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type ExpiringSwmsDocLogsUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<SwmsDocLogsFilterInput>
}>

export type ExpiringSwmsDocLogsUiQuery = {
  __typename?: 'Query'
  swmsDocLogs: Array<{
    __typename?: 'SwmsDocLog'
    id: string
    createdAt: string
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    swmsDoc: {
      __typename?: 'SwmsDoc'
      id: string
      name: string
      expireInDays?: number | null
      documentSignatures: Array<{
        __typename?: 'DocumentSignature'
        createdAt: string
        worker: { __typename?: 'Worker'; id: string }
      } | null>
    }
  }>
}

export type ExpiringTicketsUiQueryVariables = Exact<{
  filter?: InputMaybe<TicketFilterInput>
  sort?: InputMaybe<TicketSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type ExpiringTicketsUiQuery = {
  __typename?: 'Query'
  ticketsByWorkers: Array<{
    __typename?: 'Ticket'
    id: string
    expiry?: string | null
    hidden?: boolean | null
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      id: string
      shortName: string
    }
    files: Array<{
      __typename?: 'TicketFile'
      file: { __typename?: 'File'; url?: string | null; name: string }
    } | null>
  } | null>
  ticketsByWorkersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type ExpiringInsurancesUiQueryVariables = Exact<{
  filter?: InputMaybe<InsuranceFilterInput>
  sort?: InputMaybe<InsuranceSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type ExpiringInsurancesUiQuery = {
  __typename?: 'Query'
  insuranceDocs: Array<{
    __typename?: 'InsuranceDoc'
    id: string
    name: string
    type?: InsuranceType | null
    expiry?: string | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
  }>
  insuranceDocsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type ExpiringSdsDocsUiQueryVariables = Exact<{
  filter?: InputMaybe<MsdsFilterInput>
  sort?: InputMaybe<MsdsSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type ExpiringSdsDocsUiQuery = {
  __typename?: 'Query'
  msdsDocs: Array<{
    __typename?: 'MsdsDoc'
    id: string
    name: string
    createdAt: string
    reviewDate?: string | null
    status: MsdsStatus
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
  }>
  msdsDocsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type ExpiringActionsUiQueryVariables = Exact<{
  filter?: InputMaybe<PlatformActionFilterInput>
  sort?: InputMaybe<PlatformActionSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type ExpiringActionsUiQuery = {
  __typename?: 'Query'
  platformActions: Array<{
    __typename?: 'PlatformAction'
    id: string
    createdAt: string
    title?: string | null
    description?: string | null
    type?: string | null
    dueDate?: string | null
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    templateResponse?: {
      __typename?: 'TemplateResponse'
      attachments?: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        fileName: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      }> | null
    } | null
    conversation?: {
      __typename?: 'ConversationThread'
      messages: Array<{
        __typename?: 'ConversationMessage'
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          fileName: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  }>
  platformActionsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type ProjectDetailsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectDetailsUiQuery = {
  __typename?: 'Query'
  project?: {
    __typename?: 'Project'
    radius?: number | null
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      shortName: string
      name: string
    } | null>
    projectAdmins: Array<{
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null>
    projectContacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      number?: string | null
      email?: string | null
      type: ContactType
      customType?: string | null
    } | null> | null
  } | null
  signOnSettings: {
    __typename?: 'SignOnSettings'
    geolocationSignOnOffRemindersEnabledForAllProjects?: boolean | null
    projectIdsWithGeolocationSignOnOffRemindersEnabled?: Array<string> | null
    geolocationAutoSignOnOffEnabledForAllProjects?: boolean | null
  }
}

export type RecentItemsUiQueryVariables = Exact<{
  projectId: Scalars['String']
  siteDiaryfilter?: InputMaybe<SiteDiaryFilterInput>
  siteDiarySort?: InputMaybe<SiteDiarySortInput>
  checklistFilter?: InputMaybe<TemplateResponseFilterInput>
  checklistSort?: InputMaybe<TemplateResponseSortInput>
  toolboxFilter?: InputMaybe<ToolboxFilterInput>
  toolboxSort?: InputMaybe<ToolboxSortInput>
  scheduledJobFilter?: InputMaybe<ScheduledJobFilterInput>
  permitFilter?: InputMaybe<PermitFilterInput>
  permitSort?: InputMaybe<PermitSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type RecentItemsUiQuery = {
  __typename?: 'Query'
  siteDiaries: Array<{
    __typename?: 'SiteDiary'
    id: string
    date: string
    createdBy?: {
      __typename?: 'User'
      firstName: string
      lastName: string
    } | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      attachments?: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        fileName: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      }> | null
    }
  }>
  templateResponses: Array<{
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    completedAt?: string | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    }> | null
    template?:
      | { __typename?: 'LibraryTemplate'; id: string; templateName: string }
      | { __typename?: 'Template'; id: string; templateName: string }
      | null
    author?:
      | {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | null
  }>
  toolboxesByProject: Array<{
    __typename?: 'Toolbox'
    id: string
    createdAt: string
    type: ToolboxType
    templateResponse?: {
      __typename?: 'TemplateResponse'
      attachments?: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        fileName: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      }> | null
    } | null
  }>
  scheduledJobsForProject: Array<{
    __typename?: 'ScheduledJob'
    id: string
    scheduledFor: string
    schedule: {
      __typename?: 'Schedule'
      id: string
      template?: {
        __typename?: 'Template'
        id: string
        templateName: string
      } | null
    }
  }>
  permits_admin?: Array<{
    __typename?: 'Permit_Admin'
    id: string
    startDate: string
    endDate: string
    permitType: { __typename?: 'PermitType_Admin'; identifierPrefix: string }
    workers?: Array<{
      __typename?: 'PermitWorker_Admin'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null>
      } | null
    }> | null
  }> | null
}

export type CurrentRegisterItemsUiQueryVariables = Exact<{
  filter?: InputMaybe<RegisterItemFilterInput>
  sort?: InputMaybe<RegisterItemSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type CurrentRegisterItemsUiQuery = {
  __typename?: 'Query'
  registerItems: Array<{
    __typename?: 'RegisterItem'
    id: string
    identifier: number
    fullIdentifier: string
    name: string
    followUpAt?: string | null
    register: { __typename?: 'Register'; id: string; identifierPrefix: string }
    templateResponse: {
      __typename?: 'TemplateResponse'
      attachments?: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        fileName: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      }> | null
    }
  }>
}

export type GetDashboardDataUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<FilterInput>
}>

export type GetDashboardDataUiQuery = {
  __typename?: 'Query'
  getDashboardData: {
    __typename?: 'DashboardData'
    totalTicketsAwaitingReview?: number | null
    insuranceDocs?: Array<{
      __typename?: 'InsuranceDoc'
      id: string
      name: string
      expiry?: string | null
      status: InsuranceStatus
      type?: InsuranceType | null
      subcontractorId: string
      subcontractor: {
        __typename?: 'Subcontractor'
        company: { __typename?: 'Company'; name: string }
      }
    } | null> | null
    ticketExpiries?: Array<{
      __typename?: 'Ticket'
      id: string
      expiry?: string | null
      countryIssued?: string | null
      stateIssued?: string | null
      workerId: string
      ticketTemplate: {
        __typename?: 'TicketTemplate'
        name: string
        shortName: string
        code?: string | null
      }
      worker: {
        __typename?: 'Worker'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    } | null> | null
    ticketReviews?: Array<{
      __typename?: 'Ticket'
      id: string
      workerId: string
      worker: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          isBuilder?: boolean | null
        } | null>
      }
    } | null> | null
    swms?: Array<{
      __typename?: 'SwmsDoc'
      id: string
      name: string
      status: SwmsStatus
      subcontractorId: string
      subcontractor: {
        __typename?: 'Subcontractor'
        company: { __typename?: 'Company'; name: string }
      }
    } | null> | null
    workersWithoutWhiteCard?: Array<{
      __typename?: 'Worker'
      id: string
      trade?: string | null
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null> | null
    meta?: {
      __typename?: 'DashboardMeta'
      afterDateTime?: string | null
      beforeDateTime?: string | null
    } | null
    workers?: Array<{ __typename?: 'Worker'; id: string } | null> | null
  }
}

export type GetDashboardSignOnsUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<FilterInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type GetDashboardSignOnsUiQuery = {
  __typename?: 'Query'
  dashboardSignOnsByDate: {
    __typename?: 'DashboardSignOns'
    signOnsByDate: Array<{
      __typename?: 'SignOnsByDate'
      dateIndex: string
      totalSignOns: number
    } | null>
    todaysSignOns: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      signedOffAt?: string | null
      manualSignedOnAt?: string | null
      manualSignedOffAt?: string | null
      worker?: {
        __typename?: 'Worker'
        id: string
        trade?: string | null
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      visitor?: {
        __typename?: 'Visitor'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    }>
    todaysSignOnsAggregation: {
      __typename?: 'PaginationAggregation'
      totalCount?: number | null
      totalPages?: number | null
      offset?: number | null
      limit?: number | null
    }
  }
}

export type SaGetDashboardDataUiQueryVariables = Exact<{
  input: SaDashboardDataInput
  filter?: InputMaybe<FilterInput>
}>

export type SaGetDashboardDataUiQuery = {
  __typename?: 'Query'
  saGetDashboardData: {
    __typename?: 'DashboardData'
    signOnsByDate?: Array<{
      __typename?: 'GroupedSignOn'
      date?: string | null
      signOns?: Array<{
        __typename?: 'SignOn'
        id: string
        createdAt: string
        project?: { __typename?: 'Project'; name: string } | null
      } | null> | null
    } | null> | null
  }
}

export type GetBuilderEventsUiQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<BuilderEventOrderByInput>
  projectIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
}>

export type GetBuilderEventsUiQuery = {
  __typename?: 'Query'
  builderEvents?: {
    __typename?: 'BuilderEventResult'
    projectStats?: Array<{
      __typename?: 'ProjectStats'
      projectId: string
      signOns: number
      inductions: number
    } | null> | null
    events?: Array<{
      __typename?: 'BuilderEvent'
      projectId: string
      id: string
      type: BuilderEventType
      createdAt: string
      actionBy?:
        | {
            __typename?: 'AdminUserEntity'
            user?: {
              __typename?: 'UserEntity'
              firstName?: string | null
              lastName?: string | null
            } | null
          }
        | {
            __typename?: 'WorkerAuditEntity'
            user?: {
              __typename?: 'UserEntity'
              firstName?: string | null
              lastName?: string | null
            } | null
          }
        | null
    } | null> | null
  } | null
}

export type GetDashboardsListUiQueryVariables = Exact<{
  filter: DashboardListFilterInput
  pagination?: InputMaybe<PaginationInput>
}>

export type GetDashboardsListUiQuery = {
  __typename?: 'Query'
  dashboards: Array<{
    __typename?: 'Dashboard'
    id: string
    title: string
    description?: string | null
    favourited: boolean
    canMutate: boolean
    owner: {
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    access: {
      __typename?: 'DashboardAccess'
      companyRole?: DashboardAccessRole | null
      adminUsers?: Array<{
        __typename?: 'DashboardAccessAdminUser'
        role: DashboardAccessRole
        adminUser: {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      }> | null
    }
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
    }> | null
  }>
  dashboardsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type GetDashboardUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type GetDashboardUiQuery = {
  __typename?: 'Query'
  dashboard: {
    __typename?: 'Dashboard'
    id: string
    title: string
    description?: string | null
    favourited: boolean
    canMutate: boolean
    owner: {
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    access: {
      __typename?: 'DashboardAccess'
      companyRole?: DashboardAccessRole | null
      adminUsers?: Array<{
        __typename?: 'DashboardAccessAdminUser'
        role: DashboardAccessRole
        adminUser: {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      }> | null
    }
    widgets: Array<{
      __typename?: 'DashboardWidget'
      id: string
      title: string
      widgetType: WidgetType
      layout: any
      settings?:
        | { __typename?: 'WidgetGamesSettings'; gameType?: GameType | null }
        | { __typename?: 'WidgetMetabaseSettings'; dashboardId?: string | null }
        | {
            __typename?: 'WidgetReportingSettings'
            resourceType: WidgetReportResource
            metric: WidgetReportMetric
            graphType?: WidgetReportGraphType | null
            showTable?: boolean | null
            dimension?: WidgetReportDimension | null
            resourceIds?: Array<string> | null
          }
        | null
    }>
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }> | null
  }
}

export type CreateDashboardUiMutationVariables = Exact<{
  input: DashboardInput
}>

export type CreateDashboardUiMutation = {
  __typename?: 'Mutation'
  createDashboard: { __typename?: 'Dashboard'; id: string }
}

export type SaveDashboardUiMutationVariables = Exact<{
  id: Scalars['String']
  input: DashboardInput
}>

export type SaveDashboardUiMutation = {
  __typename?: 'Mutation'
  saveDashboard: { __typename?: 'Dashboard'; id: string }
}

export type DeleteDashboardUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteDashboardUiMutation = {
  __typename?: 'Mutation'
  deleteDashboard: { __typename?: 'Dashboard'; id: string }
}

export type ToggleFavouriteDashboardUiMutationVariables = Exact<{
  id: Scalars['String']
  isFavourited: Scalars['Boolean']
}>

export type ToggleFavouriteDashboardUiMutation = {
  __typename?: 'Mutation'
  toggleFavouriteDashboard: { __typename?: 'Dashboard'; id: string }
}

export type DefectAttributesFragment = {
  __typename?: 'Defect'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  completedAt?: string | null
  distributedAt?: string | null
  dueDate?: string | null
  status: DefectStatus
  priority?: DefectPriority | null
  title?: string | null
  description?: string | null
  type?: string | null
  order?: number | null
  overdue?: boolean | null
  tags?: Array<string> | null
  nextDefectId?: string | null
  previousDefectId?: string | null
  assigner: {
    __typename?: 'AdminUser'
    user: { __typename?: 'User'; firstName: string; lastName: string }
  }
  project: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
  }
  assignees: Array<{
    __typename?: 'Assignee'
    id: string
    worker?: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
  } | null>
  attachments?: Array<{
    __typename?: 'Attachment'
    id: string
    url: string
    fileName: string
    thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
  } | null> | null
  location?: {
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    parent?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  } | null
  conversation?: {
    __typename?: 'ConversationThread'
    id: string
    messages: Array<{
      __typename?: 'ConversationMessage'
      id: string
      createdAt: string
      content?: string | null
      sender: {
        __typename?: 'Assignee'
        id: string
        worker?: {
          __typename?: 'Worker'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        adminUser?: {
          __typename?: 'AdminUser'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        subcontractor?: {
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null
      }
      attachments: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      } | null>
    } | null>
  } | null
}

export type DefectUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type DefectUiQuery = {
  __typename?: 'Query'
  defect?: {
    __typename?: 'Defect'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    completedAt?: string | null
    distributedAt?: string | null
    dueDate?: string | null
    status: DefectStatus
    priority?: DefectPriority | null
    title?: string | null
    description?: string | null
    type?: string | null
    order?: number | null
    overdue?: boolean | null
    tags?: Array<string> | null
    nextDefectId?: string | null
    previousDefectId?: string | null
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    }
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null> | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
    conversation?: {
      __typename?: 'ConversationThread'
      id: string
      messages: Array<{
        __typename?: 'ConversationMessage'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee'
          id: string
          worker?: {
            __typename?: 'Worker'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor'
            id: string
            company: { __typename?: 'Company'; name: string }
          } | null
        }
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  } | null
  knockMessageLogs_admin: Array<{
    __typename?: 'KnockMessageLog_Admin'
    id: string
    logDate: string
    status: KnockMessageStatus
    messageId: string
    sentTo: {
      __typename?: 'KnockMessageLogUser_admin'
      id: string
      name: string
    }
  }>
}

export type DefectWithAuditLogsUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type DefectWithAuditLogsUiQuery = {
  __typename?: 'Query'
  defect?: {
    __typename?: 'Defect'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    completedAt?: string | null
    distributedAt?: string | null
    dueDate?: string | null
    status: DefectStatus
    priority?: DefectPriority | null
    title?: string | null
    description?: string | null
    type?: string | null
    order?: number | null
    overdue?: boolean | null
    tags?: Array<string> | null
    nextDefectId?: string | null
    previousDefectId?: string | null
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    }
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null> | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
    conversation?: {
      __typename?: 'ConversationThread'
      id: string
      messages: Array<{
        __typename?: 'ConversationMessage'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee'
          id: string
          worker?: {
            __typename?: 'Worker'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor'
            id: string
            company: { __typename?: 'Company'; name: string }
          } | null
        }
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  } | null
  auditLogsByResourceId: Array<{
    __typename?: 'AuditLog'
    id: string
    createdAt: string
    builderId?: string | null
    projectId?: string | null
    action: AuditAction
    actionBy?: AuditActionedBy | null
    actionByIdentity?: string | null
    resource: AuditResource
    resourceIdentity?: string | null
    newSnapshot?: any | null
    oldSnapshot?: any | null
    project?: { __typename?: 'Project'; name: string } | null
    actionByLink?:
      | {
          __typename?: 'AdminUserEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | { __typename?: 'SubcontractorEntity'; id: string; name: string }
      | {
          __typename?: 'WorkerAuditEntity'
          user?: {
            __typename?: 'UserEntity'
            id?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      | null
  }>
}

export type DefectsUiQueryVariables = Exact<{
  filter: DefectFilterInput
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<DefectSortInput>
}>

export type DefectsUiQuery = {
  __typename?: 'Query'
  defects?: Array<{
    __typename?: 'Defect'
    id: string
    distributedAt?: string | null
    status: DefectStatus
    order?: number | null
    title?: string | null
    type?: string | null
    description?: string | null
    dueDate?: string | null
    overdue?: boolean | null
    priority?: DefectPriority | null
    tags?: Array<string> | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null> | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  }> | null
  defectsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type CreateDefectUiMutationVariables = Exact<{
  input: CreateDefectInput
}>

export type CreateDefectUiMutation = {
  __typename?: 'Mutation'
  createDefect: {
    __typename?: 'Defect'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    completedAt?: string | null
    distributedAt?: string | null
    dueDate?: string | null
    status: DefectStatus
    priority?: DefectPriority | null
    title?: string | null
    description?: string | null
    type?: string | null
    order?: number | null
    overdue?: boolean | null
    tags?: Array<string> | null
    nextDefectId?: string | null
    previousDefectId?: string | null
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    }
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null> | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
    conversation?: {
      __typename?: 'ConversationThread'
      id: string
      messages: Array<{
        __typename?: 'ConversationMessage'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee'
          id: string
          worker?: {
            __typename?: 'Worker'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor'
            id: string
            company: { __typename?: 'Company'; name: string }
          } | null
        }
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  }
}

export type UpdateDefectUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateDefectInput
}>

export type UpdateDefectUiMutation = {
  __typename?: 'Mutation'
  updateDefect: {
    __typename?: 'Defect'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    completedAt?: string | null
    distributedAt?: string | null
    dueDate?: string | null
    status: DefectStatus
    priority?: DefectPriority | null
    title?: string | null
    description?: string | null
    type?: string | null
    order?: number | null
    overdue?: boolean | null
    tags?: Array<string> | null
    nextDefectId?: string | null
    previousDefectId?: string | null
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    }
    assignees: Array<{
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null>
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null> | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
    conversation?: {
      __typename?: 'ConversationThread'
      id: string
      messages: Array<{
        __typename?: 'ConversationMessage'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee'
          id: string
          worker?: {
            __typename?: 'Worker'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor'
            id: string
            company: { __typename?: 'Company'; name: string }
          } | null
        }
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
  }
}

export type UpdateDefectStatusUiMutationVariables = Exact<{
  id: Scalars['String']
  status: DefectStatus
}>

export type UpdateDefectStatusUiMutation = {
  __typename?: 'Mutation'
  updateDefectStatus: { __typename?: 'Defect'; id: string }
}

export type UpdateDefectsStatusUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  status: DefectStatus
}>

export type UpdateDefectsStatusUiMutation = {
  __typename?: 'Mutation'
  updateDefectsStatus?: Array<{ __typename?: 'Defect'; id: string }> | null
}

export type UpdateDefectsAssigneesUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  assignees: Array<AssigneeInput> | AssigneeInput
}>

export type UpdateDefectsAssigneesUiMutation = {
  __typename?: 'Mutation'
  updateDefectsAssignees?: Array<{ __typename?: 'Defect'; id: string }> | null
}

export type UpdateDefectsDueDateUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  dueDate: Scalars['DateTime']
}>

export type UpdateDefectsDueDateUiMutation = {
  __typename?: 'Mutation'
  updateDefectsDueDate?: Array<{ __typename?: 'Defect'; id: string }> | null
}

export type UpdateDefectViaResourceLinkUiMutationVariables = Exact<{
  resourceLinkSlug: Scalars['String']
  defectId: Scalars['String']
  input: UpdateResourceLinkDefectInput
}>

export type UpdateDefectViaResourceLinkUiMutation = {
  __typename?: 'Mutation'
  updateDefectViaResourceLink: {
    __typename?: 'Defect_ResourceLink'
    id: string
  }
}

export type CreateDefectMessageViaResourceLinkUiMutationVariables = Exact<{
  resourceLinkSlug: Scalars['String']
  defectId: Scalars['String']
  input: CreateConversationMessageInput
}>

export type CreateDefectMessageViaResourceLinkUiMutation = {
  __typename?: 'Mutation'
  createDefectMessageViaResourceLink: {
    __typename?: 'ConversationMessage_ResourceLink'
    id: string
  }
}

export type SendDefectsUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  projectId: Scalars['String']
}>

export type SendDefectsUiMutation = {
  __typename?: 'Mutation'
  sendDefects?: Array<{ __typename?: 'Defect'; id: string }> | null
}

export type WorkerDefectAttributesFragment = {
  __typename?: 'WorkerDefectEntry'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  completedAt?: string | null
  dueDate?: string | null
  status: DefectStatus
  priority?: DefectPriority | null
  title?: string | null
  description?: string | null
  type?: string | null
  order?: number | null
  overdue?: boolean | null
  project: {
    __typename?: 'Project_ResourceLink'
    id: string
    name: string
    status: ProjectStatus
  }
  attachments?: Array<{
    __typename?: 'Attachment_ResourceLink'
    id: string
    url: string
    fileName: string
    thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
  } | null> | null
  location?: {
    __typename?: 'ProjectLocation_ResourceLink'
    id: string
    name: string
    order?: number | null
    fullLocationName: string
    parent?: {
      __typename?: 'ProjectLocation_ResourceLink'
      id: string
      name: string
      order?: number | null
      fullLocationName: string
      parent?: {
        __typename?: 'ProjectLocation_ResourceLink'
        id: string
        name: string
        order?: number | null
        fullLocationName: string
        parent?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
          order?: number | null
          fullLocationName: string
          parent?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
            order?: number | null
            fullLocationName: string
            parent?: {
              __typename?: 'ProjectLocation_ResourceLink'
              id: string
              name: string
              order?: number | null
              fullLocationName: string
              parent?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                order?: number | null
                fullLocationName: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                  order?: number | null
                  fullLocationName: string
                  parent?: {
                    __typename?: 'ProjectLocation_ResourceLink'
                    id: string
                    name: string
                    order?: number | null
                    fullLocationName: string
                    parent?: {
                      __typename?: 'ProjectLocation_ResourceLink'
                      id: string
                      name: string
                      order?: number | null
                      fullLocationName: string
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  } | null
}

export type MyDefectsUiQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>
}>

export type MyDefectsUiQuery = {
  __typename?: 'Query'
  myDefects: Array<{
    __typename?: 'WorkerDefectEntry'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    completedAt?: string | null
    dueDate?: string | null
    status: DefectStatus
    priority?: DefectPriority | null
    title?: string | null
    description?: string | null
    type?: string | null
    order?: number | null
    overdue?: boolean | null
    project: {
      __typename?: 'Project_ResourceLink'
      id: string
      name: string
      status: ProjectStatus
    }
    attachments?: Array<{
      __typename?: 'Attachment_ResourceLink'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null> | null
    location?: {
      __typename?: 'ProjectLocation_ResourceLink'
      id: string
      name: string
      order?: number | null
      fullLocationName: string
      parent?: {
        __typename?: 'ProjectLocation_ResourceLink'
        id: string
        name: string
        order?: number | null
        fullLocationName: string
        parent?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
          order?: number | null
          fullLocationName: string
          parent?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
            order?: number | null
            fullLocationName: string
            parent?: {
              __typename?: 'ProjectLocation_ResourceLink'
              id: string
              name: string
              order?: number | null
              fullLocationName: string
              parent?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                order?: number | null
                fullLocationName: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                  order?: number | null
                  fullLocationName: string
                  parent?: {
                    __typename?: 'ProjectLocation_ResourceLink'
                    id: string
                    name: string
                    order?: number | null
                    fullLocationName: string
                    parent?: {
                      __typename?: 'ProjectLocation_ResourceLink'
                      id: string
                      name: string
                      order?: number | null
                      fullLocationName: string
                      parent?: {
                        __typename?: 'ProjectLocation_ResourceLink'
                        id: string
                        name: string
                        order?: number | null
                        fullLocationName: string
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  }>
}

export type MyDefectUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type MyDefectUiQuery = {
  __typename?: 'Query'
  myDefect: {
    __typename?: 'WorkerDefectEntry'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    completedAt?: string | null
    dueDate?: string | null
    status: DefectStatus
    priority?: DefectPriority | null
    title?: string | null
    description?: string | null
    type?: string | null
    order?: number | null
    overdue?: boolean | null
    conversation?: {
      __typename?: 'ConversationThread_ResourceLink'
      id: string
      messages?: Array<{
        __typename?: 'ConversationMessage_ResourceLink'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee_ResourceLink'
          id: string
          worker?: {
            __typename?: 'Worker_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
          } | null
        }
        attachments?: Array<{
          __typename?: 'Attachment_ResourceLink'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        }> | null
      }> | null
    } | null
    project: {
      __typename?: 'Project_ResourceLink'
      id: string
      name: string
      status: ProjectStatus
    }
    attachments?: Array<{
      __typename?: 'Attachment_ResourceLink'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null> | null
    location?: {
      __typename?: 'ProjectLocation_ResourceLink'
      id: string
      name: string
      order?: number | null
      fullLocationName: string
      parent?: {
        __typename?: 'ProjectLocation_ResourceLink'
        id: string
        name: string
        order?: number | null
        fullLocationName: string
        parent?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
          order?: number | null
          fullLocationName: string
          parent?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
            order?: number | null
            fullLocationName: string
            parent?: {
              __typename?: 'ProjectLocation_ResourceLink'
              id: string
              name: string
              order?: number | null
              fullLocationName: string
              parent?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                order?: number | null
                fullLocationName: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                  order?: number | null
                  fullLocationName: string
                  parent?: {
                    __typename?: 'ProjectLocation_ResourceLink'
                    id: string
                    name: string
                    order?: number | null
                    fullLocationName: string
                    parent?: {
                      __typename?: 'ProjectLocation_ResourceLink'
                      id: string
                      name: string
                      order?: number | null
                      fullLocationName: string
                      parent?: {
                        __typename?: 'ProjectLocation_ResourceLink'
                        id: string
                        name: string
                        order?: number | null
                        fullLocationName: string
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  }
}

export type UpdateMyDefectUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateMyDefectInput
}>

export type UpdateMyDefectUiMutation = {
  __typename?: 'Mutation'
  updateMyDefect: {
    __typename?: 'WorkerDefectEntry'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    completedAt?: string | null
    dueDate?: string | null
    status: DefectStatus
    priority?: DefectPriority | null
    title?: string | null
    description?: string | null
    type?: string | null
    order?: number | null
    overdue?: boolean | null
    conversation?: {
      __typename?: 'ConversationThread_ResourceLink'
      id: string
      messages?: Array<{
        __typename?: 'ConversationMessage_ResourceLink'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee_ResourceLink'
          id: string
          worker?: {
            __typename?: 'Worker_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
          } | null
        }
        attachments?: Array<{
          __typename?: 'Attachment_ResourceLink'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        }> | null
      }> | null
    } | null
    project: {
      __typename?: 'Project_ResourceLink'
      id: string
      name: string
      status: ProjectStatus
    }
    attachments?: Array<{
      __typename?: 'Attachment_ResourceLink'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    } | null> | null
    location?: {
      __typename?: 'ProjectLocation_ResourceLink'
      id: string
      name: string
      order?: number | null
      fullLocationName: string
      parent?: {
        __typename?: 'ProjectLocation_ResourceLink'
        id: string
        name: string
        order?: number | null
        fullLocationName: string
        parent?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
          order?: number | null
          fullLocationName: string
          parent?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
            order?: number | null
            fullLocationName: string
            parent?: {
              __typename?: 'ProjectLocation_ResourceLink'
              id: string
              name: string
              order?: number | null
              fullLocationName: string
              parent?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                order?: number | null
                fullLocationName: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                  order?: number | null
                  fullLocationName: string
                  parent?: {
                    __typename?: 'ProjectLocation_ResourceLink'
                    id: string
                    name: string
                    order?: number | null
                    fullLocationName: string
                    parent?: {
                      __typename?: 'ProjectLocation_ResourceLink'
                      id: string
                      name: string
                      order?: number | null
                      fullLocationName: string
                      parent?: {
                        __typename?: 'ProjectLocation_ResourceLink'
                        id: string
                        name: string
                        order?: number | null
                        fullLocationName: string
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  }
}

export type CreateMyDefectMessageUiMutationVariables = Exact<{
  id: Scalars['String']
  input: CreateConversationMessageInput
}>

export type CreateMyDefectMessageUiMutation = {
  __typename?: 'Mutation'
  createMyDefectMessage: {
    __typename?: 'ConversationMessage_ResourceLink'
    id: string
  }
}

export type DefectAssigneesQueryVariables = Exact<{
  projectId: Scalars['String']
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  adminUserFilter?: InputMaybe<AdminUserFilterInput>
  adminUserSort?: InputMaybe<AdminUserSortInput>
  filter?: InputMaybe<SubcontractorFilterInput>
  sort?: InputMaybe<SubcontractorSortInput>
}>

export type DefectAssigneesQuery = {
  __typename?: 'Query'
  workersByProject?: Array<{
    __typename?: 'Worker'
    id: string
    trade?: string | null
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null> | null
  subcontractorsByProject: Array<{
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
  }>
  adminUsers: Array<{
    __typename?: 'AdminUser'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
  }>
}

export type DocumentFolderAttributesFragment = {
  __typename?: 'DocumentFolder'
  id: string
  name: string
  visibleToWorkers?: boolean | null
  resourceLink?: {
    __typename?: 'ResourceLink'
    id: string
    active: boolean
    slug: string
  } | null
}

export type BulkDeleteDocumentFoldersUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkDeleteDocumentFoldersUiMutation = {
  __typename?: 'Mutation'
  bulkDeleteDocumentFolders: Array<string>
}

export type GetDocumentFolderUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type GetDocumentFolderUiQuery = {
  __typename?: 'Query'
  documentFolder?: {
    __typename?: 'DocumentFolder'
    id: string
    name: string
    visibleToWorkers?: boolean | null
    resourceLink?: {
      __typename?: 'ResourceLink'
      id: string
      active: boolean
      slug: string
    } | null
  } | null
}

export type DocumentSignatureAttributesFragment = {
  __typename?: 'DocumentSignature'
  id: string
  createdAt: string
  signatureUrl: string
  builderGenerated: boolean
  worker: {
    __typename?: 'Worker'
    id: string
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
  }
  adminUser?: {
    __typename?: 'AdminUserEntity'
    id: string
    user?: {
      __typename?: 'UserEntity'
      firstName?: string | null
      lastName?: string | null
    } | null
  } | null
  induction?:
    | {
        __typename?: 'BuilderInduction'
        id: string
        type: InductionType
        templateName?: string | null
      }
    | {
        __typename?: 'ProjectInduction'
        id: string
        type: InductionType
        templateName?: string | null
      }
    | null
  swmsDoc: {
    __typename?: 'SwmsDoc'
    id: string
    name: string
    subcontractorId: string
    projectId: string
    showAll?: boolean | null
    project: { __typename?: 'Project'; id: string; name: string }
  }
}

export type GetPresignedUrlForSignatureUiQueryVariables = Exact<{
  id: Scalars['String']
  filename: Scalars['String']
  filesize: Scalars['String']
  filetype: Scalars['String']
}>

export type GetPresignedUrlForSignatureUiQuery = {
  __typename?: 'Query'
  getPresignedUrl: {
    __typename?: 'PresignedUrl'
    url: string
    key: string
    viewUrl: string
  }
}

export type CreateDocumentSignatureForWorkerUiMutationVariables = Exact<{
  input: CreateDocumentSignatureForWorkerInput
}>

export type CreateDocumentSignatureForWorkerUiMutation = {
  __typename?: 'Mutation'
  createDocumentSignatureForWorker: {
    __typename?: 'DocumentSignature'
    id: string
    createdAt: string
    signatureUrl: string
    builderGenerated: boolean
    worker: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
    }
    adminUser?: {
      __typename?: 'AdminUserEntity'
      id: string
      user?: {
        __typename?: 'UserEntity'
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
    induction?:
      | {
          __typename?: 'BuilderInduction'
          id: string
          type: InductionType
          templateName?: string | null
        }
      | {
          __typename?: 'ProjectInduction'
          id: string
          type: InductionType
          templateName?: string | null
        }
      | null
    swmsDoc: {
      __typename?: 'SwmsDoc'
      id: string
      name: string
      subcontractorId: string
      projectId: string
      showAll?: boolean | null
      project: { __typename?: 'Project'; id: string; name: string }
    }
  }
}

export type DocumentAttributesFragment = {
  __typename?: 'Document'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  name: string
  summary?: string | null
  status: DocumentStatus
  type?: string | null
  url: string
  public?: boolean | null
  category?: DocumentCategory | null
  subcontractor?: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
    } | null> | null
  } | null
  project?: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  } | null
  builder: {
    __typename?: 'Builder'
    id: string
    company: { __typename?: 'Company'; name: string }
  }
  currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
  versionHistory?: Array<{
    __typename?: 'VersionHistory'
    version: number
    document?: {
      __typename?: 'Document'
      id: string
      name: string
      status: DocumentStatus
      createdAt: string
      archivedAt?: string | null
    } | null
  }> | null
}

export type DocumentAttributesSubsetFragment = {
  __typename?: 'Document'
  id: string
  createdAt: string
  name: string
  status: DocumentStatus
  type?: string | null
  url: string
  public?: boolean | null
  subcontractor?: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
    } | null> | null
  } | null
  project?: { __typename?: 'Project'; id: string; name: string } | null
}

export type CreateDocumentUiMutationVariables = Exact<{
  input: CreateDocumentInput
}>

export type CreateDocumentUiMutation = {
  __typename?: 'Mutation'
  createDocument: {
    __typename?: 'Document'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    summary?: string | null
    status: DocumentStatus
    type?: string | null
    url: string
    public?: boolean | null
    category?: DocumentCategory | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      document?: {
        __typename?: 'Document'
        id: string
        name: string
        status: DocumentStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type CreateDocumentsUiMutationVariables = Exact<{
  input: Array<CreateDocumentInput> | CreateDocumentInput
}>

export type CreateDocumentsUiMutation = {
  __typename?: 'Mutation'
  createDocuments: Array<{
    __typename?: 'Document'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    summary?: string | null
    status: DocumentStatus
    type?: string | null
    url: string
    public?: boolean | null
    category?: DocumentCategory | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      document?: {
        __typename?: 'Document'
        id: string
        name: string
        status: DocumentStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }>
}

export type DocumentsUiQueryVariables = Exact<{
  filter?: InputMaybe<DocumentFilterInput>
}>

export type DocumentsUiQuery = {
  __typename?: 'Query'
  documents: Array<{
    __typename?: 'Document'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    summary?: string | null
    status: DocumentStatus
    type?: string | null
    url: string
    public?: boolean | null
    category?: DocumentCategory | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      document?: {
        __typename?: 'Document'
        id: string
        name: string
        status: DocumentStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }>
}

export type DocumentsListUiQueryVariables = Exact<{
  filter?: InputMaybe<DocumentFilterInput>
  sort?: InputMaybe<DocumentSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type DocumentsListUiQuery = {
  __typename?: 'Query'
  documents: Array<{
    __typename?: 'Document'
    id: string
    createdAt: string
    name: string
    status: DocumentStatus
    type?: string | null
    url: string
    public?: boolean | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    } | null
    project?: { __typename?: 'Project'; id: string; name: string } | null
  }>
  documentsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type DocumentsListWithFoldersUiQueryVariables = Exact<{
  filter?: InputMaybe<DocumentFilterInput>
  sort?: InputMaybe<DocumentSortInput>
  pagination?: InputMaybe<PaginationInput>
  folderFilter: DocumentFolderFilterInput
  folderSort?: InputMaybe<DocumentFolderSortInput>
}>

export type DocumentsListWithFoldersUiQuery = {
  __typename?: 'Query'
  documents: Array<{
    __typename?: 'Document'
    id: string
    createdAt: string
    name: string
    status: DocumentStatus
    type?: string | null
    url: string
    public?: boolean | null
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
    }> | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    } | null
    project?: { __typename?: 'Project'; id: string; name: string } | null
  }>
  documentsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  documentFolders: Array<{
    __typename?: 'DocumentFolder'
    id: string
    name: string
  }>
}

export type DocumentUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type DocumentUiQuery = {
  __typename?: 'Query'
  document?: {
    __typename?: 'Document'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    summary?: string | null
    status: DocumentStatus
    type?: string | null
    url: string
    public?: boolean | null
    category?: DocumentCategory | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      document?: {
        __typename?: 'Document'
        id: string
        name: string
        status: DocumentStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  } | null
}

export type UpdateDocumentUiMutationVariables = Exact<{
  id: Scalars['String']
  name?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  status?: InputMaybe<DocumentStatus>
  summary?: InputMaybe<Scalars['String']>
  key?: InputMaybe<Scalars['String']>
  public?: InputMaybe<Scalars['Boolean']>
}>

export type UpdateDocumentUiMutation = {
  __typename?: 'Mutation'
  updateDocument: {
    __typename?: 'Document'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    summary?: string | null
    status: DocumentStatus
    type?: string | null
    url: string
    public?: boolean | null
    category?: DocumentCategory | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      document?: {
        __typename?: 'Document'
        id: string
        name: string
        status: DocumentStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type UpdateDocumentStatusUiMutationVariables = Exact<{
  id: Scalars['String']
  status?: InputMaybe<DocumentStatus>
}>

export type UpdateDocumentStatusUiMutation = {
  __typename?: 'Mutation'
  updateDocument: {
    __typename?: 'Document'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    summary?: string | null
    status: DocumentStatus
    type?: string | null
    url: string
    public?: boolean | null
    category?: DocumentCategory | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      document?: {
        __typename?: 'Document'
        id: string
        name: string
        status: DocumentStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type GetPresignedUrlForDocumentUiQueryVariables = Exact<{
  id: Scalars['String']
  filename: Scalars['String']
  filesize: Scalars['String']
  filetype: Scalars['String']
}>

export type GetPresignedUrlForDocumentUiQuery = {
  __typename?: 'Query'
  getPresignedUrl: { __typename?: 'PresignedUrl'; url: string; key: string }
}

export type DeleteDocumentUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteDocumentUiMutation = {
  __typename?: 'Mutation'
  deleteDocument: { __typename?: 'Document'; id: string }
}

export type SendRequestUpdateEmailUiMutationVariables = Exact<{
  documentType: DocumentType
  documentId: Scalars['String']
  subcontractorId: Scalars['String']
  customMessage?: InputMaybe<Scalars['String']>
  contactIds: Array<Scalars['String']> | Scalars['String']
}>

export type SendRequestUpdateEmailUiMutation = {
  __typename?: 'Mutation'
  sendRequestUpdateEmail: {
    __typename?: 'EmailSent'
    serviceResponse?: any | null
  }
}

export type ArchiveDocumentUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveDocumentUiMutation = {
  __typename?: 'Mutation'
  archiveDocument: { __typename?: 'Document'; id: string }
}

export type RestoreDocumentUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreDocumentUiMutation = {
  __typename?: 'Mutation'
  restoreDocument: { __typename?: 'Document'; id: string }
}

export type BulkArchiveDocumentsUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkArchiveDocumentsUiMutation = {
  __typename?: 'Mutation'
  bulkArchiveDocuments: Array<string>
}

export type BulkRestoreDocumentsUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkRestoreDocumentsUiMutation = {
  __typename?: 'Mutation'
  bulkRestoreDocuments: Array<string>
}

export type DocumentFolderHierarchyUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type DocumentFolderHierarchyUiQuery = {
  __typename?: 'Query'
  documentFolderHierarchy: Array<{
    __typename?: 'DocumentFolder'
    id: string
    name: string
  }>
}

export type CreateDocumentFolderUiMutationVariables = Exact<{
  input: CreateDocumentFolderInput
}>

export type CreateDocumentFolderUiMutation = {
  __typename?: 'Mutation'
  createDocumentFolder: {
    __typename?: 'DocumentFolder'
    id: string
    name: string
  }
}

export type UpdateDocumentFolderUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateDocumentFolderInput
}>

export type UpdateDocumentFolderUiMutation = {
  __typename?: 'Mutation'
  updateDocumentFolder: {
    __typename?: 'DocumentFolder'
    id: string
    name: string
  }
}

export type DocumentFolderTreeUiQueryVariables = Exact<{
  category: DocumentCategory
  projectId?: InputMaybe<Scalars['String']>
}>

export type DocumentFolderTreeUiQuery = {
  __typename?: 'Query'
  documentFolderTree: Array<{
    __typename?: 'DocumentFolder'
    id: string
    name: string
    parentId?: string | null
  }>
}

export type MoveDocumentsUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  documentFolderId?: InputMaybe<Scalars['String']>
}>

export type MoveDocumentsUiMutation = {
  __typename?: 'Mutation'
  moveDocuments: Array<{ __typename?: 'Document'; id: string }>
}

export type MoveDocumentFoldersUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  documentFolderId?: InputMaybe<Scalars['String']>
}>

export type MoveDocumentFoldersUiMutation = {
  __typename?: 'Mutation'
  moveDocumentFolders: Array<{ __typename?: 'DocumentFolder'; id: string }>
}

export type IsDocumentFolderEmptyUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type IsDocumentFolderEmptyUiQuery = {
  __typename?: 'Query'
  isDocumentFolderEmpty: boolean
}

export type DeleteDocumentFolderUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteDocumentFolderUiMutation = {
  __typename?: 'Mutation'
  deleteDocumentFolder: { __typename?: 'DocumentFolder'; id: string }
}

export type DocumentEntityAttributesFragment = {
  __typename?: 'DocumentEntity'
  id: string
  url: string
  name: string
}

export type DocumentForWorkerUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type DocumentForWorkerUiQuery = {
  __typename?: 'Query'
  documentForWorker?: {
    __typename?: 'DocumentEntity'
    id: string
    url: string
    name: string
  } | null
}

export type GetWorkerDocumentsUiQueryVariables = Exact<{
  projectId: Scalars['String']
  subcontractorId?: InputMaybe<Scalars['String']>
}>

export type GetWorkerDocumentsUiQuery = {
  __typename?: 'Query'
  workerDocuments: {
    __typename?: 'WorkerDocuments'
    swmsDocs: Array<{
      __typename?: 'SwmsDocEntity'
      id: string
      updatedAt: string
      name: string
      url?: string | null
      isBuilder?: boolean | null
      required?: boolean | null
      requiredAll?: boolean | null
      showAll?: boolean | null
    } | null>
    msdsDocs: Array<{
      __typename?: 'MsdsDocEntity'
      id: string
      updatedAt: string
      name: string
      url: string
    } | null>
    documents: Array<{
      __typename?: 'DocumentEntity'
      id: string
      updatedAt: string
      name: string
      category?: DocumentCategory | null
      url: string
      type?: string | null
    } | null>
  }
}

export type DocumentsVisitorUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type DocumentsVisitorUiQuery = {
  __typename?: 'Query'
  documents_visitor: {
    __typename?: 'VisitorDocuments'
    swmsDocs: Array<{
      __typename?: 'SwmsDocEntity'
      id: string
      updatedAt: string
      name: string
      url?: string | null
      isBuilder?: boolean | null
      required?: boolean | null
      requiredAll?: boolean | null
      showAll?: boolean | null
    } | null>
    msdsDocs: Array<{
      __typename?: 'MsdsDocEntity'
      id: string
      updatedAt: string
      name: string
      url: string
    } | null>
    documents: Array<{
      __typename?: 'DocumentEntity'
      id: string
      updatedAt: string
      name: string
      category?: DocumentCategory | null
      url: string
      type?: string | null
    } | null>
  }
}

export type SwmsDocVisitorUiQueryVariables = Exact<{
  projectId: Scalars['String']
  documentId: Scalars['String']
}>

export type SwmsDocVisitorUiQuery = {
  __typename?: 'Query'
  swmsDoc_visitor: {
    __typename?: 'SwmsDocEntity'
    name: string
    url?: string | null
  }
}

export type MsdsDocVisitorUiQueryVariables = Exact<{
  projectId: Scalars['String']
  documentId: Scalars['String']
}>

export type MsdsDocVisitorUiQuery = {
  __typename?: 'Query'
  msdsDoc_visitor: { __typename?: 'MsdsDocEntity'; name: string; url: string }
}

export type DocumentVisitorUiQueryVariables = Exact<{
  projectId: Scalars['String']
  documentId: Scalars['String']
}>

export type DocumentVisitorUiQuery = {
  __typename?: 'Query'
  document_visitor: {
    __typename?: 'DocumentEntity'
    id: string
    name: string
    category?: DocumentCategory | null
    url: string
    type?: string | null
  }
}

export type DrawingAttributesFragment = {
  __typename?: 'Drawing_Admin'
  id: string
  createdAt: string
  updatedAt: string
  title?: string | null
  drawingNumber?: string | null
  drawingRevision?: string | null
  fileName: string
  url: string
  documentFolderId?: string | null
  status: DrawingStatus
  waitingReviewStatus?: DrawingWaitingReviewStatus | null
  previousRevision?: {
    __typename?: 'Drawing_Admin'
    id: string
    url: string
    drawingRevision?: string | null
  } | null
}

export type GetDrawingAdminUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type GetDrawingAdminUiQuery = {
  __typename?: 'Query'
  drawing_admin?: {
    __typename?: 'Drawing_Admin'
    id: string
    createdAt: string
    updatedAt: string
    title?: string | null
    drawingNumber?: string | null
    drawingRevision?: string | null
    fileName: string
    url: string
    documentFolderId?: string | null
    status: DrawingStatus
    waitingReviewStatus?: DrawingWaitingReviewStatus | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      createdAt: string
      drawing?: {
        __typename?: 'Drawing_Admin'
        id: string
        drawingRevision?: string | null
        createdAt: string
      } | null
    }> | null
    previousRevision?: {
      __typename?: 'Drawing_Admin'
      id: string
      url: string
      drawingRevision?: string | null
    } | null
  } | null
}

export type GetDrawingsAdminUiQueryVariables = Exact<{
  filter?: InputMaybe<DrawingFilterInput>
}>

export type GetDrawingsAdminUiQuery = {
  __typename?: 'Query'
  drawings_admin?: Array<{
    __typename?: 'Drawing_Admin'
    id: string
    createdAt: string
    updatedAt: string
    title?: string | null
    drawingNumber?: string | null
    drawingRevision?: string | null
    fileName: string
    url: string
    documentFolderId?: string | null
    status: DrawingStatus
    waitingReviewStatus?: DrawingWaitingReviewStatus | null
    previousRevision?: {
      __typename?: 'Drawing_Admin'
      id: string
      url: string
      drawingRevision?: string | null
    } | null
  }> | null
}

export type GetDrawingNumberOptionsAdminUiQueryVariables = Exact<{
  filter?: InputMaybe<DrawingFilterInput>
}>

export type GetDrawingNumberOptionsAdminUiQuery = {
  __typename?: 'Query'
  drawings_admin?: Array<{
    __typename?: 'Drawing_Admin'
    id: string
    drawingNumber?: string | null
    title?: string | null
  }> | null
}

export type CreateDrawingAdminUiMutationVariables = Exact<{
  input: CreateDrawingInputAdmin
}>

export type CreateDrawingAdminUiMutation = {
  __typename?: 'Mutation'
  createDrawing_admin: { __typename?: 'Drawing_Admin'; id: string }
}

export type UpdateDrawingAdminUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateDrawingInputAdmin
}>

export type UpdateDrawingAdminUiMutation = {
  __typename?: 'Mutation'
  updateDrawing_admin: { __typename?: 'Drawing_Admin'; id: string }
}

export type ArchiveDrawingAdminUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveDrawingAdminUiMutation = {
  __typename?: 'Mutation'
  archiveDrawing_admin: { __typename?: 'Drawing_Admin'; id: string }
}

export type BulkArchiveDrawingsAdminUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkArchiveDrawingsAdminUiMutation = {
  __typename?: 'Mutation'
  bulkArchiveDrawings_admin: Array<string>
}

export type DeleteDrawingAdminUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteDrawingAdminUiMutation = {
  __typename?: 'Mutation'
  deleteDrawing_admin: { __typename?: 'Drawing_Admin'; id: string }
}

export type BulkDeleteDrawingsAdminUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkDeleteDrawingsAdminUiMutation = {
  __typename?: 'Mutation'
  bulkDeleteDrawings_admin: Array<string>
}

export type HandleDrawingReviewConfirmAdminUiMutationVariables = Exact<{
  id: Scalars['String']
  waitingReviewStatus: DrawingWaitingReviewStatus
}>

export type HandleDrawingReviewConfirmAdminUiMutation = {
  __typename?: 'Mutation'
  handleDrawingReviewConfirm_admin: { __typename?: 'Drawing_Admin'; id: string }
}

export type GetDrawingsWithFoldersAdminUiQueryVariables = Exact<{
  filter?: InputMaybe<DrawingFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<DrawingSortInput>
  folderFilter: DocumentFolderFilterInput
}>

export type GetDrawingsWithFoldersAdminUiQuery = {
  __typename?: 'Query'
  drawings_admin?: Array<{
    __typename?: 'Drawing_Admin'
    id: string
    createdAt: string
    updatedAt: string
    title?: string | null
    drawingNumber?: string | null
    drawingRevision?: string | null
    fileName: string
    url: string
    documentFolderId?: string | null
    status: DrawingStatus
    waitingReviewStatus?: DrawingWaitingReviewStatus | null
    previousRevision?: {
      __typename?: 'Drawing_Admin'
      id: string
      url: string
      drawingRevision?: string | null
    } | null
  }> | null
  drawingsAggregation_admin: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  documentFolders: Array<{
    __typename?: 'DocumentFolder'
    id: string
    name: string
    updatedAt: string
    fileCount?: number | null
    folderCount?: number | null
    visibleToWorkers?: boolean | null
    resourceLink?: {
      __typename?: 'ResourceLink'
      id: string
      active: boolean
      slug: string
    } | null
  }>
}

export type MoveDrawingsAdminUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  documentFolderId?: InputMaybe<Scalars['String']>
}>

export type MoveDrawingsAdminUiMutation = {
  __typename?: 'Mutation'
  moveDrawings_admin: Array<{ __typename?: 'Drawing_Admin'; id: string }>
}

export type GetDrawingsFoldersWorkerUiQueryVariables = Exact<{
  drawingsFilter?: InputMaybe<DrawingFilterInputWorker>
  drawingsSort?: InputMaybe<DrawingSortInputWorker>
  folderFilter: DocumentFolderFilterInputWorker
}>

export type GetDrawingsFoldersWorkerUiQuery = {
  __typename?: 'Query'
  drawings_worker?: Array<{
    __typename?: 'Drawing_Worker'
    id: string
    title?: string | null
    drawingNumber?: string | null
    drawingRevision?: string | null
    url: string
  }> | null
  documentFolders_worker: Array<{
    __typename?: 'DocumentFolder_Worker'
    id: string
    name: string
    parentId?: string | null
  }>
}

export type GetDrawingsFoldersPublicUiQueryVariables = Exact<{
  drawingsFilter?: InputMaybe<DrawingFilterInputPublic>
  folderFilter: DocumentFolderFilterInputPublic
}>

export type GetDrawingsFoldersPublicUiQuery = {
  __typename?: 'Query'
  drawings_public?: Array<{
    __typename?: 'Drawing_Public'
    id: string
    title?: string | null
    drawingNumber?: string | null
    drawingRevision?: string | null
    url: string
  }> | null
  documentFolders_public: Array<{
    __typename?: 'DocumentFolder_Public'
    id: string
    name: string
    parentId?: string | null
  }>
}

export type GetDrawingActivityFeedAdminUiQueryVariables = Exact<{
  projectId: Scalars['String']
  documentFolderId?: InputMaybe<Scalars['String']>
}>

export type GetDrawingActivityFeedAdminUiQuery = {
  __typename?: 'Query'
  drawingActivityFeed_admin?: Array<{
    __typename?: 'DrawingActivityDay'
    date: string
    folders: Array<{
      __typename?: 'DrawingActivityFolder'
      id: string
      name: string
      resourceLink?: {
        __typename?: 'ResourceLink'
        id: string
        active: boolean
        slug: string
      } | null
      drawings: Array<{
        __typename?: 'DrawingActivityItem'
        id: string
        fileName: string
        drawingNumber?: string | null
        drawingRevision?: string | null
        title?: string | null
        documentFolderId?: string | null
        status: DrawingStatus
        type: DrawingWaitingReviewStatus
      }>
    }>
  }> | null
}

export type EmailLogAttributesFragment = {
  __typename?: 'EmailLog'
  id: string
  createdAt: string
  to: string
  type: EmailType
  status: EmailStatus
  subcontractor?: {
    __typename?: 'Subcontractor'
    company: { __typename?: 'Company'; name: string }
  } | null
  builder?: {
    __typename?: 'Builder'
    company: { __typename?: 'Company'; name: string }
  } | null
  project?: { __typename?: 'Project'; id: string; name: string } | null
  adminUser?: {
    __typename?: 'AdminUserEntity'
    user?: {
      __typename?: 'UserEntity'
      firstName?: string | null
      lastName?: string | null
    } | null
  } | null
}

export type EmailLogAttributesSubsetFragment = {
  __typename?: 'EmailLog'
  id: string
  createdAt: string
  to: string
  type: EmailType
  status: EmailStatus
  project?: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  } | null
  adminUser?: {
    __typename?: 'AdminUserEntity'
    id: string
    user?: {
      __typename?: 'UserEntity'
      firstName?: string | null
      lastName?: string | null
    } | null
  } | null
}

export type EmailLogsBySubcontractorUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type EmailLogsBySubcontractorUiQuery = {
  __typename?: 'Query'
  emailLogsBySubcontractor: Array<{
    __typename?: 'EmailLog'
    id: string
    createdAt: string
    to: string
    type: EmailType
    status: EmailStatus
    subcontractor?: {
      __typename?: 'Subcontractor'
      company: { __typename?: 'Company'; name: string }
    } | null
    builder?: {
      __typename?: 'Builder'
      company: { __typename?: 'Company'; name: string }
    } | null
    project?: { __typename?: 'Project'; id: string; name: string } | null
    adminUser?: {
      __typename?: 'AdminUserEntity'
      user?: {
        __typename?: 'UserEntity'
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  }>
}

export type EmailLogsBySubcontractorListUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type EmailLogsBySubcontractorListUiQuery = {
  __typename?: 'Query'
  emailLogsBySubcontractor: Array<{
    __typename?: 'EmailLog'
    id: string
    createdAt: string
    to: string
    type: EmailType
    status: EmailStatus
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null
    adminUser?: {
      __typename?: 'AdminUserEntity'
      id: string
      user?: {
        __typename?: 'UserEntity'
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  }>
}

export type EmailLogsByBuilderUiQueryVariables = Exact<{
  builderId: Scalars['String']
  filter?: InputMaybe<EmailLogFilterInput>
}>

export type EmailLogsByBuilderUiQuery = {
  __typename?: 'Query'
  emailLogsByBuilder: Array<{
    __typename?: 'EmailLog'
    id: string
    createdAt: string
    to: string
    type: EmailType
    status: EmailStatus
    subcontractor?: {
      __typename?: 'Subcontractor'
      company: { __typename?: 'Company'; name: string }
    } | null
    builder?: {
      __typename?: 'Builder'
      company: { __typename?: 'Company'; name: string }
    } | null
    project?: { __typename?: 'Project'; id: string; name: string } | null
    adminUser?: {
      __typename?: 'AdminUserEntity'
      user?: {
        __typename?: 'UserEntity'
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  }>
}

export type EmailLogsByBuilderListUiQueryVariables = Exact<{
  builderId: Scalars['String']
  filter?: InputMaybe<EmailLogFilterInput>
}>

export type EmailLogsByBuilderListUiQuery = {
  __typename?: 'Query'
  emailLogsByBuilder: Array<{
    __typename?: 'EmailLog'
    id: string
    createdAt: string
    to: string
    type: EmailType
    status: EmailStatus
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null
    adminUser?: {
      __typename?: 'AdminUserEntity'
      id: string
      user?: {
        __typename?: 'UserEntity'
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  }>
}

export type EmailLogsByProjectUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type EmailLogsByProjectUiQuery = {
  __typename?: 'Query'
  emailLogsByProject: Array<{
    __typename?: 'EmailLog'
    id: string
    createdAt: string
    to: string
    type: EmailType
    status: EmailStatus
    subcontractor?: {
      __typename?: 'Subcontractor'
      company: { __typename?: 'Company'; name: string }
    } | null
    builder?: {
      __typename?: 'Builder'
      company: { __typename?: 'Company'; name: string }
    } | null
    project?: { __typename?: 'Project'; id: string; name: string } | null
    adminUser?: {
      __typename?: 'AdminUserEntity'
      user?: {
        __typename?: 'UserEntity'
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  }>
}

export type EmergencyAttributesFragment = {
  __typename?: 'Emergency'
  id: string
  createdAt: string
  updatedAt: string
  resolvedAt?: string | null
  status: EmergencyStatus
  title: string
  description?: string | null
}

export type PublicEmergencyAttributesFragment = {
  __typename?: 'PublicEmergency'
  id: string
  createdAt: string
  resolvedAt?: string | null
  status: EmergencyStatus
  title: string
  description?: string | null
}

export type GetEmergenciesUiQueryVariables = Exact<{
  filter?: InputMaybe<EmergencyFilterInput>
}>

export type GetEmergenciesUiQuery = {
  __typename?: 'Query'
  emergencies: Array<{
    __typename?: 'Emergency'
    id: string
    createdAt: string
    updatedAt: string
    resolvedAt?: string | null
    status: EmergencyStatus
    title: string
    description?: string | null
    messages?: Array<{
      __typename?: 'EmergencyMessage'
      id: string
      status: EmergencyMessageStatus
    }> | null
  }>
}

export type GetEmergencyUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type GetEmergencyUiQuery = {
  __typename?: 'Query'
  emergency?: {
    __typename?: 'Emergency'
    id: string
    createdAt: string
    updatedAt: string
    resolvedAt?: string | null
    status: EmergencyStatus
    title: string
    description?: string | null
  } | null
}

export type GetEmergencyWithMessagesUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type GetEmergencyWithMessagesUiQuery = {
  __typename?: 'Query'
  emergency?: {
    __typename?: 'Emergency'
    id: string
    createdAt: string
    updatedAt: string
    resolvedAt?: string | null
    status: EmergencyStatus
    title: string
    description?: string | null
    messages?: Array<{
      __typename?: 'EmergencyMessage'
      id: string
      status: EmergencyMessageStatus
      slug: string
      acknowledgedBy?: EmergencyMessageAcknowledgedBy | null
      adminUser?: {
        __typename?: 'AdminUser'
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      worker?: {
        __typename?: 'Worker'
        id: string
        mobile?: string | null
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      visitor?: {
        __typename?: 'Visitor'
        id: string
        mobile?: string | null
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
    }> | null
  } | null
}

export type TriggerEmergencyUiMutationVariables = Exact<{
  input: CreateEmergencyInput
}>

export type TriggerEmergencyUiMutation = {
  __typename?: 'Mutation'
  createEmergency: { __typename?: 'Emergency'; id: string }
}

export type UpdateEmergencyUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateEmergencyInput
}>

export type UpdateEmergencyUiMutation = {
  __typename?: 'Mutation'
  updateEmergency: { __typename?: 'Emergency'; id: string }
}

export type GetEmergencyFromMessageUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type GetEmergencyFromMessageUiQuery = {
  __typename?: 'Query'
  publicEmergencyFromMessage?: {
    __typename?: 'PublicEmergencyWithMessage'
    emergency?: {
      __typename?: 'PublicEmergency'
      id: string
      createdAt: string
      resolvedAt?: string | null
      status: EmergencyStatus
      title: string
      description?: string | null
      project?: {
        __typename?: 'ProjectEntity'
        id: string
        name: string
      } | null
    } | null
    message?: {
      __typename?: 'PublicEmergencyMessage'
      id: string
      status: EmergencyMessageStatus
    } | null
  } | null
}

export type UpdateEmergencyMessageUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateEmergencyMessageInput
}>

export type UpdateEmergencyMessageUiMutation = {
  __typename?: 'Mutation'
  updateEmergencyMessage: { __typename?: 'EmergencyMessage'; id: string }
}

export type UpdateEmergencyMessageAsWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateEmergencyMessageAsWorkerInput
}>

export type UpdateEmergencyMessageAsWorkerUiMutation = {
  __typename?: 'Mutation'
  updateEmergencyMessageAsWorker: {
    __typename?: 'PublicEmergencyMessage'
    id: string
  }
}

export type ExtractTextUiQueryVariables = Exact<{
  key: Scalars['String']
  type: DocumentType
}>

export type ExtractTextUiQuery = {
  __typename?: 'Query'
  extractText: {
    __typename?: 'ExtractedText'
    blocks: Array<{
      __typename?: 'ExtractedBlock'
      BlockType: AnalyzedBlockType
      Confidence?: number | null
      Id: string
      Text?: string | null
      EntityTypes?: Array<BlockEntityType> | null
      Relationships?: Array<{
        __typename?: 'BlockRelationship'
        Type: BlockRelationshipType
        Ids: Array<string>
      }> | null
    } | null>
  }
}

export type SendFileUploadInviteEmailUiMutationVariables = Exact<{
  subcontractorId: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
  contactIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  customMessage?: InputMaybe<Scalars['String']>
  metadata?: InputMaybe<Scalars['JSON']>
}>

export type SendFileUploadInviteEmailUiMutation = {
  __typename?: 'Mutation'
  sendFileUploadInviteEmail: {
    __typename?: 'FileUploadInviteEmailSent'
    serviceResponse?: any | null
  }
}

export type WorkerSnapshotAttributesFragment = {
  __typename?: 'WorkerSnapshot'
  id?: string | null
  dob?: string | null
  trade?: string | null
  mobile?: string | null
  address?: string | null
  emergencyContact?: string | null
  emergencyContactNumber?: string | null
  emergencyContactRelationship?: string | null
  employmentStatus?: string | null
  medicalInformation?: string | null
  allergies?: string | null
  user?: {
    __typename?: 'WorkerUserSnapshot'
    id?: string | null
    email?: string | null
    firstName?: string | null
    lastName?: string | null
    userIdentity?: string | null
  } | null
  tickets?: Array<{
    __typename?: 'WorkerTicketSnapshot'
    id?: string | null
    expiry?: string | null
    number?: string | null
    obtained?: string | null
    builderGenerated?: boolean | null
    builderId?: string | null
    countryIssued?: string | null
    stateIssued?: string | null
    ticketTemplate?: {
      __typename?: 'WorkerTicketTemplateSnapshot'
      id?: string | null
      code?: string | null
      name?: string | null
      expiry?: boolean | null
      obtained?: boolean | null
      shortName?: string | null
      ticketTypeId?: string | null
      ticketCategoryId?: string | null
    } | null
    files?: Array<{
      __typename?: 'WorkerTicketFileSnapshot'
      id?: string | null
      file?: {
        __typename?: 'WorkerFileSnapshot'
        id?: string | null
        name?: string | null
        url?: string | null
        contentType?: string | null
      } | null
    } | null> | null
  } | null> | null
  subcontractors?: Array<{
    __typename?: 'WorkerSubcontractorSnapshot'
    id?: string | null
    name?: string | null
    email?: string | null
    builderId?: string | null
  } | null> | null
}

export type SiteInductionAttributesFragment = {
  __typename?: 'ProjectInduction'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  signatureUrl?: string | null
  evidenceSighted?: boolean | null
  templateName?: string | null
  type: InductionType
  status?: InductionStatus | null
  identifier?: number | null
  workerSnapshot?: {
    __typename?: 'WorkerSnapshot'
    id?: string | null
    dob?: string | null
    trade?: string | null
    mobile?: string | null
    address?: string | null
    emergencyContact?: string | null
    emergencyContactNumber?: string | null
    emergencyContactRelationship?: string | null
    employmentStatus?: string | null
    medicalInformation?: string | null
    allergies?: string | null
    user?: {
      __typename?: 'WorkerUserSnapshot'
      id?: string | null
      email?: string | null
      firstName?: string | null
      lastName?: string | null
      userIdentity?: string | null
    } | null
    tickets?: Array<{
      __typename?: 'WorkerTicketSnapshot'
      id?: string | null
      expiry?: string | null
      number?: string | null
      obtained?: string | null
      builderGenerated?: boolean | null
      builderId?: string | null
      countryIssued?: string | null
      stateIssued?: string | null
      ticketTemplate?: {
        __typename?: 'WorkerTicketTemplateSnapshot'
        id?: string | null
        code?: string | null
        name?: string | null
        expiry?: boolean | null
        obtained?: boolean | null
        shortName?: string | null
        ticketTypeId?: string | null
        ticketCategoryId?: string | null
      } | null
      files?: Array<{
        __typename?: 'WorkerTicketFileSnapshot'
        id?: string | null
        file?: {
          __typename?: 'WorkerFileSnapshot'
          id?: string | null
          name?: string | null
          url?: string | null
          contentType?: string | null
        } | null
      } | null> | null
    } | null> | null
    subcontractors?: Array<{
      __typename?: 'WorkerSubcontractorSnapshot'
      id?: string | null
      name?: string | null
      email?: string | null
      builderId?: string | null
    } | null> | null
  } | null
  templateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
  } | null
  project: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }
  worker: {
    __typename?: 'Worker'
    id: string
    mobile?: string | null
    builderGenerated: boolean
    trade?: string | null
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
    tickets?: Array<{
      __typename?: 'Ticket'
      id: string
      updatedAt: string
      latestReviewStatus?: TicketReviewStatus | null
      ticketTemplate: {
        __typename?: 'TicketTemplate'
        name: string
        shortName: string
      }
    } | null> | null
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
  }
  subcontractor?: {
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    company: { __typename?: 'Company'; id?: string | null; name: string }
  } | null
  documentSignatures: Array<{
    __typename?: 'DocumentSignature'
    id: string
    createdAt: string
    signatureUrl: string
    builderGenerated: boolean
    worker: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
    }
    adminUser?: {
      __typename?: 'AdminUserEntity'
      id: string
      user?: {
        __typename?: 'UserEntity'
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
    induction?:
      | {
          __typename?: 'BuilderInduction'
          id: string
          type: InductionType
          templateName?: string | null
        }
      | {
          __typename?: 'ProjectInduction'
          id: string
          type: InductionType
          templateName?: string | null
        }
      | null
    swmsDoc: {
      __typename?: 'SwmsDoc'
      id: string
      name: string
      subcontractorId: string
      projectId: string
      showAll?: boolean | null
      project: { __typename?: 'Project'; id: string; name: string }
    }
  } | null>
  currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
  versionHistory?: Array<{
    __typename?: 'VersionHistory'
    version: number
    induction?:
      | {
          __typename?: 'BuilderInduction'
          id: string
          status?: InductionStatus | null
          type: InductionType
          createdAt: string
          archivedAt?: string | null
        }
      | {
          __typename?: 'ProjectInduction'
          id: string
          status?: InductionStatus | null
          type: InductionType
          createdAt: string
          archivedAt?: string | null
        }
      | null
  }> | null
}

export type SiteInductionAttributesSubsetFragment = {
  __typename?: 'ProjectInduction'
  id: string
  createdAt: string
  type: InductionType
  status?: InductionStatus | null
  identifier?: number | null
  project: { __typename?: 'Project'; name: string }
  worker: {
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
    tickets?: Array<{
      __typename?: 'Ticket'
      ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
      reviews?: Array<{
        __typename?: 'TicketReview'
        reviewStatus: TicketReviewStatus
      } | null> | null
    } | null> | null
  }
  subcontractor?: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; id?: string | null; name: string }
  } | null
  currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
  versionHistory?: Array<{
    __typename?: 'VersionHistory'
    version: number
  }> | null
  templateResponse?: {
    __typename?: 'TemplateResponse'
    tableBlocks?: any | null
  } | null
}

export type CompanyInductionAttributesFragment = {
  __typename?: 'BuilderInduction'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  signatureUrl?: string | null
  evidenceSighted?: boolean | null
  templateName?: string | null
  type: InductionType
  status?: InductionStatus | null
  workerSnapshot?: {
    __typename?: 'WorkerSnapshot'
    id?: string | null
    dob?: string | null
    trade?: string | null
    mobile?: string | null
    address?: string | null
    emergencyContact?: string | null
    emergencyContactNumber?: string | null
    emergencyContactRelationship?: string | null
    employmentStatus?: string | null
    medicalInformation?: string | null
    allergies?: string | null
    user?: {
      __typename?: 'WorkerUserSnapshot'
      id?: string | null
      email?: string | null
      firstName?: string | null
      lastName?: string | null
      userIdentity?: string | null
    } | null
    tickets?: Array<{
      __typename?: 'WorkerTicketSnapshot'
      id?: string | null
      expiry?: string | null
      number?: string | null
      obtained?: string | null
      builderGenerated?: boolean | null
      builderId?: string | null
      countryIssued?: string | null
      stateIssued?: string | null
      ticketTemplate?: {
        __typename?: 'WorkerTicketTemplateSnapshot'
        id?: string | null
        code?: string | null
        name?: string | null
        expiry?: boolean | null
        obtained?: boolean | null
        shortName?: string | null
        ticketTypeId?: string | null
        ticketCategoryId?: string | null
      } | null
      files?: Array<{
        __typename?: 'WorkerTicketFileSnapshot'
        id?: string | null
        file?: {
          __typename?: 'WorkerFileSnapshot'
          id?: string | null
          name?: string | null
          url?: string | null
          contentType?: string | null
        } | null
      } | null> | null
    } | null> | null
    subcontractors?: Array<{
      __typename?: 'WorkerSubcontractorSnapshot'
      id?: string | null
      name?: string | null
      email?: string | null
      builderId?: string | null
    } | null> | null
  } | null
  templateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
  } | null
  worker: {
    __typename?: 'Worker'
    id: string
    mobile?: string | null
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
    tickets?: Array<{
      __typename?: 'Ticket'
      updatedAt: string
      ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
      reviews?: Array<{
        __typename?: 'TicketReview'
        reviewStatus: TicketReviewStatus
      } | null> | null
    } | null> | null
  }
  subcontractor?: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
  } | null
  documentSignatures: Array<{
    __typename?: 'DocumentSignature'
    id: string
    createdAt: string
    signatureUrl: string
    builderGenerated: boolean
    worker: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
    }
    adminUser?: {
      __typename?: 'AdminUserEntity'
      id: string
      user?: {
        __typename?: 'UserEntity'
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
    induction?:
      | {
          __typename?: 'BuilderInduction'
          id: string
          type: InductionType
          templateName?: string | null
        }
      | {
          __typename?: 'ProjectInduction'
          id: string
          type: InductionType
          templateName?: string | null
        }
      | null
    swmsDoc: {
      __typename?: 'SwmsDoc'
      id: string
      name: string
      subcontractorId: string
      projectId: string
      showAll?: boolean | null
      project: { __typename?: 'Project'; id: string; name: string }
    }
  } | null>
  currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
  versionHistory?: Array<{
    __typename?: 'VersionHistory'
    version: number
    induction?:
      | {
          __typename?: 'BuilderInduction'
          id: string
          status?: InductionStatus | null
          type: InductionType
          createdAt: string
          archivedAt?: string | null
        }
      | {
          __typename?: 'ProjectInduction'
          id: string
          status?: InductionStatus | null
          type: InductionType
          createdAt: string
          archivedAt?: string | null
        }
      | null
  }> | null
}

export type CompanyInductionAttributesSubsetFragment = {
  __typename?: 'BuilderInduction'
  id: string
  createdAt: string
  type: InductionType
  status?: InductionStatus | null
  worker: {
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
    tickets?: Array<{
      __typename?: 'Ticket'
      ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
      reviews?: Array<{
        __typename?: 'TicketReview'
        reviewStatus: TicketReviewStatus
      } | null> | null
    } | null> | null
  }
  subcontractor?: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
  } | null
  currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
  versionHistory?: Array<{
    __typename?: 'VersionHistory'
    version: number
  }> | null
}

export type CompanyInductionsListUiQueryVariables = Exact<{
  builderId: Scalars['String']
  filter?: InputMaybe<BuilderInductionFilterInput>
  sort?: InputMaybe<InductionSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type CompanyInductionsListUiQuery = {
  __typename?: 'Query'
  builderInductions: Array<{
    __typename?: 'BuilderInduction'
    id: string
    createdAt: string
    type: InductionType
    status?: InductionStatus | null
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
      tickets?: Array<{
        __typename?: 'Ticket'
        ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
        reviews?: Array<{
          __typename?: 'TicketReview'
          reviewStatus: TicketReviewStatus
        } | null> | null
      } | null> | null
    }
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
    }> | null
  }>
  builderInductionsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type CompanyInductionsUiQueryVariables = Exact<{
  builderId: Scalars['String']
  filter?: InputMaybe<BuilderInductionFilterInput>
}>

export type CompanyInductionsUiQuery = {
  __typename?: 'Query'
  builderInductions: Array<{
    __typename?: 'BuilderInduction'
    id: string
    createdAt: string
    status?: InductionStatus | null
    worker: {
      __typename?: 'Worker'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    subcontractor?: {
      __typename?: 'Subcontractor'
      company: { __typename?: 'Company'; name: string }
    } | null
  }>
}

export type CompanyInductionUiQueryVariables = Exact<{
  inductionId: Scalars['String']
}>

export type CompanyInductionUiQuery = {
  __typename?: 'Query'
  builderInduction?: {
    __typename?: 'BuilderInduction'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    signatureUrl?: string | null
    evidenceSighted?: boolean | null
    templateName?: string | null
    type: InductionType
    status?: InductionStatus | null
    workerSnapshot?: {
      __typename?: 'WorkerSnapshot'
      id?: string | null
      dob?: string | null
      trade?: string | null
      mobile?: string | null
      address?: string | null
      emergencyContact?: string | null
      emergencyContactNumber?: string | null
      emergencyContactRelationship?: string | null
      employmentStatus?: string | null
      medicalInformation?: string | null
      allergies?: string | null
      user?: {
        __typename?: 'WorkerUserSnapshot'
        id?: string | null
        email?: string | null
        firstName?: string | null
        lastName?: string | null
        userIdentity?: string | null
      } | null
      tickets?: Array<{
        __typename?: 'WorkerTicketSnapshot'
        id?: string | null
        expiry?: string | null
        number?: string | null
        obtained?: string | null
        builderGenerated?: boolean | null
        builderId?: string | null
        countryIssued?: string | null
        stateIssued?: string | null
        ticketTemplate?: {
          __typename?: 'WorkerTicketTemplateSnapshot'
          id?: string | null
          code?: string | null
          name?: string | null
          expiry?: boolean | null
          obtained?: boolean | null
          shortName?: string | null
          ticketTypeId?: string | null
          ticketCategoryId?: string | null
        } | null
        files?: Array<{
          __typename?: 'WorkerTicketFileSnapshot'
          id?: string | null
          file?: {
            __typename?: 'WorkerFileSnapshot'
            id?: string | null
            name?: string | null
            url?: string | null
            contentType?: string | null
          } | null
        } | null> | null
      } | null> | null
      subcontractors?: Array<{
        __typename?: 'WorkerSubcontractorSnapshot'
        id?: string | null
        name?: string | null
        email?: string | null
        builderId?: string | null
      } | null> | null
    } | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    worker: {
      __typename?: 'Worker'
      id: string
      mobile?: string | null
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
      tickets?: Array<{
        __typename?: 'Ticket'
        updatedAt: string
        ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
        reviews?: Array<{
          __typename?: 'TicketReview'
          reviewStatus: TicketReviewStatus
        } | null> | null
      } | null> | null
    }
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            status?: InductionStatus | null
            type: InductionType
            createdAt: string
            archivedAt?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            status?: InductionStatus | null
            type: InductionType
            createdAt: string
            archivedAt?: string | null
          }
        | null
    }> | null
  } | null
}

export type SiteInductionsListUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<InductionFilterInput>
  sort?: InputMaybe<InductionSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type SiteInductionsListUiQuery = {
  __typename?: 'Query'
  projectInductions: Array<{
    __typename?: 'ProjectInduction'
    id: string
    createdAt: string
    type: InductionType
    status?: InductionStatus | null
    identifier?: number | null
    project: { __typename?: 'Project'; name: string }
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
      tickets?: Array<{
        __typename?: 'Ticket'
        ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
        reviews?: Array<{
          __typename?: 'TicketReview'
          reviewStatus: TicketReviewStatus
        } | null> | null
      } | null> | null
    }
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; id?: string | null; name: string }
    } | null
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
    }> | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      tableBlocks?: any | null
    } | null
  }>
  projectInductionsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SiteInductionsUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<InductionFilterInput>
}>

export type SiteInductionsUiQuery = {
  __typename?: 'Query'
  projectInductions: Array<{
    __typename?: 'ProjectInduction'
    id: string
    identifier?: number | null
    createdAt: string
    status?: InductionStatus | null
    worker: {
      __typename?: 'Worker'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    subcontractor?: {
      __typename?: 'Subcontractor'
      company: { __typename?: 'Company'; name: string }
    } | null
  }>
}

export type SiteInductionsForSearchUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<InductionFilterInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type SiteInductionsForSearchUiQuery = {
  __typename?: 'Query'
  projectInductions: Array<{
    __typename?: 'ProjectInduction'
    id: string
    createdAt: string
    identifier?: number | null
    status?: InductionStatus | null
    worker: {
      __typename?: 'Worker'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
  }>
}

export type SiteInductionUiQueryVariables = Exact<{
  inductionId: Scalars['String']
}>

export type SiteInductionUiQuery = {
  __typename?: 'Query'
  projectInduction?: {
    __typename?: 'ProjectInduction'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    signatureUrl?: string | null
    evidenceSighted?: boolean | null
    templateName?: string | null
    type: InductionType
    status?: InductionStatus | null
    identifier?: number | null
    workerSnapshot?: {
      __typename?: 'WorkerSnapshot'
      id?: string | null
      dob?: string | null
      trade?: string | null
      mobile?: string | null
      address?: string | null
      emergencyContact?: string | null
      emergencyContactNumber?: string | null
      emergencyContactRelationship?: string | null
      employmentStatus?: string | null
      medicalInformation?: string | null
      allergies?: string | null
      user?: {
        __typename?: 'WorkerUserSnapshot'
        id?: string | null
        email?: string | null
        firstName?: string | null
        lastName?: string | null
        userIdentity?: string | null
      } | null
      tickets?: Array<{
        __typename?: 'WorkerTicketSnapshot'
        id?: string | null
        expiry?: string | null
        number?: string | null
        obtained?: string | null
        builderGenerated?: boolean | null
        builderId?: string | null
        countryIssued?: string | null
        stateIssued?: string | null
        ticketTemplate?: {
          __typename?: 'WorkerTicketTemplateSnapshot'
          id?: string | null
          code?: string | null
          name?: string | null
          expiry?: boolean | null
          obtained?: boolean | null
          shortName?: string | null
          ticketTypeId?: string | null
          ticketCategoryId?: string | null
        } | null
        files?: Array<{
          __typename?: 'WorkerTicketFileSnapshot'
          id?: string | null
          file?: {
            __typename?: 'WorkerFileSnapshot'
            id?: string | null
            name?: string | null
            url?: string | null
            contentType?: string | null
          } | null
        } | null> | null
      } | null> | null
      subcontractors?: Array<{
        __typename?: 'WorkerSubcontractorSnapshot'
        id?: string | null
        name?: string | null
        email?: string | null
        builderId?: string | null
      } | null> | null
    } | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
    worker: {
      __typename?: 'Worker'
      id: string
      mobile?: string | null
      builderGenerated: boolean
      trade?: string | null
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
      tickets?: Array<{
        __typename?: 'Ticket'
        id: string
        updatedAt: string
        latestReviewStatus?: TicketReviewStatus | null
        ticketTemplate: {
          __typename?: 'TicketTemplate'
          name: string
          shortName: string
        }
      } | null> | null
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; id?: string | null; name: string }
    } | null
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            status?: InductionStatus | null
            type: InductionType
            createdAt: string
            archivedAt?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            status?: InductionStatus | null
            type: InductionType
            createdAt: string
            archivedAt?: string | null
          }
        | null
    }> | null
  } | null
}

export type SiteInductionByIdentifierUiQueryVariables = Exact<{
  projectId: Scalars['String']
  inductionIdentifier: Scalars['Int']
}>

export type SiteInductionByIdentifierUiQuery = {
  __typename?: 'Query'
  projectInductionByIdentifier?: {
    __typename?: 'ProjectInduction'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    signatureUrl?: string | null
    evidenceSighted?: boolean | null
    templateName?: string | null
    type: InductionType
    status?: InductionStatus | null
    identifier?: number | null
    workerSnapshot?: {
      __typename?: 'WorkerSnapshot'
      id?: string | null
      dob?: string | null
      trade?: string | null
      mobile?: string | null
      address?: string | null
      emergencyContact?: string | null
      emergencyContactNumber?: string | null
      emergencyContactRelationship?: string | null
      employmentStatus?: string | null
      medicalInformation?: string | null
      allergies?: string | null
      user?: {
        __typename?: 'WorkerUserSnapshot'
        id?: string | null
        email?: string | null
        firstName?: string | null
        lastName?: string | null
        userIdentity?: string | null
      } | null
      tickets?: Array<{
        __typename?: 'WorkerTicketSnapshot'
        id?: string | null
        expiry?: string | null
        number?: string | null
        obtained?: string | null
        builderGenerated?: boolean | null
        builderId?: string | null
        countryIssued?: string | null
        stateIssued?: string | null
        ticketTemplate?: {
          __typename?: 'WorkerTicketTemplateSnapshot'
          id?: string | null
          code?: string | null
          name?: string | null
          expiry?: boolean | null
          obtained?: boolean | null
          shortName?: string | null
          ticketTypeId?: string | null
          ticketCategoryId?: string | null
        } | null
        files?: Array<{
          __typename?: 'WorkerTicketFileSnapshot'
          id?: string | null
          file?: {
            __typename?: 'WorkerFileSnapshot'
            id?: string | null
            name?: string | null
            url?: string | null
            contentType?: string | null
          } | null
        } | null> | null
      } | null> | null
      subcontractors?: Array<{
        __typename?: 'WorkerSubcontractorSnapshot'
        id?: string | null
        name?: string | null
        email?: string | null
        builderId?: string | null
      } | null> | null
    } | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
    worker: {
      __typename?: 'Worker'
      id: string
      mobile?: string | null
      builderGenerated: boolean
      trade?: string | null
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
      tickets?: Array<{
        __typename?: 'Ticket'
        id: string
        updatedAt: string
        latestReviewStatus?: TicketReviewStatus | null
        ticketTemplate: {
          __typename?: 'TicketTemplate'
          name: string
          shortName: string
        }
      } | null> | null
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; id?: string | null; name: string }
    } | null
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            status?: InductionStatus | null
            type: InductionType
            createdAt: string
            archivedAt?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            status?: InductionStatus | null
            type: InductionType
            createdAt: string
            archivedAt?: string | null
          }
        | null
    }> | null
  } | null
}

export type SiteInductionByIdentifierPublicUiQueryVariables = Exact<{
  projectId: Scalars['String']
  inductionIdentifier: Scalars['Int']
}>

export type SiteInductionByIdentifierPublicUiQuery = {
  __typename?: 'Query'
  projectInductionByIdentifier_public?: {
    __typename?: 'ProjectInduction_Public'
    workerId: string
    firstName: string
    lastName: string
    status: InductionStatus
    signedOnAt?: string | null
  } | null
}

export type SiteInductionByWorkerPublicUiQueryVariables = Exact<{
  projectId: Scalars['String']
  workerId: Scalars['String']
}>

export type SiteInductionByWorkerPublicUiQuery = {
  __typename?: 'Query'
  projectInductionByWorker_public?: {
    __typename?: 'ProjectInduction_Public'
    workerId: string
    firstName: string
    lastName: string
    status: InductionStatus
    signedOnAt?: string | null
  } | null
}

export type UpdateInductionStatusUiMutationVariables = Exact<{
  id: Scalars['String']
  status: InductionStatus
  evidenceSighted?: InputMaybe<Scalars['Boolean']>
  updateTicketStatus?: InputMaybe<Scalars['Boolean']>
}>

export type UpdateInductionStatusUiMutation = {
  __typename?: 'Mutation'
  updateInduction:
    | {
        __typename?: 'BuilderInduction'
        id: string
        status?: InductionStatus | null
        evidenceSighted?: boolean | null
      }
    | {
        __typename?: 'ProjectInduction'
        id: string
        status?: InductionStatus | null
        evidenceSighted?: boolean | null
      }
}

export type SendInductionUpdateEmailUiMutationVariables = Exact<{
  inductionId: Scalars['String']
  customMessage?: InputMaybe<Scalars['String']>
}>

export type SendInductionUpdateEmailUiMutation = {
  __typename?: 'Mutation'
  sendInductionUpdateEmail: {
    __typename?: 'EmailSent'
    serviceResponse?: any | null
  }
}

export type SendBulkInductionUpdateEmailAdminUiMutationVariables = Exact<{
  input: SendBulkInductionUpdateEmailsInputAdmin
}>

export type SendBulkInductionUpdateEmailAdminUiMutation = {
  __typename?: 'Mutation'
  sendBulkInductionUpdateEmails_admin: Array<string>
}

export type CreateInductionUiMutationVariables = Exact<{
  input: CreateInductionInput
}>

export type CreateInductionUiMutation = {
  __typename?: 'Mutation'
  createInduction:
    | { __typename?: 'BuilderInduction'; id: string }
    | {
        __typename?: 'ProjectInduction'
        identifier?: number | null
        id: string
      }
}

export type CreateInductionInviteUiMutationVariables = Exact<{
  subcontractorId: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
}>

export type CreateInductionInviteUiMutation = {
  __typename?: 'Mutation'
  createInductionInvite: {
    __typename?: 'InductionInvite'
    id: string
    metadata?: any | null
  }
}

export type CreateInductionInvitesUiMutationVariables = Exact<{
  subcontractorIds: Array<Scalars['String']> | Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
}>

export type CreateInductionInvitesUiMutation = {
  __typename?: 'Mutation'
  createInductionInvites: Array<{
    __typename?: 'InductionInvite'
    id: string
    metadata?: any | null
    batchId?: string | null
  }>
}

export type SendInductionInviteEmailUiMutationVariables = Exact<{
  subcontractorId: Scalars['String']
  contactIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  projectId: Scalars['String']
  inviteId: Scalars['String']
  customMessage?: InputMaybe<Scalars['String']>
}>

export type SendInductionInviteEmailUiMutation = {
  __typename?: 'Mutation'
  sendInductionInviteEmail: {
    __typename?: 'InductionInviteEmailSent'
    serviceResponse?: any | null
  }
}

export type ArchiveInductionUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveInductionUiMutation = {
  __typename?: 'Mutation'
  archiveInduction:
    | { __typename?: 'BuilderInduction'; id: string }
    | { __typename?: 'ProjectInduction'; id: string }
}

export type RestoreInductionUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreInductionUiMutation = {
  __typename?: 'Mutation'
  restoreInduction:
    | { __typename?: 'BuilderInduction'; id: string }
    | { __typename?: 'ProjectInduction'; id: string }
}

export type SiteInductionForWorkerUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type SiteInductionForWorkerUiQuery = {
  __typename?: 'Query'
  projectInductionForWorker?: {
    __typename?: 'WorkerProjectInduction'
    id: string
    identifier?: number | null
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    templateName?: string | null
    type: InductionType
    status?: InductionStatus | null
    signatureUrl?: string | null
    templateResponse?: {
      __typename?: 'WorkerProjectInduction_TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    project: {
      __typename?: 'WorkerProjectInduction_Project'
      id: string
      name: string
    }
  } | null
}

export type SiteInductionByWorkerUiQueryVariables = Exact<{
  projectId: Scalars['String']
  workerId: Scalars['String']
}>

export type SiteInductionByWorkerUiQuery = {
  __typename?: 'Query'
  projectInductionByWorker?: {
    __typename?: 'ProjectInduction'
    identifier?: number | null
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    type: InductionType
    status?: InductionStatus | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      company: { __typename?: 'Company'; name: string }
    } | null
  } | null
}

export type InsuranceAttributesFragment = {
  __typename?: 'InsuranceDoc'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  name: string
  status: InsuranceStatus
  url: string
  expiry?: string | null
  type?: InsuranceType | null
  typeOther?: string | null
  subcontractor: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
    } | null> | null
  }
  builder: {
    __typename?: 'Builder'
    id: string
    company: { __typename?: 'Company'; name: string }
  }
  currentVersion: { __typename?: 'VersionHistory'; version: number }
  versionHistory?: Array<{
    __typename?: 'VersionHistory'
    version: number
    insuranceDoc?: {
      __typename?: 'InsuranceDoc'
      id: string
      name: string
      status: InsuranceStatus
      expiry?: string | null
      createdAt: string
      archivedAt?: string | null
    } | null
  }> | null
}

export type InsuranceAttributesSubsetFragment = {
  __typename?: 'InsuranceDoc'
  id: string
  createdAt: string
  name: string
  status: InsuranceStatus
  expiry?: string | null
  type?: InsuranceType | null
  subcontractor: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      email?: string | null
      isPrimaryContact: boolean
    } | null> | null
  }
}

export type CreateInsuranceDocUiMutationVariables = Exact<{
  status: InsuranceStatus
  key: Scalars['String']
  name: Scalars['String']
  type: InsuranceType
  typeOther?: InputMaybe<Scalars['String']>
  expiry?: InputMaybe<Scalars['DateTime']>
  subcontractorId: Scalars['String']
}>

export type CreateInsuranceDocUiMutation = {
  __typename?: 'Mutation'
  createInsuranceDoc: {
    __typename?: 'InsuranceDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    status: InsuranceStatus
    url: string
    expiry?: string | null
    type?: InsuranceType | null
    typeOther?: string | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      insuranceDoc?: {
        __typename?: 'InsuranceDoc'
        id: string
        name: string
        status: InsuranceStatus
        expiry?: string | null
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type InsuranceDocsUiQueryVariables = Exact<{
  filter?: InputMaybe<InsuranceFilterInput>
}>

export type InsuranceDocsUiQuery = {
  __typename?: 'Query'
  insuranceDocs: Array<{
    __typename?: 'InsuranceDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    status: InsuranceStatus
    url: string
    expiry?: string | null
    type?: InsuranceType | null
    typeOther?: string | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      insuranceDoc?: {
        __typename?: 'InsuranceDoc'
        id: string
        name: string
        status: InsuranceStatus
        expiry?: string | null
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }>
}

export type InsuranceDocsListUiQueryVariables = Exact<{
  filter?: InputMaybe<InsuranceFilterInput>
  sort?: InputMaybe<InsuranceSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type InsuranceDocsListUiQuery = {
  __typename?: 'Query'
  insuranceDocs: Array<{
    __typename?: 'InsuranceDoc'
    id: string
    createdAt: string
    name: string
    status: InsuranceStatus
    expiry?: string | null
    type?: InsuranceType | null
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
    }> | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        email?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
  }>
  insuranceDocsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type InsuranceDocUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type InsuranceDocUiQuery = {
  __typename?: 'Query'
  insuranceDoc?: {
    __typename?: 'InsuranceDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    status: InsuranceStatus
    url: string
    expiry?: string | null
    type?: InsuranceType | null
    typeOther?: string | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      insuranceDoc?: {
        __typename?: 'InsuranceDoc'
        id: string
        name: string
        status: InsuranceStatus
        expiry?: string | null
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  } | null
}

export type UpdateInsuranceDocUiMutationVariables = Exact<{
  id: Scalars['String']
  name: Scalars['String']
  type: InsuranceType
  typeOther?: InputMaybe<Scalars['String']>
  status: InsuranceStatus
  expiry?: InputMaybe<Scalars['DateTime']>
  key?: InputMaybe<Scalars['String']>
}>

export type UpdateInsuranceDocUiMutation = {
  __typename?: 'Mutation'
  updateInsuranceDoc: {
    __typename?: 'InsuranceDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    status: InsuranceStatus
    url: string
    expiry?: string | null
    type?: InsuranceType | null
    typeOther?: string | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      insuranceDoc?: {
        __typename?: 'InsuranceDoc'
        id: string
        name: string
        status: InsuranceStatus
        expiry?: string | null
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type UpdateInsuranceDocStatusUiMutationVariables = Exact<{
  id: Scalars['String']
  status: InsuranceStatus
}>

export type UpdateInsuranceDocStatusUiMutation = {
  __typename?: 'Mutation'
  updateInsuranceDoc: {
    __typename?: 'InsuranceDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    status: InsuranceStatus
    url: string
    expiry?: string | null
    type?: InsuranceType | null
    typeOther?: string | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      insuranceDoc?: {
        __typename?: 'InsuranceDoc'
        id: string
        name: string
        status: InsuranceStatus
        expiry?: string | null
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type ArchiveInsuranceDocUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveInsuranceDocUiMutation = {
  __typename?: 'Mutation'
  archiveInsuranceDoc: { __typename?: 'InsuranceDoc'; id: string }
}

export type BulkArchiveInsuranceDocsUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkArchiveInsuranceDocsUiMutation = {
  __typename?: 'Mutation'
  bulkArchiveInsuranceDocs: Array<string>
}

export type BulkRestoreInsuranceDocsUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkRestoreInsuranceDocsUiMutation = {
  __typename?: 'Mutation'
  bulkRestoreInsuranceDocs: Array<string>
}

export type GetIntegrationConnectionForProjectUiQueryVariables = Exact<{
  integrationType: IntegrationType
  projectId: Scalars['String']
}>

export type GetIntegrationConnectionForProjectUiQuery = {
  __typename?: 'Query'
  integrationConnectionForProject?: {
    __typename?: 'IntegrationConnection'
    id: string
    integration: {
      __typename?: 'Integration'
      id: string
      integrationType: IntegrationType
    }
  } | null
}

export type CreateIntegrationConnectionUiMutationVariables = Exact<{
  integrationIdentifier: Scalars['String']
  integrationId: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
  subcontractorId?: InputMaybe<Scalars['String']>
}>

export type CreateIntegrationConnectionUiMutation = {
  __typename?: 'Mutation'
  createIntegrationConnection: {
    __typename?: 'IntegrationConnection'
    id: string
  }
}

export type CreateIntegrationConnectionsInBulkUiMutationVariables = Exact<{
  integrationId: Scalars['String']
  integrations: Array<InputMaybe<RelationPair>> | InputMaybe<RelationPair>
}>

export type CreateIntegrationConnectionsInBulkUiMutation = {
  __typename?: 'Mutation'
  createIntegrationConnectionsInBulk: Array<{
    __typename?: 'IntegrationConnection'
    id: string
  } | null>
}

export type DeleteIntegrationConnectionUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteIntegrationConnectionUiMutation = {
  __typename?: 'Mutation'
  deleteIntegrationConnection: {
    __typename?: 'IntegrationConnection'
    id: string
  }
}

export type DeleteIntegrationConnectionsInBulkUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type DeleteIntegrationConnectionsInBulkUiMutation = {
  __typename?: 'Mutation'
  deleteIntegrationConnectionsInBulk: Array<string>
}

export type PublishIntegrationConnectionDocumentUiMutationVariables = Exact<{
  type: IntegrationType
  documentId: Scalars['String']
  integrationIdentifier: Scalars['String']
}>

export type PublishIntegrationConnectionDocumentUiMutation = {
  __typename?: 'Mutation'
  publishIntegrationConnectionDocument: {
    __typename?: 'DocumentUpload'
    fileName?: string | null
    fileUrl?: string | null
    container?: string | null
  }
}

export type SyncIntegrationConnectionUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type SyncIntegrationConnectionUiMutation = {
  __typename?: 'Mutation'
  syncIntegrationConnection: {
    __typename?: 'IntegrationConnection'
    id: string
  }
}

export type SyncIntegrationConnectionsUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type SyncIntegrationConnectionsUiMutation = {
  __typename?: 'Mutation'
  syncIntegrationConnections: {
    __typename?: 'BulkSyncResult'
    ids: Array<string>
  }
}

export type AgaveProjectAttributesFragment = {
  __typename?: 'AgaveProject'
  id: string
  integrationId: string
  sourceId: string
  sourceUrl?: string | null
  name: string
  description?: string | null
  logoUrl?: string | null
  startDate?: string | null
  completionDate?: string | null
  address?: string | null
  status: AgaveProjectStatus
  integrationConnection?: {
    __typename?: 'IntegrationConnection'
    id: string
    project?: { __typename?: 'Project'; id: string; name: string } | null
  } | null
}

export type GetIntegrationsQueryVariables = Exact<{ [key: string]: never }>

export type GetIntegrationsQuery = {
  __typename?: 'Query'
  integrations: Array<{
    __typename?: 'Integration'
    id: string
    integrationType: IntegrationType
    integrationData?: any | null
  }>
}

export type GetIntegrationByTypeUiQueryVariables = Exact<{
  integrationType: IntegrationType
}>

export type GetIntegrationByTypeUiQuery = {
  __typename?: 'Query'
  integrationByType?: {
    __typename?: 'Integration'
    id: string
    createdAt: string
    integrationType: IntegrationType
    integrationData?: any | null
  } | null
}

export type CreateIntegrationMutationVariables = Exact<{
  integrationType: IntegrationType
  integrationIdentifier: Scalars['String']
  integrationData?: InputMaybe<Scalars['JSON']>
  integrationSecrets?: InputMaybe<Scalars['JSON']>
}>

export type CreateIntegrationMutation = {
  __typename?: 'Mutation'
  createIntegration: { __typename?: 'Integration'; id: string }
}

export type DeleteIntegrationMutationVariables = Exact<{
  integrationId: Scalars['String']
}>

export type DeleteIntegrationMutation = {
  __typename?: 'Mutation'
  deleteIntegration: { __typename?: 'Integration'; id: string }
}

export type GetIntegrationDataQueryVariables = Exact<{
  type: IntegrationType
  action: IntegrationActions
}>

export type GetIntegrationDataQuery = {
  __typename?: 'Query'
  getIntegrationData?: any | null
  projects: Array<{
    __typename?: 'Project'
    id: string
    name: string
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }>
}

export type GetIntegrationLogsUiQueryVariables = Exact<{
  id: Scalars['String']
  filter?: InputMaybe<IntegrationLogFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<IntegrationLogSortInput>
}>

export type GetIntegrationLogsUiQuery = {
  __typename?: 'Query'
  integrationLogs: Array<{
    __typename?: 'IntegrationLog'
    id: string
    createdAt: string
    status: IntegrationLogStatus
    action: IntegrationLogAction
    resource?: IntegrationLogResource | null
    resourceIdentity?: string | null
    internal: boolean
    integration: {
      __typename?: 'Integration'
      id: string
      integrationType: IntegrationType
    }
    integrationConnection?: {
      __typename?: 'IntegrationConnection'
      id: string
      project?: { __typename?: 'Project'; id: string; name: string } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null
    adminUser?: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }>
  integrationLogsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type CreateAgaveLinkTokenUiQueryVariables = Exact<{
  [key: string]: never
}>

export type CreateAgaveLinkTokenUiQuery = {
  __typename?: 'Query'
  createAgaveLinkToken: {
    __typename?: 'AgaveLinkTokenResponse'
    linkToken?: string | null
  }
}

export type ConnectAgaveAccountUiMutationVariables = Exact<{
  input: ConnectAgaveAccountInput
}>

export type ConnectAgaveAccountUiMutation = {
  __typename?: 'Mutation'
  connectAgaveAccount: {
    __typename?: 'AgaveAccountStatus'
    connected: boolean
    setup: boolean
  }
}

export type AgaveAccountStatusUiQueryVariables = Exact<{
  integrationType: IntegrationType
}>

export type AgaveAccountStatusUiQuery = {
  __typename?: 'Query'
  agaveAccountStatus: {
    __typename?: 'AgaveAccountStatus'
    connected: boolean
    setup: boolean
  }
}

export type AgaveProjectsUiQueryVariables = Exact<{
  input: QueryAgaveProjectsInput
  pagination?: InputMaybe<AgavePaginationInput>
  filter?: InputMaybe<AgaveProjectFilterInput>
}>

export type AgaveProjectsUiQuery = {
  __typename?: 'Query'
  agaveProjectsPaged: {
    __typename?: 'AgaveProjectsPagedResponse'
    projects: Array<{
      __typename?: 'AgaveProject'
      id: string
      integrationId: string
      sourceId: string
      sourceUrl?: string | null
      name: string
      description?: string | null
      logoUrl?: string | null
      startDate?: string | null
      completionDate?: string | null
      address?: string | null
      status: AgaveProjectStatus
      integrationConnection?: {
        __typename?: 'IntegrationConnection'
        id: string
        project?: { __typename?: 'Project'; id: string; name: string } | null
      } | null
    }>
    meta: {
      __typename?: 'AgavePagedMeta'
      hasMoreResults: boolean
      currentPage: number
      pageSize: number
    }
  }
}

export type AgaveVendorsUiQueryVariables = Exact<{
  input: QueryAgaveVendorsInput
  pagination?: InputMaybe<AgavePaginationInput>
  filter?: InputMaybe<AgaveVendorFilterInput>
}>

export type AgaveVendorsUiQuery = {
  __typename?: 'Query'
  agaveVendorsPaged: {
    __typename?: 'AgaveVendorsPagedResponse'
    vendors: Array<{
      __typename?: 'AgaveVendor'
      id: string
      integrationId: string
      sourceId: string
      sourceUrl?: string | null
      name: string
      email?: string | null
      phone?: string | null
      abn?: string | null
      integrationConnection?: {
        __typename?: 'IntegrationConnection'
        id: string
        subcontractor?: {
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null
      } | null
    }>
    meta: {
      __typename?: 'AgavePagedMeta'
      hasMoreResults: boolean
      currentPage: number
      pageSize: number
    }
  }
}

export type SyncAgaveVendorsUiMutationVariables = Exact<{
  input: SyncAgaveVendorsInput
}>

export type SyncAgaveVendorsUiMutation = {
  __typename?: 'Mutation'
  syncAgaveVendors: {
    __typename?: 'SyncAgaveVendorsResponse'
    ids: Array<string>
  }
}

export type SyncAgaveProjectsUiMutationVariables = Exact<{
  input: SyncAgaveProjectsInput
}>

export type SyncAgaveProjectsUiMutation = {
  __typename?: 'Mutation'
  syncAgaveProjects: {
    __typename?: 'SyncAgaveProjectsResponse'
    ids: Array<string>
  }
}

export type ConnectBuildxactAccountUiMutationVariables = Exact<{
  input: ConnectBuildxactAccountInput
}>

export type ConnectBuildxactAccountUiMutation = {
  __typename?: 'Mutation'
  connectBuildxactAccount: {
    __typename?: 'BuildxactAccountStatus'
    connected: boolean
    setup: boolean
  }
}

export type SetupBuildxactAccessTokenUiMutationVariables = Exact<{
  input: SetupBuildxactAccessTokenInput
}>

export type SetupBuildxactAccessTokenUiMutation = {
  __typename?: 'Mutation'
  setupBuildxactAccessToken: {
    __typename?: 'BuildxactAccountStatus'
    connected: boolean
    setup: boolean
  }
}

export type BuildxactProjectAttributesFragment = {
  __typename?: 'BuildxactProject'
  id: string
  integrationId: string
  name: string
  description?: string | null
  address?: string | null
  status: string
  jobUrl?: string | null
  integrationConnection?: {
    __typename?: 'IntegrationConnection'
    id: string
    project?: { __typename?: 'Project'; id: string; name: string } | null
  } | null
}

export type GetBuildxactProjectsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type GetBuildxactProjectsUiQuery = {
  __typename?: 'Query'
  getBuildxactProjects: Array<{
    __typename?: 'BuildxactProject'
    id: string
    integrationId: string
    name: string
    description?: string | null
    address?: string | null
    status: string
    jobUrl?: string | null
    integrationConnection?: {
      __typename?: 'IntegrationConnection'
      id: string
      project?: { __typename?: 'Project'; id: string; name: string } | null
    } | null
  }>
}

export type GetBuildxactProjectsPaginatedUiQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>
}>

export type GetBuildxactProjectsPaginatedUiQuery = {
  __typename?: 'Query'
  getBuildxactProjectsPaginated: {
    __typename?: 'BuildxactProjectsPaginatedResponse'
    projects: Array<{
      __typename?: 'BuildxactProject'
      id: string
      integrationId: string
      name: string
      description?: string | null
      address?: string | null
      status: string
      jobUrl?: string | null
      integrationConnection?: {
        __typename?: 'IntegrationConnection'
        id: string
        project?: { __typename?: 'Project'; id: string; name: string } | null
      } | null
    }>
    pagination: {
      __typename?: 'PaginationAggregation'
      totalCount?: number | null
      totalPages?: number | null
      offset?: number | null
      limit?: number | null
    }
  }
}

export type ConnectBuildxactProjectsUiMutationVariables = Exact<{
  input: ConnectBuildxactProjectsInput
}>

export type ConnectBuildxactProjectsUiMutation = {
  __typename?: 'Mutation'
  connectBuildxactProjects: {
    __typename?: 'ConnectBuildxactProjectsResponse'
    ids: Array<string>
  }
}

export type ConnectBuildxactContactsUiMutationVariables = Exact<{
  input: ConnectBuildxactContactsInput
}>

export type ConnectBuildxactContactsUiMutation = {
  __typename?: 'Mutation'
  connectBuildxactContacts: {
    __typename?: 'ConnectBuildxactContactsResponse'
    ids: Array<string>
  }
}

export type SendFileToBuildxactUiMutationVariables = Exact<{
  input: SendFileToBuildxactInput
}>

export type SendFileToBuildxactUiMutation = {
  __typename?: 'Mutation'
  sendFileToBuildxact: {
    __typename?: 'SendFileToBuildxactResponse'
    success: boolean
    message?: string | null
  }
}

export type GetBuildxactContactsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type GetBuildxactContactsUiQuery = {
  __typename?: 'Query'
  getBuildxactContacts: Array<{
    __typename?: 'BuildxactContact'
    id: string
    integrationId: string
    abn?: string | null
    businessName: string
    contactName?: string | null
    email?: string | null
    address?: string | null
    contactUrl?: string | null
    integrationConnection?: {
      __typename?: 'IntegrationConnection'
      id: string
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null
  }>
}

export type GetBuildxactContactsPaginatedUiQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>
}>

export type GetBuildxactContactsPaginatedUiQuery = {
  __typename?: 'Query'
  getBuildxactContactsPaginated: {
    __typename?: 'BuildxactContactsPaginatedResponse'
    contacts: Array<{
      __typename?: 'BuildxactContact'
      id: string
      integrationId: string
      abn?: string | null
      businessName: string
      contactName?: string | null
      email?: string | null
      address?: string | null
      contactUrl?: string | null
      integrationConnection?: {
        __typename?: 'IntegrationConnection'
        id: string
        subcontractor?: {
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null
      } | null
    }>
    pagination: {
      __typename?: 'PaginationAggregation'
      totalCount?: number | null
      totalPages?: number | null
      offset?: number | null
      limit?: number | null
    }
  }
}

export type ConnectPremierAccountUiMutationVariables = Exact<{
  input: ConnectPremierAccountInput
}>

export type ConnectPremierAccountUiMutation = {
  __typename?: 'Mutation'
  connectPremierAccount: {
    __typename?: 'PremierAccountStatus'
    connected: boolean
    setup: boolean
  }
}

export type PremierCompanyAttributesFragment = {
  __typename?: 'PremierCompany'
  id: string
  code: string
  name: string
  active: boolean
}

export type GetPremierCompaniesUiQueryVariables = Exact<{
  [key: string]: never
}>

export type GetPremierCompaniesUiQuery = {
  __typename?: 'Query'
  getPremierCompanies: Array<{
    __typename?: 'PremierCompany'
    id: string
    code: string
    name: string
    active: boolean
  }>
}

export type SetPremierCompanyAsPrimaryUiMutationVariables = Exact<{
  input: SetPremierCompanyAsPrimaryInput
}>

export type SetPremierCompanyAsPrimaryUiMutation = {
  __typename?: 'Mutation'
  setPremierCompanyAsPrimary: boolean
}

export type PremierJobAttributesFragment = {
  __typename?: 'PremierJob'
  id: string
  integrationId: string
  name: string
  description?: string | null
  address?: string | null
  status: string
  jobUrl?: string | null
  subledgerCode?: string | null
  integrationConnection?: {
    __typename?: 'IntegrationConnection'
    id: string
    project?: { __typename?: 'Project'; id: string; name: string } | null
  } | null
}

export type GetPremierJobsUiQueryVariables = Exact<{
  companyId: Scalars['String']
  search?: InputMaybe<Scalars['String']>
}>

export type GetPremierJobsUiQuery = {
  __typename?: 'Query'
  getPremierJobs: Array<{
    __typename?: 'PremierJob'
    id: string
    integrationId: string
    name: string
    description?: string | null
    address?: string | null
    status: string
    jobUrl?: string | null
    subledgerCode?: string | null
    integrationConnection?: {
      __typename?: 'IntegrationConnection'
      id: string
      project?: { __typename?: 'Project'; id: string; name: string } | null
    } | null
  }>
}

export type GetAvailableProjectsForPremierUiQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAvailableProjectsForPremierUiQuery = {
  __typename?: 'Query'
  getAvailableProjectsForPremier: Array<{
    __typename?: 'Project'
    id: string
    name: string
  }>
}

export type ConnectPremierJobsUiMutationVariables = Exact<{
  input: ConnectPremierJobsInput
}>

export type ConnectPremierJobsUiMutation = {
  __typename?: 'Mutation'
  connectPremierJobs: {
    __typename?: 'ConnectPremierJobsResponse'
    ids: Array<string>
  }
}

export type PremierVendorAttributesFragment = {
  __typename?: 'PremierVendor'
  id: string
  integrationId: string
  abn?: string | null
  businessName: string
  contactName?: string | null
  email?: string | null
  address?: string | null
  vendorUrl?: string | null
  subledgerCode?: string | null
  integrationConnection?: {
    __typename?: 'IntegrationConnection'
    id: string
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
  } | null
}

export type GetPremierVendorsUiQueryVariables = Exact<{
  companyId: Scalars['String']
  search?: InputMaybe<Scalars['String']>
}>

export type GetPremierVendorsUiQuery = {
  __typename?: 'Query'
  getPremierVendors: Array<{
    __typename?: 'PremierVendor'
    id: string
    integrationId: string
    abn?: string | null
    businessName: string
    contactName?: string | null
    email?: string | null
    address?: string | null
    vendorUrl?: string | null
    subledgerCode?: string | null
    integrationConnection?: {
      __typename?: 'IntegrationConnection'
      id: string
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null
  }>
}

export type GetAvailableVendorsForPremierUiQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAvailableVendorsForPremierUiQuery = {
  __typename?: 'Query'
  getAvailableVendorsForPremier: Array<{
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
  }>
}

export type ConnectPremierVendorsUiMutationVariables = Exact<{
  input: ConnectPremierVendorsInput
}>

export type ConnectPremierVendorsUiMutation = {
  __typename?: 'Mutation'
  connectPremierVendors: {
    __typename?: 'ConnectPremierVendorsResponse'
    ids: Array<string>
  }
}

export type AccessControlIntegrationConnectionFragment = {
  __typename?: 'AccessControl_IntegrationConnection'
  id: string
  createdAt: string
  updatedAt: string
  integrationIdentifier: string
  projectAccess?: Array<{
    __typename?: 'AccessControlProjectAccess'
    createdAt: string
    access: AccessControlAccess
    project: { __typename?: 'Project'; id: string; name: string }
  } | null> | null
  worker?: {
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null
}

export type AccessControlIntegrationConnectionByWorkerIdUiQueryVariables =
  Exact<{
    workerId: Scalars['String']
  }>

export type AccessControlIntegrationConnectionByWorkerIdUiQuery = {
  __typename?: 'Query'
  accessControlIntegrationConnectionByWorkerId?: {
    __typename?: 'AccessControl_IntegrationConnection'
    id: string
    createdAt: string
    updatedAt: string
    integrationIdentifier: string
    projectAccess?: Array<{
      __typename?: 'AccessControlProjectAccess'
      createdAt: string
      access: AccessControlAccess
      project: { __typename?: 'Project'; id: string; name: string }
    } | null> | null
    worker?: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  } | null
}

export type CreateAccessControlIntegrationConnectionUiMutationVariables =
  Exact<{
    input: CreateAccessControlIntegrationConnectionInput
  }>

export type CreateAccessControlIntegrationConnectionUiMutation = {
  __typename?: 'Mutation'
  createAccessControlIntegrationConnection:
    | { __typename?: 'AccessControl_IntegrationConnection'; id: string }
    | {
        __typename?: 'AccessControl_IntegrationConnection_Error'
        message: string
      }
}

export type UpdateAccessControlIntegrationConnectionUiMutationVariables =
  Exact<{
    id: Scalars['String']
    input: UpdateAccessControlIntegrationConnectionInput
  }>

export type UpdateAccessControlIntegrationConnectionUiMutation = {
  __typename?: 'Mutation'
  updateAccessControlIntegrationConnection:
    | {
        __typename?: 'AccessControl_IntegrationConnection'
        id: string
        createdAt: string
        updatedAt: string
        integrationIdentifier: string
        projectAccess?: Array<{
          __typename?: 'AccessControlProjectAccess'
          createdAt: string
          access: AccessControlAccess
          project: { __typename?: 'Project'; id: string; name: string }
        } | null> | null
        worker?: {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        } | null
      }
    | { __typename?: 'AccessControl_IntegrationConnection_Error' }
}

export type RemoveProjectAccessFromAccessControlIntegrationConnectionUiMutationVariables =
  Exact<{
    id: Scalars['String']
    projectId: Scalars['String']
  }>

export type RemoveProjectAccessFromAccessControlIntegrationConnectionUiMutation =
  {
    __typename?: 'Mutation'
    removeProjectAccessFromAccessControlIntegrationConnection: {
      __typename?: 'AccessControl_IntegrationConnection'
      id: string
      createdAt: string
      updatedAt: string
      integrationIdentifier: string
      projectAccess?: Array<{
        __typename?: 'AccessControlProjectAccess'
        createdAt: string
        access: AccessControlAccess
        project: { __typename?: 'Project'; id: string; name: string }
      } | null> | null
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    }
  }

export type DeleteAccessControlIntegrationConnectionUiMutationVariables =
  Exact<{
    id: Scalars['String']
  }>

export type DeleteAccessControlIntegrationConnectionUiMutation = {
  __typename?: 'Mutation'
  deleteAccessControlIntegrationConnection: {
    __typename?: 'AccessControl_IntegrationConnection'
    id: string
  }
}

export type UpdateProjectAccessForAccessControlIntegrationConnectionUiMutationVariables =
  Exact<{
    id: Scalars['String']
    projectId: Scalars['String']
    access: AccessControlAccess
  }>

export type UpdateProjectAccessForAccessControlIntegrationConnectionUiMutation =
  {
    __typename?: 'Mutation'
    updateProjectAccessForAccessControlIntegrationConnection: {
      __typename?: 'AccessControl_IntegrationConnection'
      id: string
      createdAt: string
      updatedAt: string
      integrationIdentifier: string
      projectAccess?: Array<{
        __typename?: 'AccessControlProjectAccess'
        createdAt: string
        access: AccessControlAccess
        project: { __typename?: 'Project'; id: string; name: string }
      } | null> | null
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    }
  }

export type GenerateProjectQrCodeUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type GenerateProjectQrCodeUiQuery = {
  __typename?: 'Query'
  generateCodeForProject_admin:
    | {
        __typename?: 'CodeForProject_Disabled'
        message: string
        project: {
          __typename?: 'Project'
          id: string
          name: string
          status: ProjectStatus
          address?: string | null
          builder?: {
            __typename?: 'Builder'
            logoUrl?: string | null
            company: { __typename?: 'Company'; name: string }
          } | null
        }
      }
    | {
        __typename?: 'CodeForProject_Success'
        code: string
        interval?: number | null
        nextRefresh?: string | null
        project: {
          __typename?: 'Project'
          id: string
          name: string
          status: ProjectStatus
          address?: string | null
          builder?: {
            __typename?: 'Builder'
            logoUrl?: string | null
            company: { __typename?: 'Company'; name: string }
          } | null
        }
      }
}

export type ProjectLocationUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type ProjectLocationUiQuery = {
  __typename?: 'Query'
  projectLocation?: {
    __typename?: 'ProjectLocation'
    createdAt: string
    updatedAt: string
    defectsCount: number
    checklistsCount: number
    itpsCount: number
    platformActionsCount: number
    permitsCount: number
    id: string
    name: string
    order: number
    children?: Array<{
      __typename?: 'ProjectLocation'
      id: string
      name: string
    }> | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      url: string
      fileName: string
    }> | null
    parent?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  } | null
}

export type ProjectLocationPublicUiQueryVariables = Exact<{
  id: Scalars['String']
  slug?: InputMaybe<Scalars['String']>
}>

export type ProjectLocationPublicUiQuery = {
  __typename?: 'Query'
  projectLocation_public?: {
    __typename?: 'ProjectLocation_Public'
    id: string
    name: string
    order: number
    children?: Array<{
      __typename?: 'ProjectLocation_Public'
      id: string
      name: string
      order: number
      children?: Array<{
        __typename?: 'ProjectLocation_Public'
        id: string
        name: string
        order: number
        children?: Array<{
          __typename?: 'ProjectLocation_Public'
          id: string
          name: string
          order: number
          children?: Array<{
            __typename?: 'ProjectLocation_Public'
            id: string
            name: string
            order: number
            children?: Array<{
              __typename?: 'ProjectLocation_Public'
              id: string
              name: string
              order: number
              children?: Array<{
                __typename?: 'ProjectLocation_Public'
                id: string
                name: string
                order: number
                children?: Array<{
                  __typename?: 'ProjectLocation_Public'
                  id: string
                  name: string
                  order: number
                  children?: Array<{
                    __typename?: 'ProjectLocation_Public'
                    id: string
                    name: string
                    order: number
                    children?: Array<{
                      __typename?: 'ProjectLocation_Public'
                      id: string
                      name: string
                      order: number
                    }> | null
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  } | null
}

export type CloneProjectLocationUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type CloneProjectLocationUiMutation = {
  __typename?: 'Mutation'
  cloneProjectLocation: {
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    children?: Array<{
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      children?: Array<{
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        children?: Array<{
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          children?: Array<{
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            children?: Array<{
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              children?: Array<{
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                children?: Array<{
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  children?: Array<{
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    children?: Array<{
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                    }> | null
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  }
}

export type CloneProjectLocationsUiMutationVariables = Exact<{
  input: CloneProjectLocationsInput
}>

export type CloneProjectLocationsUiMutation = {
  __typename?: 'Mutation'
  cloneProjectLocations: Array<{
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    children?: Array<{
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      children?: Array<{
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        children?: Array<{
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          children?: Array<{
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            children?: Array<{
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              children?: Array<{
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                children?: Array<{
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  children?: Array<{
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    children?: Array<{
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                    }> | null
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  }>
}

export type MsdsAttributesFragment = {
  __typename?: 'MsdsDoc'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  reviewDate?: string | null
  name: string
  status: MsdsStatus
  url: string
  checklistTemplateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
    completedAt?: string | null
    createdAt: string
  } | null
  subcontractor: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
    } | null> | null
  }
  projects: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    sdsChecklistTemplate?: {
      __typename?: 'Template'
      id: string
      templateData?: any | null
    } | null
  } | null>
  builder: {
    __typename?: 'Builder'
    id: string
    company: { __typename?: 'Company'; name: string }
  }
  currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
  versionHistory?: Array<{
    __typename?: 'VersionHistory'
    version: number
    msdsDoc?: {
      __typename?: 'MsdsDoc'
      id: string
      name: string
      status: MsdsStatus
      createdAt: string
      archivedAt?: string | null
    } | null
  }> | null
}

export type MsdsAttributesSubsetFragment = {
  __typename?: 'MsdsDoc'
  id: string
  createdAt: string
  name: string
  status: MsdsStatus
  reviewDate?: string | null
  projects: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  } | null>
  subcontractor: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
    } | null> | null
  }
}

export type CreateMsdsDocUiMutationVariables = Exact<{
  input: CreateMsdsDocInput
}>

export type CreateMsdsDocUiMutation = {
  __typename?: 'Mutation'
  createMsdsDoc: {
    __typename?: 'MsdsDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    reviewDate?: string | null
    name: string
    status: MsdsStatus
    url: string
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      createdAt: string
    } | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      sdsChecklistTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
    } | null>
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      msdsDoc?: {
        __typename?: 'MsdsDoc'
        id: string
        name: string
        status: MsdsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type MsdsDocsUiQueryVariables = Exact<{
  filter?: InputMaybe<MsdsFilterInput>
}>

export type MsdsDocsUiQuery = {
  __typename?: 'Query'
  msdsDocs: Array<{
    __typename?: 'MsdsDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    reviewDate?: string | null
    name: string
    status: MsdsStatus
    url: string
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      createdAt: string
    } | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      sdsChecklistTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
    } | null>
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      msdsDoc?: {
        __typename?: 'MsdsDoc'
        id: string
        name: string
        status: MsdsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }>
}

export type MsdsDocsListUiQueryVariables = Exact<{
  filter?: InputMaybe<MsdsFilterInput>
  sort?: InputMaybe<MsdsSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type MsdsDocsListUiQuery = {
  __typename?: 'Query'
  msdsDocs: Array<{
    __typename?: 'MsdsDoc'
    id: string
    createdAt: string
    name: string
    status: MsdsStatus
    reviewDate?: string | null
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
    }> | null
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
  }>
  msdsDocsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type MsdsDocUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type MsdsDocUiQuery = {
  __typename?: 'Query'
  msdsDoc?: {
    __typename?: 'MsdsDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    reviewDate?: string | null
    name: string
    status: MsdsStatus
    url: string
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      createdAt: string
    } | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      sdsChecklistTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
    } | null>
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      msdsDoc?: {
        __typename?: 'MsdsDoc'
        id: string
        name: string
        status: MsdsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  } | null
}

export type UpdateMsdsDocUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateMsdsDocInput
}>

export type UpdateMsdsDocUiMutation = {
  __typename?: 'Mutation'
  updateMsdsDoc: {
    __typename?: 'MsdsDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    reviewDate?: string | null
    name: string
    status: MsdsStatus
    url: string
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      createdAt: string
    } | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      sdsChecklistTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
    } | null>
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      msdsDoc?: {
        __typename?: 'MsdsDoc'
        id: string
        name: string
        status: MsdsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type UpdateMsdsDocStatusUiMutationVariables = Exact<{
  id: Scalars['String']
  status?: InputMaybe<MsdsStatus>
}>

export type UpdateMsdsDocStatusUiMutation = {
  __typename?: 'Mutation'
  updateMsdsDoc: {
    __typename?: 'MsdsDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    reviewDate?: string | null
    name: string
    status: MsdsStatus
    url: string
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      createdAt: string
    } | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      sdsChecklistTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
    } | null>
    builder: {
      __typename?: 'Builder'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      msdsDoc?: {
        __typename?: 'MsdsDoc'
        id: string
        name: string
        status: MsdsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type DeleteMsdsDocUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteMsdsDocUiMutation = {
  __typename?: 'Mutation'
  deleteMsdsDoc: { __typename?: 'MsdsDoc'; id: string }
}

export type ArchiveMsdsDocUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveMsdsDocUiMutation = {
  __typename?: 'Mutation'
  archiveMsdsDoc: { __typename?: 'MsdsDoc'; id: string }
}

export type BulkArchiveMsdsDocsUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkArchiveMsdsDocsUiMutation = {
  __typename?: 'Mutation'
  bulkArchiveMsdsDocs: Array<string>
}

export type BulkRestoreMsdsDocsUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkRestoreMsdsDocsUiMutation = {
  __typename?: 'Mutation'
  bulkRestoreMsdsDocs: Array<string>
}

export type MsdsDocEntityAttributesFragment = {
  __typename?: 'MsdsDocEntity'
  id: string
  url: string
  name: string
}

export type MsdsDocForWorkerUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type MsdsDocForWorkerUiQuery = {
  __typename?: 'Query'
  msdsDocForWorker?: {
    __typename?: 'MsdsDocEntity'
    id: string
    url: string
    name: string
  } | null
}

export type GeneratePdfUiMutationVariables = Exact<{
  input: PdfGenerationInput
}>

export type GeneratePdfUiMutation = {
  __typename?: 'Mutation'
  generatePDF: {
    __typename?: 'PDFResponse'
    key?: string | null
    url?: string | null
    viewUrl?: string | null
  }
}

export type GenerateMultiEntityPdfUiMutationVariables = Exact<{
  input: MultiPdfGenerationInput
}>

export type GenerateMultiEntityPdfUiMutation = {
  __typename?: 'Mutation'
  generateMultiEntityPDF: {
    __typename?: 'PDFResponse'
    key?: string | null
    url?: string | null
    viewUrl?: string | null
  }
}

export type GeneratePublicDefectsPdfUiMutationVariables = Exact<{
  input: PublicDefectsPdfGenerationInput
}>

export type GeneratePublicDefectsPdfUiMutation = {
  __typename?: 'Mutation'
  generatePublicDefectsPDF: {
    __typename?: 'PDFResponse'
    key?: string | null
    url?: string | null
    viewUrl?: string | null
  }
}

export type GenerateListPdfUiMutationVariables = Exact<{
  input: ListPdfGenerationInput
}>

export type GenerateListPdfUiMutation = {
  __typename?: 'Mutation'
  generateListPDF: {
    __typename?: 'PDFResponse'
    key?: string | null
    url?: string | null
    viewUrl?: string | null
  }
}

export type ProjectPerformancesUiQueryVariables = Exact<{
  [key: string]: never
}>

export type ProjectPerformancesUiQuery = {
  __typename?: 'Query'
  projectPerformances: Array<{
    __typename?: 'ProjectPerformance'
    overallStatus: PerformanceIndicatorStatus
    projectDetails: {
      __typename?: 'Project'
      id: string
      name: string
      projectAdmins: Array<{
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
    }
    performanceIndicators: Array<{
      __typename?: 'PerformanceIndicator'
      name: string
      target: number
      progress: number
      percentage: number
      status: PerformanceIndicatorStatus
    }>
  }>
}

export type RolesAttributesFragment = {
  __typename?: 'Role'
  id: string
  createdAt: string
  updatedAt?: string | null
  builderId?: string | null
  auth0Identifier?: string | null
  name: string
  description?: string | null
  countOfUsers: number
  permissions: Array<{
    __typename?: 'Permission'
    id: string
    action: PermissionAction
    resource: string
  }>
}

export type PermissionsByRoleUiQueryVariables = Exact<{
  roleId: Scalars['String']
}>

export type PermissionsByRoleUiQuery = {
  __typename?: 'Query'
  permissionsByRole: Array<{
    __typename?: 'Permission'
    id: string
    action: PermissionAction
    resource: string
  }>
}

export type CreateRoleUiMutationVariables = Exact<{
  input: CreateRoleInput
}>

export type CreateRoleUiMutation = {
  __typename?: 'Mutation'
  createRole: {
    __typename?: 'Role'
    id: string
    createdAt: string
    updatedAt?: string | null
    builderId?: string | null
    auth0Identifier?: string | null
    name: string
    description?: string | null
    countOfUsers: number
    permissions: Array<{
      __typename?: 'Permission'
      id: string
      action: PermissionAction
      resource: string
    }>
  }
}

export type UpdateRolePermissionsUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateRolePermissionsInput
}>

export type UpdateRolePermissionsUiMutation = {
  __typename?: 'Mutation'
  updateRolePermissions: {
    __typename?: 'Role'
    id: string
    createdAt: string
    updatedAt?: string | null
    builderId?: string | null
    auth0Identifier?: string | null
    name: string
    description?: string | null
    countOfUsers: number
    permissions: Array<{
      __typename?: 'Permission'
      id: string
      action: PermissionAction
      resource: string
    }>
  }
}

export type PermitTypeAttributesFragment = {
  __typename?: 'PermitType_Admin'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  name: string
  identifierPrefix: string
  maxDays?: number | null
}

export type PermitTypeAttributesWorkerFragment = {
  __typename?: 'PermitType_Worker'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  name: string
  identifierPrefix: string
  maxDays?: number | null
}

export type PermitTypesListUiQueryVariables = Exact<{
  filter?: InputMaybe<PermitTypeFilterInputAdmin>
  sort?: InputMaybe<PermitTypeSortInputAdmin>
  pagination?: InputMaybe<PaginationInput>
}>

export type PermitTypesListUiQuery = {
  __typename?: 'Query'
  permitTypes_admin: Array<{
    __typename?: 'PermitType_Admin'
    applicationTemplateId?: string | null
    enactingTemplateId?: string | null
    closeoutTemplateId?: string | null
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    identifierPrefix: string
    maxDays?: number | null
  }>
  permitTypesAggregation_admin: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type PermitTypesForSearchUiQueryVariables = Exact<{
  [key: string]: never
}>

export type PermitTypesForSearchUiQuery = {
  __typename?: 'Query'
  permitTypes_admin: Array<{
    __typename?: 'PermitType_Admin'
    id: string
    name: string
    identifierPrefix: string
  }>
}

export type PermitTypesForSearchWorkerUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type PermitTypesForSearchWorkerUiQuery = {
  __typename?: 'Query'
  permitTypes_worker: Array<{
    __typename?: 'PermitType_Worker'
    id: string
    name: string
    identifierPrefix: string
  }>
}

export type PermitTypeUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PermitTypeUiQuery = {
  __typename?: 'Query'
  permitType_admin?: {
    __typename?: 'PermitType_Admin'
    applicationTemplateId?: string | null
    enactingTemplateId?: string | null
    closeoutTemplateId?: string | null
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    identifierPrefix: string
    maxDays?: number | null
  } | null
}

export type PermitTypeWithApplicationTemplateUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PermitTypeWithApplicationTemplateUiQuery = {
  __typename?: 'Query'
  permitType_admin?: {
    __typename?: 'PermitType_Admin'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    identifierPrefix: string
    maxDays?: number | null
    applicationTemplate?: {
      __typename?: 'Template'
      id: string
      templateData?: any | null
    } | null
  } | null
}

export type PermitTypeWithApplicationTemplateWorkerUiQueryVariables = Exact<{
  permitTypeId: Scalars['String']
  projectId: Scalars['String']
}>

export type PermitTypeWithApplicationTemplateWorkerUiQuery = {
  __typename?: 'Query'
  permitType_worker?: {
    __typename?: 'PermitType_Worker'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    identifierPrefix: string
    maxDays?: number | null
    applicationTemplate?: {
      __typename?: 'TemplateEntity'
      id: string
      templateData?: any | null
    } | null
  } | null
}

export type CreatePermitTypeUiMutationVariables = Exact<{
  input: CreatePermitTypeInputAdmin
}>

export type CreatePermitTypeUiMutation = {
  __typename?: 'Mutation'
  createPermitType_admin: { __typename?: 'PermitType_Admin'; id: string }
}

export type UpdatePermitTypeUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdatePermitTypeInputAdmin
}>

export type UpdatePermitTypeUiMutation = {
  __typename?: 'Mutation'
  updatePermitType_admin: { __typename?: 'PermitType_Admin'; id: string }
}

export type ArchivePermitTypeUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchivePermitTypeUiMutation = {
  __typename?: 'Mutation'
  archivePermitType_admin: { __typename?: 'PermitType_Admin'; id: string }
}

export type RestorePermitTypeUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestorePermitTypeUiMutation = {
  __typename?: 'Mutation'
  restorePermitType_admin: { __typename?: 'PermitType_Admin'; id: string }
}

export type CreatePermitTypeTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
  type: PermitTypeTemplate
}>

export type CreatePermitTypeTemplateUiMutation = {
  __typename?: 'Mutation'
  createPermitTypeTemplate_admin: { __typename?: 'Template'; id: string }
}

export type DeletePermitTypeTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
  type: PermitTypeTemplate
}>

export type DeletePermitTypeTemplateUiMutation = {
  __typename?: 'Mutation'
  deletePermitTypeTemplate_admin: {
    __typename?: 'PermitType_Admin'
    id: string
  }
}

export type TransferPermitTypeUiMutationVariables = Exact<{
  permitType: TransferPermitTypeInputAdmin
  builderId: Scalars['String']
}>

export type TransferPermitTypeUiMutation = {
  __typename?: 'Mutation'
  transferPermitType_admin: string
}

export type PermitWorkerAttributesFragment = {
  __typename?: 'PermitWorker_Admin'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  approvedAt?: string | null
  closedOutAt?: string | null
  suspendedAt?: string | null
  status: PermitStatus
  activeStatus: PermitActiveStatus
  overallStatus: OverallPermitStatus
  worker?: {
    __typename?: 'Worker'
    id: string
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
    }
  } | null
  applicationTemplateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
    updatedAt: string
  } | null
  enactingTemplateResponses?: Array<{
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    responseData?: any | null
  }> | null
  closeoutTemplateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
  } | null
}

export type PermitAttributesFragment = {
  __typename?: 'Permit_Admin'
  id: string
  createdAt: string
  updatedAt: string
  identifier: number
  name?: string | null
  description?: string | null
  startDate: string
  endDate: string
  projectLocationId?: string | null
  workers?: Array<{
    __typename?: 'PermitWorker_Admin'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    approvedAt?: string | null
    closedOutAt?: string | null
    suspendedAt?: string | null
    status: PermitStatus
    activeStatus: PermitActiveStatus
    overallStatus: OverallPermitStatus
    worker?: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    applicationTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      updatedAt: string
    } | null
    enactingTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
      createdAt: string
      responseData?: any | null
    }> | null
    closeoutTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
  }> | null
  project: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  }
}

export type PermitWorkerAttributesWorkerFragment = {
  __typename?: 'PermitWorker_Worker'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  approvedAt?: string | null
  closedOutAt?: string | null
  suspendedAt?: string | null
  status: PermitStatus
  activeStatus: PermitActiveStatus
  overallStatus: OverallPermitStatus
  worker: {
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
  }
  applicationTemplateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
  } | null
  enactingTemplateResponses?: Array<{
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    responseData?: any | null
  }> | null
  closeoutTemplateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
  } | null
}

export type PermitAttributesWorkerFragment = {
  __typename?: 'Permit_Worker'
  id: string
  createdAt: string
  updatedAt: string
  identifier: number
  name?: string | null
  description?: string | null
  startDate: string
  endDate: string
  overallStatus: OverallPermitStatus
  permitWorker: {
    __typename?: 'PermitWorker_Worker'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    approvedAt?: string | null
    closedOutAt?: string | null
    suspendedAt?: string | null
    status: PermitStatus
    activeStatus: PermitActiveStatus
    overallStatus: OverallPermitStatus
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    applicationTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    enactingTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
      createdAt: string
      responseData?: any | null
    }> | null
    closeoutTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
  }
  permitWorkers: Array<{
    __typename?: 'PermitWorker_Worker'
    id: string
    status: PermitStatus
    activeStatus: PermitActiveStatus
    overallStatus: OverallPermitStatus
    archivedAt?: string | null
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
  }>
  project: {
    __typename?: 'Project_ResourceLink'
    id: string
    name: string
    status: ProjectStatus
  }
  conversation?: {
    __typename?: 'ConversationThread_ResourceLink'
    id: string
    messages?: Array<{
      __typename?: 'ConversationMessage_ResourceLink'
      id: string
      createdAt: string
      content?: string | null
      sender: {
        __typename?: 'Assignee_ResourceLink'
        id: string
        worker?: {
          __typename?: 'Worker_ResourceLink'
          id: string
          user: {
            __typename?: 'User_ResourceLink'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        adminUser?: {
          __typename?: 'AdminUser_ResourceLink'
          id: string
          user: {
            __typename?: 'User_ResourceLink'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        subcontractor?: {
          __typename?: 'Subcontractor_ResourceLink'
          id: string
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
      }
      attachments?: Array<{
        __typename?: 'Attachment_ResourceLink'
        id: string
        url: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      }> | null
    }> | null
  } | null
  permitType: {
    __typename?: 'PermitType_Worker'
    id: string
    name: string
    maxDays?: number | null
    applicationTemplate?: {
      __typename?: 'TemplateEntity'
      id: string
      templateData?: any | null
    } | null
    enactingTemplate?: {
      __typename?: 'TemplateEntity'
      id: string
      templateData?: any | null
    } | null
    closeoutTemplate?: {
      __typename?: 'TemplateEntity'
      id: string
      templateData?: any | null
    } | null
  }
}

export type PermitListAdminUiQueryVariables = Exact<{
  filter?: InputMaybe<PermitFilterInput>
  sort?: InputMaybe<PermitSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type PermitListAdminUiQuery = {
  __typename?: 'Query'
  permits_admin?: Array<{
    __typename?: 'Permit_Admin'
    id: string
    identifier: number
    name?: string | null
    description?: string | null
    startDate: string
    endDate: string
    archivedAt?: string | null
    overallStatus: OverallPermitStatus
    workers?: Array<{
      __typename?: 'PermitWorker_Admin'
      id: string
      status: PermitStatus
      activeStatus: PermitActiveStatus
      overallStatus: OverallPermitStatus
      archivedAt?: string | null
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    }> | null
  }> | null
  permitAggregation_admin: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type PermitAdminUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PermitAdminUiQuery = {
  __typename?: 'Query'
  permit_admin?: {
    __typename?: 'Permit_Admin'
    overallStatus: OverallPermitStatus
    id: string
    createdAt: string
    updatedAt: string
    identifier: number
    name?: string | null
    description?: string | null
    startDate: string
    endDate: string
    projectLocationId?: string | null
    conversation?: {
      __typename?: 'ConversationThread'
      id: string
      messages: Array<{
        __typename?: 'ConversationMessage'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee'
          id: string
          worker?: {
            __typename?: 'Worker'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser'
            id: string
            user: {
              __typename?: 'User'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor'
            id: string
            company: { __typename?: 'Company'; name: string }
          } | null
        }
        attachments: Array<{
          __typename?: 'Attachment'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null>
      } | null>
    } | null
    permitType: {
      __typename?: 'PermitType_Admin'
      name: string
      maxDays?: number | null
      applicationTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
      enactingTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
      closeoutTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
    }
    createdBy?: {
      __typename?: 'Assignee'
      id: string
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null
    workers?: Array<{
      __typename?: 'PermitWorker_Admin'
      id: string
      createdAt: string
      updatedAt: string
      archivedAt?: string | null
      approvedAt?: string | null
      closedOutAt?: string | null
      suspendedAt?: string | null
      status: PermitStatus
      activeStatus: PermitActiveStatus
      overallStatus: OverallPermitStatus
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      applicationTemplateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
        updatedAt: string
      } | null
      enactingTemplateResponses?: Array<{
        __typename?: 'TemplateResponse'
        id: string
        createdAt: string
        responseData?: any | null
      }> | null
      closeoutTemplateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
      } | null
    }> | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
  } | null
  knockMessageLogs_admin: Array<{
    __typename?: 'KnockMessageLog_Admin'
    id: string
    logDate: string
    status: KnockMessageStatus
    messageId: string
    sentTo: {
      __typename?: 'KnockMessageLogUser_admin'
      id: string
      name: string
    }
  }>
}

export type PermitsForDashboardAdminUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type PermitsForDashboardAdminUiQuery = {
  __typename?: 'Query'
  permitsForDashboard_admin: Array<{
    __typename?: 'Permit_Admin'
    id: string
    name?: string | null
    overallStatus: OverallPermitStatus
    startDate: string
    endDate: string
    workers?: Array<{
      __typename?: 'PermitWorker_Admin'
      id: string
      status: PermitStatus
      activeStatus: PermitActiveStatus
      overallStatus: OverallPermitStatus
      archivedAt?: string | null
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
    }> | null
  }>
}

export type PermitViewCountAdminUiQueryVariables = Exact<{
  activeCountFilter?: InputMaybe<PermitFilterInput>
  waitingReviewCountFilter?: InputMaybe<PermitFilterInput>
}>

export type PermitViewCountAdminUiQuery = {
  __typename?: 'Query'
  activeCount: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
  }
  waitingReviewCount: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
  }
}

export type PermitWorkerAdminUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PermitWorkerAdminUiQuery = {
  __typename?: 'Query'
  permitWorker_admin?: {
    __typename?: 'PermitWorker_Admin'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    approvedAt?: string | null
    closedOutAt?: string | null
    suspendedAt?: string | null
    status: PermitStatus
    activeStatus: PermitActiveStatus
    overallStatus: OverallPermitStatus
    worker?: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    applicationTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      updatedAt: string
    } | null
    enactingTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
      createdAt: string
      responseData?: any | null
    }> | null
    closeoutTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
  } | null
}

export type PermitWorkerWithLinksAdminUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PermitWorkerWithLinksAdminUiQuery = {
  __typename?: 'Query'
  permitWorker_admin?: {
    __typename?: 'PermitWorker_Admin'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    approvedAt?: string | null
    closedOutAt?: string | null
    suspendedAt?: string | null
    status: PermitStatus
    activeStatus: PermitActiveStatus
    overallStatus: OverallPermitStatus
    paginationLinks?: {
      __typename?: 'PermitWorkerPaginationLinks'
      previous?: {
        __typename?: 'PermitWorker_Admin'
        id: string
        worker?: {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        } | null
      } | null
      next?: {
        __typename?: 'PermitWorker_Admin'
        id: string
        worker?: {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        } | null
      } | null
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    applicationTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      updatedAt: string
    } | null
    enactingTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
      createdAt: string
      responseData?: any | null
    }> | null
    closeoutTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
  } | null
}

export type PermitListCsvAdminUiQueryVariables = Exact<{
  filter?: InputMaybe<PermitFilterInput>
}>

export type PermitListCsvAdminUiQuery = {
  __typename?: 'Query'
  permits_admin?: Array<{
    __typename?: 'Permit_Admin'
    id: string
    createdAt: string
    updatedAt: string
    identifier: number
    name?: string | null
    description?: string | null
    startDate: string
    endDate: string
    projectLocationId?: string | null
    workers?: Array<{
      __typename?: 'PermitWorker_Admin'
      id: string
      createdAt: string
      updatedAt: string
      archivedAt?: string | null
      approvedAt?: string | null
      closedOutAt?: string | null
      suspendedAt?: string | null
      status: PermitStatus
      activeStatus: PermitActiveStatus
      overallStatus: OverallPermitStatus
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      applicationTemplateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
        updatedAt: string
      } | null
      enactingTemplateResponses?: Array<{
        __typename?: 'TemplateResponse'
        id: string
        createdAt: string
        responseData?: any | null
      }> | null
      closeoutTemplateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
      } | null
    }> | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
  }> | null
}

export type CreatePermitAdminUiMutationVariables = Exact<{
  input: CreatePermitInputAdmin
}>

export type CreatePermitAdminUiMutation = {
  __typename?: 'Mutation'
  createPermit_admin: {
    __typename?: 'Permit_Admin'
    id: string
    createdAt: string
    updatedAt: string
    identifier: number
    name?: string | null
    description?: string | null
    startDate: string
    endDate: string
    projectLocationId?: string | null
    workers?: Array<{
      __typename?: 'PermitWorker_Admin'
      id: string
      createdAt: string
      updatedAt: string
      archivedAt?: string | null
      approvedAt?: string | null
      closedOutAt?: string | null
      suspendedAt?: string | null
      status: PermitStatus
      activeStatus: PermitActiveStatus
      overallStatus: OverallPermitStatus
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      applicationTemplateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
        updatedAt: string
      } | null
      enactingTemplateResponses?: Array<{
        __typename?: 'TemplateResponse'
        id: string
        createdAt: string
        responseData?: any | null
      }> | null
      closeoutTemplateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
      } | null
    }> | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
  }
}

export type UpdatePermitAdminUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdatePermitInputAdmin
}>

export type UpdatePermitAdminUiMutation = {
  __typename?: 'Mutation'
  updatePermit_admin: { __typename?: 'Permit_Admin'; id: string }
}

export type ApprovePermitAdminUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  permitId: Scalars['String']
  input?: InputMaybe<ApprovePermitInputAdmin>
}>

export type ApprovePermitAdminUiMutation = {
  __typename?: 'Mutation'
  approvePermit_admin: Array<{ __typename?: 'PermitWorker_Admin'; id: string }>
}

export type RejectPermitAdminUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  permitId: Scalars['String']
  input: RejectPermitInputAdmin
}>

export type RejectPermitAdminUiMutation = {
  __typename?: 'Mutation'
  rejectPermit_admin: Array<{ __typename?: 'PermitWorker_Admin'; id: string }>
}

export type StartPermitAdminUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  permitId: Scalars['String']
  input?: InputMaybe<StartPermitInputAdmin>
}>

export type StartPermitAdminUiMutation = {
  __typename?: 'Mutation'
  startPermit_admin: Array<{ __typename?: 'PermitWorker_Admin'; id: string }>
}

export type PausePermitAdminUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  permitId: Scalars['String']
}>

export type PausePermitAdminUiMutation = {
  __typename?: 'Mutation'
  pausePermit_admin: Array<{ __typename?: 'PermitWorker_Admin'; id: string }>
}

export type ClosePermitAdminUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  permitId: Scalars['String']
  input?: InputMaybe<CloseoutPermitInputAdmin>
}>

export type ClosePermitAdminUiMutation = {
  __typename?: 'Mutation'
  closeoutPermit_admin: Array<{ __typename?: 'PermitWorker_Admin'; id: string }>
}

export type SuspendPermitAdminUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  permitId: Scalars['String']
  input?: InputMaybe<SuspendPermitInputAdmin>
}>

export type SuspendPermitAdminUiMutation = {
  __typename?: 'Mutation'
  suspendPermit_admin: Array<{ __typename?: 'PermitWorker_Admin'; id: string }>
}

export type ResumePermitAdminUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  permitId: Scalars['String']
}>

export type ResumePermitAdminUiMutation = {
  __typename?: 'Mutation'
  resumePermit_admin: Array<{ __typename?: 'PermitWorker_Admin'; id: string }>
}

export type DuplicatePermitAdminUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DuplicatePermitAdminUiMutation = {
  __typename?: 'Mutation'
  duplicatePermit_admin: { __typename?: 'Permit_Admin'; id: string }
}

export type ArchivePermitAdminUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchivePermitAdminUiMutation = {
  __typename?: 'Mutation'
  archivePermit_admin: { __typename?: 'Permit_Admin'; id: string }
}

export type RestorePermitAdminUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestorePermitAdminUiMutation = {
  __typename?: 'Mutation'
  restorePermit_admin: { __typename?: 'Permit_Admin'; id: string }
}

export type ArchivePermitWorkerAdminUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchivePermitWorkerAdminUiMutation = {
  __typename?: 'Mutation'
  archivePermitWorker_admin: { __typename?: 'PermitWorker_Admin'; id: string }
}

export type RestorePermitWorkerAdminUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestorePermitWorkerAdminUiMutation = {
  __typename?: 'Mutation'
  restorePermitWorker_admin: { __typename?: 'PermitWorker_Admin'; id: string }
}

export type UpdatePermitWorkerTemplateResponseAdminUiMutationVariables = Exact<{
  permitWorkerId: Scalars['String']
  templateResponseId: Scalars['String']
  permitType: PermitTypeTemplate
  responseData: Scalars['JSON']
}>

export type UpdatePermitWorkerTemplateResponseAdminUiMutation = {
  __typename?: 'Mutation'
  updatePermitWorkerTemplateResponse_admin: {
    __typename?: 'TemplateResponse'
    id: string
  }
}

export type PermitListWorkerUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type PermitListWorkerUiQuery = {
  __typename?: 'Query'
  permits_worker?: Array<{
    __typename?: 'Permit_Worker'
    id: string
    name?: string | null
    overallStatus: OverallPermitStatus
    startDate: string
    endDate: string
    permitWorker: {
      __typename?: 'PermitWorker_Worker'
      id: string
      overallStatus: OverallPermitStatus
    }
    project: { __typename?: 'Project_ResourceLink'; id: string }
  }> | null
}

export type PermitWorkerUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PermitWorkerUiQuery = {
  __typename?: 'Query'
  permit_worker?: {
    __typename?: 'Permit_Worker'
    id: string
    createdAt: string
    updatedAt: string
    identifier: number
    name?: string | null
    description?: string | null
    startDate: string
    endDate: string
    overallStatus: OverallPermitStatus
    permitWorker: {
      __typename?: 'PermitWorker_Worker'
      id: string
      createdAt: string
      updatedAt: string
      archivedAt?: string | null
      approvedAt?: string | null
      closedOutAt?: string | null
      suspendedAt?: string | null
      status: PermitStatus
      activeStatus: PermitActiveStatus
      overallStatus: OverallPermitStatus
      worker: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      applicationTemplateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
      } | null
      enactingTemplateResponses?: Array<{
        __typename?: 'TemplateResponse'
        id: string
        createdAt: string
        responseData?: any | null
      }> | null
      closeoutTemplateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
      } | null
    }
    permitWorkers: Array<{
      __typename?: 'PermitWorker_Worker'
      id: string
      status: PermitStatus
      activeStatus: PermitActiveStatus
      overallStatus: OverallPermitStatus
      archivedAt?: string | null
      worker: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    }>
    project: {
      __typename?: 'Project_ResourceLink'
      id: string
      name: string
      status: ProjectStatus
    }
    conversation?: {
      __typename?: 'ConversationThread_ResourceLink'
      id: string
      messages?: Array<{
        __typename?: 'ConversationMessage_ResourceLink'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee_ResourceLink'
          id: string
          worker?: {
            __typename?: 'Worker_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
          } | null
        }
        attachments?: Array<{
          __typename?: 'Attachment_ResourceLink'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        }> | null
      }> | null
    } | null
    permitType: {
      __typename?: 'PermitType_Worker'
      id: string
      name: string
      maxDays?: number | null
      applicationTemplate?: {
        __typename?: 'TemplateEntity'
        id: string
        templateData?: any | null
      } | null
      enactingTemplate?: {
        __typename?: 'TemplateEntity'
        id: string
        templateData?: any | null
      } | null
      closeoutTemplate?: {
        __typename?: 'TemplateEntity'
        id: string
        templateData?: any | null
      } | null
    }
  } | null
}

export type PermitWorkerWorkerUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PermitWorkerWorkerUiQuery = {
  __typename?: 'Query'
  permitWorker_worker?: {
    __typename?: 'PermitWorker_Worker'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    approvedAt?: string | null
    closedOutAt?: string | null
    suspendedAt?: string | null
    status: PermitStatus
    activeStatus: PermitActiveStatus
    overallStatus: OverallPermitStatus
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    applicationTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    enactingTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
      createdAt: string
      responseData?: any | null
    }> | null
    closeoutTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
  } | null
}

export type StartPermitWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
  input?: InputMaybe<StartPermitInputWorker>
}>

export type StartPermitWorkerUiMutation = {
  __typename?: 'Mutation'
  startPermit_worker: { __typename?: 'Permit_Worker'; id: string }
}

export type PausePermitWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type PausePermitWorkerUiMutation = {
  __typename?: 'Mutation'
  pausePermit_worker: { __typename?: 'Permit_Worker'; id: string }
}

export type ClosePermitWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
  input?: InputMaybe<CloseoutPermitInputWorker>
}>

export type ClosePermitWorkerUiMutation = {
  __typename?: 'Mutation'
  closeoutPermit_worker: { __typename?: 'Permit_Worker'; id: string }
}

export type CreatePermitWorkerUiMutationVariables = Exact<{
  input: CreatePermitInputWorker
}>

export type CreatePermitWorkerUiMutation = {
  __typename?: 'Mutation'
  createPermit_worker: {
    __typename?: 'Permit_Worker'
    id: string
    createdAt: string
    updatedAt: string
    identifier: number
    name?: string | null
    description?: string | null
    startDate: string
    endDate: string
    overallStatus: OverallPermitStatus
    permitWorker: {
      __typename?: 'PermitWorker_Worker'
      id: string
      createdAt: string
      updatedAt: string
      archivedAt?: string | null
      approvedAt?: string | null
      closedOutAt?: string | null
      suspendedAt?: string | null
      status: PermitStatus
      activeStatus: PermitActiveStatus
      overallStatus: OverallPermitStatus
      worker: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      applicationTemplateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
      } | null
      enactingTemplateResponses?: Array<{
        __typename?: 'TemplateResponse'
        id: string
        createdAt: string
        responseData?: any | null
      }> | null
      closeoutTemplateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
      } | null
    }
    permitWorkers: Array<{
      __typename?: 'PermitWorker_Worker'
      id: string
      status: PermitStatus
      activeStatus: PermitActiveStatus
      overallStatus: OverallPermitStatus
      archivedAt?: string | null
      worker: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    }>
    project: {
      __typename?: 'Project_ResourceLink'
      id: string
      name: string
      status: ProjectStatus
    }
    conversation?: {
      __typename?: 'ConversationThread_ResourceLink'
      id: string
      messages?: Array<{
        __typename?: 'ConversationMessage_ResourceLink'
        id: string
        createdAt: string
        content?: string | null
        sender: {
          __typename?: 'Assignee_ResourceLink'
          id: string
          worker?: {
            __typename?: 'Worker_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
          } | null
        }
        attachments?: Array<{
          __typename?: 'Attachment_ResourceLink'
          id: string
          url: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        }> | null
      }> | null
    } | null
    permitType: {
      __typename?: 'PermitType_Worker'
      id: string
      name: string
      maxDays?: number | null
      applicationTemplate?: {
        __typename?: 'TemplateEntity'
        id: string
        templateData?: any | null
      } | null
      enactingTemplate?: {
        __typename?: 'TemplateEntity'
        id: string
        templateData?: any | null
      } | null
      closeoutTemplate?: {
        __typename?: 'TemplateEntity'
        id: string
        templateData?: any | null
      } | null
    }
  }
}

export type UpdatePermitWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
  projectId: Scalars['String']
  input: UpdatePermitInputWorker
}>

export type UpdatePermitWorkerUiMutation = {
  __typename?: 'Mutation'
  updatePermit_worker: { __typename?: 'Permit_Worker'; id: string }
}

export type CreatePermitMessageWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
  input: CreateConversationMessageInput
}>

export type CreatePermitMessageWorkerUiMutation = {
  __typename?: 'Mutation'
  createPermitMessage_worker: {
    __typename?: 'ConversationMessage_ResourceLink'
    id: string
  }
}

export type UpdatePermitWorkerTemplateResponseWorkerUiMutationVariables =
  Exact<{
    id: Scalars['String']
    responseData: Scalars['JSON']
  }>

export type UpdatePermitWorkerTemplateResponseWorkerUiMutation = {
  __typename?: 'Mutation'
  updatePermitWorkerTemplateResponse_worker: {
    __typename?: 'TemplateResponse'
    id: string
  }
}

export type PreStartsAttributesFragment = {
  __typename?: 'PreStart'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  date: string
  endDate?: string | null
  signOns: Array<{
    __typename?: 'SignOn'
    id: string
    createdAt: string
    builderGenerated: boolean
    worker?: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    visitor?: {
      __typename?: 'Visitor'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  } | null>
  template: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
    completedAt?: string | null
  }
  project: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  }
}

export type PreStartsAttributesSubsetFragment = {
  __typename?: 'PreStart'
  id: string
  createdAt: string
  archivedAt?: string | null
  date: string
  endDate?: string | null
  signOns: Array<{
    __typename?: 'SignOn'
    id: string
    createdAt: string
    builderGenerated: boolean
  } | null>
  template: {
    __typename?: 'TemplateResponse'
    id: string
    completedAt?: string | null
    responseData?: any | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateData?: any | null
        }
      | { __typename?: 'Template'; id: string; templateData?: any | null }
      | null
  }
}

export type PreStartsUiQueryVariables = Exact<{
  filter?: InputMaybe<PreStartsFilterInput>
  sort?: InputMaybe<PreStartsSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type PreStartsUiQuery = {
  __typename?: 'Query'
  preStarts: Array<{
    __typename?: 'PreStart'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    endDate?: string | null
    signOns: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      builderGenerated: boolean
    } | null>
    template: {
      __typename?: 'TemplateResponse'
      id: string
      completedAt?: string | null
      responseData?: any | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    }
  }>
  preStartsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type PreStartUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PreStartUiQuery = {
  __typename?: 'Query'
  preStart?: {
    __typename?: 'PreStart'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    date: string
    endDate?: string | null
    toolbox?: {
      __typename?: 'Toolbox'
      id: string
      date: string
      type: ToolboxType
    } | null
    acknowledgements?: Array<{
      __typename?: 'Acknowledgement'
      id: string
      createdAt: string
      worker: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    } | null> | null
    template: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    }
    signOns: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      builderGenerated: boolean
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      visitor?: {
        __typename?: 'Visitor'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    } | null>
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
  } | null
}

export type TodaysPreStartsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type TodaysPreStartsUiQuery = {
  __typename?: 'Query'
  todaysPreStarts: Array<{
    __typename?: 'PreStart'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    date: string
    endDate?: string | null
    signOns: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      builderGenerated: boolean
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      visitor?: {
        __typename?: 'Visitor'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    } | null>
    template: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
  }>
}

export type CreatePreStartUiMutationVariables = Exact<{
  input: CreatePreStartInput
}>

export type CreatePreStartUiMutation = {
  __typename?: 'Mutation'
  createPreStart: {
    __typename?: 'PreStart'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    date: string
    endDate?: string | null
    signOns: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      builderGenerated: boolean
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      visitor?: {
        __typename?: 'Visitor'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    } | null>
    template: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
  }
}

export type UpdatePreStartUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdatePreStartInput
}>

export type UpdatePreStartUiMutation = {
  __typename?: 'Mutation'
  updatePreStart: {
    __typename?: 'PreStart'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    date: string
    endDate?: string | null
    signOns: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      builderGenerated: boolean
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      visitor?: {
        __typename?: 'Visitor'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    } | null>
    template: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
  }
}

export type ArchivePreStartUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchivePreStartUiMutation = {
  __typename?: 'Mutation'
  archivePreStart: {
    __typename?: 'PreStart'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    date: string
    endDate?: string | null
    signOns: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      builderGenerated: boolean
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      visitor?: {
        __typename?: 'Visitor'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    } | null>
    template: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
  }
}

export type RestorePreStartUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestorePreStartUiMutation = {
  __typename?: 'Mutation'
  restorePreStart: {
    __typename?: 'PreStart'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    date: string
    endDate?: string | null
    signOns: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      builderGenerated: boolean
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      visitor?: {
        __typename?: 'Visitor'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
    } | null>
    template: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
  }
}

export type AcknowledgePreStartsUiMutationVariables = Exact<{
  preStartIds: Array<Scalars['String']> | Scalars['String']
  signOnId: Scalars['String']
}>

export type AcknowledgePreStartsUiMutation = {
  __typename?: 'Mutation'
  acknowledgePreStarts: { __typename?: 'SignOn'; id: string }
}

export type PrequalificationAttributesBaseFragment = {
  __typename?: 'Prequalification'
  id: string
  createdAt: string
  updatedAt: string
  status: PrequalificationStatus
}

export type PrequalificationsWithAggUiQueryVariables = Exact<{
  filter?: InputMaybe<PrequalificationFilterInput>
  sort?: InputMaybe<PrequalificationSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type PrequalificationsWithAggUiQuery = {
  __typename?: 'Query'
  prequalifications: Array<{
    __typename?: 'Prequalification'
    reviewComments?: string | null
    builderGenerated?: boolean | null
    id: string
    createdAt: string
    updatedAt: string
    status: PrequalificationStatus
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
    }> | null
  }>
  prequalificationsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type PrequalificationEnabledUiQueryVariables = Exact<{
  [key: string]: never
}>

export type PrequalificationEnabledUiQuery = {
  __typename?: 'Query'
  prequalificationEnabled: {
    __typename?: 'PrequalificationEnabled'
    enabled: boolean
  }
}

export type SendRequestForPrequalificationUiMutationVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type SendRequestForPrequalificationUiMutation = {
  __typename?: 'Mutation'
  sendRequestForPrequalification: {
    __typename?: 'Prequalification'
    id: string
  }
}

export type PrequalificationUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type PrequalificationUiQuery = {
  __typename?: 'Query'
  prequalification: {
    __typename?: 'Prequalification'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    builderGenerated?: boolean | null
    status: PrequalificationStatus
    reviewComments?: string | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    }
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      prequalification?: {
        __typename?: 'Prequalification'
        id: string
        createdAt: string
        status: PrequalificationStatus
      } | null
    }> | null
  }
}

export type ApprovePrequalificationUiMutationVariables = Exact<{
  id: Scalars['String']
  input?: InputMaybe<UpdatePrequalificationInput>
}>

export type ApprovePrequalificationUiMutation = {
  __typename?: 'Mutation'
  approvePrequalification: { __typename?: 'Prequalification'; id: string }
}

export type RejectPrequalificationUiMutationVariables = Exact<{
  id: Scalars['String']
  input?: InputMaybe<UpdatePrequalificationInput>
}>

export type RejectPrequalificationUiMutation = {
  __typename?: 'Mutation'
  rejectPrequalification: { __typename?: 'Prequalification'; id: string }
}

export type CreatePrequalificationForSubcontractorUiMutationVariables = Exact<{
  subcontractorId: Scalars['String']
  input: CreatePrequalificationForSubcontractor
}>

export type CreatePrequalificationForSubcontractorUiMutation = {
  __typename?: 'Mutation'
  createPrequalificationForSubcontractor: {
    __typename?: 'Prequalification'
    id: string
  }
}

export type PrequalificationsForDashboardUiQueryVariables = Exact<{
  filter?: InputMaybe<PrequalificationFilterInput>
}>

export type PrequalificationsForDashboardUiQuery = {
  __typename?: 'Query'
  prequalifications: Array<{
    __typename?: 'Prequalification'
    id: string
    createdAt: string
    updatedAt: string
    status: PrequalificationStatus
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
  }>
}

export type SubcontractorPrequalificationsUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type SubcontractorPrequalificationsUiQuery = {
  __typename?: 'Query'
  subcontractor?: {
    __typename?: 'Subcontractor'
    company: { __typename?: 'Company'; name: string }
    prequalifications?: Array<{
      __typename?: 'Prequalification'
      reviewComments?: string | null
      id: string
      createdAt: string
      updatedAt: string
      status: PrequalificationStatus
      currentVersion: { __typename?: 'VersionHistory'; version: number }
    } | null> | null
  } | null
}

export type GetPresignedUrlUiQueryVariables = Exact<{
  id: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['String']
  fileType: Scalars['String']
  type: DocumentType
}>

export type GetPresignedUrlUiQuery = {
  __typename?: 'Query'
  getPresignedUrl: {
    __typename?: 'PresignedUrl'
    url: string
    key: string
    viewUrl: string
  }
}

export type ProcoreCompanyWebhooksUiQueryVariables = Exact<{
  [key: string]: never
}>

export type ProcoreCompanyWebhooksUiQuery = {
  __typename?: 'Query'
  procoreCompanyWebhooks: boolean
}

export type ProcoreCompanyProjectsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type ProcoreCompanyProjectsUiQuery = {
  __typename?: 'Query'
  procoreCompanyProjects?: any | null
}

export type ProcoreConfigUiQueryVariables = Exact<{ [key: string]: never }>

export type ProcoreConfigUiQuery = {
  __typename?: 'Query'
  procoreConfig?: {
    __typename?: 'ProcoreConfig'
    procoreCompanyId: string
    isDev: boolean
  } | null
}

export type UpsertProcoreConfigUiMutationVariables = Exact<{
  input?: InputMaybe<UpsertProcoreConfigInput>
}>

export type UpsertProcoreConfigUiMutation = {
  __typename?: 'Mutation'
  upsertProcoreConfig: { __typename?: 'ProcoreConfig'; id: string }
}

export type ConfigureProcoreWebhooksUiMutationVariables = Exact<{
  [key: string]: never
}>

export type ConfigureProcoreWebhooksUiMutation = {
  __typename?: 'Mutation'
  configureProcoreWebhooks: { __typename?: 'ProcoreConfig'; id: string }
}

export type DeleteProcoreConfigUiMutationVariables = Exact<{
  [key: string]: never
}>

export type DeleteProcoreConfigUiMutation = {
  __typename?: 'Mutation'
  deleteProcoreConfig: {
    __typename?: 'ProcoreConfig'
    procoreCompanyId: string
  }
}

export type ProcoreCompanySubcontractorsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type ProcoreCompanySubcontractorsUiQuery = {
  __typename?: 'Query'
  procoreCompanySubcontractors?: any | null
}

export type HasProcoreAppInstalledUiQueryVariables = Exact<{
  isDev: Scalars['Boolean']
}>

export type HasProcoreAppInstalledUiQuery = {
  __typename?: 'Query'
  hasProcoreAppInstalled?: boolean | null
}

export type TransferFileToProcoreUiMutationVariables = Exact<{
  input: TransferFileToAgaveInput
}>

export type TransferFileToProcoreUiMutation = {
  __typename?: 'Mutation'
  transferFileToAgave: {
    __typename?: 'TransferFileToAgaveResponse'
    success: boolean
  }
}

export type SyncSiteAttendanceToProcoreUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type SyncSiteAttendanceToProcoreUiMutation = {
  __typename?: 'Mutation'
  syncSiteAttendanceToProcore: {
    __typename?: 'SyncSiteAttendanceResults'
    results: Array<{
      __typename?: 'SyncSiteAttendanceResult'
      subcontractorId: string
      numberOfWorkers?: number | null
      projectHours?: number | null
    }>
  }
}

export type ProjectAttributesFragment = {
  __typename?: 'Project'
  id: string
  createdAt: string
  updatedAt: string
  name: string
  status: ProjectStatus
  address?: string | null
  startDate?: string | null
  timezone?: string | null
  locale?: SupportedLocaleCountryCode | null
  language?: string | null
  endDate?: string | null
  info?: any | null
  config?: any | null
  procoreId?: string | null
  latitude?: number | null
  longitude?: number | null
  radius?: number | null
  projectContacts?: Array<{
    __typename?: 'Contact'
    id: string
    name?: string | null
    number?: string | null
    email?: string | null
    type: ContactType
    customType?: string | null
  } | null> | null
  projectAdmins: Array<{
    __typename?: 'AdminUser'
    id: string
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
    }
  } | null>
  requiredTickets: Array<{
    __typename?: 'TicketTemplateEntity'
    id: string
    shortName: string
    name: string
  } | null>
  builder?: {
    __typename?: 'Builder'
    builderMetadata?: any | null
    company: { __typename?: 'Company'; name: string }
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      shortName: string
      name: string
    } | null>
  } | null
  subcontractors: Array<{
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
  } | null>
  documents?: Array<{ __typename?: 'Document'; id: string } | null> | null
  integrationConnections: Array<{
    __typename?: 'IntegrationConnection'
    id: string
    integrationId: string
    integrationIdentifier: string
    sourceId: string
    integration: {
      __typename?: 'Integration'
      integrationType: IntegrationType
    }
  } | null>
  siteTimings?: Array<{
    __typename?: 'ProjectSiteTiming'
    dayOfWeek: string
    startTime?: string | null
    endTime?: string | null
  } | null> | null
  tags?: Array<{
    __typename?: 'ResourceTag'
    id: string
    slug: string
    name: string
  } | null> | null
}

export type ProjectAttributesSubsetFragment = {
  __typename?: 'Project'
  id: string
  name: string
  address?: string | null
  status: ProjectStatus
  createdAt: string
  timezone?: string | null
  locale?: SupportedLocaleCountryCode | null
  language?: string | null
  latitude?: number | null
  longitude?: number | null
  procoreId?: string | null
  projectAddress?: {
    __typename?: 'Address'
    country?: string | null
    state?: string | null
  } | null
  projectAdmins: Array<{
    __typename?: 'AdminUser'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null>
  integrationConnections: Array<{
    __typename?: 'IntegrationConnection'
    id: string
    integrationIdentifier: string
    sourceId: string
    integration: {
      __typename?: 'Integration'
      integrationType: IntegrationType
    }
  } | null>
  tags?: Array<{
    __typename?: 'ResourceTag'
    id: string
    name: string
    slug: string
  } | null> | null
}

export type ProjectsUiQueryVariables = Exact<{
  sort?: InputMaybe<ProjectSortInput>
}>

export type ProjectsUiQuery = {
  __typename?: 'Query'
  projects: Array<{
    __typename?: 'Project'
    id: string
    createdAt: string
    updatedAt: string
    name: string
    status: ProjectStatus
    address?: string | null
    startDate?: string | null
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    language?: string | null
    endDate?: string | null
    info?: any | null
    config?: any | null
    procoreId?: string | null
    latitude?: number | null
    longitude?: number | null
    radius?: number | null
    projectContacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      number?: string | null
      email?: string | null
      type: ContactType
      customType?: string | null
    } | null> | null
    projectAdmins: Array<{
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null>
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      shortName: string
      name: string
    } | null>
    builder?: {
      __typename?: 'Builder'
      builderMetadata?: any | null
      company: { __typename?: 'Company'; name: string }
      requiredTickets: Array<{
        __typename?: 'TicketTemplateEntity'
        id: string
        shortName: string
        name: string
      } | null>
    } | null
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
    } | null>
    documents?: Array<{ __typename?: 'Document'; id: string } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationId: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
    siteTimings?: Array<{
      __typename?: 'ProjectSiteTiming'
      dayOfWeek: string
      startTime?: string | null
      endTime?: string | null
    } | null> | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      slug: string
      name: string
    } | null> | null
  }>
}

export type ProjectsWithIntegrationsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type ProjectsWithIntegrationsUiQuery = {
  __typename?: 'Query'
  projects: Array<{
    __typename?: 'Project'
    id: string
    name: string
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }>
}

export type ProjectsListUiQueryVariables = Exact<{
  sort?: InputMaybe<ProjectSortInput>
  filter?: InputMaybe<ProjectFilterInput>
}>

export type ProjectsListUiQuery = {
  __typename?: 'Query'
  projects: Array<{
    __typename?: 'Project'
    id: string
    name: string
    address?: string | null
    status: ProjectStatus
    createdAt: string
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    language?: string | null
    latitude?: number | null
    longitude?: number | null
    procoreId?: string | null
    projectAddress?: {
      __typename?: 'Address'
      country?: string | null
      state?: string | null
    } | null
    projectAdmins: Array<{
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      name: string
      slug: string
    } | null> | null
  }>
}

export type ProjectsForBuilderListUiQueryVariables = Exact<{
  filter?: InputMaybe<ProjectsForBuilderFilterInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type ProjectsForBuilderListUiQuery = {
  __typename?: 'Query'
  projectsForBuilder: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  }>
}

export type ProjectsForBuilderWithAggUiQueryVariables = Exact<{
  filter?: InputMaybe<ProjectsForBuilderFilterInput>
  sort?: InputMaybe<ProjectsForBuilderSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type ProjectsForBuilderWithAggUiQuery = {
  __typename?: 'Query'
  projectsForBuilder: Array<{
    __typename?: 'Project'
    id: string
    name: string
    address?: string | null
    status: ProjectStatus
    createdAt: string
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    language?: string | null
    latitude?: number | null
    longitude?: number | null
    procoreId?: string | null
    projectAddress?: {
      __typename?: 'Address'
      country?: string | null
      state?: string | null
    } | null
    projectAdmins: Array<{
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      name: string
      slug: string
    } | null> | null
  }>
  projectsForBuilderAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type ProjectsForBuilderFilterAggregationUiQueryVariables = Exact<{
  [key: string]: never
}>

export type ProjectsForBuilderFilterAggregationUiQuery = {
  __typename?: 'Query'
  projectsForBuilderFilterAggregation?: {
    __typename?: 'ProjectsForBuilderFilterAggregation'
    inProgress?: number | null
    upcoming?: number | null
    complete?: number | null
    archived?: number | null
  } | null
}

export type SaProjectsByBuilderUiQueryVariables = Exact<{
  builderId?: InputMaybe<Scalars['String']>
}>

export type SaProjectsByBuilderUiQuery = {
  __typename?: 'Query'
  saProjectsByBuilder: Array<{
    __typename?: 'Project'
    id: string
    createdAt: string
    updatedAt: string
    name: string
    status: ProjectStatus
    address?: string | null
    startDate?: string | null
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    language?: string | null
    endDate?: string | null
    info?: any | null
    config?: any | null
    procoreId?: string | null
    latitude?: number | null
    longitude?: number | null
    radius?: number | null
    projectContacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      number?: string | null
      email?: string | null
      type: ContactType
      customType?: string | null
    } | null> | null
    projectAdmins: Array<{
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null>
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      shortName: string
      name: string
    } | null>
    builder?: {
      __typename?: 'Builder'
      builderMetadata?: any | null
      company: { __typename?: 'Company'; name: string }
      requiredTickets: Array<{
        __typename?: 'TicketTemplateEntity'
        id: string
        shortName: string
        name: string
      } | null>
    } | null
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
    } | null>
    documents?: Array<{ __typename?: 'Document'; id: string } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationId: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
    siteTimings?: Array<{
      __typename?: 'ProjectSiteTiming'
      dayOfWeek: string
      startTime?: string | null
      endTime?: string | null
    } | null> | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      slug: string
      name: string
    } | null> | null
  }>
}

export type ProjectUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectUiQuery = {
  __typename?: 'Query'
  project?: {
    __typename?: 'Project'
    id: string
    createdAt: string
    updatedAt: string
    name: string
    status: ProjectStatus
    address?: string | null
    startDate?: string | null
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    language?: string | null
    endDate?: string | null
    info?: any | null
    config?: any | null
    procoreId?: string | null
    latitude?: number | null
    longitude?: number | null
    radius?: number | null
    projectContacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      number?: string | null
      email?: string | null
      type: ContactType
      customType?: string | null
    } | null> | null
    projectAdmins: Array<{
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null>
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      shortName: string
      name: string
    } | null>
    builder?: {
      __typename?: 'Builder'
      builderMetadata?: any | null
      company: { __typename?: 'Company'; name: string }
      requiredTickets: Array<{
        __typename?: 'TicketTemplateEntity'
        id: string
        shortName: string
        name: string
      } | null>
    } | null
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
    } | null>
    documents?: Array<{ __typename?: 'Document'; id: string } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationId: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
    siteTimings?: Array<{
      __typename?: 'ProjectSiteTiming'
      dayOfWeek: string
      startTime?: string | null
      endTime?: string | null
    } | null> | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      slug: string
      name: string
    } | null> | null
  } | null
  projectSpecificSettings: {
    __typename?: 'ProjectSpecificSettings'
    qrCodeRotationEnabled: boolean
    qrCodeRotationInterval: number
    qrCodeRotationCustomMessage?: string | null
    manualQrCodeRotationProjectCode?: string | null
  }
}

export type ProjectContactsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectContactsUiQuery = {
  __typename?: 'Query'
  project?: {
    __typename?: 'Project'
    projectContacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      number?: string | null
      email?: string | null
      type: ContactType
      customType?: string | null
    } | null> | null
    projectAdmins: Array<{
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
  } | null
}

export type PublicProjectUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type PublicProjectUiQuery = {
  __typename?: 'Query'
  publicProject?: {
    __typename?: 'PublicProject'
    id: string
    createdAt: string
    name: string
    address?: string | null
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    language?: string | null
    country?: string | null
    status: ProjectStatus
    latitude?: number | null
    longitude?: number | null
    signOnRedirectUrl?: string | null
    timesheetsEnabled?: boolean | null
    defectsEnabled?: boolean | null
    drawingsEnabled?: boolean | null
    workerChecklistsEnabled?: boolean | null
    permitsEnabled?: boolean | null
    actionsEnabled?: boolean | null
    visitorDocumentAccessEnabled?: boolean | null
    qrCodeRotationEnabled?: boolean | null
    qrCodeRotationCustomMessage?: string | null
    swmsBuilderEnabled?: boolean | null
    builder?: {
      __typename?: 'BuilderEntity'
      id: string
      logoUrl?: string | null
      builderMetadata?: any | null
      hideBuildPassLogos?: boolean | null
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
      company?: { __typename?: 'Company'; name: string } | null
    } | null
    projectContacts?: Array<{
      __typename?: 'ContactEntity'
      id: string
      name?: string | null
      number?: string | null
      type: ContactType
      customType?: string | null
    } | null> | null
    siteTimings?: Array<{
      __typename?: 'ProjectSiteTiming'
      dayOfWeek: string
      startTime?: string | null
      endTime?: string | null
    } | null> | null
  } | null
}

export type PublicProjectsForSubcontractorUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type PublicProjectsForSubcontractorUiQuery = {
  __typename?: 'Query'
  publicProjectsForSubcontractor?: Array<{
    __typename?: 'PublicProject'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    builder?: {
      __typename?: 'BuilderEntity'
      id: string
      logoUrl?: string | null
      defaultTimezone?: string | null
      defaultLocale?: SupportedLocaleCountryCode | null
      company?: { __typename?: 'Company'; name: string } | null
    } | null
  }> | null
}

export type CreateProjectUiMutationVariables = Exact<{
  projectName: Scalars['String']
  projectAddress: Scalars['String']
  projectStatus: ProjectStatus
  projectAdminsIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
  requiredTicketsIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
  signOnRedirectUrl?: InputMaybe<Scalars['String']>
  projectContacts?: InputMaybe<
    Array<InputMaybe<ContactInput>> | InputMaybe<ContactInput>
  >
  startDate?: InputMaybe<Scalars['DateTime']>
  endDate?: InputMaybe<Scalars['DateTime']>
  locale?: InputMaybe<SupportedLocaleCountryCode>
  timezone?: InputMaybe<Scalars['String']>
}>

export type CreateProjectUiMutation = {
  __typename?: 'Mutation'
  createProject: {
    __typename?: 'Project'
    id: string
    createdAt: string
    updatedAt: string
    name: string
    status: ProjectStatus
    address?: string | null
    startDate?: string | null
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    language?: string | null
    endDate?: string | null
    info?: any | null
    config?: any | null
    procoreId?: string | null
    latitude?: number | null
    longitude?: number | null
    radius?: number | null
    projectContacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      number?: string | null
      email?: string | null
      type: ContactType
      customType?: string | null
    } | null> | null
    projectAdmins: Array<{
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null>
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      shortName: string
      name: string
    } | null>
    builder?: {
      __typename?: 'Builder'
      builderMetadata?: any | null
      company: { __typename?: 'Company'; name: string }
      requiredTickets: Array<{
        __typename?: 'TicketTemplateEntity'
        id: string
        shortName: string
        name: string
      } | null>
    } | null
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
    } | null>
    documents?: Array<{ __typename?: 'Document'; id: string } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationId: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
    siteTimings?: Array<{
      __typename?: 'ProjectSiteTiming'
      dayOfWeek: string
      startTime?: string | null
      endTime?: string | null
    } | null> | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      slug: string
      name: string
    } | null> | null
  }
}

export type UpdateProjectUiMutationVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']>
  projectAddress?: InputMaybe<Scalars['String']>
  projectStatus?: InputMaybe<ProjectStatus>
  projectId: Scalars['String']
  projectAdminsIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
  requiredTicketsIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
  signOnRedirectUrl?: InputMaybe<Scalars['String']>
  projectContacts?: InputMaybe<
    Array<InputMaybe<UpdateContactInput>> | InputMaybe<UpdateContactInput>
  >
  startDate?: InputMaybe<Scalars['DateTime']>
  endDate?: InputMaybe<Scalars['DateTime']>
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
  radius?: InputMaybe<Scalars['Float']>
  info?: InputMaybe<Scalars['JSON']>
  timezone?: InputMaybe<Scalars['String']>
  locale?: InputMaybe<SupportedLocaleCountryCode>
  language?: InputMaybe<Scalars['String']>
}>

export type UpdateProjectUiMutation = {
  __typename?: 'Mutation'
  updateProject: {
    __typename?: 'Project'
    id: string
    createdAt: string
    updatedAt: string
    name: string
    status: ProjectStatus
    address?: string | null
    startDate?: string | null
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    language?: string | null
    endDate?: string | null
    info?: any | null
    config?: any | null
    procoreId?: string | null
    latitude?: number | null
    longitude?: number | null
    radius?: number | null
    projectContacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      number?: string | null
      email?: string | null
      type: ContactType
      customType?: string | null
    } | null> | null
    projectAdmins: Array<{
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null>
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      shortName: string
      name: string
    } | null>
    builder?: {
      __typename?: 'Builder'
      builderMetadata?: any | null
      company: { __typename?: 'Company'; name: string }
      requiredTickets: Array<{
        __typename?: 'TicketTemplateEntity'
        id: string
        shortName: string
        name: string
      } | null>
    } | null
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
    } | null>
    documents?: Array<{ __typename?: 'Document'; id: string } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationId: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
    siteTimings?: Array<{
      __typename?: 'ProjectSiteTiming'
      dayOfWeek: string
      startTime?: string | null
      endTime?: string | null
    } | null> | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      slug: string
      name: string
    } | null> | null
  }
}

export type ArchiveProjectUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveProjectUiMutation = {
  __typename?: 'Mutation'
  updateProject: {
    __typename?: 'Project'
    id: string
    createdAt: string
    updatedAt: string
    name: string
    status: ProjectStatus
    address?: string | null
    startDate?: string | null
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    language?: string | null
    endDate?: string | null
    info?: any | null
    config?: any | null
    procoreId?: string | null
    latitude?: number | null
    longitude?: number | null
    radius?: number | null
    projectContacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      number?: string | null
      email?: string | null
      type: ContactType
      customType?: string | null
    } | null> | null
    projectAdmins: Array<{
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null>
    requiredTickets: Array<{
      __typename?: 'TicketTemplateEntity'
      id: string
      shortName: string
      name: string
    } | null>
    builder?: {
      __typename?: 'Builder'
      builderMetadata?: any | null
      company: { __typename?: 'Company'; name: string }
      requiredTickets: Array<{
        __typename?: 'TicketTemplateEntity'
        id: string
        shortName: string
        name: string
      } | null>
    } | null
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
    } | null>
    documents?: Array<{ __typename?: 'Document'; id: string } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationId: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
    siteTimings?: Array<{
      __typename?: 'ProjectSiteTiming'
      dayOfWeek: string
      startTime?: string | null
      endTime?: string | null
    } | null> | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      slug: string
      name: string
    } | null> | null
  }
}

export type ConnectProcoreProjectUiMutationVariables = Exact<{
  id: Scalars['String']
  input?: InputMaybe<ProcoreProjectInput>
}>

export type ConnectProcoreProjectUiMutation = {
  __typename?: 'Mutation'
  connectProcoreProject: {
    __typename?: 'Project'
    id: string
    procoreId?: string | null
  }
}

export type DisconnectProcoreProjectUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DisconnectProcoreProjectUiMutation = {
  __typename?: 'Mutation'
  disconnectProcoreProject: {
    __typename?: 'Project'
    id: string
    procoreId?: string | null
  }
}

export type ImportIntegrationProjectsUiMutationVariables = Exact<{
  integrationType: IntegrationType
  integrationIdentifiers: Array<Scalars['String']> | Scalars['String']
}>

export type ImportIntegrationProjectsUiMutation = {
  __typename?: 'Mutation'
  importIntegrationProjects: Array<{ __typename?: 'Project'; id: string }>
}

export type NestedProjectLocationAttributesFragment = {
  __typename?: 'ProjectLocation'
  id: string
  name: string
  order: number
}

export type NestedProjectLocationResourceLinkAttributesFragment = {
  __typename?: 'ProjectLocation_ResourceLink'
  id: string
  name: string
  order?: number | null
  fullLocationName: string
}

export type ProjectLocationWithChildrenAttributesFragment = {
  __typename?: 'ProjectLocation'
  id: string
  name: string
  order: number
  children?: Array<{
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    children?: Array<{
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      children?: Array<{
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        children?: Array<{
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          children?: Array<{
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            children?: Array<{
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              children?: Array<{
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                children?: Array<{
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  children?: Array<{
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  }> | null
}

export type ProjectLocationCountAttributesFragment = {
  __typename?: 'ProjectLocation'
  defectsCount: number
  checklistsCount: number
  itpsCount: number
  platformActionsCount: number
  permitsCount: number
}

export type NestedProjectLocationPublicAttributesFragment = {
  __typename?: 'ProjectLocation_Public'
  id: string
  name: string
  order: number
}

export type ProjectLocationPublicWithChildrenAttributesFragment = {
  __typename?: 'ProjectLocation_Public'
  id: string
  name: string
  order: number
  children?: Array<{
    __typename?: 'ProjectLocation_Public'
    id: string
    name: string
    order: number
    children?: Array<{
      __typename?: 'ProjectLocation_Public'
      id: string
      name: string
      order: number
      children?: Array<{
        __typename?: 'ProjectLocation_Public'
        id: string
        name: string
        order: number
        children?: Array<{
          __typename?: 'ProjectLocation_Public'
          id: string
          name: string
          order: number
          children?: Array<{
            __typename?: 'ProjectLocation_Public'
            id: string
            name: string
            order: number
            children?: Array<{
              __typename?: 'ProjectLocation_Public'
              id: string
              name: string
              order: number
              children?: Array<{
                __typename?: 'ProjectLocation_Public'
                id: string
                name: string
                order: number
                children?: Array<{
                  __typename?: 'ProjectLocation_Public'
                  id: string
                  name: string
                  order: number
                  children?: Array<{
                    __typename?: 'ProjectLocation_Public'
                    id: string
                    name: string
                    order: number
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  }> | null
}

export type ProjectLocationListWithChildrenAttributesFragment = {
  __typename?: 'ProjectLocation'
  id: string
  name: string
  order: number
  defectsCount: number
  checklistsCount: number
  itpsCount: number
  platformActionsCount: number
  permitsCount: number
  children?: Array<{
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    defectsCount: number
    checklistsCount: number
    itpsCount: number
    platformActionsCount: number
    permitsCount: number
    children?: Array<{
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      defectsCount: number
      checklistsCount: number
      itpsCount: number
      platformActionsCount: number
      permitsCount: number
      children?: Array<{
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        defectsCount: number
        checklistsCount: number
        itpsCount: number
        platformActionsCount: number
        permitsCount: number
        children?: Array<{
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          defectsCount: number
          checklistsCount: number
          itpsCount: number
          platformActionsCount: number
          permitsCount: number
          children?: Array<{
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            defectsCount: number
            checklistsCount: number
            itpsCount: number
            platformActionsCount: number
            permitsCount: number
            children?: Array<{
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              defectsCount: number
              checklistsCount: number
              itpsCount: number
              platformActionsCount: number
              permitsCount: number
              children?: Array<{
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                defectsCount: number
                checklistsCount: number
                itpsCount: number
                platformActionsCount: number
                permitsCount: number
                children?: Array<{
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  defectsCount: number
                  checklistsCount: number
                  itpsCount: number
                  platformActionsCount: number
                  permitsCount: number
                  children?: Array<{
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    defectsCount: number
                    checklistsCount: number
                    itpsCount: number
                    platformActionsCount: number
                    permitsCount: number
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  }> | null
}

export type ProjectLocationWithParentAttributesFragment = {
  __typename?: 'ProjectLocation'
  id: string
  name: string
  order: number
  parent?: {
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    parent?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  } | null
}

export type ProjectLocationResourceLinkWithParentAttributesFragment = {
  __typename?: 'ProjectLocation_ResourceLink'
  id: string
  name: string
  order?: number | null
  fullLocationName: string
  parent?: {
    __typename?: 'ProjectLocation_ResourceLink'
    id: string
    name: string
    order?: number | null
    fullLocationName: string
    parent?: {
      __typename?: 'ProjectLocation_ResourceLink'
      id: string
      name: string
      order?: number | null
      fullLocationName: string
      parent?: {
        __typename?: 'ProjectLocation_ResourceLink'
        id: string
        name: string
        order?: number | null
        fullLocationName: string
        parent?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
          order?: number | null
          fullLocationName: string
          parent?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
            order?: number | null
            fullLocationName: string
            parent?: {
              __typename?: 'ProjectLocation_ResourceLink'
              id: string
              name: string
              order?: number | null
              fullLocationName: string
              parent?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                order?: number | null
                fullLocationName: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                  order?: number | null
                  fullLocationName: string
                  parent?: {
                    __typename?: 'ProjectLocation_ResourceLink'
                    id: string
                    name: string
                    order?: number | null
                    fullLocationName: string
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  } | null
}

export type ProjectLocationsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectLocationsUiQuery = {
  __typename?: 'Query'
  projectLocations: Array<{
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    children?: Array<{
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      children?: Array<{
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        children?: Array<{
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          children?: Array<{
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            children?: Array<{
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              children?: Array<{
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                children?: Array<{
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  children?: Array<{
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    children?: Array<{
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                    }> | null
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  }>
}

export type ProjectLocationsPublicUiQueryVariables = Exact<{
  projectId: Scalars['String']
  slug?: InputMaybe<Scalars['String']>
}>

export type ProjectLocationsPublicUiQuery = {
  __typename?: 'Query'
  projectLocations_public: Array<{
    __typename?: 'ProjectLocation_Public'
    id: string
    name: string
    order: number
    children?: Array<{
      __typename?: 'ProjectLocation_Public'
      id: string
      name: string
      order: number
      children?: Array<{
        __typename?: 'ProjectLocation_Public'
        id: string
        name: string
        order: number
        children?: Array<{
          __typename?: 'ProjectLocation_Public'
          id: string
          name: string
          order: number
          children?: Array<{
            __typename?: 'ProjectLocation_Public'
            id: string
            name: string
            order: number
            children?: Array<{
              __typename?: 'ProjectLocation_Public'
              id: string
              name: string
              order: number
              children?: Array<{
                __typename?: 'ProjectLocation_Public'
                id: string
                name: string
                order: number
                children?: Array<{
                  __typename?: 'ProjectLocation_Public'
                  id: string
                  name: string
                  order: number
                  children?: Array<{
                    __typename?: 'ProjectLocation_Public'
                    id: string
                    name: string
                    order: number
                    children?: Array<{
                      __typename?: 'ProjectLocation_Public'
                      id: string
                      name: string
                      order: number
                    }> | null
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  }>
}

export type ProjectLocationsListUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectLocationsListUiQuery = {
  __typename?: 'Query'
  projectLocations: Array<{
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    defectsCount: number
    checklistsCount: number
    itpsCount: number
    platformActionsCount: number
    permitsCount: number
    children?: Array<{
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      defectsCount: number
      checklistsCount: number
      itpsCount: number
      platformActionsCount: number
      permitsCount: number
      children?: Array<{
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        defectsCount: number
        checklistsCount: number
        itpsCount: number
        platformActionsCount: number
        permitsCount: number
        children?: Array<{
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          defectsCount: number
          checklistsCount: number
          itpsCount: number
          platformActionsCount: number
          permitsCount: number
          children?: Array<{
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            defectsCount: number
            checklistsCount: number
            itpsCount: number
            platformActionsCount: number
            permitsCount: number
            children?: Array<{
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              defectsCount: number
              checklistsCount: number
              itpsCount: number
              platformActionsCount: number
              permitsCount: number
              children?: Array<{
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                defectsCount: number
                checklistsCount: number
                itpsCount: number
                platformActionsCount: number
                permitsCount: number
                children?: Array<{
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  defectsCount: number
                  checklistsCount: number
                  itpsCount: number
                  platformActionsCount: number
                  permitsCount: number
                  children?: Array<{
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    defectsCount: number
                    checklistsCount: number
                    itpsCount: number
                    platformActionsCount: number
                    permitsCount: number
                    children?: Array<{
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      defectsCount: number
                      checklistsCount: number
                      itpsCount: number
                      platformActionsCount: number
                      permitsCount: number
                    }> | null
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  }>
}

export type AllProjectLocationsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type AllProjectLocationsUiQuery = {
  __typename?: 'Query'
  projects: Array<{
    __typename?: 'Project'
    id: string
    name: string
    locations?: Array<{
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      children?: Array<{
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        children?: Array<{
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          children?: Array<{
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            children?: Array<{
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              children?: Array<{
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                children?: Array<{
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  children?: Array<{
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    children?: Array<{
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      children?: Array<{
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      }> | null
                    }> | null
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    } | null> | null
  }>
}

export type CreateProjectLocationUiMutationVariables = Exact<{
  input: CreateProjectLocationInput
}>

export type CreateProjectLocationUiMutation = {
  __typename?: 'Mutation'
  createProjectLocation: {
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    children?: Array<{
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      children?: Array<{
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        children?: Array<{
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          children?: Array<{
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            children?: Array<{
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              children?: Array<{
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                children?: Array<{
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  children?: Array<{
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    children?: Array<{
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                    }> | null
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  }
}

export type UpdateProjectLocationUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateProjectLocationInput
}>

export type UpdateProjectLocationUiMutation = {
  __typename?: 'Mutation'
  updateProjectLocation: {
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    children?: Array<{
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      children?: Array<{
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        children?: Array<{
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          children?: Array<{
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            children?: Array<{
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              children?: Array<{
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                children?: Array<{
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  children?: Array<{
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    children?: Array<{
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                    }> | null
                  }> | null
                }> | null
              }> | null
            }> | null
          }> | null
        }> | null
      }> | null
    }> | null
  }
}

export type DeleteProjectLocationUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteProjectLocationUiMutation = {
  __typename?: 'Mutation'
  deleteProjectLocation: { __typename?: 'ProjectLocation'; id: string }
}

export type SetProjectSiteTimingsUiMutationVariables = Exact<{
  id: Scalars['String']
  input: SetProjectTimingsInput
}>

export type SetProjectSiteTimingsUiMutation = {
  __typename?: 'Mutation'
  setProjectSiteTimings?: Array<{
    __typename?: 'ProjectSiteTiming'
    dayOfWeek: string
    startTime?: string | null
    endTime?: string | null
  } | null> | null
}

export type ProjectStatsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectStatsUiQuery = {
  __typename?: 'Query'
  projectStats: {
    __typename?: 'ProjectStats'
    signOnCount?: number | null
    inductionCount?: number | null
    workerCount?: number | null
    subcontractorCount?: number | null
  }
}

export type UpdateProjectSpecificSettingsUiMutationVariables = Exact<{
  projectId: Scalars['String']
  input: UpdateProjectSpecificSettingsInput
}>

export type UpdateProjectSpecificSettingsUiMutation = {
  __typename?: 'Mutation'
  updateProjectSpecificSettings: {
    __typename?: 'ProjectSpecificSettings'
    qrCodeRotationEnabled: boolean
    qrCodeRotationInterval: number
  }
}

export type RegisterItemTypeAttributesFragment = {
  __typename?: 'RegisterItemType'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  name: string
  uploadTemplateId?: string | null
  reviewTemplateId?: string | null
  linkedChecklists: Array<{
    __typename?: 'Template'
    id: string
    templateName: string
  }>
}

export type RegisterItemTypesListUiQueryVariables = Exact<{
  filter?: InputMaybe<RegisterItemTypeFilterInput>
  sort?: InputMaybe<RegisterItemTypeSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type RegisterItemTypesListUiQuery = {
  __typename?: 'Query'
  registerItemTypes: Array<{
    __typename?: 'RegisterItemType'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    uploadTemplateId?: string | null
    reviewTemplateId?: string | null
    linkedChecklists: Array<{
      __typename?: 'Template'
      id: string
      templateName: string
    }>
  }>
  registerItemTypesAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type RegisterItemTypesForSearchUiQueryVariables = Exact<{
  [key: string]: never
}>

export type RegisterItemTypesForSearchUiQuery = {
  __typename?: 'Query'
  registerItemTypes: Array<{
    __typename?: 'RegisterItemType'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    uploadTemplateId?: string | null
    reviewTemplateId?: string | null
    linkedChecklists: Array<{
      __typename?: 'Template'
      id: string
      templateName: string
    }>
  }>
}

export type RegisterItemTypesForSearchPublicUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type RegisterItemTypesForSearchPublicUiQuery = {
  __typename?: 'Query'
  registerItemTypes_public: Array<{
    __typename?: 'RegisterItemType_Public'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    linkedChecklists: Array<{
      __typename?: 'TemplateEntity'
      id: string
      templateName: string
    }>
  }>
}

export type RegisterItemTypeUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type RegisterItemTypeUiQuery = {
  __typename?: 'Query'
  registerItemType?: {
    __typename?: 'RegisterItemType'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    uploadTemplateId?: string | null
    reviewTemplateId?: string | null
    uploadTemplate?: {
      __typename?: 'Template'
      id: string
      templateData?: any | null
    } | null
    reviewTemplate?: {
      __typename?: 'Template'
      id: string
      templateData?: any | null
    } | null
    linkedChecklists: Array<{
      __typename?: 'Template'
      id: string
      templateName: string
    }>
  } | null
}

export type RegisterItemTypePublicUiQueryVariables = Exact<{
  id: Scalars['String']
  subcontractorId: Scalars['String']
}>

export type RegisterItemTypePublicUiQuery = {
  __typename?: 'Query'
  registerItemType_public: {
    __typename?: 'RegisterItemType_Public'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    linkedChecklists: Array<{
      __typename?: 'TemplateEntity'
      id: string
      templateName: string
    }>
    uploadTemplate?: {
      __typename?: 'Template'
      id: string
      templateData?: any | null
    } | null
    reviewTemplate?: {
      __typename?: 'Template'
      id: string
      templateData?: any | null
    } | null
  }
}

export type CreateRegisterItemTypeUiMutationVariables = Exact<{
  input: CreateRegisterItemTypeInput
}>

export type CreateRegisterItemTypeUiMutation = {
  __typename?: 'Mutation'
  createRegisterItemType: { __typename?: 'RegisterItemType'; id: string }
}

export type UpdateRegisterItemTypeUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateRegisterItemTypeInput
}>

export type UpdateRegisterItemTypeUiMutation = {
  __typename?: 'Mutation'
  updateRegisterItemType: { __typename?: 'RegisterItemType'; id: string }
}

export type ArchiveRegisterItemTypeUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveRegisterItemTypeUiMutation = {
  __typename?: 'Mutation'
  archiveRegisterItemType: { __typename?: 'RegisterItemType'; id: string }
}

export type CreateRegisterItemTypeTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
  type: RegisterItemTypeTemplate
}>

export type CreateRegisterItemTypeTemplateUiMutation = {
  __typename?: 'Mutation'
  createRegisterItemTypeTemplate: { __typename?: 'Template'; id: string }
}

export type ArchiveRegisterItemTypeTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
  type: RegisterItemTypeTemplate
}>

export type ArchiveRegisterItemTypeTemplateUiMutation = {
  __typename?: 'Mutation'
  archiveRegisterItemTypeTemplate: {
    __typename?: 'RegisterItemType'
    id: string
  }
}

export type RegisterForItemsListUiQueryVariables = Exact<{
  identifierPrefix: Scalars['String']
}>

export type RegisterForItemsListUiQuery = {
  __typename?: 'Query'
  register?: {
    __typename?: 'Register'
    id: string
    name: string
    createdAt: string
    archivedAt?: string | null
    identifierPrefix: string
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    settings?: {
      __typename?: 'RegisterSettings'
      canAssignItemsToProject?: boolean | null
      canAssignMultipleProjects?: boolean | null
      canAssignChecklists?: boolean | null
      canSubcontractorsManageItems?: boolean | null
      hideAssignees?: boolean | null
      hideFollowUpDate?: boolean | null
      hideIdentifier?: boolean | null
      checklistColumns?: Array<{
        __typename?: 'ChecklistColumn'
        templateId: string
        blockId: string
        title?: string | null
      }> | null
    } | null
    template: { __typename?: 'Template'; id: string; templateData?: any | null }
    typeLibraryTemplate?: {
      __typename?: 'LibraryTemplate'
      templateName: string
    } | null
  } | null
}

export type RegisterItemsListUiQueryVariables = Exact<{
  sort?: InputMaybe<RegisterItemSortInput>
  filter?: InputMaybe<RegisterItemFilterInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type RegisterItemsListUiQuery = {
  __typename?: 'Query'
  registerItems: Array<{
    __typename?: 'RegisterItem'
    id: string
    archivedAt?: string | null
    followUpAt?: string | null
    identifier: number
    fullIdentifier: string
    name: string
    status?: RegisterItemStatus | null
    checklistTableBlocks?: any | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      tableBlocks?: any | null
      responseData?: any | null
      platformActions?: Array<{
        __typename?: 'PlatformAction'
        id: string
        title?: string | null
        status: PlatformActionStatus
      } | null> | null
    }
    assignees?: Array<{
      __typename?: 'Assignee'
      id: string
      type?: AssigneeType | null
      worker?: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null
    } | null> | null
  }>
  registerItemsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type RegisterAttributesFragment = {
  __typename?: 'Register'
  id: string
  createdAt: string
  archivedAt?: string | null
  typeLibraryTemplateId?: string | null
  name: string
  identifierPrefix: string
  settings?: {
    __typename?: 'RegisterSettings'
    canAssignItemsToProject?: boolean | null
    canAssignMultipleProjects?: boolean | null
    canAssignChecklists?: boolean | null
    canSubcontractorsManageItems?: boolean | null
    hideAssignees?: boolean | null
    hideFollowUpDate?: boolean | null
    hideIdentifier?: boolean | null
    checklistColumns?: Array<{
      __typename?: 'ChecklistColumn'
      templateId: string
      blockId: string
      title?: string | null
    }> | null
  } | null
  template: { __typename?: 'Template'; id: string; templateData?: any | null }
  typeLibraryTemplate?: {
    __typename?: 'LibraryTemplate'
    id: string
    templateName: string
    templateData?: any | null
  } | null
  projects?: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  } | null> | null
}

export type RegisterListAttributesFragment = {
  __typename?: 'Register'
  id: string
  createdAt: string
  archivedAt?: string | null
  name: string
  identifierPrefix: string
  itemCount: number
  projects?: Array<{
    __typename?: 'Project'
    name: string
    id: string
    status: ProjectStatus
  } | null> | null
  typeLibraryTemplate?: {
    __typename?: 'LibraryTemplate'
    templateName: string
  } | null
}

export type RegistersUiQueryVariables = Exact<{
  filter?: InputMaybe<RegisterFilterInput>
}>

export type RegistersUiQuery = {
  __typename?: 'Query'
  registers: Array<{
    __typename?: 'Register'
    id: string
    createdAt: string
    archivedAt?: string | null
    name: string
    identifierPrefix: string
    itemCount: number
    projects?: Array<{
      __typename?: 'Project'
      name: string
      id: string
      status: ProjectStatus
    } | null> | null
    typeLibraryTemplate?: {
      __typename?: 'LibraryTemplate'
      templateName: string
    } | null
  }>
}

export type RegisterIdentifiersUiQueryVariables = Exact<{
  [key: string]: never
}>

export type RegisterIdentifiersUiQuery = {
  __typename?: 'Query'
  registerIdentifiers: Array<string>
}

export type RegisterUiQueryVariables = Exact<{
  identifierPrefix: Scalars['String']
  filter?: InputMaybe<RegisterFilterInput>
}>

export type RegisterUiQuery = {
  __typename?: 'Query'
  register?: {
    __typename?: 'Register'
    id: string
    createdAt: string
    archivedAt?: string | null
    typeLibraryTemplateId?: string | null
    name: string
    identifierPrefix: string
    settings?: {
      __typename?: 'RegisterSettings'
      canAssignItemsToProject?: boolean | null
      canAssignMultipleProjects?: boolean | null
      canAssignChecklists?: boolean | null
      canSubcontractorsManageItems?: boolean | null
      hideAssignees?: boolean | null
      hideFollowUpDate?: boolean | null
      hideIdentifier?: boolean | null
      checklistColumns?: Array<{
        __typename?: 'ChecklistColumn'
        templateId: string
        blockId: string
        title?: string | null
      }> | null
    } | null
    template: { __typename?: 'Template'; id: string; templateData?: any | null }
    typeLibraryTemplate?: {
      __typename?: 'LibraryTemplate'
      id: string
      templateName: string
      templateData?: any | null
    } | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
  } | null
}

export type CreateRegisterUiMutationVariables = Exact<{
  input: CreateRegisterInput
}>

export type CreateRegisterUiMutation = {
  __typename?: 'Mutation'
  createRegister: {
    __typename?: 'Register'
    id: string
    createdAt: string
    archivedAt?: string | null
    typeLibraryTemplateId?: string | null
    name: string
    identifierPrefix: string
    settings?: {
      __typename?: 'RegisterSettings'
      canAssignItemsToProject?: boolean | null
      canAssignMultipleProjects?: boolean | null
      canAssignChecklists?: boolean | null
      canSubcontractorsManageItems?: boolean | null
      hideAssignees?: boolean | null
      hideFollowUpDate?: boolean | null
      hideIdentifier?: boolean | null
      checklistColumns?: Array<{
        __typename?: 'ChecklistColumn'
        templateId: string
        blockId: string
        title?: string | null
      }> | null
    } | null
    template: { __typename?: 'Template'; id: string; templateData?: any | null }
    typeLibraryTemplate?: {
      __typename?: 'LibraryTemplate'
      id: string
      templateName: string
      templateData?: any | null
    } | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
  }
}

export type UpdateRegisterUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateRegisterInput
}>

export type UpdateRegisterUiMutation = {
  __typename?: 'Mutation'
  updateRegister: {
    __typename?: 'Register'
    id: string
    createdAt: string
    archivedAt?: string | null
    typeLibraryTemplateId?: string | null
    name: string
    identifierPrefix: string
    settings?: {
      __typename?: 'RegisterSettings'
      canAssignItemsToProject?: boolean | null
      canAssignMultipleProjects?: boolean | null
      canAssignChecklists?: boolean | null
      canSubcontractorsManageItems?: boolean | null
      hideAssignees?: boolean | null
      hideFollowUpDate?: boolean | null
      hideIdentifier?: boolean | null
      checklistColumns?: Array<{
        __typename?: 'ChecklistColumn'
        templateId: string
        blockId: string
        title?: string | null
      }> | null
    } | null
    template: { __typename?: 'Template'; id: string; templateData?: any | null }
    typeLibraryTemplate?: {
      __typename?: 'LibraryTemplate'
      id: string
      templateName: string
      templateData?: any | null
    } | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
  }
}

export type ArchiveRegisterUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveRegisterUiMutation = {
  __typename?: 'Mutation'
  archiveRegister: {
    __typename?: 'Register'
    id: string
    createdAt: string
    archivedAt?: string | null
    typeLibraryTemplateId?: string | null
    name: string
    identifierPrefix: string
    settings?: {
      __typename?: 'RegisterSettings'
      canAssignItemsToProject?: boolean | null
      canAssignMultipleProjects?: boolean | null
      canAssignChecklists?: boolean | null
      canSubcontractorsManageItems?: boolean | null
      hideAssignees?: boolean | null
      hideFollowUpDate?: boolean | null
      hideIdentifier?: boolean | null
      checklistColumns?: Array<{
        __typename?: 'ChecklistColumn'
        templateId: string
        blockId: string
        title?: string | null
      }> | null
    } | null
    template: { __typename?: 'Template'; id: string; templateData?: any | null }
    typeLibraryTemplate?: {
      __typename?: 'LibraryTemplate'
      id: string
      templateName: string
      templateData?: any | null
    } | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
  }
}

export type RestoreRegisterUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreRegisterUiMutation = {
  __typename?: 'Mutation'
  restoreRegister: {
    __typename?: 'Register'
    id: string
    createdAt: string
    archivedAt?: string | null
    typeLibraryTemplateId?: string | null
    name: string
    identifierPrefix: string
    settings?: {
      __typename?: 'RegisterSettings'
      canAssignItemsToProject?: boolean | null
      canAssignMultipleProjects?: boolean | null
      canAssignChecklists?: boolean | null
      canSubcontractorsManageItems?: boolean | null
      hideAssignees?: boolean | null
      hideFollowUpDate?: boolean | null
      hideIdentifier?: boolean | null
      checklistColumns?: Array<{
        __typename?: 'ChecklistColumn'
        templateId: string
        blockId: string
        title?: string | null
      }> | null
    } | null
    template: { __typename?: 'Template'; id: string; templateData?: any | null }
    typeLibraryTemplate?: {
      __typename?: 'LibraryTemplate'
      id: string
      templateName: string
      templateData?: any | null
    } | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
  }
}

export type RegisterItemAttributesFragment = {
  __typename?: 'RegisterItem'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  followUpAt?: string | null
  status?: RegisterItemStatus | null
  identifier: number
  fullIdentifier: string
  name: string
  projects?: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  } | null> | null
  bookings?: Array<{
    __typename?: 'RegisterItemBooking'
    id: string
    title?: string | null
    startDate: string
    endDate: string
  } | null> | null
  registerItemType?: {
    __typename?: 'RegisterItemType'
    id: string
    name: string
  } | null
  checklistTemplates?: Array<{
    __typename?: 'Template'
    id: string
    templateName: string
    templateData?: any | null
  } | null> | null
  checklistTemplateResponses?: Array<{
    __typename?: 'TemplateResponse'
    id: string
  } | null> | null
  assignees?: Array<{
    __typename?: 'Assignee'
    id: string
    type?: AssigneeType | null
    worker?: {
      __typename?: 'Worker'
      id: string
      trade?: string | null
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    } | null
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      projects?: Array<{ __typename?: 'Project'; name: string } | null> | null
    } | null
  } | null> | null
  templateResponse: {
    __typename?: 'TemplateResponse'
    id: string
    updatedAt: string
    responseData?: any | null
  }
  typeTemplateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    updatedAt: string
    responseData?: any | null
  } | null
  register: {
    __typename?: 'Register'
    identifierPrefix: string
    typeLibraryTemplateId?: string | null
    typeLibraryTemplate?: {
      __typename?: 'LibraryTemplate'
      templateName: string
    } | null
    template: { __typename?: 'Template'; templateData?: any | null }
    settings?: {
      __typename?: 'RegisterSettings'
      canAssignItemsToProject?: boolean | null
      canAssignMultipleProjects?: boolean | null
      canAssignChecklists?: boolean | null
      canSubcontractorsManageItems?: boolean | null
      hideAssignees?: boolean | null
      hideFollowUpDate?: boolean | null
      hideIdentifier?: boolean | null
    } | null
  }
}

export type RegisterItemUiQueryVariables = Exact<{
  identifierPrefix: Scalars['String']
  identifier: Scalars['Int']
}>

export type RegisterItemUiQuery = {
  __typename?: 'Query'
  registerItem?: {
    __typename?: 'RegisterItem'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    followUpAt?: string | null
    status?: RegisterItemStatus | null
    identifier: number
    fullIdentifier: string
    name: string
    uploadTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      updatedAt: string
    } | null
    reviewTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      updatedAt: string
    } | null
    registerItemType?: {
      __typename?: 'RegisterItemType'
      id: string
      name: string
      reviewTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
    } | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    bookings?: Array<{
      __typename?: 'RegisterItemBooking'
      id: string
      title?: string | null
      startDate: string
      endDate: string
    } | null> | null
    checklistTemplates?: Array<{
      __typename?: 'Template'
      id: string
      templateName: string
      templateData?: any | null
    } | null> | null
    checklistTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
    } | null> | null
    assignees?: Array<{
      __typename?: 'Assignee'
      id: string
      type?: AssigneeType | null
      worker?: {
        __typename?: 'Worker'
        id: string
        trade?: string | null
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null>
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
        projects?: Array<{ __typename?: 'Project'; name: string } | null> | null
      } | null
    } | null> | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    }
    typeTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    } | null
    register: {
      __typename?: 'Register'
      identifierPrefix: string
      typeLibraryTemplateId?: string | null
      typeLibraryTemplate?: {
        __typename?: 'LibraryTemplate'
        templateName: string
      } | null
      template: { __typename?: 'Template'; templateData?: any | null }
      settings?: {
        __typename?: 'RegisterSettings'
        canAssignItemsToProject?: boolean | null
        canAssignMultipleProjects?: boolean | null
        canAssignChecklists?: boolean | null
        canSubcontractorsManageItems?: boolean | null
        hideAssignees?: boolean | null
        hideFollowUpDate?: boolean | null
        hideIdentifier?: boolean | null
      } | null
    }
  } | null
}

export type CreateRegisterItemUiMutationVariables = Exact<{
  input: CreateRegisterItemInput
}>

export type CreateRegisterItemUiMutation = {
  __typename?: 'Mutation'
  createRegisterItem: {
    __typename?: 'RegisterItem'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    followUpAt?: string | null
    status?: RegisterItemStatus | null
    identifier: number
    fullIdentifier: string
    name: string
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    bookings?: Array<{
      __typename?: 'RegisterItemBooking'
      id: string
      title?: string | null
      startDate: string
      endDate: string
    } | null> | null
    registerItemType?: {
      __typename?: 'RegisterItemType'
      id: string
      name: string
    } | null
    checklistTemplates?: Array<{
      __typename?: 'Template'
      id: string
      templateName: string
      templateData?: any | null
    } | null> | null
    checklistTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
    } | null> | null
    assignees?: Array<{
      __typename?: 'Assignee'
      id: string
      type?: AssigneeType | null
      worker?: {
        __typename?: 'Worker'
        id: string
        trade?: string | null
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null>
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
        projects?: Array<{ __typename?: 'Project'; name: string } | null> | null
      } | null
    } | null> | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    }
    typeTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    } | null
    register: {
      __typename?: 'Register'
      identifierPrefix: string
      typeLibraryTemplateId?: string | null
      typeLibraryTemplate?: {
        __typename?: 'LibraryTemplate'
        templateName: string
      } | null
      template: { __typename?: 'Template'; templateData?: any | null }
      settings?: {
        __typename?: 'RegisterSettings'
        canAssignItemsToProject?: boolean | null
        canAssignMultipleProjects?: boolean | null
        canAssignChecklists?: boolean | null
        canSubcontractorsManageItems?: boolean | null
        hideAssignees?: boolean | null
        hideFollowUpDate?: boolean | null
        hideIdentifier?: boolean | null
      } | null
    }
  }
}

export type UpdateRegisterItemUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateRegisterItemInput
}>

export type UpdateRegisterItemUiMutation = {
  __typename?: 'Mutation'
  updateRegisterItem: {
    __typename?: 'RegisterItem'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    followUpAt?: string | null
    status?: RegisterItemStatus | null
    identifier: number
    fullIdentifier: string
    name: string
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    bookings?: Array<{
      __typename?: 'RegisterItemBooking'
      id: string
      title?: string | null
      startDate: string
      endDate: string
    } | null> | null
    registerItemType?: {
      __typename?: 'RegisterItemType'
      id: string
      name: string
    } | null
    checklistTemplates?: Array<{
      __typename?: 'Template'
      id: string
      templateName: string
      templateData?: any | null
    } | null> | null
    checklistTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
    } | null> | null
    assignees?: Array<{
      __typename?: 'Assignee'
      id: string
      type?: AssigneeType | null
      worker?: {
        __typename?: 'Worker'
        id: string
        trade?: string | null
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null>
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
        projects?: Array<{ __typename?: 'Project'; name: string } | null> | null
      } | null
    } | null> | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    }
    typeTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    } | null
    register: {
      __typename?: 'Register'
      identifierPrefix: string
      typeLibraryTemplateId?: string | null
      typeLibraryTemplate?: {
        __typename?: 'LibraryTemplate'
        templateName: string
      } | null
      template: { __typename?: 'Template'; templateData?: any | null }
      settings?: {
        __typename?: 'RegisterSettings'
        canAssignItemsToProject?: boolean | null
        canAssignMultipleProjects?: boolean | null
        canAssignChecklists?: boolean | null
        canSubcontractorsManageItems?: boolean | null
        hideAssignees?: boolean | null
        hideFollowUpDate?: boolean | null
        hideIdentifier?: boolean | null
      } | null
    }
  }
}

export type ArchiveRegisterItemUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveRegisterItemUiMutation = {
  __typename?: 'Mutation'
  archiveRegisterItem: {
    __typename?: 'RegisterItem'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    followUpAt?: string | null
    status?: RegisterItemStatus | null
    identifier: number
    fullIdentifier: string
    name: string
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    bookings?: Array<{
      __typename?: 'RegisterItemBooking'
      id: string
      title?: string | null
      startDate: string
      endDate: string
    } | null> | null
    registerItemType?: {
      __typename?: 'RegisterItemType'
      id: string
      name: string
    } | null
    checklistTemplates?: Array<{
      __typename?: 'Template'
      id: string
      templateName: string
      templateData?: any | null
    } | null> | null
    checklistTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
    } | null> | null
    assignees?: Array<{
      __typename?: 'Assignee'
      id: string
      type?: AssigneeType | null
      worker?: {
        __typename?: 'Worker'
        id: string
        trade?: string | null
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null>
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
        projects?: Array<{ __typename?: 'Project'; name: string } | null> | null
      } | null
    } | null> | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    }
    typeTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    } | null
    register: {
      __typename?: 'Register'
      identifierPrefix: string
      typeLibraryTemplateId?: string | null
      typeLibraryTemplate?: {
        __typename?: 'LibraryTemplate'
        templateName: string
      } | null
      template: { __typename?: 'Template'; templateData?: any | null }
      settings?: {
        __typename?: 'RegisterSettings'
        canAssignItemsToProject?: boolean | null
        canAssignMultipleProjects?: boolean | null
        canAssignChecklists?: boolean | null
        canSubcontractorsManageItems?: boolean | null
        hideAssignees?: boolean | null
        hideFollowUpDate?: boolean | null
        hideIdentifier?: boolean | null
      } | null
    }
  }
}

export type RestoreRegisterItemUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreRegisterItemUiMutation = {
  __typename?: 'Mutation'
  restoreRegisterItem: {
    __typename?: 'RegisterItem'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    followUpAt?: string | null
    status?: RegisterItemStatus | null
    identifier: number
    fullIdentifier: string
    name: string
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    bookings?: Array<{
      __typename?: 'RegisterItemBooking'
      id: string
      title?: string | null
      startDate: string
      endDate: string
    } | null> | null
    registerItemType?: {
      __typename?: 'RegisterItemType'
      id: string
      name: string
    } | null
    checklistTemplates?: Array<{
      __typename?: 'Template'
      id: string
      templateName: string
      templateData?: any | null
    } | null> | null
    checklistTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
    } | null> | null
    assignees?: Array<{
      __typename?: 'Assignee'
      id: string
      type?: AssigneeType | null
      worker?: {
        __typename?: 'Worker'
        id: string
        trade?: string | null
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null>
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
        projects?: Array<{ __typename?: 'Project'; name: string } | null> | null
      } | null
    } | null> | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    }
    typeTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    } | null
    register: {
      __typename?: 'Register'
      identifierPrefix: string
      typeLibraryTemplateId?: string | null
      typeLibraryTemplate?: {
        __typename?: 'LibraryTemplate'
        templateName: string
      } | null
      template: { __typename?: 'Template'; templateData?: any | null }
      settings?: {
        __typename?: 'RegisterSettings'
        canAssignItemsToProject?: boolean | null
        canAssignMultipleProjects?: boolean | null
        canAssignChecklists?: boolean | null
        canSubcontractorsManageItems?: boolean | null
        hideAssignees?: boolean | null
        hideFollowUpDate?: boolean | null
        hideIdentifier?: boolean | null
      } | null
    }
  }
}

export type SubmitRegisterItemReviewUiMutationVariables = Exact<{
  id: Scalars['String']
  input: SubmitRegisterItemReviewInput
}>

export type SubmitRegisterItemReviewUiMutation = {
  __typename?: 'Mutation'
  submitRegisterItemReview: {
    __typename?: 'RegisterItem'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    followUpAt?: string | null
    status?: RegisterItemStatus | null
    identifier: number
    fullIdentifier: string
    name: string
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    bookings?: Array<{
      __typename?: 'RegisterItemBooking'
      id: string
      title?: string | null
      startDate: string
      endDate: string
    } | null> | null
    registerItemType?: {
      __typename?: 'RegisterItemType'
      id: string
      name: string
    } | null
    checklistTemplates?: Array<{
      __typename?: 'Template'
      id: string
      templateName: string
      templateData?: any | null
    } | null> | null
    checklistTemplateResponses?: Array<{
      __typename?: 'TemplateResponse'
      id: string
    } | null> | null
    assignees?: Array<{
      __typename?: 'Assignee'
      id: string
      type?: AssigneeType | null
      worker?: {
        __typename?: 'Worker'
        id: string
        trade?: string | null
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null>
      } | null
      adminUser?: {
        __typename?: 'AdminUser'
        id: string
        user: {
          __typename?: 'User'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
        projects?: Array<{ __typename?: 'Project'; name: string } | null> | null
      } | null
    } | null> | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    }
    typeTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      updatedAt: string
      responseData?: any | null
    } | null
    register: {
      __typename?: 'Register'
      identifierPrefix: string
      typeLibraryTemplateId?: string | null
      typeLibraryTemplate?: {
        __typename?: 'LibraryTemplate'
        templateName: string
      } | null
      template: { __typename?: 'Template'; templateData?: any | null }
      settings?: {
        __typename?: 'RegisterSettings'
        canAssignItemsToProject?: boolean | null
        canAssignMultipleProjects?: boolean | null
        canAssignChecklists?: boolean | null
        canSubcontractorsManageItems?: boolean | null
        hideAssignees?: boolean | null
        hideFollowUpDate?: boolean | null
        hideIdentifier?: boolean | null
      } | null
    }
  }
}

export type RegisterItemBookingAttributesFragment = {
  __typename?: 'RegisterItemBooking'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  startDate: string
  endDate: string
  title?: string | null
  registerItem: {
    __typename?: 'RegisterItem'
    id: string
    name: string
    fullIdentifier: string
  }
}

export type RegisterItemBookingsUiQueryVariables = Exact<{
  filter: RegisterItemBookingFilterInput
}>

export type RegisterItemBookingsUiQuery = {
  __typename?: 'Query'
  registerItemBookings: Array<{
    __typename?: 'RegisterItemBooking'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    startDate: string
    endDate: string
    title?: string | null
    registerItem: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      fullIdentifier: string
    }
  }>
}

export type CreateRegisterItemBookingUiMutationVariables = Exact<{
  input: CreateRegisterItemBookingInput
}>

export type CreateRegisterItemBookingUiMutation = {
  __typename?: 'Mutation'
  createRegisterItemBooking: {
    __typename?: 'RegisterItemBooking'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    startDate: string
    endDate: string
    title?: string | null
    registerItem: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      fullIdentifier: string
    }
  }
}

export type UpdateRegisterItemBookingUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateRegisterItemBookingInput
}>

export type UpdateRegisterItemBookingUiMutation = {
  __typename?: 'Mutation'
  updateRegisterItemBooking: {
    __typename?: 'RegisterItemBooking'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    startDate: string
    endDate: string
    title?: string | null
    registerItem: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      fullIdentifier: string
    }
  }
}

export type ArchiveRegisterItemBookingUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveRegisterItemBookingUiMutation = {
  __typename?: 'Mutation'
  archiveRegisterItemBooking: {
    __typename?: 'RegisterItemBooking'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    startDate: string
    endDate: string
    title?: string | null
    registerItem: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      fullIdentifier: string
    }
  }
}

export type RestoreRegisterItemBookingUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreRegisterItemBookingUiMutation = {
  __typename?: 'Mutation'
  restoreRegisterItemBooking: {
    __typename?: 'RegisterItemBooking'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    startDate: string
    endDate: string
    title?: string | null
    registerItem: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      fullIdentifier: string
    }
  }
}

export type RegisterItemsForSearchUiQueryVariables = Exact<{
  filter?: InputMaybe<RegisterItemFilterInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type RegisterItemsForSearchUiQuery = {
  __typename?: 'Query'
  registerItems: Array<{
    __typename?: 'RegisterItem'
    id: string
    identifier: number
    name: string
    register: {
      __typename?: 'Register'
      id: string
      name: string
      identifierPrefix: string
    }
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
  }>
}

export type WorkerRegistersUiQueryVariables = Exact<{
  filter?: InputMaybe<RegistersWorkerFilterInput>
}>

export type WorkerRegistersUiQuery = {
  __typename?: 'Query'
  registers_worker: Array<{
    __typename?: 'Register_Worker'
    id: string
    name: string
    identifierPrefix: string
    builder: {
      __typename?: 'BuilderEntity'
      id: string
      company?: { __typename?: 'Company'; name: string } | null
    }
  }>
}

export type WorkerRegisterUiQueryVariables = Exact<{
  registerId: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
}>

export type WorkerRegisterUiQuery = {
  __typename?: 'Query'
  register_worker?: {
    __typename?: 'Register_Worker'
    id: string
    name: string
    identifierPrefix: string
    items: Array<{
      __typename?: 'RegisterItem_Worker'
      id: string
      name: string
      status: RegisterItemStatus
      identifier: number
      fullIdentifier: string
    }>
  } | null
}

export type RegisterItemsPublicUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
  projectId: Scalars['String']
}>

export type RegisterItemsPublicUiQuery = {
  __typename?: 'Query'
  registerItems_public: Array<{
    __typename?: 'RegisterItem_Public'
    id: string
    name: string
    status: string
    createdAt: string
    register?: { __typename?: 'Register'; id: string; name: string } | null
    registerItemType?: {
      __typename?: 'RegisterItemType'
      id: string
      name: string
    } | null
    projects?: Array<{
      __typename?: 'PublicProject'
      id: string
      name: string
    }> | null
  }>
}

export type WorkerRegisterItemUiQueryVariables = Exact<{
  registerId: Scalars['String']
  registerItemId: Scalars['String']
}>

export type WorkerRegisterItemUiQuery = {
  __typename?: 'Query'
  registerItem_worker?: {
    __typename?: 'RegisterItem_Worker'
    id: string
    name: string
    status: RegisterItemStatus
    identifier: number
    fullIdentifier: string
    register: {
      __typename?: 'Register_Worker'
      typeLibraryTemplateId?: string | null
    }
    typeTemplateResponse?: {
      __typename?: 'TemplateResponseEntity'
      id: string
      updatedAt: string
      responseData?: any | null
    } | null
    templateResponse?: {
      __typename?: 'TemplateResponseEntity'
      id: string
      updatedAt: string
      responseData?: any | null
    } | null
    checklistTemplates?: Array<{
      __typename?: 'TemplateEntity'
      id: string
      templateName: string
    } | null> | null
  } | null
}

export type RegisterItemPublicUiQueryVariables = Exact<{
  id: Scalars['String']
  subcontractorId: Scalars['String']
}>

export type RegisterItemPublicUiQuery = {
  __typename?: 'Query'
  registerItem_public: {
    __typename?: 'RegisterItem_Public'
    id: string
    name: string
    status: string
    typeTemplateResponse?: any | null
    templateResponse?: any | null
    uploadTemplateResponse?: any | null
    companyRegisterItem?: {
      __typename?: 'CompanyRegisterItem'
      id: string
      name: string
      typeTemplateResponse?: any | null
    } | null
    register?: { __typename?: 'Register'; id: string; name: string } | null
    registerItemType?: {
      __typename?: 'RegisterItemType'
      id: string
      name: string
    } | null
    checklistTemplates: Array<{
      __typename?: 'TemplateEntity'
      id: string
      templateName: string
      templateData?: any | null
    }>
  }
}

export type RegisterPublicUiQueryVariables = Exact<{
  id: Scalars['String']
  subcontractorId: Scalars['String']
}>

export type RegisterPublicUiQuery = {
  __typename?: 'Query'
  register_public: {
    __typename?: 'Register_Public'
    id: string
    name: string
    template: { __typename?: 'TemplateEntity'; templateData?: any | null }
    typeLibraryTemplate?: {
      __typename?: 'LibraryTemplate'
      templateData?: any | null
    } | null
    settings?: {
      __typename?: 'RegisterSettings'
      canAssignItemsToProject?: boolean | null
      canAssignChecklists?: boolean | null
      hideFollowUpDate?: boolean | null
    } | null
  }
}

export type RegistersPublicUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
  builderId?: InputMaybe<Scalars['String']>
  projectId?: InputMaybe<Scalars['String']>
}>

export type RegistersPublicUiQuery = {
  __typename?: 'Query'
  registers_public: Array<{
    __typename?: 'Register_Public'
    id: string
    name: string
  }>
}

export type CreateRegisterItemPublicUiMutationVariables = Exact<{
  subcontractorId: Scalars['String']
  input: CreateRegisterItemPublicInput
}>

export type CreateRegisterItemPublicUiMutation = {
  __typename?: 'Mutation'
  createRegisterItem_public: { __typename?: 'RegisterItem_Public'; id: string }
}

export type ArchiveRegisterItemPublicUiMutationVariables = Exact<{
  id: Scalars['String']
  subcontractorId: Scalars['String']
}>

export type ArchiveRegisterItemPublicUiMutation = {
  __typename?: 'Mutation'
  archiveRegisterItem_public: { __typename?: 'RegisterItem_Public'; id: string }
}

export type GetPlatformUsageUiQueryVariables = Exact<{
  filter?: InputMaybe<PlatformUsageReportFilterInput>
}>

export type GetPlatformUsageUiQuery = {
  __typename?: 'Query'
  getPlatformUsage: {
    __typename?: 'PlatformUsageReport'
    inductions: number
    numberOfVisitors: number
    subcontractors: number
    toolboxes: number
    insurances: number
    preStarts: number
    checklists: number
    actions: number
    communications: number
    siteDiariesCount: number
    workers?: {
      __typename?: 'WorkerUsage'
      numberOfUsers: number
      numberOfWorkers: number
      numberOfManuallyCreatedWorkers: number
      vaccineStatus?: {
        __typename?: 'WorkerVaccineStatus'
        firstVaccine: number
        secondVaccine: number
        thirdVaccine: number
        exemption: number
        noVaccine: number
      } | null
    } | null
    signOns?: {
      __typename?: 'SignOnsUsage'
      total: number
      manual: number
      visitor: number
    } | null
    SWMS?: {
      __typename?: 'SWMSUsage'
      total: number
      reviewed: number
      pendingReview: number
      requestedChanges: number
    } | null
    checklistReport?: {
      __typename?: 'ChecklistUsage'
      started: number
      completed: number
      topCategories: Array<{
        __typename?: 'TopChecklistCategories'
        name: string
        completed: number
      }>
    } | null
    defects?: {
      __typename?: 'DefectsUsage'
      total: number
      inProgress: number
      resolved: number
      overdue: number
      waitingReview: number
      incompleteWorks: number
      builderDefects: number
      clientDefects: number
    } | null
    siteDiaries?: {
      __typename?: 'SiteDiaryUsage'
      total: number
      projectHours: number
      numberOfWorkers: number
      numberOfSubcontractors: number
      inclementWeatherHours?: number | null
    } | null
  }
}

export type GetPlatformAggregationUiQueryVariables = Exact<{
  filter?: InputMaybe<PlatformUsagAggregationFilterInput>
}>

export type GetPlatformAggregationUiQuery = {
  __typename?: 'Query'
  getPlatformAggregation: {
    __typename?: 'PlatformAggregationReport'
    newAudits: number
    totalAudits: number
    newUsers: number
    totalUsers: number
    newProjects: number
    totalProjects: number
    newBuilders?: number | null
    totalBuilders?: number | null
    newWorkers: number
    totalWorkers: number
    totalWorkerActions: number
    newAdminUsers: number
    totalAdminUsers: number
    totalAdminUserActions: number
    newSubcontractors: number
    totalSubcontractors: number
    totalSubcontractorActions: number
    newDefects: number
    totalDefects: number
    historicalPlatformUsage?: Array<{
      __typename?: 'HistoricPlatformUsage'
      newAudits: number
      adminUsersToDate: number
      month: string
    } | null> | null
  }
}

export type GetPlatformEngagementUiQueryVariables = Exact<{
  filter?: InputMaybe<PlatformEngagementFilterInput>
}>

export type GetPlatformEngagementUiQuery = {
  __typename?: 'Query'
  getPlatformEngagement: {
    __typename?: 'PlatformEngagementReport'
    builders?: Array<{
      __typename?: 'EngagmentAggregation'
      resourceName?: string | null
      resourceId?: string | null
      actions?: string | null
      date?: string | null
    } | null> | null
    totalAuditsPerBuilder?: Array<{
      __typename?: 'EngagmentAggregation'
      resourceName?: string | null
      resourceId?: string | null
      actions?: string | null
    } | null> | null
    totalAuditsPerFeature?: Array<{
      __typename?: 'EngagmentAggregation'
      resourceName?: string | null
      resourceId?: string | null
      actions?: string | null
    } | null> | null
    features?: Array<{
      __typename?: 'EngagmentAggregation'
      resourceName?: string | null
      actions?: string | null
      date?: string | null
    } | null> | null
    metadata?: {
      __typename?: 'EngagmentMetadata'
      builders?: Array<{
        __typename?: 'Builder'
        id: string
        isDemo?: boolean | null
        company: { __typename?: 'Company'; name: string }
      } | null> | null
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
      adminUsers?: Array<{ __typename?: 'AdminUser'; id: string } | null> | null
    } | null
    builderEngagement?: {
      __typename?: 'BuilderEngagement'
      latestProject?: {
        __typename?: 'Project'
        id: string
        name: string
        createdAt: string
      } | null
      latestSignOn?: {
        __typename?: 'SignOn'
        id: string
        createdAt: string
        project?: { __typename?: 'Project'; name: string } | null
      } | null
      latestAudit?: {
        __typename?: 'AuditLog'
        id: string
        createdAt: string
        action: AuditAction
        actionBy?: AuditActionedBy | null
        resource: AuditResource
      } | null
      latestAdminUserAudit?: {
        __typename?: 'AuditLog'
        id: string
        createdAt: string
        action: AuditAction
        actionBy?: AuditActionedBy | null
        resource: AuditResource
      } | null
    } | null
  }
}

export type GetSubcontractorReportUiQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorReportFilterInput>
}>

export type GetSubcontractorReportUiQuery = {
  __typename?: 'Query'
  getSubcontractorReport: {
    __typename?: 'SubcontractorsReport'
    subcontractors: Array<{
      __typename?: 'SubcontractorReport'
      id: string
      name: string
      numberOfWorkers: number
      projectHours: number
      projectHoursByDate: Array<{
        __typename?: 'ProjectHoursByDate'
        date: string
        projectHours: number
      }>
      workers?: Array<{
        __typename?: 'WorkerReport'
        id?: string | null
        name: string
        projectHours: number
      }> | null
    }>
  }
}

export type GetDefectReportUiQueryVariables = Exact<{
  filter?: InputMaybe<DefectReportFilterInput>
}>

export type GetDefectReportUiQuery = {
  __typename?: 'Query'
  getDefectReport: {
    __typename?: 'DefectReport'
    statistics: {
      __typename?: 'DefectsUsage'
      total: number
      inProgress: number
      resolved: number
      overdue: number
      waitingReview: number
      incompleteWorks: number
      builderDefects: number
      clientDefects: number
    }
    overdue: Array<{
      __typename?: 'Defect'
      id: string
      createdAt: string
      updatedAt: string
      archivedAt?: string | null
      completedAt?: string | null
      distributedAt?: string | null
      dueDate?: string | null
      status: DefectStatus
      priority?: DefectPriority | null
      title?: string | null
      description?: string | null
      type?: string | null
      order?: number | null
      overdue?: boolean | null
      tags?: Array<string> | null
      nextDefectId?: string | null
      previousDefectId?: string | null
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      project: {
        __typename?: 'Project'
        id: string
        name: string
        status: ProjectStatus
        timezone?: string | null
      }
      assignees: Array<{
        __typename?: 'Assignee'
        id: string
        worker?: {
          __typename?: 'Worker'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        adminUser?: {
          __typename?: 'AdminUser'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        subcontractor?: {
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null
      } | null>
      attachments?: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        fileName: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      } | null> | null
      location?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                        parent?: {
                          __typename?: 'ProjectLocation'
                          id: string
                          name: string
                          order: number
                        } | null
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
      conversation?: {
        __typename?: 'ConversationThread'
        id: string
        messages: Array<{
          __typename?: 'ConversationMessage'
          id: string
          createdAt: string
          content?: string | null
          sender: {
            __typename?: 'Assignee'
            id: string
            worker?: {
              __typename?: 'Worker'
              id: string
              user: {
                __typename?: 'User'
                id: string
                firstName: string
                lastName: string
              }
            } | null
            adminUser?: {
              __typename?: 'AdminUser'
              id: string
              user: {
                __typename?: 'User'
                id: string
                firstName: string
                lastName: string
              }
            } | null
            subcontractor?: {
              __typename?: 'Subcontractor'
              id: string
              company: { __typename?: 'Company'; name: string }
            } | null
          }
          attachments: Array<{
            __typename?: 'Attachment'
            id: string
            url: string
            thumbnail?: {
              __typename?: 'Thumbnail'
              small?: string | null
            } | null
          } | null>
        } | null>
      } | null
    }>
    waitingReview: Array<{
      __typename?: 'Defect'
      id: string
      createdAt: string
      updatedAt: string
      archivedAt?: string | null
      completedAt?: string | null
      distributedAt?: string | null
      dueDate?: string | null
      status: DefectStatus
      priority?: DefectPriority | null
      title?: string | null
      description?: string | null
      type?: string | null
      order?: number | null
      overdue?: boolean | null
      tags?: Array<string> | null
      nextDefectId?: string | null
      previousDefectId?: string | null
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      project: {
        __typename?: 'Project'
        id: string
        name: string
        status: ProjectStatus
        timezone?: string | null
      }
      assignees: Array<{
        __typename?: 'Assignee'
        id: string
        worker?: {
          __typename?: 'Worker'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        adminUser?: {
          __typename?: 'AdminUser'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        subcontractor?: {
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
        } | null
      } | null>
      attachments?: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        fileName: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      } | null> | null
      location?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                        parent?: {
                          __typename?: 'ProjectLocation'
                          id: string
                          name: string
                          order: number
                        } | null
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
      conversation?: {
        __typename?: 'ConversationThread'
        id: string
        messages: Array<{
          __typename?: 'ConversationMessage'
          id: string
          createdAt: string
          content?: string | null
          sender: {
            __typename?: 'Assignee'
            id: string
            worker?: {
              __typename?: 'Worker'
              id: string
              user: {
                __typename?: 'User'
                id: string
                firstName: string
                lastName: string
              }
            } | null
            adminUser?: {
              __typename?: 'AdminUser'
              id: string
              user: {
                __typename?: 'User'
                id: string
                firstName: string
                lastName: string
              }
            } | null
            subcontractor?: {
              __typename?: 'Subcontractor'
              id: string
              company: { __typename?: 'Company'; name: string }
            } | null
          }
          attachments: Array<{
            __typename?: 'Attachment'
            id: string
            url: string
            thumbnail?: {
              __typename?: 'Thumbnail'
              small?: string | null
            } | null
          } | null>
        } | null>
      } | null
    }>
  }
}

export type GetProjectHoursBudgetReportUiQueryVariables = Exact<{
  filter: ProjectHoursBudgetReportFilterInput
}>

export type GetProjectHoursBudgetReportUiQuery = {
  __typename?: 'Query'
  getProjectHoursBudgetReport?: {
    __typename?: 'ProjectHoursBudgetReport'
    lastLoggedCompletionPercentage?: number | null
    completionLastLoggedAt?: string | null
    status: BudgetStatus
    totalHours: number
    projectHoursByDate: Array<{
      __typename?: 'ProjectHoursByDate'
      date: string
      projectHours: number
    }>
    projectCompletionByDate: Array<{
      __typename?: 'ProjectCompletionByDate'
      date: string
      completionPercentage: number
    }>
    subcontractors?: Array<{
      __typename?: 'SubcontractorReport'
      id: string
      name: string
      numberOfWorkers: number
      projectHours: number
      projectHoursByDate: Array<{
        __typename?: 'ProjectHoursByDate'
        date: string
        projectHours: number
      }>
      workers?: Array<{
        __typename?: 'WorkerReport'
        id?: string | null
        name: string
        projectHours: number
      }> | null
    }> | null
  } | null
}

export type GetAllProjectHoursBudgetReportsUiQueryVariables = Exact<{
  filter?: InputMaybe<AllProjectHoursBudgetReportFilterInput>
}>

export type GetAllProjectHoursBudgetReportsUiQuery = {
  __typename?: 'Query'
  getAllProjectHoursBudgetReports: {
    __typename?: 'AllProjectHoursBudgetReport'
    projects: Array<{
      __typename?: 'AllProjectHoursBudgetReportProject'
      projectId: string
      budget?: number | null
      projectHours?: number | null
      percentageHoursUsed?: number | null
      status: BudgetStatus
      project: { __typename?: 'Project'; name: string }
    }>
  }
}

export type GetProjectHoursBudgetReportForSiteDiaryUiQueryVariables = Exact<{
  siteDiaryId: Scalars['String']
}>

export type GetProjectHoursBudgetReportForSiteDiaryUiQuery = {
  __typename?: 'Query'
  getProjectHoursBudgetReportForSiteDiary?: {
    __typename?: 'ProjectHoursBudgetReport'
    lastLoggedCompletionPercentage?: number | null
    status: BudgetStatus
    totalHours: number
    subcontractors?: Array<{
      __typename?: 'SubcontractorReport'
      id: string
      name: string
      numberOfWorkers: number
      projectHours: number
    }> | null
  } | null
}

export type TemplateResponseDisplayPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type TemplateResponseDisplayPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | {
        __typename?: 'DeactivatedResourceLinkEntity'
        id: string
        active: boolean
      }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          hideBuildPassLogos?: boolean | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        templateResponse?: {
          __typename?: 'TemplateResponse_ResourceLink'
          id: string
          createdAt: string
          updatedAt?: string | null
          completedAt?: string | null
          responseData?: any | null
          templateName?: string | null
          author?: string | null
          project?: {
            __typename?: 'Project_ResourceLink'
            id: string
            name: string
            address?: string | null
            timezone?: string | null
            country?: string | null
            locale?: SupportedLocaleCountryCode | null
            builder?: {
              __typename?: 'Builder_ResourceLink'
              defaultLocale?: SupportedLocaleCountryCode | null
              defaultTimezone?: string | null
              company: { __typename?: 'Company_ResourceLink'; name: string }
            } | null
          } | null
          location?: {
            __typename?: 'ProjectLocation_ResourceLink'
            name: string
            fullLocationName: string
          } | null
        } | null
      }
    | null
}

export type SwmsDocPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type SwmsDocPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | {
        __typename?: 'DeactivatedResourceLinkEntity'
        id: string
        active: boolean
      }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          hideBuildPassLogos?: boolean | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        swmsDoc?: {
          __typename?: 'SwmsDocEntity'
          createdAt: string
          updatedAt: string
          status: SwmsStatus
          id: string
          name: string
          url?: string | null
          checklist?: any | null
          review?: string | null
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            company: { __typename?: 'Company_ResourceLink'; name: string }
          } | null
          templateResponse?: {
            __typename?: 'TemplateResponseEntity'
            responseData?: any | null
          } | null
          checklistTemplateResponse?: {
            __typename?: 'TemplateResponseEntity'
            id: string
            responseData?: any | null
          } | null
          activityLogs?: Array<{
            __typename?: 'AuditLog_ResourceLink'
            id: string
            createdAt: string
            action: AuditAction
            actionBy?: AuditActionedBy | null
            actionByIdentity?: string | null
            resource: AuditResource
            resourceIdentity?: string | null
            newSnapshot?: any | null
            oldSnapshot?: any | null
            actionByLink?:
              | {
                  __typename?: 'AdminUser_ResourceLink'
                  user: {
                    __typename?: 'User_ResourceLink'
                    id: string
                    firstName: string
                    lastName: string
                  }
                }
              | {
                  __typename?: 'Subcontractor_ResourceLink'
                  id: string
                  company: { __typename?: 'Company_ResourceLink'; name: string }
                }
              | {
                  __typename?: 'WorkerAudit_ResourceLink'
                  user: {
                    __typename?: 'User_ResourceLink'
                    id: string
                    firstName: string
                    lastName: string
                  }
                }
              | null
          } | null> | null
          project: {
            __typename?: 'ProjectEntity'
            id: string
            name: string
            timezone?: string | null
            country?: string | null
            locale?: SupportedLocaleCountryCode | null
            builder?: {
              __typename?: 'BuilderEntityPublic'
              defaultLocale?: SupportedLocaleCountryCode | null
              defaultTimezone?: string | null
              company?: { __typename?: 'Company'; name: string } | null
            } | null
          }
          documentSignatures: Array<{
            __typename?: 'DocumentSignatureEntity'
            id: string
            createdAt: string
            signatureUrl: string
            builderGenerated: boolean
            induction?: {
              __typename?: 'InductionEntity'
              type: InductionType
              templateName?: string | null
            } | null
            worker: {
              __typename?: 'Worker_ResourceLink'
              id: string
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            }
            adminUser?: {
              __typename?: 'AdminUser_ResourceLink'
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            } | null
          } | null>
        } | null
      }
    | null
}

export type SiteDiaryPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type SiteDiaryPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | {
        __typename?: 'DeactivatedResourceLinkEntity'
        id: string
        active: boolean
      }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          hideBuildPassLogos?: boolean | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        siteDiary?: {
          __typename?: 'SiteDiary_ResourceLink'
          id: string
          date: string
          project: {
            __typename?: 'Project_ResourceLink'
            id: string
            name: string
            timezone?: string | null
            country?: string | null
            locale?: SupportedLocaleCountryCode | null
            builder?: {
              __typename?: 'Builder_ResourceLink'
              defaultLocale?: SupportedLocaleCountryCode | null
              defaultTimezone?: string | null
              company: { __typename?: 'Company_ResourceLink'; name: string }
            } | null
          }
          templateResponse: {
            __typename?: 'TemplateResponse_ResourceLink'
            id: string
            responseData?: any | null
            author?: string | null
          }
          subcontractors?: Array<{
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
            workers?: Array<{
              __typename?: 'Worker_ResourceLink'
              id: string
              user: {
                __typename?: 'User_ResourceLink'
                id: string
                firstName: string
                lastName: string
              }
            } | null> | null
          }> | null
          signOns?: Array<{
            __typename?: 'SignOn_ResourceLink'
            id: string
            createdAt: string
            signedOffAt?: string | null
            manualSignedOnAt?: string | null
            manualSignedOffAt?: string | null
            signOnHours?: {
              __typename?: 'SignOnHours'
              hours?: number | null
              updatedAt?: string | null
            } | null
            worker?: {
              __typename?: 'Worker_ResourceLink'
              id: string
              user: {
                __typename?: 'User_ResourceLink'
                id: string
                firstName: string
                lastName: string
              }
              subcontractors: Array<{
                __typename?: 'Subcontractor_ResourceLink'
                id: string
                company: { __typename?: 'Company_ResourceLink'; name: string }
                projects?: Array<{
                  __typename?: 'Project_ResourceLink'
                  name: string
                  id: string
                } | null> | null
              } | null>
            } | null
            visitor?: {
              __typename?: 'Visitor_ResourceLink'
              user: {
                __typename?: 'User_ResourceLink'
                id: string
                firstName: string
                lastName: string
              }
            } | null
          }> | null
        } | null
      }
    | null
}

export type ToolboxPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type ToolboxPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | {
        __typename?: 'DeactivatedResourceLinkEntity'
        id: string
        active: boolean
      }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          hideBuildPassLogos?: boolean | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        toolbox?: {
          __typename?: 'Toolbox_ResourceLink'
          date: string
          type: ToolboxType
          status: ToolboxStatus
          agenda?: string | null
          notes?: string | null
          urls?: Array<string | null> | null
          templateResponse?: {
            __typename?: 'TemplateResponse_ResourceLink'
            id: string
            responseData?: any | null
          } | null
          attended: Array<
            | {
                __typename?: 'AdminUser_ResourceLink'
                id: string
                user: {
                  __typename?: 'User_ResourceLink'
                  firstName: string
                  lastName: string
                }
              }
            | {
                __typename?: 'Worker_ResourceLink'
                id: string
                trade?: string | null
                user: {
                  __typename?: 'User_ResourceLink'
                  firstName: string
                  lastName: string
                }
              }
            | null
          >
          invited: Array<
            | {
                __typename?: 'AdminUser_ResourceLink'
                id: string
                user: {
                  __typename?: 'User_ResourceLink'
                  firstName: string
                  lastName: string
                }
              }
            | {
                __typename?: 'Worker_ResourceLink'
                id: string
                trade?: string | null
                user: {
                  __typename?: 'User_ResourceLink'
                  firstName: string
                  lastName: string
                }
              }
            | null
          >
          project: {
            __typename?: 'Project_ResourceLink'
            id: string
            name: string
            status: ProjectStatus
            timezone?: string | null
            country?: string | null
            locale?: SupportedLocaleCountryCode | null
            builder?: {
              __typename?: 'Builder_ResourceLink'
              defaultLocale?: SupportedLocaleCountryCode | null
              defaultTimezone?: string | null
              company: { __typename?: 'Company_ResourceLink'; name: string }
            } | null
          }
          preStart?: {
            __typename?: 'PreStart_ResourceLink'
            signOns: Array<{
              __typename?: 'SignOn_ResourceLink'
              id: string
              createdAt: string
              worker?: {
                __typename?: 'Worker_ResourceLink'
                id: string
                trade?: string | null
                user: {
                  __typename?: 'User_ResourceLink'
                  firstName: string
                  lastName: string
                }
              } | null
              visitor?: {
                __typename?: 'Visitor_ResourceLink'
                user: {
                  __typename?: 'User_ResourceLink'
                  firstName: string
                  lastName: string
                }
              } | null
            } | null>
            template?: {
              __typename?: 'TemplateResponse_ResourceLink'
              completedAt?: string | null
            } | null
          } | null
        } | null
      }
    | null
}

export type PermitPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type PermitPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | {
        __typename?: 'DeactivatedResourceLinkEntity'
        id: string
        active: boolean
      }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          hideBuildPassLogos?: boolean | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        permit?: {
          __typename?: 'Permit_ResourceLink'
          id: string
          name: string
          description?: string | null
          createdAt: string
          updatedAt: string
          startDate: string
          endDate: string
          overallStatus: OverallPermitStatus
          permitType: {
            __typename?: 'PermitType_ResourceLink'
            id: string
            name: string
          }
          workers?: Array<{
            __typename?: 'PermitWorker_ResourceLink'
            id: string
            createdAt: string
            updatedAt: string
            overallStatus: OverallPermitStatus
            worker: {
              __typename?: 'Worker_ResourceLink'
              id: string
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            }
            applicationTemplateResponse?: {
              __typename?: 'TemplateResponse_ResourceLink'
              id: string
              responseData?: any | null
            } | null
            enactingTemplateResponses?: Array<{
              __typename?: 'TemplateResponse_ResourceLink'
              id: string
              createdAt: string
            }> | null
            closeoutTemplateResponse?: {
              __typename?: 'TemplateResponse_ResourceLink'
              id: string
              responseData?: any | null
            } | null
          }> | null
          project: {
            __typename?: 'Project_ResourceLink'
            id: string
            name: string
            status: ProjectStatus
            timezone?: string | null
            country?: string | null
            locale?: SupportedLocaleCountryCode | null
            builder?: {
              __typename?: 'Builder_ResourceLink'
              defaultLocale?: SupportedLocaleCountryCode | null
              defaultTimezone?: string | null
              company: { __typename?: 'Company_ResourceLink'; name: string }
            } | null
          }
        } | null
      }
    | null
}

export type DefectsPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type DefectsPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | {
        __typename?: 'DeactivatedResourceLinkEntity'
        id: string
        active: boolean
      }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          hideBuildPassLogos?: boolean | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        defects?: Array<{
          __typename?: 'Defect_ResourceLink'
          id: string
          createdAt: string
          updatedAt: string
          archivedAt?: string | null
          completedAt?: string | null
          dueDate?: string | null
          status: DefectStatus
          priority?: DefectPriority | null
          title?: string | null
          description?: string | null
          type?: string | null
          order?: number | null
          overdue?: boolean | null
          assigner: {
            __typename?: 'AdminUser_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          }
          project: {
            __typename?: 'Project_ResourceLink'
            id: string
            name: string
            status: ProjectStatus
            country?: string | null
            timezone?: string | null
            locale?: SupportedLocaleCountryCode | null
            builder?: {
              __typename?: 'Builder_ResourceLink'
              defaultLocale?: SupportedLocaleCountryCode | null
              defaultTimezone?: string | null
            } | null
          }
          assignees: Array<{
            __typename?: 'Assignee_ResourceLink'
            id: string
            createdAt: string
            updatedAt: string
            worker?: {
              __typename?: 'Worker_ResourceLink'
              id: string
              user: {
                __typename?: 'User_ResourceLink'
                id: string
                firstName: string
                lastName: string
              }
            } | null
            adminUser?: {
              __typename?: 'AdminUser_ResourceLink'
              id: string
              user: {
                __typename?: 'User_ResourceLink'
                id: string
                firstName: string
                lastName: string
              }
            } | null
            subcontractor?: {
              __typename?: 'Subcontractor_ResourceLink'
              id: string
              company: { __typename?: 'Company_ResourceLink'; name: string }
            } | null
          } | null>
          attachments?: Array<{
            __typename?: 'Attachment_ResourceLink'
            id: string
            url: string
            fileName: string
            thumbnail?: {
              __typename?: 'Thumbnail'
              small?: string | null
            } | null
          } | null> | null
          location?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
            parent?: {
              __typename?: 'ProjectLocation_ResourceLink'
              id: string
              name: string
              parent?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                  parent?: {
                    __typename?: 'ProjectLocation_ResourceLink'
                    id: string
                    name: string
                  } | null
                } | null
              } | null
            } | null
          } | null
          conversation?: {
            __typename?: 'ConversationThread_ResourceLink'
            id: string
            messages?: Array<{
              __typename?: 'ConversationMessage_ResourceLink'
              id: string
              createdAt: string
              content?: string | null
              sender: {
                __typename?: 'Assignee_ResourceLink'
                id: string
                worker?: {
                  __typename?: 'Worker_ResourceLink'
                  id: string
                  user: {
                    __typename?: 'User_ResourceLink'
                    id: string
                    firstName: string
                    lastName: string
                  }
                } | null
                adminUser?: {
                  __typename?: 'AdminUser_ResourceLink'
                  id: string
                  user: {
                    __typename?: 'User_ResourceLink'
                    id: string
                    firstName: string
                    lastName: string
                  }
                } | null
                subcontractor?: {
                  __typename?: 'Subcontractor_ResourceLink'
                  id: string
                  company: { __typename?: 'Company_ResourceLink'; name: string }
                } | null
              }
              attachments?: Array<{
                __typename?: 'Attachment_ResourceLink'
                id: string
                url: string
                fileName: string
                thumbnail?: {
                  __typename?: 'Thumbnail'
                  small?: string | null
                } | null
              }> | null
            }> | null
          } | null
        } | null> | null
      }
    | null
}

export type DocumentSignatureResourceLinkAttributesFragment = {
  __typename?: 'DocumentSignature_ResourceLink'
  createdAt: string
  signatureUrl: string
  builderGenerated: boolean
  worker?: {
    __typename?: 'Worker_ResourceLink'
    id: string
    user: {
      __typename?: 'User_ResourceLink'
      firstName: string
      lastName: string
    }
  } | null
  adminUser?: {
    __typename?: 'AdminUser_ResourceLink'
    user: {
      __typename?: 'User_ResourceLink'
      firstName: string
      lastName: string
    }
  } | null
  induction?: {
    __typename?: 'Induction_ResourceLink'
    id: string
    type: InductionType
    templateName?: string | null
  } | null
  swmsDoc?: { __typename?: 'SwmsDocEntity'; id: string; name: string } | null
}

export type SiteInductionPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type SiteInductionPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | {
        __typename?: 'DeactivatedResourceLinkEntity'
        id: string
        active: boolean
      }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          hideBuildPassLogos?: boolean | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        siteInduction?: {
          __typename?: 'SiteInduction_ResourceLink'
          createdAt: string
          updatedAt: string
          signatureUrl?: string | null
          type: InductionType
          status?: InductionStatus | null
          templateResponse?: {
            __typename?: 'TemplateResponse_ResourceLink'
            id: string
            responseData?: any | null
          } | null
          project: {
            __typename?: 'Project_ResourceLink'
            id: string
            name: string
            status: ProjectStatus
            timezone?: string | null
            country?: string | null
            locale?: SupportedLocaleCountryCode | null
            builder?: {
              __typename?: 'Builder_ResourceLink'
              defaultLocale?: SupportedLocaleCountryCode | null
              defaultTimezone?: string | null
              company: { __typename?: 'Company_ResourceLink'; name: string }
            } | null
          }
          worker: {
            __typename?: 'Worker_ResourceLink'
            dob?: string | null
            mobile?: string | null
            email?: string | null
            address?: string | null
            trade?: string | null
            allergies?: string | null
            medicalInformation?: string | null
            emergencyContact?: string | null
            emergencyContactNumber?: string | null
            emergencyContactRelationship?: string | null
            user: {
              __typename?: 'User_ResourceLink'
              firstName: string
              lastName: string
            }
            tickets?: Array<{
              __typename?: 'Ticket_ResourceLink'
              id: string
              number?: string | null
              countryIssued?: string | null
              stateIssued?: string | null
              ticketTemplate: {
                __typename?: 'TicketTemplate_ResourceLink'
                name: string
                shortName: string
              }
            } | null> | null
            subcontractors: Array<{
              __typename?: 'Subcontractor_ResourceLink'
              company: { __typename?: 'Company_ResourceLink'; name: string }
            } | null>
          }
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
          } | null
          documentSignatures: Array<{
            __typename?: 'DocumentSignature_ResourceLink'
            createdAt: string
            signatureUrl: string
            builderGenerated: boolean
            worker?: {
              __typename?: 'Worker_ResourceLink'
              id: string
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            } | null
            adminUser?: {
              __typename?: 'AdminUser_ResourceLink'
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            } | null
            induction?: {
              __typename?: 'Induction_ResourceLink'
              id: string
              type: InductionType
              templateName?: string | null
            } | null
            swmsDoc?: {
              __typename?: 'SwmsDocEntity'
              id: string
              name: string
            } | null
          } | null>
          reviewer?: {
            __typename?: 'InductionReviewer_ResourceLink'
            reviewedAt: string
            reviewedBy: {
              __typename?: 'AdminUser_ResourceLink'
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            }
          } | null
        } | null
      }
    | null
}

export type CompanyInductionPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type CompanyInductionPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | {
        __typename?: 'DeactivatedResourceLinkEntity'
        id: string
        active: boolean
      }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          hideBuildPassLogos?: boolean | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        companyInduction?: {
          __typename?: 'CompanyInduction_ResourceLink'
          createdAt: string
          updatedAt: string
          type: InductionType
          status?: InductionStatus | null
          templateResponse?: {
            __typename?: 'TemplateResponse_ResourceLink'
            id: string
            responseData?: any | null
          } | null
          worker: {
            __typename?: 'Worker_ResourceLink'
            dob?: string | null
            mobile?: string | null
            email?: string | null
            address?: string | null
            trade?: string | null
            allergies?: string | null
            medicalInformation?: string | null
            emergencyContact?: string | null
            emergencyContactNumber?: string | null
            emergencyContactRelationship?: string | null
            user: {
              __typename?: 'User_ResourceLink'
              firstName: string
              lastName: string
            }
            tickets?: Array<{
              __typename?: 'Ticket_ResourceLink'
              id: string
              number?: string | null
              countryIssued?: string | null
              stateIssued?: string | null
              ticketTemplate: {
                __typename?: 'TicketTemplate_ResourceLink'
                name: string
                shortName: string
              }
            } | null> | null
            subcontractors: Array<{
              __typename?: 'Subcontractor_ResourceLink'
              company: { __typename?: 'Company_ResourceLink'; name: string }
            } | null>
          }
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
          } | null
          documentSignatures: Array<{
            __typename?: 'DocumentSignature_ResourceLink'
            createdAt: string
            signatureUrl: string
            builderGenerated: boolean
            worker?: {
              __typename?: 'Worker_ResourceLink'
              id: string
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            } | null
            adminUser?: {
              __typename?: 'AdminUser_ResourceLink'
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            } | null
            induction?: {
              __typename?: 'Induction_ResourceLink'
              id: string
              type: InductionType
              templateName?: string | null
            } | null
            swmsDoc?: {
              __typename?: 'SwmsDocEntity'
              id: string
              name: string
            } | null
          } | null>
        } | null
      }
    | null
}

export type SignOnsPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type SignOnsPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | { __typename?: 'DeactivatedResourceLinkEntity' }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        extraData?: any | null
        signOns?: Array<{
          __typename?: 'SignOn_ResourceLink'
          id: string
          createdAt: string
          manualSignedOnAt?: string | null
          manualSignedOffAt?: string | null
          signedOffAt?: string | null
          builderGenerated: boolean
          integrationGenerated?: boolean | null
          project?: {
            __typename?: 'Project_ResourceLink'
            id: string
            name: string
            status: ProjectStatus
            timezone?: string | null
          } | null
          worker?: {
            __typename?: 'Worker_ResourceLink'
            id: string
            trade?: string | null
            builderGenerated: boolean
            mobile?: string | null
            subcontractors: Array<{
              __typename?: 'Subcontractor_ResourceLink'
              id: string
              company: { __typename?: 'Company_ResourceLink'; name: string }
            } | null>
            user: {
              __typename?: 'User_ResourceLink'
              firstName: string
              lastName: string
            }
            tickets?: Array<{
              __typename?: 'Ticket_ResourceLink'
              id: string
              expiry?: string | null
              ticketTemplate: {
                __typename?: 'TicketTemplate_ResourceLink'
                name: string
                shortName: string
              }
            } | null> | null
          } | null
          visitor?: {
            __typename?: 'Visitor_ResourceLink'
            user: {
              __typename?: 'User_ResourceLink'
              firstName: string
              lastName: string
            }
          } | null
        } | null> | null
      }
    | null
}

export type RegisterItemPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type RegisterItemPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | { __typename?: 'DeactivatedResourceLinkEntity' }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        extraData?: any | null
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        project?: {
          __typename?: 'Project_ResourceLink'
          id: string
          name: string
          status: ProjectStatus
        } | null
        registerItemResourceLink?: {
          __typename?: 'RegisterItem_ResourceLink'
          id: string
          name: string
          updatedAt: string
          templateResponse: {
            __typename?: 'TemplateResponse_ResourceLink'
            id: string
            updatedAt?: string | null
            responseData?: any | null
          }
        } | null
      }
    | null
}

export type PreStartPdfResourceLinkUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type PreStartPdfResourceLinkUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | {
        __typename?: 'DeactivatedResourceLinkEntity'
        id: string
        active: boolean
      }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          hideBuildPassLogos?: boolean | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        preStart?: {
          __typename?: 'PreStart_ResourceLink'
          id: string
          createdAt: string
          updatedAt: string
          archivedAt?: string | null
          date: string
          endDate?: string | null
          signOns: Array<{
            __typename?: 'SignOn_ResourceLink'
            id: string
            createdAt: string
            builderGenerated: boolean
            worker?: {
              __typename?: 'Worker_ResourceLink'
              id: string
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            } | null
            visitor?: {
              __typename?: 'Visitor_ResourceLink'
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            } | null
          } | null>
          template?: {
            __typename?: 'TemplateResponse_ResourceLink'
            id: string
            responseData?: any | null
            completedAt?: string | null
          } | null
          project?: {
            __typename?: 'Project_ResourceLink'
            id: string
            name: string
            status: ProjectStatus
            timezone?: string | null
            country?: string | null
            locale?: SupportedLocaleCountryCode | null
            builder?: {
              __typename?: 'Builder_ResourceLink'
              defaultLocale?: SupportedLocaleCountryCode | null
              defaultTimezone?: string | null
              company: { __typename?: 'Company_ResourceLink'; name: string }
            } | null
          } | null
          toolbox?: {
            __typename?: 'Toolbox_ResourceLink'
            id: string
            date: string
            type: ToolboxType
          } | null
          acknowledgements?: Array<{
            __typename?: 'Acknowledgement_ResourceLink'
            id: string
            createdAt: string
            worker?: {
              __typename?: 'Worker_ResourceLink'
              id: string
              user: {
                __typename?: 'User_ResourceLink'
                firstName: string
                lastName: string
              }
            } | null
          } | null> | null
        } | null
      }
    | null
}

export type ResourceLinkConversationThreadAttributesFragment = {
  __typename?: 'ConversationThread_ResourceLink'
  id: string
  messages?: Array<{
    __typename?: 'ConversationMessage_ResourceLink'
    id: string
    createdAt: string
    content?: string | null
    sender: {
      __typename?: 'Assignee_ResourceLink'
      id: string
      worker?: {
        __typename?: 'Worker_ResourceLink'
        id: string
        user: {
          __typename?: 'User_ResourceLink'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      adminUser?: {
        __typename?: 'AdminUser_ResourceLink'
        id: string
        user: {
          __typename?: 'User_ResourceLink'
          id: string
          firstName: string
          lastName: string
        }
      } | null
      subcontractor?: {
        __typename?: 'Subcontractor_ResourceLink'
        id: string
        company: { __typename?: 'Company_ResourceLink'; name: string }
      } | null
    }
    attachments?: Array<{
      __typename?: 'Attachment_ResourceLink'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    }> | null
  }> | null
}

export type NestedResourceLinkProjectLocationForDefectAttributesFragment = {
  __typename?: 'ProjectLocation_ResourceLink'
  id: string
  name: string
}

export type ResourceLinkProjectLocationForDefectAttributesFragment = {
  __typename?: 'ProjectLocation_ResourceLink'
  id: string
  name: string
  parent?: {
    __typename?: 'ProjectLocation_ResourceLink'
    id: string
    name: string
    parent?: {
      __typename?: 'ProjectLocation_ResourceLink'
      id: string
      name: string
      parent?: {
        __typename?: 'ProjectLocation_ResourceLink'
        id: string
        name: string
        parent?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
        } | null
      } | null
    } | null
  } | null
}

export type ResourceLinkAttributesFragment = {
  __typename?: 'ResourceLink'
  id: string
  createdAt: string
  updatedAt: string
  slug: string
  active: boolean
  project?: { __typename?: 'Project'; id: string; name: string } | null
  template?: {
    __typename?: 'Template'
    id: string
    templateName: string
  } | null
}

export type DefectResourceLinkAttributesFragment = {
  __typename?: 'Defect_ResourceLink'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  completedAt?: string | null
  dueDate?: string | null
  status: DefectStatus
  priority?: DefectPriority | null
  title?: string | null
  description?: string | null
  type?: string | null
  order?: number | null
  overdue?: boolean | null
  assigner: {
    __typename?: 'AdminUser_ResourceLink'
    id: string
    user: {
      __typename?: 'User_ResourceLink'
      id: string
      firstName: string
      lastName: string
    }
  }
  project: {
    __typename?: 'Project_ResourceLink'
    id: string
    name: string
    status: ProjectStatus
    country?: string | null
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
    builder?: {
      __typename?: 'Builder_ResourceLink'
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
    } | null
  }
  assignees: Array<{
    __typename?: 'Assignee_ResourceLink'
    id: string
    createdAt: string
    updatedAt: string
    worker?: {
      __typename?: 'Worker_ResourceLink'
      id: string
      user: {
        __typename?: 'User_ResourceLink'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    adminUser?: {
      __typename?: 'AdminUser_ResourceLink'
      id: string
      user: {
        __typename?: 'User_ResourceLink'
        id: string
        firstName: string
        lastName: string
      }
    } | null
    subcontractor?: {
      __typename?: 'Subcontractor_ResourceLink'
      id: string
      company: { __typename?: 'Company_ResourceLink'; name: string }
    } | null
  } | null>
  attachments?: Array<{
    __typename?: 'Attachment_ResourceLink'
    id: string
    url: string
    fileName: string
    thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
  } | null> | null
  location?: {
    __typename?: 'ProjectLocation_ResourceLink'
    id: string
    name: string
    parent?: {
      __typename?: 'ProjectLocation_ResourceLink'
      id: string
      name: string
      parent?: {
        __typename?: 'ProjectLocation_ResourceLink'
        id: string
        name: string
        parent?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
          parent?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
          } | null
        } | null
      } | null
    } | null
  } | null
  conversation?: {
    __typename?: 'ConversationThread_ResourceLink'
    id: string
    messages?: Array<{
      __typename?: 'ConversationMessage_ResourceLink'
      id: string
      createdAt: string
      content?: string | null
      sender: {
        __typename?: 'Assignee_ResourceLink'
        id: string
        worker?: {
          __typename?: 'Worker_ResourceLink'
          id: string
          user: {
            __typename?: 'User_ResourceLink'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        adminUser?: {
          __typename?: 'AdminUser_ResourceLink'
          id: string
          user: {
            __typename?: 'User_ResourceLink'
            id: string
            firstName: string
            lastName: string
          }
        } | null
        subcontractor?: {
          __typename?: 'Subcontractor_ResourceLink'
          id: string
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
      }
      attachments?: Array<{
        __typename?: 'Attachment_ResourceLink'
        id: string
        url: string
        fileName: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      }> | null
    }> | null
  } | null
}

export type ActionResourceLinkAttributesFragment = {
  __typename?: 'PlatformAction_ResourceLink'
  id: string
  createdAt: string
  title?: string | null
  description?: string | null
  status: PlatformActionStatus
  priorityType?: string | null
  dueDate?: string | null
  templateResponseBlockData?: any | null
  attachments?: Array<{
    __typename?: 'Attachment_ResourceLink'
    id: string
    url: string
    fileName: string
  } | null> | null
  templateResponse?: {
    __typename?: 'TemplateResponse_ResourceLink'
    id: string
    responseData?: any | null
  } | null
  config?: {
    __typename?: 'PlatformActionConfig'
    requireAttachmentToClose?: boolean | null
  } | null
}

export type PrequalificationResourceLinkAttributesFragment = {
  __typename?: 'Prequalification_ResourceLink'
  id: string
  status: PrequalificationStatus
  builder: {
    __typename?: 'Builder_ResourceLink'
    defaultLocale?: SupportedLocaleCountryCode | null
    defaultTimezone?: string | null
  }
  subcontractor: {
    __typename?: 'Subcontractor_ResourceLink'
    id: string
    company: { __typename?: 'Company_ResourceLink'; name: string }
  }
  templateResponse: {
    __typename?: 'TemplateResponse_ResourceLink'
    id: string
    responseData?: any | null
    template?: {
      __typename?: 'Template_ResourceLink'
      templateData?: any | null
      id: string
    } | null
  }
}

export type NestedDocumentFolderResourceLinkAttributesFragment = {
  __typename?: 'DocumentFolder_ResourceLink'
  id: string
  name: string
  childrenFolders?: Array<{
    __typename?: 'DocumentFolder_ResourceLink'
    id: string
    name: string
  }> | null
  drawings?: Array<{
    __typename?: 'Drawing_ResourceLink'
    id: string
    drawingNumber?: string | null
    drawingRevision?: string | null
    url: string
  }> | null
}

export type DocumentFolderResourceLinkAttributesFragment = {
  __typename?: 'DocumentFolder_ResourceLink'
  id: string
  name: string
  childrenFolders?: Array<{
    __typename?: 'DocumentFolder_ResourceLink'
    id: string
    name: string
    childrenFolders?: Array<{
      __typename?: 'DocumentFolder_ResourceLink'
      id: string
      name: string
      childrenFolders?: Array<{
        __typename?: 'DocumentFolder_ResourceLink'
        id: string
        name: string
        childrenFolders?: Array<{
          __typename?: 'DocumentFolder_ResourceLink'
          id: string
          name: string
          childrenFolders?: Array<{
            __typename?: 'DocumentFolder_ResourceLink'
            id: string
            name: string
            childrenFolders?: Array<{
              __typename?: 'DocumentFolder_ResourceLink'
              id: string
              name: string
              childrenFolders?: Array<{
                __typename?: 'DocumentFolder_ResourceLink'
                id: string
                name: string
                childrenFolders?: Array<{
                  __typename?: 'DocumentFolder_ResourceLink'
                  id: string
                  name: string
                  childrenFolders?: Array<{
                    __typename?: 'DocumentFolder_ResourceLink'
                    id: string
                    name: string
                    childrenFolders?: Array<{
                      __typename?: 'DocumentFolder_ResourceLink'
                      id: string
                      name: string
                    }> | null
                    drawings?: Array<{
                      __typename?: 'Drawing_ResourceLink'
                      id: string
                      drawingNumber?: string | null
                      drawingRevision?: string | null
                      url: string
                    }> | null
                  }> | null
                  drawings?: Array<{
                    __typename?: 'Drawing_ResourceLink'
                    id: string
                    drawingNumber?: string | null
                    drawingRevision?: string | null
                    url: string
                  }> | null
                }> | null
                drawings?: Array<{
                  __typename?: 'Drawing_ResourceLink'
                  id: string
                  drawingNumber?: string | null
                  drawingRevision?: string | null
                  url: string
                }> | null
              }> | null
              drawings?: Array<{
                __typename?: 'Drawing_ResourceLink'
                id: string
                drawingNumber?: string | null
                drawingRevision?: string | null
                url: string
              }> | null
            }> | null
            drawings?: Array<{
              __typename?: 'Drawing_ResourceLink'
              id: string
              drawingNumber?: string | null
              drawingRevision?: string | null
              url: string
            }> | null
          }> | null
          drawings?: Array<{
            __typename?: 'Drawing_ResourceLink'
            id: string
            drawingNumber?: string | null
            drawingRevision?: string | null
            url: string
          }> | null
        }> | null
        drawings?: Array<{
          __typename?: 'Drawing_ResourceLink'
          id: string
          drawingNumber?: string | null
          drawingRevision?: string | null
          url: string
        }> | null
      }> | null
      drawings?: Array<{
        __typename?: 'Drawing_ResourceLink'
        id: string
        drawingNumber?: string | null
        drawingRevision?: string | null
        url: string
      }> | null
    }> | null
    drawings?: Array<{
      __typename?: 'Drawing_ResourceLink'
      id: string
      drawingNumber?: string | null
      drawingRevision?: string | null
      url: string
    }> | null
  }> | null
  drawings?: Array<{
    __typename?: 'Drawing_ResourceLink'
    id: string
    drawingNumber?: string | null
    drawingRevision?: string | null
    url: string
  }> | null
}

export type ResourceLinkAttributesEntityFragment = {
  __typename?: 'ResourceLinkEntity'
  id: string
  createdAt: string
  updatedAt: string
  slug: string
  active: boolean
  templateId?: string | null
  registerItemId?: string | null
  builder?: {
    __typename?: 'Builder_ResourceLink'
    id: string
    logoUrl?: string | null
    hideBuildPassLogos?: boolean | null
    defaultLocale?: SupportedLocaleCountryCode | null
    defaultTimezone?: string | null
    company: { __typename?: 'Company_ResourceLink'; name: string }
  } | null
  project?: {
    __typename?: 'Project_ResourceLink'
    id: string
    createdAt: string
    name: string
    address?: string | null
    timezone?: string | null
    projectCode?: string | null
    country?: string | null
    locale?: SupportedLocaleCountryCode | null
    builder?: {
      __typename?: 'Builder_ResourceLink'
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
    } | null
  } | null
  template?: {
    __typename?: 'TemplateEntity'
    id: string
    templateType: TemplateType
    templateName: string
    templateData?: any | null
    builder?: {
      __typename?: 'BuilderEntityPublic'
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
    } | null
  } | null
  registerItem?: {
    __typename?: 'RegisterItemEntity'
    id: string
    name: string
    identifier: number
    fullIdentifier: string
    checklistTemplates?: Array<{
      __typename?: 'TemplateEntity'
      id: string
      templateType: TemplateType
      templateName: string
      templateData?: any | null
    } | null> | null
    checklistResourceLinks?: Array<{
      __typename?: 'ResourceLinkEntity'
      id: string
      active: boolean
      slug: string
      project?: { __typename?: 'Project_ResourceLink'; id: string } | null
      template?: { __typename?: 'TemplateEntity'; id: string } | null
    } | null> | null
  } | null
  prequalification?: {
    __typename?: 'Prequalification_ResourceLink'
    id: string
    status: PrequalificationStatus
    builder: {
      __typename?: 'Builder_ResourceLink'
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
    }
    subcontractor: {
      __typename?: 'Subcontractor_ResourceLink'
      id: string
      company: { __typename?: 'Company_ResourceLink'; name: string }
    }
    templateResponse: {
      __typename?: 'TemplateResponse_ResourceLink'
      id: string
      responseData?: any | null
      template?: {
        __typename?: 'Template_ResourceLink'
        templateData?: any | null
        id: string
      } | null
    }
  } | null
  documentFolder?: {
    __typename?: 'DocumentFolder_ResourceLink'
    id: string
    name: string
    childrenFolders?: Array<{
      __typename?: 'DocumentFolder_ResourceLink'
      id: string
      name: string
      childrenFolders?: Array<{
        __typename?: 'DocumentFolder_ResourceLink'
        id: string
        name: string
        childrenFolders?: Array<{
          __typename?: 'DocumentFolder_ResourceLink'
          id: string
          name: string
          childrenFolders?: Array<{
            __typename?: 'DocumentFolder_ResourceLink'
            id: string
            name: string
            childrenFolders?: Array<{
              __typename?: 'DocumentFolder_ResourceLink'
              id: string
              name: string
              childrenFolders?: Array<{
                __typename?: 'DocumentFolder_ResourceLink'
                id: string
                name: string
                childrenFolders?: Array<{
                  __typename?: 'DocumentFolder_ResourceLink'
                  id: string
                  name: string
                  childrenFolders?: Array<{
                    __typename?: 'DocumentFolder_ResourceLink'
                    id: string
                    name: string
                    childrenFolders?: Array<{
                      __typename?: 'DocumentFolder_ResourceLink'
                      id: string
                      name: string
                      childrenFolders?: Array<{
                        __typename?: 'DocumentFolder_ResourceLink'
                        id: string
                        name: string
                      }> | null
                      drawings?: Array<{
                        __typename?: 'Drawing_ResourceLink'
                        id: string
                        drawingNumber?: string | null
                        drawingRevision?: string | null
                        url: string
                      }> | null
                    }> | null
                    drawings?: Array<{
                      __typename?: 'Drawing_ResourceLink'
                      id: string
                      drawingNumber?: string | null
                      drawingRevision?: string | null
                      url: string
                    }> | null
                  }> | null
                  drawings?: Array<{
                    __typename?: 'Drawing_ResourceLink'
                    id: string
                    drawingNumber?: string | null
                    drawingRevision?: string | null
                    url: string
                  }> | null
                }> | null
                drawings?: Array<{
                  __typename?: 'Drawing_ResourceLink'
                  id: string
                  drawingNumber?: string | null
                  drawingRevision?: string | null
                  url: string
                }> | null
              }> | null
              drawings?: Array<{
                __typename?: 'Drawing_ResourceLink'
                id: string
                drawingNumber?: string | null
                drawingRevision?: string | null
                url: string
              }> | null
            }> | null
            drawings?: Array<{
              __typename?: 'Drawing_ResourceLink'
              id: string
              drawingNumber?: string | null
              drawingRevision?: string | null
              url: string
            }> | null
          }> | null
          drawings?: Array<{
            __typename?: 'Drawing_ResourceLink'
            id: string
            drawingNumber?: string | null
            drawingRevision?: string | null
            url: string
          }> | null
        }> | null
        drawings?: Array<{
          __typename?: 'Drawing_ResourceLink'
          id: string
          drawingNumber?: string | null
          drawingRevision?: string | null
          url: string
        }> | null
      }> | null
      drawings?: Array<{
        __typename?: 'Drawing_ResourceLink'
        id: string
        drawingNumber?: string | null
        drawingRevision?: string | null
        url: string
      }> | null
    }> | null
    drawings?: Array<{
      __typename?: 'Drawing_ResourceLink'
      id: string
      drawingNumber?: string | null
      drawingRevision?: string | null
      url: string
    }> | null
  } | null
  contact?: {
    __typename?: 'Contact_ResourceLink'
    id: string
    name?: string | null
    subcontractor?: {
      __typename?: 'Subcontractor_ResourceLink'
      id: string
      company: { __typename?: 'Company_ResourceLink'; name: string }
      defects?: Array<{
        __typename?: 'Defect_ResourceLink'
        id: string
        createdAt: string
        updatedAt: string
        archivedAt?: string | null
        completedAt?: string | null
        dueDate?: string | null
        status: DefectStatus
        priority?: DefectPriority | null
        title?: string | null
        description?: string | null
        type?: string | null
        order?: number | null
        overdue?: boolean | null
        assigner: {
          __typename?: 'AdminUser_ResourceLink'
          id: string
          user: {
            __typename?: 'User_ResourceLink'
            id: string
            firstName: string
            lastName: string
          }
        }
        project: {
          __typename?: 'Project_ResourceLink'
          id: string
          name: string
          status: ProjectStatus
          country?: string | null
          timezone?: string | null
          locale?: SupportedLocaleCountryCode | null
          builder?: {
            __typename?: 'Builder_ResourceLink'
            defaultLocale?: SupportedLocaleCountryCode | null
            defaultTimezone?: string | null
          } | null
        }
        assignees: Array<{
          __typename?: 'Assignee_ResourceLink'
          id: string
          createdAt: string
          updatedAt: string
          worker?: {
            __typename?: 'Worker_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          adminUser?: {
            __typename?: 'AdminUser_ResourceLink'
            id: string
            user: {
              __typename?: 'User_ResourceLink'
              id: string
              firstName: string
              lastName: string
            }
          } | null
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
          } | null
        } | null>
        attachments?: Array<{
          __typename?: 'Attachment_ResourceLink'
          id: string
          url: string
          fileName: string
          thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
        } | null> | null
        location?: {
          __typename?: 'ProjectLocation_ResourceLink'
          id: string
          name: string
          parent?: {
            __typename?: 'ProjectLocation_ResourceLink'
            id: string
            name: string
            parent?: {
              __typename?: 'ProjectLocation_ResourceLink'
              id: string
              name: string
              parent?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                } | null
              } | null
            } | null
          } | null
        } | null
        conversation?: {
          __typename?: 'ConversationThread_ResourceLink'
          id: string
          messages?: Array<{
            __typename?: 'ConversationMessage_ResourceLink'
            id: string
            createdAt: string
            content?: string | null
            sender: {
              __typename?: 'Assignee_ResourceLink'
              id: string
              worker?: {
                __typename?: 'Worker_ResourceLink'
                id: string
                user: {
                  __typename?: 'User_ResourceLink'
                  id: string
                  firstName: string
                  lastName: string
                }
              } | null
              adminUser?: {
                __typename?: 'AdminUser_ResourceLink'
                id: string
                user: {
                  __typename?: 'User_ResourceLink'
                  id: string
                  firstName: string
                  lastName: string
                }
              } | null
              subcontractor?: {
                __typename?: 'Subcontractor_ResourceLink'
                id: string
                company: { __typename?: 'Company_ResourceLink'; name: string }
              } | null
            }
            attachments?: Array<{
              __typename?: 'Attachment_ResourceLink'
              id: string
              url: string
              fileName: string
              thumbnail?: {
                __typename?: 'Thumbnail'
                small?: string | null
              } | null
            }> | null
          }> | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type ResourceLinkBySlugUiQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type ResourceLinkBySlugUiQuery = {
  __typename?: 'Query'
  resourceLinkBySlug?:
    | {
        __typename?: 'DeactivatedResourceLinkEntity'
        id: string
        active: boolean
      }
    | { __typename?: 'ExpiredResourceLinkEntity' }
    | {
        __typename?: 'ResourceLinkEntity'
        id: string
        createdAt: string
        updatedAt: string
        slug: string
        active: boolean
        templateId?: string | null
        registerItemId?: string | null
        builder?: {
          __typename?: 'Builder_ResourceLink'
          id: string
          logoUrl?: string | null
          hideBuildPassLogos?: boolean | null
          defaultLocale?: SupportedLocaleCountryCode | null
          defaultTimezone?: string | null
          company: { __typename?: 'Company_ResourceLink'; name: string }
        } | null
        project?: {
          __typename?: 'Project_ResourceLink'
          id: string
          createdAt: string
          name: string
          address?: string | null
          timezone?: string | null
          projectCode?: string | null
          country?: string | null
          locale?: SupportedLocaleCountryCode | null
          builder?: {
            __typename?: 'Builder_ResourceLink'
            defaultLocale?: SupportedLocaleCountryCode | null
            defaultTimezone?: string | null
          } | null
        } | null
        template?: {
          __typename?: 'TemplateEntity'
          id: string
          templateType: TemplateType
          templateName: string
          templateData?: any | null
          builder?: {
            __typename?: 'BuilderEntityPublic'
            defaultLocale?: SupportedLocaleCountryCode | null
            defaultTimezone?: string | null
          } | null
        } | null
        registerItem?: {
          __typename?: 'RegisterItemEntity'
          id: string
          name: string
          identifier: number
          fullIdentifier: string
          checklistTemplates?: Array<{
            __typename?: 'TemplateEntity'
            id: string
            templateType: TemplateType
            templateName: string
            templateData?: any | null
          } | null> | null
          checklistResourceLinks?: Array<{
            __typename?: 'ResourceLinkEntity'
            id: string
            active: boolean
            slug: string
            project?: { __typename?: 'Project_ResourceLink'; id: string } | null
            template?: { __typename?: 'TemplateEntity'; id: string } | null
          } | null> | null
        } | null
        prequalification?: {
          __typename?: 'Prequalification_ResourceLink'
          id: string
          status: PrequalificationStatus
          builder: {
            __typename?: 'Builder_ResourceLink'
            defaultLocale?: SupportedLocaleCountryCode | null
            defaultTimezone?: string | null
          }
          subcontractor: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
          }
          templateResponse: {
            __typename?: 'TemplateResponse_ResourceLink'
            id: string
            responseData?: any | null
            template?: {
              __typename?: 'Template_ResourceLink'
              templateData?: any | null
              id: string
            } | null
          }
        } | null
        documentFolder?: {
          __typename?: 'DocumentFolder_ResourceLink'
          id: string
          name: string
          childrenFolders?: Array<{
            __typename?: 'DocumentFolder_ResourceLink'
            id: string
            name: string
            childrenFolders?: Array<{
              __typename?: 'DocumentFolder_ResourceLink'
              id: string
              name: string
              childrenFolders?: Array<{
                __typename?: 'DocumentFolder_ResourceLink'
                id: string
                name: string
                childrenFolders?: Array<{
                  __typename?: 'DocumentFolder_ResourceLink'
                  id: string
                  name: string
                  childrenFolders?: Array<{
                    __typename?: 'DocumentFolder_ResourceLink'
                    id: string
                    name: string
                    childrenFolders?: Array<{
                      __typename?: 'DocumentFolder_ResourceLink'
                      id: string
                      name: string
                      childrenFolders?: Array<{
                        __typename?: 'DocumentFolder_ResourceLink'
                        id: string
                        name: string
                        childrenFolders?: Array<{
                          __typename?: 'DocumentFolder_ResourceLink'
                          id: string
                          name: string
                          childrenFolders?: Array<{
                            __typename?: 'DocumentFolder_ResourceLink'
                            id: string
                            name: string
                            childrenFolders?: Array<{
                              __typename?: 'DocumentFolder_ResourceLink'
                              id: string
                              name: string
                            }> | null
                            drawings?: Array<{
                              __typename?: 'Drawing_ResourceLink'
                              id: string
                              drawingNumber?: string | null
                              drawingRevision?: string | null
                              url: string
                            }> | null
                          }> | null
                          drawings?: Array<{
                            __typename?: 'Drawing_ResourceLink'
                            id: string
                            drawingNumber?: string | null
                            drawingRevision?: string | null
                            url: string
                          }> | null
                        }> | null
                        drawings?: Array<{
                          __typename?: 'Drawing_ResourceLink'
                          id: string
                          drawingNumber?: string | null
                          drawingRevision?: string | null
                          url: string
                        }> | null
                      }> | null
                      drawings?: Array<{
                        __typename?: 'Drawing_ResourceLink'
                        id: string
                        drawingNumber?: string | null
                        drawingRevision?: string | null
                        url: string
                      }> | null
                    }> | null
                    drawings?: Array<{
                      __typename?: 'Drawing_ResourceLink'
                      id: string
                      drawingNumber?: string | null
                      drawingRevision?: string | null
                      url: string
                    }> | null
                  }> | null
                  drawings?: Array<{
                    __typename?: 'Drawing_ResourceLink'
                    id: string
                    drawingNumber?: string | null
                    drawingRevision?: string | null
                    url: string
                  }> | null
                }> | null
                drawings?: Array<{
                  __typename?: 'Drawing_ResourceLink'
                  id: string
                  drawingNumber?: string | null
                  drawingRevision?: string | null
                  url: string
                }> | null
              }> | null
              drawings?: Array<{
                __typename?: 'Drawing_ResourceLink'
                id: string
                drawingNumber?: string | null
                drawingRevision?: string | null
                url: string
              }> | null
            }> | null
            drawings?: Array<{
              __typename?: 'Drawing_ResourceLink'
              id: string
              drawingNumber?: string | null
              drawingRevision?: string | null
              url: string
            }> | null
          }> | null
          drawings?: Array<{
            __typename?: 'Drawing_ResourceLink'
            id: string
            drawingNumber?: string | null
            drawingRevision?: string | null
            url: string
          }> | null
        } | null
        contact?: {
          __typename?: 'Contact_ResourceLink'
          id: string
          name?: string | null
          subcontractor?: {
            __typename?: 'Subcontractor_ResourceLink'
            id: string
            company: { __typename?: 'Company_ResourceLink'; name: string }
            defects?: Array<{
              __typename?: 'Defect_ResourceLink'
              id: string
              createdAt: string
              updatedAt: string
              archivedAt?: string | null
              completedAt?: string | null
              dueDate?: string | null
              status: DefectStatus
              priority?: DefectPriority | null
              title?: string | null
              description?: string | null
              type?: string | null
              order?: number | null
              overdue?: boolean | null
              assigner: {
                __typename?: 'AdminUser_ResourceLink'
                id: string
                user: {
                  __typename?: 'User_ResourceLink'
                  id: string
                  firstName: string
                  lastName: string
                }
              }
              project: {
                __typename?: 'Project_ResourceLink'
                id: string
                name: string
                status: ProjectStatus
                country?: string | null
                timezone?: string | null
                locale?: SupportedLocaleCountryCode | null
                builder?: {
                  __typename?: 'Builder_ResourceLink'
                  defaultLocale?: SupportedLocaleCountryCode | null
                  defaultTimezone?: string | null
                } | null
              }
              assignees: Array<{
                __typename?: 'Assignee_ResourceLink'
                id: string
                createdAt: string
                updatedAt: string
                worker?: {
                  __typename?: 'Worker_ResourceLink'
                  id: string
                  user: {
                    __typename?: 'User_ResourceLink'
                    id: string
                    firstName: string
                    lastName: string
                  }
                } | null
                adminUser?: {
                  __typename?: 'AdminUser_ResourceLink'
                  id: string
                  user: {
                    __typename?: 'User_ResourceLink'
                    id: string
                    firstName: string
                    lastName: string
                  }
                } | null
                subcontractor?: {
                  __typename?: 'Subcontractor_ResourceLink'
                  id: string
                  company: { __typename?: 'Company_ResourceLink'; name: string }
                } | null
              } | null>
              attachments?: Array<{
                __typename?: 'Attachment_ResourceLink'
                id: string
                url: string
                fileName: string
                thumbnail?: {
                  __typename?: 'Thumbnail'
                  small?: string | null
                } | null
              } | null> | null
              location?: {
                __typename?: 'ProjectLocation_ResourceLink'
                id: string
                name: string
                parent?: {
                  __typename?: 'ProjectLocation_ResourceLink'
                  id: string
                  name: string
                  parent?: {
                    __typename?: 'ProjectLocation_ResourceLink'
                    id: string
                    name: string
                    parent?: {
                      __typename?: 'ProjectLocation_ResourceLink'
                      id: string
                      name: string
                      parent?: {
                        __typename?: 'ProjectLocation_ResourceLink'
                        id: string
                        name: string
                      } | null
                    } | null
                  } | null
                } | null
              } | null
              conversation?: {
                __typename?: 'ConversationThread_ResourceLink'
                id: string
                messages?: Array<{
                  __typename?: 'ConversationMessage_ResourceLink'
                  id: string
                  createdAt: string
                  content?: string | null
                  sender: {
                    __typename?: 'Assignee_ResourceLink'
                    id: string
                    worker?: {
                      __typename?: 'Worker_ResourceLink'
                      id: string
                      user: {
                        __typename?: 'User_ResourceLink'
                        id: string
                        firstName: string
                        lastName: string
                      }
                    } | null
                    adminUser?: {
                      __typename?: 'AdminUser_ResourceLink'
                      id: string
                      user: {
                        __typename?: 'User_ResourceLink'
                        id: string
                        firstName: string
                        lastName: string
                      }
                    } | null
                    subcontractor?: {
                      __typename?: 'Subcontractor_ResourceLink'
                      id: string
                      company: {
                        __typename?: 'Company_ResourceLink'
                        name: string
                      }
                    } | null
                  }
                  attachments?: Array<{
                    __typename?: 'Attachment_ResourceLink'
                    id: string
                    url: string
                    fileName: string
                    thumbnail?: {
                      __typename?: 'Thumbnail'
                      small?: string | null
                    } | null
                  }> | null
                }> | null
              } | null
            } | null> | null
          } | null
        } | null
      }
    | null
}

export type ResourceLinkByResourceUiQueryVariables = Exact<{
  filter: ResourceLinkByResourceFilterInput
}>

export type ResourceLinkByResourceUiQuery = {
  __typename?: 'Query'
  resourceLinkByResource?: {
    __typename?: 'ResourceLink'
    id: string
    createdAt: string
    updatedAt: string
    slug: string
    active: boolean
    project?: { __typename?: 'Project'; id: string; name: string } | null
    template?: {
      __typename?: 'Template'
      id: string
      templateName: string
    } | null
  } | null
}

export type FindOrCreateResourceLinkUiMutationVariables = Exact<{
  input: CreateResourceLinkInput
}>

export type FindOrCreateResourceLinkUiMutation = {
  __typename?: 'Mutation'
  findOrCreateResourceLink: {
    __typename?: 'ResourceLink'
    id: string
    createdAt: string
    updatedAt: string
    slug: string
    active: boolean
    project?: { __typename?: 'Project'; id: string; name: string } | null
    template?: {
      __typename?: 'Template'
      id: string
      templateName: string
    } | null
  }
}

export type FindOrCreateResourceLinksUiMutationVariables = Exact<{
  input: Array<CreateResourceLinkInput> | CreateResourceLinkInput
}>

export type FindOrCreateResourceLinksUiMutation = {
  __typename?: 'Mutation'
  findOrCreateResourceLinks: Array<{
    __typename?: 'ResourceLink'
    id: string
    createdAt: string
    updatedAt: string
    slug: string
    active: boolean
    project?: { __typename?: 'Project'; id: string; name: string } | null
    template?: {
      __typename?: 'Template'
      id: string
      templateName: string
    } | null
  }>
}

export type CreateResourceLinkUiMutationVariables = Exact<{
  input: CreateResourceLinkInput
}>

export type CreateResourceLinkUiMutation = {
  __typename?: 'Mutation'
  createResourceLink: {
    __typename?: 'ResourceLink'
    id: string
    createdAt: string
    updatedAt: string
    slug: string
    active: boolean
    project?: { __typename?: 'Project'; id: string; name: string } | null
    template?: {
      __typename?: 'Template'
      id: string
      templateName: string
    } | null
  }
}

export type UpdateResourceLinkUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateResourceLinkInput
}>

export type UpdateResourceLinkUiMutation = {
  __typename?: 'Mutation'
  updateResourceLink: {
    __typename?: 'ResourceLink'
    id: string
    createdAt: string
    updatedAt: string
    slug: string
    active: boolean
    project?: { __typename?: 'Project'; id: string; name: string } | null
    template?: {
      __typename?: 'Template'
      id: string
      templateName: string
    } | null
  }
}

export type PublicPlatformActionViaChecklistResourceLinkUiQueryVariables =
  Exact<{
    id: Scalars['String']
    resourceLinkId: Scalars['String']
  }>

export type PublicPlatformActionViaChecklistResourceLinkUiQuery = {
  __typename?: 'Query'
  publicPlatformActionViaChecklistResourceLink?: {
    __typename?: 'PlatformAction_ResourceLink'
    id: string
    createdAt: string
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    priorityType?: string | null
    dueDate?: string | null
    templateResponseBlockData?: any | null
    attachments?: Array<{
      __typename?: 'Attachment_ResourceLink'
      id: string
      url: string
      fileName: string
    } | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse_ResourceLink'
      id: string
      responseData?: any | null
    } | null
    config?: {
      __typename?: 'PlatformActionConfig'
      requireAttachmentToClose?: boolean | null
    } | null
  } | null
}

export type CreatePublicPlatformActionViaChecklistResourceLinkUiMutationVariables =
  Exact<{
    input: CreatePublicPlatformActionViaChecklistResourceLinkInput
  }>

export type CreatePublicPlatformActionViaChecklistResourceLinkUiMutation = {
  __typename?: 'Mutation'
  createPublicPlatformActionViaChecklistResourceLink: {
    __typename?: 'PlatformAction_ResourceLink'
    id: string
    createdAt: string
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    priorityType?: string | null
    dueDate?: string | null
    templateResponseBlockData?: any | null
    attachments?: Array<{
      __typename?: 'Attachment_ResourceLink'
      id: string
      url: string
      fileName: string
    } | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse_ResourceLink'
      id: string
      responseData?: any | null
    } | null
    config?: {
      __typename?: 'PlatformActionConfig'
      requireAttachmentToClose?: boolean | null
    } | null
  }
}

export type UpdatePublicPlatformActionViaChecklistResourceLinkUiMutationVariables =
  Exact<{
    id: Scalars['String']
    input: UpdatePublicPlatformActionViaChecklistResourceLinkInput
  }>

export type UpdatePublicPlatformActionViaChecklistResourceLinkUiMutation = {
  __typename?: 'Mutation'
  updatePublicPlatformActionViaChecklistResourceLink: {
    __typename?: 'PlatformAction_ResourceLink'
    id: string
    createdAt: string
    title?: string | null
    description?: string | null
    status: PlatformActionStatus
    priorityType?: string | null
    dueDate?: string | null
    templateResponseBlockData?: any | null
    attachments?: Array<{
      __typename?: 'Attachment_ResourceLink'
      id: string
      url: string
      fileName: string
    } | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse_ResourceLink'
      id: string
      responseData?: any | null
    } | null
    config?: {
      __typename?: 'PlatformActionConfig'
      requireAttachmentToClose?: boolean | null
    } | null
  }
}

export type UpdatePrequalificationViaResourceLinkUiMutationVariables = Exact<{
  resourceLinkSlug: Scalars['String']
  prequalificationId: Scalars['String']
  subcontractorId: Scalars['String']
  input: UpdateResourceLinkPrequalificationInput
}>

export type UpdatePrequalificationViaResourceLinkUiMutation = {
  __typename?: 'Mutation'
  updatePrequalificationViaResourceLink: {
    __typename?: 'Prequalification_ResourceLink'
    id: string
    status: PrequalificationStatus
    builder: {
      __typename?: 'Builder_ResourceLink'
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
    }
    subcontractor: {
      __typename?: 'Subcontractor_ResourceLink'
      id: string
      company: { __typename?: 'Company_ResourceLink'; name: string }
    }
    templateResponse: {
      __typename?: 'TemplateResponse_ResourceLink'
      id: string
      responseData?: any | null
      template?: {
        __typename?: 'Template_ResourceLink'
        templateData?: any | null
        id: string
      } | null
    }
  }
}

export type ResourceTagsAttributesFragment = {
  __typename?: 'ResourceTag'
  id: string
  name: string
  slug: string
  attachmentCount: number
  subcontractorUsageCount: number
  projectUsageCount: number
}

export type UpdateResourceTagsAdminUiMutationVariables = Exact<{
  resourceId: Scalars['String']
  resourceType: ResourceTagResourceTypeAdmin
  tags: Array<Scalars['String']> | Scalars['String']
}>

export type UpdateResourceTagsAdminUiMutation = {
  __typename?: 'Mutation'
  updateResourceTags_admin: Array<{
    __typename?: 'ResourceTag'
    id: string
    name: string
  }>
}

export type ExistingResourceTagsAdminUiQueryVariables = Exact<{
  filter?: InputMaybe<ResourceTagsFilterInputAdmin>
}>

export type ExistingResourceTagsAdminUiQuery = {
  __typename?: 'Query'
  existingResourceTags_admin: Array<{
    __typename?: 'ResourceTag'
    id: string
    name: string
    slug: string
    attachmentCount: number
    subcontractorUsageCount: number
    projectUsageCount: number
  }>
}

export type BulkAddResourceTagsAdminUiMutationVariables = Exact<{
  resourceIds: Array<Scalars['String']> | Scalars['String']
  resourceType: ResourceTagResourceTypeAdmin
  tags: Array<Scalars['String']> | Scalars['String']
}>

export type BulkAddResourceTagsAdminUiMutation = {
  __typename?: 'Mutation'
  bulkAddTags_admin: Array<{
    __typename?: 'ResourceTag'
    id: string
    name: string
  }>
}

export type ResourceTagsAdminUiQueryVariables = Exact<{ [key: string]: never }>

export type ResourceTagsAdminUiQuery = {
  __typename?: 'Query'
  resourceTags: Array<{
    __typename?: 'ResourceTag'
    id: string
    name: string
    slug: string
    attachmentCount: number
    subcontractorUsageCount: number
    projectUsageCount: number
  }>
}

export type ScheduleAttributesFragment = {
  __typename?: 'Schedule'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  status: ScheduleStatus
  title: string
  interval?: string | null
  startDate: string
  assigner: {
    __typename?: 'AdminUser'
    user: { __typename?: 'User'; firstName: string; lastName: string }
  }
  assignees: Array<{
    __typename?: 'AdminUser'
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null>
  scheduledJobs: Array<{
    __typename?: 'ScheduledJob'
    id: string
    scheduledFor: string
    processed: boolean
  } | null>
}

export type ScheduleAttributesSubsetFragment = {
  __typename?: 'Schedule'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  projectId: string
  status: ScheduleStatus
  title: string
  assigner: {
    __typename?: 'AdminUser'
    user: { __typename?: 'User'; firstName: string; lastName: string }
  }
  assignees: Array<{
    __typename?: 'AdminUser'
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null>
  scheduledJobs: Array<{
    __typename?: 'ScheduledJob'
    id: string
    scheduledFor: string
  } | null>
}

export type ScheduledJobAttributesFragment = {
  __typename?: 'ScheduledJob'
  id: string
  createdAt: string
  updatedAt: string
  processed: boolean
  scheduledFor: string
  schedule: {
    __typename?: 'Schedule'
    status: ScheduleStatus
    title: string
    libraryTemplateId?: string | null
    templateId?: string | null
    projectId: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    project: { __typename?: 'Project'; name: string }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
  }
  templateResponse?: { __typename?: 'TemplateResponse'; id: string } | null
}

export type SchedulesUiQueryVariables = Exact<{
  filter?: InputMaybe<SchedulesFilterInput>
}>

export type SchedulesUiQuery = {
  __typename?: 'Query'
  schedules: Array<{
    __typename?: 'Schedule'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    status: ScheduleStatus
    title: string
    interval?: string | null
    startDate: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    scheduledJobs: Array<{
      __typename?: 'ScheduledJob'
      id: string
      scheduledFor: string
      processed: boolean
    } | null>
  }>
}

export type SchedulesByTemplateUiQueryVariables = Exact<{
  templateId: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
}>

export type SchedulesByTemplateUiQuery = {
  __typename?: 'Query'
  schedulesByTemplate: Array<{
    __typename?: 'Schedule'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    projectId: string
    status: ScheduleStatus
    title: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    scheduledJobs: Array<{
      __typename?: 'ScheduledJob'
      id: string
      scheduledFor: string
    } | null>
  }>
}

export type SchedulesListUiQueryVariables = Exact<{
  filter?: InputMaybe<SchedulesFilterInput>
}>

export type SchedulesListUiQuery = {
  __typename?: 'Query'
  schedules: Array<{
    __typename?: 'Schedule'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    projectId: string
    status: ScheduleStatus
    title: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    scheduledJobs: Array<{
      __typename?: 'ScheduledJob'
      id: string
      scheduledFor: string
    } | null>
  }>
}

export type ScheduleUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type ScheduleUiQuery = {
  __typename?: 'Query'
  schedule?: {
    __typename?: 'Schedule'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    status: ScheduleStatus
    title: string
    interval?: string | null
    startDate: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    scheduledJobs: Array<{
      __typename?: 'ScheduledJob'
      id: string
      scheduledFor: string
      processed: boolean
    } | null>
  } | null
}

export type CreateScheduleUiMutationVariables = Exact<{
  input: CreateScheduleInput
}>

export type CreateScheduleUiMutation = {
  __typename?: 'Mutation'
  createSchedule: {
    __typename?: 'Schedule'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    status: ScheduleStatus
    title: string
    interval?: string | null
    startDate: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    scheduledJobs: Array<{
      __typename?: 'ScheduledJob'
      id: string
      scheduledFor: string
      processed: boolean
    } | null>
  }
}

export type UpdateScheduleUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateScheduleInput
}>

export type UpdateScheduleUiMutation = {
  __typename?: 'Mutation'
  updateSchedule: {
    __typename?: 'Schedule'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    status: ScheduleStatus
    title: string
    interval?: string | null
    startDate: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    scheduledJobs: Array<{
      __typename?: 'ScheduledJob'
      id: string
      scheduledFor: string
      processed: boolean
    } | null>
  }
}

export type ArchiveScheduleUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveScheduleUiMutation = {
  __typename?: 'Mutation'
  archiveSchedule: {
    __typename?: 'Schedule'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    status: ScheduleStatus
    title: string
    interval?: string | null
    startDate: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    scheduledJobs: Array<{
      __typename?: 'ScheduledJob'
      id: string
      scheduledFor: string
      processed: boolean
    } | null>
  }
}

export type RestoreScheduleUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreScheduleUiMutation = {
  __typename?: 'Mutation'
  restoreSchedule: {
    __typename?: 'Schedule'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    status: ScheduleStatus
    title: string
    interval?: string | null
    startDate: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    scheduledJobs: Array<{
      __typename?: 'ScheduledJob'
      id: string
      scheduledFor: string
      processed: boolean
    } | null>
  }
}

export type DeactivateScheduleUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeactivateScheduleUiMutation = {
  __typename?: 'Mutation'
  deactivateSchedule: {
    __typename?: 'Schedule'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    status: ScheduleStatus
    title: string
    interval?: string | null
    startDate: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    scheduledJobs: Array<{
      __typename?: 'ScheduledJob'
      id: string
      scheduledFor: string
      processed: boolean
    } | null>
  }
}

export type ActivateScheduleUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ActivateScheduleUiMutation = {
  __typename?: 'Mutation'
  activateSchedule: {
    __typename?: 'Schedule'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    status: ScheduleStatus
    title: string
    interval?: string | null
    startDate: string
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    scheduledJobs: Array<{
      __typename?: 'ScheduledJob'
      id: string
      scheduledFor: string
      processed: boolean
    } | null>
  }
}

export type ScheduledJobsUiQueryVariables = Exact<{
  scheduleId: Scalars['String']
}>

export type ScheduledJobsUiQuery = {
  __typename?: 'Query'
  scheduledJobs: Array<{
    __typename?: 'ScheduledJob'
    id: string
    createdAt: string
    updatedAt: string
    processed: boolean
    scheduledFor: string
    schedule: {
      __typename?: 'Schedule'
      status: ScheduleStatus
      title: string
      libraryTemplateId?: string | null
      templateId?: string | null
      projectId: string
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      project: { __typename?: 'Project'; name: string }
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
    }
    templateResponse?: { __typename?: 'TemplateResponse'; id: string } | null
  }>
}

export type ScheduledJobUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type ScheduledJobUiQuery = {
  __typename?: 'Query'
  scheduledJob?: {
    __typename?: 'ScheduledJob'
    id: string
    createdAt: string
    updatedAt: string
    processed: boolean
    scheduledFor: string
    schedule: {
      __typename?: 'Schedule'
      status: ScheduleStatus
      title: string
      libraryTemplateId?: string | null
      templateId?: string | null
      projectId: string
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      project: { __typename?: 'Project'; name: string }
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
    }
    templateResponse?: { __typename?: 'TemplateResponse'; id: string } | null
  } | null
}

export type ProjectSchedulesForNavUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectSchedulesForNavUiQuery = {
  __typename?: 'Query'
  projectSchedules_admin: Array<{
    __typename?: 'ProjectSchedule_Admin'
    id: string
  }>
}

export type ProjectSchedulesUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectSchedulesUiQuery = {
  __typename?: 'Query'
  projectSchedules_admin: Array<{
    __typename?: 'ProjectSchedule_Admin'
    id: string
    title?: string | null
    status?: ProjectScheduleStatus | null
    updatedAt: string
    earliestDate?: string | null
    latestDate?: string | null
    editingAdminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    } | null
  }>
}

export type CreateProjectScheduleUiMutationVariables = Exact<{
  projectId: Scalars['String']
  input: CreateProjectScheduleInputAdmin
}>

export type CreateProjectScheduleUiMutation = {
  __typename?: 'Mutation'
  createProjectSchedule_admin: {
    __typename?: 'ProjectSchedule_Admin'
    id: string
  }
}

export type SubbieProjectSchedulesUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type SubbieProjectSchedulesUiQuery = {
  __typename?: 'Query'
  subcontractorProjectSchedules_public: Array<{
    __typename?: 'ProjectSchedule_Public'
    id: string
    title?: string | null
    project?: {
      __typename?: 'PublicProject'
      id: string
      status: ProjectStatus
      name: string
      timezone?: string | null
      locale?: SupportedLocaleCountryCode | null
      builder?: {
        __typename?: 'BuilderEntity'
        id: string
        logoUrl?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultTimezone?: string | null
        company?: { __typename?: 'Company'; name: string } | null
      } | null
    } | null
  }>
  publicSubcontractor?: {
    __typename?: 'SubcontractorEntity'
    id: string
    company: { __typename?: 'CompanyEntity'; name: string; abn?: string | null }
    builder?: {
      __typename?: 'BuilderEntityPublic'
      id: string
      logoUrl?: string | null
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
      company?: { __typename?: 'Company'; name: string } | null
    } | null
  } | null
}

export type SubbieProjectScheduleItemFragment = {
  __typename?: 'ProjectScheduleItem_Public'
  id: string
  confirmedAt?: string | null
  title?: string | null
  description?: string | null
  startDate: string
  duration: number
}

export type SubbieProjectScheduleUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
  projectScheduleId: Scalars['String']
}>

export type SubbieProjectScheduleUiQuery = {
  __typename?: 'Query'
  subcontractorProjectSchedule_public?: {
    __typename?: 'ProjectSchedule_Public'
    id: string
    title?: string | null
    project?: {
      __typename?: 'PublicProject'
      id: string
      name: string
      timezone?: string | null
      locale?: SupportedLocaleCountryCode | null
      status: ProjectStatus
      builder?: {
        __typename?: 'BuilderEntity'
        id: string
        logoUrl?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultTimezone?: string | null
        company?: { __typename?: 'Company'; name: string } | null
      } | null
      projectContacts?: Array<{
        __typename?: 'ContactEntity'
        id: string
        type: ContactType
        name?: string | null
        email?: string | null
        number?: string | null
      } | null> | null
    } | null
    instructions?: Array<{
      __typename?: 'ProjectScheduleInstruction'
      id: string
      instructions: string
    } | null> | null
    items?: Array<{
      __typename?: 'ProjectScheduleItem_Public'
      id: string
      confirmedAt?: string | null
      title?: string | null
      description?: string | null
      startDate: string
      duration: number
    } | null> | null
  } | null
  publicSubcontractor?: {
    __typename?: 'SubcontractorEntity'
    id: string
    company: { __typename?: 'CompanyEntity'; name: string; abn?: string | null }
    builder?: {
      __typename?: 'BuilderEntityPublic'
      id: string
      logoUrl?: string | null
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
      company?: { __typename?: 'Company'; name: string } | null
    } | null
  } | null
}

export type SubbieConfirmProjectScheduleItemUiMutationVariables = Exact<{
  subcontractorId: Scalars['String']
  projectScheduleItemId: Scalars['String']
}>

export type SubbieConfirmProjectScheduleItemUiMutation = {
  __typename?: 'Mutation'
  confirmProjectScheduleItem_public: {
    __typename?: 'ProjectScheduleItem_Public'
    id: string
    confirmedAt?: string | null
    title?: string | null
    description?: string | null
    startDate: string
    duration: number
  }
}

export type SwmsSettingsAttributesFragment = {
  __typename?: 'SWMSSettings'
  includeSWMSChecklistInPDFExport: boolean
  includeSWMSActivityInPDFExport: boolean
  showBuildPassSWMSTemplatesOption: boolean
  showStartFromScratchSWMSOption: boolean
  allowSavingNewSWMSTemplates: boolean
  allowOverridingExistingSWMSTemplates: boolean
  autoApproveSWMSForBuilder: boolean
  autoApproveSWMSForSubcontractorFromTemplate: boolean
  sharedSWMSTemplateIds?: Array<string> | null
  allowExpiringSWMS: boolean
  defaultSWMSHazardResponsible?: Array<string> | null
  librarySwmsExpiryDays?: number | null
}

export type ChecklistSettingsAttributesFragment = {
  __typename?: 'ChecklistSettings'
  publicChecklistIds?: Array<string> | null
  checklistsAvailableForStaff?: boolean | null
  checklistCategoriesInNavigation?: Array<string> | null
  onlySendActionsAfterChecklistCompleted?: boolean | null
  requireProjectInduction?: boolean | null
  showSubcontractorColumnInChecklistTable?: boolean | null
  checklistCategories?: Array<{
    __typename?: 'ChecklistCategorySetting'
    id: string
    label: string
    icon?: string | null
    colour?: string | null
  }> | null
}

export type InductionSettingsAttributesFragment = {
  __typename?: 'InductionSettings'
  projectIdsWithInductionDisabled?: Array<string> | null
  inductionsDisabledForAllProjects?: boolean | null
  preventWorkersAccessingDocumentsUntilApproved?: boolean | null
  inductionScanRequirementDisabledForAllProjects?: boolean | null
  projectIdsWithInductionScanRequirementDisabled?: Array<string> | null
  projectManagersCanEditInductionTemplates?: boolean | null
  projectIdsWithVisitorAccessToPublicDocumentsAfterInduction?: Array<string> | null
  preventInductionWithoutApprovedSwms?: boolean | null
}

export type ProjectSpecificInductionSettingsAttributesFragment = {
  __typename?: 'ProjectSpecificInductionSettings'
  siteInductionCode?: string | null
  siteInductionCodeDescription?: string | null
  projectManagersCanEditInductionTemplates?: boolean | null
}

export type SignOnSettingsAttributesFragment = {
  __typename?: 'SignOnSettings'
  projectIdsWithSignOnScanRequirementDisabled?: Array<string> | null
  signOnScanRequirementDisabledForAllProjects?: boolean | null
  geolocationSignOnOffRemindersEnabledForAllProjects?: boolean | null
  projectIdsWithGeolocationSignOnOffRemindersEnabled?: Array<string> | null
  preventSignOnWithoutValidTickets?: boolean | null
  preventSignOnUntilInductionApproved?: boolean | null
  geolocationAutoSignOnOffEnabledForAllProjects?: boolean | null
}

export type ProjectSpecificPermitSettingsAttributesFragment = {
  __typename?: 'ProjectSpecificPermitSettings'
  permitAdminNotificationsIds?: Array<string> | null
  authorisedWorkersForPermitRequests?: Array<string> | null
}

export type ProjectSpecificWorkerPermitSettingsAttributesFragment = {
  __typename?: 'ProjectSpecificWorkerPermitSettings'
  isAuthorisedToRequestPermits?: boolean | null
}

export type AiToolsSettingsAttributesFragment = {
  __typename?: 'AiToolsSettings'
  aiToolsEnabled?: boolean | null
  enabledByName?: string | null
  enabledByDate?: string | null
  checklistAssistantEnabled?: boolean | null
  imageTaggingEnabled?: boolean | null
  siteDiarySummaryEnabled?: boolean | null
  toolboxSummaryEnabled?: boolean | null
  defectEnhancementEnabled?: boolean | null
  documentSummaryEnabled?: boolean | null
  contentTaggingEnabled?: boolean | null
  locationImportEnabled?: boolean | null
  contextualActionGeneratorEnabled?: boolean | null
  requestedAiTools?: Array<string> | null
}

export type UserSettingsAttributesFragment = {
  __typename?: 'UserSettings'
  favourites?: Array<string> | null
}

export type SwmsSettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type SwmsSettingsUiQuery = {
  __typename?: 'Query'
  swmsSettings: {
    __typename?: 'SWMSSettings'
    includeSWMSChecklistInPDFExport: boolean
    includeSWMSActivityInPDFExport: boolean
    showBuildPassSWMSTemplatesOption: boolean
    showStartFromScratchSWMSOption: boolean
    allowSavingNewSWMSTemplates: boolean
    allowOverridingExistingSWMSTemplates: boolean
    autoApproveSWMSForBuilder: boolean
    autoApproveSWMSForSubcontractorFromTemplate: boolean
    sharedSWMSTemplateIds?: Array<string> | null
    allowExpiringSWMS: boolean
    defaultSWMSHazardResponsible?: Array<string> | null
    librarySwmsExpiryDays?: number | null
  }
}

export type UpdateSwmsSettingsUiMutationVariables = Exact<{
  input: UpdateSwmsSettingInput
}>

export type UpdateSwmsSettingsUiMutation = {
  __typename?: 'Mutation'
  updateSWMSSettings: {
    __typename?: 'SWMSSettings'
    includeSWMSChecklistInPDFExport: boolean
    includeSWMSActivityInPDFExport: boolean
    showBuildPassSWMSTemplatesOption: boolean
    showStartFromScratchSWMSOption: boolean
    allowSavingNewSWMSTemplates: boolean
    allowOverridingExistingSWMSTemplates: boolean
    autoApproveSWMSForBuilder: boolean
    autoApproveSWMSForSubcontractorFromTemplate: boolean
    sharedSWMSTemplateIds?: Array<string> | null
    allowExpiringSWMS: boolean
    defaultSWMSHazardResponsible?: Array<string> | null
    librarySwmsExpiryDays?: number | null
  }
}

export type TimesheetSettingsAttributesFragment = {
  __typename?: 'TimesheetSettings'
  requiresSecondaryApproval: boolean
  isSecondaryApprover: boolean
  timesheetEntryNotes: boolean
  timesheetStartEndTimes: boolean
  jobPacCsvExport: boolean
  isPrimaryApproverOfProjects?: Array<{
    __typename?: 'IsPrimaryApprover'
    projectId: string
    isPrimaryApprover: boolean
  }> | null
  timeTypes: Array<{
    __typename?: 'TimeType'
    id: string
    label: string
    icon?: string | null
    colour?: string | null
  } | null>
  costCodes: Array<{
    __typename?: 'CostCode'
    id: string
    code: string
    description: string
  } | null>
}

export type TimesheetSettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type TimesheetSettingsUiQuery = {
  __typename?: 'Query'
  timesheetSettings: {
    __typename?: 'TimesheetSettings'
    secondaryApproverIds?: Array<string> | null
    requiresSecondaryApproval: boolean
    isSecondaryApprover: boolean
    timesheetEntryNotes: boolean
    timesheetStartEndTimes: boolean
    jobPacCsvExport: boolean
    primaryApprovers?: Array<{
      __typename?: 'TimesheetPrimaryApprover'
      projectId: string
      adminUserIds?: Array<string> | null
    }> | null
    secondaryApprovers?: Array<{
      __typename?: 'AdminUserEntity'
      id: string
      user?: {
        __typename?: 'UserEntity'
        id?: string | null
        firstName?: string | null
        lastName?: string | null
      } | null
    }> | null
    subcontractorsWhitelist?: Array<{
      __typename?: 'SubcontractorEntity'
      id: string
      company: { __typename?: 'CompanyEntity'; name: string }
    }> | null
    isPrimaryApproverOfProjects?: Array<{
      __typename?: 'IsPrimaryApprover'
      projectId: string
      isPrimaryApprover: boolean
    }> | null
    timeTypes: Array<{
      __typename?: 'TimeType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    } | null>
    costCodes: Array<{
      __typename?: 'CostCode'
      id: string
      code: string
      description: string
    } | null>
  }
}

export type WorkerTimesheetSettingsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type WorkerTimesheetSettingsUiQuery = {
  __typename?: 'Query'
  workerTimesheetSettings: {
    __typename?: 'WorkerTimesheetSettings'
    isTimesheetsEnabledForMe: boolean
    timesheetEntryNotes: boolean
    timesheetStartEndTimes: boolean
    timeTypes: Array<{
      __typename?: 'TimeType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    } | null>
    costCodes: Array<{
      __typename?: 'CostCode'
      id: string
      code: string
      description: string
    } | null>
  }
}

export type UpdateTimesheetSettingsUiMutationVariables = Exact<{
  input: UpdateTimesheetSettingInput
}>

export type UpdateTimesheetSettingsUiMutation = {
  __typename?: 'Mutation'
  updateTimesheetSettings: {
    __typename?: 'TimesheetSettings'
    requiresSecondaryApproval: boolean
    isSecondaryApprover: boolean
    timesheetEntryNotes: boolean
    timesheetStartEndTimes: boolean
    jobPacCsvExport: boolean
    isPrimaryApproverOfProjects?: Array<{
      __typename?: 'IsPrimaryApprover'
      projectId: string
      isPrimaryApprover: boolean
    }> | null
    timeTypes: Array<{
      __typename?: 'TimeType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    } | null>
    costCodes: Array<{
      __typename?: 'CostCode'
      id: string
      code: string
      description: string
    } | null>
  }
}

export type ProcoreSettingsAttributesFragment = {
  __typename?: 'ProcoreSettings'
  syncProjects: boolean
  projectFields: Array<ProcoreProjectField>
  syncSubcontractors: boolean
  subcontractorFields: Array<ProcoreVendorField>
  syncInductions: boolean
  syncSiteDiaries: boolean
  syncToolboxes: boolean
  syncSwms: boolean
  syncChecklists: Array<string>
  notifyForProjects: boolean
  notifyForSubcontractors: boolean
  syncSiteAttendanceToDailyLog_Manpower?: boolean | null
  syncSiteAttendanceToDailyLog_Timecards?: boolean | null
}

export type ProcoreSettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type ProcoreSettingsUiQuery = {
  __typename?: 'Query'
  procoreSettings: {
    __typename?: 'ProcoreSettings'
    syncProjects: boolean
    projectFields: Array<ProcoreProjectField>
    syncSubcontractors: boolean
    subcontractorFields: Array<ProcoreVendorField>
    syncInductions: boolean
    syncSiteDiaries: boolean
    syncToolboxes: boolean
    syncSwms: boolean
    syncChecklists: Array<string>
    notifyForProjects: boolean
    notifyForSubcontractors: boolean
    syncSiteAttendanceToDailyLog_Manpower?: boolean | null
    syncSiteAttendanceToDailyLog_Timecards?: boolean | null
  }
}

export type UpdateProcoreSettingsUiMutationVariables = Exact<{
  input: UpdateProcoreSettingInput
}>

export type UpdateProcoreSettingsUiMutation = {
  __typename?: 'Mutation'
  updateProcoreSettings: {
    __typename?: 'ProcoreSettings'
    syncProjects: boolean
    projectFields: Array<ProcoreProjectField>
    syncSubcontractors: boolean
    subcontractorFields: Array<ProcoreVendorField>
    syncInductions: boolean
    syncSiteDiaries: boolean
    syncToolboxes: boolean
    syncSwms: boolean
    syncChecklists: Array<string>
    notifyForProjects: boolean
    notifyForSubcontractors: boolean
    syncSiteAttendanceToDailyLog_Manpower?: boolean | null
    syncSiteAttendanceToDailyLog_Timecards?: boolean | null
  }
}

export type PremierSettingsAttributesFragment = {
  __typename?: 'PremierSettings'
  syncProjects: boolean
  projectFields: Array<PremierProjectField>
  notifyForProjects: boolean
  syncSubcontractors: boolean
  subcontractorFields: Array<PremierSubcontractorField>
  notifyForSubcontractors: boolean
}

export type PremierSettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type PremierSettingsUiQuery = {
  __typename?: 'Query'
  premierSettings: {
    __typename?: 'PremierSettings'
    syncProjects: boolean
    projectFields: Array<PremierProjectField>
    notifyForProjects: boolean
    syncSubcontractors: boolean
    subcontractorFields: Array<PremierSubcontractorField>
    notifyForSubcontractors: boolean
  }
}

export type UpdatePremierSettingsUiMutationVariables = Exact<{
  input: UpdatePremierSettingInput
}>

export type UpdatePremierSettingsUiMutation = {
  __typename?: 'Mutation'
  updatePremierSettings: {
    __typename?: 'PremierSettings'
    syncProjects: boolean
    projectFields: Array<PremierProjectField>
    notifyForProjects: boolean
    syncSubcontractors: boolean
    subcontractorFields: Array<PremierSubcontractorField>
    notifyForSubcontractors: boolean
  }
}

export type GlobalInductionSettingsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type GlobalInductionSettingsUiQuery = {
  __typename?: 'Query'
  inductionSettings: {
    __typename?: 'InductionSettings'
    projectIdsWithInductionDisabled?: Array<string> | null
    inductionsDisabledForAllProjects?: boolean | null
    preventWorkersAccessingDocumentsUntilApproved?: boolean | null
    inductionScanRequirementDisabledForAllProjects?: boolean | null
    projectIdsWithInductionScanRequirementDisabled?: Array<string> | null
    projectManagersCanEditInductionTemplates?: boolean | null
    projectIdsWithVisitorAccessToPublicDocumentsAfterInduction?: Array<string> | null
    preventInductionWithoutApprovedSwms?: boolean | null
  }
}

export type ProjectSpecificInductionSettingsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectSpecificInductionSettingsUiQuery = {
  __typename?: 'Query'
  projectSpecificInductionSettings: {
    __typename?: 'ProjectSpecificInductionSettings'
    siteInductionCode?: string | null
    siteInductionCodeDescription?: string | null
    projectManagersCanEditInductionTemplates?: boolean | null
  }
}

export type UpdateInductionSettingsUiMutationVariables = Exact<{
  input: UpdateInductionSettingInput
}>

export type UpdateInductionSettingsUiMutation = {
  __typename?: 'Mutation'
  updateInductionSettings: {
    __typename?: 'InductionSettings'
    projectIdsWithInductionDisabled?: Array<string> | null
    inductionsDisabledForAllProjects?: boolean | null
    preventWorkersAccessingDocumentsUntilApproved?: boolean | null
    inductionScanRequirementDisabledForAllProjects?: boolean | null
    projectIdsWithInductionScanRequirementDisabled?: Array<string> | null
    projectManagersCanEditInductionTemplates?: boolean | null
    projectIdsWithVisitorAccessToPublicDocumentsAfterInduction?: Array<string> | null
    preventInductionWithoutApprovedSwms?: boolean | null
  }
}

export type UpdateProjectSpecificInductionSettingsUiMutationVariables = Exact<{
  projectId: Scalars['String']
  input: UpdateProjectSpecificInductionSettingInput
}>

export type UpdateProjectSpecificInductionSettingsUiMutation = {
  __typename?: 'Mutation'
  updateProjectSpecificInductionSettings: {
    __typename?: 'ProjectSpecificInductionSettings'
    siteInductionCode?: string | null
    siteInductionCodeDescription?: string | null
    projectManagersCanEditInductionTemplates?: boolean | null
  }
}

export type SignOnSettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type SignOnSettingsUiQuery = {
  __typename?: 'Query'
  signOnSettings: {
    __typename?: 'SignOnSettings'
    projectIdsWithSignOnScanRequirementDisabled?: Array<string> | null
    signOnScanRequirementDisabledForAllProjects?: boolean | null
    geolocationSignOnOffRemindersEnabledForAllProjects?: boolean | null
    projectIdsWithGeolocationSignOnOffRemindersEnabled?: Array<string> | null
    preventSignOnWithoutValidTickets?: boolean | null
    preventSignOnUntilInductionApproved?: boolean | null
    geolocationAutoSignOnOffEnabledForAllProjects?: boolean | null
  }
}

export type UpdateSignOnSettingsUiMutationVariables = Exact<{
  input: UpdateSignOnSettingInput
}>

export type UpdateSignOnSettingsUiMutation = {
  __typename?: 'Mutation'
  updateSignOnSettings: {
    __typename?: 'SignOnSettings'
    projectIdsWithSignOnScanRequirementDisabled?: Array<string> | null
    signOnScanRequirementDisabledForAllProjects?: boolean | null
    geolocationSignOnOffRemindersEnabledForAllProjects?: boolean | null
    projectIdsWithGeolocationSignOnOffRemindersEnabled?: Array<string> | null
    preventSignOnWithoutValidTickets?: boolean | null
    preventSignOnUntilInductionApproved?: boolean | null
    geolocationAutoSignOnOffEnabledForAllProjects?: boolean | null
  }
}

export type ProjectSpecificPermitSettingsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectSpecificPermitSettingsUiQuery = {
  __typename?: 'Query'
  projectSpecificPermitSettings: {
    __typename?: 'ProjectSpecificPermitSettings'
    permitAdminNotificationsIds?: Array<string> | null
    authorisedWorkersForPermitRequests?: Array<string> | null
  }
}

export type ProjectSpecificWorkerPermitSettingsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectSpecificWorkerPermitSettingsUiQuery = {
  __typename?: 'Query'
  projectSpecificWorkerPermitSettings: {
    __typename?: 'ProjectSpecificWorkerPermitSettings'
    isAuthorisedToRequestPermits?: boolean | null
  }
}

export type UpdateProjectSpecificPermitSettingsUiMutationVariables = Exact<{
  projectId: Scalars['String']
  input: UpdateProjectSpecificPermitSettingsInput
}>

export type UpdateProjectSpecificPermitSettingsUiMutation = {
  __typename?: 'Mutation'
  updateProjectSpecificPermitSettings: {
    __typename?: 'ProjectSpecificPermitSettings'
    permitAdminNotificationsIds?: Array<string> | null
    authorisedWorkersForPermitRequests?: Array<string> | null
  }
}

export type ChecklistSettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type ChecklistSettingsUiQuery = {
  __typename?: 'Query'
  checklistSettings: {
    __typename?: 'ChecklistSettings'
    publicChecklistIds?: Array<string> | null
    checklistsAvailableForStaff?: boolean | null
    checklistCategoriesInNavigation?: Array<string> | null
    onlySendActionsAfterChecklistCompleted?: boolean | null
    requireProjectInduction?: boolean | null
    showSubcontractorColumnInChecklistTable?: boolean | null
    checklistCategories?: Array<{
      __typename?: 'ChecklistCategorySetting'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    }> | null
  }
}

export type UpdateChecklistSettingsUiMutationVariables = Exact<{
  input: UpdateChecklistSettingInput
}>

export type UpdateChecklistSettingsUiMutation = {
  __typename?: 'Mutation'
  updateChecklistSettings: {
    __typename?: 'ChecklistSettings'
    publicChecklistIds?: Array<string> | null
    checklistsAvailableForStaff?: boolean | null
    checklistCategoriesInNavigation?: Array<string> | null
    onlySendActionsAfterChecklistCompleted?: boolean | null
    requireProjectInduction?: boolean | null
    showSubcontractorColumnInChecklistTable?: boolean | null
    checklistCategories?: Array<{
      __typename?: 'ChecklistCategorySetting'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    }> | null
  }
}

export type SubcontractorSettingsAttributesFragment = {
  __typename?: 'SubcontractorSettings'
  expiredInsurancesEmails: boolean
  notifyAdminUsers?: Array<string> | null
  customInsurancesTypes?: Array<string> | null
}

export type SubcontractorSettingsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type SubcontractorSettingsUiQuery = {
  __typename?: 'Query'
  subcontractorSettings: {
    __typename?: 'SubcontractorSettings'
    expiredInsurancesEmails: boolean
    notifyAdminUsers?: Array<string> | null
    customInsurancesTypes?: Array<string> | null
  }
}

export type PublicSubcontractorSettingsUiQueryVariables = Exact<{
  builderId: Scalars['String']
}>

export type PublicSubcontractorSettingsUiQuery = {
  __typename?: 'Query'
  publicSubcontractorSettings: {
    __typename?: 'PublicSubcontractorSettings'
    customInsurancesTypes?: Array<string> | null
  }
}

export type UpdateSubcontractorSettingsUiMutationVariables = Exact<{
  input: UpdateSubcontractorSettingInput
}>

export type UpdateSubcontractorSettingsUiMutation = {
  __typename?: 'Mutation'
  updateSubcontractorSettings: {
    __typename?: 'SubcontractorSettings'
    expiredInsurancesEmails: boolean
    notifyAdminUsers?: Array<string> | null
    customInsurancesTypes?: Array<string> | null
  }
}

export type AddPublicChecklistUiMutationVariables = Exact<{
  checklistId: Scalars['String']
}>

export type AddPublicChecklistUiMutation = {
  __typename?: 'Mutation'
  addPublicChecklist: {
    __typename?: 'ChecklistSettings'
    publicChecklistIds?: Array<string> | null
  }
}

export type RemovePublicChecklistUiMutationVariables = Exact<{
  checklistId: Scalars['String']
}>

export type RemovePublicChecklistUiMutation = {
  __typename?: 'Mutation'
  removePublicChecklist: {
    __typename?: 'ChecklistSettings'
    publicChecklistIds?: Array<string> | null
  }
}

export type PlatformActionSettingsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type PlatformActionSettingsUiQuery = {
  __typename?: 'Query'
  platformActionSettings: {
    __typename?: 'PlatformActionSettings'
    sendReminderEnabled: boolean
    sendReminderDays: number
    overdueActionsReminder: boolean
    overdueActionsReminderFrequency: number
    overdueActionsReminderAdminUsers?: Array<string> | null
    actionsDueSoonReminder: boolean
    actionsDueSoonReminderDays: number
    actionsDueSoonReminderFrequency: number
    actionsDueSoonReminderAdminUsers?: Array<string> | null
    allowSubcontractorsToCloseActions: boolean
    types: Array<{
      __typename?: 'PlatformActionType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    }>
    priorities: Array<{
      __typename?: 'PlatformActionPriorityType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    }>
  }
}

export type PublicPlatformActionSettingsUiQueryVariables = Exact<{
  builderId: Scalars['String']
}>

export type PublicPlatformActionSettingsUiQuery = {
  __typename?: 'Query'
  publicPlatformActionSettings: {
    __typename?: 'PublicPlatformActionSettings'
    types: Array<{
      __typename?: 'PlatformActionType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    }>
    priorities: Array<{
      __typename?: 'PlatformActionPriorityType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    }>
  }
}

export type UpdatePlatformActionSettingsUiMutationVariables = Exact<{
  input: UpdatePlatformActionSettingInput
}>

export type UpdatePlatformActionSettingsUiMutation = {
  __typename?: 'Mutation'
  updatePlatformActionSettings: {
    __typename?: 'PlatformActionSettings'
    sendReminderEnabled: boolean
    sendReminderDays: number
    overdueActionsReminder: boolean
    overdueActionsReminderFrequency: number
    overdueActionsReminderAdminUsers?: Array<string> | null
    actionsDueSoonReminder: boolean
    actionsDueSoonReminderDays: number
    actionsDueSoonReminderFrequency: number
    actionsDueSoonReminderAdminUsers?: Array<string> | null
    allowSubcontractorsToCloseActions: boolean
    types: Array<{
      __typename?: 'PlatformActionType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    }>
    priorities: Array<{
      __typename?: 'PlatformActionPriorityType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    }>
  }
}

export type HoursBudgetSettingsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type HoursBudgetSettingsUiQuery = {
  __typename?: 'Query'
  hoursBudgetSettings: {
    __typename?: 'HoursBudgetSettings'
    hoursBudget?: number | null
  }
}

export type UpdateHoursBudgetSettingsUiMutationVariables = Exact<{
  projectId: Scalars['String']
  input: UpdateHoursBudgetSettingsInput
}>

export type UpdateHoursBudgetSettingsUiMutation = {
  __typename?: 'Mutation'
  updateHoursBudgetSettings: {
    __typename?: 'HoursBudgetSettings'
    hoursBudget?: number | null
  }
}

export type DefectSettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type DefectSettingsUiQuery = {
  __typename?: 'Query'
  defectSettings: {
    __typename?: 'DefectSettings'
    allowWorkerAssignees: boolean
    notifyAssigneesOnDefectCreated: boolean
  }
}

export type UpdateDefectSettingsUiMutationVariables = Exact<{
  input: UpdateDefectSettingsInput
}>

export type UpdateDefectSettingsUiMutation = {
  __typename?: 'Mutation'
  updateDefectSettings: {
    __typename?: 'DefectSettings'
    allowWorkerAssignees: boolean
    notifyAssigneesOnDefectCreated: boolean
  }
}

export type BuilderRegisterSettingsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type BuilderRegisterSettingsUiQuery = {
  __typename?: 'Query'
  builderRegisterSettings: {
    __typename?: 'BuilderRegisterSettings'
    onlyAllowReviewedRegisterItemChecklists: boolean
  }
}

export type UpdateBuilderRegisterSettingsUiMutationVariables = Exact<{
  input: UpdateBuilderRegisterSettingsInput
}>

export type UpdateBuilderRegisterSettingsUiMutation = {
  __typename?: 'Mutation'
  updateBuilderRegisterSettings: {
    __typename?: 'BuilderRegisterSettings'
    onlyAllowReviewedRegisterItemChecklists: boolean
  }
}

export type PrequalificationSettingsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type PrequalificationSettingsUiQuery = {
  __typename?: 'Query'
  prequalificationSettings: {
    __typename?: 'PrequalificationSettings'
    notifyAdminUsers?: Array<string> | null
    notifyAdminUsersOnApproval?: Array<string> | null
  }
}

export type UpdatePrequalificationSettingsUiMutationVariables = Exact<{
  input: UpdatePrequalificationSettingsInput
}>

export type UpdatePrequalificationSettingsUiMutation = {
  __typename?: 'Mutation'
  updatePrequalificationSettings: {
    __typename?: 'PrequalificationSettings'
    notifyAdminUsers?: Array<string> | null
    notifyAdminUsersOnApproval?: Array<string> | null
  }
}

export type StylingSettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type StylingSettingsUiQuery = {
  __typename?: 'Query'
  stylingSettings: {
    __typename?: 'StylingSettings'
    primaryColour?: string | null
    buttonTextColour?: string | null
    primaryTextColour?: string | null
  }
}

export type UpdateStylingSettingsUiMutationVariables = Exact<{
  input: UpdateStylingSettingsInput
}>

export type UpdateStylingSettingsUiMutation = {
  __typename?: 'Mutation'
  updateStylingSettings: {
    __typename?: 'StylingSettings'
    primaryColour?: string | null
    buttonTextColour?: string | null
    primaryTextColour?: string | null
  }
}

export type CommunicationSettingsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type CommunicationSettingsUiQuery = {
  __typename?: 'Query'
  communicationSettings: {
    __typename?: 'CommunicationSettings'
    allowCompanyWideCommunication?: boolean | null
  }
}

export type UpdateCommunicationSettingsUiMutationVariables = Exact<{
  input: UpdateCommunicationSettingsInput
}>

export type UpdateCommunicationSettingsUiMutation = {
  __typename?: 'Mutation'
  updateCommunicationSettings: {
    __typename?: 'CommunicationSettings'
    allowCompanyWideCommunication?: boolean | null
  }
}

export type AiToolsSettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type AiToolsSettingsUiQuery = {
  __typename?: 'Query'
  aiToolsSettings: {
    __typename?: 'AiToolsSettings'
    aiToolsEnabled?: boolean | null
    enabledByName?: string | null
    enabledByDate?: string | null
    checklistAssistantEnabled?: boolean | null
    imageTaggingEnabled?: boolean | null
    siteDiarySummaryEnabled?: boolean | null
    toolboxSummaryEnabled?: boolean | null
    defectEnhancementEnabled?: boolean | null
    documentSummaryEnabled?: boolean | null
    contentTaggingEnabled?: boolean | null
    locationImportEnabled?: boolean | null
    contextualActionGeneratorEnabled?: boolean | null
    requestedAiTools?: Array<string> | null
  }
}

export type UpdateAiToolsSettingsUiMutationVariables = Exact<{
  input: UpdateAiToolsSettingsInput
}>

export type UpdateAiToolsSettingsUiMutation = {
  __typename?: 'Mutation'
  updateAiToolsSettings: {
    __typename?: 'AiToolsSettings'
    aiToolsEnabled?: boolean | null
    enabledByName?: string | null
    enabledByDate?: string | null
    checklistAssistantEnabled?: boolean | null
    imageTaggingEnabled?: boolean | null
    siteDiarySummaryEnabled?: boolean | null
    toolboxSummaryEnabled?: boolean | null
    defectEnhancementEnabled?: boolean | null
    documentSummaryEnabled?: boolean | null
    contentTaggingEnabled?: boolean | null
    locationImportEnabled?: boolean | null
    contextualActionGeneratorEnabled?: boolean | null
    requestedAiTools?: Array<string> | null
  }
}

export type ToggleAiToolsEnabledSettingsUiMutationVariables = Exact<{
  [key: string]: never
}>

export type ToggleAiToolsEnabledSettingsUiMutation = {
  __typename?: 'Mutation'
  toggleAiToolsEnabledSettings: {
    __typename?: 'AiToolsSettings'
    aiToolsEnabled?: boolean | null
    enabledByName?: string | null
    enabledByDate?: string | null
    checklistAssistantEnabled?: boolean | null
    imageTaggingEnabled?: boolean | null
    siteDiarySummaryEnabled?: boolean | null
    toolboxSummaryEnabled?: boolean | null
    defectEnhancementEnabled?: boolean | null
    documentSummaryEnabled?: boolean | null
    contentTaggingEnabled?: boolean | null
    locationImportEnabled?: boolean | null
    contextualActionGeneratorEnabled?: boolean | null
    requestedAiTools?: Array<string> | null
  }
}

export type RequestAiToolSettingsUiMutationVariables = Exact<{
  tool: Scalars['String']
}>

export type RequestAiToolSettingsUiMutation = {
  __typename?: 'Mutation'
  requestAiToolSettings: {
    __typename?: 'AiToolsSettings'
    aiToolsEnabled?: boolean | null
    enabledByName?: string | null
    enabledByDate?: string | null
    checklistAssistantEnabled?: boolean | null
    imageTaggingEnabled?: boolean | null
    siteDiarySummaryEnabled?: boolean | null
    toolboxSummaryEnabled?: boolean | null
    defectEnhancementEnabled?: boolean | null
    documentSummaryEnabled?: boolean | null
    contentTaggingEnabled?: boolean | null
    locationImportEnabled?: boolean | null
    contextualActionGeneratorEnabled?: boolean | null
    requestedAiTools?: Array<string> | null
  }
}

export type RegisterAiToolsUsageUiMutationVariables = Exact<{
  tool: Scalars['String']
  action: Scalars['String']
}>

export type RegisterAiToolsUsageUiMutation = {
  __typename?: 'Mutation'
  registerAIToolsUsage: boolean
}

export type UpdateUserSettingsUiMutationVariables = Exact<{
  input: UpdateUserSettings
}>

export type UpdateUserSettingsUiMutation = {
  __typename?: 'Mutation'
  updateUserSettings: {
    __typename?: 'UserSettings'
    favourites?: Array<string> | null
  }
}

export type GallerySettingsAttributesFragment = {
  __typename?: 'GallerySettings'
  defaultCompression?: ImageCompressionPreset | null
}

export type GallerySettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type GallerySettingsUiQuery = {
  __typename?: 'Query'
  gallerySettings: {
    __typename?: 'GallerySettings'
    defaultCompression?: ImageCompressionPreset | null
  }
}

export type UpdateGallerySettingsUiMutationVariables = Exact<{
  input: UpdateGallerySettingsInput
}>

export type UpdateGallerySettingsUiMutation = {
  __typename?: 'Mutation'
  updateGallerySettings: {
    __typename?: 'GallerySettings'
    defaultCompression?: ImageCompressionPreset | null
  }
}

export type ProjectUserSuggestionsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectUserSuggestionsUiQuery = {
  __typename?: 'Query'
  projectSpecificUserSettings: {
    __typename?: 'ProjectSpecificUserSettings'
    aiSuggestionsLastGenerated?: string | null
    birthdayWorkerNames?: string | null
    aiSuggestions?: Array<{
      __typename?: 'UserAISuggestion'
      resource: Resource
      resourceId?: string | null
      resourceName?: string | null
      nextPromptDate?: string | null
      hasCreatedToday: boolean
    }> | null
  }
}

export type GenerateUserAiSuggestionsUiMutationVariables = Exact<{
  projectId: Scalars['String']
}>

export type GenerateUserAiSuggestionsUiMutation = {
  __typename?: 'Mutation'
  generateUserAISuggestions: boolean
}

export type ProjectSpecificSiteDiarySettingsAttributesFragment = {
  __typename?: 'ProjectSpecificSiteDiarySettings'
  automaticCreationEnabled: boolean
}

export type ProjectSpecificSiteDiarySettingsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectSpecificSiteDiarySettingsUiQuery = {
  __typename?: 'Query'
  projectSpecificSiteDiarySettings: {
    __typename?: 'ProjectSpecificSiteDiarySettings'
    automaticCreationEnabled: boolean
  }
}

export type UpdateProjectSpecificSiteDiarySettingsUiMutationVariables = Exact<{
  projectId: Scalars['String']
  input: UpdateProjectSpecificSiteDiarySettingsInput
}>

export type UpdateProjectSpecificSiteDiarySettingsUiMutation = {
  __typename?: 'Mutation'
  updateProjectSpecificSiteDiarySettings: {
    __typename?: 'ProjectSpecificSiteDiarySettings'
    automaticCreationEnabled: boolean
  }
}

export type AgaveFoldersByProjectQueryVariables = Exact<{
  projectId: Scalars['String']
  parentFolderId?: InputMaybe<Scalars['String']>
  integrationType: IntegrationType
}>

export type AgaveFoldersByProjectQuery = {
  __typename?: 'Query'
  agaveFoldersByProject?: Array<{
    __typename?: 'AgaveFolder'
    id: string
    name: string
    hasChildren: boolean
  } | null> | null
}

export type AgaveFolderUiQueryVariables = Exact<{
  projectId: Scalars['String']
  folderId: Scalars['String']
  integrationType: IntegrationType
}>

export type AgaveFolderUiQuery = {
  __typename?: 'Query'
  agaveFolder?: { __typename?: 'AgaveFolder'; id: string; name: string } | null
}

export type ProjectSpecificProcoreSettingsAttributesFragment = {
  __typename?: 'ProjectSpecificProcoreSettings'
  inductionFolderId?: string | null
  siteDiaryFolderId?: string | null
  toolboxFolderId?: string | null
  swmsFolderId?: string | null
  checklistFolderId?: string | null
}

export type ProjectSpecificProcoreSettingsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ProjectSpecificProcoreSettingsUiQuery = {
  __typename?: 'Query'
  projectSpecificProcoreSettings?: {
    __typename?: 'ProjectSpecificProcoreSettings'
    inductionFolderId?: string | null
    siteDiaryFolderId?: string | null
    toolboxFolderId?: string | null
    swmsFolderId?: string | null
    checklistFolderId?: string | null
  } | null
}

export type UpdateProjectSpecificProcoreSettingsUiMutationVariables = Exact<{
  projectId: Scalars['String']
  input: UpdateProjectSpecificProcoreSettingInput
}>

export type UpdateProjectSpecificProcoreSettingsUiMutation = {
  __typename?: 'Mutation'
  updateProjectSpecificProcoreSettings: {
    __typename?: 'ProjectSpecificProcoreSettings'
    inductionFolderId?: string | null
    siteDiaryFolderId?: string | null
    toolboxFolderId?: string | null
    swmsFolderId?: string | null
    checklistFolderId?: string | null
  }
}

export type InductionInviteUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type InductionInviteUiQuery = {
  __typename?: 'Query'
  inductionInvite?: {
    __typename?: 'InductionInvite'
    id: string
    metadata?: any | null
  } | null
}

export type SignOnAttributesForBulkSignOffFragment = {
  __typename?: 'SignOn'
  id: string
  createdAt: string
  updatedAt?: string | null
  archivedAt?: string | null
  builderGenerated: boolean
  integrationGenerated?: boolean | null
  integrationType?: string | null
  manualSignedOnAt?: string | null
  signedOffAt?: string | null
  manualSignedOffAt?: string | null
  project?: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
  } | null
  worker?: {
    __typename?: 'Worker'
    id: string
    trade?: string | null
    builderGenerated: boolean
    mobile?: string | null
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
  } | null
  visitor?: {
    __typename?: 'Visitor'
    id: string
    mobile?: string | null
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null
}

export type SignOnAttributesFragment = {
  __typename?: 'SignOn'
  id: string
  createdAt: string
  updatedAt?: string | null
  archivedAt?: string | null
  metadata?: any | null
  builderGenerated: boolean
  integrationGenerated?: boolean | null
  integrationType?: string | null
  manualSignedOnAt?: string | null
  signedOffAt?: string | null
  manualSignedOffAt?: string | null
  contextMetadata?: {
    __typename?: 'ContextMetadata'
    createdFrom?: CreatedFromContext | null
    formName?: string | null
    geolocationContext?: {
      __typename?: 'GeolocationContext'
      autoSignOn?: boolean | null
      autoSignOff?: boolean | null
    } | null
  } | null
  signOnHours?: {
    __typename?: 'SignOnHours'
    hours?: number | null
    updatedAt?: string | null
  } | null
  preStarts?: Array<{
    __typename?: 'PreStart'
    id: string
    template: { __typename?: 'TemplateResponse'; responseData?: any | null }
  } | null> | null
  project?: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
  } | null
  worker?: {
    __typename?: 'Worker'
    id: string
    trade?: string | null
    builderGenerated: boolean
    mobile?: string | null
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
    tickets?: Array<{
      __typename?: 'Ticket'
      id: string
      expiry?: string | null
      files: Array<{
        __typename?: 'TicketFile'
        file: {
          __typename?: 'File'
          url?: string | null
          name: string
          contentType: string
        }
      } | null>
      ticketTemplate: {
        __typename?: 'TicketTemplate'
        name: string
        shortName: string
      }
    } | null> | null
  } | null
  visitor?: {
    __typename?: 'Visitor'
    id: string
    mobile?: string | null
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null
}

export type SignOnsForBulkSignOffUiQueryVariables = Exact<{
  filter?: InputMaybe<SignOnFilterInput>
  sort?: InputMaybe<SignOnSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type SignOnsForBulkSignOffUiQuery = {
  __typename?: 'Query'
  signOns: Array<{
    __typename?: 'SignOn'
    id: string
    createdAt: string
    updatedAt?: string | null
    archivedAt?: string | null
    builderGenerated: boolean
    integrationGenerated?: boolean | null
    integrationType?: string | null
    manualSignedOnAt?: string | null
    signedOffAt?: string | null
    manualSignedOffAt?: string | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      trade?: string | null
      builderGenerated: boolean
      mobile?: string | null
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
    } | null
    visitor?: {
      __typename?: 'Visitor'
      id: string
      mobile?: string | null
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }>
  signOnsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SignOnsUiQueryVariables = Exact<{
  filter?: InputMaybe<SignOnFilterInput>
  sort?: InputMaybe<SignOnSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type SignOnsUiQuery = {
  __typename?: 'Query'
  signOns: Array<{
    __typename?: 'SignOn'
    id: string
    createdAt: string
    updatedAt?: string | null
    archivedAt?: string | null
    metadata?: any | null
    builderGenerated: boolean
    integrationGenerated?: boolean | null
    integrationType?: string | null
    manualSignedOnAt?: string | null
    signedOffAt?: string | null
    manualSignedOffAt?: string | null
    contextMetadata?: {
      __typename?: 'ContextMetadata'
      createdFrom?: CreatedFromContext | null
      formName?: string | null
      geolocationContext?: {
        __typename?: 'GeolocationContext'
        autoSignOn?: boolean | null
        autoSignOff?: boolean | null
      } | null
    } | null
    signOnHours?: {
      __typename?: 'SignOnHours'
      hours?: number | null
      updatedAt?: string | null
    } | null
    preStarts?: Array<{
      __typename?: 'PreStart'
      id: string
      template: { __typename?: 'TemplateResponse'; responseData?: any | null }
    } | null> | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      trade?: string | null
      builderGenerated: boolean
      mobile?: string | null
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
      tickets?: Array<{
        __typename?: 'Ticket'
        id: string
        expiry?: string | null
        files: Array<{
          __typename?: 'TicketFile'
          file: {
            __typename?: 'File'
            url?: string | null
            name: string
            contentType: string
          }
        } | null>
        ticketTemplate: {
          __typename?: 'TicketTemplate'
          name: string
          shortName: string
        }
      } | null> | null
    } | null
    visitor?: {
      __typename?: 'Visitor'
      id: string
      mobile?: string | null
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }>
  signOnsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SignOnsForCsvUiQueryVariables = Exact<{
  filter?: InputMaybe<SignOnFilterInput>
  sort?: InputMaybe<SignOnSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type SignOnsForCsvUiQuery = {
  __typename?: 'Query'
  signOns: Array<{
    __typename?: 'SignOn'
    id: string
    createdAt: string
    manualSignedOnAt?: string | null
    manualSignedOffAt?: string | null
    signedOffAt?: string | null
    builderGenerated: boolean
    integrationGenerated?: boolean | null
    integrationType?: string | null
    signOnHours?: { __typename?: 'SignOnHours'; hours?: number | null } | null
    visitor?: {
      __typename?: 'Visitor'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      mobile?: string | null
      trade?: string | null
      builderGenerated: boolean
      user: {
        __typename?: 'User'
        email?: string | null
        firstName: string
        lastName: string
      }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        company: { __typename?: 'Company'; name: string }
      } | null>
    } | null
    project?: { __typename?: 'Project'; name: string } | null
  }>
}

export type SignOnsListUiQueryVariables = Exact<{
  filter?: InputMaybe<SignOnFilterInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type SignOnsListUiQuery = {
  __typename?: 'Query'
  signOns: Array<{
    __typename?: 'SignOn'
    id: string
    createdAt: string
    updatedAt?: string | null
    archivedAt?: string | null
    builderGenerated: boolean
    integrationGenerated?: boolean | null
    manualSignedOnAt?: string | null
    signedOffAt?: string | null
    manualSignedOffAt?: string | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    worker?: { __typename?: 'Worker'; id: string } | null
    visitor?: { __typename?: 'Visitor'; id: string } | null
  }>
  signOnsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type ProcessedSignOnsAdminUiQueryVariables = Exact<{
  filter?: InputMaybe<SignOnFilterInput>
}>

export type ProcessedSignOnsAdminUiQuery = {
  __typename?: 'Query'
  processedSignOns_admin: Array<{
    __typename?: 'ProcessedSignOn'
    id: string
    workerId: string
    projectId: string
    signOnTime: string
    signOffTime?: string | null
  }>
}

export type ProcessedSignOnsWorkerUiQueryVariables = Exact<{
  filter?: InputMaybe<ProcessedSignOnFilterInput>
}>

export type ProcessedSignOnsWorkerUiQuery = {
  __typename?: 'Query'
  processedSignOns_worker: Array<{
    __typename?: 'ProcessedSignOn'
    id: string
    workerId: string
    projectId: string
    signOnTime: string
    signOffTime?: string | null
  }>
}

export type SignOnUiQueryVariables = Exact<{
  signOnId: Scalars['String']
}>

export type SignOnUiQuery = {
  __typename?: 'Query'
  signOn?: {
    __typename?: 'SignOn'
    id: string
    createdAt: string
    updatedAt?: string | null
    archivedAt?: string | null
    metadata?: any | null
    builderGenerated: boolean
    integrationGenerated?: boolean | null
    integrationType?: string | null
    manualSignedOnAt?: string | null
    signedOffAt?: string | null
    manualSignedOffAt?: string | null
    contextMetadata?: {
      __typename?: 'ContextMetadata'
      createdFrom?: CreatedFromContext | null
      formName?: string | null
      geolocationContext?: {
        __typename?: 'GeolocationContext'
        autoSignOn?: boolean | null
        autoSignOff?: boolean | null
      } | null
    } | null
    signOnHours?: {
      __typename?: 'SignOnHours'
      hours?: number | null
      updatedAt?: string | null
    } | null
    preStarts?: Array<{
      __typename?: 'PreStart'
      id: string
      template: { __typename?: 'TemplateResponse'; responseData?: any | null }
    } | null> | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      trade?: string | null
      builderGenerated: boolean
      mobile?: string | null
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
      tickets?: Array<{
        __typename?: 'Ticket'
        id: string
        expiry?: string | null
        files: Array<{
          __typename?: 'TicketFile'
          file: {
            __typename?: 'File'
            url?: string | null
            name: string
            contentType: string
          }
        } | null>
        ticketTemplate: {
          __typename?: 'TicketTemplate'
          name: string
          shortName: string
        }
      } | null> | null
    } | null
    visitor?: {
      __typename?: 'Visitor'
      id: string
      mobile?: string | null
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  } | null
}

export type CreateSignOnUiMutationVariables = Exact<{
  input: CreateSignOnInput
}>

export type CreateSignOnUiMutation = {
  __typename?: 'Mutation'
  createSignOn: {
    __typename?: 'SignOn'
    id: string
    createdAt: string
    updatedAt?: string | null
    archivedAt?: string | null
    metadata?: any | null
    builderGenerated: boolean
    integrationGenerated?: boolean | null
    integrationType?: string | null
    manualSignedOnAt?: string | null
    signedOffAt?: string | null
    manualSignedOffAt?: string | null
    contextMetadata?: {
      __typename?: 'ContextMetadata'
      createdFrom?: CreatedFromContext | null
      formName?: string | null
      geolocationContext?: {
        __typename?: 'GeolocationContext'
        autoSignOn?: boolean | null
        autoSignOff?: boolean | null
      } | null
    } | null
    signOnHours?: {
      __typename?: 'SignOnHours'
      hours?: number | null
      updatedAt?: string | null
    } | null
    preStarts?: Array<{
      __typename?: 'PreStart'
      id: string
      template: { __typename?: 'TemplateResponse'; responseData?: any | null }
    } | null> | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      trade?: string | null
      builderGenerated: boolean
      mobile?: string | null
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
      tickets?: Array<{
        __typename?: 'Ticket'
        id: string
        expiry?: string | null
        files: Array<{
          __typename?: 'TicketFile'
          file: {
            __typename?: 'File'
            url?: string | null
            name: string
            contentType: string
          }
        } | null>
        ticketTemplate: {
          __typename?: 'TicketTemplate'
          name: string
          shortName: string
        }
      } | null> | null
    } | null
    visitor?: {
      __typename?: 'Visitor'
      id: string
      mobile?: string | null
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }
}

export type ManuallySignOffUiMutationVariables = Exact<{
  input: ManuallySignOffInput
}>

export type ManuallySignOffUiMutation = {
  __typename?: 'Mutation'
  manuallySignOff: {
    __typename?: 'SignOn'
    id: string
    createdAt: string
    updatedAt?: string | null
    archivedAt?: string | null
    metadata?: any | null
    builderGenerated: boolean
    integrationGenerated?: boolean | null
    integrationType?: string | null
    manualSignedOnAt?: string | null
    signedOffAt?: string | null
    manualSignedOffAt?: string | null
    contextMetadata?: {
      __typename?: 'ContextMetadata'
      createdFrom?: CreatedFromContext | null
      formName?: string | null
      geolocationContext?: {
        __typename?: 'GeolocationContext'
        autoSignOn?: boolean | null
        autoSignOff?: boolean | null
      } | null
    } | null
    signOnHours?: {
      __typename?: 'SignOnHours'
      hours?: number | null
      updatedAt?: string | null
    } | null
    preStarts?: Array<{
      __typename?: 'PreStart'
      id: string
      template: { __typename?: 'TemplateResponse'; responseData?: any | null }
    } | null> | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      trade?: string | null
      builderGenerated: boolean
      mobile?: string | null
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
      tickets?: Array<{
        __typename?: 'Ticket'
        id: string
        expiry?: string | null
        files: Array<{
          __typename?: 'TicketFile'
          file: {
            __typename?: 'File'
            url?: string | null
            name: string
            contentType: string
          }
        } | null>
        ticketTemplate: {
          __typename?: 'TicketTemplate'
          name: string
          shortName: string
        }
      } | null> | null
    } | null
    visitor?: {
      __typename?: 'Visitor'
      id: string
      mobile?: string | null
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }
}

export type CreateWorkerSignOnFromFormUiMutationVariables = Exact<{
  input: CreateWorkerSignOnFromFormInput
}>

export type CreateWorkerSignOnFromFormUiMutation = {
  __typename?: 'Mutation'
  createWorkerSignOnFromForm: { __typename?: 'SignOn'; id: string }
}

export type CreateWorkerSignOnFromFormWorkerUiMutationVariables = Exact<{
  input: CreateWorkerSignOnFromFormWorkerInput
}>

export type CreateWorkerSignOnFromFormWorkerUiMutation = {
  __typename?: 'Mutation'
  createWorkerSignOnFromForm_worker: {
    __typename?: 'SignOn_Worker'
    id: string
  }
}

export type ManuallySignOffBulkUiMutationVariables = Exact<{
  input: ManuallySignOffBulkInput
}>

export type ManuallySignOffBulkUiMutation = {
  __typename?: 'Mutation'
  manuallySignOffBulk: Array<{
    __typename?: 'SignOn'
    id: string
    createdAt: string
    updatedAt?: string | null
    archivedAt?: string | null
    builderGenerated: boolean
    integrationGenerated?: boolean | null
    integrationType?: string | null
    manualSignedOnAt?: string | null
    signedOffAt?: string | null
    manualSignedOffAt?: string | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      trade?: string | null
      builderGenerated: boolean
      mobile?: string | null
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
    } | null
    visitor?: {
      __typename?: 'Visitor'
      id: string
      mobile?: string | null
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }>
}

export type CreateWorkerSignOnUiMutationVariables = Exact<{
  input: CreateSignOnInput
}>

export type CreateWorkerSignOnUiMutation = {
  __typename?: 'Mutation'
  createSignOn: { __typename?: 'SignOn'; id: string }
}

export type CreateVisitorSignOnUiMutationVariables = Exact<{
  input: CreateVisitorSignOnInput
}>

export type CreateVisitorSignOnUiMutation = {
  __typename?: 'Mutation'
  createVisitorSignOn: { __typename?: 'SignOn'; id: string }
}

export type ArchiveSignOnUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveSignOnUiMutation = {
  __typename?: 'Mutation'
  archiveSignOn: { __typename?: 'SignOn'; id: string }
}

export type RestoreSignOnUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreSignOnUiMutation = {
  __typename?: 'Mutation'
  restoreSignOn: { __typename?: 'SignOn'; id: string }
}

export type SaSignOnsByProjectQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type SaSignOnsByProjectQuery = {
  __typename?: 'Query'
  signOnsByProject: Array<{
    __typename?: 'SignOn'
    id: string
    createdAt: string
    contextMetadata?: {
      __typename?: 'ContextMetadata'
      geolocationContext?: {
        __typename?: 'GeolocationContext'
        signOnGeolocationData?: {
          __typename?: 'GeolocationData'
          latitude?: number | null
          longitude?: number | null
          accuracy?: number | null
        } | null
        signOffGeolocationData?: {
          __typename?: 'GeolocationData'
          latitude?: number | null
          longitude?: number | null
          accuracy?: number | null
        } | null
      } | null
    } | null
  }>
}

export type SiteDiaryAttributesFragment = {
  __typename?: 'SiteDiary'
  id: string
  createdAt: string
  archivedAt?: string | null
  date: string
  createdBy?: {
    __typename?: 'User'
    id: string
    firstName: string
    lastName: string
    email?: string | null
  } | null
  templateResponse: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
    completedAt?: string | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateData?: any | null
        }
      | { __typename?: 'Template'; id: string; templateData?: any | null }
      | null
  }
  project: {
    __typename?: 'Project'
    id: string
    name: string
    timezone?: string | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }
}

export type SiteDiaryListAttributesFragment = {
  __typename?: 'SiteDiary'
  id: string
  createdAt: string
  archivedAt?: string | null
  date: string
  templateResponseId: string
  project: { __typename?: 'Project'; id: string; name: string }
  templateResponse: {
    __typename?: 'TemplateResponse'
    tableBlocks?: any | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      url: string
      fileName: string
      thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
    }> | null
  }
  statistics?: {
    __typename?: 'SiteDiaryStatistics'
    numberOfWorkers?: number | null
    numberOfSubcontractors?: number | null
    projectHours?: number | null
    totalSignOns?: number | null
    weather?: string | null
    temperature?: number | null
    hasUploads?: boolean | null
    updatedAt?: string | null
    projectCompletionPercentage?: number | null
  } | null
}

export type SiteDiariesUiQueryVariables = Exact<{
  filter?: InputMaybe<SiteDiaryFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SiteDiarySortInput>
}>

export type SiteDiariesUiQuery = {
  __typename?: 'Query'
  siteDiaries: Array<{
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    templateResponseId: string
    project: { __typename?: 'Project'; id: string; name: string }
    templateResponse: {
      __typename?: 'TemplateResponse'
      tableBlocks?: any | null
      attachments?: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        fileName: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      }> | null
    }
    statistics?: {
      __typename?: 'SiteDiaryStatistics'
      numberOfWorkers?: number | null
      numberOfSubcontractors?: number | null
      projectHours?: number | null
      totalSignOns?: number | null
      weather?: string | null
      temperature?: number | null
      hasUploads?: boolean | null
      updatedAt?: string | null
      projectCompletionPercentage?: number | null
    } | null
  }>
  siteDiariesAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  mostRecentSiteDiary?: {
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    date: string
  } | null
}

export type SiteDiariesCsvUiQueryVariables = Exact<{
  filter?: InputMaybe<SiteDiaryFilterInput>
  sort?: InputMaybe<SiteDiarySortInput>
}>

export type SiteDiariesCsvUiQuery = {
  __typename?: 'Query'
  siteDiaries: Array<{
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    templateResponseId: string
    templateResponse: {
      __typename?: 'TemplateResponse'
      responseData?: any | null
      tableBlocks?: any | null
      attachments?: Array<{
        __typename?: 'Attachment'
        id: string
        url: string
        fileName: string
        thumbnail?: { __typename?: 'Thumbnail'; small?: string | null } | null
      }> | null
    }
    project: { __typename?: 'Project'; id: string; name: string }
    statistics?: {
      __typename?: 'SiteDiaryStatistics'
      numberOfWorkers?: number | null
      numberOfSubcontractors?: number | null
      projectHours?: number | null
      totalSignOns?: number | null
      weather?: string | null
      temperature?: number | null
      hasUploads?: boolean | null
      updatedAt?: string | null
      projectCompletionPercentage?: number | null
    } | null
  }>
}

export type SiteDiariesForSummaryUiQueryVariables = Exact<{
  filter?: InputMaybe<SiteDiaryFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SiteDiarySortInput>
}>

export type SiteDiariesForSummaryUiQuery = {
  __typename?: 'Query'
  siteDiaries: Array<{
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    createdBy?: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
    } | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  }>
  siteDiariesAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  mostRecentSiteDiary?: {
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    date: string
  } | null
}

export type SiteDiaryByDayUiQueryVariables = Exact<{
  date: Scalars['String']
  projectId: Scalars['String']
}>

export type SiteDiaryByDayUiQuery = {
  __typename?: 'Query'
  siteDiaryByDay?: {
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    createdBy?: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
    } | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  } | null
}

export type SiteDiaryUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type SiteDiaryUiQuery = {
  __typename?: 'Query'
  siteDiary?: {
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    createdBy?: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
    } | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  } | null
}

export type SiteDiaryWithLinksUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type SiteDiaryWithLinksUiQuery = {
  __typename?: 'Query'
  siteDiary?: {
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    paginationLinks?: {
      __typename?: 'SiteDiaryPaginationLinks'
      previous?: { __typename?: 'SiteDiary'; id: string; date: string } | null
      next?: { __typename?: 'SiteDiary'; id: string; date: string } | null
    } | null
    createdBy?: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
    } | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  } | null
}

export type SiteDiarySignOnsUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type SiteDiarySignOnsUiQuery = {
  __typename?: 'Query'
  siteDiary?: {
    __typename?: 'SiteDiary'
    id: string
    date: string
    signOns?: Array<{
      __typename?: 'SignOn'
      id: string
      createdAt: string
      signedOffAt?: string | null
      manualSignedOnAt?: string | null
      manualSignedOffAt?: string | null
      worker?: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
        subcontractors: Array<{
          __typename?: 'Subcontractor'
          id: string
          company: { __typename?: 'Company'; name: string }
          projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
        } | null>
      } | null
      visitor?: {
        __typename?: 'Visitor'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      signOnHours?: {
        __typename?: 'SignOnHours'
        hours?: number | null
        updatedAt?: string | null
      } | null
    }> | null
  } | null
}

export type CreateSiteDiaryUiMutationVariables = Exact<{
  input: CreateSiteDiaryInput
}>

export type CreateSiteDiaryUiMutation = {
  __typename?: 'Mutation'
  createSiteDiary: {
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    createdBy?: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
    } | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  }
}

export type UpdateSiteDiaryUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateSiteDiaryInput
}>

export type UpdateSiteDiaryUiMutation = {
  __typename?: 'Mutation'
  updateSiteDiary: {
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    createdBy?: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
    } | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  }
}

export type ArchiveSiteDiaryUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveSiteDiaryUiMutation = {
  __typename?: 'Mutation'
  archiveSiteDiary: {
    __typename?: 'SiteDiary'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    createdBy?: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      email?: string | null
    } | null
    templateResponse: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    }
    project: {
      __typename?: 'Project'
      id: string
      name: string
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  }
}

export type UpsertProcoreDailyLogsUiMutationVariables = Exact<{
  input?: InputMaybe<UpsertProcoreDailyLogsInput>
}>

export type UpsertProcoreDailyLogsUiMutation = {
  __typename?: 'Mutation'
  upsertProcoreDailyLogs?: {
    __typename?: 'ProcoreDailyLogsConfirmation'
    success: boolean
  } | null
}

export type StaffAttributesSubsetFragment = {
  __typename?: 'Worker'
  id: string
  trade?: string | null
  mobile?: string | null
  builderGenerated: boolean
  projects: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  } | null>
  user: {
    __typename?: 'User'
    firstName: string
    lastName: string
    profilePicture?: { __typename?: 'Attachment'; url: string } | null
  }
  subcontractors: Array<{
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    company: { __typename?: 'Company'; name: string }
  } | null>
  tickets?: Array<{
    __typename?: 'Ticket'
    id: string
    ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
  } | null> | null
}

export type StaffListUiQueryVariables = Exact<{
  filter?: InputMaybe<BuilderWorkersFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type StaffListUiQuery = {
  __typename?: 'Query'
  builderWorkers: Array<{
    __typename?: 'Worker'
    id: string
    trade?: string | null
    mobile?: string | null
    builderGenerated: boolean
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      profilePicture?: { __typename?: 'Attachment'; url: string } | null
    }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
    } | null>
    tickets?: Array<{
      __typename?: 'Ticket'
      id: string
      ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
    } | null> | null
  }>
  builderWorkersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type StaffCsvListUiQueryVariables = Exact<{ [key: string]: never }>

export type StaffCsvListUiQuery = {
  __typename?: 'Query'
  builderWorkers: Array<{
    __typename?: 'Worker'
    dob?: string | null
    address?: string | null
    emergencyContact?: string | null
    emergencyContactNumber?: string | null
    emergencyContactRelationship?: string | null
    medicalInformation?: string | null
    allergies?: string | null
    id: string
    trade?: string | null
    mobile?: string | null
    builderGenerated: boolean
    user: {
      __typename?: 'User'
      email?: string | null
      firstName: string
      lastName: string
      profilePicture?: { __typename?: 'Attachment'; url: string } | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
    } | null>
    tickets?: Array<{
      __typename?: 'Ticket'
      id: string
      ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
    } | null> | null
  }>
}

export type SendStaffInviteEmailsUiMutationVariables = Exact<{
  emails: Array<Scalars['String']> | Scalars['String']
  customMessage?: InputMaybe<Scalars['String']>
}>

export type SendStaffInviteEmailsUiMutation = {
  __typename?: 'Mutation'
  sendStaffInviteEmails: {
    __typename?: 'EmailSent'
    serviceResponse?: any | null
  }
}

export type SendTestWelcomeEmailsUiMutationVariables = Exact<{
  emails: Array<Scalars['String']> | Scalars['String']
  projectId: Scalars['String']
  customMessage?: InputMaybe<Scalars['String']>
  metadata?: InputMaybe<Scalars['JSON']>
}>

export type SendTestWelcomeEmailsUiMutation = {
  __typename?: 'Mutation'
  sendTestWelcomeEmails: {
    __typename?: 'EmailSent'
    serviceResponse?: any | null
  }
}

export type SendWelcomeEmailsUiMutationVariables = Exact<{
  subcontractorIds: Array<Scalars['String']> | Scalars['String']
  contactIds: Array<Scalars['String']> | Scalars['String']
  projectId: Scalars['String']
  customMessage?: InputMaybe<Scalars['String']>
  metadata?: InputMaybe<Scalars['JSON']>
}>

export type SendWelcomeEmailsUiMutation = {
  __typename?: 'Mutation'
  sendWelcomeEmails: { __typename?: 'EmailSent'; serviceResponse?: any | null }
}

export type GetWelcomeLinkUiMutationVariables = Exact<{
  subcontractorId: Scalars['String']
  projectId: Scalars['String']
  metadata?: InputMaybe<Scalars['JSON']>
}>

export type GetWelcomeLinkUiMutation = {
  __typename?: 'Mutation'
  getWelcomeLink: { __typename?: 'Link'; uploadUrl: string }
}

export type SubcontractorCommonAttributesFragment = {
  __typename?: 'Subcontractor'
  id: string
  isBuilder?: boolean | null
  statuses?: Array<SubcontractorStatus | null> | null
  addressParts?: {
    __typename?: 'Address'
    suburb?: string | null
    state?: string | null
  } | null
  company: { __typename?: 'Company'; name: string; abn?: string | null }
  contacts?: Array<{
    __typename?: 'Contact'
    id: string
    email?: string | null
    name?: string | null
    number?: string | null
    isPrimaryContact: boolean
    subcontractorId?: string | null
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
  } | null> | null
}

export type SubcontractorsByProjectListUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type SubcontractorsByProjectListUiQuery = {
  __typename?: 'Query'
  subcontractorsByProject: Array<{
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    statuses?: Array<SubcontractorStatus | null> | null
    addressParts?: {
      __typename?: 'Address'
      suburb?: string | null
      state?: string | null
    } | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      email?: string | null
      name?: string | null
      number?: string | null
      isPrimaryContact: boolean
      subcontractorId?: string | null
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      name: string
      slug: string
    } | null> | null
    prequalifications?: Array<{
      __typename?: 'Prequalification'
      id: string
      status: PrequalificationStatus
      createdAt: string
      updatedAt: string
    } | null> | null
    stats?: {
      __typename?: 'SubcontractorStats'
      workersCount?: number | null
      swmsDocsCount?: number | null
      insuranceDocsCount?: number | null
      msdsDocsCount?: number | null
      documentsCount?: number | null
    } | null
  }>
  subcontractorsByProjectAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SubcontractorsByBuilderListUiQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type SubcontractorsByBuilderListUiQuery = {
  __typename?: 'Query'
  subcontractorsByBuilder: Array<{
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    addressParts?: {
      __typename?: 'Address'
      suburb?: string | null
      state?: string | null
    } | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      email?: string | null
      name?: string | null
      number?: string | null
      isPrimaryContact: boolean
      subcontractorId?: string | null
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      name: string
      slug: string
    } | null> | null
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
  }>
  subcontractorsByBuilderAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SubcontractorFilterAggregationUiQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SubcontractorFilterInput>
}>

export type SubcontractorFilterAggregationUiQuery = {
  __typename?: 'Query'
  subcontractorFilterAggregation?: {
    __typename?: 'SubcontractorFilterAggregation'
    allBuilder?: number | null
    allProject?: number | null
    notInvited?: number | null
    invited?: number | null
  } | null
}

export type ProjectSubcontractorsCsvListUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<SubcontractorFilterInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type ProjectSubcontractorsCsvListUiQuery = {
  __typename?: 'Query'
  subcontractorsByProject: Array<{
    __typename?: 'Subcontractor'
    createdAt: string
    id: string
    isBuilder?: boolean | null
    statuses?: Array<SubcontractorStatus | null> | null
    addressParts?: {
      __typename?: 'Address'
      suburb?: string | null
      state?: string | null
    } | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      email?: string | null
      name?: string | null
      number?: string | null
      isPrimaryContact: boolean
      subcontractorId?: string | null
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
  }>
}

export type BuilderSubcontractorsCsvListUiQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type BuilderSubcontractorsCsvListUiQuery = {
  __typename?: 'Query'
  subcontractorsByBuilder: Array<{
    __typename?: 'Subcontractor'
    createdAt: string
    id: string
    isBuilder?: boolean | null
    statuses?: Array<SubcontractorStatus | null> | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
    } | null> | null
    addressParts?: {
      __typename?: 'Address'
      suburb?: string | null
      state?: string | null
    } | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      email?: string | null
      name?: string | null
      number?: string | null
      isPrimaryContact: boolean
      subcontractorId?: string | null
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
  }>
}

export type BuilderSubcontractorUiQueryVariables = Exact<{
  builderId: Scalars['String']
}>

export type BuilderSubcontractorUiQuery = {
  __typename?: 'Query'
  builder?: {
    __typename?: 'Builder'
    builderSubcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string; abn?: string | null }
      stats?: {
        __typename?: 'SubcontractorStats'
        workersCount?: number | null
        swmsDocsCount?: number | null
        insuranceDocsCount?: number | null
        msdsDocsCount?: number | null
        documentsCount?: number | null
      } | null
    } | null
  } | null
}

export type ContactAttributesFragment = {
  __typename?: 'Contact'
  id: string
  name?: string | null
  email?: string | null
  number?: string | null
  isPrimaryContact: boolean
  projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
}

export type SubcontractorAttributesFragment = {
  __typename?: 'Subcontractor'
  id: string
  isBuilder?: boolean | null
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  procoreId?: string | null
  address?: string | null
  company: { __typename?: 'Company'; name: string; abn?: string | null }
  contacts?: Array<{
    __typename?: 'Contact'
    id: string
    name?: string | null
    email?: string | null
    number?: string | null
    isPrimaryContact: boolean
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
  } | null> | null
  workers: Array<{
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null>
  projects?: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  } | null> | null
  prequalifications?: Array<{
    __typename?: 'Prequalification'
    id: string
    status: PrequalificationStatus
    createdAt: string
    updatedAt: string
    reviewComments?: string | null
  } | null> | null
  integrationConnections: Array<{
    __typename?: 'IntegrationConnection'
    id: string
    integrationIdentifier: string
    sourceId: string
    integration: {
      __typename?: 'Integration'
      integrationType: IntegrationType
    }
  } | null>
}

export type SubcontractorMinimumAttributesFragment = {
  __typename?: 'Subcontractor'
  id: string
  createdAt: string
  isBuilder?: boolean | null
  company: {
    __typename?: 'Company'
    id?: string | null
    name: string
    abn?: string | null
  }
}

export type SubcontractorFilesFragment = {
  __typename?: 'Subcontractor'
  swmsDocs?: Array<{
    __typename?: 'SwmsDoc'
    id: string
    name: string
    createdAt: string
    archivedAt?: string | null
    status: SwmsStatus
    project: { __typename?: 'Project'; id: string; name: string }
  } | null> | null
  insuranceDocs?: Array<{
    __typename?: 'InsuranceDoc'
    id: string
    name: string
    createdAt: string
    status: InsuranceStatus
    expiry?: string | null
  } | null> | null
  msdsDocs?: Array<{
    __typename?: 'MsdsDoc'
    id: string
    name: string
    createdAt: string
    status: MsdsStatus
  } | null> | null
  documents?: Array<{
    __typename?: 'Document'
    id: string
    name: string
    createdAt: string
    status: DocumentStatus
    type?: string | null
    project?: { __typename?: 'Project'; id: string; name: string } | null
  } | null> | null
}

export type SubcontractorUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type SubcontractorUiQuery = {
  __typename?: 'Query'
  subcontractor?: {
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    procoreId?: string | null
    address?: string | null
    tags?: Array<{
      __typename?: 'ResourceTag'
      id: string
      slug: string
      name: string
    } | null> | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    prequalifications?: Array<{
      __typename?: 'Prequalification'
      id: string
      status: PrequalificationStatus
      createdAt: string
      updatedAt: string
      reviewComments?: string | null
    } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  } | null
}

export type SubcontractorWithFilesUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type SubcontractorWithFilesUiQuery = {
  __typename?: 'Query'
  subcontractor?: {
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    procoreId?: string | null
    address?: string | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    prequalifications?: Array<{
      __typename?: 'Prequalification'
      id: string
      status: PrequalificationStatus
      createdAt: string
      updatedAt: string
      reviewComments?: string | null
    } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
    swmsDocs?: Array<{
      __typename?: 'SwmsDoc'
      id: string
      name: string
      createdAt: string
      archivedAt?: string | null
      status: SwmsStatus
      project: { __typename?: 'Project'; id: string; name: string }
    } | null> | null
    insuranceDocs?: Array<{
      __typename?: 'InsuranceDoc'
      id: string
      name: string
      createdAt: string
      status: InsuranceStatus
      expiry?: string | null
    } | null> | null
    msdsDocs?: Array<{
      __typename?: 'MsdsDoc'
      id: string
      name: string
      createdAt: string
      status: MsdsStatus
    } | null> | null
    documents?: Array<{
      __typename?: 'Document'
      id: string
      name: string
      createdAt: string
      status: DocumentStatus
      type?: string | null
      project?: { __typename?: 'Project'; id: string; name: string } | null
    } | null> | null
  } | null
}

export type SubcontractorFilesListUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type SubcontractorFilesListUiQuery = {
  __typename?: 'Query'
  subcontractor?: {
    __typename?: 'Subcontractor'
    swmsDocs?: Array<{
      __typename?: 'SwmsDoc'
      id: string
      name: string
      createdAt: string
      archivedAt?: string | null
      status: SwmsStatus
      project: { __typename?: 'Project'; id: string; name: string }
    } | null> | null
    insuranceDocs?: Array<{
      __typename?: 'InsuranceDoc'
      id: string
      name: string
      createdAt: string
      status: InsuranceStatus
      expiry?: string | null
    } | null> | null
    msdsDocs?: Array<{
      __typename?: 'MsdsDoc'
      id: string
      name: string
      createdAt: string
      status: MsdsStatus
    } | null> | null
    documents?: Array<{
      __typename?: 'Document'
      id: string
      name: string
      createdAt: string
      status: DocumentStatus
      type?: string | null
      project?: { __typename?: 'Project'; id: string; name: string } | null
    } | null> | null
  } | null
}

export type SubcontractorsByProjectUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type SubcontractorsByProjectUiQuery = {
  __typename?: 'Query'
  subcontractorsByProject: Array<{
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    procoreId?: string | null
    address?: string | null
    lastFileUploadEmail?: {
      __typename?: 'EmailLog'
      id: string
      createdAt: string
    } | null
    lastInductionEmail?: {
      __typename?: 'EmailLog'
      id: string
      createdAt: string
    } | null
    lastWelcomeEmail?: {
      __typename?: 'EmailLog'
      id: string
      createdAt: string
    } | null
    lastFileUploadInvite?: {
      __typename?: 'FileUploadInvite'
      id: string
      createdAt: string
    } | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    prequalifications?: Array<{
      __typename?: 'Prequalification'
      id: string
      status: PrequalificationStatus
      createdAt: string
      updatedAt: string
      reviewComments?: string | null
    } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }>
  subcontractorsByProjectAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SubcontractorsByBuilderFilterListUiQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type SubcontractorsByBuilderFilterListUiQuery = {
  __typename?: 'Query'
  subcontractorsByBuilder: Array<{
    __typename?: 'Subcontractor'
    id: string
    createdAt: string
    isBuilder?: boolean | null
    company: {
      __typename?: 'Company'
      id?: string | null
      name: string
      abn?: string | null
    }
  }>
}

export type SubcontractorsByBuilderSearchUiQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type SubcontractorsByBuilderSearchUiQuery = {
  __typename?: 'Query'
  subcontractorsByBuilder: Array<{
    __typename?: 'Subcontractor'
    id: string
    createdAt: string
    isBuilder?: boolean | null
    addressParts?: { __typename?: 'Address'; state?: string | null } | null
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    company: {
      __typename?: 'Company'
      id?: string | null
      name: string
      abn?: string | null
    }
  }>
}

export type SubcontractorsByProjectFilterListUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type SubcontractorsByProjectFilterListUiQuery = {
  __typename?: 'Query'
  subcontractorsByProject: Array<{
    __typename?: 'Subcontractor'
    id: string
    createdAt: string
    isBuilder?: boolean | null
    company: {
      __typename?: 'Company'
      id?: string | null
      name: string
      abn?: string | null
    }
  }>
}

export type ProjectSubbieAssigneesUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type ProjectSubbieAssigneesUiQuery = {
  __typename?: 'Query'
  subcontractorsByProject: Array<{
    __typename?: 'Subcontractor'
    id: string
    createdAt: string
    isBuilder?: boolean | null
    company: {
      __typename?: 'Company'
      id?: string | null
      name: string
      abn?: string | null
    }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      email?: string | null
      name?: string | null
      number?: string | null
      isPrimaryContact: boolean
      subcontractorId?: string | null
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
  }>
  subcontractorsByProjectAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type ProjectSubbiesForSearchUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type ProjectSubbiesForSearchUiQuery = {
  __typename?: 'Query'
  subcontractorsByProject: Array<{
    __typename?: 'Subcontractor'
    id: string
    createdAt: string
    isBuilder?: boolean | null
    company: {
      __typename?: 'Company'
      id?: string | null
      name: string
      abn?: string | null
    }
  }>
  subcontractorsByProjectAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SubcontractorAttributesForIntegrationFragment = {
  __typename?: 'Subcontractor'
  id: string
  isBuilder?: boolean | null
  createdAt: string
  updatedAt: string
  company: { __typename?: 'Company'; name: string; abn?: string | null }
  integrationConnections: Array<{
    __typename?: 'IntegrationConnection'
    id: string
    integrationIdentifier: string
    sourceId: string
    integration: {
      __typename?: 'Integration'
      integrationType: IntegrationType
    }
  } | null>
}

export type AgaveBuilderSubbiesUiQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type AgaveBuilderSubbiesUiQuery = {
  __typename?: 'Query'
  subcontractorsByBuilder: Array<{
    __typename?: 'Subcontractor'
    procoreId?: string | null
    id: string
    isBuilder?: boolean | null
    createdAt: string
    updatedAt: string
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }>
  subcontractorsByBuilderAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type BuildxactBuilderSubbiesUiQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type BuildxactBuilderSubbiesUiQuery = {
  __typename?: 'Query'
  subcontractorsByBuilder: Array<{
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    createdAt: string
    updatedAt: string
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }>
  subcontractorsByBuilderAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type BuilderSubbieAssigneesUiQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type BuilderSubbieAssigneesUiQuery = {
  __typename?: 'Query'
  subcontractorsByBuilder: Array<{
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
  }>
  subcontractorsByBuilderAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type BuilderSubbiesForSearchUiQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type BuilderSubbiesForSearchUiQuery = {
  __typename?: 'Query'
  subcontractorsByBuilder: Array<{
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    procoreId?: string | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
  }>
  subcontractorsByBuilderAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type CreateSubcontractorUiMutationVariables = Exact<{
  companyName: Scalars['String']
  companyEmail: Scalars['String']
  companyNumber?: InputMaybe<Scalars['String']>
  companyAbn?: InputMaybe<Scalars['String']>
  companyContactName?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
  builderId: Scalars['String']
  address?: InputMaybe<Scalars['String']>
}>

export type CreateSubcontractorUiMutation = {
  __typename?: 'Mutation'
  createSubcontractor: {
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    procoreId?: string | null
    address?: string | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    prequalifications?: Array<{
      __typename?: 'Prequalification'
      id: string
      status: PrequalificationStatus
      createdAt: string
      updatedAt: string
      reviewComments?: string | null
    } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }
}

export type CreateSubcontractorsUiMutationVariables = Exact<{
  input?: InputMaybe<Array<CreateSubcontractorInput> | CreateSubcontractorInput>
}>

export type CreateSubcontractorsUiMutation = {
  __typename?: 'Mutation'
  createSubcontractors: { __typename?: 'Count'; count: string }
}

export type UpdateSubcontractorUiMutationVariables = Exact<{
  id: Scalars['String']
  companyName: Scalars['String']
  companyEmail: Scalars['String']
  companyNumber?: InputMaybe<Scalars['String']>
  companyAbn?: InputMaybe<Scalars['String']>
  companyContactName?: InputMaybe<Scalars['String']>
  projectIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
  builderId?: InputMaybe<Scalars['String']>
  address?: InputMaybe<Scalars['String']>
}>

export type UpdateSubcontractorUiMutation = {
  __typename?: 'Mutation'
  updateSubcontractor: {
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    procoreId?: string | null
    address?: string | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    prequalifications?: Array<{
      __typename?: 'Prequalification'
      id: string
      status: PrequalificationStatus
      createdAt: string
      updatedAt: string
      reviewComments?: string | null
    } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }
}

export type UpdateSubcontractorDetailsUiMutationVariables = Exact<{
  id: Scalars['String']
  companyName: Scalars['String']
  companyEmail: Scalars['String']
  companyNumber?: InputMaybe<Scalars['String']>
  companyAbn?: InputMaybe<Scalars['String']>
  companyContactName?: InputMaybe<Scalars['String']>
  address?: InputMaybe<Scalars['String']>
}>

export type UpdateSubcontractorDetailsUiMutation = {
  __typename?: 'Mutation'
  updateSubcontractorDetails: {
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    procoreId?: string | null
    address?: string | null
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    prequalifications?: Array<{
      __typename?: 'Prequalification'
      id: string
      status: PrequalificationStatus
      createdAt: string
      updatedAt: string
      reviewComments?: string | null
    } | null> | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      sourceId: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }
}

export type AssignSubcontractorsToProjectUiMutationVariables = Exact<{
  id: Scalars['String']
  subcontractorIds: Array<Scalars['String']> | Scalars['String']
}>

export type AssignSubcontractorsToProjectUiMutation = {
  __typename?: 'Mutation'
  assignSubcontractorsToProject: { __typename?: 'Project'; id: string }
}

export type UnassignSubcontractorsFromProjectUiMutationVariables = Exact<{
  id: Scalars['String']
  subcontractorIds: Array<Scalars['String']> | Scalars['String']
}>

export type UnassignSubcontractorsFromProjectUiMutation = {
  __typename?: 'Mutation'
  unassignSubcontractorsFromProject: { __typename?: 'Project'; id: string }
}

export type ArchiveSubcontractorUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveSubcontractorUiMutation = {
  __typename?: 'Mutation'
  archiveSubcontractor: { __typename?: 'Subcontractor'; id: string }
}

export type GetSubcontractorArchiveInfoUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type GetSubcontractorArchiveInfoUiQuery = {
  __typename?: 'Query'
  getSubcontractorArchiveInfo?: {
    __typename?: 'SubcontractorArchiveInfo'
    workersCount?: number | null
    swmsDocsCount?: number | null
    insuranceDocsCount?: number | null
    sdsDocsCount?: number | null
    documentsCount?: number | null
    prequalificationsCount?: number | null
    timesheetsCount?: number | null
    integrationConnectionsCount?: number | null
  } | null
}

export type GetBulkSubcontractorArchiveInfoUiQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SubcontractorSortInput>
}>

export type GetBulkSubcontractorArchiveInfoUiQuery = {
  __typename?: 'Query'
  subcontractorsByBuilder: Array<{
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    stats?: {
      __typename?: 'SubcontractorStats'
      workersCount?: number | null
      swmsDocsCount?: number | null
      insuranceDocsCount?: number | null
      msdsDocsCount?: number | null
      documentsCount?: number | null
      prequalificationsCount?: number | null
      timesheetsCount?: number | null
      integrationConnectionsCount?: number | null
    } | null
  }>
}

export type BulkArchiveSubcontractorsUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkArchiveSubcontractorsUiMutation = {
  __typename?: 'Mutation'
  bulkArchiveSubcontractors: number
}

export type ConnectProcoreSubcontractorUiMutationVariables = Exact<{
  id: Scalars['String']
  input?: InputMaybe<ProcoreSubcontractorInput>
}>

export type ConnectProcoreSubcontractorUiMutation = {
  __typename?: 'Mutation'
  connectProcoreSubcontractor: {
    __typename?: 'Subcontractor'
    id: string
    procoreId?: string | null
  }
}

export type ConnectProcoreSubcontractorsUiMutationVariables = Exact<{
  input:
    | Array<ProcoreSubcontractorConnectInput>
    | ProcoreSubcontractorConnectInput
}>

export type ConnectProcoreSubcontractorsUiMutation = {
  __typename?: 'Mutation'
  connectProcoreSubcontractors: Array<{
    __typename?: 'Subcontractor'
    id: string
    procoreId?: string | null
  }>
}

export type DisconnectProcoreSubcontractorUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DisconnectProcoreSubcontractorUiMutation = {
  __typename?: 'Mutation'
  disconnectProcoreSubcontractor: {
    __typename?: 'Subcontractor'
    id: string
    procoreId?: string | null
  }
}

export type ContactUiQueryVariables = Exact<{
  contactId: Scalars['String']
}>

export type ContactUiQuery = {
  __typename?: 'Query'
  contact: {
    __typename?: 'Contact'
    id: string
    name?: string | null
    email?: string | null
    number?: string | null
    isPrimaryContact: boolean
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
  }
}

export type CreateContactForSubcontractorUiMutationVariables = Exact<{
  subcontractorId: Scalars['String']
  input: ContactInput
}>

export type CreateContactForSubcontractorUiMutation = {
  __typename?: 'Mutation'
  createContact: {
    __typename?: 'Contact'
    id: string
    name?: string | null
    email?: string | null
    number?: string | null
    isPrimaryContact: boolean
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
  }
}

export type UpdateContactUiMutationVariables = Exact<{
  contactId: Scalars['String']
  input: ContactInput
}>

export type UpdateContactUiMutation = {
  __typename?: 'Mutation'
  updateContact: {
    __typename?: 'Contact'
    id: string
    name?: string | null
    email?: string | null
    number?: string | null
    isPrimaryContact: boolean
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
  }
}

export type DeleteContactUiMutationVariables = Exact<{
  contactId: Scalars['String']
}>

export type DeleteContactUiMutation = {
  __typename?: 'Mutation'
  deleteContact: {
    __typename?: 'Contact'
    id: string
    name?: string | null
    email?: string | null
    number?: string | null
    isPrimaryContact: boolean
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
  }
}

export type TogglePrimaryContactUiMutationVariables = Exact<{
  contactId: Scalars['String']
}>

export type TogglePrimaryContactUiMutation = {
  __typename?: 'Mutation'
  togglePrimaryContact: {
    __typename?: 'Contact'
    id: string
    name?: string | null
    email?: string | null
    number?: string | null
    isPrimaryContact: boolean
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
  }
}

export type AssignContactToProjectUiMutationVariables = Exact<{
  contactId: Scalars['String']
  projectId: Scalars['String']
}>

export type AssignContactToProjectUiMutation = {
  __typename?: 'Mutation'
  assignContactToProject: {
    __typename?: 'Contact'
    id: string
    name?: string | null
    email?: string | null
    number?: string | null
    isPrimaryContact: boolean
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
  }
}

export type RemoveContactFromProjectUiMutationVariables = Exact<{
  contactId: Scalars['String']
  projectId: Scalars['String']
}>

export type RemoveContactFromProjectUiMutation = {
  __typename?: 'Mutation'
  removeContactFromProject: {
    __typename?: 'Contact'
    id: string
    name?: string | null
    email?: string | null
    number?: string | null
    isPrimaryContact: boolean
    projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
  }
}

export type SubbieInfoUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type SubbieInfoUiQuery = {
  __typename?: 'Query'
  subcontractor?: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string; abn?: string | null }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
      projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
    } | null> | null
  } | null
}

export type ContactInfoUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type ContactInfoUiQuery = {
  __typename?: 'Query'
  contact: {
    __typename?: 'Contact'
    id: string
    name?: string | null
    email?: string | null
    number?: string | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
  }
}

export type SaMergeSubcontractorsUiMutationVariables = Exact<{
  keepId: Scalars['String']
  archiveId: Scalars['String']
}>

export type SaMergeSubcontractorsUiMutation = {
  __typename?: 'Mutation'
  saMergeSubcontractors: { __typename?: 'Subcontractor'; id: string }
}

export type PublicSubcontractorsUiQueryVariables = Exact<{
  builderId: Scalars['String']
  filter?: InputMaybe<SubcontractorFilterInputPublic>
  pagination?: InputMaybe<PaginationInput>
}>

export type PublicSubcontractorsUiQuery = {
  __typename?: 'Query'
  subcontractors_public?: Array<{
    __typename?: 'Subcontractor_Public'
    id: string
    isBuilder?: boolean | null
    company: {
      __typename?: 'SubcontractorCompany_Public'
      name: string
      abn?: string | null
    }
  }> | null
}

export type GetWorkersSignaturesUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type GetWorkersSignaturesUiQuery = {
  __typename?: 'Query'
  workerSignatures: {
    __typename?: 'WorkerSignatures'
    signatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      signatureUrl: string
      signatureKey: string
    } | null>
    inductions: Array<
      | {
          __typename?: 'BuilderInduction'
          id: string
          signatureUrl?: string | null
          builder: {
            __typename?: 'Builder'
            id: string
            company: { __typename?: 'Company'; name: string }
          }
        }
      | {
          __typename?: 'ProjectInduction'
          id: string
          signatureUrl?: string | null
          project: {
            __typename?: 'Project'
            id: string
            name: string
            builder?: {
              __typename?: 'Builder'
              id: string
              company: { __typename?: 'Company'; name: string }
            } | null
          }
        }
      | null
    >
  }
}

export type GlobalSettingsUiQueryVariables = Exact<{ [key: string]: never }>

export type GlobalSettingsUiQuery = {
  __typename?: 'Query'
  globalSettings: {
    __typename?: 'GlobalSettings'
    externalLinks?: Array<{
      __typename?: 'ExternalLinkConfig'
      cuid: string
      type: string
      url: string
      homeUrl?: string | null
    }> | null
  }
}

export type UpdateGlobalSettingsUiMutationVariables = Exact<{
  input: UpdateGlobalSettingsInput
}>

export type UpdateGlobalSettingsUiMutation = {
  __typename?: 'Mutation'
  updateGlobalSettings: {
    __typename?: 'GlobalSettings'
    externalLinks?: Array<{
      __typename?: 'ExternalLinkConfig'
      cuid: string
      type: string
      url: string
      homeUrl?: string | null
    }> | null
  }
}

export type UpdateBuilderSettingsUiMutationVariables = Exact<{
  builderId: Scalars['String']
  input: UpdateBuilderSettingsInput
}>

export type UpdateBuilderSettingsUiMutation = {
  __typename?: 'Mutation'
  updateBuilderSettings: {
    __typename?: 'BuilderSettings'
    externalLinks?: Array<{
      __typename?: 'BuilderExternalLink'
      externalLinkCuid: string
      type: string
      homeUrl: string
      linkUrl: string
      id: string
    }> | null
  }
}

export type SwmsTemplateResponseAttributesFragment = {
  __typename?: 'SwmsTemplateResponse'
  id: string
  createdAt: string
  updatedAt: string
  responseData?: any | null
  isOwnTemplate: boolean
  project?: {
    __typename?: 'PublicProject'
    id: string
    name: string
    timezone?: string | null
    country?: string | null
    locale?: SupportedLocaleCountryCode | null
    builder?: {
      __typename?: 'BuilderEntity'
      logoUrl?: string | null
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
      company?: { __typename?: 'Company'; name: string } | null
    } | null
    projectContacts?: Array<{
      __typename?: 'ContactEntity'
      id: string
      name?: string | null
      email?: string | null
      type: ContactType
      number?: string | null
    } | null> | null
  } | null
  template?:
    | { __typename?: 'SwmsLibraryTemplate'; id: string; templateName: string }
    | { __typename?: 'SwmsTemplate'; id: string; templateName: string }
    | null
}

export type SwmsTemplateAttributesFragment = {
  __typename?: 'SwmsTemplate'
  id: string
  createdAt: string
  updatedAt: string
  templateType: TemplateType
  templateName: string
  templateData?: any | null
}

export type GetSwmsTemplateResponseUiQueryVariables = Exact<{
  id: Scalars['String']
  subcontractorId: Scalars['String']
}>

export type GetSwmsTemplateResponseUiQuery = {
  __typename?: 'Query'
  swmsTemplateResponse: {
    __typename?: 'SwmsTemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    responseData?: any | null
    isOwnTemplate: boolean
    project?: {
      __typename?: 'PublicProject'
      id: string
      name: string
      timezone?: string | null
      country?: string | null
      locale?: SupportedLocaleCountryCode | null
      builder?: {
        __typename?: 'BuilderEntity'
        logoUrl?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultTimezone?: string | null
        company?: { __typename?: 'Company'; name: string } | null
      } | null
      projectContacts?: Array<{
        __typename?: 'ContactEntity'
        id: string
        name?: string | null
        email?: string | null
        type: ContactType
        number?: string | null
      } | null> | null
    } | null
    template?:
      | { __typename?: 'SwmsLibraryTemplate'; id: string; templateName: string }
      | { __typename?: 'SwmsTemplate'; id: string; templateName: string }
      | null
  }
}

export type GetSwmsInProgressUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type GetSwmsInProgressUiQuery = {
  __typename?: 'Query'
  swmsInProgress: Array<{
    __typename?: 'SwmsTemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    responseData?: any | null
    isOwnTemplate: boolean
    project?: {
      __typename?: 'PublicProject'
      id: string
      name: string
      timezone?: string | null
      country?: string | null
      locale?: SupportedLocaleCountryCode | null
      builder?: {
        __typename?: 'BuilderEntity'
        logoUrl?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultTimezone?: string | null
        company?: { __typename?: 'Company'; name: string } | null
      } | null
      projectContacts?: Array<{
        __typename?: 'ContactEntity'
        id: string
        name?: string | null
        email?: string | null
        type: ContactType
        number?: string | null
      } | null> | null
    } | null
    template?:
      | { __typename?: 'SwmsLibraryTemplate'; id: string; templateName: string }
      | { __typename?: 'SwmsTemplate'; id: string; templateName: string }
      | null
  }>
}

export type GetSwmsTemplatesUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type GetSwmsTemplatesUiQuery = {
  __typename?: 'Query'
  swmsTemplates: Array<{
    __typename?: 'SwmsTemplate'
    id: string
    createdAt: string
    templateName: string
    templateData?: any | null
  }>
}

export type GetBuildPassSwmsTemplatesUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type GetBuildPassSwmsTemplatesUiQuery = {
  __typename?: 'Query'
  buildPassSwmsTemplates: Array<{
    __typename?: 'SwmsLibraryTemplate'
    id: string
    createdAt: string
    templateName: string
    templateData?: any | null
  }>
}

export type CreateSwmsTemplateResponseUiMutationVariables = Exact<{
  input: CreateSwmsTemplateResponseInput
}>

export type CreateSwmsTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  createSwmsTemplateResponse: {
    __typename?: 'SwmsTemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    responseData?: any | null
    isOwnTemplate: boolean
    project?: {
      __typename?: 'PublicProject'
      id: string
      name: string
      timezone?: string | null
      country?: string | null
      locale?: SupportedLocaleCountryCode | null
      builder?: {
        __typename?: 'BuilderEntity'
        logoUrl?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultTimezone?: string | null
        company?: { __typename?: 'Company'; name: string } | null
      } | null
      projectContacts?: Array<{
        __typename?: 'ContactEntity'
        id: string
        name?: string | null
        email?: string | null
        type: ContactType
        number?: string | null
      } | null> | null
    } | null
    template?:
      | { __typename?: 'SwmsLibraryTemplate'; id: string; templateName: string }
      | { __typename?: 'SwmsTemplate'; id: string; templateName: string }
      | null
  }
}

export type UpdateSwmsTemplateResponseUiMutationVariables = Exact<{
  input: UpdateSwmsTemplateResponseInput
}>

export type UpdateSwmsTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  updateSwmsTemplateResponse: {
    __typename?: 'SwmsTemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    responseData?: any | null
    isOwnTemplate: boolean
    project?: {
      __typename?: 'PublicProject'
      id: string
      name: string
      timezone?: string | null
      country?: string | null
      locale?: SupportedLocaleCountryCode | null
      builder?: {
        __typename?: 'BuilderEntity'
        logoUrl?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultTimezone?: string | null
        company?: { __typename?: 'Company'; name: string } | null
      } | null
      projectContacts?: Array<{
        __typename?: 'ContactEntity'
        id: string
        name?: string | null
        email?: string | null
        type: ContactType
        number?: string | null
      } | null> | null
    } | null
    template?:
      | { __typename?: 'SwmsLibraryTemplate'; id: string; templateName: string }
      | { __typename?: 'SwmsTemplate'; id: string; templateName: string }
      | null
  }
}

export type ArchiveSwmsTemplateResponseUiMutationVariables = Exact<{
  input: ArchiveSwmsTemplateResponseInput
}>

export type ArchiveSwmsTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  archiveSwmsTemplateResponse: {
    __typename?: 'SwmsTemplateResponse'
    id: string
  }
}

export type CreateSwmsTemplateUiMutationVariables = Exact<{
  input: CreateSwmsTemplateInput
}>

export type CreateSwmsTemplateUiMutation = {
  __typename?: 'Mutation'
  createSwmsTemplate: {
    __typename?: 'SwmsTemplate'
    id: string
    createdAt: string
    updatedAt: string
    templateType: TemplateType
    templateName: string
    templateData?: any | null
  }
}

export type UpdateSwmsTemplateUiMutationVariables = Exact<{
  input: UpdateSwmsTemplateInput
}>

export type UpdateSwmsTemplateUiMutation = {
  __typename?: 'Mutation'
  updateSwmsTemplate: {
    __typename?: 'SwmsTemplate'
    id: string
    createdAt: string
    updatedAt: string
    templateType: TemplateType
    templateName: string
    templateData?: any | null
  }
}

export type ArchiveSwmsTemplateUiMutationVariables = Exact<{
  input: ArchiveSwmsTemplateInput
}>

export type ArchiveSwmsTemplateUiMutation = {
  __typename?: 'Mutation'
  archiveSwmsTemplate: { __typename?: 'SwmsTemplate'; id: string }
}

export type SubmitSwmsTemplateResponseUiMutationVariables = Exact<{
  input: SubmitSwmsTemplateResponseInput
}>

export type SubmitSwmsTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  submitSwmsTemplateResponse: { __typename?: 'SwmsDocEntity'; id: string }
}

export type CompleteSwmsTemplateResponseUiMutationVariables = Exact<{
  input: CompleteSwmsTemplateResponseInput
}>

export type CompleteSwmsTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  completeSwmsTemplateResponse: {
    __typename?: 'PDFResponse'
    viewUrl?: string | null
  }
}

export type GetSwmsBuilderSubcontractorUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type GetSwmsBuilderSubcontractorUiQuery = {
  __typename?: 'Query'
  publicSubcontractor?: {
    __typename?: 'SubcontractorEntity'
    id: string
    company: { __typename?: 'CompanyEntity'; name: string; abn?: string | null }
    builder?: {
      __typename?: 'BuilderEntityPublic'
      id: string
      logoUrl?: string | null
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
      company?: { __typename?: 'Company'; name: string } | null
    } | null
  } | null
  swmsInProgress: Array<{
    __typename?: 'SwmsTemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    responseData?: any | null
    isOwnTemplate: boolean
    project?: {
      __typename?: 'PublicProject'
      id: string
      name: string
      timezone?: string | null
      country?: string | null
      locale?: SupportedLocaleCountryCode | null
      builder?: {
        __typename?: 'BuilderEntity'
        logoUrl?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultTimezone?: string | null
        company?: { __typename?: 'Company'; name: string } | null
      } | null
      projectContacts?: Array<{
        __typename?: 'ContactEntity'
        id: string
        name?: string | null
        email?: string | null
        type: ContactType
        number?: string | null
      } | null> | null
    } | null
    template?:
      | { __typename?: 'SwmsLibraryTemplate'; id: string; templateName: string }
      | { __typename?: 'SwmsTemplate'; id: string; templateName: string }
      | null
  }>
  swmsTemplates: Array<{
    __typename?: 'SwmsTemplate'
    id: string
    createdAt: string
    templateName: string
    templateData?: any | null
  }>
  buildPassSwmsTemplates: Array<{
    __typename?: 'SwmsLibraryTemplate'
    id: string
    createdAt: string
    templateName: string
    templateData?: any | null
  }>
}

export type GetPublicSubcontractorUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type GetPublicSubcontractorUiQuery = {
  __typename?: 'Query'
  publicSubcontractor?: {
    __typename?: 'SubcontractorEntity'
    id: string
    company: { __typename?: 'CompanyEntity'; name: string; abn?: string | null }
    registers?: Array<{
      __typename?: 'Register_Public'
      id: string
      name: string
      typeLibraryTemplate?: {
        __typename?: 'LibraryTemplate'
        id: string
        templateName: string
      } | null
    }> | null
    builder?: {
      __typename?: 'BuilderEntityPublic'
      id: string
      logoUrl?: string | null
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
      company?: { __typename?: 'Company'; name: string } | null
    } | null
  } | null
}

export type GetSubcontractorSwmsSettingsUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
  projectId?: InputMaybe<Scalars['String']>
}>

export type GetSubcontractorSwmsSettingsUiQuery = {
  __typename?: 'Query'
  subcontractorSwmsSettings: {
    __typename?: 'SubcontractorSWMSSettings'
    showBuildPassSWMSTemplatesOption: boolean
    showStartFromScratchSWMSOption: boolean
    allowSavingNewSWMSTemplates: boolean
    allowOverridingExistingSWMSTemplates: boolean
    sharedSWMSTemplates?: Array<{
      __typename?: 'SwmsTemplate'
      id: string
      createdAt: string
      templateName: string
      templateData?: any | null
    }> | null
  }
}

export type GetSubcontractorSwmsDefaultResponsibleUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
}>

export type GetSubcontractorSwmsDefaultResponsibleUiQuery = {
  __typename?: 'Query'
  subcontractorSwmsSettings: {
    __typename?: 'SubcontractorSWMSSettings'
    defaultSWMSHazardResponsible?: Array<string> | null
  }
}

export type SwmsAttributesFragment = {
  __typename?: 'SwmsDoc'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  name: string
  status: SwmsStatus
  url?: string | null
  review?: string | null
  checklist?: any | null
  required?: boolean | null
  requiredAll?: boolean | null
  showAll?: boolean | null
  expireInDays?: number | null
  signCount: number
  subcontractor: {
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    company: { __typename?: 'Company'; name: string }
    contacts?: Array<{
      __typename?: 'Contact'
      id: string
      name?: string | null
      email?: string | null
      number?: string | null
      isPrimaryContact: boolean
    } | null> | null
  }
  workers: Array<{
    __typename?: 'Worker'
    id: string
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
    }
  }>
  project: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    config?: any | null
    timezone?: string | null
    swmsChecklistTemplate?: {
      __typename?: 'Template'
      id: string
      templateData?: any | null
    } | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }
  documentSignatures: Array<{
    __typename?: 'DocumentSignature'
    id: string
    createdAt: string
    signatureUrl: string
    builderGenerated: boolean
    worker: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
    }
    adminUser?: {
      __typename?: 'AdminUserEntity'
      id: string
      user?: {
        __typename?: 'UserEntity'
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
    induction?:
      | {
          __typename?: 'BuilderInduction'
          id: string
          type: InductionType
          templateName?: string | null
        }
      | {
          __typename?: 'ProjectInduction'
          id: string
          type: InductionType
          templateName?: string | null
        }
      | null
    swmsDoc: {
      __typename?: 'SwmsDoc'
      id: string
      name: string
      subcontractorId: string
      projectId: string
      showAll?: boolean | null
      project: { __typename?: 'Project'; id: string; name: string }
    }
  } | null>
  currentVersion: { __typename?: 'VersionHistory'; version: number }
  templateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
  } | null
  checklistTemplateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
    completedAt?: string | null
    createdAt: string
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateData?: any | null
        }
      | { __typename?: 'Template'; id: string; templateData?: any | null }
      | null
  } | null
  versionHistory?: Array<{
    __typename?: 'VersionHistory'
    version: number
    swmsDoc?: {
      __typename?: 'SwmsDoc'
      id: string
      name: string
      status: SwmsStatus
      createdAt: string
      archivedAt?: string | null
    } | null
  }> | null
}

export type SwmsAttributesSubsetFragment = {
  __typename?: 'SwmsDoc'
  id: string
  createdAt: string
  archivedAt?: string | null
  name: string
  status: SwmsStatus
  expireInDays?: number | null
  signCount: number
  project: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  }
  subcontractor: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
  }
  workers: Array<{
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
  }>
}

export type SwmsEntityAttributesFragment = {
  __typename?: 'SwmsDocEntity'
  id: string
  url?: string | null
  name: string
}

export type CreateSwmsDocUiMutationVariables = Exact<{
  input: CreateSwmsDocInput
}>

export type CreateSwmsDocUiMutation = {
  __typename?: 'Mutation'
  createSwmsDoc: {
    __typename?: 'SwmsDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    status: SwmsStatus
    url?: string | null
    review?: string | null
    checklist?: any | null
    required?: boolean | null
    requiredAll?: boolean | null
    showAll?: boolean | null
    expireInDays?: number | null
    signCount: number
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    }>
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      config?: any | null
      timezone?: string | null
      swmsChecklistTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      createdAt: string
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      swmsDoc?: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        status: SwmsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type SwmsDocsUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<SwmsFilterInput>
}>

export type SwmsDocsUiQuery = {
  __typename?: 'Query'
  swmsDocs: Array<{
    __typename?: 'SwmsDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    status: SwmsStatus
    url?: string | null
    review?: string | null
    checklist?: any | null
    required?: boolean | null
    requiredAll?: boolean | null
    showAll?: boolean | null
    expireInDays?: number | null
    signCount: number
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    }>
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      config?: any | null
      timezone?: string | null
      swmsChecklistTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      createdAt: string
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      swmsDoc?: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        status: SwmsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }>
}

export type SwmsDocsListUiQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SwmsFilterInput>
  sort?: InputMaybe<SwmsSortInput>
  pagination?: InputMaybe<PaginationInput>
}>

export type SwmsDocsListUiQuery = {
  __typename?: 'Query'
  swmsDocs: Array<{
    __typename?: 'SwmsDoc'
    id: string
    createdAt: string
    archivedAt?: string | null
    name: string
    status: SwmsStatus
    expireInDays?: number | null
    signCount: number
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
    }> | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    }
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }>
  }>
  swmsDocsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type SwmsDocUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type SwmsDocUiQuery = {
  __typename?: 'Query'
  swmsDoc?: {
    __typename?: 'SwmsDoc'
    key?: string | null
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    status: SwmsStatus
    url?: string | null
    review?: string | null
    checklist?: any | null
    required?: boolean | null
    requiredAll?: boolean | null
    showAll?: boolean | null
    expireInDays?: number | null
    signCount: number
    librarySwmsDoc?: {
      __typename?: 'LibrarySwmsDoc_Admin'
      id: string
      name: string
      status: SwmsStatus
      archivedAt?: string | null
    } | null
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    }>
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      config?: any | null
      timezone?: string | null
      swmsChecklistTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      createdAt: string
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      swmsDoc?: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        status: SwmsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  } | null
}

export type SwmsDocForWorkerUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type SwmsDocForWorkerUiQuery = {
  __typename?: 'Query'
  swmsDocForWorker?: {
    __typename?: 'SwmsDocEntity'
    id: string
    url?: string | null
    name: string
  } | null
}

export type UpdateSwmsDocUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateSwmsDocInput
}>

export type UpdateSwmsDocUiMutation = {
  __typename?: 'Mutation'
  updateSwmsDoc: {
    __typename?: 'SwmsDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    status: SwmsStatus
    url?: string | null
    review?: string | null
    checklist?: any | null
    required?: boolean | null
    requiredAll?: boolean | null
    showAll?: boolean | null
    expireInDays?: number | null
    signCount: number
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    }>
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      config?: any | null
      timezone?: string | null
      swmsChecklistTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      createdAt: string
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      swmsDoc?: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        status: SwmsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type UpdateSwmsDocStatusUiMutationVariables = Exact<{
  id: Scalars['String']
  status?: InputMaybe<SwmsStatus>
}>

export type UpdateSwmsDocStatusUiMutation = {
  __typename?: 'Mutation'
  updateSwmsDoc: {
    __typename?: 'SwmsDoc'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    name: string
    status: SwmsStatus
    url?: string | null
    review?: string | null
    checklist?: any | null
    required?: boolean | null
    requiredAll?: boolean | null
    showAll?: boolean | null
    expireInDays?: number | null
    signCount: number
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    }
    workers: Array<{
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        id: string
        firstName: string
        lastName: string
      }
    }>
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      config?: any | null
      timezone?: string | null
      swmsChecklistTemplate?: {
        __typename?: 'Template'
        id: string
        templateData?: any | null
      } | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    currentVersion: { __typename?: 'VersionHistory'; version: number }
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
      createdAt: string
      template?:
        | {
            __typename?: 'LibraryTemplate'
            id: string
            templateData?: any | null
          }
        | { __typename?: 'Template'; id: string; templateData?: any | null }
        | null
    } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      swmsDoc?: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        status: SwmsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  }
}

export type ArchiveSwmsUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveSwmsUiMutation = {
  __typename?: 'Mutation'
  archiveSwmsDoc: { __typename?: 'SwmsDoc'; id: string }
}

export type RestoreSwmsUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreSwmsUiMutation = {
  __typename?: 'Mutation'
  restoreSwmsDoc: { __typename?: 'SwmsDoc'; id: string }
}

export type AllowExpiringSwmsUiQueryVariables = Exact<{ [key: string]: never }>

export type AllowExpiringSwmsUiQuery = {
  __typename?: 'Query'
  swmsSettings: { __typename?: 'SWMSSettings'; allowExpiringSWMS: boolean }
}

export type SwmsDocLogsUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<SwmsDocLogsFilterInput>
}>

export type SwmsDocLogsUiQuery = {
  __typename?: 'Query'
  swmsDocLogs: Array<{
    __typename?: 'SwmsDocLog'
    id: string
    createdAt: string
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    swmsDoc: { __typename?: 'SwmsDoc'; id: string; name: string }
  }>
}

export type DismissSwmsDocLogUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DismissSwmsDocLogUiMutation = {
  __typename?: 'Mutation'
  dismissSwmsDocLog: { __typename?: 'SwmsDocLog'; id: string }
}

export type LibrarySwmsDocAdminUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type LibrarySwmsDocAdminUiQuery = {
  __typename?: 'Query'
  librarySwmsDoc_admin?: {
    __typename?: 'LibrarySwmsDoc_Admin'
    id: string
    createdAt: string
    updatedAt: string
    expiresAt?: string | null
    archivedAt?: string | null
    name: string
    status: SwmsStatus
    key: string
    url?: string | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      } | null> | null
    } | null
    checklistTemplateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    } | null
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
      librarySwmsDoc?: {
        __typename?: 'LibrarySwmsDoc_Admin'
        id: string
        name: string
        status: SwmsStatus
        createdAt: string
        archivedAt?: string | null
      } | null
    }> | null
  } | null
}

export type LibrarySwmsDocsAdminUiQueryVariables = Exact<{
  filter?: InputMaybe<LibrarySwmsDocFilterInputAdmin>
  sort?: InputMaybe<LibrarySwmsDocSortInputAdmin>
  pagination?: InputMaybe<PaginationInput>
}>

export type LibrarySwmsDocsAdminUiQuery = {
  __typename?: 'Query'
  librarySwmsDocs_admin: Array<{
    __typename?: 'LibrarySwmsDoc_Admin'
    id: string
    createdAt: string
    expiresAt?: string | null
    archivedAt?: string | null
    name: string
    status: SwmsStatus
    connectedToProject: boolean
    subcontractorOnProject: boolean
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null
    currentVersion?: { __typename?: 'VersionHistory'; version: number } | null
    versionHistory?: Array<{
      __typename?: 'VersionHistory'
      version: number
    }> | null
  }>
  librarySwmsDocsAggregation_admin: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type CreateLibrarySwmsDocAdminUiMutationVariables = Exact<{
  input: CreateLibrarySwmsDocInputAdmin
}>

export type CreateLibrarySwmsDocAdminUiMutation = {
  __typename?: 'Mutation'
  createLibrarySwmsDoc_admin: {
    __typename?: 'LibrarySwmsDoc_Admin'
    id: string
  }
}

export type UpdateLibrarySwmsDocReviewAdminUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateLibrarySwmsDocReviewInputAdmin
}>

export type UpdateLibrarySwmsDocReviewAdminUiMutation = {
  __typename?: 'Mutation'
  updateLibrarySwmsDocReview_admin: {
    __typename?: 'LibrarySwmsDoc_Admin'
    id: string
  }
}

export type ArchiveLibrarySwmsDocAdminUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveLibrarySwmsDocAdminUiMutation = {
  __typename?: 'Mutation'
  archiveLibrarySwmsDoc_admin: {
    __typename?: 'LibrarySwmsDoc_Admin'
    id: string
  }
}

export type RestoreLibrarySwmsDocAdminUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreLibrarySwmsDocAdminUiMutation = {
  __typename?: 'Mutation'
  restoreLibrarySwmsDoc_admin: {
    __typename?: 'LibrarySwmsDoc_Admin'
    id: string
  }
}

export type UpdateLibrarySwmsDocAdminUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateLibrarySwmsDocInputAdmin
}>

export type UpdateLibrarySwmsDocAdminUiMutation = {
  __typename?: 'Mutation'
  updateLibrarySwmsDoc_admin: {
    __typename?: 'LibrarySwmsDoc_Admin'
    id: string
  }
}

export type ImportLibrarySwmsToProjectAdminUiMutationVariables = Exact<{
  projectId: Scalars['String']
  librarySwmsDocIds: Array<Scalars['String']> | Scalars['String']
}>

export type ImportLibrarySwmsToProjectAdminUiMutation = {
  __typename?: 'Mutation'
  importLibrarySwmsToProject_admin: boolean
}

export type TemplateAttributesFragment = {
  __typename?: 'Template'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  identifierPrefix?: string | null
  templateType: TemplateType
  templateName: string
  templateData?: any | null
  templateCategoryName?: string | null
  templateResponsesCount: number
  lastRun?: string | null
  isPublicChecklist: boolean
  accessProfileTemplate?: {
    __typename?: 'AccessProfileTemplate'
    id: string
    name: string
  } | null
  schedules?: Array<{
    __typename?: 'Schedule'
    id: string
    title: string
    projectId: string
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
  } | null> | null
}

export type TemplatesListAttributesFragment = {
  __typename?: 'Template'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  identifierPrefix?: string | null
  templateName: string
  templateCategoryName?: string | null
  accessProfileTemplate?: {
    __typename?: 'AccessProfileTemplate'
    id: string
    name: string
  } | null
}

export type LibraryTemplateAttributesFragment = {
  __typename?: 'LibraryTemplate'
  id: string
  createdAt: string
  updatedAt: string
  templateType: TemplateType
  templateName: string
  templateDescription?: string | null
  templateData?: any | null
  templateResponsesCount: number
  lastRun?: string | null
  schedules?: Array<{
    __typename?: 'Schedule'
    id: string
    title: string
    projectId: string
    assignees: Array<{
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null>
    assigner: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
  } | null> | null
}

export type TemplateResponseListAttributesFragment = {
  __typename?: 'TemplateResponse'
  id: string
  createdAt: string
  updatedAt: string
  completedAt?: string | null
  archivedAt?: string | null
  fullIdentifier?: string | null
  tableBlocks?: any | null
  accessProfile?: {
    __typename?: 'AccessProfile'
    id: string
    name: string
    defaultRole?: AccessProfileRole | null
    owner?: {
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    actors: Array<{
      __typename?: 'AccessProfileActor'
      role: AccessProfileRole
      adminUser: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    }>
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
  } | null
  platformActions?: Array<{
    __typename?: 'PlatformAction'
    id: string
    title?: string | null
    status: PlatformActionStatus
  } | null> | null
  relatedRegisterItem?: {
    __typename?: 'RegisterItem'
    id: string
    name: string
    identifier: number
    fullIdentifier: string
    register: {
      __typename?: 'Register'
      identifierPrefix: string
      name: string
    }
  } | null
  project?: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  } | null
  template?:
    | {
        __typename?: 'LibraryTemplate'
        id: string
        templateName: string
        templateType: TemplateType
      }
    | {
        __typename?: 'Template'
        id: string
        templateName: string
        templateType: TemplateType
        accessProfileTemplate?: {
          __typename?: 'AccessProfileTemplate'
          id: string
        } | null
      }
    | null
  author?:
    | {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    | {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    | null
  attachments?: Array<{
    __typename?: 'Attachment'
    id: string
    key: string
    url: string
  }> | null
  responseSummary?: {
    __typename?: 'TemplateResponseSummary'
    blocks?: {
      __typename?: 'TemplateResponseBlocksSummary'
      total?: number | null
      completed?: number | null
      incomplete?: number | null
      totalWithDesiredState?: number | null
      inDesiredState?: number | null
      inNeutralState?: number | null
      inUndesiredState?: number | null
    } | null
  } | null
  location?: {
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    parent?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  } | null
  subcontractor?: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; id?: string | null; name: string }
  } | null
}

export type TemplateResponseAttributesFragment = {
  __typename?: 'TemplateResponse'
  id: string
  createdAt: string
  updatedAt: string
  completedAt?: string | null
  archivedAt?: string | null
  fullIdentifier?: string | null
  responseData?: any | null
  accessProfile?: {
    __typename?: 'AccessProfile'
    id: string
    name: string
    defaultRole?: AccessProfileRole | null
    owner?: {
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    actors: Array<{
      __typename?: 'AccessProfileActor'
      role: AccessProfileRole
      adminUser: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    }>
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
  } | null
  relatedRegisterItem?: {
    __typename?: 'RegisterItem'
    id: string
    name: string
    identifier: number
    fullIdentifier: string
    register: {
      __typename?: 'Register'
      identifierPrefix: string
      name: string
    }
  } | null
  project?: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  } | null
  template?:
    | {
        __typename?: 'LibraryTemplate'
        id: string
        templateName: string
        templateData?: any | null
      }
    | {
        __typename?: 'Template'
        id: string
        templateName: string
        templateData?: any | null
        accessProfileTemplate?: {
          __typename?: 'AccessProfileTemplate'
          id: string
        } | null
      }
    | null
  author?:
    | {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    | {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
    | null
  attachments?: Array<{
    __typename?: 'Attachment'
    id: string
    key: string
    url: string
  }> | null
  responseSummary?: {
    __typename?: 'TemplateResponseSummary'
    blocks?: {
      __typename?: 'TemplateResponseBlocksSummary'
      total?: number | null
      completed?: number | null
      incomplete?: number | null
      totalWithDesiredState?: number | null
      inDesiredState?: number | null
      inNeutralState?: number | null
      inUndesiredState?: number | null
    } | null
  } | null
  location?: {
    __typename?: 'ProjectLocation'
    id: string
    name: string
    order: number
    parent?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  } | null
}

export type TemplatePublicResponseAttributesFragment = {
  __typename?: 'TemplateResponseEntity'
  id: string
  createdAt: string
  updatedAt: string
  completedAt?: string | null
  archivedAt?: string | null
  responseData?: any | null
  template?: {
    __typename?: 'TemplateEntity'
    id: string
    templateName: string
    templateData?: any | null
  } | null
  attachments?: Array<{
    __typename?: 'AttachmentEntity'
    id: string
    key: string
    url: string
  }> | null
}

export type TemplateEntityAttributesFragment = {
  __typename?: 'TemplateEntity'
  id: string
  templateName: string
  templateData?: any | null
}

export type TemplatesUiQueryVariables = Exact<{
  filter?: InputMaybe<TemplateFilterInput>
  sort?: InputMaybe<TemplateSortInput>
}>

export type TemplatesUiQuery = {
  __typename?: 'Query'
  templates: Array<{
    __typename?: 'Template'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    identifierPrefix?: string | null
    templateType: TemplateType
    templateName: string
    templateData?: any | null
    templateCategoryName?: string | null
    templateResponsesCount: number
    lastRun?: string | null
    isPublicChecklist: boolean
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
    schedules?: Array<{
      __typename?: 'Schedule'
      id: string
      title: string
      projectId: string
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
    } | null> | null
  }>
}

export type TemplatesSelectUiQueryVariables = Exact<{
  filter?: InputMaybe<TemplateFilterInput>
  sort?: InputMaybe<TemplateSortInput>
}>

export type TemplatesSelectUiQuery = {
  __typename?: 'Query'
  templates: Array<{
    __typename?: 'Template'
    id: string
    templateName: string
    templateCategoryName?: string | null
    identifierPrefix?: string | null
  }>
}

export type TemplateEntitiesUiQueryVariables = Exact<{
  subcontractorId: Scalars['String']
  filter?: InputMaybe<TemplateFilterInput>
  sort?: InputMaybe<TemplateSortInput>
}>

export type TemplateEntitiesUiQuery = {
  __typename?: 'Query'
  templates_public: Array<{
    __typename?: 'TemplateEntity'
    id: string
    templateName: string
    templateData?: any | null
  }>
}

export type TemplatesListUiQueryVariables = Exact<{
  filter?: InputMaybe<TemplateFilterInput>
}>

export type TemplatesListUiQuery = {
  __typename?: 'Query'
  templates: Array<{
    __typename?: 'Template'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    identifierPrefix?: string | null
    templateName: string
    templateCategoryName?: string | null
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
  }>
}

export type TemplatesListPaginatedUiQueryVariables = Exact<{
  filter?: InputMaybe<TemplateFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<TemplateSortInput>
}>

export type TemplatesListPaginatedUiQuery = {
  __typename?: 'Query'
  templates: Array<{
    __typename?: 'Template'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    identifierPrefix?: string | null
    templateName: string
    templateCategoryName?: string | null
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
  }>
  templatesAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type CompanyTemplatesUiQueryVariables = Exact<{
  filter?: InputMaybe<TemplateFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<TemplateSortInput>
}>

export type CompanyTemplatesUiQuery = {
  __typename?: 'Query'
  templates: Array<{
    __typename?: 'Template'
    id: string
    updatedAt: string
    archivedAt?: string | null
    templateType: TemplateType
    templateName: string
    templateResponsesCount: number
    templateCategoryName?: string | null
  }>
  templatesAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type AllCompanyTemplatesUiQueryVariables = Exact<{
  filter?: InputMaybe<TemplateFilterInput>
}>

export type AllCompanyTemplatesUiQuery = {
  __typename?: 'Query'
  templates: Array<{
    __typename?: 'Template'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    templateType: TemplateType
    templateName: string
    templateResponsesCount: number
    templateCategoryName?: string | null
  }>
}

export type TemplatesListWithProjectsUiQueryVariables = Exact<{
  filter?: InputMaybe<TemplateFilterInput>
}>

export type TemplatesListWithProjectsUiQuery = {
  __typename?: 'Query'
  templates: Array<{
    __typename?: 'Template'
    id: string
    default?: boolean | null
    templateName: string
    templateData?: any | null
    templateCategoryName?: string | null
    builderId?: string | null
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
  }>
}

export type LibraryTemplatesUiQueryVariables = Exact<{
  filter?: InputMaybe<LibraryTemplateFilterInput>
}>

export type LibraryTemplatesUiQuery = {
  __typename?: 'Query'
  libraryTemplates: Array<{
    __typename?: 'LibraryTemplate'
    id: string
    createdAt: string
    updatedAt: string
    templateType: TemplateType
    templateName: string
    templateDescription?: string | null
    templateData?: any | null
    templateResponsesCount: number
    lastRun?: string | null
    schedules?: Array<{
      __typename?: 'Schedule'
      id: string
      title: string
      projectId: string
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
    } | null> | null
  }>
}

export type LibraryTemplatesSelectUiQueryVariables = Exact<{
  filter?: InputMaybe<LibraryTemplateFilterInput>
}>

export type LibraryTemplatesSelectUiQuery = {
  __typename?: 'Query'
  libraryTemplates: Array<{
    __typename?: 'LibraryTemplate'
    id: string
    templateName: string
  }>
}

export type LibraryTemplateUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type LibraryTemplateUiQuery = {
  __typename?: 'Query'
  libraryTemplate?: {
    __typename?: 'LibraryTemplate'
    id: string
    createdAt: string
    updatedAt: string
    templateType: TemplateType
    templateName: string
    templateDescription?: string | null
    templateData?: any | null
    templateResponsesCount: number
    lastRun?: string | null
    schedules?: Array<{
      __typename?: 'Schedule'
      id: string
      title: string
      projectId: string
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
    } | null> | null
  } | null
}

export type TemplateUiQueryVariables = Exact<{
  id: Scalars['String']
  archivedFilter?: InputMaybe<ArchivedFilter>
}>

export type TemplateUiQuery = {
  __typename?: 'Query'
  template?: {
    __typename?: 'Template'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    identifierPrefix?: string | null
    templateType: TemplateType
    templateName: string
    templateData?: any | null
    templateCategoryName?: string | null
    templateResponsesCount: number
    lastRun?: string | null
    isPublicChecklist: boolean
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
    schedules?: Array<{
      __typename?: 'Schedule'
      id: string
      title: string
      projectId: string
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
    } | null> | null
  } | null
}

export type TemplateFromMarketplaceUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type TemplateFromMarketplaceUiQuery = {
  __typename?: 'Query'
  templateFromMarketplace?: {
    __typename?: 'TemplateEntity'
    id: string
    templateName: string
    templateData?: any | null
  } | null
}

export type TemplateDataUiQueryVariables = Exact<{
  id: Scalars['String']
  archivedFilter?: InputMaybe<ArchivedFilter>
}>

export type TemplateDataUiQuery = {
  __typename?: 'Query'
  template?: { __typename?: 'Template'; templateData?: any | null } | null
}

export type TemplateAsWorkerUiQueryVariables = Exact<{
  id: Scalars['String']
  projectId: Scalars['String']
}>

export type TemplateAsWorkerUiQuery = {
  __typename?: 'Query'
  templateAsWorker?: {
    __typename?: 'TemplateEntity'
    id: string
    templateName: string
    templateData?: any | null
  } | null
}

export type TemplateIdentifiersUiQueryVariables = Exact<{
  [key: string]: never
}>

export type TemplateIdentifiersUiQuery = {
  __typename?: 'Query'
  templateIdentifiers: Array<string>
}

export type UpdateTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateTemplateInput
}>

export type UpdateTemplateUiMutation = {
  __typename?: 'Mutation'
  updateTemplate: {
    __typename?: 'Template'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    identifierPrefix?: string | null
    templateType: TemplateType
    templateName: string
    templateData?: any | null
    templateCategoryName?: string | null
    templateResponsesCount: number
    lastRun?: string | null
    isPublicChecklist: boolean
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
    schedules?: Array<{
      __typename?: 'Schedule'
      id: string
      title: string
      projectId: string
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
    } | null> | null
  }
}

export type BulkUpdateTemplatesUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  input: UpdateTemplateInput
}>

export type BulkUpdateTemplatesUiMutation = {
  __typename?: 'Mutation'
  bulkUpdateTemplates: Array<{ __typename?: 'Template'; id: string } | null>
}

export type TemplateResponsesUiQueryVariables = Exact<{
  filter?: InputMaybe<TemplateResponseFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<TemplateResponseSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type TemplateResponsesUiQuery = {
  __typename?: 'Query'
  templateResponses: Array<{
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    archivedAt?: string | null
    fullIdentifier?: string | null
    tableBlocks?: any | null
    accessProfile?: {
      __typename?: 'AccessProfile'
      id: string
      name: string
      defaultRole?: AccessProfileRole | null
      owner?: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      actors: Array<{
        __typename?: 'AccessProfileActor'
        role: AccessProfileRole
        adminUser: {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      }>
      accessProfileTemplate?: {
        __typename?: 'AccessProfileTemplate'
        id: string
        name: string
      } | null
    } | null
    platformActions?: Array<{
      __typename?: 'PlatformAction'
      id: string
      title?: string | null
      status: PlatformActionStatus
    } | null> | null
    relatedRegisterItem?: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      identifier: number
      fullIdentifier: string
      register: {
        __typename?: 'Register'
        identifierPrefix: string
        name: string
      }
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateName: string
          templateType: TemplateType
        }
      | {
          __typename?: 'Template'
          id: string
          templateName: string
          templateType: TemplateType
          accessProfileTemplate?: {
            __typename?: 'AccessProfileTemplate'
            id: string
          } | null
        }
      | null
    author?:
      | {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
    }> | null
    responseSummary?: {
      __typename?: 'TemplateResponseSummary'
      blocks?: {
        __typename?: 'TemplateResponseBlocksSummary'
        total?: number | null
        completed?: number | null
        incomplete?: number | null
        totalWithDesiredState?: number | null
        inDesiredState?: number | null
        inNeutralState?: number | null
        inUndesiredState?: number | null
      } | null
    } | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
    subcontractor?: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; id?: string | null; name: string }
    } | null
  }>
  templateResponsesAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type TemplateResponsesForCsvUiQueryVariables = Exact<{
  filter?: InputMaybe<TemplateResponseFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<TemplateResponseSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type TemplateResponsesForCsvUiQuery = {
  __typename?: 'Query'
  templateResponses: Array<{
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    archivedAt?: string | null
    fullIdentifier?: string | null
    responseData?: any | null
    accessProfile?: {
      __typename?: 'AccessProfile'
      id: string
      name: string
      defaultRole?: AccessProfileRole | null
      owner?: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      actors: Array<{
        __typename?: 'AccessProfileActor'
        role: AccessProfileRole
        adminUser: {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      }>
      accessProfileTemplate?: {
        __typename?: 'AccessProfileTemplate'
        id: string
        name: string
      } | null
    } | null
    relatedRegisterItem?: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      identifier: number
      fullIdentifier: string
      register: {
        __typename?: 'Register'
        identifierPrefix: string
        name: string
      }
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateName: string
          templateData?: any | null
        }
      | {
          __typename?: 'Template'
          id: string
          templateName: string
          templateData?: any | null
          accessProfileTemplate?: {
            __typename?: 'AccessProfileTemplate'
            id: string
          } | null
        }
      | null
    author?:
      | {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
    }> | null
    responseSummary?: {
      __typename?: 'TemplateResponseSummary'
      blocks?: {
        __typename?: 'TemplateResponseBlocksSummary'
        total?: number | null
        completed?: number | null
        incomplete?: number | null
        totalWithDesiredState?: number | null
        inDesiredState?: number | null
        inNeutralState?: number | null
        inUndesiredState?: number | null
      } | null
    } | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  }>
}

export type TemplateResponseUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type TemplateResponseUiQuery = {
  __typename?: 'Query'
  templateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    archivedAt?: string | null
    fullIdentifier?: string | null
    responseData?: any | null
    accessProfile?: {
      __typename?: 'AccessProfile'
      id: string
      name: string
      defaultRole?: AccessProfileRole | null
      owner?: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      actors: Array<{
        __typename?: 'AccessProfileActor'
        role: AccessProfileRole
        adminUser: {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      }>
      accessProfileTemplate?: {
        __typename?: 'AccessProfileTemplate'
        id: string
        name: string
      } | null
    } | null
    relatedRegisterItem?: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      identifier: number
      fullIdentifier: string
      register: {
        __typename?: 'Register'
        identifierPrefix: string
        name: string
      }
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateName: string
          templateData?: any | null
        }
      | {
          __typename?: 'Template'
          id: string
          templateName: string
          templateData?: any | null
          accessProfileTemplate?: {
            __typename?: 'AccessProfileTemplate'
            id: string
          } | null
        }
      | null
    author?:
      | {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
    }> | null
    responseSummary?: {
      __typename?: 'TemplateResponseSummary'
      blocks?: {
        __typename?: 'TemplateResponseBlocksSummary'
        total?: number | null
        completed?: number | null
        incomplete?: number | null
        totalWithDesiredState?: number | null
        inDesiredState?: number | null
        inNeutralState?: number | null
        inUndesiredState?: number | null
      } | null
    } | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  } | null
}

export type TemplateResponsesAggregateStatsUiQueryVariables = Exact<{
  filter?: InputMaybe<TemplateResponseFilterInput>
}>

export type TemplateResponsesAggregateStatsUiQuery = {
  __typename?: 'Query'
  templateResponsesAggregateStats?: Array<{
    __typename?: 'TemplateResponseAggregateStats'
    status: TemplateResponseAggregateTypes
    count: number
  } | null> | null
}

export type TemplateOrLibraryTemplateUiQueryVariables = Exact<{
  templateType: TemplateType
  projectId?: InputMaybe<Scalars['String']>
}>

export type TemplateOrLibraryTemplateUiQuery = {
  __typename?: 'Query'
  templateOrLibraryTemplate?:
    | {
        __typename?: 'LibraryTemplate'
        id: string
        createdAt: string
        updatedAt: string
        templateType: TemplateType
        templateName: string
        templateDescription?: string | null
        templateData?: any | null
        templateResponsesCount: number
        lastRun?: string | null
        schedules?: Array<{
          __typename?: 'Schedule'
          id: string
          title: string
          projectId: string
          assignees: Array<{
            __typename?: 'AdminUser'
            user: { __typename?: 'User'; firstName: string; lastName: string }
          } | null>
          assigner: {
            __typename?: 'AdminUser'
            user: { __typename?: 'User'; firstName: string; lastName: string }
          }
          scheduledJobs: Array<{
            __typename?: 'ScheduledJob'
            id: string
          } | null>
        } | null> | null
      }
    | {
        __typename?: 'Template'
        id: string
        createdAt: string
        updatedAt: string
        archivedAt?: string | null
        identifierPrefix?: string | null
        templateType: TemplateType
        templateName: string
        templateData?: any | null
        templateCategoryName?: string | null
        templateResponsesCount: number
        lastRun?: string | null
        isPublicChecklist: boolean
        accessProfileTemplate?: {
          __typename?: 'AccessProfileTemplate'
          id: string
          name: string
        } | null
        schedules?: Array<{
          __typename?: 'Schedule'
          id: string
          title: string
          projectId: string
          assignees: Array<{
            __typename?: 'AdminUser'
            user: { __typename?: 'User'; firstName: string; lastName: string }
          } | null>
          assigner: {
            __typename?: 'AdminUser'
            user: { __typename?: 'User'; firstName: string; lastName: string }
          }
          scheduledJobs: Array<{
            __typename?: 'ScheduledJob'
            id: string
          } | null>
        } | null> | null
      }
    | null
}

export type TemplateOrLibraryTemplateDataUiQueryVariables = Exact<{
  templateType: TemplateType
  projectId?: InputMaybe<Scalars['String']>
}>

export type TemplateOrLibraryTemplateDataUiQuery = {
  __typename?: 'Query'
  templateOrLibraryTemplate?:
    | { __typename?: 'LibraryTemplate'; id: string; templateData?: any | null }
    | { __typename?: 'Template'; id: string; templateData?: any | null }
    | null
}

export type CreateTemplateResponseUiMutationVariables = Exact<{
  input: CreateTemplateResponseInput
}>

export type CreateTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  createTemplateResponse: {
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    archivedAt?: string | null
    fullIdentifier?: string | null
    responseData?: any | null
    accessProfile?: {
      __typename?: 'AccessProfile'
      id: string
      name: string
      defaultRole?: AccessProfileRole | null
      owner?: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      actors: Array<{
        __typename?: 'AccessProfileActor'
        role: AccessProfileRole
        adminUser: {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      }>
      accessProfileTemplate?: {
        __typename?: 'AccessProfileTemplate'
        id: string
        name: string
      } | null
    } | null
    relatedRegisterItem?: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      identifier: number
      fullIdentifier: string
      register: {
        __typename?: 'Register'
        identifierPrefix: string
        name: string
      }
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateName: string
          templateData?: any | null
        }
      | {
          __typename?: 'Template'
          id: string
          templateName: string
          templateData?: any | null
          accessProfileTemplate?: {
            __typename?: 'AccessProfileTemplate'
            id: string
          } | null
        }
      | null
    author?:
      | {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
    }> | null
    responseSummary?: {
      __typename?: 'TemplateResponseSummary'
      blocks?: {
        __typename?: 'TemplateResponseBlocksSummary'
        total?: number | null
        completed?: number | null
        incomplete?: number | null
        totalWithDesiredState?: number | null
        inDesiredState?: number | null
        inNeutralState?: number | null
        inUndesiredState?: number | null
      } | null
    } | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  }
}

export type CreatePublicTemplateResponseUiMutationVariables = Exact<{
  input: CreatePublicTemplateResponseInput
}>

export type CreatePublicTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  createPublicTemplateResponse: {
    __typename?: 'TemplateResponseEntity'
    id: string
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    archivedAt?: string | null
    responseData?: any | null
    template?: {
      __typename?: 'TemplateEntity'
      id: string
      templateName: string
      templateData?: any | null
    } | null
    attachments?: Array<{
      __typename?: 'AttachmentEntity'
      id: string
      key: string
      url: string
    }> | null
  }
}

export type UpdatePublicTemplateResponseUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdatePublicTemplateResponseInput
}>

export type UpdatePublicTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  updatePublicTemplateResponse: {
    __typename?: 'TemplateResponseEntity'
    id: string
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    archivedAt?: string | null
    responseData?: any | null
    template?: {
      __typename?: 'TemplateEntity'
      id: string
      templateName: string
      templateData?: any | null
    } | null
    attachments?: Array<{
      __typename?: 'AttachmentEntity'
      id: string
      key: string
      url: string
    }> | null
  }
}

export type CreateLibraryTemplateUiMutationVariables = Exact<{
  input: CreateLibraryTemplateInput
}>

export type CreateLibraryTemplateUiMutation = {
  __typename?: 'Mutation'
  createLibraryTemplate: {
    __typename?: 'LibraryTemplate'
    id: string
    templateName: string
  }
}

export type CreateTemplateUiMutationVariables = Exact<{
  input: CreateTemplateInput
}>

export type CreateTemplateUiMutation = {
  __typename?: 'Mutation'
  createTemplate: {
    __typename?: 'Template'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    identifierPrefix?: string | null
    templateType: TemplateType
    templateName: string
    templateData?: any | null
    templateCategoryName?: string | null
    templateResponsesCount: number
    lastRun?: string | null
    isPublicChecklist: boolean
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
    schedules?: Array<{
      __typename?: 'Schedule'
      id: string
      title: string
      projectId: string
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
    } | null> | null
  }
}

export type UpdateLibraryTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateLibraryTemplateInput
}>

export type UpdateLibraryTemplateUiMutation = {
  __typename?: 'Mutation'
  updateLibraryTemplate: {
    __typename?: 'LibraryTemplate'
    id: string
    createdAt: string
    updatedAt: string
    templateType: TemplateType
    templateName: string
    templateDescription?: string | null
    templateData?: any | null
    templateResponsesCount: number
    lastRun?: string | null
    schedules?: Array<{
      __typename?: 'Schedule'
      id: string
      title: string
      projectId: string
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
    } | null> | null
  }
}

export type UpdateTemplateResponseUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateTemplateResponseInput
}>

export type UpdateTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  updateTemplateResponse: {
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    archivedAt?: string | null
    fullIdentifier?: string | null
    responseData?: any | null
    accessProfile?: {
      __typename?: 'AccessProfile'
      id: string
      name: string
      defaultRole?: AccessProfileRole | null
      owner?: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      actors: Array<{
        __typename?: 'AccessProfileActor'
        role: AccessProfileRole
        adminUser: {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      }>
      accessProfileTemplate?: {
        __typename?: 'AccessProfileTemplate'
        id: string
        name: string
      } | null
    } | null
    relatedRegisterItem?: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      identifier: number
      fullIdentifier: string
      register: {
        __typename?: 'Register'
        identifierPrefix: string
        name: string
      }
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateName: string
          templateData?: any | null
        }
      | {
          __typename?: 'Template'
          id: string
          templateName: string
          templateData?: any | null
          accessProfileTemplate?: {
            __typename?: 'AccessProfileTemplate'
            id: string
          } | null
        }
      | null
    author?:
      | {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
    }> | null
    responseSummary?: {
      __typename?: 'TemplateResponseSummary'
      blocks?: {
        __typename?: 'TemplateResponseBlocksSummary'
        total?: number | null
        completed?: number | null
        incomplete?: number | null
        totalWithDesiredState?: number | null
        inDesiredState?: number | null
        inNeutralState?: number | null
        inUndesiredState?: number | null
      } | null
    } | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  }
}

export type CompleteTemplateResponseUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type CompleteTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  completeTemplateResponse: { __typename?: 'TemplateResponse'; id: string }
}

export type ArchiveTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveTemplateUiMutation = {
  __typename?: 'Mutation'
  archiveTemplate: {
    __typename?: 'Template'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    identifierPrefix?: string | null
    templateType: TemplateType
    templateName: string
    templateData?: any | null
    templateCategoryName?: string | null
    templateResponsesCount: number
    lastRun?: string | null
    isPublicChecklist: boolean
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
    schedules?: Array<{
      __typename?: 'Schedule'
      id: string
      title: string
      projectId: string
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
    } | null> | null
  }
}

export type RestoreTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreTemplateUiMutation = {
  __typename?: 'Mutation'
  restoreTemplate: {
    __typename?: 'Template'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    identifierPrefix?: string | null
    templateType: TemplateType
    templateName: string
    templateData?: any | null
    templateCategoryName?: string | null
    templateResponsesCount: number
    lastRun?: string | null
    isPublicChecklist: boolean
    accessProfileTemplate?: {
      __typename?: 'AccessProfileTemplate'
      id: string
      name: string
    } | null
    schedules?: Array<{
      __typename?: 'Schedule'
      id: string
      title: string
      projectId: string
      assignees: Array<{
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null>
      assigner: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      scheduledJobs: Array<{ __typename?: 'ScheduledJob'; id: string } | null>
    } | null> | null
  }
}

export type TransferTemplateUiMutationVariables = Exact<{
  id: Scalars['String']
  name: Scalars['String']
  builderId: Scalars['String']
}>

export type TransferTemplateUiMutation = {
  __typename?: 'Mutation'
  transferTemplate: string
}

export type TransferTemplatesUiMutationVariables = Exact<{
  templates: Array<TransferTemplateInput> | TransferTemplateInput
  builderId: Scalars['String']
}>

export type TransferTemplatesUiMutation = {
  __typename?: 'Mutation'
  transferTemplates: Array<string>
}

export type ArchiveTemplateResponseUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  archiveTemplateResponse: {
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    archivedAt?: string | null
    fullIdentifier?: string | null
    responseData?: any | null
    accessProfile?: {
      __typename?: 'AccessProfile'
      id: string
      name: string
      defaultRole?: AccessProfileRole | null
      owner?: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      actors: Array<{
        __typename?: 'AccessProfileActor'
        role: AccessProfileRole
        adminUser: {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      }>
      accessProfileTemplate?: {
        __typename?: 'AccessProfileTemplate'
        id: string
        name: string
      } | null
    } | null
    relatedRegisterItem?: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      identifier: number
      fullIdentifier: string
      register: {
        __typename?: 'Register'
        identifierPrefix: string
        name: string
      }
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateName: string
          templateData?: any | null
        }
      | {
          __typename?: 'Template'
          id: string
          templateName: string
          templateData?: any | null
          accessProfileTemplate?: {
            __typename?: 'AccessProfileTemplate'
            id: string
          } | null
        }
      | null
    author?:
      | {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
    }> | null
    responseSummary?: {
      __typename?: 'TemplateResponseSummary'
      blocks?: {
        __typename?: 'TemplateResponseBlocksSummary'
        total?: number | null
        completed?: number | null
        incomplete?: number | null
        totalWithDesiredState?: number | null
        inDesiredState?: number | null
        inNeutralState?: number | null
        inUndesiredState?: number | null
      } | null
    } | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  }
}

export type RestoreTemplateResponseUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreTemplateResponseUiMutation = {
  __typename?: 'Mutation'
  restoreTemplateResponse: {
    __typename?: 'TemplateResponse'
    id: string
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    archivedAt?: string | null
    fullIdentifier?: string | null
    responseData?: any | null
    accessProfile?: {
      __typename?: 'AccessProfile'
      id: string
      name: string
      defaultRole?: AccessProfileRole | null
      owner?: {
        __typename?: 'AdminUser'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      actors: Array<{
        __typename?: 'AccessProfileActor'
        role: AccessProfileRole
        adminUser: {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      }>
      accessProfileTemplate?: {
        __typename?: 'AccessProfileTemplate'
        id: string
        name: string
      } | null
    } | null
    relatedRegisterItem?: {
      __typename?: 'RegisterItem'
      id: string
      name: string
      identifier: number
      fullIdentifier: string
      register: {
        __typename?: 'Register'
        identifierPrefix: string
        name: string
      }
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    } | null
    template?:
      | {
          __typename?: 'LibraryTemplate'
          id: string
          templateName: string
          templateData?: any | null
        }
      | {
          __typename?: 'Template'
          id: string
          templateName: string
          templateData?: any | null
          accessProfileTemplate?: {
            __typename?: 'AccessProfileTemplate'
            id: string
          } | null
        }
      | null
    author?:
      | {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | null
    attachments?: Array<{
      __typename?: 'Attachment'
      id: string
      key: string
      url: string
    }> | null
    responseSummary?: {
      __typename?: 'TemplateResponseSummary'
      blocks?: {
        __typename?: 'TemplateResponseBlocksSummary'
        total?: number | null
        completed?: number | null
        incomplete?: number | null
        totalWithDesiredState?: number | null
        inDesiredState?: number | null
        inNeutralState?: number | null
        inUndesiredState?: number | null
      } | null
    } | null
    location?: {
      __typename?: 'ProjectLocation'
      id: string
      name: string
      order: number
      parent?: {
        __typename?: 'ProjectLocation'
        id: string
        name: string
        order: number
        parent?: {
          __typename?: 'ProjectLocation'
          id: string
          name: string
          order: number
          parent?: {
            __typename?: 'ProjectLocation'
            id: string
            name: string
            order: number
            parent?: {
              __typename?: 'ProjectLocation'
              id: string
              name: string
              order: number
              parent?: {
                __typename?: 'ProjectLocation'
                id: string
                name: string
                order: number
                parent?: {
                  __typename?: 'ProjectLocation'
                  id: string
                  name: string
                  order: number
                  parent?: {
                    __typename?: 'ProjectLocation'
                    id: string
                    name: string
                    order: number
                    parent?: {
                      __typename?: 'ProjectLocation'
                      id: string
                      name: string
                      order: number
                      parent?: {
                        __typename?: 'ProjectLocation'
                        id: string
                        name: string
                        order: number
                      } | null
                    } | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
      } | null
    } | null
  }
}

export type CreateTemplateResponseAsWorkerUiMutationVariables = Exact<{
  input: CreateTemplateResponseAsWorkerInput
}>

export type CreateTemplateResponseAsWorkerUiMutation = {
  __typename?: 'Mutation'
  createTemplateResponseAsWorker: {
    __typename?: 'TemplateResponseEntity'
    id: string
  }
}

export type UpdateTemplateResponseAsWorkerUiMutationVariables = Exact<{
  input: UpdateTemplateResponseAsWorkerInput
}>

export type UpdateTemplateResponseAsWorkerUiMutation = {
  __typename?: 'Mutation'
  updateTemplateResponseAsWorker: {
    __typename?: 'TemplateResponseEntity'
    id: string
  }
}

export type UpdateTemplateResponseRelatedRegisterItemUiMutationVariables =
  Exact<{
    id: Scalars['String']
    registerItemId?: InputMaybe<Scalars['String']>
  }>

export type UpdateTemplateResponseRelatedRegisterItemUiMutation = {
  __typename?: 'Mutation'
  updateTemplateResponseRelatedRegisterItem: {
    __typename?: 'TemplateResponse'
    id: string
  }
}

export type ConnectProjectToTemplateUiMutationVariables = Exact<{
  projectId: Scalars['String']
  templateId: Scalars['String']
  input: AssignProjectToTemplateInput
}>

export type ConnectProjectToTemplateUiMutation = {
  __typename?: 'Mutation'
  connectProjectToTemplate: { __typename?: 'Template'; id: string }
}

export type DisconnectProjectFromTemplateTypeUiMutationVariables = Exact<{
  projectId: Scalars['String']
  templateType: TemplateType
}>

export type DisconnectProjectFromTemplateTypeUiMutation = {
  __typename?: 'Mutation'
  disconnectProjectFromTemplateType: { __typename?: 'Project'; id: string }
}

export type BulkArchiveTemplatesUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkArchiveTemplatesUiMutation = {
  __typename?: 'Mutation'
  bulkArchiveTemplates?: Array<string> | null
}

export type BulkRestoreTemplatesUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
}>

export type BulkRestoreTemplatesUiMutation = {
  __typename?: 'Mutation'
  bulkRestoreTemplates?: Array<string> | null
}

export type TicketWalletSharePublicUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type TicketWalletSharePublicUiQuery = {
  __typename?: 'Query'
  ticketWalletSharePublic?:
    | {
        __typename?: 'TicketWalletShare'
        id: string
        expiry: string
        worker: {
          __typename?: 'WorkerTicketShareEntity'
          dob?: string | null
          trade?: string | null
          user: {
            __typename?: 'UserEntity'
            firstName?: string | null
            lastName?: string | null
          }
          subcontractors: Array<{
            __typename?: 'SubcontractorEntity'
            name: string
          } | null>
          tickets?: Array<{
            __typename?: 'TicketEntity'
            id: string
            number?: string | null
            expiry?: string | null
            obtained?: string | null
            countryIssued?: string | null
            stateIssued?: string | null
            ticketTemplate: {
              __typename?: 'TicketTemplateEntity'
              name: string
              shortName: string
            }
            files: Array<{
              __typename?: 'TicketFileEntity'
              id: string
              name: string
              file: {
                __typename?: 'FileEntity'
                name: string
                url?: string | null
                contentType: string
              }
            } | null>
          } | null> | null
        }
      }
    | {
        __typename?: 'TicketWalletShareExpired'
        id: string
        expiry: string
        expired: boolean
      }
    | null
}

export type TicketAttributesFragment = {
  __typename?: 'Ticket'
  id: string
  createdAt: string
  updatedAt: string
  expiry?: string | null
  number?: string | null
  latestReviewStatus?: TicketReviewStatus | null
  obtained?: string | null
  stateIssued?: string | null
  countryIssued?: string | null
  reviews?: Array<{
    __typename?: 'TicketReview'
    reviewStatus: TicketReviewStatus
  } | null> | null
  ticketTemplate: {
    __typename?: 'TicketTemplate'
    id: string
    shortName: string
    name: string
    ticketFileConfigs: Array<{
      __typename?: 'TicketFileConfig'
      name: string
      id: string
    } | null>
  }
  worker: {
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
  }
  files: Array<{
    __typename?: 'TicketFile'
    id: string
    name: string
    file: {
      __typename?: 'File'
      name: string
      key: string
      url?: string | null
      contentType: string
    }
  } | null>
}

export type TicketAttributesSubsetFragment = {
  __typename?: 'Ticket'
  id: string
  updatedAt: string
  expiry?: string | null
  number?: string | null
  builderGenerated?: boolean | null
  latestReviewStatus?: TicketReviewStatus | null
  ticketTemplate: {
    __typename?: 'TicketTemplate'
    shortName: string
    name: string
  }
  worker: {
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
  }
}

export type TicketReviewAttributesFragment = {
  __typename?: 'TicketReview'
  id: string
  createdAt: string
  updatedAt: string
  reviewStatus: TicketReviewStatus
  reviewComments?: string | null
  adminUser?: {
    __typename?: 'AdminUser'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null
}

export type TicketsByWorkersCsvUiQueryVariables = Exact<{
  filter?: InputMaybe<TicketFilterInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type TicketsByWorkersCsvUiQuery = {
  __typename?: 'Query'
  ticketsByWorkers: Array<{
    __typename?: 'Ticket'
    id: string
    createdAt: string
    updatedAt: string
    expiry?: string | null
    number?: string | null
    latestReviewStatus?: TicketReviewStatus | null
    obtained?: string | null
    stateIssued?: string | null
    countryIssued?: string | null
    reviews?: Array<{
      __typename?: 'TicketReview'
      reviewStatus: TicketReviewStatus
    } | null> | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      id: string
      shortName: string
      name: string
      ticketFileConfigs: Array<{
        __typename?: 'TicketFileConfig'
        name: string
        id: string
      } | null>
    }
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
    files: Array<{
      __typename?: 'TicketFile'
      id: string
      name: string
      file: {
        __typename?: 'File'
        name: string
        key: string
        url?: string | null
        contentType: string
      }
    } | null>
  } | null>
}

export type TicketsUiQueryVariables = Exact<{
  filter?: InputMaybe<TicketFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<TicketSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type TicketsUiQuery = {
  __typename?: 'Query'
  ticketsByWorkers: Array<{
    __typename?: 'Ticket'
    id: string
    createdAt: string
    updatedAt: string
    expiry?: string | null
    number?: string | null
    latestReviewStatus?: TicketReviewStatus | null
    obtained?: string | null
    stateIssued?: string | null
    countryIssued?: string | null
    reviews?: Array<{
      __typename?: 'TicketReview'
      reviewStatus: TicketReviewStatus
    } | null> | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      id: string
      shortName: string
      name: string
      ticketFileConfigs: Array<{
        __typename?: 'TicketFileConfig'
        name: string
        id: string
      } | null>
    }
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
    files: Array<{
      __typename?: 'TicketFile'
      id: string
      name: string
      file: {
        __typename?: 'File'
        name: string
        key: string
        url?: string | null
        contentType: string
      }
    } | null>
  } | null>
}

export type TicketsByWorkersListUiQueryVariables = Exact<{
  filter?: InputMaybe<TicketFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<TicketSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type TicketsByWorkersListUiQuery = {
  __typename?: 'Query'
  ticketsByWorkers: Array<{
    __typename?: 'Ticket'
    id: string
    updatedAt: string
    expiry?: string | null
    number?: string | null
    builderGenerated?: boolean | null
    latestReviewStatus?: TicketReviewStatus | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      shortName: string
      name: string
    }
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
  } | null>
  ticketsByWorkersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type TicketsByWorkersForSearchUiQueryVariables = Exact<{
  filter?: InputMaybe<TicketFilterInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type TicketsByWorkersForSearchUiQuery = {
  __typename?: 'Query'
  ticketsByWorkers: Array<{
    __typename?: 'Ticket'
    id: string
    updatedAt: string
    expiry?: string | null
    number?: string | null
    builderGenerated?: boolean | null
    latestReviewStatus?: TicketReviewStatus | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      shortName: string
      name: string
    }
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
  } | null>
}

export type TicketTemplatesListUiQueryVariables = Exact<{
  [key: string]: never
}>

export type TicketTemplatesListUiQuery = {
  __typename?: 'Query'
  ticketTemplates: Array<{
    __typename?: 'TicketTemplate'
    id: string
    name: string
    shortName: string
    code?: string | null
    expiry: boolean
    obtained: boolean
    number: boolean
    medical: boolean
    ticketCount: number
    ticketCategory: { __typename?: 'TicketCategory'; id: string; name: string }
    ticketType: { __typename?: 'TicketType'; id: string; name: string }
    ticketFileConfigs: Array<{
      __typename?: 'TicketFileConfig'
      id: string
      name: string
      required: boolean
    } | null>
  }>
}

export type TicketTemplatesInfoUiQueryVariables = Exact<{
  [key: string]: never
}>

export type TicketTemplatesInfoUiQuery = {
  __typename?: 'Query'
  ticketTypes: Array<{
    __typename?: 'TicketType'
    id: string
    name: string
    ticketTemplatesCount: number
  }>
  ticketCategories: Array<{
    __typename?: 'TicketCategory'
    id: string
    name: string
    ticketTemplatesCount: number
  }>
}

export type TicketTemplateAttributesFragment = {
  __typename?: 'TicketTemplate'
  id: string
  createdAt: string
  updatedAt: string
  shortName: string
  name: string
  code?: string | null
  expiry: boolean
  obtained: boolean
  number: boolean
  ticketCategory: { __typename?: 'TicketCategory'; id: string; name: string }
  ticketType: { __typename?: 'TicketType'; id: string; name: string }
  ticketFileConfigs: Array<{
    __typename?: 'TicketFileConfig'
    id: string
    name: string
    required: boolean
  } | null>
}

export type TicketTemplatesUiQueryVariables = Exact<{ [key: string]: never }>

export type TicketTemplatesUiQuery = {
  __typename?: 'Query'
  ticketTemplates: Array<{
    __typename?: 'TicketTemplate'
    id: string
    createdAt: string
    updatedAt: string
    shortName: string
    name: string
    code?: string | null
    expiry: boolean
    obtained: boolean
    number: boolean
    ticketCategory: { __typename?: 'TicketCategory'; id: string; name: string }
    ticketType: { __typename?: 'TicketType'; id: string; name: string }
    ticketFileConfigs: Array<{
      __typename?: 'TicketFileConfig'
      id: string
      name: string
      required: boolean
    } | null>
  }>
}

export type TicketTemplatesForSearchUiQueryVariables = Exact<{
  [key: string]: never
}>

export type TicketTemplatesForSearchUiQuery = {
  __typename?: 'Query'
  ticketTemplates: Array<{
    __typename?: 'TicketTemplate'
    id: string
    shortName: string
  }>
}

export type CreateTicketTemplateUiMutationVariables = Exact<{
  input: CreateTicketTemplateInput
}>

export type CreateTicketTemplateUiMutation = {
  __typename?: 'Mutation'
  createTicketTemplate: { __typename?: 'TicketTemplate'; id: string }
}

export type CreateTicketReviewUiMutationVariables = Exact<{
  input: CreateTicketReviewInput
}>

export type CreateTicketReviewUiMutation = {
  __typename?: 'Mutation'
  createTicketReview: {
    __typename?: 'TicketReview'
    id: string
    createdAt: string
    updatedAt: string
    reviewStatus: TicketReviewStatus
    reviewComments?: string | null
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }
}

export type CreateTicketReviewsUiMutationVariables = Exact<{
  input:
    | Array<InputMaybe<CreateTicketReviewInput>>
    | InputMaybe<CreateTicketReviewInput>
}>

export type CreateTicketReviewsUiMutation = {
  __typename?: 'Mutation'
  createTicketReviews: Array<{
    __typename?: 'TicketReview'
    id: string
    createdAt: string
    updatedAt: string
    reviewStatus: TicketReviewStatus
    reviewComments?: string | null
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  } | null>
}

export type TicketUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type TicketUiQuery = {
  __typename?: 'Query'
  ticket?: {
    __typename?: 'Ticket'
    id: string
    createdAt: string
    updatedAt: string
    expiry?: string | null
    number?: string | null
    latestReviewStatus?: TicketReviewStatus | null
    obtained?: string | null
    stateIssued?: string | null
    countryIssued?: string | null
    reviews?: Array<{
      __typename?: 'TicketReview'
      reviewStatus: TicketReviewStatus
    } | null> | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      id: string
      shortName: string
      name: string
      ticketFileConfigs: Array<{
        __typename?: 'TicketFileConfig'
        name: string
        id: string
      } | null>
    }
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
    files: Array<{
      __typename?: 'TicketFile'
      id: string
      name: string
      file: {
        __typename?: 'File'
        name: string
        key: string
        url?: string | null
        contentType: string
      }
    } | null>
  } | null
}

export type TicketLatestReviewUiQueryVariables = Exact<{
  ticketId: Scalars['String']
}>

export type TicketLatestReviewUiQuery = {
  __typename?: 'Query'
  latestTicketReview?: {
    __typename?: 'TicketReview'
    createdAt: string
    reviewStatus: TicketReviewStatus
    reviewComments?: string | null
    adminUser?: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  } | null
}

export type CreateTicketForWorkerUiMutationVariables = Exact<{
  input: CreateTicketInputV2
}>

export type CreateTicketForWorkerUiMutation = {
  __typename?: 'Mutation'
  createTicketv2: {
    __typename?: 'Ticket'
    id: string
    createdAt: string
    updatedAt: string
    expiry?: string | null
    number?: string | null
    latestReviewStatus?: TicketReviewStatus | null
    obtained?: string | null
    stateIssued?: string | null
    countryIssued?: string | null
    reviews?: Array<{
      __typename?: 'TicketReview'
      reviewStatus: TicketReviewStatus
    } | null> | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      id: string
      shortName: string
      name: string
      ticketFileConfigs: Array<{
        __typename?: 'TicketFileConfig'
        name: string
        id: string
      } | null>
    }
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
    files: Array<{
      __typename?: 'TicketFile'
      id: string
      name: string
      file: {
        __typename?: 'File'
        name: string
        key: string
        url?: string | null
        contentType: string
      }
    } | null>
  }
}

export type UpdateTicketForWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
  input?: InputMaybe<UpdateTicketInputV2>
}>

export type UpdateTicketForWorkerUiMutation = {
  __typename?: 'Mutation'
  updateTicketv2: {
    __typename?: 'Ticket'
    id: string
    createdAt: string
    updatedAt: string
    expiry?: string | null
    number?: string | null
    latestReviewStatus?: TicketReviewStatus | null
    obtained?: string | null
    stateIssued?: string | null
    countryIssued?: string | null
    reviews?: Array<{
      __typename?: 'TicketReview'
      reviewStatus: TicketReviewStatus
    } | null> | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      id: string
      shortName: string
      name: string
      ticketFileConfigs: Array<{
        __typename?: 'TicketFileConfig'
        name: string
        id: string
      } | null>
    }
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    }
    files: Array<{
      __typename?: 'TicketFile'
      id: string
      name: string
      file: {
        __typename?: 'File'
        name: string
        key: string
        url?: string | null
        contentType: string
      }
    } | null>
  }
}

export type DeleteTicketForWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteTicketForWorkerUiMutation = {
  __typename?: 'Mutation'
  deleteTicket: { __typename?: 'Ticket'; id: string }
}

export type TimesheetEntryListAttributesFragment = {
  __typename?: 'TimesheetEntry'
  id: string
  date: string
  hours: number
  startTime?: string | null
  endTime?: string | null
  hoursOverride?: number | null
  status: TimesheetEntryStatus
  timeType: string
  costCode?: string | null
  notes?: string | null
  project: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
  }
  worker: {
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
  }
  subcontractor: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
  }
}

export type TimesheetEntryAttributesFragment = {
  __typename?: 'TimesheetEntry'
  timesheetGroupCount: number
  timesheetGroupId: string
  approvedAt1?: string | null
  approvedAt2?: string | null
  id: string
  date: string
  hours: number
  startTime?: string | null
  endTime?: string | null
  hoursOverride?: number | null
  status: TimesheetEntryStatus
  timeType: string
  costCode?: string | null
  notes?: string | null
  project: {
    __typename?: 'Project'
    id: string
    status: ProjectStatus
    name: string
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
  }
  approver1?: {
    __typename?: 'AdminUser'
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null
  approver2?: {
    __typename?: 'AdminUser'
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null
  worker: {
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
  }
  subcontractor: {
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
  }
}

export type TimesheetsUiQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>
  filter: TimesheetEntryFilterInput
  sort?: InputMaybe<TimesheetEntrySortInput>
}>

export type TimesheetsUiQuery = {
  __typename?: 'Query'
  timesheets?: Array<{
    __typename?: 'TimesheetEntry'
    id: string
    date: string
    hours: number
    startTime?: string | null
    endTime?: string | null
    hoursOverride?: number | null
    status: TimesheetEntryStatus
    timeType: string
    costCode?: string | null
    notes?: string | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      locale?: SupportedLocaleCountryCode | null
    }
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
  }> | null
  timesheetsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
  timesheetSettings: {
    __typename?: 'TimesheetSettings'
    requiresSecondaryApproval: boolean
    isSecondaryApprover: boolean
    timesheetEntryNotes: boolean
    timesheetStartEndTimes: boolean
    jobPacCsvExport: boolean
    isPrimaryApproverOfProjects?: Array<{
      __typename?: 'IsPrimaryApprover'
      projectId: string
      isPrimaryApprover: boolean
    }> | null
    timeTypes: Array<{
      __typename?: 'TimeType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    } | null>
    costCodes: Array<{
      __typename?: 'CostCode'
      id: string
      code: string
      description: string
    } | null>
  }
}

export type TimesheetsForCsvUiQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>
  filter: TimesheetEntryFilterInput
  sort?: InputMaybe<TimesheetEntrySortInput>
}>

export type TimesheetsForCsvUiQuery = {
  __typename?: 'Query'
  timesheets?: Array<{
    __typename?: 'TimesheetEntry'
    approvedAt1?: string | null
    approvedAt2?: string | null
    id: string
    date: string
    hours: number
    startTime?: string | null
    endTime?: string | null
    hoursOverride?: number | null
    status: TimesheetEntryStatus
    timeType: string
    costCode?: string | null
    notes?: string | null
    project: {
      __typename?: 'Project'
      name: string
      id: string
      status: ProjectStatus
      timezone?: string | null
      locale?: SupportedLocaleCountryCode | null
    }
    approver1?: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    approver2?: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    timesheetGroup: {
      __typename?: 'TimesheetGroup'
      templateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
      } | null
    }
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
  }> | null
  timesheetSettings: {
    __typename?: 'TimesheetSettings'
    requiresSecondaryApproval: boolean
    isSecondaryApprover: boolean
    timesheetEntryNotes: boolean
    timesheetStartEndTimes: boolean
    jobPacCsvExport: boolean
    isPrimaryApproverOfProjects?: Array<{
      __typename?: 'IsPrimaryApprover'
      projectId: string
      isPrimaryApprover: boolean
    }> | null
    timeTypes: Array<{
      __typename?: 'TimeType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    } | null>
    costCodes: Array<{
      __typename?: 'CostCode'
      id: string
      code: string
      description: string
    } | null>
  }
}

export type TimesheetUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type TimesheetUiQuery = {
  __typename?: 'Query'
  timesheet: {
    __typename?: 'TimesheetEntry'
    timesheetGroupCount: number
    timesheetGroupId: string
    approvedAt1?: string | null
    approvedAt2?: string | null
    id: string
    date: string
    hours: number
    startTime?: string | null
    endTime?: string | null
    hoursOverride?: number | null
    status: TimesheetEntryStatus
    timeType: string
    costCode?: string | null
    notes?: string | null
    timesheetGroup: {
      __typename?: 'TimesheetGroup'
      templateResponse?: {
        __typename?: 'TemplateResponse'
        id: string
        responseData?: any | null
      } | null
    }
    project: {
      __typename?: 'Project'
      id: string
      status: ProjectStatus
      name: string
      timezone?: string | null
      locale?: SupportedLocaleCountryCode | null
    }
    approver1?: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    approver2?: {
      __typename?: 'AdminUser'
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    worker: {
      __typename?: 'Worker'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    }
    subcontractor: {
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    }
  }
  timesheetSettings: {
    __typename?: 'TimesheetSettings'
    requiresSecondaryApproval: boolean
    isSecondaryApprover: boolean
    timesheetEntryNotes: boolean
    timesheetStartEndTimes: boolean
    jobPacCsvExport: boolean
    isPrimaryApproverOfProjects?: Array<{
      __typename?: 'IsPrimaryApprover'
      projectId: string
      isPrimaryApprover: boolean
    }> | null
    timeTypes: Array<{
      __typename?: 'TimeType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    } | null>
    costCodes: Array<{
      __typename?: 'CostCode'
      id: string
      code: string
      description: string
    } | null>
  }
}

export type TimesheetGroupUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type TimesheetGroupUiQuery = {
  __typename?: 'Query'
  timesheetGroup: {
    __typename?: 'TimesheetGroup'
    id: string
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      project?: { __typename?: 'Project'; id: string } | null
    } | null
    timesheetEntries: Array<{
      __typename?: 'TimesheetEntry'
      timesheetGroupCount: number
      timesheetGroupId: string
      approvedAt1?: string | null
      approvedAt2?: string | null
      id: string
      date: string
      hours: number
      startTime?: string | null
      endTime?: string | null
      hoursOverride?: number | null
      status: TimesheetEntryStatus
      timeType: string
      costCode?: string | null
      notes?: string | null
      project: {
        __typename?: 'Project'
        id: string
        status: ProjectStatus
        name: string
        timezone?: string | null
        locale?: SupportedLocaleCountryCode | null
      }
      approver1?: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      approver2?: {
        __typename?: 'AdminUser'
        user: { __typename?: 'User'; firstName: string; lastName: string }
      } | null
      worker: {
        __typename?: 'Worker'
        id: string
        user: { __typename?: 'User'; firstName: string; lastName: string }
      }
      subcontractor: {
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      }
    }>
  }
  timesheetSettings: {
    __typename?: 'TimesheetSettings'
    requiresSecondaryApproval: boolean
    isSecondaryApprover: boolean
    timesheetEntryNotes: boolean
    timesheetStartEndTimes: boolean
    jobPacCsvExport: boolean
    isPrimaryApproverOfProjects?: Array<{
      __typename?: 'IsPrimaryApprover'
      projectId: string
      isPrimaryApprover: boolean
    }> | null
    timeTypes: Array<{
      __typename?: 'TimeType'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    } | null>
    costCodes: Array<{
      __typename?: 'CostCode'
      id: string
      code: string
      description: string
    } | null>
  }
}

export type UpdateTimesheetsStatusUiMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String']
  status: TimesheetEntryStatus
}>

export type UpdateTimesheetsStatusUiMutation = {
  __typename?: 'Mutation'
  updateTimesheetsStatus?: Array<{
    __typename?: 'TimesheetEntry'
    id: string
  }> | null
}

export type CreateTimesheetEntriesAdminUiMutationVariables = Exact<{
  input: CreateTimesheetsInput
}>

export type CreateTimesheetEntriesAdminUiMutation = {
  __typename?: 'Mutation'
  createTimesheetEntries?: Array<{
    __typename?: 'TimesheetEntry'
    id: string
  }> | null
}

export type UpdateTimesheetEntryUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateTimesheetInput
}>

export type UpdateTimesheetEntryUiMutation = {
  __typename?: 'Mutation'
  updateTimesheetEntry: { __typename?: 'TimesheetEntry'; id: string }
}

export type DeleteTimesheetEntryUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteTimesheetEntryUiMutation = {
  __typename?: 'Mutation'
  deleteTimesheetEntry: {
    __typename?: 'TimesheetEntry'
    id: string
    timesheetGroupCount: number
  }
}

export type UpdateTimesheetEntriesUiMutationVariables = Exact<{
  input: UpdateTimesheetsInputs
}>

export type UpdateTimesheetEntriesUiMutation = {
  __typename?: 'Mutation'
  updateTimesheetEntries: Array<{ __typename?: 'TimesheetEntry'; id: string }>
}

export type TimesheetEntryWorkerAttributesFragment = {
  __typename?: 'WorkerTimesheetEntry'
  id: string
  date: string
  hours: number
  hoursOverride?: number | null
  status: TimesheetEntryStatus
  timeType: string
  costCode?: string | null
  subcontractor: {
    __typename?: 'SubcontractorEntity'
    id: string
    company: { __typename?: 'CompanyEntity'; name: string }
  }
  project: {
    __typename?: 'ProjectEntity'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
    locale?: SupportedLocaleCountryCode | null
  }
}

export type MyTimesheetsUiQueryVariables = Exact<{
  filter: MyTimesheetEntryFilterInput
}>

export type MyTimesheetsUiQuery = {
  __typename?: 'Query'
  myTimesheets: Array<{
    __typename?: 'WorkerTimesheetEntry'
    id: string
    date: string
    hours: number
    hoursOverride?: number | null
    status: TimesheetEntryStatus
    timeType: string
    costCode?: string | null
    subcontractor: {
      __typename?: 'SubcontractorEntity'
      id: string
      company: { __typename?: 'CompanyEntity'; name: string }
    }
    project: {
      __typename?: 'ProjectEntity'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      locale?: SupportedLocaleCountryCode | null
    }
  }>
}

export type CreateMyTimesheetEntriesUiMutationVariables = Exact<{
  input: CreateMyTimesheetsInput
}>

export type CreateMyTimesheetEntriesUiMutation = {
  __typename?: 'Mutation'
  createMyTimesheetEntries?: Array<{
    __typename?: 'WorkerTimesheetEntry'
    id: string
  }> | null
}

export type DeleteMyTimesheetEntryUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteMyTimesheetEntryUiMutation = {
  __typename?: 'Mutation'
  deleteMyTimesheetEntry: { __typename?: 'WorkerTimesheetEntry'; id: string }
}

export type ToolboxesAttributesFragment = {
  __typename?: 'Toolbox'
  id: string
  createdAt: string
  updatedAt: string
  date: string
  status: ToolboxStatus
  type: ToolboxType
  agenda?: string | null
  notes?: string | null
  urls?: Array<string | null> | null
  keys?: Array<string | null> | null
  templateResponse?: {
    __typename?: 'TemplateResponse'
    id: string
    responseData?: any | null
    completedAt?: string | null
  } | null
  project: {
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
    builder?: {
      __typename?: 'Builder'
      company: { __typename?: 'Company'; name: string }
    } | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }
}

export type ToolboxesAttributesSubsetFragment = {
  __typename?: 'Toolbox'
  id: string
  createdAt: string
  date: string
  status: ToolboxStatus
  type: ToolboxType
  agenda?: string | null
}

export type ToolboxesAttributesWorkerFragment = {
  __typename?: 'ToolboxEntity'
  id: string
  createdAt: string
  date: string
  status: ToolboxStatus
  type: ToolboxType
  agenda?: string | null
  notes?: string | null
  urls?: Array<string | null> | null
  project: {
    __typename?: 'ProjectEntity'
    id: string
    name: string
    timezone?: string | null
  }
  templateResponse?: {
    __typename?: 'TemplateResponseEntity'
    id: string
    responseData?: any | null
  } | null
}

export type ToolboxesByProjectUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type ToolboxesByProjectUiQuery = {
  __typename?: 'Query'
  toolboxesByProject: Array<{
    __typename?: 'Toolbox'
    id: string
    createdAt: string
    updatedAt: string
    date: string
    status: ToolboxStatus
    type: ToolboxType
    agenda?: string | null
    notes?: string | null
    urls?: Array<string | null> | null
    keys?: Array<string | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
    } | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      builder?: {
        __typename?: 'Builder'
        company: { __typename?: 'Company'; name: string }
      } | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  }>
}

export type ToolboxesByProjectListUiQueryVariables = Exact<{
  projectId: Scalars['String']
  filter?: InputMaybe<ToolboxFilterInput>
  sort?: InputMaybe<ToolboxSortInput>
}>

export type ToolboxesByProjectListUiQuery = {
  __typename?: 'Query'
  toolboxesByProject: Array<{
    __typename?: 'Toolbox'
    id: string
    createdAt: string
    date: string
    status: ToolboxStatus
    type: ToolboxType
    agenda?: string | null
  }>
}

export type ToolboxUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type ToolboxUiQuery = {
  __typename?: 'Query'
  toolbox?: {
    __typename?: 'Toolbox'
    deletedAt?: string | null
    id: string
    createdAt: string
    updatedAt: string
    date: string
    status: ToolboxStatus
    type: ToolboxType
    agenda?: string | null
    notes?: string | null
    urls?: Array<string | null> | null
    keys?: Array<string | null> | null
    preStart?: {
      __typename?: 'PreStart'
      id: string
      date: string
      endDate?: string | null
      signOns: Array<{
        __typename?: 'SignOn'
        id: string
        createdAt: string
        builderGenerated: boolean
        worker?: {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        } | null
        visitor?: {
          __typename?: 'Visitor'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        } | null
      } | null>
      template: {
        __typename?: 'TemplateResponse'
        id: string
        completedAt?: string | null
      }
    } | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
    } | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      builder?: {
        __typename?: 'Builder'
        company: { __typename?: 'Company'; name: string }
      } | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  } | null
}

export type ToolboxInviteByWorkerUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type ToolboxInviteByWorkerUiQuery = {
  __typename?: 'Query'
  toolboxInviteByWorker?: {
    __typename?: 'ToolboxInvite'
    id: string
    attended?: boolean | null
    updatedAt: string
  } | null
}

export type WorkerToolboxUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type WorkerToolboxUiQuery = {
  __typename?: 'Query'
  workerToolbox?: {
    __typename?: 'ToolboxEntity'
    id: string
    createdAt: string
    date: string
    status: ToolboxStatus
    type: ToolboxType
    agenda?: string | null
    notes?: string | null
    urls?: Array<string | null> | null
    project: {
      __typename?: 'ProjectEntity'
      id: string
      name: string
      timezone?: string | null
    }
    templateResponse?: {
      __typename?: 'TemplateResponseEntity'
      id: string
      responseData?: any | null
    } | null
  } | null
}

export type CreateToolboxUiMutationVariables = Exact<{
  input: CreateToolboxInput
}>

export type CreateToolboxUiMutation = {
  __typename?: 'Mutation'
  createToolbox: {
    __typename?: 'Toolbox'
    id: string
    createdAt: string
    updatedAt: string
    date: string
    status: ToolboxStatus
    type: ToolboxType
    agenda?: string | null
    notes?: string | null
    urls?: Array<string | null> | null
    keys?: Array<string | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
    } | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      builder?: {
        __typename?: 'Builder'
        company: { __typename?: 'Company'; name: string }
      } | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  }
}

export type UpdateToolboxUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateToolboxInput
}>

export type UpdateToolboxUiMutation = {
  __typename?: 'Mutation'
  updateToolbox: {
    __typename?: 'Toolbox'
    id: string
    createdAt: string
    updatedAt: string
    date: string
    status: ToolboxStatus
    type: ToolboxType
    agenda?: string | null
    notes?: string | null
    urls?: Array<string | null> | null
    keys?: Array<string | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
    } | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      builder?: {
        __typename?: 'Builder'
        company: { __typename?: 'Company'; name: string }
      } | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  }
}

export type DeleteToolboxUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteToolboxUiMutation = {
  __typename?: 'Mutation'
  deleteToolbox?: {
    __typename?: 'Toolbox'
    id: string
    createdAt: string
    updatedAt: string
    date: string
    status: ToolboxStatus
    type: ToolboxType
    agenda?: string | null
    notes?: string | null
    urls?: Array<string | null> | null
    keys?: Array<string | null> | null
    templateResponse?: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
      completedAt?: string | null
    } | null
    project: {
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
      timezone?: string | null
      builder?: {
        __typename?: 'Builder'
        company: { __typename?: 'Company'; name: string }
      } | null
      integrationConnections: Array<{
        __typename?: 'IntegrationConnection'
        integration: {
          __typename?: 'Integration'
          integrationType: IntegrationType
        }
      } | null>
    }
  } | null
}

export type CreateToolboxPreStartUiMutationVariables = Exact<{
  toolboxId: Scalars['String']
  input: CreateToolboxPreStartInput
}>

export type CreateToolboxPreStartUiMutation = {
  __typename?: 'Mutation'
  createToolboxPreStart: { __typename?: 'Toolbox'; id: string }
}

export type ToolboxInvitesByToolboxUiQueryVariables = Exact<{
  toolboxId: Scalars['String']
}>

export type ToolboxInvitesByToolboxUiQuery = {
  __typename?: 'Query'
  toolboxInvitesByToolbox: Array<{
    __typename?: 'ToolboxInvite'
    id: string
    updatedAt: string
    attended?: boolean | null
    builderGeneratedAttendance?: boolean | null
    invitee?:
      | {
          __typename?: 'AdminUser'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | {
          __typename?: 'Worker'
          id: string
          user: { __typename?: 'User'; firstName: string; lastName: string }
        }
      | null
  }>
}

export type MarkToolboxAttendanceUiMutationVariables = Exact<{
  input: MarkToolboxAttendanceInput
}>

export type MarkToolboxAttendanceUiMutation = {
  __typename?: 'Mutation'
  markToolboxAttendance: { __typename?: 'ToolboxInvite'; id: string }
}

export type MarkOwnToolboxAttendanceUiMutationVariables = Exact<{
  input: MarkOwnToolboxAttendanceInput
}>

export type MarkOwnToolboxAttendanceUiMutation = {
  __typename?: 'Mutation'
  markOwnToolboxAttendance: {
    __typename?: 'ToolboxInvite'
    id: string
    attended?: boolean | null
    updatedAt: string
  }
}

export type MarkToolboxAttendanceBatchUiMutationVariables = Exact<{
  input: MarkToolboxAttendanceBatchInput
}>

export type MarkToolboxAttendanceBatchUiMutation = {
  __typename?: 'Mutation'
  markToolboxAttendanceBatch: Array<{
    __typename?: 'ToolboxInvite'
    id: string
  }>
}

export type FileUploadInviteUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type FileUploadInviteUiQuery = {
  __typename?: 'Query'
  fileUploadInvite?: {
    __typename?: 'FileUploadInvite'
    id: string
    isSwmsBuilderEnabled?: boolean | null
    metadata?: any | null
    project?: {
      __typename?: 'FileUpload_Project'
      id: string
      name: string
      address?: string | null
      country?: string | null
      latitude?: number | null
      longitude?: number | null
      timezone?: string | null
      locale?: SupportedLocaleCountryCode | null
      builder?: {
        __typename?: 'FileUpload_Builder'
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultTimezone?: string | null
      } | null
      projectContacts?: Array<{
        __typename?: 'ContactEntity'
        name?: string | null
        number?: string | null
        email?: string | null
        type: ContactType
      } | null> | null
    } | null
    subcontractor: {
      __typename?: 'FileUpload_Subcontractor'
      id: string
      name: string
      company?: {
        __typename?: 'FileUpload_Company'
        abn?: string | null
        attachments?: Array<{
          __typename?: 'CompanyAttachment'
          id: string
          fileName: string
          type: CompanyAttachmentType
          metadata?: any | null
        }> | null
      } | null
      contacts?: Array<{
        __typename?: 'Contact'
        id: string
        name?: string | null
        email?: string | null
        number?: string | null
        isPrimaryContact: boolean
      }> | null
      insuranceDocs?: Array<{
        __typename?: 'FileUpload_Insurance'
        id: string
        name: string
        expiry: string
        type?: InsuranceType | null
        typeOther?: string | null
      } | null> | null
      swmsDocs?: Array<{
        __typename?: 'FileUpload_Swms'
        id: string
        name: string
        templateResponseId?: string | null
      } | null> | null
      msdsDocs?: Array<{
        __typename?: 'FileUpload_Msds'
        id: string
        name: string
      } | null> | null
      otherDocs?: Array<{
        __typename?: 'FileUpload_OtherDoc'
        id: string
        name: string
        type: string
      } | null> | null
      librarySwmsDocs?: Array<{
        __typename?: 'FileUpload_LibrarySwms'
        id: string
        name: string
        templateResponseId?: string | null
      } | null> | null
    }
    builder?: {
      __typename?: 'FileUpload_Builder'
      id?: string | null
      name?: string | null
      builderMetadata?: any | null
      logoUrl?: string | null
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultTimezone?: string | null
    } | null
    swmsChecklistTemplateResponse?: {
      __typename?: 'FileUploadInviteTemplateResponse'
      id: string
      responseData: any
    } | null
    sdsChecklistTemplateResponse?: {
      __typename?: 'FileUploadInviteTemplateResponse'
      id: string
      responseData: any
    } | null
    registers?: Array<{
      __typename?: 'Register_Public'
      id: string
      name: string
      typeLibraryTemplate?: {
        __typename?: 'LibraryTemplate'
        id: string
        templateName: string
      } | null
    }> | null
  } | null
}

export type UploadFilesUiMutationVariables = Exact<{
  files: Array<FileInput> | FileInput
  companyAttachmentIds?: InputMaybe<
    Array<Scalars['String']> | Scalars['String']
  >
  fileUploadInviteId: Scalars['String']
  replyTo?: InputMaybe<Scalars['String']>
}>

export type UploadFilesUiMutation = {
  __typename?: 'Mutation'
  uploadFiles: { __typename?: 'FilesUploaded'; filesUploaded?: number | null }
}

export type LoggedInUserUiQueryVariables = Exact<{ [key: string]: never }>

export type LoggedInUserUiQuery = {
  __typename?: 'Query'
  user?: {
    __typename?: 'User'
    id: string
    createdAt: string
    userIdentity?: string | null
    firstName: string
    lastName: string
    email?: string | null
    profilePicture?: { __typename?: 'Attachment'; url: string } | null
    adminUser?: {
      __typename?: 'AdminUser'
      id: string
      modules?: Array<BuildPassModule> | null
      limitedPermissions: boolean
      mobile?: string | null
      dashboards?: Array<{
        __typename?: 'Dashboard'
        id: string
        title: string
        favourited: boolean
        projects?: Array<{
          __typename?: 'Project'
          id: string
          name: string
        }> | null
      }> | null
      builders: Array<{
        __typename?: 'AdminUserToBuilder'
        builder?: {
          __typename?: 'Builder'
          id: string
          clerkOrganizationId?: string | null
          company: { __typename?: 'Company'; id?: string | null; name: string }
        } | null
      } | null>
      roles?: Array<{
        __typename?: 'Role'
        name: string
        permissions: Array<{
          __typename?: 'Permission'
          resource: string
          action: PermissionAction
        }>
      } | null> | null
      builder?: {
        __typename?: 'Builder'
        id: string
        logoUrl?: string | null
        hideBuildPassLogos?: boolean | null
        subscription: BuilderTier
        builderMetadata?: any | null
        isTrial?: boolean | null
        trialExpiresAt?: string | null
        clerkOrganizationId?: string | null
        subscriptId?: string | null
        defaultTimezone?: string | null
        defaultLocale?: SupportedLocaleCountryCode | null
        defaultLanguage?: string | null
        builderSubcontractor?: {
          __typename?: 'Subcontractor'
          id: string
          company: {
            __typename?: 'Company'
            id?: string | null
            name: string
            abn?: string | null
          }
        } | null
        integrations?: Array<{
          __typename?: 'Integration'
          id: string
          integrationType: IntegrationType
        }> | null
        company: { __typename?: 'Company'; name: string }
        publicBuilderSettings: {
          __typename?: 'PublicBuilderSettings'
          hideMedical?: boolean | null
        }
      } | null
    } | null
  } | null
}

export type LoggedInUserProjectsUiQueryVariables = Exact<{
  projectFilter?: InputMaybe<ProjectsForBuilderFilterInput>
  projectPaginationFilter?: InputMaybe<PaginationInput>
}>

export type LoggedInUserProjectsUiQuery = {
  __typename?: 'Query'
  projectsForBuilder: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
    address?: string | null
    country?: string | null
    latitude?: number | null
    longitude?: number | null
    procoreId?: string | null
    startDate?: string | null
    endDate?: string | null
    timezone?: string | null
    language?: string | null
    locale?: SupportedLocaleCountryCode | null
    builder?: {
      __typename?: 'Builder'
      defaultTimezone?: string | null
      defaultLocale?: SupportedLocaleCountryCode | null
      defaultLanguage?: string | null
    } | null
    siteTimings?: Array<{
      __typename?: 'ProjectSiteTiming'
      dayOfWeek: string
      startTime?: string | null
      endTime?: string | null
    } | null> | null
    projectSettings?: {
      __typename?: 'ProjectSettings'
      hideDocumentsUntilInductionApproved?: boolean | null
    } | null
    integrationConnections: Array<{
      __typename?: 'IntegrationConnection'
      id: string
      integrationIdentifier: string
      integration: {
        __typename?: 'Integration'
        integrationType: IntegrationType
      }
    } | null>
  }>
  projectsForBuilderAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
  }
}

export type LoggedInUserSettingsUiQueryVariables = Exact<{
  [key: string]: never
}>

export type LoggedInUserSettingsUiQuery = {
  __typename?: 'Query'
  checklistSettings: {
    __typename?: 'ChecklistSettings'
    checklistCategoriesInNavigation?: Array<string> | null
    checklistCategories?: Array<{
      __typename?: 'ChecklistCategorySetting'
      id: string
      label: string
      icon?: string | null
      colour?: string | null
    }> | null
  }
  aiToolsSettings: {
    __typename?: 'AiToolsSettings'
    aiToolsEnabled?: boolean | null
    checklistAssistantEnabled?: boolean | null
    imageTaggingEnabled?: boolean | null
    siteDiarySummaryEnabled?: boolean | null
    defectEnhancementEnabled?: boolean | null
    toolboxSummaryEnabled?: boolean | null
    documentSummaryEnabled?: boolean | null
    contentTaggingEnabled?: boolean | null
    locationImportEnabled?: boolean | null
    contextualActionGeneratorEnabled?: boolean | null
  }
  stylingSettings: {
    __typename?: 'StylingSettings'
    primaryColour?: string | null
    buttonTextColour?: string | null
    primaryTextColour?: string | null
  }
  userSettings: {
    __typename?: 'UserSettings'
    favourites?: Array<string> | null
  }
  gallerySettings: {
    __typename?: 'GallerySettings'
    defaultCompression?: ImageCompressionPreset | null
  }
}

export type LoggedInUserRegistersUiQueryVariables = Exact<{
  filter?: InputMaybe<RegisterFilterInput>
}>

export type LoggedInUserRegistersUiQuery = {
  __typename?: 'Query'
  registers: Array<{
    __typename?: 'Register'
    id: string
    name: string
    identifierPrefix: string
    itemCount: number
  }>
}

export type UpdateUserForSignupUiMutationVariables = Exact<{
  input: UpdateUserInput
}>

export type UpdateUserForSignupUiMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'User'
    id: string
    firstName: string
    lastName: string
    email?: string | null
  }
}

export type UpdateWorkerUserAdminUiMutationVariables = Exact<{
  workerId: Scalars['String']
  input: UpdateUserInput
}>

export type UpdateWorkerUserAdminUiMutation = {
  __typename?: 'Mutation'
  updateWorkerUser_admin: { __typename?: 'User'; id: string }
}

export type UserWithWorkerForPublicRoutesUiQueryVariables = Exact<{
  [key: string]: never
}>

export type UserWithWorkerForPublicRoutesUiQuery = {
  __typename?: 'Query'
  user?: {
    __typename?: 'User'
    id: string
    createdAt: string
    email?: string | null
    firstName: string
    lastName: string
    hasWorker?: boolean | null
    worker?: {
      __typename?: 'Worker'
      id: string
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        company: { __typename?: 'Company'; name: string }
      } | null>
    } | null
  } | null
}

export type UserWorkerIdForPublicRoutesUiQueryVariables = Exact<{
  [key: string]: never
}>

export type UserWorkerIdForPublicRoutesUiQuery = {
  __typename?: 'Query'
  user?: {
    __typename?: 'User'
    worker?: { __typename?: 'Worker'; id: string } | null
  } | null
}

export type WorkerProjectSubcontractorsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type WorkerProjectSubcontractorsUiQuery = {
  __typename?: 'Query'
  workerProject?: {
    __typename?: 'WorkerProject'
    id: string
    subcontractors?: Array<{
      __typename?: 'SubcontractorEntity'
      id: string
      name: string
      validationStatus: SubcontractorValidationStatus
      hasShowAllSwms?: boolean | null
      isBuilder?: boolean | null
    } | null> | null
  } | null
}

export type UserHasWorkerOrVisitorUiQueryVariables = Exact<{
  [key: string]: never
}>

export type UserHasWorkerOrVisitorUiQuery = {
  __typename?: 'Query'
  user?: {
    __typename?: 'User'
    id: string
    hasWorker?: boolean | null
    hasVisitor?: boolean | null
  } | null
}

export type TicketDetailsFragment = {
  __typename?: 'Ticket'
  id: string
  countryIssued?: string | null
  stateIssued?: string | null
  number?: string | null
  expiry?: string | null
  obtained?: string | null
  ticketTemplate: {
    __typename?: 'TicketTemplate'
    id: string
    name: string
    shortName: string
    code?: string | null
    expiry: boolean
    obtained: boolean
    number: boolean
    ticketCategory: { __typename?: 'TicketCategory'; name: string }
    ticketFileConfigs: Array<{
      __typename?: 'TicketFileConfig'
      name: string
      required: boolean
    } | null>
  }
  files: Array<{
    __typename?: 'TicketFile'
    name: string
    file: {
      __typename?: 'File'
      id: string
      name: string
      key: string
      url?: string | null
      contentType: string
    }
  } | null>
}

export type UserWithWorkerUiQueryVariables = Exact<{ [key: string]: never }>

export type UserWithWorkerUiQuery = {
  __typename?: 'Query'
  user?: {
    __typename?: 'User'
    id: string
    createdAt: string
    firstName: string
    lastName: string
    email?: string | null
    userIdentity?: string | null
    hasWorker?: boolean | null
    profilePicture?: { __typename?: 'Attachment'; url: string } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      trade?: string | null
      address?: string | null
      mobile?: string | null
      dob?: string | null
      employmentStatus?: string | null
      emergencyContact?: string | null
      emergencyContactNumber?: string | null
      emergencyContactRelationship?: string | null
      medicalInformation?: string | null
      allergies?: string | null
      tickets?: Array<{
        __typename?: 'Ticket'
        id: string
        countryIssued?: string | null
        stateIssued?: string | null
        number?: string | null
        expiry?: string | null
        obtained?: string | null
        ticketTemplate: {
          __typename?: 'TicketTemplate'
          id: string
          name: string
          shortName: string
          code?: string | null
          expiry: boolean
          obtained: boolean
          number: boolean
          ticketCategory: { __typename?: 'TicketCategory'; name: string }
          ticketFileConfigs: Array<{
            __typename?: 'TicketFileConfig'
            name: string
            required: boolean
          } | null>
        }
        files: Array<{
          __typename?: 'TicketFile'
          name: string
          file: {
            __typename?: 'File'
            id: string
            name: string
            key: string
            url?: string | null
            contentType: string
          }
        } | null>
      } | null> | null
      permits?: Array<{
        __typename?: 'Permit_Admin'
        overallStatus: OverallPermitStatus
      } | null> | null
      defects?: Array<{
        __typename?: 'Defect'
        id: string
        title?: string | null
      } | null> | null
      subcontractors: Array<{
        __typename?: 'Subcontractor'
        id: string
        builder: { __typename?: 'Builder'; id: string }
        projects?: Array<{ __typename?: 'Project'; id: string } | null> | null
      } | null>
      documentSignatures: Array<{
        __typename?: 'DocumentSignature'
        id: string
        createdAt: string
        expired: boolean
        swmsDoc: {
          __typename?: 'SwmsDoc'
          id: string
          showAll?: boolean | null
        }
      } | null>
      inductions: Array<
        | { __typename?: 'BuilderInduction'; id: string }
        | {
            __typename?: 'ProjectInduction'
            id: string
            project: { __typename?: 'Project'; id: string }
          }
        | null
      >
    } | null
  } | null
}

export type UserWithVisitorUiQueryVariables = Exact<{ [key: string]: never }>

export type UserWithVisitorUiQuery = {
  __typename?: 'Query'
  user?: {
    __typename?: 'User'
    id: string
    createdAt: string
    firstName: string
    lastName: string
    email?: string | null
    userIdentity?: string | null
    visitor?: {
      __typename?: 'Visitor'
      id: string
      mobile?: string | null
    } | null
  } | null
}

export type CreateWorkerUserUiMutationVariables = Exact<{
  input: CreateWorkerUserUserInput
}>

export type CreateWorkerUserUiMutation = {
  __typename?: 'Mutation'
  createWorkerUser: { __typename?: 'User'; id: string }
}

export type CreateVisitorUserUiMutationVariables = Exact<{
  input: CreateVisitorUserUserInput
}>

export type CreateVisitorUserUiMutation = {
  __typename?: 'Mutation'
  createVisitorUser: { __typename?: 'User'; id: string }
}

export type CreateWorkerUiMutationVariables = Exact<{
  input: CreateWorkerInput
}>

export type CreateWorkerUiMutation = {
  __typename?: 'Mutation'
  createWorker: { __typename?: 'WorkerEntity'; id: string }
}

export type CreateVisitorUiMutationVariables = Exact<{
  input: CreateVisitorInput
}>

export type CreateVisitorUiMutation = {
  __typename?: 'Mutation'
  createVisitor: { __typename?: 'Visitor'; id: string }
}

export type UpdateWorkerUiMutationVariables = Exact<{
  input: UpdateWorkerInput
}>

export type UpdateWorkerUiMutation = {
  __typename?: 'Mutation'
  updateWorker: { __typename?: 'Worker'; id: string }
}

export type RequiredTicketsUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type RequiredTicketsUiQuery = {
  __typename?: 'Query'
  workerProject?: {
    __typename?: 'WorkerProject'
    id: string
    requiredTickets?: Array<{
      __typename?: 'TicketTemplate'
      id: string
      name: string
      shortName: string
      number: boolean
      expiry: boolean
      obtained: boolean
      code?: string | null
      ticketFileConfigs: Array<{
        __typename?: 'TicketFileConfig'
        id: string
        name: string
        required: boolean
      } | null>
    } | null> | null
    builder?: {
      __typename?: 'BuilderEntity'
      id: string
      requiredTickets?: Array<{
        __typename?: 'TicketTemplateEntity'
        id: string
        name: string
        shortName: string
        expiry: boolean
        obtained: boolean
        number: boolean
        code?: string | null
        ticketFileConfigs: Array<{
          __typename?: 'TicketFileConfig'
          id: string
          name: string
          required: boolean
        } | null>
      } | null> | null
    } | null
  } | null
}

export type WorkerTicketReviewStatusesUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type WorkerTicketReviewStatusesUiQuery = {
  __typename?: 'Query'
  workerTicketReviewStatuses: {
    __typename?: 'WorkerTicketReviewStatuses'
    enforceValidation: boolean
    reviews?: Array<{
      __typename?: 'WorkerTicketReviewStatus'
      ticketId: string
      reviewStatus: TicketReviewStatus
      reviewComments?: string | null
    }> | null
  }
}

export type CreateTicketUiMutationVariables = Exact<{
  input: CreateTicketInputV2
}>

export type CreateTicketUiMutation = {
  __typename?: 'Mutation'
  createTicketv2: {
    __typename?: 'Ticket'
    id: string
    countryIssued?: string | null
    stateIssued?: string | null
    number?: string | null
    expiry?: string | null
    obtained?: string | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      id: string
      name: string
      shortName: string
      code?: string | null
      expiry: boolean
      obtained: boolean
      number: boolean
      ticketCategory: { __typename?: 'TicketCategory'; name: string }
      ticketFileConfigs: Array<{
        __typename?: 'TicketFileConfig'
        name: string
        required: boolean
      } | null>
    }
    files: Array<{
      __typename?: 'TicketFile'
      name: string
      file: {
        __typename?: 'File'
        id: string
        name: string
        key: string
        url?: string | null
        contentType: string
      }
    } | null>
  }
}

export type UpdateTicketUiMutationVariables = Exact<{
  id: Scalars['String']
  input: UpdateTicketInputV2
}>

export type UpdateTicketUiMutation = {
  __typename?: 'Mutation'
  updateTicketv2: {
    __typename?: 'Ticket'
    id: string
    countryIssued?: string | null
    stateIssued?: string | null
    number?: string | null
    expiry?: string | null
    obtained?: string | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      id: string
      name: string
      shortName: string
      code?: string | null
      expiry: boolean
      obtained: boolean
      number: boolean
      ticketCategory: { __typename?: 'TicketCategory'; name: string }
      ticketFileConfigs: Array<{
        __typename?: 'TicketFileConfig'
        name: string
        required: boolean
      } | null>
    }
    files: Array<{
      __typename?: 'TicketFile'
      name: string
      file: {
        __typename?: 'File'
        id: string
        name: string
        key: string
        url?: string | null
        contentType: string
      }
    } | null>
  }
}

export type WorkerSwmsUiQueryVariables = Exact<{
  projectId: Scalars['String']
  subcontractorId?: InputMaybe<Scalars['String']>
}>

export type WorkerSwmsUiQuery = {
  __typename?: 'Query'
  workerDocuments: {
    __typename?: 'WorkerDocuments'
    swmsDocs: Array<{
      __typename?: 'SwmsDocEntity'
      id: string
      updatedAt: string
      name: string
      url?: string | null
      isBuilder?: boolean | null
      required?: boolean | null
      requiredAll?: boolean | null
      showAll?: boolean | null
    } | null>
  }
}

export type TemplateOrLibraryTemplateLiteUiQueryVariables = Exact<{
  templateType: TemplateType
  projectId?: InputMaybe<Scalars['String']>
}>

export type TemplateOrLibraryTemplateLiteUiQuery = {
  __typename?: 'Query'
  templateOrLibraryTemplate?:
    | {
        __typename?: 'LibraryTemplate'
        id: string
        createdAt: string
        updatedAt: string
        templateType: TemplateType
        templateName: string
        templateData?: any | null
      }
    | {
        __typename?: 'Template'
        id: string
        createdAt: string
        updatedAt: string
        templateType: TemplateType
        templateName: string
        templateData?: any | null
      }
    | null
}

export type TemplateOrLibraryTemplateLiteWithProjectUiQueryVariables = Exact<{
  templateType: TemplateType
  projectId?: InputMaybe<Scalars['String']>
}>

export type TemplateOrLibraryTemplateLiteWithProjectUiQuery = {
  __typename?: 'Query'
  templateOrLibraryTemplate?:
    | {
        __typename?: 'LibraryTemplate'
        id: string
        createdAt: string
        updatedAt: string
        templateType: TemplateType
        templateName: string
        templateData?: any | null
      }
    | {
        __typename?: 'Template'
        id: string
        createdAt: string
        updatedAt: string
        templateType: TemplateType
        templateName: string
        templateData?: any | null
        projects: Array<{ __typename?: 'Project'; id: string } | null>
      }
    | null
}

export type CreateDocumentSignatureUiMutationVariables = Exact<{
  input: CreateDocumentSignatureInput
}>

export type CreateDocumentSignatureUiMutation = {
  __typename?: 'Mutation'
  createDocumentSignature: { __typename?: 'DocumentSignature'; id: string }
}

export type UpdateDocumentSignaturesUiMutationVariables = Exact<{
  input: UpdateDocumentSignaturesInput
}>

export type UpdateDocumentSignaturesUiMutation = {
  __typename?: 'Mutation'
  updateDocumentSignatures: Array<string>
}

export type GetWorkerTasksUiQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>
  date?: InputMaybe<Scalars['Date']>
  flags?: InputMaybe<Flags>
  filter?: InputMaybe<DateFilterInput>
}>

export type GetWorkerTasksUiQuery = {
  __typename?: 'Query'
  tasks: Array<{ __typename?: 'Task'; type?: TaskType | null }>
}

export type WorkerSignOnStatusUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type WorkerSignOnStatusUiQuery = {
  __typename?: 'Query'
  workerSignOnStatus?: {
    __typename?: 'SignOnStatus'
    active?: {
      __typename?: 'SignOn'
      id: string
      createdAt: string
      signedOffAt?: string | null
      manualSignedOffAt?: string | null
    } | null
    open?: {
      __typename?: 'SignOn'
      id: string
      createdAt: string
      signedOffAt?: string | null
      manualSignedOffAt?: string | null
    } | null
  } | null
}

export type SignOffWorkerUiMutationVariables = Exact<{
  input: SignOffInput
}>

export type SignOffWorkerUiMutation = {
  __typename?: 'Mutation'
  signOff: { __typename?: 'SignOn'; id: string }
}

export type TodaysPreStartsPublicUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type TodaysPreStartsPublicUiQuery = {
  __typename?: 'Query'
  todaysPreStarts: Array<{
    __typename?: 'PreStart'
    id: string
    createdAt: string
    archivedAt?: string | null
    date: string
    endDate?: string | null
    template: {
      __typename?: 'TemplateResponse'
      id: string
      responseData?: any | null
    }
  }>
}

export type TicketTemplatesPublicUiQueryVariables = Exact<{
  [key: string]: never
}>

export type TicketTemplatesPublicUiQuery = {
  __typename?: 'Query'
  ticketTemplates: Array<{
    __typename?: 'TicketTemplate'
    id: string
    name: string
    shortName: string
    code?: string | null
    number: boolean
    expiry: boolean
    obtained: boolean
    ticketCategory: { __typename?: 'TicketCategory'; name: string }
    ticketFileConfigs: Array<{
      __typename?: 'TicketFileConfig'
      id: string
      name: string
      required: boolean
    } | null>
  }>
}

export type SiteInductionRequiresCodeUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type SiteInductionRequiresCodeUiQuery = {
  __typename?: 'Query'
  projectInductionRequiresCode: {
    __typename?: 'SiteInductionCodeInfo'
    requiresCode: boolean
    description?: string | null
  }
}

export type CheckSiteInductionCodeUiMutationVariables = Exact<{
  projectId: Scalars['String']
  code: Scalars['String']
}>

export type CheckSiteInductionCodeUiMutation = {
  __typename?: 'Mutation'
  checkProjectInductionCode: boolean
}

export type CreateUserUiMutationVariables = Exact<{
  input: CreateUserInput
}>

export type CreateUserUiMutation = {
  __typename?: 'Mutation'
  createUser: {
    __typename?: 'User'
    id: string
    hasWorker?: boolean | null
    hasVisitor?: boolean | null
  }
}

export type CheckProjectCodeUiMutationVariables = Exact<{
  projectId: Scalars['String']
  code: Scalars['String']
}>

export type CheckProjectCodeUiMutation = {
  __typename?: 'Mutation'
  checkProjectCode_public:
    | { __typename?: 'CodeForProjectCheck_Failure'; message: string }
    | {
        __typename?: 'CodeForProjectCheck_Success'
        expiresAt: string
        token: string
      }
}

export type SignInTokenUiMutationVariables = Exact<{ [key: string]: never }>

export type SignInTokenUiMutation = {
  __typename?: 'Mutation'
  signInToken?: {
    __typename?: 'SignInTokenResponse'
    token: string
    expiresAt: string
  } | null
}

export type WorkerAttributesFragment = {
  __typename?: 'Worker'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  trade?: string | null
  mobile?: string | null
  address?: string | null
  dob?: string | null
  employmentStatus?: string | null
  emergencyContact?: string | null
  emergencyContactNumber?: string | null
  emergencyContactRelationship?: string | null
  medicalInformation?: string | null
  allergies?: string | null
  builderGenerated: boolean
  user: {
    __typename?: 'User'
    firstName: string
    lastName: string
    email?: string | null
  }
  inductions: Array<
    | {
        __typename?: 'BuilderInduction'
        id: string
        createdAt: string
        type: InductionType
        status?: InductionStatus | null
        templateName?: string | null
      }
    | {
        __typename?: 'ProjectInduction'
        identifier?: number | null
        id: string
        createdAt: string
        type: InductionType
        status?: InductionStatus | null
        templateName?: string | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    | null
  >
  subcontractors: Array<{
    __typename?: 'Subcontractor'
    id: string
    isBuilder?: boolean | null
    company: { __typename?: 'Company'; name: string }
  } | null>
  tickets?: Array<{
    __typename?: 'Ticket'
    id: string
    expiry?: string | null
    number?: string | null
    obtained?: string | null
    countryIssued?: string | null
    stateIssued?: string | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      id: string
      shortName: string
      name: string
    }
    files: Array<{
      __typename?: 'TicketFile'
      id: string
      name: string
      file: {
        __typename?: 'File'
        name: string
        url?: string | null
        contentType: string
      }
    } | null>
  } | null> | null
  documentSignatures: Array<{
    __typename?: 'DocumentSignature'
    id: string
    createdAt: string
    signatureUrl: string
    builderGenerated: boolean
    worker: {
      __typename?: 'Worker'
      id: string
      user: {
        __typename?: 'User'
        firstName: string
        lastName: string
        email?: string | null
      }
    }
    adminUser?: {
      __typename?: 'AdminUserEntity'
      id: string
      user?: {
        __typename?: 'UserEntity'
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
    induction?:
      | {
          __typename?: 'BuilderInduction'
          id: string
          type: InductionType
          templateName?: string | null
        }
      | {
          __typename?: 'ProjectInduction'
          id: string
          type: InductionType
          templateName?: string | null
        }
      | null
    swmsDoc: {
      __typename?: 'SwmsDoc'
      id: string
      name: string
      subcontractorId: string
      projectId: string
      showAll?: boolean | null
      project: { __typename?: 'Project'; id: string; name: string }
    }
  } | null>
  builderDocuments?: Array<{
    __typename?: 'BuilderWorkerDocument'
    id: string
    createdAt: string
    name?: string | null
    attachment: { __typename?: 'Attachment'; fileName: string; url: string }
  } | null> | null
  accessControls?: Array<{
    __typename?: 'AccessControl'
    id: string
    createdAt: string
    updatedAt?: string | null
    type: AccessControlType
    identifier: string
    status: AccessControlStatus
    projects: Array<{ __typename?: 'Project'; id: string; name: string }>
  }> | null
}

export type WorkerAttributesSubsetFragment = {
  __typename?: 'Worker'
  id: string
  createdAt: string
  trade?: string | null
  mobile?: string | null
  archivedAt?: string | null
  builderGenerated: boolean
  user: {
    __typename?: 'User'
    firstName: string
    lastName: string
    email?: string | null
  }
  subcontractors: Array<{
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
  } | null>
  tickets?: Array<{
    __typename?: 'Ticket'
    id: string
    latestReviewStatus?: TicketReviewStatus | null
    ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
  } | null> | null
}

export type WorkerAttributesCommsSubsetFragment = {
  __typename?: 'Worker'
  id: string
  mobile?: string | null
  mostRecentSignOnDate?: string | null
  user: { __typename?: 'User'; firstName: string; lastName: string }
  subcontractors: Array<{
    __typename?: 'Subcontractor'
    id: string
    company: { __typename?: 'Company'; name: string }
  } | null>
}

export type WorkerTicketsAttributesFragment = {
  __typename?: 'Ticket'
  id: string
  hidden?: boolean | null
  latestReviewStatus?: TicketReviewStatus | null
  expiry?: string | null
  number?: string | null
  obtained?: string | null
  countryIssued?: string | null
  stateIssued?: string | null
  builderGenerated?: boolean | null
  ticketTemplate: {
    __typename?: 'TicketTemplate'
    shortName: string
    name: string
  }
  files: Array<{
    __typename?: 'TicketFile'
    id: string
    name: string
    file: {
      __typename?: 'File'
      name: string
      url?: string | null
      contentType: string
    }
  } | null>
}

export type WorkerByProjectUiQueryVariables = Exact<{
  workerId: Scalars['String']
  projectId: Scalars['String']
}>

export type WorkerByProjectUiQuery = {
  __typename?: 'Query'
  workerByProject?: {
    __typename?: 'Worker'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    trade?: string | null
    mobile?: string | null
    address?: string | null
    dob?: string | null
    employmentStatus?: string | null
    emergencyContact?: string | null
    emergencyContactNumber?: string | null
    emergencyContactRelationship?: string | null
    medicalInformation?: string | null
    allergies?: string | null
    builderGenerated: boolean
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
    inductions: Array<
      | {
          __typename?: 'BuilderInduction'
          id: string
          createdAt: string
          type: InductionType
          status?: InductionStatus | null
          templateName?: string | null
        }
      | {
          __typename?: 'ProjectInduction'
          identifier?: number | null
          id: string
          createdAt: string
          type: InductionType
          status?: InductionStatus | null
          templateName?: string | null
          project: { __typename?: 'Project'; id: string; name: string }
        }
      | null
    >
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
    } | null>
    tickets?: Array<{
      __typename?: 'Ticket'
      id: string
      expiry?: string | null
      number?: string | null
      obtained?: string | null
      countryIssued?: string | null
      stateIssued?: string | null
      ticketTemplate: {
        __typename?: 'TicketTemplate'
        id: string
        shortName: string
        name: string
      }
      files: Array<{
        __typename?: 'TicketFile'
        id: string
        name: string
        file: {
          __typename?: 'File'
          name: string
          url?: string | null
          contentType: string
        }
      } | null>
    } | null> | null
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    builderDocuments?: Array<{
      __typename?: 'BuilderWorkerDocument'
      id: string
      createdAt: string
      name?: string | null
      attachment: { __typename?: 'Attachment'; fileName: string; url: string }
    } | null> | null
    accessControls?: Array<{
      __typename?: 'AccessControl'
      id: string
      createdAt: string
      updatedAt?: string | null
      type: AccessControlType
      identifier: string
      status: AccessControlStatus
      projects: Array<{ __typename?: 'Project'; id: string; name: string }>
    }> | null
  } | null
}

export type WorkerUiQueryVariables = Exact<{
  workerId: Scalars['String']
}>

export type WorkerUiQuery = {
  __typename?: 'Query'
  worker?: {
    __typename?: 'Worker'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    trade?: string | null
    mobile?: string | null
    address?: string | null
    dob?: string | null
    employmentStatus?: string | null
    emergencyContact?: string | null
    emergencyContactNumber?: string | null
    emergencyContactRelationship?: string | null
    medicalInformation?: string | null
    allergies?: string | null
    builderGenerated: boolean
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
      profilePicture?: {
        __typename?: 'Attachment'
        id: string
        key: string
        url: string
        fileName: string
      } | null
    }
    permits?: Array<{
      __typename?: 'Permit_Admin'
      id: string
      name?: string | null
      overallStatus: OverallPermitStatus
      startDate: string
      endDate: string
      workers?: Array<{
        __typename?: 'PermitWorker_Admin'
        id: string
        worker?: {
          __typename?: 'Worker'
          id: string
          user: {
            __typename?: 'User'
            id: string
            firstName: string
            lastName: string
          }
        } | null
      }> | null
    } | null> | null
    inductions: Array<
      | {
          __typename?: 'BuilderInduction'
          id: string
          createdAt: string
          type: InductionType
          status?: InductionStatus | null
          templateName?: string | null
        }
      | {
          __typename?: 'ProjectInduction'
          identifier?: number | null
          id: string
          createdAt: string
          type: InductionType
          status?: InductionStatus | null
          templateName?: string | null
          project: { __typename?: 'Project'; id: string; name: string }
        }
      | null
    >
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
    } | null>
    tickets?: Array<{
      __typename?: 'Ticket'
      id: string
      expiry?: string | null
      number?: string | null
      obtained?: string | null
      countryIssued?: string | null
      stateIssued?: string | null
      ticketTemplate: {
        __typename?: 'TicketTemplate'
        id: string
        shortName: string
        name: string
      }
      files: Array<{
        __typename?: 'TicketFile'
        id: string
        name: string
        file: {
          __typename?: 'File'
          name: string
          url?: string | null
          contentType: string
        }
      } | null>
    } | null> | null
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    builderDocuments?: Array<{
      __typename?: 'BuilderWorkerDocument'
      id: string
      createdAt: string
      name?: string | null
      attachment: { __typename?: 'Attachment'; fileName: string; url: string }
    } | null> | null
    accessControls?: Array<{
      __typename?: 'AccessControl'
      id: string
      createdAt: string
      updatedAt?: string | null
      type: AccessControlType
      identifier: string
      status: AccessControlStatus
      projects: Array<{ __typename?: 'Project'; id: string; name: string }>
    }> | null
  } | null
}

export type WorkerToReassignUiQueryVariables = Exact<{
  workerId: Scalars['String']
}>

export type WorkerToReassignUiQuery = {
  __typename?: 'Query'
  worker?: {
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
    inductions: Array<
      | { __typename?: 'BuilderInduction'; type: InductionType }
      | { __typename?: 'ProjectInduction'; type: InductionType }
      | null
    >
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      swmsDoc: { __typename?: 'SwmsDoc'; name: string }
    } | null>
  } | null
}

export type WorkerTicketsUiQueryVariables = Exact<{
  workerId: Scalars['String']
}>

export type WorkerTicketsUiQuery = {
  __typename?: 'Query'
  ticketsByWorker: Array<{
    __typename?: 'Ticket'
    id: string
    hidden?: boolean | null
    latestReviewStatus?: TicketReviewStatus | null
    expiry?: string | null
    number?: string | null
    obtained?: string | null
    countryIssued?: string | null
    stateIssued?: string | null
    builderGenerated?: boolean | null
    ticketTemplate: {
      __typename?: 'TicketTemplate'
      shortName: string
      name: string
    }
    files: Array<{
      __typename?: 'TicketFile'
      id: string
      name: string
      file: {
        __typename?: 'File'
        name: string
        url?: string | null
        contentType: string
      }
    } | null>
  } | null>
}

export type WorkerDocumentSignaturesUiQueryVariables = Exact<{
  workerId: Scalars['String']
}>

export type WorkerDocumentSignaturesUiQuery = {
  __typename?: 'Query'
  worker?: {
    __typename?: 'Worker'
    id: string
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
  } | null
}

export type WorkerNameUiQueryVariables = Exact<{
  workerId: Scalars['String']
}>

export type WorkerNameUiQuery = {
  __typename?: 'Query'
  worker?: {
    __typename?: 'Worker'
    id: string
    user: { __typename?: 'User'; firstName: string; lastName: string }
  } | null
}

export type WorkersNameUiQueryVariables = Exact<{
  ids?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<WorkersFilterInput>
}>

export type WorkersNameUiQuery = {
  __typename?: 'Query'
  workers: Array<{
    __typename?: 'Worker'
    id: string
    trade?: string | null
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      profilePicture?: { __typename?: 'Attachment'; url: string } | null
    }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
  }>
  workersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type WorkersNameWorkerUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type WorkersNameWorkerUiQuery = {
  __typename?: 'Query'
  workers_worker: Array<{
    __typename?: 'WorkerEntity'
    id: string
    trade?: string | null
    user: {
      __typename?: 'UserEntity'
      firstName?: string | null
      lastName?: string | null
    }
  }>
}

export type WorkersUiQueryVariables = Exact<{
  ids?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
}>

export type WorkersUiQuery = {
  __typename?: 'Query'
  workers: Array<{
    __typename?: 'Worker'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    trade?: string | null
    mobile?: string | null
    address?: string | null
    dob?: string | null
    employmentStatus?: string | null
    emergencyContact?: string | null
    emergencyContactNumber?: string | null
    emergencyContactRelationship?: string | null
    medicalInformation?: string | null
    allergies?: string | null
    builderGenerated: boolean
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
    inductions: Array<
      | {
          __typename?: 'BuilderInduction'
          id: string
          createdAt: string
          type: InductionType
          status?: InductionStatus | null
          templateName?: string | null
        }
      | {
          __typename?: 'ProjectInduction'
          identifier?: number | null
          id: string
          createdAt: string
          type: InductionType
          status?: InductionStatus | null
          templateName?: string | null
          project: { __typename?: 'Project'; id: string; name: string }
        }
      | null
    >
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
    } | null>
    tickets?: Array<{
      __typename?: 'Ticket'
      id: string
      expiry?: string | null
      number?: string | null
      obtained?: string | null
      countryIssued?: string | null
      stateIssued?: string | null
      ticketTemplate: {
        __typename?: 'TicketTemplate'
        id: string
        shortName: string
        name: string
      }
      files: Array<{
        __typename?: 'TicketFile'
        id: string
        name: string
        file: {
          __typename?: 'File'
          name: string
          url?: string | null
          contentType: string
        }
      } | null>
    } | null> | null
    documentSignatures: Array<{
      __typename?: 'DocumentSignature'
      id: string
      createdAt: string
      signatureUrl: string
      builderGenerated: boolean
      worker: {
        __typename?: 'Worker'
        id: string
        user: {
          __typename?: 'User'
          firstName: string
          lastName: string
          email?: string | null
        }
      }
      adminUser?: {
        __typename?: 'AdminUserEntity'
        id: string
        user?: {
          __typename?: 'UserEntity'
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      induction?:
        | {
            __typename?: 'BuilderInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | {
            __typename?: 'ProjectInduction'
            id: string
            type: InductionType
            templateName?: string | null
          }
        | null
      swmsDoc: {
        __typename?: 'SwmsDoc'
        id: string
        name: string
        subcontractorId: string
        projectId: string
        showAll?: boolean | null
        project: { __typename?: 'Project'; id: string; name: string }
      }
    } | null>
    builderDocuments?: Array<{
      __typename?: 'BuilderWorkerDocument'
      id: string
      createdAt: string
      name?: string | null
      attachment: { __typename?: 'Attachment'; fileName: string; url: string }
    } | null> | null
    accessControls?: Array<{
      __typename?: 'AccessControl'
      id: string
      createdAt: string
      updatedAt?: string | null
      type: AccessControlType
      identifier: string
      status: AccessControlStatus
      projects: Array<{ __typename?: 'Project'; id: string; name: string }>
    }> | null
  }>
}

export type WorkerSubcontractorsUiQueryVariables = Exact<{
  workerId: Scalars['String']
}>

export type WorkerSubcontractorsUiQuery = {
  __typename?: 'Query'
  worker?: {
    __typename?: 'Worker'
    id: string
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      isBuilder?: boolean | null
      company: { __typename?: 'Company'; name: string }
    } | null>
  } | null
}

export type WorkerSignOnsUiQueryVariables = Exact<{
  workerId?: InputMaybe<Scalars['String']>
  pagination?: InputMaybe<PaginationInput>
}>

export type WorkerSignOnsUiQuery = {
  __typename?: 'Query'
  workerSignOns: Array<{
    __typename?: 'SignOn'
    id: string
    createdAt: string
    manualSignedOnAt?: string | null
    manualSignedOffAt?: string | null
    signedOffAt?: string | null
    builderGenerated: boolean
    integrationGenerated?: boolean | null
    integrationType?: string | null
    contextMetadata?: {
      __typename?: 'ContextMetadata'
      createdFrom?: CreatedFromContext | null
      formName?: string | null
    } | null
    project?: {
      __typename?: 'Project'
      id: string
      createdAt: string
      name: string
      timezone?: string | null
      country?: string | null
      status: ProjectStatus
    } | null
    visitor?: {
      __typename?: 'Visitor'
      id: string
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
    worker?: {
      __typename?: 'Worker'
      id: string
      builderGenerated: boolean
      user: { __typename?: 'User'; firstName: string; lastName: string }
    } | null
  }>
  workerSignOnsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type WorkersListUiQueryVariables = Exact<{
  filter?: InputMaybe<WorkersFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<WorkerSortInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type WorkersListUiQuery = {
  __typename?: 'Query'
  workers: Array<{
    __typename?: 'Worker'
    id: string
    createdAt: string
    trade?: string | null
    mobile?: string | null
    archivedAt?: string | null
    builderGenerated: boolean
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
      profilePicture?: { __typename?: 'Attachment'; url: string } | null
    }
    projects: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null>
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
    tickets?: Array<{
      __typename?: 'Ticket'
      id: string
      latestReviewStatus?: TicketReviewStatus | null
      ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
    } | null> | null
  }>
  workersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type WorkerProjectUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type WorkerProjectUiQuery = {
  __typename?: 'Query'
  workerProject?: {
    __typename?: 'WorkerProject'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
    country?: string | null
    builder?: {
      __typename?: 'BuilderEntity'
      id: string
      company?: { __typename?: 'Company'; name: string } | null
    } | null
  } | null
}

export type WorkerProjectsWorkerUiQueryVariables = Exact<{
  [key: string]: never
}>

export type WorkerProjectsWorkerUiQuery = {
  __typename?: 'Query'
  workerProjects: Array<{
    __typename?: 'WorkerProject'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
    country?: string | null
    builder?: {
      __typename?: 'BuilderEntity'
      id: string
      company?: { __typename?: 'Company'; name: string } | null
    } | null
  }>
}

export type WorkerProjectsWithSubbiesWorkerUiQueryVariables = Exact<{
  [key: string]: never
}>

export type WorkerProjectsWithSubbiesWorkerUiQuery = {
  __typename?: 'Query'
  workerProjects: Array<{
    __typename?: 'WorkerProject'
    id: string
    name: string
    status: ProjectStatus
    timezone?: string | null
    country?: string | null
    builder?: {
      __typename?: 'BuilderEntity'
      id: string
      company?: { __typename?: 'Company'; name: string } | null
    } | null
    subcontractors?: Array<{
      __typename?: 'SubcontractorEntity'
      id: string
    } | null> | null
  }>
}

export type WorkersCommsListUiQueryVariables = Exact<{
  filter?: InputMaybe<WorkersFilterInput>
}>

export type WorkersCommsListUiQuery = {
  __typename?: 'Query'
  workers: Array<{
    __typename?: 'Worker'
    id: string
    mobile?: string | null
    mostRecentSignOnDate?: string | null
    user: { __typename?: 'User'; firstName: string; lastName: string }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
  }>
}

export type WorkersWithSignonUiQueryVariables = Exact<{
  filter?: InputMaybe<WorkersWithResourceFilterInput>
}>

export type WorkersWithSignonUiQuery = {
  __typename?: 'Query'
  workersWithSignon?: Array<{
    __typename?: 'Worker'
    id: string
    mobile?: string | null
    mostRecentSignOnDate?: string | null
    user: { __typename?: 'User'; firstName: string; lastName: string }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
  } | null> | null
}

export type WorkersWithInductionUiQueryVariables = Exact<{
  filter?: InputMaybe<WorkersWithResourceFilterInput>
  inductionType: InductionType
  inductionStatus?: InputMaybe<InductionStatus>
}>

export type WorkersWithInductionUiQuery = {
  __typename?: 'Query'
  workersWithInduction?: Array<{
    __typename?: 'Worker'
    id: string
    mobile?: string | null
    mostRecentSignOnDate?: string | null
    user: { __typename?: 'User'; firstName: string; lastName: string }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
  } | null> | null
}

export type WorkersListCsvUiQueryVariables = Exact<{
  filter?: InputMaybe<WorkersFilterInput>
  searchString?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<WorkerSortInput>
}>

export type WorkersListCsvUiQuery = {
  __typename?: 'Query'
  workers: Array<{
    __typename?: 'Worker'
    trade?: string | null
    mobile?: string | null
    address?: string | null
    dob?: string | null
    employmentStatus?: string | null
    emergencyContact?: string | null
    emergencyContactNumber?: string | null
    emergencyContactRelationship?: string | null
    medicalInformation?: string | null
    allergies?: string | null
    id: string
    createdAt: string
    archivedAt?: string | null
    builderGenerated: boolean
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
    tickets?: Array<{
      __typename?: 'Ticket'
      id: string
      latestReviewStatus?: TicketReviewStatus | null
      ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
    } | null> | null
  }>
}

export type WorkersListForSearchUiQueryVariables = Exact<{
  filter?: InputMaybe<WorkersFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<WorkerSortInput>
  searchString?: InputMaybe<Scalars['String']>
  ids?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
}>

export type WorkersListForSearchUiQuery = {
  __typename?: 'Query'
  workers: Array<{
    __typename?: 'Worker'
    id: string
    trade?: string | null
    builderGenerated: boolean
    mobile?: string | null
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
  }>
  workersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type WorkersByProjectUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type WorkersByProjectUiQuery = {
  __typename?: 'Query'
  workersByProject?: Array<{
    __typename?: 'Worker'
    id: string
    createdAt: string
    trade?: string | null
    mobile?: string | null
    archivedAt?: string | null
    builderGenerated: boolean
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
    subcontractors: Array<{
      __typename?: 'Subcontractor'
      id: string
      company: { __typename?: 'Company'; name: string }
    } | null>
    tickets?: Array<{
      __typename?: 'Ticket'
      id: string
      latestReviewStatus?: TicketReviewStatus | null
      ticketTemplate: { __typename?: 'TicketTemplate'; shortName: string }
    } | null> | null
  } | null> | null
}

export type BuilderWorkersUiQueryVariables = Exact<{
  filter?: InputMaybe<BuilderWorkersFilterInput>
  pagination?: InputMaybe<PaginationInput>
  searchString?: InputMaybe<Scalars['String']>
}>

export type BuilderWorkersUiQuery = {
  __typename?: 'Query'
  builderWorkers: Array<{
    __typename?: 'Worker'
    id: string
    trade?: string | null
    mobile?: string | null
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
  }>
  builderWorkersAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type WorkersOnSiteUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type WorkersOnSiteUiQuery = {
  __typename?: 'Query'
  workersOnSite?: Array<{
    __typename?: 'WorkerForEmergency'
    id: string
    trade?: string | null
    mobile?: string | null
    user: {
      __typename?: 'UserEntity'
      firstName?: string | null
      lastName?: string | null
    }
  } | null> | null
}

export type VisitorsOnSiteUiQueryVariables = Exact<{
  projectId: Scalars['String']
}>

export type VisitorsOnSiteUiQuery = {
  __typename?: 'Query'
  visitorsOnSite?: Array<{
    __typename?: 'Visitor'
    id: string
    mobile?: string | null
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
    }
  } | null> | null
}

export type CreateWorkerWithUserUiMutationVariables = Exact<{
  input: CreateWorkerUserInput
}>

export type CreateWorkerWithUserUiMutation = {
  __typename?: 'Mutation'
  createWorkerWithUser: { __typename?: 'Worker'; id: string }
}

export type UpdateWorkerWithUserUiMutationVariables = Exact<{
  input: UpdateWorkerUserInput
}>

export type UpdateWorkerWithUserUiMutation = {
  __typename?: 'Mutation'
  updateWorkerWithUser: { __typename?: 'Worker'; id: string }
}

export type BuilderWorkerDocumentAttributesFragment = {
  __typename?: 'BuilderWorkerDocument'
  id: string
  createdAt: string
  updatedAt: string
  deletedAt?: string | null
  name?: string | null
  attachment: {
    __typename?: 'Attachment'
    id: string
    createdAt: string
    updatedAt: string
    fileName: string
    fileSize: string
    contentType: string
    description?: string | null
    metadata?: any | null
    type: AttachmentType
    key: string
    url: string
  }
}

export type CreateBuilderWorkerDocumentUiMutationVariables = Exact<{
  input: CreateBuilderWorkerDocumentInput
}>

export type CreateBuilderWorkerDocumentUiMutation = {
  __typename?: 'Mutation'
  createBuilderWorkerDocument: {
    __typename?: 'BuilderWorkerDocument'
    id: string
    createdAt: string
    updatedAt: string
    deletedAt?: string | null
    name?: string | null
    attachment: {
      __typename?: 'Attachment'
      id: string
      createdAt: string
      updatedAt: string
      fileName: string
      fileSize: string
      contentType: string
      description?: string | null
      metadata?: any | null
      type: AttachmentType
      key: string
      url: string
    }
  }
}

export type BuilderWorkerDocumentUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type BuilderWorkerDocumentUiQuery = {
  __typename?: 'Query'
  builderWorkerDocument?: {
    __typename?: 'BuilderWorkerDocument'
    id: string
    createdAt: string
    updatedAt: string
    deletedAt?: string | null
    name?: string | null
    attachment: {
      __typename?: 'Attachment'
      id: string
      createdAt: string
      updatedAt: string
      fileName: string
      fileSize: string
      contentType: string
      description?: string | null
      metadata?: any | null
      type: AttachmentType
      key: string
      url: string
    }
  } | null
}

export type DeleteBuilderWorkerDocumentUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DeleteBuilderWorkerDocumentUiMutation = {
  __typename?: 'Mutation'
  deleteBuilderWorkerDocument: {
    __typename?: 'BuilderWorkerDocument'
    id: string
    createdAt: string
    updatedAt: string
    deletedAt?: string | null
    name?: string | null
    attachment: {
      __typename?: 'Attachment'
      id: string
      createdAt: string
      updatedAt: string
      fileName: string
      fileSize: string
      contentType: string
      description?: string | null
      metadata?: any | null
      type: AttachmentType
      key: string
      url: string
    }
  }
}

export type DeleteStaffSubcontractorUiMutationVariables = Exact<{
  input: DeleteStaffSubcontractorInput
}>

export type DeleteStaffSubcontractorUiMutation = {
  __typename?: 'Mutation'
  deleteStaffSubcontractor: { __typename?: 'Worker'; id: string }
}

export type ArchiveWorkerUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveWorkerUiMutation = {
  __typename?: 'Mutation'
  archiveWorker: { __typename?: 'Worker'; id: string }
}

export type ReassignWorkerSubcontractorsUiMutationVariables = Exact<{
  workerId: Scalars['String']
  subcontractorIds: Array<Scalars['String']> | Scalars['String']
}>

export type ReassignWorkerSubcontractorsUiMutation = {
  __typename?: 'Mutation'
  reassignWorkerSubcontractors: { __typename?: 'Worker'; id: string }
}

export type WorkerInfoUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type WorkerInfoUiQuery = {
  __typename?: 'Query'
  worker?: {
    __typename?: 'Worker'
    id: string
    trade?: string | null
    mobile?: string | null
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
  } | null
}

export type VisitorInfoUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type VisitorInfoUiQuery = {
  __typename?: 'Query'
  visitor?: {
    __typename?: 'Visitor'
    id: string
    mobile?: string | null
    user: {
      __typename?: 'User'
      firstName: string
      lastName: string
      email?: string | null
    }
  } | null
}

export type DisconnectWorkerFromBuilderUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type DisconnectWorkerFromBuilderUiMutation = {
  __typename?: 'Mutation'
  disconnectWorkerFromBuilder: { __typename?: 'Worker'; id: string }
}

export type WorkflowConditionAttributesFragment = {
  __typename?: 'WorkflowCondition'
  conditionType: WorkflowConditionType
  label: string
  fieldComparison?: {
    __typename?: 'WorkflowConditionFieldComparisonData'
    field: Array<string>
    operator: string
    value?: string | null
  } | null
}

export type WorkflowAttributesFragment = {
  __typename?: 'Workflow'
  id: string
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  active?: boolean | null
  name?: string | null
  resourceId?: string | null
  resourceType?: Resource | null
  projects?: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  } | null> | null
  resource?: {
    __typename?: 'Template'
    templateName: string
    templateData?: any | null
  } | null
  conditions?: Array<{
    __typename?: 'WorkflowCondition'
    conditionType: WorkflowConditionType
    label: string
    fieldComparison?: {
      __typename?: 'WorkflowConditionFieldComparisonData'
      field: Array<string>
      operator: string
      value?: string | null
    } | null
  }> | null
  steps?: Array<{
    __typename?: 'WorkflowStep'
    id: string
    parentId?: string | null
    type?: WorkflowStepType | null
    data?: any | null
    conditions?: Array<{
      __typename?: 'WorkflowCondition'
      conditionType: WorkflowConditionType
      label: string
      fieldComparison?: {
        __typename?: 'WorkflowConditionFieldComparisonData'
        field: Array<string>
        operator: string
        value?: string | null
      } | null
    }> | null
  } | null> | null
}

export type WorkflowListAttributesFragment = {
  __typename?: 'Workflow'
  id: string
  active?: boolean | null
  name?: string | null
  resourceType?: Resource | null
  projects?: Array<{
    __typename?: 'Project'
    id: string
    name: string
    status: ProjectStatus
  } | null> | null
  resource?: {
    __typename?: 'Template'
    templateName: string
    templateData?: any | null
  } | null
}

export type WorkflowsListUiQueryVariables = Exact<{
  filter?: InputMaybe<WorkflowFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<WorkflowSortInput>
}>

export type WorkflowsListUiQuery = {
  __typename?: 'Query'
  workflows: Array<{
    __typename?: 'Workflow'
    id: string
    active?: boolean | null
    name?: string | null
    resourceType?: Resource | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    resource?: {
      __typename?: 'Template'
      templateName: string
      templateData?: any | null
    } | null
  }>
  workflowsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type WorkflowsForFilteringUiQueryVariables = Exact<{
  filter?: InputMaybe<WorkflowFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<WorkflowSortInput>
}>

export type WorkflowsForFilteringUiQuery = {
  __typename?: 'Query'
  workflows: Array<{
    __typename?: 'Workflow'
    id: string
    name?: string | null
  }>
  workflowsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type WorkflowExecutionListAttributesFragment = {
  __typename?: 'WorkflowExecution'
  id: string
  createdAt: string
  completedAt?: string | null
  status: WorkflowExecutionStatus
  statusMessage?: string | null
  executionSteps?: Array<{
    __typename?: 'WorkflowExecutionStep'
    id: string
    createdAt: string
    completedAt?: string | null
    status: WorkflowExecutionStatus
    statusMessage?: string | null
  }> | null
  workflow: {
    __typename?: 'Workflow'
    id: string
    active?: boolean | null
    name?: string | null
    resourceType?: Resource | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    resource?: {
      __typename?: 'Template'
      templateName: string
      templateData?: any | null
    } | null
  }
}

export type WorkflowExecutionsListUiQueryVariables = Exact<{
  filter?: InputMaybe<WorkflowExecutionFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<WorkflowExecutionSortInput>
}>

export type WorkflowExecutionsListUiQuery = {
  __typename?: 'Query'
  workflowExecutions: Array<{
    __typename?: 'WorkflowExecution'
    id: string
    createdAt: string
    completedAt?: string | null
    status: WorkflowExecutionStatus
    statusMessage?: string | null
    executionSteps?: Array<{
      __typename?: 'WorkflowExecutionStep'
      id: string
      createdAt: string
      completedAt?: string | null
      status: WorkflowExecutionStatus
      statusMessage?: string | null
    }> | null
    workflow: {
      __typename?: 'Workflow'
      id: string
      active?: boolean | null
      name?: string | null
      resourceType?: Resource | null
      projects?: Array<{
        __typename?: 'Project'
        id: string
        name: string
        status: ProjectStatus
      } | null> | null
      resource?: {
        __typename?: 'Template'
        templateName: string
        templateData?: any | null
      } | null
    }
  }>
  workflowExecutionsAggregation: {
    __typename?: 'PaginationAggregation'
    totalCount?: number | null
    totalPages?: number | null
    offset?: number | null
    limit?: number | null
  }
}

export type WorkflowUiQueryVariables = Exact<{
  id: Scalars['String']
}>

export type WorkflowUiQuery = {
  __typename?: 'Query'
  workflow: {
    __typename?: 'Workflow'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    active?: boolean | null
    name?: string | null
    resourceId?: string | null
    resourceType?: Resource | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    resource?: {
      __typename?: 'Template'
      templateName: string
      templateData?: any | null
    } | null
    conditions?: Array<{
      __typename?: 'WorkflowCondition'
      conditionType: WorkflowConditionType
      label: string
      fieldComparison?: {
        __typename?: 'WorkflowConditionFieldComparisonData'
        field: Array<string>
        operator: string
        value?: string | null
      } | null
    }> | null
    steps?: Array<{
      __typename?: 'WorkflowStep'
      id: string
      parentId?: string | null
      type?: WorkflowStepType | null
      data?: any | null
      conditions?: Array<{
        __typename?: 'WorkflowCondition'
        conditionType: WorkflowConditionType
        label: string
        fieldComparison?: {
          __typename?: 'WorkflowConditionFieldComparisonData'
          field: Array<string>
          operator: string
          value?: string | null
        } | null
      }> | null
    } | null> | null
  }
}

export type CreateWorkflowUiMutationVariables = Exact<{
  workflow: WorkflowInput
}>

export type CreateWorkflowUiMutation = {
  __typename?: 'Mutation'
  createWorkflow: { __typename?: 'Workflow'; id: string }
}

export type UpdateWorkflowUiMutationVariables = Exact<{
  id: Scalars['String']
  workflow: WorkflowInput
}>

export type UpdateWorkflowUiMutation = {
  __typename?: 'Mutation'
  updateWorkflow: {
    __typename?: 'Workflow'
    id: string
    createdAt: string
    updatedAt: string
    archivedAt?: string | null
    active?: boolean | null
    name?: string | null
    resourceId?: string | null
    resourceType?: Resource | null
    projects?: Array<{
      __typename?: 'Project'
      id: string
      name: string
      status: ProjectStatus
    } | null> | null
    resource?: {
      __typename?: 'Template'
      templateName: string
      templateData?: any | null
    } | null
    conditions?: Array<{
      __typename?: 'WorkflowCondition'
      conditionType: WorkflowConditionType
      label: string
      fieldComparison?: {
        __typename?: 'WorkflowConditionFieldComparisonData'
        field: Array<string>
        operator: string
        value?: string | null
      } | null
    }> | null
    steps?: Array<{
      __typename?: 'WorkflowStep'
      id: string
      parentId?: string | null
      type?: WorkflowStepType | null
      data?: any | null
      conditions?: Array<{
        __typename?: 'WorkflowCondition'
        conditionType: WorkflowConditionType
        label: string
        fieldComparison?: {
          __typename?: 'WorkflowConditionFieldComparisonData'
          field: Array<string>
          operator: string
          value?: string | null
        } | null
      }> | null
    } | null> | null
  }
}

export type ArchiveWorkflowUiMutationVariables = Exact<{
  id: Scalars['String']
}>

export type ArchiveWorkflowUiMutation = {
  __typename?: 'Mutation'
  archiveWorkflow: { __typename?: 'Workflow'; id: string }
}
